import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `BigInt` scalar type represents non-fractional whole numeric values.
   * `BigInt` is not constrained to 32-bit like the `Int` type and thus is a less
   * compatible type.
   */
  BigInt: any;
  CoercedBoolean: any;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  JSONStringNestedSerializer: any;
  /** Mimics behavior of Int in older graphene versions; if given a float, will floor it into an int. */
  RoundedInt: any;
};

export type AcceptCompanyClaim = {
  readonly __typename: 'AcceptCompanyClaim';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AcceptCompanyClaimInput = {
  readonly id: Scalars['ID'];
};

export type AccessObject = {
  readonly __typename: 'AccessObject';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly objectPk: Scalars['String'];
  readonly organization: LimitedOrganizationObject;
  readonly permission: Scalars['String'];
};

export type ActionMapObject = {
  readonly __typename: 'ActionMapObject';
  readonly action: Maybe<Scalars['String']>;
  readonly eventName: Scalars['String'];
  readonly id: Scalars['String'];
  readonly key: KeyObject;
};

export type ActivityObject = {
  readonly __typename: 'ActivityObject';
  readonly count: Scalars['RoundedInt'];
  readonly time: Scalars['DateTime'];
};

export type AdMarkerObject = {
  readonly __typename: 'AdMarkerObject';
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly seconds: Maybe<Scalars['Float']>;
};

export type AdObject = {
  readonly __typename: 'AdObject';
  readonly company: Maybe<CompanyObject>;
  readonly cost: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['DateTime'];
  readonly duration: Scalars['Float'];
  readonly firstPublished: Maybe<Scalars['DateTime']>;
  readonly flacPath: Maybe<Scalars['String']>;
  readonly guess: Maybe<AdSearchResult>;
  readonly id: Scalars['String'];
  readonly mpegPath: Maybe<Scalars['String']>;
  readonly placements: Maybe<ReadonlyArray<Maybe<PlacementObject>>>;
  readonly placementsCount: Maybe<Scalars['Int']>;
  readonly product: Maybe<ProductObject>;
  readonly reviews: Maybe<ReadonlyArray<Maybe<ReviewObject>>>;
  readonly sampleRate: Maybe<Scalars['Int']>;
  readonly sponsor: Maybe<CompanyObject>;
  readonly src: Maybe<Scalars['String']>;
  readonly state: AdState;
  readonly text: Maybe<Scalars['String']>;
  readonly transcript: Maybe<Scalars['JSONString']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly waveform: Maybe<Scalars['JSONString']>;
  readonly words: Maybe<Scalars['JSONString']>;
};


export type AdObjectPlacementsArgs = {
  limit: InputMaybe<Scalars['Int']>;
};


export type AdObjectPlacementsCountArgs = {
  after: InputMaybe<Scalars['String']>;
};


export type AdObjectReviewsArgs = {
  reviewerId: InputMaybe<Scalars['ID']>;
};

export type AdSearchResult = {
  readonly __typename: 'AdSearchResult';
  readonly body: Maybe<Scalars['String']>;
  readonly companyId: Maybe<Scalars['String']>;
  readonly companyName: Maybe<Scalars['String']>;
  readonly duration: Maybe<Scalars['Float']>;
  readonly id: Maybe<Scalars['String']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly maxScore: Maybe<Scalars['Float']>;
  readonly productId: Maybe<Scalars['String']>;
  readonly productName: Maybe<Scalars['String']>;
  readonly score: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum AdState {
  /** Approved */
  Approved = 'APPROVED',
  /** Duplicate */
  Duplicate = 'DUPLICATE',
  /** edited */
  Edited = 'EDITED',
  /** Initial Review */
  Initial = 'INITIAL',
  /** Media Generated */
  Media = 'MEDIA',
  /** New */
  New = 'NEW',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Split */
  Split = 'SPLIT',
  /** Transcript Generated */
  Transcript = 'TRANSCRIPT',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

export type AdStudioSandboxCleanup = {
  readonly __typename: 'AdStudioSandboxCleanup';
  readonly success: Scalars['Boolean'];
};

export type AddAccess = {
  readonly __typename: 'AddAccess';
  readonly access: Maybe<AccessObject>;
};

export type AddAccessInput = {
  readonly contentType: Scalars['String'];
  readonly name: Scalars['String'];
  readonly objectPk: Scalars['ID'];
  readonly organizationId: Scalars['ID'];
  readonly permission: Scalars['String'];
};

export type AddAdStudioAdAccount = {
  readonly __typename: 'AddAdStudioAdAccount';
  readonly linking: Maybe<LinkingRequestObject>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AddAdStudioAdAccountInput = {
  readonly businessId: Scalars['String'];
  readonly id: Scalars['ID'];
};

export type AddAdvisorForOrganization = {
  readonly __typename: 'AddAdvisorForOrganization';
  readonly organization: Maybe<OrganizationObject>;
};

export type AddAdvisorForOrganizationInput = {
  readonly id: Scalars['String'];
};

/** We can save the secret on multiple objects, so this is just easier. */
export type AddArt19Secret = {
  readonly __typename: 'AddArt19Secret';
  readonly art19Secret: Maybe<Scalars['String']>;
};

export type AddArt19SecretInput = {
  readonly contentType: Scalars['String'];
  readonly pk: Scalars['ID'];
  readonly secret: Scalars['String'];
};

export type AddDomain = {
  readonly __typename: 'AddDomain';
  readonly organizationDomain: Maybe<OrganizationDomainObject>;
};

export type AddDomainInput = {
  readonly domain: Scalars['String'];
  readonly organizationId: Scalars['String'];
};

export type AddFeed = {
  readonly __typename: 'AddFeed';
  readonly feed: Maybe<FeedObject>;
};

export type AddFeedInput = {
  readonly href: Scalars['String'];
  readonly measure: InputMaybe<Scalars['Boolean']>;
};

export type AddMember = {
  readonly __typename: 'AddMember';
  readonly membership: Maybe<MembershipObject>;
  readonly organizationId: Maybe<Scalars['ID']>;
};

export type AddMemberInput = {
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly host: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly message: InputMaybe<Scalars['String']>;
  readonly organizationId: Scalars['String'];
  readonly role: Scalars['String'];
  readonly sendEmail: InputMaybe<Scalars['Boolean']>;
};

export type AddTag = {
  readonly __typename: 'AddTag';
  readonly companyId: Maybe<Scalars['ID']>;
  readonly productId: Maybe<Scalars['ID']>;
  readonly tag: Maybe<TagObject>;
};

export type AddTagInput = {
  readonly companyId: InputMaybe<Scalars['ID']>;
  readonly id: InputMaybe<Scalars['ID']>;
  readonly label: InputMaybe<Scalars['String']>;
  readonly productId: InputMaybe<Scalars['ID']>;
};

export type Admin = {
  readonly __typename: 'Admin';
  readonly billingRecords: Maybe<ReadonlyArray<Maybe<BillingRecord>>>;
  readonly campaign: Maybe<CampaignObject>;
  readonly campaigns: Maybe<ReadonlyArray<Maybe<CampaignObject>>>;
  readonly cloudsenseNewBrandRequests: Maybe<ReadonlyArray<Maybe<CloudsenseNewBrandRequestObject>>>;
  readonly companies: Maybe<ReadonlyArray<Maybe<CompanyObject>>>;
  readonly company: Maybe<CompanyObject>;
  readonly companyClaim: Maybe<CompanyClaimObject>;
  readonly companyClaims: Maybe<ReadonlyArray<Maybe<CompanyClaimObject>>>;
  readonly contact: Maybe<ContactObject>;
  readonly contacts: Maybe<ReadonlyArray<Maybe<ContactObject>>>;
  readonly episodelessCampaignEpisodes: Maybe<ReadonlyArray<Maybe<CampaignEpisodeObject>>>;
  readonly feed: Maybe<FeedObject>;
  readonly feedSearch: Maybe<ReadonlyArray<Maybe<FeedObject>>>;
  readonly feeds: Maybe<ReadonlyArray<Maybe<FeedObject>>>;
  readonly futureEpisode: Maybe<FutureEpisodeObject>;
  readonly futureEpisodes: Maybe<ReadonlyArray<Maybe<FutureEpisodeObject>>>;
  readonly invoice: Maybe<InvoiceObject>;
  readonly invoices: Maybe<ReadonlyArray<Maybe<InvoiceObject>>>;
  readonly liftReports: Maybe<ReadonlyArray<Maybe<LiftReportObject>>>;
  readonly management: Maybe<Management>;
  readonly notifications: Maybe<ReadonlyArray<Maybe<OrganizationNotificationObject>>>;
  readonly organization: Maybe<OrganizationObject>;
  readonly organizations: Maybe<ReadonlyArray<Maybe<OrganizationObject>>>;
  readonly prefixlessCampaignPodcasts: Maybe<ReadonlyArray<Maybe<CampaignPodcastObject>>>;
  readonly product: Maybe<ProductObject>;
  readonly queue: Maybe<QueueObject>;
  readonly reviewer: Maybe<ReviewerObject>;
  readonly reviewers: Maybe<ReadonlyArray<Maybe<ReviewerObject>>>;
  readonly reviews: Maybe<ReadonlyArray<Maybe<ReviewObject>>>;
  readonly tags: Maybe<ReadonlyArray<Maybe<TagObject>>>;
  readonly user: Maybe<UserObject>;
  readonly users: Maybe<ReadonlyArray<Maybe<UserObject>>>;
};


export type AdminBillingRecordsArgs = {
  after: Scalars['String'];
  before: InputMaybe<Scalars['String']>;
  span: InputMaybe<Scalars['String']>;
};


export type AdminCampaignArgs = {
  id: Scalars['ID'];
};


export type AdminCompaniesArgs = {
  duplicates: InputMaybe<Scalars['Boolean']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
};


export type AdminCompanyArgs = {
  id: InputMaybe<Scalars['ID']>;
  slug: InputMaybe<Scalars['String']>;
};


export type AdminCompanyClaimArgs = {
  id: Scalars['ID'];
};


export type AdminCompanyClaimsArgs = {
  states: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type AdminContactArgs = {
  id: Scalars['ID'];
};


export type AdminEpisodelessCampaignEpisodesArgs = {
  after: Scalars['String'];
  before: Scalars['String'];
};


export type AdminFeedArgs = {
  id: Scalars['ID'];
};


export type AdminFeedSearchArgs = {
  query: Scalars['String'];
  state: InputMaybe<Scalars['String']>;
};


export type AdminFeedsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  order: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
  state: InputMaybe<Scalars['String']>;
};


export type AdminFutureEpisodeArgs = {
  id: Scalars['ID'];
};


export type AdminFutureEpisodesArgs = {
  after: Scalars['String'];
  before: Scalars['String'];
};


export type AdminInvoiceArgs = {
  id: Scalars['ID'];
};


export type AdminNotificationsArgs = {
  kind: InputMaybe<Scalars['String']>;
};


export type AdminOrganizationArgs = {
  id: Scalars['ID'];
};


export type AdminOrganizationsArgs = {
  kind: InputMaybe<Scalars['String']>;
};


export type AdminProductArgs = {
  id: InputMaybe<Scalars['ID']>;
  slug: InputMaybe<Scalars['String']>;
};


export type AdminQueueArgs = {
  topic: Scalars['String'];
};


export type AdminReviewerArgs = {
  id: InputMaybe<Scalars['ID']>;
};


export type AdminTagsArgs = {
  query: InputMaybe<Scalars['String']>;
};


export type AdminUserArgs = {
  id: Scalars['ID'];
};

export type Advisor = {
  readonly __typename: 'Advisor';
  readonly brandsByIndustry: Maybe<BrandsOverviewSearchResults>;
  readonly columnGroups: Maybe<AdvisorColumnGroups>;
  readonly feedSearch: Maybe<AdvisorFeedSearch>;
  readonly id: Scalars['ID'];
  readonly options: Maybe<AdvisorOptions>;
  /** Organization requesting advisor */
  readonly organizationId: Scalars['ID'];
  readonly podcast: Maybe<LimitedPodcastObject>;
  readonly podcastsByIndustry: Maybe<FeedOverviewSearchResults>;
  readonly publisherAffinityScores: Maybe<ReadonlyArray<PublisherAffinityScoreObject>>;
  readonly publisherSearch: Maybe<AdvisorPublisherSearch>;
  readonly publishersByIndustry: Maybe<PublisherOverviewSearchResults>;
  readonly results: Maybe<AdvisorResults>;
  readonly savedSearch: Maybe<AdvisorSavedSearchObject>;
  readonly savedSearches: Maybe<ReadonlyArray<Maybe<AdvisorSavedSearchObject>>>;
  readonly show: Maybe<AdvisorShow>;
};


export type AdvisorBrandsByIndustryArgs = {
  industry: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
  page: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
};


export type AdvisorFeedSearchArgs = {
  query: InputMaybe<AdvisorFeedSearchQuery>;
};


export type AdvisorPodcastArgs = {
  id: Scalars['ID'];
};


export type AdvisorPodcastsByIndustryArgs = {
  industry: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
  page: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
};


export type AdvisorPublisherAffinityScoresArgs = {
  feedId: Scalars['ID'];
};


export type AdvisorPublisherSearchArgs = {
  query: InputMaybe<AdvisorPublisherSearchQuery>;
};


export type AdvisorPublishersByIndustryArgs = {
  industry: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
  page: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
};


export type AdvisorResultsArgs = {
  query: InputMaybe<AdvisorQuery>;
};


export type AdvisorSavedSearchArgs = {
  id: InputMaybe<Scalars['ID']>;
  slug: InputMaybe<Scalars['String']>;
};


export type AdvisorShowArgs = {
  id: Scalars['ID'];
  includeTestData: InputMaybe<Scalars['Boolean']>;
};

export type AdvisorCell = {
  readonly __typename: 'AdvisorCell';
  /** Column ID */
  readonly columnId: Scalars['String'];
  /** Column ID */
  readonly id: Scalars['ID'];
  readonly values: Maybe<ReadonlyArray<Maybe<AdvisorCellValue>>>;
};

export type AdvisorCellValue = {
  readonly __typename: 'AdvisorCellValue';
  /** If this is a filterable value, we set that here */
  readonly filterId: Maybe<Scalars['ID']>;
  /** Value of index (average of all values) for the column. */
  readonly index: Maybe<Scalars['Float']>;
  /** ID of the Object. */
  readonly objectId: Maybe<Scalars['ID']>;
  /** Standard deviation for the column. */
  readonly stddev: Maybe<Scalars['Float']>;
  /** Object Type [number, string, boolean] */
  readonly type: Maybe<Scalars['String']>;
  /** Value of Cell */
  readonly value: Maybe<Scalars['String']>;
};

export type AdvisorColumn = {
  readonly __typename: 'AdvisorColumn';
  readonly description: Maybe<Scalars['String']>;
  /** If this Column is filterable, then this is the id we should use. i.e. brand */
  readonly filterId: Maybe<Scalars['String']>;
  /** Average of all values for the column. */
  readonly filterIndex: Maybe<Scalars['Float']>;
  /** max value of the filter range. */
  readonly filterMax: Maybe<Scalars['Float']>;
  /** min value of the filter range. */
  readonly filterMin: Maybe<Scalars['Float']>;
  /** Standard deviation for the column. */
  readonly filterStddev: Maybe<Scalars['Float']>;
  /** Type of filter avalible. ['range'] */
  readonly filterType: Maybe<Scalars['String']>;
  /** Column ID, we use this in columns and sort on the input. */
  readonly id: Scalars['ID'];
  readonly title: Scalars['String'];
  /** Type of data in column. [int, float, duration, segment, string, boolean, datetime] */
  readonly type: Scalars['String'];
};

export type AdvisorColumnGroup = {
  readonly __typename: 'AdvisorColumnGroup';
  readonly columns: Maybe<ReadonlyArray<Maybe<AdvisorColumn>>>;
  /** If this Column Group is filterable, then this is the id we should use. i.e. brand */
  readonly filterId: Maybe<Scalars['String']>;
  /** Title of the Column Group */
  readonly title: Scalars['String'];
};

export type AdvisorColumnGroups = {
  readonly __typename: 'AdvisorColumnGroups';
  readonly brands: Maybe<AdvisorColumnGroup>;
  readonly clearbit: Maybe<AdvisorColumnGroup>;
  readonly columns: Maybe<ReadonlyArray<Maybe<AdvisorColumn>>>;
  readonly contentMaturity: Maybe<AdvisorColumnGroup>;
  readonly experian: Maybe<AdvisorColumnGroup>;
  readonly feedGrowth: Maybe<AdvisorColumnGroup>;
  readonly general: Maybe<AdvisorColumnGroup>;
  readonly industries: Maybe<AdvisorColumnGroup>;
  readonly nielsen: Maybe<AdvisorColumnGroup>;
  readonly overlap: Maybe<AdvisorColumnGroup>;
  readonly publishers: Maybe<AdvisorColumnGroup>;
  readonly radioMarkets: Maybe<AdvisorColumnGroup>;
  readonly tags: Maybe<AdvisorColumnGroup>;
};


export type AdvisorColumnGroupsBrandsArgs = {
  id: InputMaybe<Scalars['ID']>;
  query: InputMaybe<Scalars['String']>;
};


export type AdvisorColumnGroupsClearbitArgs = {
  id: InputMaybe<Scalars['ID']>;
  query: InputMaybe<Scalars['String']>;
};


export type AdvisorColumnGroupsColumnsArgs = {
  ids: ReadonlyArray<InputMaybe<Scalars['ID']>>;
};


export type AdvisorColumnGroupsExperianArgs = {
  id: InputMaybe<Scalars['ID']>;
  query: InputMaybe<Scalars['String']>;
};


export type AdvisorColumnGroupsFeedGrowthArgs = {
  query: InputMaybe<Scalars['String']>;
};


export type AdvisorColumnGroupsIndustriesArgs = {
  id: InputMaybe<Scalars['ID']>;
  query: InputMaybe<Scalars['String']>;
};


export type AdvisorColumnGroupsNielsenArgs = {
  id: InputMaybe<Scalars['ID']>;
  query: InputMaybe<Scalars['String']>;
};


export type AdvisorColumnGroupsOverlapArgs = {
  id: InputMaybe<Scalars['ID']>;
  query: InputMaybe<Scalars['String']>;
};


export type AdvisorColumnGroupsPublishersArgs = {
  id: InputMaybe<Scalars['ID']>;
  query: InputMaybe<Scalars['String']>;
};


export type AdvisorColumnGroupsRadioMarketsArgs = {
  id: InputMaybe<Scalars['ID']>;
  query: InputMaybe<Scalars['String']>;
};


export type AdvisorColumnGroupsTagsArgs = {
  id: InputMaybe<Scalars['ID']>;
  query: InputMaybe<Scalars['String']>;
};

export type AdvisorFeedSearch = {
  readonly __typename: 'AdvisorFeedSearch';
  readonly count: Maybe<Scalars['Int']>;
  readonly feeds: Maybe<ReadonlyArray<Maybe<LimitedFeedObject>>>;
  readonly limit: Maybe<Scalars['Int']>;
  readonly offset: Maybe<Scalars['Int']>;
  readonly publisherId: Maybe<Scalars['ID']>;
};

export type AdvisorFeedSearchQuery = {
  readonly limit: InputMaybe<Scalars['Int']>;
  readonly offset: InputMaybe<Scalars['Int']>;
  readonly publisherId: InputMaybe<Scalars['ID']>;
  readonly query: InputMaybe<Scalars['String']>;
};

export type AdvisorFilter = {
  readonly id: Scalars['String'];
  /** either OR or RANGE */
  readonly operator: Scalars['String'];
  readonly values: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type AdvisorOptions = {
  readonly __typename: 'AdvisorOptions';
  readonly capabilities: Maybe<ReadonlyArray<Maybe<CapabilityObject>>>;
  readonly id: Scalars['ID'];
};

export type AdvisorPublisherSearch = {
  readonly __typename: 'AdvisorPublisherSearch';
  readonly count: Maybe<Scalars['Int']>;
  readonly limit: Maybe<Scalars['Int']>;
  readonly results: Maybe<ReadonlyArray<Maybe<AdvisorPublisherSearchResult>>>;
};

export type AdvisorPublisherSearchQuery = {
  readonly limit: InputMaybe<Scalars['Int']>;
  readonly query: Scalars['String'];
};

export type AdvisorPublisherSearchResult = {
  readonly __typename: 'AdvisorPublisherSearchResult';
  readonly id: Maybe<Scalars['ID']>;
  readonly name: Maybe<Scalars['String']>;
};

export type AdvisorQuery = {
  /** Columns Requested */
  readonly columns: ReadonlyArray<InputMaybe<Scalars['String']>>;
  readonly filters: InputMaybe<ReadonlyArray<InputMaybe<AdvisorFilter>>>;
  readonly includeTestData: InputMaybe<Scalars['Boolean']>;
  /** Total number of rows returned */
  readonly limit: Scalars['Int'];
  /** Start index of results. */
  readonly offset: Scalars['Int'];
  readonly query: InputMaybe<Scalars['String']>;
  /** List of sort values in order, eg: [-affinity, -impressions] */
  readonly sort: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type AdvisorQuiz = {
  readonly __typename: 'AdvisorQuiz';
  readonly columnGroups: Maybe<AdvisorColumnGroups>;
};

export type AdvisorResults = {
  readonly __typename: 'AdvisorResults';
  readonly cells: Maybe<ReadonlyArray<Maybe<AdvisorCell>>>;
  /** Total number of results. */
  readonly count: Scalars['Int'];
  readonly id: Maybe<Scalars['ID']>;
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
  readonly rows: Maybe<ReadonlyArray<Maybe<AdvisorRow>>>;
};


export type AdvisorResultsRowsArgs = {
  query: InputMaybe<AdvisorQuery>;
};

export type AdvisorRow = {
  readonly __typename: 'AdvisorRow';
  readonly cells: Maybe<ReadonlyArray<Maybe<AdvisorCell>>>;
  readonly feed: Maybe<LimitedFeedObject>;
  readonly id: Maybe<Scalars['ID']>;
};

export type AdvisorSavedSearchObject = {
  readonly __typename: 'AdvisorSavedSearchObject';
  readonly createdAt: Scalars['DateTime'];
  readonly data: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly name: Scalars['String'];
  readonly orgDefault: Scalars['Boolean'];
  readonly organization: Maybe<UnAuthedOrganizationObject>;
  readonly slug: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
  readonly user: Maybe<UnAuthedUserObject>;
  readonly version: Scalars['Float'];
};

export type AdvisorShow = {
  readonly __typename: 'AdvisorShow';
  readonly ad: Maybe<AdObject>;
  readonly adLoad: Maybe<Scalars['Float']>;
  readonly adPlacements: Maybe<AdvisorShowAdPlacements>;
  readonly adsDurationMean: Maybe<Scalars['Float']>;
  readonly adsEpisodesSampled: Maybe<Scalars['Int']>;
  readonly adsPerEpisodeMean: Maybe<Scalars['Float']>;
  readonly adsPerEpisodeMedian: Maybe<Scalars['Float']>;
  readonly adsSampled: Maybe<Scalars['Int']>;
  readonly affinity: Maybe<Scalars['RoundedInt']>;
  readonly averageEpisodeLength: Maybe<Scalars['RoundedInt']>;
  readonly averageMonthlyImpressions: Maybe<Scalars['RoundedInt']>;
  readonly averageMonthlyReach: Maybe<Scalars['RoundedInt']>;
  readonly averageWeeklyImpressions: Maybe<Scalars['RoundedInt']>;
  readonly averageWeeklyReach: Maybe<Scalars['RoundedInt']>;
  readonly cadence: Maybe<Scalars['String']>;
  readonly capabilities: Maybe<ReadonlyArray<Maybe<AdvisorShowCapability>>>;
  readonly contentMaturity: Maybe<Scalars['Int']>;
  readonly dataQualityScore: Maybe<Scalars['Float']>;
  readonly feed: FeedObject;
  readonly firstRunImpressions: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly industriesOverview: Maybe<ReadonlyArray<Maybe<AdvisorShowIndustriesOverview>>>;
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly percentNewReach: Maybe<Scalars['Float']>;
  readonly podcast: Maybe<PodcastIdObject>;
  readonly publisher: Maybe<PublisherObject>;
  readonly samePublisher: Maybe<ReadonlyArray<Maybe<FeedObject>>>;
  readonly similarAudiences: Maybe<ReadonlyArray<Maybe<FeedObject>>>;
  readonly topBrands: Maybe<AdvisorShowTopBrandsResults>;
  readonly urbanClassification: Maybe<Scalars['Float']>;
};


export type AdvisorShowAdPlacementsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  q: InputMaybe<Scalars['String']>;
  sort: InputMaybe<Scalars['String']>;
};


export type AdvisorShowCapabilitiesArgs = {
  q: InputMaybe<Scalars['String']>;
};


export type AdvisorShowIndustriesOverviewArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  q: InputMaybe<Scalars['String']>;
  sort: InputMaybe<Scalars['String']>;
};


export type AdvisorShowSamePublisherArgs = {
  limit: InputMaybe<Scalars['Int']>;
};


export type AdvisorShowSimilarAudiencesArgs = {
  limit: InputMaybe<Scalars['Int']>;
};


export type AdvisorShowTopBrandsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  q: InputMaybe<Scalars['String']>;
  sort: InputMaybe<Scalars['String']>;
};

export type AdvisorShowAdPlacement = {
  readonly __typename: 'AdvisorShowAdPlacement';
  readonly brand: Maybe<CompanyObject>;
  readonly episode: Maybe<EpisodeObject>;
  readonly id: Scalars['ID'];
};

export type AdvisorShowAdPlacements = {
  readonly __typename: 'AdvisorShowAdPlacements';
  readonly count: Maybe<Scalars['Int']>;
  readonly limit: Maybe<Scalars['Int']>;
  readonly offset: Maybe<Scalars['Int']>;
  readonly rows: Maybe<ReadonlyArray<Maybe<AdvisorShowAdPlacement>>>;
};

export type AdvisorShowCapability = {
  readonly __typename: 'AdvisorShowCapability';
  readonly category: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['ID']>;
  readonly title: Maybe<Scalars['String']>;
};

export type AdvisorShowIndustriesOverview = {
  readonly __typename: 'AdvisorShowIndustriesOverview';
  readonly adCount: Maybe<Scalars['Int']>;
  readonly episodeCount: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly industry: Scalars['String'];
  readonly percent: Maybe<Scalars['Float']>;
  readonly totalAds: Maybe<Scalars['Int']>;
};

export type AdvisorShowTopBrand = {
  readonly __typename: 'AdvisorShowTopBrand';
  readonly adCount: Maybe<Scalars['Int']>;
  readonly brand: Maybe<CompanyObject>;
  readonly episodeCount: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
};

export type AdvisorShowTopBrandsResults = {
  readonly __typename: 'AdvisorShowTopBrandsResults';
  readonly count: Maybe<Scalars['Int']>;
  readonly limit: Maybe<Scalars['Int']>;
  readonly offset: Maybe<Scalars['Int']>;
  readonly rows: Maybe<ReadonlyArray<Maybe<AdvisorShowTopBrand>>>;
};

/** Used by AgencySearchQuery so that we don't leak all the things that point to agency. */
export type AgencySearchObject = {
  readonly __typename: 'AgencySearchObject';
  readonly id: Maybe<Scalars['ID']>;
  readonly name: Maybe<Scalars['String']>;
  readonly slug: Maybe<Scalars['String']>;
};

export type ApiKeyObject = {
  readonly __typename: 'ApiKeyObject';
  readonly key: Maybe<Scalars['String']>;
  readonly secret: Maybe<Scalars['String']>;
};

export type ApprovalAgency = {
  readonly __typename: 'ApprovalAgency';
  readonly id: Scalars['ID'];
  readonly members: Maybe<ReadonlyArray<Maybe<UnAuthedUserObject>>>;
  readonly name: Scalars['String'];
};

/**
 * All the people we can request approval from.
 *
 * Root is a campaign.
 */
export type ApprovalConfig = {
  readonly __typename: 'ApprovalConfig';
  readonly brandMembers: Maybe<ReadonlyArray<Maybe<UnAuthedUserObject>>>;
  readonly buySideAgencies: Maybe<ReadonlyArray<Maybe<ApprovalAgency>>>;
  readonly publisherMembers: Maybe<ReadonlyArray<Maybe<UnAuthedUserObject>>>;
};

export type ApprovalOrganization = {
  readonly __typename: 'ApprovalOrganization';
  readonly id: Scalars['ID'];
  readonly name: Maybe<Scalars['String']>;
};

/** start processing feeds. */
export type ArchiveFeed = {
  readonly __typename: 'ArchiveFeed';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type ArchiveFeedInput = {
  readonly feedId: Scalars['ID'];
};

export type Asr = {
  readonly __typename: 'Asr';
  readonly episodeId: Scalars['ID'];
  readonly feedId: Scalars['ID'];
  readonly labels: Maybe<ReadonlyArray<Maybe<AsrRange>>>;
  readonly transcript: Maybe<AsrTranscript>;
};

export type AsrRange = {
  readonly __typename: 'AsrRange';
  readonly end: Maybe<Scalars['Float']>;
  readonly start: Maybe<Scalars['Float']>;
};

export type AsrSpeaker = {
  readonly __typename: 'AsrSpeaker';
  readonly id: Maybe<Scalars['Int']>;
  readonly ranges: Maybe<ReadonlyArray<Maybe<AsrRange>>>;
};

export type AsrTranscript = {
  readonly __typename: 'AsrTranscript';
  readonly confidence: Maybe<Scalars['Float']>;
  readonly created: Maybe<Scalars['DateTime']>;
  readonly duration: Maybe<Scalars['Float']>;
  readonly speakers: Maybe<ReadonlyArray<Maybe<AsrSpeaker>>>;
  readonly transcript: Maybe<Scalars['String']>;
  readonly words: Maybe<ReadonlyArray<Maybe<AsrTranscriptWord>>>;
};

export type AsrTranscriptWord = {
  readonly __typename: 'AsrTranscriptWord';
  readonly confidence: Maybe<Scalars['Float']>;
  readonly end: Maybe<Scalars['Float']>;
  readonly punctuatedWord: Maybe<Scalars['String']>;
  readonly speaker: Maybe<Scalars['Float']>;
  readonly start: Maybe<Scalars['Float']>;
  readonly word: Maybe<Scalars['String']>;
};

export type AssetObject = {
  readonly __typename: 'AssetObject';
  readonly contentType: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly duration: Maybe<Scalars['Float']>;
  readonly height: Maybe<Scalars['Int']>;
  readonly id: Scalars['String'];
  readonly name: Scalars['String'];
  readonly path: Scalars['String'];
  readonly podlinkDomainFavicons: ReadonlyArray<PodlinkDomainObject>;
  readonly podlinkDomainsImages: ReadonlyArray<PodlinkDomainObject>;
  readonly size: Scalars['Float'];
  readonly src: Maybe<Scalars['String']>;
  readonly transcript: Maybe<Scalars['String']>;
  readonly waveform: Maybe<Scalars['String']>;
  readonly width: Maybe<Scalars['Int']>;
};

export type AssignSpotifyOrderBrand = {
  readonly __typename: 'AssignSpotifyOrderBrand';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AssignSpotifyOrderBrandInput = {
  readonly advertiserId: Scalars['ID'];
  readonly campaignKind: Scalars['String'];
  readonly spotifyOrderId: Scalars['ID'];
};

export type AttributionCampaignPreRangeInput = {
  readonly after: Scalars['String'];
  readonly before: Scalars['String'];
  readonly campaignId: Scalars['String'];
};

/** run the ranges. */
export type AttributionCampaignPreRun = {
  readonly __typename: 'AttributionCampaignPreRun';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AttributionCampaignPreRunInput = {
  readonly ranges: ReadonlyArray<InputMaybe<AttributionCampaignPreRangeInput>>;
};

export type AttributionConfigObject = {
  readonly __typename: 'AttributionConfigObject';
  readonly attributionConfigs: ReadonlyArray<OrganizationObject>;
  readonly attributionInterval: Scalars['Int'];
  readonly cableInterval: Scalars['Int'];
  readonly cellularInterval: Scalars['Int'];
  readonly corporateInterval: Scalars['Int'];
  readonly householdInterval: Scalars['Int'];
  readonly id: Scalars['String'];
  readonly maxUsersPerHousehold: Scalars['Int'];
};

export type AttributionDownload = {
  readonly __typename: 'AttributionDownload';
  readonly attribution: Scalars['Float'];
  readonly campaignDynamicId: Scalars['ID'];
  readonly campaignId: Scalars['ID'];
  readonly city: Maybe<Scalars['String']>;
  readonly country: Maybe<Scalars['String']>;
  readonly did: Scalars['ID'];
  readonly episode: Maybe<EpisodeObject>;
  readonly episodeId: Scalars['ID'];
  readonly feed: Maybe<FeedObject>;
  readonly feedId: Scalars['ID'];
  readonly householdIp: Scalars['ID'];
  readonly ip: Scalars['ID'];
  readonly key: Scalars['ID'];
  readonly kind: Scalars['String'];
  readonly latitude: Maybe<Scalars['Float']>;
  readonly longitude: Maybe<Scalars['Float']>;
  readonly region: Maybe<Scalars['String']>;
  readonly source: Scalars['String'];
  readonly time: Scalars['DateTime'];
  readonly uids: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly userAgent: Maybe<UserAgent>;
};

export type AttributionDownloadLocationsQuery = AttributionLocationInterface & {
  readonly __typename: 'AttributionDownloadLocationsQuery';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly cities: Maybe<ReadonlyArray<Maybe<AttributionLocation>>>;
  readonly city: Maybe<Scalars['String']>;
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly countries: Maybe<ReadonlyArray<Maybe<AttributionLocation>>>;
  readonly country: Maybe<Scalars['String']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly key: Scalars['ID'];
  readonly nodes: Maybe<ReadonlyArray<Maybe<AttributionLocation>>>;
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly region: Maybe<Scalars['String']>;
  readonly regions: Maybe<ReadonlyArray<Maybe<AttributionLocation>>>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};


export type AttributionDownloadLocationsQueryCitiesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type AttributionDownloadLocationsQueryCountriesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type AttributionDownloadLocationsQueryNodesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type AttributionDownloadLocationsQueryRegionsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};

export type AttributionDownloads = AttributionInterface & {
  readonly __typename: 'AttributionDownloads';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly key: Scalars['ID'];
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly query: Maybe<AttributionDownloadsQuery>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};

export type AttributionDownloadsQuery = AttributionInterface & {
  readonly __typename: 'AttributionDownloadsQuery';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly count: Maybe<Scalars['Int']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly householdIp: Maybe<Scalars['ID']>;
  readonly key: Scalars['ID'];
  readonly nodes: Maybe<ReadonlyArray<Maybe<AttributionDownload>>>;
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};


export type AttributionDownloadsQueryNodesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};

export type AttributionEvent = {
  readonly __typename: 'AttributionEvent';
  readonly action: Maybe<Scalars['String']>;
  readonly alias: Maybe<Scalars['String']>;
  readonly campaignDynamicIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly campaignIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly city: Maybe<Scalars['String']>;
  readonly country: Maybe<Scalars['String']>;
  readonly currency: Maybe<Scalars['String']>;
  readonly discountCode: Maybe<Scalars['String']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly householdId: Maybe<Scalars['String']>;
  readonly householdIp: Maybe<Scalars['String']>;
  readonly ip: Maybe<Scalars['String']>;
  readonly key: Scalars['ID'];
  readonly latitude: Maybe<Scalars['String']>;
  readonly leadCategory: Maybe<Scalars['String']>;
  readonly leadType: Maybe<Scalars['String']>;
  readonly lineItems: Maybe<Scalars['String']>;
  readonly longitude: Maybe<Scalars['String']>;
  readonly orderId: Maybe<Scalars['String']>;
  readonly product: Maybe<Scalars['String']>;
  readonly quantity: Maybe<Scalars['RoundedInt']>;
  readonly referrer: Maybe<Scalars['String']>;
  readonly referrerDomain: Maybe<Scalars['String']>;
  readonly referrerPath: Maybe<Scalars['String']>;
  readonly referrerType: Maybe<Scalars['String']>;
  readonly region: Maybe<Scalars['String']>;
  readonly source: Scalars['String'];
  readonly time: Maybe<Scalars['DateTime']>;
  readonly uid: Scalars['ID'];
  readonly url: Maybe<Scalars['String']>;
  readonly urlPath: Maybe<Scalars['String']>;
  readonly urlType: Maybe<Scalars['String']>;
  readonly userAgent: Maybe<UserAgent>;
  readonly value: Maybe<Scalars['Float']>;
};

export type AttributionEvents = AttributionInterface & {
  readonly __typename: 'AttributionEvents';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly hourly: Maybe<ReadonlyArray<Maybe<AttributionEventsHourly>>>;
  readonly key: Scalars['ID'];
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly purchaseValueByDay: Maybe<ReadonlyArray<Maybe<AttributionPurchaseValueByDay>>>;
  readonly query: Maybe<AttributionEventsQuery>;
  readonly sum: Maybe<AttributionEventsSum>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};

export type AttributionEventsHourly = {
  readonly __typename: 'AttributionEventsHourly';
  readonly action: Maybe<Scalars['String']>;
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly hour: Maybe<Scalars['DateTime']>;
};

export type AttributionEventsQuery = AttributionInterface & {
  readonly __typename: 'AttributionEventsQuery';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly count: Maybe<Scalars['Int']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly householdIp: Maybe<Scalars['ID']>;
  readonly key: Scalars['ID'];
  readonly nodes: Maybe<ReadonlyArray<Maybe<AttributionEvent>>>;
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};


export type AttributionEventsQueryCountArgs = {
  uid: InputMaybe<Scalars['String']>;
};


export type AttributionEventsQueryNodesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
  uid: InputMaybe<Scalars['String']>;
};

export type AttributionEventsSum = {
  readonly __typename: 'AttributionEventsSum';
  readonly addtocart: Maybe<Scalars['RoundedInt']>;
  readonly checkout: Maybe<Scalars['RoundedInt']>;
  readonly init: Maybe<Scalars['RoundedInt']>;
  readonly lead: Maybe<Scalars['RoundedInt']>;
  readonly product: Maybe<Scalars['RoundedInt']>;
  readonly purchase: Maybe<Scalars['RoundedInt']>;
};

export type AttributionHousehold = AttributionInterface & {
  readonly __typename: 'AttributionHousehold';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly downloads: Maybe<AttributionDownloadsQuery>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly events: Maybe<AttributionEventsQuery>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly ip: Scalars['ID'];
  readonly key: Scalars['ID'];
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};

export type AttributionHouseholds = AttributionInterface & {
  readonly __typename: 'AttributionHouseholds';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly household: Maybe<AttributionHousehold>;
  readonly key: Scalars['ID'];
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};


export type AttributionHouseholdsHouseholdArgs = {
  id: Scalars['ID'];
};

export type AttributionInterface = {
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly key: Scalars['ID'];
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};

export type AttributionLift = {
  readonly __typename: 'AttributionLift';
  readonly category: Maybe<Scalars['ID']>;
  readonly hour: Maybe<Scalars['DateTime']>;
  readonly kind: Maybe<Scalars['ID']>;
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly value: Maybe<Scalars['RoundedInt']>;
};

export type AttributionLocation = {
  readonly __typename: 'AttributionLocation';
  readonly city: Maybe<Scalars['String']>;
  readonly country: Maybe<Scalars['String']>;
  readonly latitude: Maybe<Scalars['Float']>;
  readonly longitude: Maybe<Scalars['Float']>;
  readonly region: Maybe<Scalars['String']>;
  readonly total: Maybe<Scalars['RoundedInt']>;
};

export type AttributionLocationInterface = {
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly city: Maybe<Scalars['String']>;
  readonly country: Maybe<Scalars['String']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly key: Scalars['ID'];
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly region: Maybe<Scalars['String']>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};

export type AttributionLocations = AttributionLocationInterface & {
  readonly __typename: 'AttributionLocations';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly city: Maybe<Scalars['String']>;
  readonly country: Maybe<Scalars['String']>;
  readonly downloads: Maybe<AttributionDownloadLocationsQuery>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly key: Scalars['ID'];
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly region: Maybe<Scalars['String']>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};

export type AttributionManagement = {
  readonly __typename: 'AttributionManagement';
  readonly backdated: Maybe<ReadonlyArray<Maybe<Backdated>>>;
  readonly missing: Maybe<ReadonlyArray<Maybe<Missing>>>;
};


export type AttributionManagementBackdatedArgs = {
  after: Scalars['String'];
  before: Scalars['String'];
  byPublished: InputMaybe<Scalars['Boolean']>;
  freqGte: InputMaybe<Scalars['Float']>;
};


export type AttributionManagementMissingArgs = {
  after: Scalars['String'];
  before: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type AttributionMarketing = AttributionInterface & {
  readonly __typename: 'AttributionMarketing';
  readonly acquired: Maybe<ReadonlyArray<Maybe<TargetAcquired>>>;
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly key: Scalars['ID'];
  readonly linkAttributionHourly: Maybe<ReadonlyArray<Maybe<LinkAttributionHourly>>>;
  readonly linkAttributionTargetEpisodes: Maybe<LinkTargetEpisodes>;
  readonly linkClicks: Maybe<ReadonlyArray<Maybe<LinkClicks>>>;
  readonly linkHourly: Maybe<ReadonlyArray<Maybe<LinkHourly>>>;
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly targetEpisodes: Maybe<MarketingTargetEpisodes>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};

export type AttributionObject = AttributionInterface & {
  readonly __typename: 'AttributionObject';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly downloads: Maybe<AttributionDownloads>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly events: Maybe<AttributionEvents>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly households: Maybe<AttributionHouseholds>;
  readonly key: Scalars['ID'];
  readonly lift: Maybe<ReadonlyArray<Maybe<AttributionLift>>>;
  readonly locations: Maybe<AttributionLocations>;
  readonly marketing: Maybe<AttributionMarketing>;
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
  readonly users: Maybe<AttributionUsers>;
};


export type AttributionObjectEventsArgs = {
  action: InputMaybe<Scalars['String']>;
};


export type AttributionObjectLiftArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  categories: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  category: InputMaybe<Scalars['String']>;
  kind: InputMaybe<Scalars['String']>;
  kinds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  limit: InputMaybe<Scalars['Int']>;
};


export type AttributionObjectLocationsArgs = {
  city: InputMaybe<Scalars['String']>;
  country: InputMaybe<Scalars['String']>;
  region: InputMaybe<Scalars['String']>;
};

/** I clear out the pre directories to get a fresh start if there is an issue. */
export type AttributionPreClearRange = {
  readonly __typename: 'AttributionPreClearRange';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AttributionPreRangeInput = {
  readonly after: Scalars['String'];
  readonly before: Scalars['String'];
  readonly organizationId: Scalars['String'];
};

/** run the ranges. */
export type AttributionPreRun = {
  readonly __typename: 'AttributionPreRun';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AttributionPreRunInput = {
  readonly ranges: ReadonlyArray<InputMaybe<AttributionPreRangeInput>>;
};

export type AttributionPurchaseValueByDay = {
  readonly __typename: 'AttributionPurchaseValueByDay';
  readonly day: Maybe<Scalars['DateTime']>;
  readonly value: Maybe<Scalars['Float']>;
};

export type AttributionReferrer = {
  readonly __typename: 'AttributionReferrer';
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly referrer: Maybe<Scalars['String']>;
};

export type AttributionReferrerDomain = {
  readonly __typename: 'AttributionReferrerDomain';
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly referrerDomain: Maybe<Scalars['String']>;
};

export type AttributionReferrerDomains = AttributionInterface & {
  readonly __typename: 'AttributionReferrerDomains';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly allNodes: Maybe<ReadonlyArray<Maybe<AttributionReferrerDomain>>>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly key: Scalars['ID'];
  readonly nodes: Maybe<ReadonlyArray<Maybe<AttributionReferrerDomain>>>;
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly sum: Maybe<Scalars['RoundedInt']>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};


export type AttributionReferrerDomainsNodesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};

export type AttributionReferrers = AttributionInterface & {
  readonly __typename: 'AttributionReferrers';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly allNodes: Maybe<ReadonlyArray<Maybe<AttributionReferrer>>>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly key: Scalars['ID'];
  readonly nodes: Maybe<ReadonlyArray<Maybe<AttributionReferrer>>>;
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly sum: Maybe<Scalars['RoundedInt']>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};


export type AttributionReferrersNodesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};

export type AttributionRun = {
  readonly __typename: 'AttributionRun';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AttributionRunInput = {
  readonly organizationId: Scalars['ID'];
  readonly reset: InputMaybe<Scalars['Boolean']>;
};

export type AttributionUrl = {
  readonly __typename: 'AttributionUrl';
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly url: Maybe<Scalars['String']>;
  readonly urlPath: Maybe<Scalars['String']>;
};

export type AttributionUrls = AttributionInterface & {
  readonly __typename: 'AttributionUrls';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly allNodes: Maybe<ReadonlyArray<Maybe<AttributionUrl>>>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly key: Scalars['ID'];
  readonly nodes: Maybe<ReadonlyArray<Maybe<AttributionUrl>>>;
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly sum: Maybe<Scalars['RoundedInt']>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};


export type AttributionUrlsNodesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};

export type AttributionUsers = AttributionInterface & {
  readonly __typename: 'AttributionUsers';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly hourlyVisitors: Maybe<ReadonlyArray<Maybe<AttributionVisitorsHourly>>>;
  readonly key: Scalars['ID'];
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly referrerDomains: Maybe<AttributionReferrerDomains>;
  readonly referrers: Maybe<AttributionReferrers>;
  readonly sum: Maybe<AttributionUsersSum>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
  readonly urls: Maybe<AttributionUrls>;
};


export type AttributionUsersReferrersArgs = {
  referrerDomain: InputMaybe<Scalars['String']>;
};

export type AttributionUsersSum = {
  readonly __typename: 'AttributionUsersSum';
  readonly addtocarts: Maybe<Scalars['Float']>;
  readonly addtocartsModeled: Maybe<Scalars['Float']>;
  readonly checkouts: Maybe<Scalars['Float']>;
  readonly checkoutsModeled: Maybe<Scalars['Float']>;
  readonly installed: Maybe<Scalars['Float']>;
  readonly installedModeled: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly leadValueModeled: Maybe<Scalars['Float']>;
  readonly leads: Maybe<Scalars['Float']>;
  readonly leadsModeled: Maybe<Scalars['Float']>;
  readonly pages: Maybe<Scalars['Float']>;
  readonly pagesModeled: Maybe<Scalars['Float']>;
  readonly products: Maybe<Scalars['Float']>;
  readonly productsModeled: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly purchaseValueModeled: Maybe<Scalars['Float']>;
  readonly purchases: Maybe<Scalars['Float']>;
  readonly purchasesModeled: Maybe<Scalars['Float']>;
  readonly sessions: Maybe<Scalars['Float']>;
  readonly sessionsModeled: Maybe<Scalars['Float']>;
  readonly users: Maybe<Scalars['RoundedInt']>;
  readonly usersModeled: Maybe<Scalars['Float']>;
  readonly value: Maybe<Scalars['Float']>;
  readonly valueModeled: Maybe<Scalars['Float']>;
};

export type AttributionVisitorsHourly = {
  readonly __typename: 'AttributionVisitorsHourly';
  readonly count: Maybe<Scalars['Float']>;
  readonly hour: Maybe<Scalars['DateTime']>;
};

export type AudienceInsightsMetricObject = {
  readonly __typename: 'AudienceInsightsMetricObject';
  readonly category: CampaignAudienceInsightsMetricCategory;
  readonly cr: Maybe<Scalars['Float']>;
  readonly crIndex: Maybe<Scalars['Float']>;
  readonly impressions: Maybe<Scalars['Int']>;
  readonly segment: Scalars['String'];
};

export type AudienceInsightsObject = {
  readonly __typename: 'AudienceInsightsObject';
  readonly age: ReadonlyArray<AudienceInsightsMetricObject>;
  readonly campaignId: Scalars['ID'];
  readonly device: ReadonlyArray<AudienceInsightsMetricObject>;
  readonly format: ReadonlyArray<AudienceInsightsMetricObject>;
  readonly gender: ReadonlyArray<AudienceInsightsMetricObject>;
  readonly musicGenre: ReadonlyArray<AudienceInsightsMetricObject>;
  readonly playlist: ReadonlyArray<AudienceInsightsMetricObject>;
  readonly podcastCategory: ReadonlyArray<AudienceInsightsMetricObject>;
  readonly userSegment: ReadonlyArray<AudienceInsightsMetricObject>;
};

export type Authed = {
  readonly __typename: 'Authed';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type AuthedInput = {
  readonly organizationId: InputMaybe<Scalars['ID']>;
  readonly token: InputMaybe<Scalars['String']>;
};

export type BackdateRange = {
  readonly __typename: 'BackdateRange';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type BackdateRangeInput = {
  readonly after: Scalars['String'];
  readonly before: Scalars['String'];
};

export type Backdated = {
  readonly __typename: 'Backdated';
  readonly organization: Maybe<OrganizationObject>;
  readonly rows: Maybe<ReadonlyArray<Maybe<BackdatedRow>>>;
};

export type BackdatedRow = {
  readonly __typename: 'BackdatedRow';
  readonly campaignEpisode: Maybe<CampaignEpisodeObject>;
  readonly end: Maybe<Scalars['DateTime']>;
  readonly hours: Maybe<Scalars['RoundedInt']>;
  readonly impressions: Maybe<Scalars['RoundedInt']>;
  readonly start: Maybe<Scalars['DateTime']>;
};

export type BenchmarkReportObject = {
  readonly __typename: 'BenchmarkReportObject';
  readonly analysisOverview: Maybe<Scalars['JSONStringNestedSerializer']>;
  readonly brandPerformanceCampaign: Maybe<Scalars['JSONStringNestedSerializer']>;
  readonly brandPerformancePublisher: Maybe<Scalars['JSONStringNestedSerializer']>;
  readonly industryBenchmarkReach: Maybe<Scalars['JSONStringNestedSerializer']>;
  readonly industryBenchmarkVisitor: Maybe<Scalars['JSONStringNestedSerializer']>;
  readonly quarter: Scalars['String'];
  readonly rollPlacement: Maybe<Scalars['JSONStringNestedSerializer']>;
};

export type BillingInfoObject = {
  readonly __typename: 'BillingInfoObject';
  readonly city: Maybe<Scalars['String']>;
  readonly companyName: Maybe<Scalars['String']>;
  readonly contactEmail: Maybe<Scalars['String']>;
  readonly email: Maybe<Scalars['String']>;
  readonly firstName: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly lastName: Maybe<Scalars['String']>;
  readonly phoneNumber: Maybe<Scalars['String']>;
  readonly stateOrProvince: Maybe<Scalars['String']>;
  readonly streetAddress: Maybe<Scalars['String']>;
  readonly taxRegistrationNumber: Maybe<Scalars['String']>;
  readonly zipCode: Maybe<Scalars['String']>;
};

export type BillingRecord = {
  readonly __typename: 'BillingRecord';
  readonly advertiserId: Maybe<Scalars['String']>;
  readonly advertiserName: Maybe<Scalars['String']>;
  readonly agency: Maybe<Scalars['String']>;
  readonly campaignEndAt: Maybe<Scalars['String']>;
  readonly campaignId: Maybe<Scalars['String']>;
  readonly campaignInternal: Maybe<Scalars['String']>;
  readonly campaignKind: Maybe<Scalars['String']>;
  readonly campaignName: Maybe<Scalars['String']>;
  readonly campaignStartAt: Maybe<Scalars['String']>;
  readonly campaignState: Maybe<Scalars['String']>;
  readonly impressions: Maybe<Scalars['RoundedInt']>;
  readonly lineItem: Maybe<Scalars['String']>;
  readonly organizationId: Maybe<Scalars['String']>;
  readonly organizationName: Maybe<Scalars['String']>;
  readonly payer: Maybe<Scalars['String']>;
  readonly spanEndAt: Maybe<Scalars['DateTime']>;
  readonly spanStartAt: Maybe<Scalars['DateTime']>;
};

export type BrandObject = {
  readonly __typename: 'BrandObject';
  readonly brandId: Maybe<Scalars['ID']>;
  readonly brandsOverview: Maybe<BrandsOverviewSearchResults>;
  readonly slug: Maybe<Scalars['String']>;
};


export type BrandObjectBrandsOverviewArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  maxAds: InputMaybe<Scalars['Int']>;
  maxCompanyFirstPublished: InputMaybe<Scalars['String']>;
  maxCompanyLastPublished: InputMaybe<Scalars['String']>;
  maxEpisodes: InputMaybe<Scalars['Int']>;
  maxPodcasts: InputMaybe<Scalars['Int']>;
  minAds: InputMaybe<Scalars['Int']>;
  minCompanyFirstPublished: InputMaybe<Scalars['String']>;
  minCompanyLastPublished: InputMaybe<Scalars['String']>;
  minEpisodes: InputMaybe<Scalars['Int']>;
  minPodcasts: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
};

export type BrandOverviewNode = {
  readonly __typename: 'BrandOverviewNode';
  readonly addtocarts: Maybe<Scalars['Float']>;
  readonly addtocartsModeled: Maybe<Scalars['Float']>;
  readonly advertiserName: Maybe<Scalars['String']>;
  readonly attributedDownloads: Maybe<Scalars['Float']>;
  readonly attributedDownloadsModeled: Maybe<Scalars['Float']>;
  readonly attributedReach: Maybe<Scalars['Float']>;
  readonly attributedReachModeled: Maybe<Scalars['Float']>;
  readonly campaignDynamicId: Scalars['ID'];
  readonly campaignId: Scalars['ID'];
  readonly campaignKind: Maybe<Scalars['String']>;
  readonly campaignName: Maybe<Scalars['String']>;
  readonly code: Maybe<Scalars['String']>;
  readonly episodeId: Scalars['ID'];
  readonly episodeTitle: Maybe<Scalars['String']>;
  readonly feedId: Scalars['ID'];
  readonly households: Maybe<Scalars['Float']>;
  readonly householdsModeled: Maybe<Scalars['Float']>;
  readonly impressions: Maybe<Scalars['RoundedInt']>;
  readonly installed: Maybe<Scalars['Float']>;
  readonly installedModeled: Maybe<Scalars['Float']>;
  readonly leads: Maybe<Scalars['Float']>;
  readonly leadsModeled: Maybe<Scalars['Float']>;
  readonly lineItemId: Maybe<Scalars['String']>;
  readonly lineItemName: Maybe<Scalars['String']>;
  readonly podcastTitle: Maybe<Scalars['String']>;
  readonly products: Maybe<Scalars['Float']>;
  readonly productsModeled: Maybe<Scalars['Float']>;
  readonly published: Maybe<Scalars['DateTime']>;
  readonly publisherName: Maybe<Scalars['String']>;
  readonly purchases: Maybe<Scalars['Float']>;
  readonly purchasesModeled: Maybe<Scalars['Float']>;
  readonly reach: Maybe<Scalars['RoundedInt']>;
  readonly spend: Maybe<Scalars['Float']>;
  readonly time: Maybe<Scalars['Date']>;
  readonly value: Maybe<Scalars['Float']>;
  readonly valueModeled: Maybe<Scalars['Float']>;
  readonly views: Maybe<Scalars['Float']>;
  readonly viewsModeled: Maybe<Scalars['Float']>;
  readonly visitors: Maybe<Scalars['Float']>;
  readonly visitorsModeled: Maybe<Scalars['Float']>;
};

export type BrandOverviewObject = {
  readonly __typename: 'BrandOverviewObject';
  readonly count: Scalars['RoundedInt'];
  readonly nodes: Maybe<ReadonlyArray<Maybe<BrandOverviewNode>>>;
};

export type BrandsOverviewSearchResult = {
  readonly __typename: 'BrandsOverviewSearchResult';
  readonly adFirstPublished: Maybe<Scalars['Date']>;
  readonly adsCount: Maybe<Scalars['Int']>;
  readonly companyFirstPublished: Maybe<Scalars['Date']>;
  readonly companyLastPublished: Maybe<Scalars['Date']>;
  readonly episodesCount: Maybe<Scalars['Int']>;
  readonly feedsCount: Maybe<Scalars['Int']>;
  readonly id: Maybe<Scalars['String']>;
  readonly industry: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly slug: Maybe<Scalars['String']>;
};

export type BrandsOverviewSearchResults = {
  readonly __typename: 'BrandsOverviewSearchResults';
  readonly results: Maybe<ReadonlyArray<Maybe<BrandsOverviewSearchResult>>>;
  readonly total: Maybe<Scalars['RoundedInt']>;
};

/** An enumeration. */
export enum CampaignAudienceInsightsMetricCategory {
  /** Age */
  Age = 'AGE',
  /** Podcast Category */
  Category = 'CATEGORY',
  /** Device */
  Device = 'DEVICE',
  /** Format */
  Format = 'FORMAT',
  /** Gender */
  Gender = 'GENDER',
  /** Music Genre */
  Genre = 'GENRE',
  /** Playlist */
  Playlist = 'PLAYLIST',
  /** User Segment */
  Segment = 'SEGMENT'
}

export type CampaignAuditLogEventObject = {
  readonly __typename: 'CampaignAuditLogEventObject';
  readonly action: Scalars['String'];
  readonly campaignOrLineItemName: Scalars['String'];
  readonly dateTimeChanged: Scalars['DateTime'];
  readonly eventType: CampaignAuditLogEventTypes;
  readonly fieldName: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly newVal: Maybe<Scalars['String']>;
  readonly oldVal: Maybe<Scalars['String']>;
  readonly userFirstName: Scalars['String'];
  readonly userLastInitial: Scalars['String'];
};

/** An enumeration. */
export enum CampaignAuditLogEventTypes {
  Campaign = 'CAMPAIGN',
  Dynamic = 'DYNAMIC',
  Embedded = 'EMBEDDED',
  Episode = 'EPISODE',
  Streaming = 'STREAMING'
}

/** An enumeration. */
export enum CampaignBroadcastCurrency {
  /** Australian Dollar */
  Aud = 'AUD',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Euro */
  Eur = 'EUR',
  /** Pound Sterling */
  Gbp = 'GBP',
  /** Ghanian Cedi */
  Ghs = 'GHS',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Naira */
  Ngn = 'NGN',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Uganda Shilling */
  Ugx = 'UGX',
  /** US Dollar */
  Usd = 'USD'
}

export type CampaignBroadcastObject = {
  readonly __typename: 'CampaignBroadcastObject';
  readonly addtocartTotal: Maybe<Scalars['Float']>;
  readonly addtocartTotalModeled: Maybe<Scalars['Float']>;
  readonly attribution: Maybe<AttributionObject>;
  readonly attributionTotal: Maybe<Scalars['Float']>;
  readonly campaign: CampaignObject;
  readonly campaignBroadcastStation: Maybe<CampaignBroadcastStationObject>;
  readonly campaignBroadcastStations: ReadonlyArray<CampaignBroadcastStationObject>;
  readonly checkoutTotal: Maybe<Scalars['Float']>;
  readonly checkoutTotalModeled: Maybe<Scalars['Float']>;
  readonly cost: Maybe<Scalars['Float']>;
  readonly costToDate: Maybe<Scalars['Float']>;
  readonly cpm: Maybe<Scalars['Float']>;
  readonly createdAt: Scalars['DateTime'];
  readonly currency: CampaignBroadcastCurrency;
  readonly discountCode: Maybe<Scalars['String']>;
  readonly discountUrl: Maybe<Scalars['String']>;
  readonly downloadTotal: Maybe<Scalars['BigInt']>;
  readonly downloads: Maybe<DownloadsObject>;
  readonly duration: Maybe<Scalars['Int']>;
  readonly effectiveUrl: Maybe<Scalars['String']>;
  readonly endAt: Maybe<Scalars['DateTime']>;
  readonly goal: Maybe<Scalars['Int']>;
  readonly id: Scalars['String'];
  readonly installedTotal: Maybe<Scalars['Float']>;
  readonly installedTotalModeled: Maybe<Scalars['Float']>;
  readonly isActive: Scalars['Boolean'];
  readonly isBaseline: Scalars['Boolean'];
  readonly leadTotal: Maybe<Scalars['Float']>;
  readonly leadTotalModeled: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly leadValueModeled: Maybe<Scalars['Float']>;
  readonly maids: Maybe<MaidsObject>;
  readonly name: Scalars['String'];
  readonly productTotal: Maybe<Scalars['Float']>;
  readonly productTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseTotal: Maybe<Scalars['Float']>;
  readonly purchaseTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly purchaseValueModeled: Maybe<Scalars['Float']>;
  readonly reachTotal: Maybe<Scalars['Int']>;
  readonly spotifyClickTotal: Maybe<Scalars['Int']>;
  readonly startAt: Maybe<Scalars['DateTime']>;
  readonly targetDownloadTotal: Maybe<Scalars['Float']>;
  readonly targetReachTotal: Maybe<Scalars['Float']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly userTotal: Maybe<Scalars['Float']>;
  readonly userTotalModeled: Maybe<Scalars['Float']>;
  readonly valueTotal: Maybe<Scalars['Float']>;
  readonly valueTotalModeled: Maybe<Scalars['Float']>;
};


export type CampaignBroadcastObjectAttributionArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  key: InputMaybe<Scalars['ID']>;
};


export type CampaignBroadcastObjectCampaignBroadcastStationArgs = {
  id: Scalars['ID'];
};


export type CampaignBroadcastObjectCpmArgs = {
  spendByImpressionsDelivered: InputMaybe<Scalars['Boolean']>;
};


export type CampaignBroadcastObjectDownloadsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
};

export type CampaignBroadcastStationObject = {
  readonly __typename: 'CampaignBroadcastStationObject';
  readonly addtocartTotal: Maybe<Scalars['Float']>;
  readonly addtocartTotalModeled: Maybe<Scalars['Float']>;
  readonly attribution: Maybe<AttributionObject>;
  readonly attributionTotal: Maybe<Scalars['Float']>;
  readonly campaignBroadcast: CampaignBroadcastObject;
  readonly checkoutTotal: Maybe<Scalars['Float']>;
  readonly checkoutTotalModeled: Maybe<Scalars['Float']>;
  readonly cost: Maybe<Scalars['Float']>;
  readonly costToDate: Maybe<Scalars['Float']>;
  readonly cpm: Maybe<Scalars['Float']>;
  readonly createdAt: Scalars['DateTime'];
  readonly currency: Maybe<Scalars['String']>;
  readonly downloadTotal: Maybe<Scalars['BigInt']>;
  readonly downloads: Maybe<DownloadsObject>;
  readonly endAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['String'];
  readonly installedTotal: Maybe<Scalars['Float']>;
  readonly installedTotalModeled: Maybe<Scalars['Float']>;
  readonly leadTotal: Maybe<Scalars['Float']>;
  readonly leadTotalModeled: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly leadValueModeled: Maybe<Scalars['Float']>;
  readonly productTotal: Maybe<Scalars['Float']>;
  readonly productTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseTotal: Maybe<Scalars['Float']>;
  readonly purchaseTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly purchaseValueModeled: Maybe<Scalars['Float']>;
  readonly reachTotal: Maybe<Scalars['Int']>;
  readonly spotifyClickTotal: Maybe<Scalars['Int']>;
  readonly startAt: Maybe<Scalars['DateTime']>;
  readonly targetDownloadTotal: Maybe<Scalars['Float']>;
  readonly targetReachTotal: Maybe<Scalars['Float']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly userTotal: Maybe<Scalars['Float']>;
  readonly userTotalModeled: Maybe<Scalars['Float']>;
  readonly valueTotal: Maybe<Scalars['Float']>;
  readonly valueTotalModeled: Maybe<Scalars['Float']>;
};


export type CampaignBroadcastStationObjectAttributionArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  key: InputMaybe<Scalars['ID']>;
};


export type CampaignBroadcastStationObjectCpmArgs = {
  spendByImpressionsDelivered: InputMaybe<Scalars['Boolean']>;
};


export type CampaignBroadcastStationObjectDownloadsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
};

export type CampaignBuySideAgencyMembershipObject = {
  readonly __typename: 'CampaignBuySideAgencyMembershipObject';
  readonly enabled: Maybe<Scalars['Boolean']>;
  readonly organizationId: Maybe<Scalars['String']>;
  readonly organizationName: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum CampaignCurrency {
  /** Australian Dollar */
  Aud = 'AUD',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Euro */
  Eur = 'EUR',
  /** Pound Sterling */
  Gbp = 'GBP',
  /** Ghanian Cedi */
  Ghs = 'GHS',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Naira */
  Ngn = 'NGN',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Uganda Shilling */
  Ugx = 'UGX',
  /** US Dollar */
  Usd = 'USD'
}

export type CampaignDebug = {
  readonly __typename: 'CampaignDebug';
  readonly after: Scalars['DateTime'];
  readonly attributionHourly: Maybe<ReadonlyArray<Maybe<HourlyNode>>>;
  readonly before: Scalars['DateTime'];
  readonly campaignId: Scalars['ID'];
  readonly embedded: Maybe<ReadonlyArray<Maybe<Embedded>>>;
  readonly events: Maybe<AttributionEvents>;
  readonly key: Scalars['ID'];
  readonly pixel: Maybe<PixelDebug>;
  readonly preHourly: Maybe<ReadonlyArray<Maybe<HourlyNode>>>;
  readonly prefixConsistency: ReadonlyArray<DataConsistencyNode>;
  readonly prefixHourly: Maybe<ReadonlyArray<Maybe<HourlyNode>>>;
  readonly webhookConsistency: ReadonlyArray<DataConsistencyNode>;
  readonly webhookHourly: Maybe<ReadonlyArray<Maybe<HourlyNode>>>;
  readonly webhookInvalidImpressions: Maybe<ReadonlyArray<Maybe<InvalidImpressionsNode>>>;
};


export type CampaignDebugPrefixConsistencyArgs = {
  campaignEpisodeId: InputMaybe<Scalars['ID']>;
  campaignPodcastId: InputMaybe<Scalars['ID']>;
};


export type CampaignDebugWebhookConsistencyArgs = {
  campaignDynamicId: InputMaybe<Scalars['ID']>;
};

/** An enumeration. */
export enum CampaignDownloadAlgorithm {
  /** Megaphone */
  Megaphone = 'MEGAPHONE',
  /** Podsights */
  Podsights = 'PODSIGHTS'
}

/** An enumeration. */
export enum CampaignDynamicCurrency {
  /** Australian Dollar */
  Aud = 'AUD',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Euro */
  Eur = 'EUR',
  /** Pound Sterling */
  Gbp = 'GBP',
  /** Ghanian Cedi */
  Ghs = 'GHS',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Naira */
  Ngn = 'NGN',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Uganda Shilling */
  Ugx = 'UGX',
  /** US Dollar */
  Usd = 'USD'
}

/** An enumeration. */
export enum CampaignDynamicDeleteReason {
  /** Cancellation */
  Cancel = 'CANCEL',
  /** Created In Error */
  Error = 'ERROR',
  /** No Reason Given */
  NoReason = 'NO_REASON',
  /** Other */
  Other = 'OTHER',
  /** Wrong Tracker Installed */
  Tracker = 'TRACKER'
}

export type CampaignDynamicDeliveryObject = {
  readonly __typename: 'CampaignDynamicDeliveryObject';
  readonly campaignDynamic: CampaignDynamicObject;
  readonly id: Scalars['String'];
  readonly viewedAt: Scalars['DateTime'];
  readonly viewedBy: Maybe<UnAuthedUserObject>;
};

export type CampaignDynamicEpisodeObject = {
  readonly __typename: 'CampaignDynamicEpisodeObject';
  readonly addtocartTotal: Maybe<Scalars['Float']>;
  readonly addtocartTotalModeled: Maybe<Scalars['Float']>;
  readonly attribution: Maybe<AttributionObject>;
  readonly attributionTotal: Maybe<Scalars['Float']>;
  readonly campaignDynamicPodcast: CampaignDynamicPodcastObject;
  readonly checkoutTotal: Maybe<Scalars['Float']>;
  readonly checkoutTotalModeled: Maybe<Scalars['Float']>;
  readonly cost: Maybe<Scalars['Float']>;
  readonly costToDate: Maybe<Scalars['Float']>;
  readonly cpm: Maybe<Scalars['Float']>;
  readonly createdAt: Scalars['DateTime'];
  readonly currency: Maybe<Scalars['Float']>;
  readonly downloadTotal: Maybe<Scalars['BigInt']>;
  readonly downloads: Maybe<DownloadsObject>;
  readonly endAt: Maybe<Scalars['DateTime']>;
  readonly episode: Maybe<EpisodeObject>;
  readonly id: Scalars['String'];
  readonly installedTotal: Maybe<Scalars['Float']>;
  readonly installedTotalModeled: Maybe<Scalars['Float']>;
  readonly leadTotal: Maybe<Scalars['Float']>;
  readonly leadTotalModeled: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly leadValueModeled: Maybe<Scalars['Float']>;
  readonly productTotal: Maybe<Scalars['Float']>;
  readonly productTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseTotal: Maybe<Scalars['Float']>;
  readonly purchaseTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly purchaseValueModeled: Maybe<Scalars['Float']>;
  readonly reachTotal: Maybe<Scalars['Int']>;
  readonly spotifyClickTotal: Maybe<Scalars['Int']>;
  readonly startAt: Maybe<Scalars['DateTime']>;
  readonly targetDownloadTotal: Maybe<Scalars['Float']>;
  readonly targetReachTotal: Maybe<Scalars['Float']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly userTotal: Maybe<Scalars['Float']>;
  readonly userTotalModeled: Maybe<Scalars['Float']>;
  readonly valueTotal: Maybe<Scalars['Float']>;
  readonly valueTotalModeled: Maybe<Scalars['Float']>;
};


export type CampaignDynamicEpisodeObjectAttributionArgs = {
  key: InputMaybe<Scalars['ID']>;
};


export type CampaignDynamicEpisodeObjectCpmArgs = {
  spendByImpressionsDelivered: InputMaybe<Scalars['Boolean']>;
};

export type CampaignDynamicObject = {
  readonly __typename: 'CampaignDynamicObject';
  readonly addtocartTotal: Maybe<Scalars['Float']>;
  readonly addtocartTotalModeled: Maybe<Scalars['Float']>;
  readonly approvals: ReadonlyArray<DynamicApprovalObject>;
  readonly art19Secret: Maybe<Scalars['String']>;
  readonly attribution: Maybe<AttributionObject>;
  readonly attributionTotal: Maybe<Scalars['Float']>;
  readonly auditLogEvents: ReadonlyArray<CampaignAuditLogEventObject>;
  readonly campaign: CampaignObject;
  readonly campaignDynamicPodcast: Maybe<CampaignDynamicPodcastObject>;
  readonly campaignDynamicPodcasts: ReadonlyArray<CampaignDynamicPodcastObject>;
  readonly checkoutTotal: Maybe<Scalars['Float']>;
  readonly checkoutTotalModeled: Maybe<Scalars['Float']>;
  readonly cloudsenseCost: Maybe<Scalars['Float']>;
  readonly cloudsenseExpectedEndAt: Maybe<Scalars['DateTime']>;
  readonly cloudsenseExpectedStartAt: Maybe<Scalars['DateTime']>;
  readonly cloudsenseGoal: Maybe<Scalars['Int']>;
  readonly cloudsenseName: Maybe<Scalars['String']>;
  readonly cost: Maybe<Scalars['Float']>;
  readonly costToDate: Maybe<Scalars['Float']>;
  readonly cpm: Maybe<Scalars['Float']>;
  readonly createdAt: Scalars['DateTime'];
  readonly currency: CampaignDynamicCurrency;
  readonly deleteReason: CampaignDynamicDeleteReason;
  readonly deleteReasons: Maybe<ReadonlyArray<Maybe<DeleteReasonObject>>>;
  readonly deliveries: ReadonlyArray<CampaignDynamicDeliveryObject>;
  readonly discountCode: Maybe<Scalars['String']>;
  readonly discountUrl: Maybe<Scalars['String']>;
  readonly downloadTotal: Maybe<Scalars['BigInt']>;
  readonly downloads: Maybe<DownloadsObject>;
  readonly duration: Maybe<Scalars['Int']>;
  readonly dynamicType: Maybe<Scalars['String']>;
  readonly effectiveUrl: Maybe<Scalars['String']>;
  readonly endAt: Maybe<Scalars['DateTime']>;
  readonly expectedEndAt: Maybe<Scalars['DateTime']>;
  readonly expectedStartAt: Maybe<Scalars['DateTime']>;
  readonly goal: Maybe<Scalars['Int']>;
  readonly id: Scalars['String'];
  readonly installedTotal: Maybe<Scalars['Float']>;
  readonly installedTotalModeled: Maybe<Scalars['Float']>;
  readonly isActive: Scalars['Boolean'];
  readonly isBaseline: Scalars['Boolean'];
  readonly isMidRoll: Scalars['Boolean'];
  readonly isPostRoll: Scalars['Boolean'];
  readonly isPpa: Scalars['Boolean'];
  readonly isPreRoll: Scalars['Boolean'];
  readonly leadTotal: Maybe<Scalars['Float']>;
  readonly leadTotalModeled: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly leadValueModeled: Maybe<Scalars['Float']>;
  readonly maids: Maybe<MaidsObject>;
  readonly multiplier: Scalars['Float'];
  readonly name: Scalars['String'];
  readonly notes: Maybe<Scalars['String']>;
  readonly productTotal: Maybe<Scalars['Float']>;
  readonly productTotalModeled: Maybe<Scalars['Float']>;
  readonly providerName: Maybe<CampaignDynamicProviderName>;
  readonly providerNames: Maybe<ReadonlyArray<Maybe<ProviderNameObject>>>;
  readonly providerTrackingUrl: Maybe<Scalars['String']>;
  readonly purchaseTotal: Maybe<Scalars['Float']>;
  readonly purchaseTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly purchaseValueModeled: Maybe<Scalars['Float']>;
  readonly reachTotal: Maybe<Scalars['Int']>;
  readonly source: CampaignDynamicSource;
  readonly spotifyAdFormat: Maybe<Scalars['String']>;
  readonly spotifyClickTotal: Scalars['Int'];
  readonly spotifyCtr: Scalars['Float'];
  readonly startAt: Maybe<Scalars['DateTime']>;
  readonly targetDownloadTotal: Maybe<Scalars['Float']>;
  readonly targetReachTotal: Maybe<Scalars['Float']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly userTotal: Maybe<Scalars['Float']>;
  readonly userTotalModeled: Maybe<Scalars['Float']>;
  readonly valueTotal: Maybe<Scalars['Float']>;
  readonly valueTotalModeled: Maybe<Scalars['Float']>;
};


export type CampaignDynamicObjectAttributionArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  key: InputMaybe<Scalars['ID']>;
};


export type CampaignDynamicObjectCampaignDynamicPodcastArgs = {
  id: Scalars['ID'];
};


export type CampaignDynamicObjectCpmArgs = {
  spendByImpressionsDelivered: InputMaybe<Scalars['Boolean']>;
};


export type CampaignDynamicObjectDownloadsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
};

export type CampaignDynamicPodcastObject = {
  readonly __typename: 'CampaignDynamicPodcastObject';
  readonly addtocartTotal: Maybe<Scalars['Float']>;
  readonly addtocartTotalModeled: Maybe<Scalars['Float']>;
  readonly attribution: Maybe<AttributionObject>;
  readonly attributionTotal: Maybe<Scalars['Float']>;
  readonly campaignDynamic: CampaignDynamicObject;
  readonly campaignDynamicEpisode: Maybe<CampaignDynamicEpisodeObject>;
  readonly campaignDynamicEpisodes: ReadonlyArray<CampaignDynamicEpisodeObject>;
  readonly campaignDynamicEpisodesCount: Maybe<Scalars['Int']>;
  readonly checkoutTotal: Maybe<Scalars['Float']>;
  readonly checkoutTotalModeled: Maybe<Scalars['Float']>;
  readonly cost: Maybe<Scalars['Float']>;
  readonly costToDate: Maybe<Scalars['Float']>;
  readonly cpm: Maybe<Scalars['Float']>;
  readonly createdAt: Scalars['DateTime'];
  readonly currency: Maybe<Scalars['String']>;
  readonly downloadTotal: Maybe<Scalars['BigInt']>;
  readonly downloads: Maybe<DownloadsObject>;
  readonly endAt: Maybe<Scalars['DateTime']>;
  readonly episodes: Maybe<ReadonlyArray<Maybe<EpisodeObject>>>;
  readonly feed: Maybe<LimitedFeedObject>;
  readonly id: Scalars['String'];
  readonly installedTotal: Maybe<Scalars['Float']>;
  readonly installedTotalModeled: Maybe<Scalars['Float']>;
  readonly leadTotal: Maybe<Scalars['Float']>;
  readonly leadTotalModeled: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly leadValueModeled: Maybe<Scalars['Float']>;
  readonly podcast: Maybe<PodcastIdObject>;
  readonly productTotal: Maybe<Scalars['Float']>;
  readonly productTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseTotal: Maybe<Scalars['Float']>;
  readonly purchaseTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly purchaseValueModeled: Maybe<Scalars['Float']>;
  readonly reachTotal: Maybe<Scalars['Int']>;
  readonly spotifyClickTotal: Maybe<Scalars['Int']>;
  readonly startAt: Maybe<Scalars['DateTime']>;
  readonly targetDownloadTotal: Maybe<Scalars['Float']>;
  readonly targetReachTotal: Maybe<Scalars['Float']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly userTotal: Maybe<Scalars['Float']>;
  readonly userTotalModeled: Maybe<Scalars['Float']>;
  readonly valueTotal: Maybe<Scalars['Float']>;
  readonly valueTotalModeled: Maybe<Scalars['Float']>;
};


export type CampaignDynamicPodcastObjectAttributionArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  key: InputMaybe<Scalars['ID']>;
};


export type CampaignDynamicPodcastObjectCampaignDynamicEpisodeArgs = {
  id: Scalars['ID'];
};


export type CampaignDynamicPodcastObjectCpmArgs = {
  spendByImpressionsDelivered: InputMaybe<Scalars['Boolean']>;
};


export type CampaignDynamicPodcastObjectDownloadsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
};


export type CampaignDynamicPodcastObjectEpisodesArgs = {
  after: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum CampaignDynamicProviderName {
  /** Acast */
  Acast = 'ACAST',
  /** Acast EU */
  AcastEu = 'ACAST_EU',
  /** AdsWizz */
  Adswizz = 'ADSWIZZ',
  /** Art19 */
  Art19 = 'ART19',
  /** Audioboom */
  Audioboom = 'AUDIOBOOM',
  /** Audiohook */
  Audiohook = 'AUDIOHOOK',
  /** Audiomeans */
  Audiomeans = 'AUDIOMEANS',
  /** Barstool HQ */
  BarstoolHq = 'BARSTOOL_HQ',
  /** Dovetail */
  Dovetail = 'DOVETAIL',
  /** DV360 */
  Dv360 = 'DV360',
  /** iHeart */
  Iheart = 'IHEART',
  /** iHeart Audience Marketplace */
  IheartAudienceMarketplace = 'IHEART_AUDIENCE_MARKETPLACE',
  /** Megaphone */
  Megaphone = 'MEGAPHONE',
  /** MTM */
  Mtm = 'MTM',
  /** No Provider Selected */
  None = 'NONE',
  /** Omny */
  Omny = 'OMNY',
  /** Podbean */
  Podbean = 'PODBEAN',
  /** RedCircle */
  Redcircle = 'REDCIRCLE',
  /** Simplecast */
  Simplecast = 'SIMPLECAST',
  /** Sounder */
  Sounder = 'SOUNDER',
  /** SPAN */
  Span = 'SPAN',
  /** Spotify DAI */
  SpotifyDai = 'SPOTIFY_DAI',
  /** Spotify SAI */
  SpotifySai = 'SPOTIFY_SAI',
  /** Spreaker */
  Spreaker = 'SPREAKER',
  /** TTD Podcast */
  TtdPodcast = 'TTD_PODCAST',
  /** Whooshkaa */
  Whooshkaa = 'WHOOSHKAA'
}

/** An enumeration. */
export enum CampaignDynamicSource {
  /** Ad Event Tracker */
  Aet = 'AET',
  /** GAM */
  Gam = 'GAM',
  /** Native (SpAA/Podsights) */
  Native = 'NATIVE',
  /** Spotify Ad Server / Ad Studio */
  Sas = 'SAS',
  /** Spotify Ad Server via CloudSense */
  SasCloudsense = 'SAS_CLOUDSENSE',
  /** SPAN */
  Span = 'SPAN'
}

export type CampaignEnhancedConversionsObject = {
  readonly __typename: 'CampaignEnhancedConversionsObject';
  readonly appleAttribution: Maybe<Scalars['Float']>;
  readonly appleCr: Maybe<Scalars['Float']>;
  readonly appleImpressions: Maybe<Scalars['Float']>;
  readonly appleReach: Maybe<Scalars['Float']>;
  readonly appleWeightedCr: Maybe<Scalars['Float']>;
  readonly campaignId: Scalars['ID'];
  readonly combinedOtherCr: Maybe<Scalars['Float']>;
  readonly combinedOtherImpressions: Maybe<Scalars['Float']>;
  readonly combinedOtherReach: Maybe<Scalars['Float']>;
  readonly combinedOtherWeightedCr: Maybe<Scalars['Float']>;
  readonly organizationId: Scalars['ID'];
  readonly otherCr: Maybe<Scalars['Float']>;
  readonly otherImpressions: Maybe<Scalars['Float']>;
  readonly otherReach: Maybe<Scalars['Float']>;
  readonly otherWeightedCr: Maybe<Scalars['Float']>;
  readonly spotifyAttribution: Maybe<Scalars['Float']>;
  readonly spotifyCr: Maybe<Scalars['Float']>;
  readonly spotifyImpressions: Maybe<Scalars['Float']>;
  readonly spotifyReach: Maybe<Scalars['Float']>;
  readonly totalImpressions: Maybe<Scalars['Float']>;
  readonly totalReach: Maybe<Scalars['Float']>;
};

export type CampaignEpisodeObject = {
  readonly __typename: 'CampaignEpisodeObject';
  readonly addtocartTotal: Maybe<Scalars['Float']>;
  readonly addtocartTotalModeled: Maybe<Scalars['Float']>;
  readonly attribution: Maybe<AttributionObject>;
  readonly attributionTotal: Maybe<Scalars['Float']>;
  readonly backdateAttemptDate: Maybe<Scalars['DateTime']>;
  readonly backdatedError: Scalars['Boolean'];
  readonly backdatedErrorMessage: Maybe<Scalars['String']>;
  readonly campaignPodcast: CampaignPodcastObject;
  readonly checkoutTotal: Maybe<Scalars['Float']>;
  readonly checkoutTotalModeled: Maybe<Scalars['Float']>;
  readonly cost: Maybe<Scalars['Float']>;
  readonly costToDate: Maybe<Scalars['Float']>;
  readonly cpm: Maybe<Scalars['Float']>;
  readonly createdAt: Scalars['DateTime'];
  readonly currency: Maybe<Scalars['String']>;
  readonly downloadTotal: Maybe<Scalars['BigInt']>;
  readonly downloads: Maybe<DownloadsObject>;
  readonly endAt: Maybe<Scalars['DateTime']>;
  readonly episode: Maybe<EpisodeObject>;
  readonly futureEpisode: Maybe<FutureEpisodeObject>;
  readonly goal: Maybe<Scalars['RoundedInt']>;
  readonly id: Scalars['String'];
  readonly installedTotal: Maybe<Scalars['Float']>;
  readonly installedTotalModeled: Maybe<Scalars['Float']>;
  readonly isBaseline: Scalars['Boolean'];
  readonly isDynamic: Scalars['Boolean'];
  readonly leadTotal: Maybe<Scalars['Float']>;
  readonly leadTotalModeled: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly leadValueModeled: Maybe<Scalars['Float']>;
  readonly maids: Maybe<MaidsObject>;
  readonly name: Maybe<Scalars['String']>;
  readonly otherPlacements: Maybe<ReadonlyArray<Maybe<PlacementObject>>>;
  readonly placements: Maybe<ReadonlyArray<Maybe<PlacementObject>>>;
  readonly productTotal: Maybe<Scalars['Float']>;
  readonly productTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseTotal: Maybe<Scalars['Float']>;
  readonly purchaseTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly purchaseValueModeled: Maybe<Scalars['Float']>;
  readonly reachTotal: Maybe<Scalars['Int']>;
  readonly spotifyClickTotal: Maybe<Scalars['Int']>;
  readonly startAt: Maybe<Scalars['DateTime']>;
  readonly targetDownloadTotal: Maybe<Scalars['Float']>;
  readonly targetReachTotal: Maybe<Scalars['Float']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly userTotal: Maybe<Scalars['Float']>;
  readonly userTotalModeled: Maybe<Scalars['Float']>;
  readonly valueTotal: Maybe<Scalars['Float']>;
  readonly valueTotalModeled: Maybe<Scalars['Float']>;
  readonly verified: Scalars['Boolean'];
};


export type CampaignEpisodeObjectAttributionArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  key: InputMaybe<Scalars['ID']>;
};


export type CampaignEpisodeObjectCpmArgs = {
  spendByImpressionsDelivered: InputMaybe<Scalars['Boolean']>;
};

export type CampaignFilterObject = {
  readonly __typename: 'CampaignFilterObject';
  readonly results: Maybe<ReadonlyArray<Maybe<CampaignObject>>>;
  readonly resultsCount: Maybe<Scalars['Int']>;
};

export type CampaignFilterQuery = {
  readonly advertisers: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly after: InputMaybe<Scalars['String']>;
  readonly before: InputMaybe<Scalars['String']>;
  readonly impressionsMax: InputMaybe<Scalars['Int']>;
  readonly impressionsMin: InputMaybe<Scalars['Int']>;
  readonly isCreatedByBrand: InputMaybe<Scalars['Boolean']>;
  readonly isMarketing: InputMaybe<Scalars['Boolean']>;
  readonly isPublisherApproved: InputMaybe<Scalars['Boolean']>;
  readonly limit: InputMaybe<Scalars['Int']>;
  readonly name: InputMaybe<Scalars['String']>;
  readonly offset: InputMaybe<Scalars['Int']>;
  readonly sort: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly states: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly tags: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly types: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};

export type CampaignLinkObject = {
  readonly __typename: 'CampaignLinkObject';
  readonly addtocartTotal: Maybe<Scalars['Float']>;
  readonly addtocartTotalModeled: Maybe<Scalars['Float']>;
  readonly attribution: Maybe<AttributionObject>;
  readonly attributionTotal: Maybe<Scalars['Float']>;
  readonly campaign: CampaignObject;
  readonly checkoutTotal: Maybe<Scalars['Float']>;
  readonly checkoutTotalModeled: Maybe<Scalars['Float']>;
  readonly clickTotal: Maybe<Scalars['Int']>;
  readonly costToDate: Maybe<Scalars['Float']>;
  readonly cpm: Maybe<Scalars['Float']>;
  readonly createdAt: Scalars['DateTime'];
  readonly design: Maybe<Scalars['String']>;
  readonly downloadTotal: Maybe<Scalars['BigInt']>;
  readonly id: Scalars['String'];
  readonly installedTotal: Maybe<Scalars['Float']>;
  readonly installedTotalModeled: Maybe<Scalars['Float']>;
  readonly leadTotal: Maybe<Scalars['Float']>;
  readonly leadTotalModeled: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly leadValueModeled: Maybe<Scalars['Float']>;
  readonly name: Maybe<Scalars['String']>;
  readonly productTotal: Maybe<Scalars['Float']>;
  readonly productTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseTotal: Maybe<Scalars['Float']>;
  readonly purchaseTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly purchaseValueModeled: Maybe<Scalars['Float']>;
  readonly reachTotal: Maybe<Scalars['Int']>;
  readonly redirectTotal: Maybe<Scalars['Int']>;
  readonly target: Maybe<CampaignTargetObject>;
  readonly targetDownloadTotal: Maybe<Scalars['Float']>;
  readonly targetReachTotal: Maybe<Scalars['Float']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly userTotal: Maybe<Scalars['Float']>;
  readonly userTotalModeled: Maybe<Scalars['Float']>;
  readonly valueTotal: Maybe<Scalars['Float']>;
  readonly valueTotalModeled: Maybe<Scalars['Float']>;
  readonly viewTotal: Maybe<Scalars['Int']>;
};


export type CampaignLinkObjectAttributionArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  key: InputMaybe<Scalars['ID']>;
};


export type CampaignLinkObjectCpmArgs = {
  spendByImpressionsDelivered: InputMaybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum CampaignMode {
  /** Default */
  Default = 'DEFAULT',
  /** Locked */
  Locked = 'LOCKED',
  /** Strict */
  Strict = 'STRICT'
}

export type CampaignNoiseObject = {
  readonly __typename: 'CampaignNoiseObject';
  readonly campaign: CampaignObject;
  readonly createdAt: Scalars['DateTime'];
  readonly endAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['String'];
  readonly name: Maybe<Scalars['String']>;
  readonly startAt: Maybe<Scalars['DateTime']>;
  readonly targetImpressions: Maybe<Scalars['Int']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly usePublisherImpressions: Scalars['Boolean'];
};

export type CampaignObject = {
  readonly __typename: 'CampaignObject';
  readonly addtocartTotal: Maybe<Scalars['Float']>;
  readonly addtocartTotalModeled: Maybe<Scalars['Float']>;
  readonly advertiser: Maybe<CompanyObject>;
  readonly advertiserCanView: Scalars['Boolean'];
  readonly advertiserEmail: Maybe<Scalars['String']>;
  readonly advertiserFirstName: Maybe<Scalars['String']>;
  readonly advertiserIsAgency: Scalars['Boolean'];
  readonly advertiserLastName: Maybe<Scalars['String']>;
  readonly allowBrandEditAccess: Scalars['Boolean'];
  readonly allowRetargeting: Scalars['Boolean'];
  readonly approvalConfig: Maybe<ApprovalConfig>;
  readonly art19Secret: Maybe<Scalars['String']>;
  readonly attribution: Maybe<AttributionObject>;
  readonly attributionCpm: Maybe<Scalars['Float']>;
  readonly attributionTotal: Maybe<Scalars['Float']>;
  readonly attributionWindow: Scalars['Int'];
  readonly audienceInsights: AudienceInsightsObject;
  readonly auditLogEvents: Maybe<ReadonlyArray<Maybe<CampaignAuditLogEventObject>>>;
  readonly buySideAgencies: Maybe<ReadonlyArray<Maybe<CampaignBuySideAgencyMembershipObject>>>;
  readonly campaignBroadcast: Maybe<CampaignBroadcastObject>;
  readonly campaignBroadcasts: ReadonlyArray<CampaignBroadcastObject>;
  readonly campaignDynamic: Maybe<CampaignDynamicObject>;
  readonly campaignDynamics: ReadonlyArray<CampaignDynamicObject>;
  readonly campaignEpisode: Maybe<CampaignEpisodeObject>;
  readonly campaignEpisodes: Maybe<ReadonlyArray<Maybe<CampaignEpisodeObject>>>;
  readonly campaignLink: Maybe<CampaignLinkObject>;
  readonly campaignLinks: ReadonlyArray<CampaignLinkObject>;
  readonly campaignNoises: ReadonlyArray<CampaignNoiseObject>;
  readonly campaignPodcast: Maybe<CampaignPodcastObject>;
  readonly campaignPodcasts: Maybe<ReadonlyArray<Maybe<CampaignPodcastObject>>>;
  readonly campaignStreaming: Maybe<CampaignStreamingObject>;
  readonly campaignStreamings: ReadonlyArray<CampaignStreamingObject>;
  readonly campaignTarget: Maybe<CampaignTargetObject>;
  readonly campaignTargets: ReadonlyArray<CampaignTargetObject>;
  readonly canViewBrand: Maybe<Scalars['Boolean']>;
  readonly checkoutTotal: Maybe<Scalars['Float']>;
  readonly checkoutTotalModeled: Maybe<Scalars['Float']>;
  readonly clickTotal: Maybe<Scalars['Int']>;
  readonly content: Maybe<Scalars['String']>;
  readonly conversionRows: Maybe<ReadonlyArray<Maybe<ConversionRowObject>>>;
  readonly cost: Maybe<Scalars['Float']>;
  readonly costToDate: Maybe<Scalars['Float']>;
  readonly cpm: Maybe<Scalars['Float']>;
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: Maybe<LimitedUserObject>;
  readonly currency: CampaignCurrency;
  readonly debug: Maybe<CampaignDebug>;
  readonly downloadAlgorithm: CampaignDownloadAlgorithm;
  readonly downloadTotal: Maybe<Scalars['BigInt']>;
  readonly downloads: Maybe<DownloadsObject>;
  readonly dynamicApprovals: Maybe<ReadonlyArray<Maybe<DynamicApprovalObject>>>;
  readonly endAt: Maybe<Scalars['DateTime']>;
  readonly enhancedConversions: Maybe<CampaignEnhancedConversionsObject>;
  readonly episode: Maybe<EpisodeObject>;
  readonly episodes: Maybe<ReadonlyArray<Maybe<EpisodeObject>>>;
  readonly expectedEndAt: Maybe<Scalars['DateTime']>;
  readonly expectedStartAt: Maybe<Scalars['DateTime']>;
  readonly futureEpisodes: Maybe<ReadonlyArray<Maybe<FutureEpisodeObject>>>;
  readonly genericTags: Maybe<ReadonlyArray<Maybe<GenericTagObject>>>;
  readonly goLiveDate: Maybe<Scalars['Date']>;
  readonly goal: Maybe<Scalars['Int']>;
  readonly goodReach: Maybe<Scalars['Int']>;
  readonly hideMatchedDynamics: Scalars['Boolean'];
  readonly householdReach: Maybe<Scalars['Int']>;
  readonly id: Scalars['String'];
  readonly impressions: Maybe<ImpressionsObject>;
  readonly installedTotal: Maybe<Scalars['Float']>;
  readonly installedTotalModeled: Maybe<Scalars['Float']>;
  readonly isCreatedByBrand: Scalars['Boolean'];
  readonly isExperianApproved: Scalars['Boolean'];
  readonly isHiddenFromAgency: Scalars['Boolean'];
  readonly isMegaphone: Scalars['Boolean'];
  readonly isNeustar: Scalars['Boolean'];
  readonly isNielsenApproved: Scalars['Boolean'];
  readonly isPpa: Maybe<Scalars['Boolean']>;
  readonly isPublisherApproved: Scalars['Boolean'];
  readonly isSas: Scalars['Boolean'];
  readonly kind: Maybe<Scalars['String']>;
  readonly lastBuilt: Maybe<Scalars['DateTime']>;
  readonly leadTotal: Maybe<Scalars['Float']>;
  readonly leadTotalModeled: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly leadValueModeled: Maybe<Scalars['Float']>;
  readonly liftReport: Maybe<LiftReportObject>;
  readonly liftReports: ReadonlyArray<LiftReportObject>;
  readonly liftreportSet: ReadonlyArray<LiftReportObject>;
  readonly maids: Maybe<MaidsObject>;
  readonly mode: CampaignMode;
  readonly multiplier: Scalars['Float'];
  readonly name: Scalars['String'];
  readonly noiselessReach: Maybe<Scalars['Int']>;
  readonly organization: Maybe<OrganizationObject>;
  readonly overlap: Maybe<Overlap>;
  readonly payer: Maybe<LimitedOrganizationObject>;
  readonly permission: Maybe<PermissionObject>;
  readonly permissions: Maybe<ReadonlyArray<Maybe<PermissionObject>>>;
  readonly pixel: Maybe<KeyObject>;
  readonly pixels: Maybe<ReadonlyArray<Maybe<KeyObject>>>;
  readonly podcastApprovals: Maybe<ReadonlyArray<Maybe<PodcastApprovalObject>>>;
  readonly productTotal: Maybe<Scalars['Float']>;
  readonly productTotalModeled: Maybe<Scalars['Float']>;
  readonly publisherDenyReason: Maybe<Scalars['String']>;
  readonly purchaseTotal: Maybe<Scalars['Float']>;
  readonly purchaseTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly purchaseValueModeled: Maybe<Scalars['Float']>;
  readonly reachTotal: Maybe<Scalars['Int']>;
  readonly redirectTotal: Maybe<Scalars['Int']>;
  readonly slug: Scalars['String'];
  readonly spotAudAge: ReadonlyArray<SpotifyAudienceObject>;
  readonly spotAudDevice: ReadonlyArray<SpotifyAudienceObject>;
  readonly spotAudFormat: ReadonlyArray<SpotifyAudienceObject>;
  readonly spotAudGender: ReadonlyArray<SpotifyAudienceObject>;
  readonly spotAudGenre: ReadonlyArray<SpotifyAudienceObject>;
  readonly spotAudPlaylist: ReadonlyArray<SpotifyAudienceObject>;
  readonly spotAudSegment: ReadonlyArray<SpotifyAudienceObject>;
  readonly spotifyBrandLiftReports: ReadonlyArray<SpotifyBrandLiftReportObject>;
  readonly spotifyClickTotal: Scalars['Int'];
  readonly spotifyCtr: Scalars['Float'];
  readonly spotifyOrder: Maybe<SpotifyOrderObject>;
  readonly startAt: Maybe<Scalars['DateTime']>;
  readonly state: CampaignState;
  readonly stateOverview: Maybe<CampaignStateOverview>;
  readonly streamingApprovals: Maybe<ReadonlyArray<Maybe<StreamingApprovalObject>>>;
  readonly targetDownloadTotal: Maybe<Scalars['Float']>;
  readonly targetOptions: Maybe<ReadonlyArray<Maybe<PodcastIdAndFeedObject>>>;
  readonly targetReachTotal: Maybe<Scalars['Float']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly userReachTotal: Maybe<Scalars['Int']>;
  readonly userTotal: Maybe<Scalars['Float']>;
  readonly userTotalModeled: Maybe<Scalars['Float']>;
  readonly valueTotal: Maybe<Scalars['Float']>;
  readonly valueTotalModeled: Maybe<Scalars['Float']>;
  readonly verifiedReach: Maybe<Scalars['Int']>;
  readonly viewTotal: Maybe<Scalars['Int']>;
};


export type CampaignObjectAttributionArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  key: InputMaybe<Scalars['ID']>;
};


export type CampaignObjectAuditLogEventsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type CampaignObjectCampaignBroadcastArgs = {
  id: Scalars['ID'];
};


export type CampaignObjectCampaignDynamicArgs = {
  id: Scalars['ID'];
};


export type CampaignObjectCampaignEpisodeArgs = {
  id: Scalars['ID'];
};


export type CampaignObjectCampaignLinkArgs = {
  id: Scalars['ID'];
};


export type CampaignObjectCampaignPodcastArgs = {
  id: Scalars['ID'];
};


export type CampaignObjectCampaignStreamingArgs = {
  id: Scalars['ID'];
};


export type CampaignObjectCampaignTargetArgs = {
  id: Scalars['ID'];
};


export type CampaignObjectConversionRowsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type CampaignObjectCpmArgs = {
  spendByImpressionsDelivered: InputMaybe<Scalars['Boolean']>;
};


export type CampaignObjectDownloadsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
};


export type CampaignObjectEpisodeArgs = {
  id: Scalars['ID'];
};


export type CampaignObjectGenericTagsArgs = {
  organizationId: Scalars['ID'];
};


export type CampaignObjectImpressionsArgs = {
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
};


export type CampaignObjectLiftReportArgs = {
  id: Scalars['ID'];
};


export type CampaignObjectOverlapArgs = {
  key: InputMaybe<Scalars['ID']>;
};


export type CampaignObjectPermissionArgs = {
  id: Scalars['ID'];
};


export type CampaignObjectPixelArgs = {
  key: Scalars['ID'];
};

export type CampaignOverlapObject = {
  readonly __typename: 'CampaignOverlapObject';
  readonly baseCampaign: Maybe<CampaignObject>;
  readonly baseCampaignId: Maybe<Scalars['ID']>;
  readonly baseDownloads: Maybe<Scalars['RoundedInt']>;
  readonly baseReach: Maybe<Scalars['RoundedInt']>;
  readonly combined: Maybe<Scalars['RoundedInt']>;
  readonly compCampaign: Maybe<CampaignObject>;
  readonly compCampaignId: Maybe<Scalars['ID']>;
  readonly compDownloads: Maybe<Scalars['RoundedInt']>;
  readonly compReach: Maybe<Scalars['RoundedInt']>;
  readonly overlap: Maybe<Scalars['RoundedInt']>;
};

/** Like the pixel but shareable. */
export type CampaignPixel = {
  readonly __typename: 'CampaignPixel';
  readonly hasData: Maybe<Scalars['Boolean']>;
  readonly historical: Maybe<ReadonlyArray<Maybe<CampaignPixelHistorical>>>;
};


/** Like the pixel but shareable. */
export type CampaignPixelHistoricalArgs = {
  after: Scalars['String'];
  before: Scalars['String'];
};

export type CampaignPixelHistorical = {
  readonly __typename: 'CampaignPixelHistorical';
  readonly day: Maybe<Scalars['DateTime']>;
  readonly init: Maybe<Scalars['RoundedInt']>;
  readonly installed: Maybe<Scalars['RoundedInt']>;
  readonly lead: Maybe<Scalars['RoundedInt']>;
  readonly purchase: Maybe<Scalars['RoundedInt']>;
};

/** An enumeration. */
export enum CampaignPodcastCurrency {
  /** Australian Dollar */
  Aud = 'AUD',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Euro */
  Eur = 'EUR',
  /** Pound Sterling */
  Gbp = 'GBP',
  /** Ghanian Cedi */
  Ghs = 'GHS',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Naira */
  Ngn = 'NGN',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Uganda Shilling */
  Ugx = 'UGX',
  /** US Dollar */
  Usd = 'USD'
}

/** An enumeration. */
export enum CampaignPodcastDeleteReason {
  /** Cancellation */
  Cancel = 'CANCEL',
  /** Created In Error */
  Error = 'ERROR',
  /** No Reason Given */
  NoReason = 'NO_REASON',
  /** Other */
  Other = 'OTHER',
  /** Wrong Tracker Installed */
  Tracker = 'TRACKER'
}

export type CampaignPodcastObject = {
  readonly __typename: 'CampaignPodcastObject';
  readonly addtocartTotal: Maybe<Scalars['Float']>;
  readonly addtocartTotalModeled: Maybe<Scalars['Float']>;
  readonly approvals: ReadonlyArray<PodcastApprovalObject>;
  readonly attribution: Maybe<AttributionObject>;
  readonly attributionTotal: Maybe<Scalars['Float']>;
  readonly auditLogEvents: ReadonlyArray<CampaignAuditLogEventObject>;
  readonly campaign: CampaignObject;
  readonly campaignEpisodes: ReadonlyArray<CampaignEpisodeObject>;
  readonly campaignEpisodesCount: Maybe<Scalars['Int']>;
  readonly checkoutTotal: Maybe<Scalars['Float']>;
  readonly checkoutTotalModeled: Maybe<Scalars['Float']>;
  readonly cost: Maybe<Scalars['Float']>;
  readonly costToDate: Maybe<Scalars['Float']>;
  readonly cpm: Maybe<Scalars['Float']>;
  readonly createdAt: Scalars['DateTime'];
  readonly currency: CampaignPodcastCurrency;
  readonly deleteReason: CampaignPodcastDeleteReason;
  readonly deleteReasons: Maybe<ReadonlyArray<Maybe<DeleteReasonObject>>>;
  readonly discountCode: Maybe<Scalars['String']>;
  readonly discountUrl: Maybe<Scalars['String']>;
  readonly downloadTotal: Maybe<Scalars['BigInt']>;
  readonly downloads: Maybe<DownloadsObject>;
  readonly drops: Maybe<Scalars['Int']>;
  readonly duration: Maybe<Scalars['Int']>;
  readonly effectiveUrl: Maybe<Scalars['String']>;
  readonly endAt: Maybe<Scalars['DateTime']>;
  readonly episodes: Maybe<ReadonlyArray<Maybe<EpisodeObject>>>;
  readonly expectedEndAt: Maybe<Scalars['DateTime']>;
  readonly expectedStartAt: Maybe<Scalars['DateTime']>;
  readonly feed: Maybe<LimitedFeedObject>;
  readonly futureEpisodes: ReadonlyArray<FutureEpisodeObject>;
  readonly goal: Maybe<Scalars['Int']>;
  readonly hasBaseline: Maybe<Scalars['Boolean']>;
  readonly hasPodsightsPrefix: Scalars['Boolean'];
  readonly id: Scalars['String'];
  readonly installedTotal: Maybe<Scalars['Float']>;
  readonly installedTotalModeled: Maybe<Scalars['Float']>;
  readonly isActive: Scalars['Boolean'];
  readonly isDynamic: Scalars['Boolean'];
  readonly isMidRoll: Scalars['Boolean'];
  readonly isPostRoll: Scalars['Boolean'];
  readonly isPreRoll: Scalars['Boolean'];
  readonly leadTotal: Maybe<Scalars['Float']>;
  readonly leadTotalModeled: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly leadValueModeled: Maybe<Scalars['Float']>;
  readonly maids: Maybe<MaidsObject>;
  readonly multiplier: Scalars['Float'];
  readonly name: Maybe<Scalars['String']>;
  readonly notes: Maybe<Scalars['String']>;
  readonly podcast: Maybe<PodcastIdObject>;
  readonly productTotal: Maybe<Scalars['Float']>;
  readonly productTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseTotal: Maybe<Scalars['Float']>;
  readonly purchaseTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly purchaseValueModeled: Maybe<Scalars['Float']>;
  readonly reachTotal: Maybe<Scalars['Int']>;
  readonly spotifyClickTotal: Maybe<Scalars['Int']>;
  readonly startAt: Maybe<Scalars['DateTime']>;
  readonly targetDownloadTotal: Maybe<Scalars['Float']>;
  readonly targetReachTotal: Maybe<Scalars['Float']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly userTotal: Maybe<Scalars['Float']>;
  readonly userTotalModeled: Maybe<Scalars['Float']>;
  readonly valueTotal: Maybe<Scalars['Float']>;
  readonly valueTotalModeled: Maybe<Scalars['Float']>;
};


export type CampaignPodcastObjectAttributionArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  key: InputMaybe<Scalars['ID']>;
};


export type CampaignPodcastObjectCpmArgs = {
  spendByImpressionsDelivered: InputMaybe<Scalars['Boolean']>;
};


export type CampaignPodcastObjectDownloadsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
};


export type CampaignPodcastObjectEpisodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum CampaignState {
  /** Agency */
  Agency = 'AGENCY',
  /** Approved */
  Approved = 'APPROVED',
  /** Complete */
  Complete = 'COMPLETE',
  /** Draft */
  Draft = 'DRAFT',
  /** Live */
  Live = 'LIVE',
  /** Ready */
  Ready = 'READY',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Requested */
  Requested = 'REQUESTED'
}

export type CampaignStateManger = {
  readonly __typename: 'CampaignStateManger';
  readonly id: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly slug: Maybe<Scalars['String']>;
};

export type CampaignStateMember = {
  readonly __typename: 'CampaignStateMember';
  readonly firstName: Maybe<Scalars['String']>;
  readonly lastName: Maybe<Scalars['String']>;
};

export type CampaignStateOverview = {
  readonly __typename: 'CampaignStateOverview';
  readonly managers: Maybe<ReadonlyArray<Maybe<CampaignStateManger>>>;
  readonly members: Maybe<ReadonlyArray<Maybe<CampaignStateMember>>>;
  readonly pixel: Maybe<CampaignPixel>;
};

/** An enumeration. */
export enum CampaignStreamingCurrency {
  /** Australian Dollar */
  Aud = 'AUD',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Euro */
  Eur = 'EUR',
  /** Pound Sterling */
  Gbp = 'GBP',
  /** Ghanian Cedi */
  Ghs = 'GHS',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Naira */
  Ngn = 'NGN',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Uganda Shilling */
  Ugx = 'UGX',
  /** US Dollar */
  Usd = 'USD'
}

export type CampaignStreamingDeliveryObject = {
  readonly __typename: 'CampaignStreamingDeliveryObject';
  readonly campaignStreaming: CampaignStreamingObject;
  readonly id: Scalars['String'];
  readonly viewedAt: Scalars['DateTime'];
  readonly viewedBy: Maybe<UnAuthedUserObject>;
};

export type CampaignStreamingObject = {
  readonly __typename: 'CampaignStreamingObject';
  readonly addtocartTotal: Maybe<Scalars['Float']>;
  readonly addtocartTotalModeled: Maybe<Scalars['Float']>;
  readonly approvals: ReadonlyArray<StreamingApprovalObject>;
  readonly attribution: Maybe<AttributionObject>;
  readonly attributionTotal: Maybe<Scalars['Float']>;
  readonly auditLogEvents: ReadonlyArray<CampaignAuditLogEventObject>;
  readonly campaign: CampaignObject;
  readonly campaignStreamingStream: Maybe<CampaignStreamingStreamObject>;
  readonly campaignStreamingStreams: ReadonlyArray<CampaignStreamingStreamObject>;
  readonly checkoutTotal: Maybe<Scalars['Float']>;
  readonly checkoutTotalModeled: Maybe<Scalars['Float']>;
  readonly cloudsenseCost: Maybe<Scalars['Float']>;
  readonly cloudsenseExpectedEndAt: Maybe<Scalars['DateTime']>;
  readonly cloudsenseExpectedStartAt: Maybe<Scalars['DateTime']>;
  readonly cloudsenseGoal: Maybe<Scalars['Int']>;
  readonly cloudsenseName: Maybe<Scalars['String']>;
  readonly cost: Maybe<Scalars['Float']>;
  readonly costToDate: Maybe<Scalars['Float']>;
  readonly cpm: Maybe<Scalars['Float']>;
  readonly createdAt: Scalars['DateTime'];
  readonly currency: CampaignStreamingCurrency;
  readonly deliveries: ReadonlyArray<CampaignStreamingDeliveryObject>;
  readonly discountCode: Maybe<Scalars['String']>;
  readonly discountUrl: Maybe<Scalars['String']>;
  readonly downloadTotal: Maybe<Scalars['BigInt']>;
  readonly downloads: Maybe<DownloadsObject>;
  readonly duration: Maybe<Scalars['Int']>;
  readonly effectiveUrl: Maybe<Scalars['String']>;
  readonly endAt: Maybe<Scalars['DateTime']>;
  readonly expectedEndAt: Maybe<Scalars['DateTime']>;
  readonly expectedStartAt: Maybe<Scalars['DateTime']>;
  readonly goal: Maybe<Scalars['Int']>;
  readonly id: Scalars['String'];
  readonly installedTotal: Maybe<Scalars['Float']>;
  readonly installedTotalModeled: Maybe<Scalars['Float']>;
  readonly isActive: Scalars['Boolean'];
  readonly isBaseline: Scalars['Boolean'];
  readonly isPpa: Scalars['Boolean'];
  readonly leadTotal: Maybe<Scalars['Float']>;
  readonly leadTotalModeled: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly leadValueModeled: Maybe<Scalars['Float']>;
  readonly maids: Maybe<MaidsObject>;
  readonly multiplier: Scalars['Float'];
  readonly name: Scalars['String'];
  readonly notes: Maybe<Scalars['String']>;
  readonly productTotal: Maybe<Scalars['Float']>;
  readonly productTotalModeled: Maybe<Scalars['Float']>;
  readonly providerName: Maybe<CampaignStreamingProviderName>;
  readonly providerNames: Maybe<ReadonlyArray<Maybe<ProviderNameObject>>>;
  readonly providerTrackingUrl: Maybe<Scalars['String']>;
  readonly purchaseTotal: Maybe<Scalars['Float']>;
  readonly purchaseTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly purchaseValueModeled: Maybe<Scalars['Float']>;
  readonly reachTotal: Maybe<Scalars['Int']>;
  readonly source: CampaignStreamingSource;
  readonly spotifyAdFormat: Maybe<Scalars['String']>;
  readonly spotifyClickTotal: Scalars['Int'];
  readonly spotifyCtr: Scalars['Float'];
  readonly startAt: Maybe<Scalars['DateTime']>;
  readonly targetDownloadTotal: Maybe<Scalars['Float']>;
  readonly targetReachTotal: Maybe<Scalars['Float']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly userReachTotal: Maybe<Scalars['Int']>;
  readonly userTotal: Maybe<Scalars['Float']>;
  readonly userTotalModeled: Maybe<Scalars['Float']>;
  readonly valueTotal: Maybe<Scalars['Float']>;
  readonly valueTotalModeled: Maybe<Scalars['Float']>;
  readonly verifiedReach: Maybe<Scalars['Int']>;
};


export type CampaignStreamingObjectAttributionArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  key: InputMaybe<Scalars['ID']>;
};


export type CampaignStreamingObjectCampaignStreamingStreamArgs = {
  id: Scalars['ID'];
};


export type CampaignStreamingObjectCpmArgs = {
  spendByImpressionsDelivered: InputMaybe<Scalars['Boolean']>;
};


export type CampaignStreamingObjectDownloadsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum CampaignStreamingProviderName {
  /** AdsWizz Streaming */
  AdswizzSt = 'ADSWIZZ_ST',
  /** audacy */
  Audacy = 'AUDACY',
  /** Empire */
  Empire = 'EMPIRE',
  /** iHeart Audience Marketplace */
  Iham = 'IHAM',
  /** iHeart */
  IheartSt = 'IHEART_ST',
  /** No Provider Selected */
  None = 'NONE',
  /** Pandora */
  Pandora = 'PANDORA',
  /** SCA */
  Sca = 'SCA',
  /** SCA GAM */
  ScaGam = 'SCA_GAM',
  /** Triton */
  Triton = 'TRITON',
  /** The Trade Desk Streaming */
  Ttdst = 'TTDST',
  /** WFUZ */
  Wfuz = 'WFUZ'
}

/** An enumeration. */
export enum CampaignStreamingSource {
  /** Ad Event Tracker */
  Aet = 'AET',
  /** GAM */
  Gam = 'GAM',
  /** Native (SpAA/Podsights) */
  Native = 'NATIVE',
  /** Spotify Ad Server / Ad Studio */
  Sas = 'SAS',
  /** Spotify Ad Server via CloudSense */
  SasCloudsense = 'SAS_CLOUDSENSE',
  /** SPAN */
  Span = 'SPAN'
}

export type CampaignStreamingStreamObject = {
  readonly __typename: 'CampaignStreamingStreamObject';
  readonly addtocartTotal: Maybe<Scalars['Float']>;
  readonly addtocartTotalModeled: Maybe<Scalars['Float']>;
  readonly attribution: Maybe<AttributionObject>;
  readonly attributionTotal: Maybe<Scalars['Float']>;
  readonly campaignStreaming: CampaignStreamingObject;
  readonly checkoutTotal: Maybe<Scalars['Float']>;
  readonly checkoutTotalModeled: Maybe<Scalars['Float']>;
  readonly cost: Maybe<Scalars['Float']>;
  readonly costToDate: Maybe<Scalars['Float']>;
  readonly cpm: Maybe<Scalars['Float']>;
  readonly createdAt: Scalars['DateTime'];
  readonly currency: Maybe<Scalars['String']>;
  readonly downloadTotal: Maybe<Scalars['BigInt']>;
  readonly downloads: Maybe<DownloadsObject>;
  readonly endAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['String'];
  readonly installedTotal: Maybe<Scalars['Float']>;
  readonly installedTotalModeled: Maybe<Scalars['Float']>;
  readonly leadTotal: Maybe<Scalars['Float']>;
  readonly leadTotalModeled: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly leadValueModeled: Maybe<Scalars['Float']>;
  readonly productTotal: Maybe<Scalars['Float']>;
  readonly productTotalModeled: Maybe<Scalars['Float']>;
  readonly providerNames: Maybe<ReadonlyArray<Maybe<ProviderNameObject>>>;
  readonly purchaseTotal: Maybe<Scalars['Float']>;
  readonly purchaseTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly purchaseValueModeled: Maybe<Scalars['Float']>;
  readonly reachTotal: Maybe<Scalars['Int']>;
  readonly spotifyClickTotal: Maybe<Scalars['Int']>;
  readonly startAt: Maybe<Scalars['DateTime']>;
  readonly targetDownloadTotal: Maybe<Scalars['Float']>;
  readonly targetReachTotal: Maybe<Scalars['Float']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly userTotal: Maybe<Scalars['Float']>;
  readonly userTotalModeled: Maybe<Scalars['Float']>;
  readonly valueTotal: Maybe<Scalars['Float']>;
  readonly valueTotalModeled: Maybe<Scalars['Float']>;
};


export type CampaignStreamingStreamObjectAttributionArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  key: InputMaybe<Scalars['ID']>;
};


export type CampaignStreamingStreamObjectCpmArgs = {
  spendByImpressionsDelivered: InputMaybe<Scalars['Boolean']>;
};


export type CampaignStreamingStreamObjectDownloadsArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
};

export type CampaignTargetObject = {
  readonly __typename: 'CampaignTargetObject';
  readonly attribution: Maybe<AttributionObject>;
  readonly campaign: CampaignObject;
  readonly campaignLinks: ReadonlyArray<CampaignLinkObject>;
  readonly createdAt: Scalars['DateTime'];
  readonly downloadTotal: Maybe<Scalars['Float']>;
  readonly feed: FeedObject;
  readonly id: Scalars['String'];
  readonly podcast: Maybe<PodcastIdObject>;
  readonly reachTotal: Maybe<Scalars['Float']>;
  readonly updatedAt: Scalars['DateTime'];
};


export type CampaignTargetObjectAttributionArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  key: InputMaybe<Scalars['ID']>;
};

export type CapabilityObject = {
  readonly __typename: 'CapabilityObject';
  readonly category: Scalars['String'];
  readonly id: Scalars['String'];
  readonly title: Scalars['String'];
};

export type CheckCampaignPodcastPrefix = {
  readonly __typename: 'CheckCampaignPodcastPrefix';
  readonly campaignPodcast: Maybe<CampaignPodcastObject>;
};

export type CheckCampaignPodcastPrefixInput = {
  readonly id: Scalars['ID'];
};

export type ChoiceObject = {
  readonly __typename: 'ChoiceObject';
  readonly displayValue: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
};

export type Claim = {
  readonly __typename: 'Claim';
  readonly publisher: Maybe<ClaimPublisherObject>;
  readonly verify: Maybe<ClaimPublisherObject>;
};


export type ClaimPublisherArgs = {
  href: Scalars['String'];
};


export type ClaimVerifyArgs = {
  payload: Scalars['String'];
};

export type ClaimAddPodcast = {
  readonly __typename: 'ClaimAddPodcast';
  readonly organization: Maybe<OrganizationObject>;
  readonly podcast: Maybe<PodcastIdObject>;
};

/** Add a feed to an Organization by creating a podcast. */
export type ClaimAddPodcastInput = {
  readonly hash: Scalars['String'];
  readonly href: Scalars['String'];
  readonly organizationId: Scalars['ID'];
};

export type ClaimFeed = {
  readonly __typename: 'ClaimFeed';
  readonly publisher: Maybe<ClaimPublisherObject>;
};

export type ClaimFeedInput = {
  readonly host: Scalars['String'];
  readonly href: Scalars['String'];
  readonly organizationId: Scalars['ID'];
};

export type ClaimPublisherObject = {
  readonly __typename: 'ClaimPublisherObject';
  readonly email: Maybe<Scalars['String']>;
  readonly hash: Maybe<Scalars['String']>;
  readonly href: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly organization: Maybe<LimitedOrganizationObject>;
  readonly title: Maybe<Scalars['String']>;
};

export type ClearQueue = {
  readonly __typename: 'ClearQueue';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type ClearQueueInput = {
  readonly topic: Scalars['String'];
};

/** An enumeration. */
export enum CloudsenseBrandMappingAttemptAttemptMethod {
  /** Existing Mapping */
  Mapping = 'MAPPING',
  /** Import Request */
  Request = 'REQUEST',
  /** String Match */
  String = 'STRING'
}

/** An enumeration. */
export enum CloudsenseBrandMappingAttemptConfidence {
  /** High */
  H = 'H',
  /** Low */
  L = 'L',
  /** Medium */
  M = 'M',
  /** No Guess */
  N = 'N'
}

export type CloudsenseBrandMappingAttemptObject = {
  readonly __typename: 'CloudsenseBrandMappingAttemptObject';
  readonly advertiserWebsite: Maybe<Scalars['String']>;
  readonly attemptMethod: CloudsenseBrandMappingAttemptAttemptMethod;
  readonly cloudsenseAdvertiserId: Scalars['String'];
  readonly cloudsenseAdvertiserName: Scalars['String'];
  readonly cloudsenseBillingAccountName: Scalars['String'];
  readonly company: Maybe<CompanyObject>;
  readonly confidence: CloudsenseBrandMappingAttemptConfidence;
  readonly spotifyOrder: Maybe<SpotifyOrderObject>;
};

export type CloudsenseNewBrandRequestObject = {
  readonly __typename: 'CloudsenseNewBrandRequestObject';
  readonly advertiserWebsite: Maybe<Scalars['String']>;
  readonly agencyName: Maybe<Scalars['String']>;
  readonly bookedStatus: Scalars['String'];
  readonly brandContactEmail: Scalars['String'];
  readonly brandContactFirstName: Scalars['String'];
  readonly brandContactLastName: Scalars['String'];
  readonly brandName: Scalars['String'];
  readonly campaignKind: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly isComplete: Scalars['Boolean'];
  readonly mappingAttempts: ReadonlyArray<CloudsenseBrandMappingAttemptObject>;
  readonly requestor: Maybe<LimitedUserObject>;
};

export type CommentObject = {
  readonly __typename: 'CommentObject';
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly objectId: Scalars['String'];
  readonly organization: Maybe<UnAuthedOrganizationObject>;
  readonly state: Maybe<Scalars['Int']>;
  readonly stateDisplay: Maybe<Scalars['String']>;
  readonly text: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly user: Maybe<UnAuthedUserObject>;
};

export type CompanyClaimObject = {
  readonly __typename: 'CompanyClaimObject';
  readonly company: Maybe<CompanyObject>;
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly organization: Maybe<LimitedOrganizationObject>;
  readonly state: CompanyClaimState;
  readonly updatedAt: Scalars['DateTime'];
  readonly user: Maybe<LimitedUserObject>;
};

/** An enumeration. */
export enum CompanyClaimState {
  /** Approved */
  Approved = 'APPROVED',
  /** Denied */
  Denied = 'DENIED',
  /** Requested */
  Requested = 'REQUESTED'
}

export type CompanyObject = {
  readonly __typename: 'CompanyObject';
  readonly activity: Maybe<ReadonlyArray<Maybe<ActivityObject>>>;
  readonly ad: Maybe<AdObject>;
  readonly adFirstPublished: Maybe<Scalars['DateTime']>;
  readonly ads: Maybe<ReadonlyArray<Maybe<AdObject>>>;
  readonly adsCount: Maybe<Scalars['Int']>;
  readonly archived: Scalars['Boolean'];
  readonly campaignCount: Scalars['Int'];
  readonly campaigns: Maybe<ReadonlyArray<Maybe<CampaignObject>>>;
  readonly claims: Maybe<ReadonlyArray<Maybe<CompanyClaimObject>>>;
  readonly createdAt: Scalars['DateTime'];
  readonly description: Maybe<Scalars['String']>;
  readonly episodes: Maybe<ReadonlyArray<Maybe<EpisodeObject>>>;
  readonly episodesCount: Maybe<Scalars['Int']>;
  readonly feeds: Maybe<ReadonlyArray<Maybe<FeedObject>>>;
  readonly feedsCount: Maybe<Scalars['Int']>;
  readonly hasActivePixel: Maybe<Scalars['Boolean']>;
  readonly hasCampaigns: Maybe<Scalars['Boolean']>;
  readonly id: Scalars['String'];
  readonly image: Maybe<MediaImageObject>;
  readonly industry: Maybe<Scalars['String']>;
  readonly industryDisplay: Maybe<Scalars['String']>;
  readonly isPublisher: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly organization: Maybe<UnAuthedOrganizationObject>;
  readonly products: ReadonlyArray<ProductObject>;
  readonly productsCount: Maybe<Scalars['Int']>;
  readonly similarByEpisode: Maybe<ReadonlyArray<Maybe<CompanyObject>>>;
  readonly similarByFeed: Maybe<ReadonlyArray<Maybe<CompanyObject>>>;
  readonly slug: Scalars['String'];
  readonly sponsorships: ReadonlyArray<AdObject>;
  readonly spotifyCampaignImportRequests: ReadonlyArray<SpotifyCampaignImportRequestObject>;
  readonly tags: ReadonlyArray<TagObject>;
  readonly updatedAt: Scalars['DateTime'];
  readonly url: Maybe<Scalars['String']>;
};


export type CompanyObjectActivityArgs = {
  interval: Scalars['String'];
  kind: Scalars['String'];
};


export type CompanyObjectAdArgs = {
  id: Scalars['ID'];
};


export type CompanyObjectAdFirstPublishedArgs = {
  after: InputMaybe<Scalars['String']>;
  feedId: InputMaybe<Scalars['ID']>;
};


export type CompanyObjectAdsArgs = {
  after: InputMaybe<Scalars['String']>;
  feedId: InputMaybe<Scalars['ID']>;
  industry: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
  q: InputMaybe<Scalars['String']>;
  state: InputMaybe<Scalars['String']>;
};


export type CompanyObjectAdsCountArgs = {
  after: InputMaybe<Scalars['String']>;
  feedId: InputMaybe<Scalars['ID']>;
};


export type CompanyObjectEpisodesArgs = {
  after: InputMaybe<Scalars['String']>;
  companyId: InputMaybe<Scalars['ID']>;
  limit: InputMaybe<Scalars['Int']>;
};


export type CompanyObjectEpisodesCountArgs = {
  after: InputMaybe<Scalars['String']>;
};


export type CompanyObjectFeedsArgs = {
  after: InputMaybe<Scalars['String']>;
  companyId: InputMaybe<Scalars['ID']>;
  limit: InputMaybe<Scalars['Int']>;
};


export type CompanyObjectFeedsCountArgs = {
  after: InputMaybe<Scalars['String']>;
};


export type CompanyObjectSimilarByEpisodeArgs = {
  limit: InputMaybe<Scalars['Int']>;
};


export type CompanyObjectSimilarByFeedArgs = {
  limit: InputMaybe<Scalars['Int']>;
};

/** Used by CompanySearchQuery so that we don't leak all the things that point to company. */
export type CompanySearchObject = {
  readonly __typename: 'CompanySearchObject';
  readonly company: Maybe<CompanyObject>;
  readonly hasActivePixel: Maybe<Scalars['Boolean']>;
  readonly id: Maybe<Scalars['ID']>;
  readonly industry: Maybe<Scalars['String']>;
  readonly industryDisplay: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly slug: Maybe<Scalars['String']>;
};

export type CompletePlacements = {
  readonly __typename: 'CompletePlacements';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CompletePlacementsInput = {
  readonly episodeId: Scalars['ID'];
};

export type ContactObject = {
  readonly __typename: 'ContactObject';
  readonly address1: Maybe<Scalars['String']>;
  readonly address2: Maybe<Scalars['String']>;
  readonly city: Maybe<Scalars['String']>;
  readonly company: Maybe<Scalars['String']>;
  readonly contactedAt: Maybe<Scalars['DateTime']>;
  readonly contactedBy: Maybe<LimitedUserObject>;
  readonly country: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly email: Scalars['String'];
  readonly firstName: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly ignoredAt: Maybe<Scalars['DateTime']>;
  readonly ignoredBy: Maybe<LimitedUserObject>;
  readonly lastName: Maybe<Scalars['String']>;
  readonly message: Maybe<Scalars['String']>;
  readonly region: Maybe<Scalars['String']>;
  readonly role: Maybe<Scalars['String']>;
  readonly source: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
  readonly zipCode: Maybe<Scalars['String']>;
};

export type ContactPublisher = {
  readonly __typename: 'ContactPublisher';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type ContactPublisherInput = {
  readonly company: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly message: InputMaybe<Scalars['String']>;
  readonly phone: InputMaybe<Scalars['String']>;
  readonly publisherId: Scalars['ID'];
};

export type ContactedContact = {
  readonly __typename: 'ContactedContact';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type ContactedContactInput = {
  readonly contactId: Scalars['ID'];
};

export type ConversionRowObject = {
  readonly __typename: 'ConversionRowObject';
  readonly avgValue: Maybe<Scalars['Float']>;
  readonly leadCategory: Maybe<Scalars['String']>;
  readonly leadType: Maybe<Scalars['String']>;
  readonly quantity: Maybe<Scalars['RoundedInt']>;
  readonly totalValue: Maybe<Scalars['Float']>;
};

export type ConversionUrlObject = {
  readonly __typename: 'ConversionURLObject';
  readonly action: Maybe<Scalars['String']>;
  readonly category: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly key: KeyObject;
  readonly type: Maybe<Scalars['String']>;
  readonly url: Scalars['String'];
  readonly value: Maybe<Scalars['Float']>;
};

export type CreateActionMap = {
  readonly __typename: 'CreateActionMap';
  readonly actionMap: Maybe<ActionMapObject>;
};

export type CreateActionMapInput = {
  readonly action: Scalars['String'];
  readonly eventName: Scalars['String'];
  readonly key: Scalars['ID'];
};

export type CreateAdvisorSavedSearch = {
  readonly __typename: 'CreateAdvisorSavedSearch';
  readonly advisorSavedSearch: Maybe<AdvisorSavedSearchObject>;
};

export type CreateAdvisorSavedSearchInput = {
  readonly data: Scalars['String'];
  readonly name: Scalars['String'];
  readonly orgDefault: InputMaybe<Scalars['Boolean']>;
  readonly organizationId: InputMaybe<Scalars['ID']>;
  readonly version: Scalars['Float'];
};

/** Used to generate an API key that can be used for querying our API directly.  We cannot retrieve this. */
export type CreateApiKey = {
  readonly __typename: 'CreateApiKey';
  readonly apiKey: Maybe<ApiKeyObject>;
};

export type CreateAsset = {
  readonly __typename: 'CreateAsset';
  readonly asset: Maybe<AssetObject>;
};

export type CreateAssetInput = {
  readonly contentType: Scalars['String'];
  readonly height: Scalars['RoundedInt'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly organizationId: Scalars['ID'];
  readonly path: Scalars['String'];
  readonly size: Scalars['RoundedInt'];
  readonly width: Scalars['RoundedInt'];
};

export type CreateBillingInfo = {
  readonly __typename: 'CreateBillingInfo';
  readonly billingInfo: Maybe<BillingInfoObject>;
};

export type CreateBillingInfoInput = {
  readonly city: InputMaybe<Scalars['String']>;
  readonly companyName: InputMaybe<Scalars['String']>;
  readonly contactEmail: InputMaybe<Scalars['String']>;
  readonly email: InputMaybe<Scalars['String']>;
  readonly firstName: InputMaybe<Scalars['String']>;
  readonly lastName: InputMaybe<Scalars['String']>;
  readonly organizationId: Scalars['ID'];
  readonly phoneNumber: InputMaybe<Scalars['String']>;
  readonly stateOrProvince: InputMaybe<Scalars['String']>;
  readonly streetAddress: InputMaybe<Scalars['String']>;
  readonly taxRegistrationNumber: InputMaybe<Scalars['String']>;
  readonly zipCode: InputMaybe<Scalars['String']>;
};

export type CreateBrandInvites = {
  readonly __typename: 'CreateBrandInvites';
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

/** Lots of rules about how to create an organization. */
export type CreateBrandInvitesInput = {
  readonly companyId: Scalars['ID'];
  readonly invitees: ReadonlyArray<InputMaybe<InviteesInput>>;
  readonly organizationId: Scalars['ID'];
};

export type CreateCampaign = {
  readonly __typename: 'CreateCampaign';
  readonly campaign: Maybe<CampaignObject>;
};

export type CreateCampaignApprovalRequest = {
  readonly requesteeIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly requesteeOrganizationId: Scalars['ID'];
};

export type CreateCampaignApprovals = {
  readonly __typename: 'CreateCampaignApprovals';
  readonly dynamicApprovals: Maybe<ReadonlyArray<Maybe<DynamicApprovalObject>>>;
  readonly podcastApprovals: Maybe<ReadonlyArray<Maybe<PodcastApprovalObject>>>;
  readonly streamingApprovals: Maybe<ReadonlyArray<Maybe<StreamingApprovalObject>>>;
};

export type CreateCampaignApprovalsInput = {
  readonly campaignId: Scalars['ID'];
  readonly organizationId: Scalars['ID'];
  readonly requests: InputMaybe<ReadonlyArray<InputMaybe<CreateCampaignApprovalRequest>>>;
};

export type CreateCampaignBroadcast = {
  readonly __typename: 'CreateCampaignBroadcast';
  readonly campaignBroadcast: Maybe<CampaignBroadcastObject>;
};

export type CreateCampaignBroadcastInput = {
  readonly campaignId: Scalars['ID'];
  readonly cost: InputMaybe<Scalars['Float']>;
  readonly currency: InputMaybe<Scalars['String']>;
  readonly discountCode: InputMaybe<Scalars['String']>;
  readonly discountUrl: InputMaybe<Scalars['String']>;
  readonly duration: InputMaybe<Scalars['Int']>;
  readonly effectiveUrl: InputMaybe<Scalars['String']>;
  readonly goal: InputMaybe<Scalars['Int']>;
  readonly isBaseline: InputMaybe<Scalars['Boolean']>;
  readonly name: Scalars['String'];
};

export type CreateCampaignDynamic = {
  readonly __typename: 'CreateCampaignDynamic';
  readonly campaignDynamic: Maybe<CampaignDynamicObject>;
};

export type CreateCampaignDynamicDelivery = {
  readonly __typename: 'CreateCampaignDynamicDelivery';
  readonly campaignDynamicDelivery: Maybe<CampaignDynamicDeliveryObject>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateCampaignDynamicDeliveryInput = {
  readonly campaignDynamicId: Scalars['ID'];
};

export type CreateCampaignDynamicInput = {
  readonly art19Secret: InputMaybe<Scalars['String']>;
  readonly campaignId: Scalars['ID'];
  readonly cost: Scalars['Float'];
  readonly currency: InputMaybe<Scalars['String']>;
  readonly discountCode: InputMaybe<Scalars['String']>;
  readonly discountUrl: InputMaybe<Scalars['String']>;
  readonly duration: Scalars['Int'];
  readonly dynamicType: InputMaybe<Scalars['String']>;
  readonly effectiveUrl: InputMaybe<Scalars['String']>;
  readonly expectedEndAt: InputMaybe<Scalars['DateTime']>;
  readonly expectedStartAt: InputMaybe<Scalars['DateTime']>;
  readonly goal: Scalars['Int'];
  readonly isBaseline: InputMaybe<Scalars['CoercedBoolean']>;
  readonly isMidRoll: InputMaybe<Scalars['CoercedBoolean']>;
  readonly isPostRoll: InputMaybe<Scalars['CoercedBoolean']>;
  readonly isPreRoll: InputMaybe<Scalars['CoercedBoolean']>;
  readonly name: Scalars['String'];
  readonly notes: InputMaybe<Scalars['String']>;
  readonly organizationId: InputMaybe<Scalars['ID']>;
  readonly providerName: InputMaybe<Scalars['String']>;
};

export type CreateCampaignEpisode = {
  readonly __typename: 'CreateCampaignEpisode';
  readonly campaignEpisode: Maybe<CampaignEpisodeObject>;
};

export type CreateCampaignEpisodeInput = {
  readonly campaignPodcastId: Scalars['ID'];
  readonly episodeId: InputMaybe<Scalars['ID']>;
  readonly futureEpisodeId: InputMaybe<Scalars['ID']>;
  readonly isBaseline: InputMaybe<Scalars['Boolean']>;
};

export type CreateCampaignInput = {
  readonly companyId: Scalars['ID'];
  readonly cost: Scalars['Float'];
  readonly currency: InputMaybe<Scalars['String']>;
  readonly endAt: InputMaybe<Scalars['DateTime']>;
  readonly expectedEndAt: InputMaybe<Scalars['DateTime']>;
  readonly expectedStartAt: InputMaybe<Scalars['DateTime']>;
  readonly goLiveDate: InputMaybe<Scalars['Date']>;
  readonly goal: Scalars['Int'];
  readonly isCreatedByBrand: InputMaybe<Scalars['Boolean']>;
  readonly isHiddenFromAgency: InputMaybe<Scalars['Boolean']>;
  readonly kind: Scalars['String'];
  readonly name: Scalars['String'];
  readonly organizationId: Scalars['ID'];
  readonly payerId: InputMaybe<Scalars['ID']>;
  readonly startAt: InputMaybe<Scalars['DateTime']>;
};

export type CreateCampaignLink = {
  readonly __typename: 'CreateCampaignLink';
  readonly campaignLink: Maybe<CampaignLinkObject>;
};

export type CreateCampaignLinkInput = {
  readonly campaignId: Scalars['ID'];
  readonly campaignTargetId: Scalars['ID'];
  readonly design: InputMaybe<Scalars['String']>;
  readonly name: Scalars['ID'];
};

export type CreateCampaignNoise = {
  readonly __typename: 'CreateCampaignNoise';
  readonly campaignNoise: Maybe<CampaignNoiseObject>;
};

export type CreateCampaignNoiseInput = {
  readonly campaignId: Scalars['ID'];
  readonly endAt: Scalars['Date'];
  readonly name: Scalars['String'];
  readonly startAt: Scalars['Date'];
  readonly targetImpressions: Scalars['Int'];
  readonly usePublisherImpressions: InputMaybe<Scalars['Boolean']>;
};

export type CreateCampaignPodcast = {
  readonly __typename: 'CreateCampaignPodcast';
  readonly campaignPodcast: Maybe<CampaignPodcastObject>;
};

export type CreateCampaignPodcastInput = {
  readonly campaignId: Scalars['ID'];
  readonly cost: Scalars['Float'];
  readonly currency: InputMaybe<Scalars['String']>;
  readonly discountCode: InputMaybe<Scalars['String']>;
  readonly discountUrl: InputMaybe<Scalars['String']>;
  readonly duration: Scalars['Int'];
  readonly effectiveUrl: InputMaybe<Scalars['String']>;
  readonly goal: Scalars['Int'];
  readonly isMidRoll: InputMaybe<Scalars['CoercedBoolean']>;
  readonly isPostRoll: InputMaybe<Scalars['CoercedBoolean']>;
  readonly isPreRoll: InputMaybe<Scalars['CoercedBoolean']>;
  readonly notes: InputMaybe<Scalars['String']>;
  readonly organizationId: InputMaybe<Scalars['ID']>;
  readonly podcastId: Scalars['ID'];
};

export type CreateCampaignStreaming = {
  readonly __typename: 'CreateCampaignStreaming';
  readonly campaignStreaming: Maybe<CampaignStreamingObject>;
};

export type CreateCampaignStreamingDelivery = {
  readonly __typename: 'CreateCampaignStreamingDelivery';
  readonly campaignStreamingDelivery: Maybe<CampaignStreamingDeliveryObject>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateCampaignStreamingDeliveryInput = {
  readonly campaignStreamingId: Scalars['ID'];
};

export type CreateCampaignStreamingInput = {
  readonly campaignId: Scalars['ID'];
  readonly cost: Scalars['Float'];
  readonly currency: InputMaybe<Scalars['String']>;
  readonly discountCode: InputMaybe<Scalars['String']>;
  readonly discountUrl: InputMaybe<Scalars['String']>;
  readonly duration: Scalars['Int'];
  readonly effectiveUrl: InputMaybe<Scalars['String']>;
  readonly goal: Scalars['Int'];
  readonly isBaseline: InputMaybe<Scalars['CoercedBoolean']>;
  readonly name: Scalars['String'];
  readonly notes: InputMaybe<Scalars['String']>;
  readonly organizationId: InputMaybe<Scalars['ID']>;
};

export type CreateCampaignTarget = {
  readonly __typename: 'CreateCampaignTarget';
  readonly campaignTarget: Maybe<CampaignTargetObject>;
};

export type CreateCampaignTargetInput = {
  readonly campaignId: Scalars['ID'];
  readonly podcastId: Scalars['ID'];
};

export type CreateComment = {
  readonly __typename: 'CreateComment';
  readonly comment: Maybe<CommentObject>;
};

export type CreateCommentInput = {
  readonly contentType: Scalars['String'];
  readonly objectId: Scalars['ID'];
  readonly text: Scalars['String'];
};

export type CreateCompany = {
  readonly __typename: 'CreateCompany';
  readonly company: Maybe<CompanyObject>;
};

export type CreateCompanyClaim = {
  readonly __typename: 'CreateCompanyClaim';
  readonly companyClaim: Maybe<LimitedCompanyClaimObject>;
};

/** Lots of rules about how to create an organization. */
export type CreateCompanyClaimInput = {
  readonly companyId: InputMaybe<Scalars['ID']>;
  readonly companyName: Scalars['ID'];
  readonly industry: InputMaybe<Scalars['String']>;
  readonly organizationId: Scalars['ID'];
};

export type CreateCompanyInput = {
  readonly industry: Scalars['String'];
  readonly name: Scalars['String'];
};

export type CreateContact = {
  readonly __typename: 'CreateContact';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateContactInput = {
  readonly company: InputMaybe<Scalars['String']>;
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly message: InputMaybe<Scalars['String']>;
  readonly role: InputMaybe<Scalars['String']>;
  readonly source: Scalars['String'];
};

export type CreateConversionUrl = {
  readonly __typename: 'CreateConversionURL';
  readonly conversionUrl: Maybe<ConversionUrlObject>;
};

export type CreateConversionUrlInput = {
  readonly action: Scalars['String'];
  readonly category: InputMaybe<Scalars['String']>;
  readonly key: Scalars['ID'];
  readonly type: InputMaybe<Scalars['String']>;
  readonly url: Scalars['String'];
  readonly value: InputMaybe<Scalars['Float']>;
};

export type CreateEpisodeRating = {
  readonly __typename: 'CreateEpisodeRating';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateEpisodeRatingException = {
  readonly __typename: 'CreateEpisodeRatingException';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateEpisodeRatingExceptionInput = {
  readonly category: Scalars['String'];
  readonly episodeId: Scalars['ID'];
  readonly exceptionText: Scalars['String'];
};

export type CreateEpisodeRatingInput = {
  readonly episodeId: Scalars['ID'];
  readonly modelVersion: Scalars['Int'];
  readonly rating: Scalars['Int'];
};

export type CreateExportInstance = {
  readonly __typename: 'CreateExportInstance';
  readonly exportInstance: Maybe<ExportInstanceObject>;
  readonly success: Scalars['Boolean'];
};

export type CreateExportInstanceInput = {
  readonly exportInstanceId: InputMaybe<Scalars['ID']>;
  readonly exportParameters: InputMaybe<ExportInstanceParameters>;
  readonly exportType: Scalars['String'];
  readonly fields: InputMaybe<ReadonlyArray<InputMaybe<FieldsInputObject>>>;
  readonly orderBy: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly organizationId: Scalars['ID'];
  readonly savedExportId: InputMaybe<Scalars['ID']>;
};

export type CreateExportToken = {
  readonly __typename: 'CreateExportToken';
  readonly token: Scalars['String'];
};

export type CreateExportTokenInput = {
  readonly entityId: Scalars['ID'];
  readonly kind: Scalars['String'];
  readonly objectType: Scalars['String'];
  readonly organizationId: Scalars['ID'];
};

export type CreateFutureEpisode = {
  readonly __typename: 'CreateFutureEpisode';
  readonly futureEpisode: Maybe<FutureEpisodeObject>;
  readonly organizationId: Scalars['ID'];
  readonly podcastId: Scalars['ID'];
};

export type CreateFutureEpisodeInput = {
  readonly campaignId: InputMaybe<Scalars['ID']>;
  readonly expectedPublished: Scalars['String'];
  readonly organizationId: Scalars['ID'];
  readonly podcastId: Scalars['ID'];
  readonly subtitle: InputMaybe<Scalars['String']>;
  readonly title: Scalars['String'];
};

export type CreateGenericTag = {
  readonly __typename: 'CreateGenericTag';
  readonly genericTag: Maybe<GenericTagObject>;
};

export type CreateGenericTagInput = {
  readonly color: Scalars['String'];
  readonly organizationId: Scalars['ID'];
  readonly title: Scalars['String'];
};

export type CreateGenericTagRelationship = {
  readonly __typename: 'CreateGenericTagRelationship';
  readonly genericTagRelationship: Maybe<GenericTagRelationshipObject>;
};

export type CreateGenericTagRelationshipInput = {
  readonly contentType: Scalars['String'];
  readonly genericTagId: Scalars['ID'];
  readonly objectPk: Scalars['ID'];
};

export type CreateImage = {
  readonly __typename: 'CreateImage';
  readonly image: Maybe<MediaImageObject>;
};

export type CreateImageInput = {
  readonly contentType: Scalars['String'];
  readonly height: Scalars['RoundedInt'];
  readonly id: Scalars['ID'];
  readonly path: Scalars['String'];
  readonly size: Scalars['RoundedInt'];
  readonly width: Scalars['RoundedInt'];
};

export type CreateInvoice = {
  readonly __typename: 'CreateInvoice';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateInvoiceInput = {
  readonly invoiceId: Scalars['ID'];
};

export type CreateKey = {
  readonly __typename: 'CreateKey';
  readonly key: Maybe<KeyObject>;
};

export type CreateKeyAndCompanyClaim = {
  readonly __typename: 'CreateKeyAndCompanyClaim';
  readonly companyClaim: LimitedCompanyClaimObject;
  readonly key: KeyObject;
};

export type CreateKeyAndCompanyClaimInput = {
  readonly alias: InputMaybe<Scalars['String']>;
  readonly companyId: InputMaybe<Scalars['ID']>;
  readonly companyName: Scalars['ID'];
  readonly domain: Scalars['String'];
  readonly industry: InputMaybe<Scalars['String']>;
  readonly installations: InputMaybe<Scalars['String']>;
  readonly organizationId: Scalars['String'];
  readonly role: Scalars['String'];
};

export type CreateKeyInput = {
  readonly alias: InputMaybe<Scalars['String']>;
  readonly domain: Scalars['String'];
  readonly installations: InputMaybe<Scalars['String']>;
  readonly organizationId: Scalars['String'];
  readonly role: Scalars['String'];
};

export type CreateLiftReport = {
  readonly __typename: 'CreateLiftReport';
  readonly liftReport: Maybe<LiftReportObject>;
};

export type CreateLiftReportInput = {
  readonly campaignIds: ReadonlyArray<InputMaybe<Scalars['ID']>>;
  readonly clampUrl: InputMaybe<Scalars['String']>;
  readonly delta: InputMaybe<Scalars['Int']>;
  readonly impressionsEndAt: InputMaybe<Scalars['Date']>;
  readonly impressionsStartAt: InputMaybe<Scalars['Date']>;
  readonly name: Scalars['String'];
  readonly organizationId: Scalars['ID'];
  readonly state: InputMaybe<Scalars['String']>;
  readonly useNoise: InputMaybe<Scalars['Boolean']>;
};

export type CreateOrganization = {
  readonly __typename: 'CreateOrganization';
  readonly organization: Maybe<OrganizationObject>;
};

export type CreateOrganizationInput = {
  readonly currency: InputMaybe<Scalars['String']>;
  readonly kind: Scalars['String'];
  readonly knowledgeLevel: InputMaybe<Scalars['String']>;
  readonly location: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
};

export type CreateOrganizationWithPixel = {
  readonly __typename: 'CreateOrganizationWithPixel';
  readonly organization: Maybe<OrganizationObject>;
  readonly pixel: Maybe<KeyObject>;
};

export type CreateOrganizationWithPixelInput = {
  readonly businessId: Scalars['String'];
  readonly organizationKind: Scalars['String'];
  readonly organizationName: Scalars['String'];
  readonly pixelAlias: InputMaybe<Scalars['String']>;
  readonly pixelDomain: Scalars['String'];
  readonly pixelInstallations: InputMaybe<Scalars['String']>;
  readonly pixelRole: InputMaybe<Scalars['String']>;
};

export type CreatePixelEventRecord = {
  readonly __typename: 'CreatePixelEventRecord';
  readonly pixelEventRecord: Maybe<PixelEventRecordObject>;
};

export type CreatePixelEventRecordInput = {
  readonly category: InputMaybe<Scalars['String']>;
  readonly currency: InputMaybe<Scalars['String']>;
  readonly discountCode: InputMaybe<Scalars['String']>;
  readonly eventType: Scalars['String'];
  readonly installation: Scalars['String'];
  readonly key: Scalars['ID'];
  readonly name: InputMaybe<Scalars['String']>;
  readonly newCustomer: InputMaybe<Scalars['String']>;
  readonly orderId: InputMaybe<Scalars['String']>;
  readonly productId: InputMaybe<Scalars['String']>;
  readonly productName: InputMaybe<Scalars['String']>;
  readonly productType: InputMaybe<Scalars['String']>;
  readonly productVendor: InputMaybe<Scalars['String']>;
  readonly quantity: InputMaybe<Scalars['String']>;
  readonly type: InputMaybe<Scalars['String']>;
  readonly value: InputMaybe<Scalars['String']>;
  readonly variantId: InputMaybe<Scalars['String']>;
  readonly variantName: InputMaybe<Scalars['String']>;
};

export type CreatePodcast = {
  readonly __typename: 'CreatePodcast';
  readonly feedId: Scalars['ID'];
  readonly organizationId: Scalars['ID'];
  readonly podcast: Maybe<PodcastIdObject>;
};

export type CreatePodcastInput = {
  readonly feedId: Scalars['ID'];
  readonly organizationId: Scalars['ID'];
  readonly relation: Scalars['Int'];
};

export type CreatePodlinkDomain = {
  readonly __typename: 'CreatePodlinkDomain';
  readonly podlinkDomain: Maybe<PodlinkDomainObject>;
};

export type CreatePodlinkDomainInput = {
  readonly description: InputMaybe<Scalars['String']>;
  readonly organizationId: Scalars['ID'];
  readonly podcastIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly slug: Scalars['ID'];
  readonly title: Scalars['String'];
};

export type CreateReviewer = {
  readonly __typename: 'CreateReviewer';
  readonly reviewer: Maybe<ReviewerObject>;
};

export type CreateReviewerInput = {
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly type: Scalars['String'];
};

export type CreateSavedExport = {
  readonly __typename: 'CreateSavedExport';
  readonly savedExport: Maybe<SavedExportObject>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateSavedExportInput = {
  readonly exportParameters: InputMaybe<ExportInstanceParameters>;
  readonly exportType: Scalars['String'];
  readonly fields: InputMaybe<ReadonlyArray<InputMaybe<FieldsInputObject>>>;
  readonly name: Scalars['String'];
  readonly orderBy: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly organizationId: Scalars['ID'];
  readonly savedExport: InputMaybe<Scalars['ID']>;
  readonly slug: InputMaybe<Scalars['String']>;
};

/**
 * Used to generate an API key that is separate from any actual user,
 * giving access to only the current organization.
 */
export type CreateServiceAccountApiKey = {
  readonly __typename: 'CreateServiceAccountApiKey';
  readonly apiKey: Maybe<ApiKeyObject>;
};

export type CreateServiceAccountApiKeyInput = {
  readonly organizationId: Scalars['ID'];
};

export type CreateSpotifyCampaignImportRequests = {
  readonly __typename: 'CreateSpotifyCampaignImportRequests';
  readonly existingSpotifyCampaignImportRequests: Maybe<ReadonlyArray<Maybe<SpotifyCampaignImportRequestObject>>>;
  readonly newSpotifyCampaignImportRequests: Maybe<ReadonlyArray<Maybe<SpotifyCampaignImportRequestObject>>>;
};

export type CreateSpotifyCampaignImportRequestsInput = {
  readonly companyId: Scalars['ID'];
  readonly spotifyOrderIds: ReadonlyArray<InputMaybe<Scalars['String']>>;
};

export type CreateTermsAndConditions = {
  readonly __typename: 'CreateTermsAndConditions';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateTermsAndConditionsInput = {
  readonly organizationId: Scalars['ID'];
};

export type CreateUser = {
  readonly __typename: 'CreateUser';
  readonly user: Maybe<LimitedUserObject>;
};

export type CreateUserAccess = {
  readonly __typename: 'CreateUserAccess';
  readonly userAccess: Maybe<UserAccessObject>;
};

export type CreateUserAccessInput = {
  readonly contentType: Scalars['String'];
  readonly objectPk: Scalars['ID'];
  readonly organizationId: Scalars['ID'];
  readonly permission: Scalars['String'];
  readonly userId: Scalars['ID'];
};

export type CreateUserInput = {
  readonly host: InputMaybe<Scalars['String']>;
};

export type CreateUserSkippedTerms = {
  readonly __typename: 'CreateUserSkippedTerms';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type CreateUserSkippedTermsInput = {
  readonly organizationId: Scalars['ID'];
};

export type CurrencyNameObject = {
  readonly __typename: 'CurrencyNameObject';
  readonly currencyName: Maybe<Scalars['String']>;
  readonly currencyNameDisplay: Maybe<Scalars['String']>;
};

export type DailyCampaignBillingRecord = {
  readonly __typename: 'DailyCampaignBillingRecord';
  readonly advertiserId: Maybe<Scalars['String']>;
  readonly advertiserName: Maybe<Scalars['String']>;
  readonly campaignId: Maybe<Scalars['String']>;
  readonly campaignName: Maybe<Scalars['String']>;
  readonly downloadDate: Maybe<Scalars['Date']>;
  readonly impressions: Maybe<Scalars['RoundedInt']>;
  readonly marketingImpressions: Maybe<Scalars['RoundedInt']>;
  readonly publisherId: Maybe<Scalars['String']>;
  readonly publisherName: Maybe<Scalars['String']>;
};

export type DataConsistencyNode = {
  readonly __typename: 'DataConsistencyNode';
  readonly bigquery: Scalars['RoundedInt'];
  readonly bigqueryInvalid: Maybe<Scalars['RoundedInt']>;
  readonly bigqueryValid: Maybe<Scalars['RoundedInt']>;
  readonly bigtable: Scalars['RoundedInt'];
  readonly day: Scalars['String'];
  readonly diff: Scalars['RoundedInt'];
  readonly publisher: Maybe<Scalars['RoundedInt']>;
};

export type DayRankObject = {
  readonly __typename: 'DayRankObject';
  readonly day: Maybe<Scalars['String']>;
  readonly rank: Maybe<Scalars['Int']>;
};

export type DeleteActionMap = {
  readonly __typename: 'DeleteActionMap';
  readonly success: Scalars['Boolean'];
};

export type DeleteActionMapInput = {
  readonly actionMapId: Scalars['ID'];
};

export type DeleteAdvisorSavedSearch = {
  readonly __typename: 'DeleteAdvisorSavedSearch';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DeleteAdvisorSavedSearchInput = {
  readonly id: Scalars['ID'];
};

export type DeleteCampaign = {
  readonly __typename: 'DeleteCampaign';
  readonly success: Scalars['Boolean'];
};

export type DeleteCampaignBroadcast = {
  readonly __typename: 'DeleteCampaignBroadcast';
  readonly success: Scalars['Boolean'];
};

export type DeleteCampaignBroadcastInput = {
  readonly id: Scalars['ID'];
};

export type DeleteCampaignDynamic = {
  readonly __typename: 'DeleteCampaignDynamic';
  readonly success: Scalars['Boolean'];
};

export type DeleteCampaignDynamicDelivery = {
  readonly __typename: 'DeleteCampaignDynamicDelivery';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DeleteCampaignDynamicDeliveryInput = {
  readonly id: Scalars['ID'];
};

export type DeleteCampaignDynamicInput = {
  readonly deleteReason: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
};

export type DeleteCampaignInput = {
  readonly id: Scalars['ID'];
};

export type DeleteCampaignNoise = {
  readonly __typename: 'DeleteCampaignNoise';
  readonly success: Scalars['Boolean'];
};

export type DeleteCampaignNoiseInput = {
  readonly campaignNoiseId: Scalars['ID'];
};

export type DeleteCampaignPodcast = {
  readonly __typename: 'DeleteCampaignPodcast';
  readonly success: Scalars['Boolean'];
};

export type DeleteCampaignPodcastInput = {
  readonly deleteReason: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
};

export type DeleteCampaignStreaming = {
  readonly __typename: 'DeleteCampaignStreaming';
  readonly success: Scalars['Boolean'];
};

export type DeleteCampaignStreamingDelivery = {
  readonly __typename: 'DeleteCampaignStreamingDelivery';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DeleteCampaignStreamingDeliveryInput = {
  readonly id: Scalars['ID'];
};

export type DeleteCampaignStreamingInput = {
  readonly id: Scalars['ID'];
};

export type DeleteComment = {
  readonly __typename: 'DeleteComment';
  readonly success: Scalars['Boolean'];
};

export type DeleteCommentInput = {
  readonly commentId: Scalars['ID'];
};

export type DeleteCompany = {
  readonly __typename: 'DeleteCompany';
  readonly issues: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DeleteCompanyClaim = {
  readonly __typename: 'DeleteCompanyClaim';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DeleteCompanyClaimInput = {
  readonly id: Scalars['ID'];
};

export type DeleteCompanyInput = {
  readonly id: Scalars['ID'];
};

export type DeleteConversionUrl = {
  readonly __typename: 'DeleteConversionURL';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DeleteConversionUrlInput = {
  readonly conversionUrlId: Scalars['ID'];
};

export type DeleteFutureEpisode = {
  readonly __typename: 'DeleteFutureEpisode';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DeleteFutureEpisodeInput = {
  readonly id: Scalars['ID'];
};

export type DeleteGenericTag = {
  readonly __typename: 'DeleteGenericTag';
  readonly success: Scalars['Boolean'];
};

export type DeleteGenericTagInput = {
  readonly id: Scalars['ID'];
};

export type DeleteGenericTagRelationship = {
  readonly __typename: 'DeleteGenericTagRelationship';
  readonly success: Scalars['Boolean'];
};

export type DeleteGenericTagRelationshipInput = {
  readonly id: Scalars['ID'];
};

export type DeleteLiftReport = {
  readonly __typename: 'DeleteLiftReport';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DeleteLiftReportInput = {
  readonly liftReportId: Scalars['ID'];
};

export type DeleteOrganization = {
  readonly __typename: 'DeleteOrganization';
  readonly success: Scalars['Boolean'];
};

export type DeleteOrganizationInput = {
  readonly id: Scalars['ID'];
};

export type DeletePixelEventRecord = {
  readonly __typename: 'DeletePixelEventRecord';
  readonly success: Scalars['Boolean'];
};

export type DeletePixelEventRecordInput = {
  readonly id: Scalars['ID'];
};

export type DeletePodcast = {
  readonly __typename: 'DeletePodcast';
  readonly success: Scalars['Boolean'];
};

export type DeletePodcastInput = {
  readonly id: Scalars['ID'];
};

export type DeletePodcasts = {
  readonly __typename: 'DeletePodcasts';
  readonly success: Scalars['Boolean'];
};

export type DeletePodcastsInput = {
  readonly podcastIds: ReadonlyArray<InputMaybe<Scalars['ID']>>;
};

export type DeletePodlinkDomain = {
  readonly __typename: 'DeletePodlinkDomain';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DeletePodlinkDomainInput = {
  readonly id: Scalars['ID'];
};

export type DeleteProduct = {
  readonly __typename: 'DeleteProduct';
  readonly companyId: Maybe<Scalars['ID']>;
  readonly id: Maybe<Scalars['ID']>;
};

export type DeleteProductInput = {
  readonly id: Scalars['ID'];
};

export type DeleteReasonObject = {
  readonly __typename: 'DeleteReasonObject';
  readonly deleteReason: Maybe<Scalars['String']>;
  readonly deleteReasonDisplay: Maybe<Scalars['String']>;
};

export type DeleteReviewer = {
  readonly __typename: 'DeleteReviewer';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DeleteReviewerInput = {
  readonly id: Scalars['ID'];
};

export type DeleteSavedExport = {
  readonly __typename: 'DeleteSavedExport';
  readonly success: Scalars['Boolean'];
};

export type DeleteSavedExportInput = {
  readonly id: Scalars['ID'];
};

/** Deletes the token in the HTTP header, or if not provided in header, in the input if provided. */
export type DeleteToken = {
  readonly __typename: 'DeleteToken';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DeleteTokenInput = {
  readonly token: InputMaybe<Scalars['String']>;
};

export type DeleteUserAccess = {
  readonly __typename: 'DeleteUserAccess';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DeleteUserAccessInput = {
  readonly userAccessId: Scalars['ID'];
};

export type DesignPodlinkDomain = {
  readonly __typename: 'DesignPodlinkDomain';
  readonly podlinkDomain: Maybe<PodlinkDomainObject>;
};

export type DesignPodlinkDomainInput = {
  readonly backgroundColor: InputMaybe<Scalars['String']>;
  readonly description: InputMaybe<Scalars['String']>;
  readonly faviconId: InputMaybe<Scalars['ID']>;
  readonly fontColor: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly imageId: InputMaybe<Scalars['ID']>;
  readonly primaryColor: InputMaybe<Scalars['String']>;
  readonly secondaryColor: InputMaybe<Scalars['String']>;
  readonly title: InputMaybe<Scalars['String']>;
};

export type DownloadAd = {
  readonly __typename: 'DownloadAd';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DownloadAdInput = {
  readonly id: Scalars['ID'];
  readonly padding: Scalars['Int'];
};

export type DownloadLocation = {
  readonly __typename: 'DownloadLocation';
  readonly city: Maybe<Scalars['String']>;
  readonly country: Maybe<Scalars['String']>;
  readonly latitude: Maybe<Scalars['Float']>;
  readonly longitude: Maybe<Scalars['Float']>;
  readonly region: Maybe<Scalars['String']>;
  readonly total: Maybe<Scalars['RoundedInt']>;
};

export type DownloadLocationsQuery = {
  readonly __typename: 'DownloadLocationsQuery';
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicEpisodeId: Maybe<Scalars['ID']>;
  readonly campaignDynamicFeedId: Maybe<Scalars['ID']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignDynamicIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly cities: Maybe<ReadonlyArray<Maybe<DownloadLocation>>>;
  readonly city: Maybe<Scalars['String']>;
  readonly count: Maybe<Scalars['Int']>;
  readonly countries: Maybe<ReadonlyArray<Maybe<DownloadLocation>>>;
  readonly country: Maybe<Scalars['String']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly nodes: Maybe<ReadonlyArray<Maybe<DownloadLocation>>>;
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly publisherIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly region: Maybe<Scalars['String']>;
  readonly regions: Maybe<ReadonlyArray<Maybe<DownloadLocation>>>;
};


export type DownloadLocationsQueryCitiesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type DownloadLocationsQueryCountriesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type DownloadLocationsQueryNodesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type DownloadLocationsQueryRegionsArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};

export type DownloadMaids = {
  readonly __typename: 'DownloadMaids';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type DownloadMaidsInput = {
  readonly countries: ReadonlyArray<InputMaybe<Scalars['String']>>;
  readonly objectType: Scalars['String'];
  readonly pk: Scalars['ID'];
};

export type DownloadsObject = {
  readonly __typename: 'DownloadsObject';
  readonly after: Maybe<Scalars['DateTime']>;
  readonly algorithm: Maybe<Scalars['String']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicEpisodeId: Maybe<Scalars['ID']>;
  readonly campaignDynamicFeedId: Maybe<Scalars['ID']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignDynamicIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly hourly: Maybe<ReadonlyArray<Maybe<IabHourlyDownload>>>;
  readonly ips: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly kind: Maybe<Scalars['String']>;
  readonly locations: Maybe<DownloadLocationsQuery>;
  readonly organizationId: Maybe<Scalars['ID']>;
};


export type DownloadsObjectHourlyArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  interval: InputMaybe<Scalars['String']>;
  kind: InputMaybe<Scalars['String']>;
};


export type DownloadsObjectLocationsArgs = {
  city: InputMaybe<Scalars['String']>;
  country: InputMaybe<Scalars['String']>;
  region: InputMaybe<Scalars['String']>;
};

export type DuplicateObject = {
  readonly __typename: 'DuplicateObject';
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly density: Maybe<Scalars['Float']>;
  readonly distance: Maybe<Scalars['RoundedInt']>;
  readonly end: Maybe<Scalars['Float']>;
  readonly start: Maybe<Scalars['Float']>;
};

export type DynamicApprovalObject = {
  readonly __typename: 'DynamicApprovalObject';
  readonly campaignDynamic: CampaignDynamicObject;
  readonly comment: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly rejectedReason: Maybe<Scalars['String']>;
  readonly requestedAt: Scalars['DateTime'];
  readonly requestedBy: Maybe<UnAuthedUserObject>;
  readonly requestedByOrganization: Maybe<ApprovalOrganization>;
  readonly requestee: Maybe<UnAuthedUserObject>;
  readonly requesteeOrganization: Maybe<ApprovalOrganization>;
  readonly state: DynamicApprovalState;
  readonly updatedAt: Scalars['DateTime'];
  readonly updatedBy: Maybe<UnAuthedUserObject>;
};

/** An enumeration. */
export enum DynamicApprovalState {
  /** Approved */
  Approved = 'APPROVED',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Requested */
  Requested = 'REQUESTED'
}

export type Embedded = {
  readonly __typename: 'Embedded';
  readonly episodeId: Maybe<Scalars['String']>;
  readonly feedId: Maybe<Scalars['String']>;
};

export type EnclosureObject = {
  readonly __typename: 'EnclosureObject';
  readonly barstoolEpisodeId: Maybe<Scalars['String']>;
  readonly canonical: Maybe<Scalars['String']>;
  readonly contentPath: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly duration: Maybe<Scalars['Float']>;
  readonly episode: Maybe<EpisodeObject>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly fileSize: Maybe<Scalars['Int']>;
  readonly href: Scalars['String'];
  readonly id: Scalars['String'];
  readonly length: Maybe<Scalars['String']>;
  readonly megaphoneId: Maybe<Scalars['String']>;
  readonly mpegPath: Maybe<Scalars['String']>;
  readonly podbeanId: Maybe<Scalars['String']>;
  readonly prefixChartable: Scalars['Boolean'];
  readonly prefixPodsights: Scalars['Boolean'];
  readonly prefixPodtrac: Scalars['Boolean'];
  readonly proxiedEnclosure: Maybe<ProxiedEnclosureObject>;
  readonly proxiedEnclosures: ReadonlyArray<ProxiedEnclosureObject>;
  readonly sampleRate: Maybe<Scalars['Int']>;
  readonly source: Maybe<EpisodeObject>;
  readonly sourcePath: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
  readonly waveform: Maybe<Scalars['JSONString']>;
};


export type EnclosureObjectProxiedEnclosureArgs = {
  proxiedEnclosureId: InputMaybe<Scalars['ID']>;
};

export type EpisodeMinutesByDay = {
  readonly __typename: 'EpisodeMinutesByDay';
  readonly day: Scalars['Date'];
  readonly minutes: Scalars['Float'];
};

export type EpisodeNode = {
  readonly __typename: 'EpisodeNode';
  readonly count: Maybe<Scalars['Int']>;
  readonly hasNext: Maybe<Scalars['Boolean']>;
  readonly hasPrev: Maybe<Scalars['Boolean']>;
  readonly nodes: Maybe<ReadonlyArray<Maybe<EpisodeObject>>>;
  readonly offset: Maybe<Scalars['Int']>;
  readonly pages: Maybe<Scalars['Int']>;
};

export type EpisodeObject = {
  readonly __typename: 'EpisodeObject';
  readonly adMarkers: Maybe<ReadonlyArray<Maybe<AdMarkerObject>>>;
  readonly ads: Maybe<ReadonlyArray<Maybe<AdObject>>>;
  readonly adspottingModelVersion: Maybe<Scalars['String']>;
  readonly asr: Maybe<Asr>;
  readonly campaignEpisodes: ReadonlyArray<CampaignEpisodeObject>;
  readonly content: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly description: Maybe<Scalars['String']>;
  readonly downloads: Maybe<DownloadsObject>;
  readonly duplicates: Maybe<ReadonlyArray<Maybe<DuplicateObject>>>;
  readonly enclosure: Maybe<EnclosureObject>;
  readonly enclosures: ReadonlyArray<EnclosureObject>;
  readonly feed: Maybe<LimitedFeedObject>;
  readonly guid: Scalars['String'];
  readonly guidislink: Scalars['Boolean'];
  readonly hasAdMarkers: Scalars['Boolean'];
  readonly hasAsrLabels: Scalars['Boolean'];
  readonly hasAsrTranscript: Scalars['Boolean'];
  readonly hasDuplicates: Scalars['Boolean'];
  readonly hasKeywords: Maybe<Scalars['Boolean']>;
  readonly hasNoAds: Scalars['Boolean'];
  readonly id: Scalars['String'];
  readonly image: Maybe<ImageObject>;
  readonly isReady: Scalars['Boolean'];
  readonly itunesDuration: Maybe<Scalars['String']>;
  readonly itunesEpisode: Maybe<Scalars['Int']>;
  readonly itunesEpisodetype: Maybe<Scalars['String']>;
  readonly itunesExplicit: Scalars['Boolean'];
  readonly itunesGuid: Maybe<Scalars['String']>;
  readonly itunesSeason: Maybe<Scalars['Int']>;
  readonly itunesSubtitle: Maybe<Scalars['String']>;
  readonly itunesSummary: Maybe<Scalars['String']>;
  readonly itunesTitle: Maybe<Scalars['String']>;
  readonly keywords: Maybe<ReadonlyArray<Maybe<KeywordObject>>>;
  readonly maids: Maybe<MaidsObject>;
  readonly placement: Maybe<PlacementObject>;
  readonly placements: Maybe<ReadonlyArray<Maybe<PlacementObject>>>;
  readonly placementsCount: Maybe<Scalars['Int']>;
  readonly processed: Maybe<Scalars['CoercedBoolean']>;
  readonly published: Maybe<Scalars['DateTime']>;
  readonly reviewed: Maybe<Scalars['Boolean']>;
  readonly reviews: Maybe<ReadonlyArray<Maybe<ReviewObject>>>;
  readonly reviewsCount: Maybe<Scalars['Int']>;
  readonly saveSource: Scalars['Boolean'];
  readonly subtitle: Maybe<Scalars['String']>;
  readonly summary: Maybe<Scalars['String']>;
  readonly tags: Maybe<ReadonlyArray<Maybe<FeedTagObject>>>;
  readonly title: Scalars['String'];
  readonly updated: Maybe<Scalars['DateTime']>;
  readonly updatedAt: Scalars['DateTime'];
};


export type EpisodeObjectAdsArgs = {
  companySlug: InputMaybe<Scalars['String']>;
  reviewerId: InputMaybe<Scalars['ID']>;
};


export type EpisodeObjectDescriptionArgs = {
  chars: InputMaybe<Scalars['Int']>;
  words: InputMaybe<Scalars['Int']>;
};


export type EpisodeObjectDownloadsArgs = {
  after: InputMaybe<Scalars['String']>;
  algorithm: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  kind: InputMaybe<Scalars['String']>;
};


export type EpisodeObjectPlacementArgs = {
  id: InputMaybe<Scalars['ID']>;
};


export type EpisodeObjectPlacementsArgs = {
  active: InputMaybe<Scalars['Boolean']>;
  companyId: InputMaybe<Scalars['ID']>;
  proxiedEnclosureId: InputMaybe<Scalars['ID']>;
  reviewerId: InputMaybe<Scalars['ID']>;
};


export type EpisodeObjectPlacementsCountArgs = {
  active: InputMaybe<Scalars['Boolean']>;
  companyId: InputMaybe<Scalars['ID']>;
};


export type EpisodeObjectReviewsArgs = {
  includeAdReviews: InputMaybe<Scalars['Boolean']>;
  reviewerId: InputMaybe<Scalars['ID']>;
};

export type EpisodePathVarsObject = {
  readonly __typename: 'EpisodePathVarsObject';
  readonly episodeId: Maybe<Scalars['String']>;
  readonly feedId: Maybe<Scalars['String']>;
};

export type ExperianMetric = {
  readonly __typename: 'ExperianMetric';
  readonly index: Maybe<Scalars['Float']>;
  readonly nationalMeans: Maybe<Scalars['Float']>;
  readonly percentage: Maybe<Scalars['Float']>;
  readonly variable: Maybe<Scalars['String']>;
};

export type ExperianSegment = {
  readonly __typename: 'ExperianSegment';
  readonly category: Maybe<Scalars['String']>;
  readonly classification: Maybe<Scalars['String']>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly metrics: Maybe<ReadonlyArray<Maybe<ExperianMetric>>>;
  readonly percentExperianMatching: Maybe<Scalars['Float']>;
  readonly topic: Maybe<Scalars['String']>;
  readonly uniqueExperianMatching: Maybe<Scalars['RoundedInt']>;
  readonly uniqueHhCount: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum ExportInstanceExportType {
  /** Admin */
  Admin = 'ADMIN',
  /** Campaign Conversions */
  CampaignConversions = 'CAMPAIGN_CONVERSIONS',
  /** Campaign Daily Overview */
  CampaignDailyOverview = 'CAMPAIGN_DAILY_OVERVIEW',
  /** Campaign Entrances */
  CampaignEntrances = 'CAMPAIGN_ENTRANCES',
  /** Campaign Episode */
  CampaignEpisode = 'CAMPAIGN_EPISODE',
  /** Campaign Impressions */
  CampaignImpressions = 'CAMPAIGN_IMPRESSIONS',
  /** Campaign Overview */
  CampaignOverview = 'CAMPAIGN_OVERVIEW',
  /** Campaign Placements */
  CampaignPlacements = 'CAMPAIGN_PLACEMENTS',
  /** Campaign Podcast */
  CampaignPodcast = 'CAMPAIGN_PODCAST',
  /** Company Placements */
  CompanyPlacements = 'COMPANY_PLACEMENTS',
  /** Episode Downloads Daily */
  EpisodeDownloadsDaily = 'EPISODE_DOWNLOADS_DAILY',
  /** Episode Downloads Hourly */
  EpisodeDownloadsHourly = 'EPISODE_DOWNLOADS_HOURLY',
  /** Episode Placements */
  EpisodePlacements = 'EPISODE_PLACEMENTS',
  /** Feed Placements */
  FeedPlacements = 'FEED_PLACEMENTS',
  /** Feed Segments */
  FeedSegments = 'FEED_SEGMENTS',
  /** Organization Benchmark Campaigns */
  OrganizationBenchmarkCampaigns = 'ORGANIZATION_BENCHMARK_CAMPAIGNS',
  /** Organization Benchmark Campaigns Detail */
  OrganizationBenchmarkCampaignsDetail = 'ORGANIZATION_BENCHMARK_CAMPAIGNS_DETAIL',
  /** Organization Daily Overview */
  OrganizationCampaignConversions = 'ORGANIZATION_CAMPAIGN_CONVERSIONS',
  /** Organization Daily Overview */
  OrganizationDailyOverview = 'ORGANIZATION_DAILY_OVERVIEW',
  /** Organization Interval Overlap */
  OrganizationIntervalOverlap = 'ORGANIZATION_INTERVAL_OVERLAP',
  /** Organization IDs */
  OrganizationListAllIds = 'ORGANIZATION_LIST_ALL_IDS',
  /** Organization Campaign IDs */
  OrganizationListCampaignIds = 'ORGANIZATION_LIST_CAMPAIGN_IDS',
  /** Organization Locations Overview */
  OrganizationLocations = 'ORGANIZATION_LOCATIONS',
  /** Organization Placements */
  OrganizationPlacements = 'ORGANIZATION_PLACEMENTS',
  /** Organization Segments */
  OrganizationSegments = 'ORGANIZATION_SEGMENTS',
  /** Organization Weekly Overview */
  OrganizationWeeklyOverview = 'ORGANIZATION_WEEKLY_OVERVIEW',
  /** Podcast Downloads Daily */
  PodcastDownloadsDaily = 'PODCAST_DOWNLOADS_DAILY',
  /** Podcast Downloads Full */
  PodcastDownloadsFull = 'PODCAST_DOWNLOADS_FULL',
  /** Podcast Downloads Hourly */
  PodcastDownloadsHourly = 'PODCAST_DOWNLOADS_HOURLY'
}

export type ExportInstanceObject = {
  readonly __typename: 'ExportInstanceObject';
  readonly archived: Scalars['Boolean'];
  readonly bucketObjectName: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: Maybe<LimitedUserObject>;
  readonly downloadUrl: Maybe<Scalars['String']>;
  readonly exportJobStatus: Maybe<ExportJobStatusObject>;
  readonly exportParameters: Maybe<Scalars['JSONString']>;
  readonly exportType: ExportInstanceExportType;
  readonly fields: Maybe<Scalars['JSONString']>;
  readonly id: Scalars['String'];
  readonly lastTouch: Scalars['Boolean'];
  readonly orderBy: Maybe<Scalars['JSONString']>;
  readonly organization: Maybe<LimitedOrganizationObject>;
  readonly rowCount: Maybe<Scalars['Int']>;
  readonly savedExport: Maybe<SavedExportObject>;
  readonly status: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['DateTime'];
};

export type ExportInstanceParameters = {
  readonly actions: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly attr: InputMaybe<Scalars['String']>;
  readonly campaignId: InputMaybe<Scalars['ID']>;
  readonly campaignIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly endDate: InputMaybe<Scalars['String']>;
  readonly feedIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly instanceId: Scalars['ID'];
  readonly interval: InputMaybe<Scalars['String']>;
  readonly modelled: InputMaybe<Scalars['Boolean']>;
  readonly publisherIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly reportPeriod: InputMaybe<Scalars['Int']>;
  readonly spendByImpressions: InputMaybe<Scalars['Boolean']>;
  readonly startDate: InputMaybe<Scalars['String']>;
  readonly trailing: InputMaybe<Scalars['Int']>;
};

export type ExportJobStatusObject = {
  readonly __typename: 'ExportJobStatusObject';
  readonly createdAt: Scalars['DateTime'];
  readonly export: ExportInstanceObject;
  readonly failedReason: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly retryCount: Scalars['Int'];
  readonly status: ExportJobStatusStatus;
  readonly updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum ExportJobStatusStatus {
  /** Job Completed */
  Completed = 'COMPLETED',
  /** Job Failed */
  Failed = 'FAILED',
  /** Job Received */
  Received = 'RECEIVED',
  /** Job Started */
  Started = 'STARTED'
}

export type ExportObject = {
  readonly __typename: 'ExportObject';
  readonly exportInstance: Maybe<ExportInstanceObject>;
  readonly exportInstances: Maybe<ReadonlyArray<Maybe<ExportInstanceObject>>>;
  readonly exportTypes: Maybe<ExportTypes>;
  readonly id: Maybe<Scalars['ID']>;
  readonly organizationId: Scalars['ID'];
  readonly savedExport: Maybe<SavedExportObject>;
  readonly savedExports: Maybe<ReadonlyArray<Maybe<SavedExportObject>>>;
};


export type ExportObjectExportInstanceArgs = {
  id: Scalars['ID'];
};


export type ExportObjectSavedExportArgs = {
  id: Scalars['ID'];
};

export type ExportSupportedParameter = {
  readonly __typename: 'ExportSupportedParameter';
  /** Export Supported Parameters ID */
  readonly id: Scalars['ID'];
  /** Export Parameter Name */
  readonly name: Maybe<Scalars['String']>;
  /** Export Parameter Type */
  readonly type: Maybe<Scalars['String']>;
};

export type ExportType = {
  readonly __typename: 'ExportType';
  readonly exportKind: Maybe<Scalars['String']>;
  readonly exportType: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly name: Scalars['String'];
  readonly supportedParameters: Maybe<ReadonlyArray<Maybe<ExportSupportedParameter>>>;
};

export type ExportTypeColumn = {
  readonly __typename: 'ExportTypeColumn';
  /** Export column example */
  readonly example: Maybe<Scalars['String']>;
  /** Field ID */
  readonly id: Scalars['ID'];
  /** Export column field name */
  readonly name: Maybe<Scalars['String']>;
};

export type ExportTypes = {
  readonly __typename: 'ExportTypes';
  readonly columns: Maybe<ReadonlyArray<Maybe<ExportTypeColumn>>>;
  /** Organization id */
  readonly id: Scalars['ID'];
  readonly organizationId: Scalars['ID'];
  readonly types: Maybe<ReadonlyArray<Maybe<ExportType>>>;
};


export type ExportTypesColumnsArgs = {
  typeId: Scalars['ID'];
};

export type FeedInterface = {
  readonly description: Maybe<Scalars['String']>;
  readonly isArt19: Maybe<Scalars['Boolean']>;
  readonly isMegaphone: Maybe<Scalars['Boolean']>;
};


export type FeedInterfaceDescriptionArgs = {
  chars: InputMaybe<Scalars['Int']>;
  words: InputMaybe<Scalars['Int']>;
};

export type FeedObject = FeedInterface & {
  readonly __typename: 'FeedObject';
  readonly ads: Maybe<ReadonlyArray<Maybe<AdObject>>>;
  readonly adsCount: Maybe<Scalars['RoundedInt']>;
  readonly appleUrl: Maybe<Scalars['String']>;
  readonly author: Maybe<Scalars['String']>;
  readonly avgRank: Maybe<Scalars['Int']>;
  readonly campaignTargets: Maybe<ReadonlyArray<Maybe<CampaignTargetObject>>>;
  readonly castboxUrl: Maybe<Scalars['String']>;
  readonly companies: Maybe<ReadonlyArray<Maybe<CompanyObject>>>;
  readonly contactEmail: Maybe<Scalars['String']>;
  readonly content: Maybe<Scalars['String']>;
  readonly contentMd5: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly dayRankings: Maybe<ReadonlyArray<Maybe<DayRankObject>>>;
  readonly description: Maybe<Scalars['String']>;
  readonly duplicatesEpisodesCount: Maybe<Scalars['Int']>;
  readonly episode: Maybe<EpisodeObject>;
  readonly episodeNodes: Maybe<EpisodeNode>;
  readonly episodes: Maybe<ReadonlyArray<Maybe<EpisodeObject>>>;
  readonly episodesCount: Maybe<Scalars['Int']>;
  readonly experianSegments: Maybe<ReadonlyArray<Maybe<ExperianSegment>>>;
  readonly experianTopics: Maybe<ReadonlyArray<Maybe<Topic>>>;
  readonly generator: Maybe<Scalars['String']>;
  readonly googlePodcastsUrl: Maybe<Scalars['String']>;
  readonly hasNoAds: Scalars['Boolean'];
  readonly href: Scalars['String'];
  readonly id: Scalars['String'];
  readonly image: Maybe<ImageObject>;
  readonly isArt19: Maybe<Scalars['Boolean']>;
  readonly isExperianApproved: Scalars['Boolean'];
  readonly isIgnoredCcpa: Scalars['Boolean'];
  readonly isIgnoredGdpr: Scalars['Boolean'];
  readonly isMegaphone: Maybe<Scalars['Boolean']>;
  readonly isNielsenApproved: Scalars['Boolean'];
  readonly itunesAuthor: Maybe<Scalars['String']>;
  readonly itunesExplicit: Scalars['Boolean'];
  readonly itunesId: Maybe<Scalars['String']>;
  readonly itunesNewFeedUrl: Maybe<Scalars['String']>;
  readonly itunesSubtitle: Maybe<Scalars['String']>;
  readonly itunesSummary: Maybe<Scalars['String']>;
  readonly itunesType: Maybe<Scalars['String']>;
  readonly language: Maybe<Scalars['String']>;
  readonly lastPublished: Maybe<Scalars['DateTime']>;
  readonly link: Maybe<Scalars['String']>;
  readonly measure: Scalars['Boolean'];
  readonly mosaicTypes: Maybe<ReadonlyArray<Maybe<MosaicTypes>>>;
  readonly needsPlacementsCount: Maybe<Scalars['Int']>;
  readonly nielsenSegments: Maybe<ReadonlyArray<Maybe<NielsenSegment>>>;
  readonly nielsenTopics: Maybe<ReadonlyArray<Maybe<Topic>>>;
  readonly overcastUrl: Maybe<Scalars['String']>;
  readonly placementInfo: Maybe<FeedPlacementInfoObject>;
  readonly placementsCount: Maybe<Scalars['Int']>;
  readonly podcast: Maybe<PodcastObject>;
  readonly processedEpisodesCount: Maybe<Scalars['Int']>;
  readonly processing: Scalars['Boolean'];
  readonly published: Maybe<Scalars['DateTime']>;
  readonly publisherEmail: Maybe<Scalars['String']>;
  readonly publisherName: Maybe<Scalars['String']>;
  readonly rankings: ReadonlyArray<RankObject>;
  readonly rights: Maybe<Scalars['String']>;
  readonly saveNewEpisodeSources: Scalars['Boolean'];
  readonly segmentOverlap: Maybe<Scalars['Float']>;
  readonly spotifyId: Maybe<Scalars['String']>;
  readonly spotifyUrl: Maybe<Scalars['String']>;
  readonly state: FeedState;
  readonly subtitle: Maybe<Scalars['String']>;
  readonly summary: Maybe<Scalars['String']>;
  readonly tags: Maybe<ReadonlyArray<Maybe<FeedTagObject>>>;
  readonly title: Scalars['String'];
  readonly trailer: Maybe<EpisodeObject>;
  readonly ttl: Maybe<Scalars['Int']>;
  readonly updated: Maybe<Scalars['DateTime']>;
  readonly updatedAt: Scalars['DateTime'];
};


export type FeedObjectAdsArgs = {
  after: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
  state: InputMaybe<Scalars['String']>;
};


export type FeedObjectCompaniesArgs = {
  after: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
};


export type FeedObjectDayRankingsArgs = {
  after: InputMaybe<Scalars['String']>;
  category: Scalars['String'];
  provider: Scalars['String'];
};


export type FeedObjectDescriptionArgs = {
  chars: InputMaybe<Scalars['Int']>;
  words: InputMaybe<Scalars['Int']>;
};


export type FeedObjectEpisodeArgs = {
  id: InputMaybe<Scalars['ID']>;
};


export type FeedObjectEpisodeNodesArgs = {
  after: InputMaybe<Scalars['String']>;
  companyId: InputMaybe<Scalars['ID']>;
  companySlug: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
};


export type FeedObjectEpisodesArgs = {
  after: InputMaybe<Scalars['String']>;
  companyId: InputMaybe<Scalars['ID']>;
  companySlug: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


export type FeedObjectEpisodesCountArgs = {
  after: InputMaybe<Scalars['String']>;
  companyId: InputMaybe<Scalars['ID']>;
  companySlug: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
};


export type FeedObjectExperianSegmentsArgs = {
  classifications: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type FeedObjectNielsenSegmentsArgs = {
  classifications: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
};


export type FeedObjectPlacementsCountArgs = {
  after: InputMaybe<Scalars['String']>;
};

export type FeedOverviewSearchResults = {
  readonly __typename: 'FeedOverviewSearchResults';
  readonly results: Maybe<ReadonlyArray<Maybe<FeedObject>>>;
  readonly total: Maybe<Scalars['ID']>;
};

export type FeedPlacementInfoObject = {
  readonly __typename: 'FeedPlacementInfoObject';
  readonly avgPlacements: Maybe<Scalars['RoundedInt']>;
  readonly maxPlacements: Maybe<Scalars['RoundedInt']>;
  readonly positions: Maybe<ReadonlyArray<Maybe<FeedPlacementPositionObject>>>;
};

export type FeedPlacementPositionObject = {
  readonly __typename: 'FeedPlacementPositionObject';
  readonly avgDuration: Maybe<Scalars['Float']>;
  readonly avgStartTime: Maybe<Scalars['Float']>;
  readonly position: Maybe<Scalars['RoundedInt']>;
};

export type FeedSearch = {
  readonly __typename: 'FeedSearch';
  readonly count: Maybe<Scalars['Int']>;
  readonly limit: Maybe<Scalars['Int']>;
  readonly offset: Maybe<Scalars['Int']>;
  readonly results: Maybe<ReadonlyArray<Maybe<FeedSearchObject>>>;
};

export type FeedSearchObject = {
  readonly __typename: 'FeedSearchObject';
  readonly id: Scalars['String'];
  readonly podcast: Maybe<FeedSearchPodcastObject>;
  readonly title: Scalars['String'];
};

export type FeedSearchOrganizationObject = {
  readonly __typename: 'FeedSearchOrganizationObject';
  readonly id: Maybe<Scalars['ID']>;
};

export type FeedSearchPodcastObject = {
  readonly __typename: 'FeedSearchPodcastObject';
  readonly id: Maybe<Scalars['ID']>;
  readonly organization: Maybe<FeedSearchOrganizationObject>;
};

/** An enumeration. */
export enum FeedState {
  /** active */
  Active = 'ACTIVE',
  /** Archived */
  Archived = 'ARCHIVED'
}

export type FeedTagObject = {
  readonly __typename: 'FeedTagObject';
  readonly episodeSet: ReadonlyArray<EpisodeObject>;
  readonly id: Scalars['String'];
  readonly label: Maybe<Scalars['String']>;
  readonly scheme: Maybe<Scalars['String']>;
  readonly term: Maybe<Scalars['String']>;
};

export type FieldsInputObject = {
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type FillCampaignDynamics = {
  readonly __typename: 'FillCampaignDynamics';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type FillCampaignDynamicsInput = {
  readonly id: Scalars['ID'];
};

export type FixRedisForFeedId = {
  readonly __typename: 'FixRedisForFeedId';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type FixRedisForFeedIdInput = {
  readonly feedId: Scalars['ID'];
};

export type FutureEpisodeNodes = {
  readonly __typename: 'FutureEpisodeNodes';
  readonly count: Maybe<Scalars['Int']>;
  readonly hasNext: Maybe<Scalars['Boolean']>;
  readonly hasPrev: Maybe<Scalars['Boolean']>;
  readonly nodes: Maybe<ReadonlyArray<Maybe<FutureEpisodeObject>>>;
  readonly offset: Maybe<Scalars['Int']>;
  readonly pages: Maybe<Scalars['Int']>;
};

export type FutureEpisodeObject = {
  readonly __typename: 'FutureEpisodeObject';
  readonly campaignEpisodes: Maybe<ReadonlyArray<Maybe<CampaignEpisodeObject>>>;
  readonly closeEpisodes: Maybe<ReadonlyArray<Maybe<EpisodeObject>>>;
  readonly closeInCampaignEpisodes: Maybe<ReadonlyArray<Maybe<EpisodeObject>>>;
  readonly createdAt: Scalars['DateTime'];
  readonly expectedPublished: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly podcast: Maybe<PodcastIdAndFeedObject>;
  readonly subtitle: Maybe<Scalars['String']>;
  readonly title: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
};


export type FutureEpisodeObjectCloseEpisodesArgs = {
  excludeCampaignId: InputMaybe<Scalars['ID']>;
};


export type FutureEpisodeObjectCloseInCampaignEpisodesArgs = {
  campaignId: Scalars['ID'];
};

export type GenericTagObject = {
  readonly __typename: 'GenericTagObject';
  readonly color: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: Maybe<UserObject>;
  readonly genericTagRelationships: ReadonlyArray<GenericTagRelationshipObject>;
  readonly id: Scalars['String'];
  readonly organization: Maybe<LimitedOrganizationObject>;
  readonly slug: Scalars['String'];
  readonly title: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
};

export type GenericTagRelationshipObject = {
  readonly __typename: 'GenericTagRelationshipObject';
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: Maybe<UserObject>;
  readonly genericTag: GenericTagObject;
  readonly id: Scalars['String'];
  readonly objectName: Maybe<Scalars['String']>;
  readonly objectPk: Scalars['String'];
  readonly tag: Maybe<GenericTagObject>;
  readonly updatedAt: Scalars['DateTime'];
};

export type HideLineItem = {
  readonly __typename: 'HideLineItem';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type HideLineItemInput = {
  readonly lineItemId: Scalars['ID'];
};

export type HideUnmappedSpotifyOrders = {
  readonly __typename: 'HideUnmappedSpotifyOrders';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type HideUnmappedSpotifyOrdersInput = {
  readonly spotifyOrderIds: ReadonlyArray<Scalars['ID']>;
};

export type HourlyNode = {
  readonly __typename: 'HourlyNode';
  readonly hour: Maybe<Scalars['DateTime']>;
  readonly total: Maybe<Scalars['RoundedInt']>;
};

export type IabHourlyDownload = {
  readonly __typename: 'IABHourlyDownload';
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly downloadClass: Maybe<Scalars['String']>;
  readonly hour: Maybe<Scalars['DateTime']>;
};

export type IgnoredContact = {
  readonly __typename: 'IgnoredContact';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type IgnoredContactInput = {
  readonly contactId: Scalars['ID'];
};

export type ImageObject = {
  readonly __typename: 'ImageObject';
  readonly episodeSet: ReadonlyArray<EpisodeObject>;
  readonly height: Maybe<Scalars['Int']>;
  readonly href: Scalars['String'];
  readonly id: Scalars['String'];
  readonly link: Maybe<Scalars['String']>;
  readonly path: Maybe<Scalars['String']>;
  readonly src: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
  readonly width: Maybe<Scalars['Int']>;
};

export type ImportPodcastIssue = {
  readonly __typename: 'ImportPodcastIssue';
  readonly href: Scalars['String'];
  readonly message: Scalars['String'];
};

export type ImportPodcasts = {
  readonly __typename: 'ImportPodcasts';
  readonly added: ReadonlyArray<Maybe<PodcastObject>>;
  readonly issues: Maybe<ReadonlyArray<Maybe<ImportPodcastIssue>>>;
  readonly podcasts: ReadonlyArray<Maybe<PodcastObject>>;
  readonly remove: ReadonlyArray<Maybe<PodcastObject>>;
};

export type ImportPodcastsInput = {
  readonly hrefs: ReadonlyArray<InputMaybe<Scalars['String']>>;
  readonly organizationId: Scalars['ID'];
};

export type ImpressionsFrequencyNode = {
  readonly __typename: 'ImpressionsFrequencyNode';
  readonly frequency: Maybe<Scalars['RoundedInt']>;
  readonly total: Maybe<Scalars['RoundedInt']>;
};

export type ImpressionsFrequencyObject = ImpressionsInterface & {
  readonly __typename: 'ImpressionsFrequencyObject';
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly max: Maybe<Scalars['RoundedInt']>;
  readonly maxFrequency: Maybe<Scalars['RoundedInt']>;
  readonly nodes: Maybe<ReadonlyArray<Maybe<ImpressionsFrequencyNode>>>;
  readonly organizationId: Scalars['ID'];
  /** Number of households that revcieved over the number of max frequency. */
  readonly over: Maybe<ImpressionsFrequencyOver>;
  readonly publisherIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
};

export type ImpressionsFrequencyOver = {
  readonly __typename: 'ImpressionsFrequencyOver';
  readonly impressions: Maybe<Scalars['RoundedInt']>;
  readonly reach: Maybe<Scalars['RoundedInt']>;
};

export type ImpressionsInterface = {
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly organizationId: Scalars['ID'];
  readonly publisherIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
};

export type ImpressionsObject = ImpressionsInterface & {
  readonly __typename: 'ImpressionsObject';
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly frequency: Maybe<ImpressionsFrequencyObject>;
  readonly households: Maybe<Scalars['RoundedInt']>;
  readonly impressions: Maybe<Scalars['RoundedInt']>;
  readonly intervalReachOverlap: Maybe<ReadonlyArray<Maybe<IntervalReachOverlap>>>;
  readonly locations: Maybe<DownloadLocationsQuery>;
  readonly organizationId: Scalars['ID'];
  readonly overlap: Maybe<ImpressionsOverlapObject>;
  readonly players: Maybe<ReadonlyArray<Maybe<ImpressionsPlayer>>>;
  readonly publisherIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly publishers: Maybe<ReadonlyArray<Maybe<ImpressionsPublisherObject>>>;
  readonly reach: Maybe<Scalars['RoundedInt']>;
};


export type ImpressionsObjectFrequencyArgs = {
  maxFrequency: InputMaybe<Scalars['Int']>;
};


export type ImpressionsObjectIntervalReachOverlapArgs = {
  attr: InputMaybe<Scalars['String']>;
  interval: InputMaybe<Scalars['String']>;
  trailing: InputMaybe<Scalars['Int']>;
};


export type ImpressionsObjectLocationsArgs = {
  city: InputMaybe<Scalars['String']>;
  country: InputMaybe<Scalars['String']>;
  region: InputMaybe<Scalars['String']>;
};

export type ImpressionsOverlapObject = ImpressionsInterface & {
  readonly __typename: 'ImpressionsOverlapObject';
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly campaigns: Maybe<ReadonlyArray<Maybe<CampaignOverlapObject>>>;
  readonly organizationId: Scalars['ID'];
  readonly publisherIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly publishers: Maybe<ReadonlyArray<Maybe<PublisherOverlapObject>>>;
};

export type ImpressionsPlayer = {
  readonly __typename: 'ImpressionsPlayer';
  readonly frequency: Maybe<Scalars['Float']>;
  readonly impressionsBetween5And15: Maybe<Scalars['RoundedInt']>;
  readonly impressionsGreaterThan15: Maybe<Scalars['RoundedInt']>;
  readonly impressionsLessThan5: Maybe<Scalars['RoundedInt']>;
  readonly percentageImpressionsBetween5And15: Maybe<Scalars['Float']>;
  readonly percentageImpressionsGreaterThan15: Maybe<Scalars['Float']>;
  readonly percentageImpressionsLessThan5: Maybe<Scalars['Float']>;
  readonly percentageReachBetween5And15: Maybe<Scalars['Float']>;
  readonly percentageReachGreaterThan15: Maybe<Scalars['Float']>;
  readonly percentageReachLessThan5: Maybe<Scalars['Float']>;
  readonly player: Maybe<Scalars['String']>;
  readonly reach: Maybe<Scalars['RoundedInt']>;
  readonly reachBetween5And15: Maybe<Scalars['RoundedInt']>;
  readonly reachGreaterThan15: Maybe<Scalars['RoundedInt']>;
  readonly reachLessThan5: Maybe<Scalars['RoundedInt']>;
  readonly total: Maybe<Scalars['RoundedInt']>;
};

export type ImpressionsPublisherObject = {
  readonly __typename: 'ImpressionsPublisherObject';
  readonly campaigns: Maybe<ReadonlyArray<Maybe<CampaignObject>>>;
  readonly id: Maybe<Scalars['ID']>;
  readonly name: Maybe<Scalars['String']>;
};

export type IndustryObject = {
  readonly __typename: 'IndustryObject';
  readonly industry: Maybe<Scalars['String']>;
  readonly industryDisplay: Maybe<Scalars['String']>;
};

export type IntervalReachOverlap = {
  readonly __typename: 'IntervalReachOverlap';
  readonly combinedReach: Maybe<Scalars['RoundedInt']>;
  readonly existingReach: Maybe<Scalars['RoundedInt']>;
  readonly impressions: Maybe<Scalars['RoundedInt']>;
  readonly impressionsToNewReach: Maybe<Scalars['RoundedInt']>;
  readonly impressionsToPriorReach: Maybe<Scalars['RoundedInt']>;
  readonly interval: Maybe<Scalars['DateTime']>;
  readonly newReach: Maybe<Scalars['RoundedInt']>;
  readonly percentNew: Maybe<Scalars['Float']>;
  readonly priorImpressions: Maybe<Scalars['RoundedInt']>;
  readonly priorReach: Maybe<Scalars['RoundedInt']>;
  readonly reach: Maybe<Scalars['RoundedInt']>;
};

export type InvalidImpressionsNode = {
  readonly __typename: 'InvalidImpressionsNode';
  readonly count: Scalars['RoundedInt'];
  readonly exampleRecord: Scalars['String'];
  readonly reason: Scalars['String'];
};

export type InviteesInput = {
  readonly email: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
};

export type InvoiceObject = {
  readonly __typename: 'InvoiceObject';
  readonly created: Scalars['DateTime'];
  readonly createdAt: Scalars['DateTime'];
  readonly due: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly lineItems: ReadonlyArray<LineItemObject>;
  readonly number: Scalars['Int'];
  readonly organization: OrganizationObject;
  readonly paid: Maybe<Scalars['DateTime']>;
  readonly periodEnd: Scalars['DateTime'];
  readonly periodStart: Scalars['DateTime'];
  readonly sent: Maybe<Scalars['DateTime']>;
  readonly stripeId: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['DateTime'];
};

export type IsProcessingPodcast = {
  readonly __typename: 'IsProcessingPodcast';
  readonly podcast: LimitedPodcastObject;
  readonly processing: Scalars['Boolean'];
};

export type IsProcessingPodcastInput = {
  readonly organizationId: Scalars['ID'];
  readonly podcastId: Scalars['ID'];
};

export type IsProcessingPodcasts = {
  readonly __typename: 'IsProcessingPodcasts';
  readonly podcasts: ReadonlyArray<Maybe<PodcastObject>>;
};

export type IsProcessingPodcastsInput = {
  readonly organizationId: Scalars['ID'];
  readonly podcastIds: ReadonlyArray<InputMaybe<Scalars['ID']>>;
};

export type Keepalive = {
  readonly __typename: 'Keepalive';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type KeepaliveInput = {
  readonly channel: Scalars['String'];
};

export type KeyObject = {
  readonly __typename: 'KeyObject';
  readonly actionMaps: ReadonlyArray<ActionMapObject>;
  readonly active: Scalars['Boolean'];
  readonly alias: Scalars['String'];
  readonly conversionUrl: Maybe<ConversionUrlObject>;
  readonly conversionUrls: ReadonlyArray<ConversionUrlObject>;
  readonly createdAt: Scalars['DateTime'];
  readonly debug: Maybe<PixelDebug>;
  readonly domain: Scalars['String'];
  readonly eventTypeChoices: Maybe<ReadonlyArray<Maybe<ChoiceObject>>>;
  readonly installationChoices: Maybe<ReadonlyArray<Maybe<ChoiceObject>>>;
  readonly installations: Scalars['String'];
  readonly key: Scalars['String'];
  readonly pixelEventRecord: Maybe<PixelEventRecordObject>;
  readonly pixelEventRecords: Maybe<ReadonlyArray<Maybe<PixelEventRecordObject>>>;
  readonly role: KeyRole;
  readonly scriptPath: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
};


export type KeyObjectConversionUrlArgs = {
  id: Scalars['ID'];
};


export type KeyObjectPixelEventRecordArgs = {
  id: Scalars['ID'];
};

/** An enumeration. */
export enum KeyRole {
  /** Development */
  Development = 'DEVELOPMENT',
  /** Production */
  Production = 'PRODUCTION',
  /** Staging */
  Staging = 'STAGING'
}

export type KeywordObject = {
  readonly __typename: 'KeywordObject';
  readonly confidence: Maybe<Scalars['Float']>;
  readonly id: Maybe<Scalars['Int']>;
  readonly keyword: Maybe<Scalars['String']>;
  readonly timestamp: Maybe<Scalars['Float']>;
  readonly version: Maybe<Scalars['Int']>;
};

export type Lift = {
  readonly __typename: 'Lift';
  readonly after: Maybe<Scalars['RoundedInt']>;
  readonly averages: Maybe<ReadonlyArray<Maybe<LiftReportAveragesObject>>>;
  readonly before: Maybe<Scalars['RoundedInt']>;
  readonly campaignId: Maybe<Scalars['String']>;
  readonly campaignIds: ReadonlyArray<Maybe<Scalars['String']>>;
  readonly liftReportId: Scalars['String'];
  readonly nodes: Maybe<ReadonlyArray<Maybe<LiftReportWeekObject>>>;
};

export type LiftReportAveragesObject = {
  readonly __typename: 'LiftReportAveragesObject';
  readonly avgInitPercentage: Maybe<Scalars['Float']>;
  readonly avgInitValue: Maybe<Scalars['Float']>;
  readonly avgInstalledPercentage: Maybe<Scalars['Float']>;
  readonly avgInstalledValue: Maybe<Scalars['Float']>;
  readonly avgLeadPercentage: Maybe<Scalars['Float']>;
  readonly avgLeadValue: Maybe<Scalars['Float']>;
  readonly avgPurchasePercentage: Maybe<Scalars['Float']>;
  readonly avgPurchaseValue: Maybe<Scalars['Float']>;
  readonly campaignDynamic: Maybe<CampaignDynamicObject>;
  readonly campaignPodcast: Maybe<CampaignPodcastObject>;
  readonly campaignStreaming: Maybe<CampaignStreamingObject>;
  readonly groupCost: Maybe<Scalars['Float']>;
  readonly groupHouseholds: Maybe<Scalars['RoundedInt']>;
  readonly groupId: Maybe<Scalars['String']>;
  readonly groupName: Maybe<Scalars['String']>;
  readonly groupReach: Maybe<Scalars['RoundedInt']>;
  readonly groupType: Maybe<Scalars['String']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly multiplier: Maybe<Scalars['Float']>;
};

export type LiftReportObject = {
  readonly __typename: 'LiftReportObject';
  readonly campaign: Maybe<CampaignObject>;
  readonly campaigns: ReadonlyArray<CampaignObject>;
  readonly clampUrl: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly delta: Scalars['Int'];
  readonly id: Scalars['String'];
  readonly impressionsEndAt: Maybe<Scalars['Date']>;
  readonly impressionsStartAt: Maybe<Scalars['Date']>;
  readonly lift: Maybe<Lift>;
  readonly name: Maybe<Scalars['String']>;
  readonly organization: Maybe<LimitedOrganizationObject>;
  readonly requestedBy: Maybe<LimitedUserObject>;
  readonly requesterOrganization: Maybe<LimitedOrganizationObject>;
  readonly runDate: Maybe<Scalars['Date']>;
  readonly state: LiftReportState;
  readonly updatedAt: Scalars['DateTime'];
  readonly useNoise: Scalars['Boolean'];
};


export type LiftReportObjectLiftArgs = {
  after: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum LiftReportState {
  /** Draft */
  Draft = 'DRAFT',
  /** Error */
  Error = 'ERROR',
  /** Live */
  Live = 'LIVE',
  /** Requested */
  Requested = 'REQUESTED',
  /** Running */
  Running = 'RUNNING'
}

export type LiftReportWeekObject = {
  readonly __typename: 'LiftReportWeekObject';
  readonly campaignId: Maybe<Scalars['String']>;
  readonly groupCost: Maybe<Scalars['Float']>;
  readonly groupHouseholds: Maybe<Scalars['RoundedInt']>;
  readonly groupId: Maybe<Scalars['String']>;
  readonly groupName: Maybe<Scalars['String']>;
  readonly groupReach: Maybe<Scalars['RoundedInt']>;
  readonly groupType: Maybe<Scalars['String']>;
  readonly initModelled: Maybe<Scalars['Float']>;
  readonly initPercentage: Maybe<Scalars['Float']>;
  readonly initValue: Maybe<Scalars['Float']>;
  readonly installedModelled: Maybe<Scalars['Float']>;
  readonly installedPercentage: Maybe<Scalars['Float']>;
  readonly installedValue: Maybe<Scalars['Float']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly leadModelled: Maybe<Scalars['Float']>;
  readonly leadPercentage: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly liftReportId: Maybe<Scalars['String']>;
  readonly purchaseModelled: Maybe<Scalars['Float']>;
  readonly purchasePercentage: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly runDate: Maybe<Scalars['Date']>;
  readonly week: Maybe<Scalars['RoundedInt']>;
};

export type LimitedAdObject = {
  readonly __typename: 'LimitedAdObject';
  readonly createdAt: Maybe<Scalars['String']>;
  readonly duration: Maybe<Scalars['Float']>;
  readonly id: Maybe<Scalars['ID']>;
  readonly mpegPath: Maybe<Scalars['String']>;
  readonly waveform: Maybe<Scalars['String']>;
};

export type LimitedCompanyClaimObject = {
  readonly __typename: 'LimitedCompanyClaimObject';
  readonly company: Maybe<LimitedCompanyObject>;
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly id: Maybe<Scalars['ID']>;
  readonly state: Maybe<Scalars['String']>;
};

export type LimitedCompanyObject = {
  readonly __typename: 'LimitedCompanyObject';
  readonly ads: Maybe<ReadonlyArray<Maybe<LimitedAdObject>>>;
  readonly id: Maybe<Scalars['ID']>;
  readonly name: Maybe<Scalars['String']>;
  readonly organization: Maybe<LimitedOrganizationObject>;
};


export type LimitedCompanyObjectAdsArgs = {
  after: InputMaybe<Scalars['String']>;
  feedId: InputMaybe<Scalars['ID']>;
  industry: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
  q: InputMaybe<Scalars['String']>;
  state: InputMaybe<Scalars['String']>;
};

export type LimitedFeedObject = FeedInterface & {
  readonly __typename: 'LimitedFeedObject';
  readonly description: Maybe<Scalars['String']>;
  readonly href: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['ID']>;
  readonly image: Maybe<ImageObject>;
  readonly isArt19: Maybe<Scalars['Boolean']>;
  readonly isMegaphone: Maybe<Scalars['Boolean']>;
  readonly subtitle: Maybe<Scalars['String']>;
  readonly summary: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
};


export type LimitedFeedObjectDescriptionArgs = {
  chars: InputMaybe<Scalars['Int']>;
  words: InputMaybe<Scalars['Int']>;
};

export type LimitedOrganizationObject = {
  readonly __typename: 'LimitedOrganizationObject';
  readonly id: Maybe<Scalars['ID']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly managers: Maybe<ReadonlyArray<Maybe<LimitedOrganizationObject>>>;
  readonly members: Maybe<ReadonlyArray<Maybe<UnAuthedUserObject>>>;
  readonly name: Maybe<Scalars['String']>;
  readonly slug: Maybe<Scalars['String']>;
};

export type LimitedPodcastObject = {
  readonly __typename: 'LimitedPodcastObject';
  readonly createdAt: Maybe<Scalars['DateTime']>;
  readonly feed: Maybe<FeedObject>;
  readonly feeds: Maybe<ReadonlyArray<Maybe<FeedObject>>>;
  readonly id: Maybe<Scalars['ID']>;
  readonly isAdvisor: Maybe<Scalars['Boolean']>;
  readonly organization: Maybe<LimitedOrganizationObject>;
  readonly processingStartedAt: Maybe<Scalars['Date']>;
};

export type LimitedUserObject = {
  readonly __typename: 'LimitedUserObject';
  readonly email: Scalars['String'];
  readonly firstName: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly lastName: Maybe<Scalars['String']>;
};

export type LineItemObject = {
  readonly __typename: 'LineItemObject';
  readonly cost: Maybe<Scalars['Float']>;
  readonly createdAt: Scalars['DateTime'];
  readonly description: Scalars['String'];
  readonly hidden: Scalars['Boolean'];
  readonly id: Scalars['String'];
  readonly invoice: InvoiceObject;
  readonly quantity: Maybe<Scalars['Int']>;
  readonly rate: Maybe<Scalars['Float']>;
  readonly stripeId: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['DateTime'];
};

export type LinkAttributionHourly = {
  readonly __typename: 'LinkAttributionHourly';
  readonly downloads: Maybe<Scalars['RoundedInt']>;
  readonly hour: Maybe<Scalars['DateTime']>;
  readonly reach: Maybe<Scalars['RoundedInt']>;
};

export type LinkClicks = {
  readonly __typename: 'LinkClicks';
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly category: Maybe<Scalars['String']>;
  readonly total: Maybe<Scalars['RoundedInt']>;
  readonly type: Maybe<Scalars['String']>;
};

export type LinkHourly = {
  readonly __typename: 'LinkHourly';
  readonly action: Maybe<Scalars['String']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly hour: Maybe<Scalars['DateTime']>;
  readonly total: Maybe<Scalars['RoundedInt']>;
};

export type LinkTargetEpisode = {
  readonly __typename: 'LinkTargetEpisode';
  readonly downloads: Maybe<Scalars['RoundedInt']>;
  readonly episode: Maybe<EpisodeObject>;
  readonly id: Maybe<Scalars['ID']>;
  readonly reach: Maybe<Scalars['Float']>;
};

export type LinkTargetEpisodes = AttributionInterface & {
  readonly __typename: 'LinkTargetEpisodes';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly key: Scalars['ID'];
  readonly nodes: Maybe<ReadonlyArray<Maybe<LinkTargetEpisode>>>;
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};


export type LinkTargetEpisodesNodesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};

export type LinkingRequestObject = {
  readonly __typename: 'LinkingRequestObject';
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly organization: OrganizationObject;
  readonly requestor: Maybe<LimitedUserObject>;
  readonly state: LinkingRequestState;
  readonly updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum LinkingRequestState {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Requested */
  Requested = 'REQUESTED'
}

export type LocationNameObject = {
  readonly __typename: 'LocationNameObject';
  readonly locationName: Scalars['String'];
  readonly locationNameDisplay: Scalars['String'];
};

export type LockEnd = {
  readonly __typename: 'LockEnd';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type LockInput = {
  readonly episodeId: Scalars['ID'];
  readonly reviewerId: InputMaybe<Scalars['ID']>;
  readonly userId: InputMaybe<Scalars['ID']>;
};

export type LockStart = {
  readonly __typename: 'LockStart';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type MaidLocation = {
  readonly __typename: 'MAIDLocation';
  readonly city: Maybe<Scalars['String']>;
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly country: Maybe<Scalars['String']>;
  readonly latitude: Maybe<Scalars['Float']>;
  readonly longitude: Maybe<Scalars['Float']>;
  readonly region: Maybe<Scalars['String']>;
};

export type MaidsObject = {
  readonly __typename: 'MAIDSObject';
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly locations: Maybe<ReadonlyArray<Maybe<MaidLocation>>>;
};


export type MaidsObjectCountArgs = {
  countries: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  kinds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  maidsLength: InputMaybe<Scalars['Int']>;
};


export type MaidsObjectLocationsArgs = {
  countries: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  kinds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  maidsLength: InputMaybe<Scalars['Int']>;
};

export type MachineLearningObject = {
  readonly __typename: 'MachineLearningObject';
  readonly episodesForLabeling: Maybe<ReadonlyArray<Maybe<EpisodePathVarsObject>>>;
  readonly episodesForMaturityRating: Maybe<ReadonlyArray<Maybe<EpisodePathVarsObject>>>;
  readonly feedIdsForBrandAffinity: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
};


export type MachineLearningObjectEpisodesForLabelingArgs = {
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
  limit: InputMaybe<Scalars['Int']>;
};

export type Management = {
  readonly __typename: 'Management';
  readonly attribution: Maybe<AttributionManagement>;
};

export type MarkNewBrandRequestComplete = {
  readonly __typename: 'MarkNewBrandRequestComplete';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type MarkNewBrandRequestCompleteInput = {
  readonly requestId: Scalars['ID'];
};

export type MarketingTargetEpisode = {
  readonly __typename: 'MarketingTargetEpisode';
  readonly attribution: Maybe<Scalars['Float']>;
  readonly downloads: Maybe<Scalars['Float']>;
  readonly episode: Maybe<EpisodeObject>;
  readonly id: Maybe<Scalars['ID']>;
};

export type MarketingTargetEpisodes = AttributionInterface & {
  readonly __typename: 'MarketingTargetEpisodes';
  readonly action: Maybe<Scalars['String']>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly campaignDynamicId: Maybe<Scalars['ID']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly campaignLinkId: Maybe<Scalars['ID']>;
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly episodeId: Maybe<Scalars['ID']>;
  readonly episodeIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly feedIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly key: Scalars['ID'];
  readonly nodes: Maybe<ReadonlyArray<Maybe<MarketingTargetEpisode>>>;
  readonly organizationId: Maybe<Scalars['ID']>;
  readonly targetFeedId: Maybe<Scalars['ID']>;
};


export type MarketingTargetEpisodesNodesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};

/** start processing feeds. */
export type MeasureFeed = {
  readonly __typename: 'MeasureFeed';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type MeasureFeedInput = {
  readonly feedId: Scalars['ID'];
};

export type MediaImageObject = {
  readonly __typename: 'MediaImageObject';
  readonly companies: ReadonlyArray<CompanyObject>;
  readonly contentType: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly height: Scalars['Int'];
  readonly id: Scalars['String'];
  readonly path: Scalars['String'];
  readonly products: ReadonlyArray<ProductObject>;
  readonly size: Scalars['Int'];
  readonly src: Maybe<Scalars['String']>;
  readonly width: Scalars['Int'];
};

export type MembershipObject = {
  readonly __typename: 'MembershipObject';
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly role: Maybe<Scalars['String']>;
  readonly roleDisplay: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly user: Maybe<LimitedUserObject>;
};

export type MergeCompany = {
  readonly __typename: 'MergeCompany';
  readonly company: Maybe<CompanyObject>;
  readonly issues: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type MergeCompanyInput = {
  readonly companyId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly productId: InputMaybe<Scalars['ID']>;
  readonly productName: InputMaybe<Scalars['String']>;
};

export type MergeProduct = {
  readonly __typename: 'MergeProduct';
  readonly product: Maybe<ProductObject>;
};

export type MergeProductInput = {
  readonly companyId: Scalars['ID'];
  readonly id: Scalars['ID'];
  readonly productId: InputMaybe<Scalars['ID']>;
};

export type MessageObject = {
  readonly __typename: 'MessageObject';
  readonly action: Maybe<Scalars['String']>;
  readonly attributes: Maybe<Scalars['JSONString']>;
};

/**
 * We create this object with the positive and total counts for control and exposed,
 * and resolvers calculate percentages and significance.
 */
export type MessageResultGroupObject = {
  readonly __typename: 'MessageResultGroupObject';
  readonly controlPercentage: Scalars['Float'];
  readonly controlPositive: Scalars['Int'];
  readonly controlTotal: Scalars['Int'];
  readonly exposedPercentage: Scalars['Float'];
  readonly exposedPositive: Scalars['Int'];
  readonly exposedTotal: Scalars['Int'];
  readonly percentChange: Scalars['Float'];
  readonly significance: Significance;
};

export type Missing = {
  readonly __typename: 'Missing';
  readonly after: Maybe<Scalars['String']>;
  readonly before: Maybe<Scalars['String']>;
  readonly organizationId: Maybe<Scalars['ID']>;
};

export type MosaicType = {
  readonly __typename: 'MosaicType';
  readonly descr: Maybe<Scalars['String']>;
  readonly feat1: Maybe<Scalars['String']>;
  readonly feat2: Maybe<Scalars['String']>;
  readonly feat3: Maybe<Scalars['String']>;
  readonly feat4: Maybe<Scalars['String']>;
  readonly feat5: Maybe<Scalars['String']>;
  readonly feat6: Maybe<Scalars['String']>;
  readonly hh: Maybe<Scalars['Float']>;
  readonly index: Maybe<Scalars['Float']>;
  readonly name: Maybe<Scalars['String']>;
  readonly percentOfPop: Maybe<Scalars['Float']>;
  readonly pop: Maybe<Scalars['Float']>;
  readonly reach: Maybe<Scalars['Float']>;
  readonly segment: Maybe<Scalars['String']>;
  readonly totalHouseholds: Maybe<Scalars['RoundedInt']>;
  readonly type: Maybe<Scalars['String']>;
};

export type MosaicTypes = {
  readonly __typename: 'MosaicTypes';
  readonly feedId: Maybe<Scalars['ID']>;
  readonly types: Maybe<ReadonlyArray<Maybe<MosaicType>>>;
};

export type MultiBillingRecords = {
  readonly __typename: 'MultiBillingRecords';
  readonly dailyCampaignBillingRecords: Maybe<ReadonlyArray<Maybe<DailyCampaignBillingRecord>>>;
  readonly simpleBillingRecords: Maybe<ReadonlyArray<Maybe<SimpleBillingRecord>>>;
};

export type Mutation = {
  readonly __typename: 'Mutation';
  readonly acceptCompanyClaim: Maybe<AcceptCompanyClaim>;
  readonly adStudioSandboxCleanup: Maybe<AdStudioSandboxCleanup>;
  readonly addAccess: Maybe<AddAccess>;
  readonly addAdStudioAdAccount: Maybe<AddAdStudioAdAccount>;
  /** We can save the secret on multiple objects, so this is just easier. */
  readonly addArt19Secret: Maybe<AddArt19Secret>;
  readonly addDomain: Maybe<AddDomain>;
  readonly addFeed: Maybe<AddFeed>;
  readonly addMember: Maybe<AddMember>;
  readonly addOrganizationAdvisor: Maybe<AddAdvisorForOrganization>;
  readonly addPixel: Maybe<CreateKey>;
  readonly addPixelAndClaimCompany: Maybe<CreateKeyAndCompanyClaim>;
  readonly addTag: Maybe<AddTag>;
  /** start processing feeds. */
  readonly archiveFeed: Maybe<ArchiveFeed>;
  readonly assignSpotifyOrderBrand: Maybe<AssignSpotifyOrderBrand>;
  /** run the ranges. */
  readonly attributionCampaignPreRun: Maybe<AttributionCampaignPreRun>;
  /** I clear out the pre directories to get a fresh start if there is an issue. */
  readonly attributionPreClearRange: Maybe<AttributionPreClearRange>;
  /** run the ranges. */
  readonly attributionPreRun: Maybe<AttributionPreRun>;
  readonly attributionRun: Maybe<AttributionRun>;
  readonly authed: Maybe<Authed>;
  readonly backdateRange: Maybe<BackdateRange>;
  readonly checkCampaignPodcastPrefix: Maybe<CheckCampaignPodcastPrefix>;
  readonly claimAddPodcast: Maybe<ClaimAddPodcast>;
  readonly claimFeed: Maybe<ClaimFeed>;
  readonly clearQueue: Maybe<ClearQueue>;
  readonly completePlacements: Maybe<CompletePlacements>;
  readonly contactPublisher: Maybe<ContactPublisher>;
  readonly contactedContact: Maybe<ContactedContact>;
  readonly createActionMap: Maybe<CreateActionMap>;
  readonly createAdvisorSavedSearch: Maybe<CreateAdvisorSavedSearch>;
  /** Used to generate an API key that can be used for querying our API directly.  We cannot retrieve this. */
  readonly createApiKey: Maybe<CreateApiKey>;
  readonly createAsset: Maybe<CreateAsset>;
  readonly createBillingInfo: Maybe<CreateBillingInfo>;
  readonly createBrandInvites: Maybe<CreateBrandInvites>;
  readonly createCampaign: Maybe<CreateCampaign>;
  readonly createCampaignApprovals: Maybe<CreateCampaignApprovals>;
  readonly createCampaignBroadcast: Maybe<CreateCampaignBroadcast>;
  readonly createCampaignDynamic: Maybe<CreateCampaignDynamic>;
  readonly createCampaignDynamicDelivery: Maybe<CreateCampaignDynamicDelivery>;
  readonly createCampaignEpisode: Maybe<CreateCampaignEpisode>;
  readonly createCampaignLink: Maybe<CreateCampaignLink>;
  readonly createCampaignNoise: Maybe<CreateCampaignNoise>;
  readonly createCampaignPodcast: Maybe<CreateCampaignPodcast>;
  readonly createCampaignStreaming: Maybe<CreateCampaignStreaming>;
  readonly createCampaignStreamingDelivery: Maybe<CreateCampaignStreamingDelivery>;
  readonly createCampaignTarget: Maybe<CreateCampaignTarget>;
  readonly createComment: Maybe<CreateComment>;
  readonly createCompany: Maybe<CreateCompany>;
  readonly createCompanyClaim: Maybe<CreateCompanyClaim>;
  readonly createContact: Maybe<CreateContact>;
  readonly createConversionUrl: Maybe<CreateConversionUrl>;
  readonly createEpisodeRating: Maybe<CreateEpisodeRating>;
  readonly createEpisodeRatingException: Maybe<CreateEpisodeRatingException>;
  readonly createExportInstance: Maybe<CreateExportInstance>;
  readonly createExportToken: Maybe<CreateExportToken>;
  readonly createFutureEpisode: Maybe<CreateFutureEpisode>;
  readonly createGenericTag: Maybe<CreateGenericTag>;
  readonly createGenericTagRelationship: Maybe<CreateGenericTagRelationship>;
  readonly createImage: Maybe<CreateImage>;
  readonly createInvoice: Maybe<CreateInvoice>;
  readonly createLiftReport: Maybe<CreateLiftReport>;
  readonly createOrganization: Maybe<CreateOrganization>;
  readonly createOrganizationWithPixel: Maybe<CreateOrganizationWithPixel>;
  readonly createPixelEventRecord: Maybe<CreatePixelEventRecord>;
  readonly createPodcast: Maybe<CreatePodcast>;
  readonly createPodlinkDomain: Maybe<CreatePodlinkDomain>;
  readonly createReviewer: Maybe<CreateReviewer>;
  readonly createSavedExport: Maybe<CreateSavedExport>;
  /**
   * Used to generate an API key that is separate from any actual user,
   * giving access to only the current organization.
   */
  readonly createServiceAccountApiKey: Maybe<CreateServiceAccountApiKey>;
  readonly createSpotifyCampaignImportRequests: Maybe<CreateSpotifyCampaignImportRequests>;
  readonly createTermsAndConditions: Maybe<CreateTermsAndConditions>;
  readonly createUser: Maybe<CreateUser>;
  readonly createUserAccess: Maybe<CreateUserAccess>;
  readonly createUserSkippedTerms: Maybe<CreateUserSkippedTerms>;
  readonly deleteActionMap: Maybe<DeleteActionMap>;
  readonly deleteAdvisorSavedSearch: Maybe<DeleteAdvisorSavedSearch>;
  readonly deleteCampaign: Maybe<DeleteCampaign>;
  readonly deleteCampaignBroadcast: Maybe<DeleteCampaignBroadcast>;
  readonly deleteCampaignDynamic: Maybe<DeleteCampaignDynamic>;
  readonly deleteCampaignDynamicDelivery: Maybe<DeleteCampaignDynamicDelivery>;
  readonly deleteCampaignNoise: Maybe<DeleteCampaignNoise>;
  readonly deleteCampaignPodcast: Maybe<DeleteCampaignPodcast>;
  readonly deleteCampaignStreaming: Maybe<DeleteCampaignStreaming>;
  readonly deleteCampaignStreamingDelivery: Maybe<DeleteCampaignStreamingDelivery>;
  readonly deleteComment: Maybe<DeleteComment>;
  readonly deleteCompany: Maybe<DeleteCompany>;
  readonly deleteCompanyClaim: Maybe<DeleteCompanyClaim>;
  readonly deleteConversionUrl: Maybe<DeleteConversionUrl>;
  readonly deleteFutureEpisode: Maybe<DeleteFutureEpisode>;
  readonly deleteGenericTag: Maybe<DeleteGenericTag>;
  readonly deleteGenericTagRelationship: Maybe<DeleteGenericTagRelationship>;
  readonly deleteLiftReport: Maybe<DeleteLiftReport>;
  readonly deleteOrganization: Maybe<DeleteOrganization>;
  readonly deletePixelEventRecord: Maybe<DeletePixelEventRecord>;
  readonly deletePodcast: Maybe<DeletePodcast>;
  readonly deletePodcasts: Maybe<DeletePodcasts>;
  readonly deletePodlinkDomain: Maybe<DeletePodlinkDomain>;
  readonly deleteProduct: Maybe<DeleteProduct>;
  readonly deleteReviewer: Maybe<DeleteReviewer>;
  readonly deleteSavedExport: Maybe<DeleteSavedExport>;
  /** Deletes the token in the HTTP header, or if not provided in header, in the input if provided. */
  readonly deleteToken: Maybe<DeleteToken>;
  readonly deleteUserAccess: Maybe<DeleteUserAccess>;
  readonly designPodlinkDomain: Maybe<DesignPodlinkDomain>;
  readonly downloadAd: Maybe<DownloadAd>;
  readonly downloadMaids: Maybe<DownloadMaids>;
  readonly fillCampaignDynamics: Maybe<FillCampaignDynamics>;
  readonly fixRedisForFeedId: Maybe<FixRedisForFeedId>;
  readonly hideLineItem: Maybe<HideLineItem>;
  readonly hideUnmappedSpotifyOrders: Maybe<HideUnmappedSpotifyOrders>;
  readonly ignoredContact: Maybe<IgnoredContact>;
  readonly importPodcasts: Maybe<ImportPodcasts>;
  readonly isProcessingPodcast: Maybe<IsProcessingPodcast>;
  readonly isProcessingPodcasts: Maybe<IsProcessingPodcasts>;
  readonly keepalive: Maybe<Keepalive>;
  readonly lockEnd: Maybe<LockEnd>;
  readonly lockStart: Maybe<LockStart>;
  readonly markNewBrandRequestComplete: Maybe<MarkNewBrandRequestComplete>;
  /** start processing feeds. */
  readonly measureFeed: Maybe<MeasureFeed>;
  readonly mergeCompany: Maybe<MergeCompany>;
  readonly mergeProduct: Maybe<MergeProduct>;
  /** start processing feeds. */
  readonly noAdsFeed: Maybe<NoAdsFeed>;
  readonly noPlacements: Maybe<NoPlacements>;
  readonly processCampaignEpisodes: Maybe<ProcessCampaignEpisodes>;
  /** start processing feeds. */
  readonly processFeed: Maybe<ProcessFeed>;
  readonly publishMessage: Maybe<PublishMessage>;
  readonly publishSpotifyBrandLiftReport: Maybe<PublishSpotifyBrandLiftReport>;
  readonly publisherApproveCampaign: Maybe<PublisherApproveCampaign>;
  readonly publisherRejectCampaign: Maybe<PublisherRejectCampaign>;
  readonly rejectAd: Maybe<RejectAd>;
  readonly rejectCompanyClaim: Maybe<RejectCompanyClaim>;
  readonly removeAccess: Maybe<RemoveAccess>;
  readonly removeCampaignEpisode: Maybe<RemoveCampaignEpisode>;
  readonly removeDomain: Maybe<RemoveDomain>;
  readonly removeMember: Maybe<RemoveMember>;
  readonly removeOrganizationAdvisor: Maybe<RemoveAdvisorForOrganization>;
  readonly removeTag: Maybe<RemoveTag>;
  readonly requestNewBrandForSpotifyOrder: Maybe<RequestNewBrandForSpotifyOrder>;
  readonly resetContact: Maybe<ResetContact>;
  readonly runLiftReport: Maybe<RunLiftReport>;
  readonly sendTrackingUrlsConfirmationReminder: Maybe<SendTrackingUrlsConfirmationReminder>;
  /**
   * Verifies that the email, Gets the token and sends an email
   * to verify the user is able to login to SPAA
   */
  readonly sendVerifyEmail: Maybe<SendVerifyEmail>;
  readonly setAdAnalyticsTutorialProgress: Maybe<SetAdAnalyticsTutorialProgress>;
  readonly setAdvisorOptions: Maybe<SetAdvisorOptions>;
  readonly setHasSeenAdAnalyticsWelcome: Maybe<SetHasSeenAdAnalyticsWelcome>;
  readonly signMedia: Maybe<SignMedia>;
  readonly splitAd: Maybe<SplitAd>;
  readonly subscribe: Maybe<Subscribe>;
  readonly syncUserEmailWithSpotifyAccount: Maybe<SyncUserEmailWithSpotifyAccount>;
  readonly unarchiveFeed: Maybe<UnArchiveFeed>;
  readonly unhideUnmappedSpotifyOrders: Maybe<UnhideUnmappedSpotifyOrders>;
  readonly unknownAd: Maybe<UnknownAd>;
  readonly unsubscribe: Maybe<Unsubscribe>;
  readonly updateActionMap: Maybe<UpdateActionMap>;
  readonly updateAd: Maybe<UpdateAd>;
  readonly updateAdvisorSavedSearch: Maybe<UpdateAdvisorSavedSearch>;
  readonly updateAffinityScores: Maybe<UpdateAffinityScores>;
  readonly updateAllowBrandEditAccess: Maybe<UpdateAllowBrandEditAccess>;
  readonly updateAttributionConfig: Maybe<UpdateAttributionConfig>;
  readonly updateBillingInfo: Maybe<UpdateBillingInfo>;
  readonly updateCampaign: Maybe<UpdateCampaign>;
  readonly updateCampaignApprovals: Maybe<UpdateCampaignApprovals>;
  readonly updateCampaignBrandAgencies: Maybe<UpdateCampaignBrandAgencies>;
  readonly updateCampaignBroadcast: Maybe<UpdateCampaignBroadcast>;
  readonly updateCampaignDates: Maybe<UpdateCampaignDates>;
  readonly updateCampaignDynamic: Maybe<UpdateCampaignDynamic>;
  readonly updateCampaignDynamicProvider: Maybe<UpdateCampaignDynamicProvider>;
  readonly updateCampaignEpisode: Maybe<UpdateCampaignEpisode>;
  readonly updateCampaignIsNeustar: Maybe<UpdateCampaignIsNeustar>;
  readonly updateCampaignKind: Maybe<UpdateCampaignKind>;
  readonly updateCampaignNoise: Maybe<UpdateCampaignNoise>;
  readonly updateCampaignPodcast: Maybe<UpdateCampaignPodcast>;
  readonly updateCampaignState: Maybe<UpdateCampaignState>;
  readonly updateCampaignStreaming: Maybe<UpdateCampaignStreaming>;
  readonly updateCampaignStreamingProvider: Maybe<UpdateCampaignStreamingProvider>;
  readonly updateComment: Maybe<UpdateComment>;
  readonly updateCompany: Maybe<UpdateCompany>;
  readonly updateCompanyArchive: Maybe<UpdateCompanyArchive>;
  readonly updateCompanyIndustry: Maybe<UpdateCompanyIndustry>;
  readonly updateConversionUrl: Maybe<UpdateConversionUrl>;
  readonly updateEpisodeAdspottingModelVersion: Maybe<UpdateEpisodeAdspottingModelVersion>;
  readonly updateEpisodeAsrStatus: Maybe<UpdateEpisodeAsrStatus>;
  readonly updateFeedContactEmail: Maybe<UpdateFeedContactEmail>;
  /** Force an update of all the attributes on the feeds. */
  readonly updateFeeds: Maybe<UpdateFeeds>;
  readonly updateGenericTag: Maybe<UpdateGenericTag>;
  readonly updateInvoice: Maybe<UpdateInvoice>;
  readonly updateIsController: Maybe<UpdateIsController>;
  readonly updateLiftReport: Maybe<UpdateLiftReport>;
  readonly updateLinkingRequest: Maybe<UpdateLinkingRequest>;
  readonly updateMember: Maybe<UpdateMember>;
  readonly updateOrganization: Maybe<UpdateOrganization>;
  readonly updatePixel: Maybe<UpdateKey>;
  readonly updatePixelEventRecord: Maybe<UpdatePixelEventRecord>;
  readonly updatePodlinkDomain: Maybe<UpdatePodlinkDomain>;
  /** We do this serverside to send special headers. */
  readonly updatePodlinkPodcast: Maybe<UpdatePodlinkPodcast>;
  readonly updateSavedExport: Maybe<UpdateSavedExport>;
  readonly upsertPlacements: Maybe<UpsertPlacements>;
};


export type MutationAcceptCompanyClaimArgs = {
  input: AcceptCompanyClaimInput;
};


export type MutationAddAccessArgs = {
  input: AddAccessInput;
};


export type MutationAddAdStudioAdAccountArgs = {
  input: AddAdStudioAdAccountInput;
};


export type MutationAddArt19SecretArgs = {
  input: AddArt19SecretInput;
};


export type MutationAddDomainArgs = {
  input: AddDomainInput;
};


export type MutationAddFeedArgs = {
  input: AddFeedInput;
};


export type MutationAddMemberArgs = {
  input: AddMemberInput;
};


export type MutationAddOrganizationAdvisorArgs = {
  input: AddAdvisorForOrganizationInput;
};


export type MutationAddPixelArgs = {
  input: CreateKeyInput;
};


export type MutationAddPixelAndClaimCompanyArgs = {
  input: CreateKeyAndCompanyClaimInput;
};


export type MutationAddTagArgs = {
  input: AddTagInput;
};


export type MutationArchiveFeedArgs = {
  input: ArchiveFeedInput;
};


export type MutationAssignSpotifyOrderBrandArgs = {
  input: InputMaybe<AssignSpotifyOrderBrandInput>;
};


export type MutationAttributionCampaignPreRunArgs = {
  input: AttributionCampaignPreRunInput;
};


export type MutationAttributionPreClearRangeArgs = {
  input: AttributionPreRangeInput;
};


export type MutationAttributionPreRunArgs = {
  input: AttributionPreRunInput;
};


export type MutationAttributionRunArgs = {
  input: AttributionRunInput;
};


export type MutationAuthedArgs = {
  input: InputMaybe<AuthedInput>;
};


export type MutationBackdateRangeArgs = {
  input: BackdateRangeInput;
};


export type MutationCheckCampaignPodcastPrefixArgs = {
  input: CheckCampaignPodcastPrefixInput;
};


export type MutationClaimAddPodcastArgs = {
  input: ClaimAddPodcastInput;
};


export type MutationClaimFeedArgs = {
  input: ClaimFeedInput;
};


export type MutationClearQueueArgs = {
  input: ClearQueueInput;
};


export type MutationCompletePlacementsArgs = {
  input: CompletePlacementsInput;
};


export type MutationContactPublisherArgs = {
  input: ContactPublisherInput;
};


export type MutationContactedContactArgs = {
  input: ContactedContactInput;
};


export type MutationCreateActionMapArgs = {
  input: CreateActionMapInput;
};


export type MutationCreateAdvisorSavedSearchArgs = {
  input: CreateAdvisorSavedSearchInput;
};


export type MutationCreateAssetArgs = {
  input: CreateAssetInput;
};


export type MutationCreateBillingInfoArgs = {
  input: CreateBillingInfoInput;
};


export type MutationCreateBrandInvitesArgs = {
  input: CreateBrandInvitesInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCampaignApprovalsArgs = {
  input: CreateCampaignApprovalsInput;
};


export type MutationCreateCampaignBroadcastArgs = {
  input: CreateCampaignBroadcastInput;
};


export type MutationCreateCampaignDynamicArgs = {
  input: CreateCampaignDynamicInput;
};


export type MutationCreateCampaignDynamicDeliveryArgs = {
  input: CreateCampaignDynamicDeliveryInput;
};


export type MutationCreateCampaignEpisodeArgs = {
  input: CreateCampaignEpisodeInput;
};


export type MutationCreateCampaignLinkArgs = {
  input: CreateCampaignLinkInput;
};


export type MutationCreateCampaignNoiseArgs = {
  input: CreateCampaignNoiseInput;
};


export type MutationCreateCampaignPodcastArgs = {
  input: CreateCampaignPodcastInput;
};


export type MutationCreateCampaignStreamingArgs = {
  input: CreateCampaignStreamingInput;
};


export type MutationCreateCampaignStreamingDeliveryArgs = {
  input: CreateCampaignStreamingDeliveryInput;
};


export type MutationCreateCampaignTargetArgs = {
  input: CreateCampaignTargetInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateCompanyClaimArgs = {
  input: CreateCompanyClaimInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateConversionUrlArgs = {
  input: CreateConversionUrlInput;
};


export type MutationCreateEpisodeRatingArgs = {
  input: CreateEpisodeRatingInput;
};


export type MutationCreateEpisodeRatingExceptionArgs = {
  input: CreateEpisodeRatingExceptionInput;
};


export type MutationCreateExportInstanceArgs = {
  input: CreateExportInstanceInput;
};


export type MutationCreateExportTokenArgs = {
  input: CreateExportTokenInput;
};


export type MutationCreateFutureEpisodeArgs = {
  input: CreateFutureEpisodeInput;
};


export type MutationCreateGenericTagArgs = {
  input: CreateGenericTagInput;
};


export type MutationCreateGenericTagRelationshipArgs = {
  input: CreateGenericTagRelationshipInput;
};


export type MutationCreateImageArgs = {
  input: CreateImageInput;
};


export type MutationCreateInvoiceArgs = {
  input: CreateInvoiceInput;
};


export type MutationCreateLiftReportArgs = {
  input: CreateLiftReportInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationWithPixelArgs = {
  input: CreateOrganizationWithPixelInput;
};


export type MutationCreatePixelEventRecordArgs = {
  input: CreatePixelEventRecordInput;
};


export type MutationCreatePodcastArgs = {
  input: CreatePodcastInput;
};


export type MutationCreatePodlinkDomainArgs = {
  input: CreatePodlinkDomainInput;
};


export type MutationCreateReviewerArgs = {
  input: CreateReviewerInput;
};


export type MutationCreateSavedExportArgs = {
  input: CreateSavedExportInput;
};


export type MutationCreateServiceAccountApiKeyArgs = {
  input: CreateServiceAccountApiKeyInput;
};


export type MutationCreateSpotifyCampaignImportRequestsArgs = {
  input: CreateSpotifyCampaignImportRequestsInput;
};


export type MutationCreateTermsAndConditionsArgs = {
  input: CreateTermsAndConditionsInput;
};


export type MutationCreateUserArgs = {
  input: InputMaybe<CreateUserInput>;
};


export type MutationCreateUserAccessArgs = {
  input: CreateUserAccessInput;
};


export type MutationCreateUserSkippedTermsArgs = {
  input: CreateUserSkippedTermsInput;
};


export type MutationDeleteActionMapArgs = {
  input: DeleteActionMapInput;
};


export type MutationDeleteAdvisorSavedSearchArgs = {
  input: DeleteAdvisorSavedSearchInput;
};


export type MutationDeleteCampaignArgs = {
  input: DeleteCampaignInput;
};


export type MutationDeleteCampaignBroadcastArgs = {
  input: DeleteCampaignBroadcastInput;
};


export type MutationDeleteCampaignDynamicArgs = {
  input: DeleteCampaignDynamicInput;
};


export type MutationDeleteCampaignDynamicDeliveryArgs = {
  input: DeleteCampaignDynamicDeliveryInput;
};


export type MutationDeleteCampaignNoiseArgs = {
  input: DeleteCampaignNoiseInput;
};


export type MutationDeleteCampaignPodcastArgs = {
  input: DeleteCampaignPodcastInput;
};


export type MutationDeleteCampaignStreamingArgs = {
  input: DeleteCampaignStreamingInput;
};


export type MutationDeleteCampaignStreamingDeliveryArgs = {
  input: DeleteCampaignStreamingDeliveryInput;
};


export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type MutationDeleteCompanyArgs = {
  input: DeleteCompanyInput;
};


export type MutationDeleteCompanyClaimArgs = {
  input: DeleteCompanyClaimInput;
};


export type MutationDeleteConversionUrlArgs = {
  input: DeleteConversionUrlInput;
};


export type MutationDeleteFutureEpisodeArgs = {
  input: DeleteFutureEpisodeInput;
};


export type MutationDeleteGenericTagArgs = {
  input: DeleteGenericTagInput;
};


export type MutationDeleteGenericTagRelationshipArgs = {
  input: DeleteGenericTagRelationshipInput;
};


export type MutationDeleteLiftReportArgs = {
  input: DeleteLiftReportInput;
};


export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


export type MutationDeletePixelEventRecordArgs = {
  input: DeletePixelEventRecordInput;
};


export type MutationDeletePodcastArgs = {
  input: DeletePodcastInput;
};


export type MutationDeletePodcastsArgs = {
  input: DeletePodcastsInput;
};


export type MutationDeletePodlinkDomainArgs = {
  input: DeletePodlinkDomainInput;
};


export type MutationDeleteProductArgs = {
  input: DeleteProductInput;
};


export type MutationDeleteReviewerArgs = {
  input: DeleteReviewerInput;
};


export type MutationDeleteSavedExportArgs = {
  input: DeleteSavedExportInput;
};


export type MutationDeleteTokenArgs = {
  input: InputMaybe<DeleteTokenInput>;
};


export type MutationDeleteUserAccessArgs = {
  input: DeleteUserAccessInput;
};


export type MutationDesignPodlinkDomainArgs = {
  input: DesignPodlinkDomainInput;
};


export type MutationDownloadAdArgs = {
  input: DownloadAdInput;
};


export type MutationDownloadMaidsArgs = {
  input: DownloadMaidsInput;
};


export type MutationFillCampaignDynamicsArgs = {
  input: FillCampaignDynamicsInput;
};


export type MutationFixRedisForFeedIdArgs = {
  input: FixRedisForFeedIdInput;
};


export type MutationHideLineItemArgs = {
  input: HideLineItemInput;
};


export type MutationHideUnmappedSpotifyOrdersArgs = {
  input: InputMaybe<HideUnmappedSpotifyOrdersInput>;
};


export type MutationIgnoredContactArgs = {
  input: IgnoredContactInput;
};


export type MutationImportPodcastsArgs = {
  input: ImportPodcastsInput;
};


export type MutationIsProcessingPodcastArgs = {
  input: IsProcessingPodcastInput;
};


export type MutationIsProcessingPodcastsArgs = {
  input: IsProcessingPodcastsInput;
};


export type MutationKeepaliveArgs = {
  input: KeepaliveInput;
};


export type MutationLockEndArgs = {
  input: LockInput;
};


export type MutationLockStartArgs = {
  input: InputMaybe<LockInput>;
};


export type MutationMarkNewBrandRequestCompleteArgs = {
  input: InputMaybe<MarkNewBrandRequestCompleteInput>;
};


export type MutationMeasureFeedArgs = {
  input: MeasureFeedInput;
};


export type MutationMergeCompanyArgs = {
  input: MergeCompanyInput;
};


export type MutationMergeProductArgs = {
  input: MergeProductInput;
};


export type MutationNoAdsFeedArgs = {
  input: NoAdsFeedInput;
};


export type MutationNoPlacementsArgs = {
  input: NoPlacementsInput;
};


export type MutationProcessCampaignEpisodesArgs = {
  input: ProcessCampaignEpisodesInput;
};


export type MutationProcessFeedArgs = {
  input: ProcessFeedInput;
};


export type MutationPublishMessageArgs = {
  input: PublishMessageInput;
};


export type MutationPublishSpotifyBrandLiftReportArgs = {
  input: PublishSpotifyBrandLiftReportInput;
};


export type MutationPublisherApproveCampaignArgs = {
  input: InputMaybe<PublisherApproveCampaignInput>;
};


export type MutationPublisherRejectCampaignArgs = {
  input: InputMaybe<PublisherRejectCampaignInput>;
};


export type MutationRejectAdArgs = {
  input: RejectAdInput;
};


export type MutationRejectCompanyClaimArgs = {
  input: RejectCompanyClaimInput;
};


export type MutationRemoveAccessArgs = {
  input: RemoveAccessInput;
};


export type MutationRemoveCampaignEpisodeArgs = {
  input: RemoveCampaignEpisodeInput;
};


export type MutationRemoveDomainArgs = {
  input: RemoveDomainInput;
};


export type MutationRemoveMemberArgs = {
  input: RemoveMemberInput;
};


export type MutationRemoveOrganizationAdvisorArgs = {
  input: RemoveAdvisorForOrganizationInput;
};


export type MutationRemoveTagArgs = {
  input: RemoveTagInput;
};


export type MutationRequestNewBrandForSpotifyOrderArgs = {
  input: InputMaybe<RequestNewBrandForSpotifyOrderInput>;
};


export type MutationResetContactArgs = {
  input: ResetContactInput;
};


export type MutationRunLiftReportArgs = {
  input: RunLiftReportInput;
};


export type MutationSendTrackingUrlsConfirmationReminderArgs = {
  input: InputMaybe<SendTrackingUrlsConfirmationReminderInput>;
};


export type MutationSendVerifyEmailArgs = {
  input: InputMaybe<SendVerifyEmailInput>;
};


export type MutationSetAdAnalyticsTutorialProgressArgs = {
  input: SetAdAnalyticsTutorialProgressInput;
};


export type MutationSetAdvisorOptionsArgs = {
  input: SetAdvisorOptionsInput;
};


export type MutationSetHasSeenAdAnalyticsWelcomeArgs = {
  input: SetHasSeenAdAnalyticsWelcomeInput;
};


export type MutationSignMediaArgs = {
  input: SignMediaInput;
};


export type MutationSplitAdArgs = {
  input: SplitAdInput;
};


export type MutationSubscribeArgs = {
  input: SubscribeInput;
};


export type MutationUnarchiveFeedArgs = {
  input: UnArchiveFeedInput;
};


export type MutationUnhideUnmappedSpotifyOrdersArgs = {
  input: InputMaybe<HideUnmappedSpotifyOrdersInput>;
};


export type MutationUnknownAdArgs = {
  input: UnknownAdInput;
};


export type MutationUnsubscribeArgs = {
  input: UnsubscribeInput;
};


export type MutationUpdateActionMapArgs = {
  input: UpdateActionMapInput;
};


export type MutationUpdateAdArgs = {
  input: UpdateAdInput;
};


export type MutationUpdateAdvisorSavedSearchArgs = {
  input: UpdateAdvisorSavedSearchInput;
};


export type MutationUpdateAffinityScoresArgs = {
  input: UpdateAffinityScoresInput;
};


export type MutationUpdateAllowBrandEditAccessArgs = {
  input: UpdateAllowBrandEditAccessInput;
};


export type MutationUpdateAttributionConfigArgs = {
  input: UpdateAttributionConfigInput;
};


export type MutationUpdateBillingInfoArgs = {
  input: UpdateBillingInfoInput;
};


export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type MutationUpdateCampaignApprovalsArgs = {
  input: UpdateCampaignApprovalsInput;
};


export type MutationUpdateCampaignBrandAgenciesArgs = {
  input: UpdateCampaignBrandAgenciesInput;
};


export type MutationUpdateCampaignBroadcastArgs = {
  input: UpdateCampaignBroadcastInput;
};


export type MutationUpdateCampaignDatesArgs = {
  input: UpdateCampaignDatesInput;
};


export type MutationUpdateCampaignDynamicArgs = {
  input: UpdateCampaignDynamicInput;
};


export type MutationUpdateCampaignDynamicProviderArgs = {
  input: UpdateCampaignDynamicProviderInput;
};


export type MutationUpdateCampaignEpisodeArgs = {
  input: UpdateCampaignEpisodeInput;
};


export type MutationUpdateCampaignIsNeustarArgs = {
  input: UpdateCampaignIsNeustarInput;
};


export type MutationUpdateCampaignKindArgs = {
  input: UpdateCampaignKindInput;
};


export type MutationUpdateCampaignNoiseArgs = {
  input: UpdateCampaignNoiseInput;
};


export type MutationUpdateCampaignPodcastArgs = {
  input: UpdateCampaignPodcastInput;
};


export type MutationUpdateCampaignStateArgs = {
  input: UpdateCampaignStateInput;
};


export type MutationUpdateCampaignStreamingArgs = {
  input: UpdateCampaignStreamingInput;
};


export type MutationUpdateCampaignStreamingProviderArgs = {
  input: UpdateCampaignStreamingProviderInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyArchiveArgs = {
  input: UpdateCompanyArchiveInput;
};


export type MutationUpdateCompanyIndustryArgs = {
  input: UpdateCompanyIndustryInput;
};


export type MutationUpdateConversionUrlArgs = {
  input: UpdateConversionUrlInput;
};


export type MutationUpdateEpisodeAdspottingModelVersionArgs = {
  input: UpdateEpisodeAdspottingModelVersionInput;
};


export type MutationUpdateEpisodeAsrStatusArgs = {
  input: UpdateEpisodeAsrStatusInput;
};


export type MutationUpdateFeedContactEmailArgs = {
  input: UpdateFeedContactEmailInput;
};


export type MutationUpdateFeedsArgs = {
  input: UpdateFeedsInput;
};


export type MutationUpdateGenericTagArgs = {
  input: UpdateGenericTagInput;
};


export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceInput;
};


export type MutationUpdateIsControllerArgs = {
  input: UpdateIsControllerInput;
};


export type MutationUpdateLiftReportArgs = {
  input: UpdateLiftReportInput;
};


export type MutationUpdateLinkingRequestArgs = {
  input: UpdateLinkingRequestInput;
};


export type MutationUpdateMemberArgs = {
  input: UpdateMemberInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdatePixelArgs = {
  input: UpdateKeyInput;
};


export type MutationUpdatePixelEventRecordArgs = {
  input: UpdatePixelEventRecordInput;
};


export type MutationUpdatePodlinkDomainArgs = {
  input: UpdatePodlinkDomainInput;
};


export type MutationUpdatePodlinkPodcastArgs = {
  input: UpdatePodlinkPodcastInput;
};


export type MutationUpdateSavedExportArgs = {
  input: UpdateSavedExportInput;
};


export type MutationUpsertPlacementsArgs = {
  input: UpsertPlacementsInput;
};

export type NielsenMetric = {
  readonly __typename: 'NielsenMetric';
  readonly index: Maybe<Scalars['Float']>;
  readonly indexPercentOfPop: Maybe<Scalars['Float']>;
  readonly podcastPercentOfPop: Maybe<Scalars['Float']>;
  readonly reach: Maybe<Scalars['Float']>;
  readonly totalHouseholds: Maybe<Scalars['Float']>;
  readonly variable: Maybe<Scalars['String']>;
};

export type NielsenSegment = {
  readonly __typename: 'NielsenSegment';
  readonly category: Maybe<Scalars['String']>;
  readonly classification: Maybe<Scalars['String']>;
  readonly feedId: Maybe<Scalars['ID']>;
  readonly metrics: Maybe<ReadonlyArray<Maybe<NielsenMetric>>>;
  readonly percentNielsenMatching: Maybe<Scalars['Float']>;
  readonly topic: Maybe<Scalars['String']>;
  readonly uniqueHhCount: Maybe<Scalars['Int']>;
  readonly uniqueNielsenMatching: Maybe<Scalars['RoundedInt']>;
};

/** start processing feeds. */
export type NoAdsFeed = {
  readonly __typename: 'NoAdsFeed';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type NoAdsFeedInput = {
  readonly feedId: Scalars['ID'];
};

export type NoPlacements = {
  readonly __typename: 'NoPlacements';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type NoPlacementsInput = {
  readonly assignmentId: InputMaybe<Scalars['String']>;
  readonly episodeId: Scalars['ID'];
  readonly hitId: InputMaybe<Scalars['String']>;
  readonly reviewDuration: InputMaybe<Scalars['Int']>;
  readonly reviewerId: InputMaybe<Scalars['ID']>;
  readonly workerId: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum OrganizationCurrency {
  /** Australian Dollar */
  Aud = 'AUD',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Euro */
  Eur = 'EUR',
  /** Pound Sterling */
  Gbp = 'GBP',
  /** Ghanian Cedi */
  Ghs = 'GHS',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Naira */
  Ngn = 'NGN',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Uganda Shilling */
  Ugx = 'UGX',
  /** US Dollar */
  Usd = 'USD'
}

export type OrganizationDomainObject = {
  readonly __typename: 'OrganizationDomainObject';
  readonly createdAt: Scalars['DateTime'];
  readonly domain: Scalars['String'];
  readonly id: Scalars['String'];
};

/** An enumeration. */
export enum OrganizationDownloadAlgorithm {
  /** Megaphone */
  Megaphone = 'MEGAPHONE',
  /** Podsights */
  Podsights = 'PODSIGHTS'
}

/** An enumeration. */
export enum OrganizationKind {
  /** Brand */
  Brand = 'BRAND',
  /** Buy Side Agency */
  BuySide = 'BUY_SIDE',
  /** Podcast */
  Podcast = 'PODCAST',
  /** Research */
  Research = 'RESEARCH',
  /** Sell Side Agency */
  SellSide = 'SELL_SIDE'
}

/** An enumeration. */
export enum OrganizationKnowledgeLevel {
  /** Expert */
  Expert = 'EXPERT',
  /** Novice */
  Novice = 'NOVICE',
  /** Proficient */
  Proficient = 'PROFICIENT'
}

/** An enumeration. */
export enum OrganizationLocation {
  /** Afghanistan */
  Afg = 'AFG',
  /** Angola */
  Ago = 'AGO',
  /** Albania */
  Alb = 'ALB',
  /** Andorra */
  And = 'AND',
  /** United Arab Emirates */
  Are = 'ARE',
  /** Argentina */
  Arg = 'ARG',
  /** Armenia */
  Arm = 'ARM',
  /** Antigua & Barbuda */
  Atg = 'ATG',
  /** Australia */
  Aus = 'AUS',
  /** Austria */
  Aut = 'AUT',
  /** Azerbaijan */
  Aze = 'AZE',
  /** Burundi */
  Bdi = 'BDI',
  /** Belgium */
  Bel = 'BEL',
  /** Benin */
  Ben = 'BEN',
  /** Burkina Faso */
  Bfa = 'BFA',
  /** Bangladesh */
  Bgd = 'BGD',
  /** Bulgaria */
  Bgr = 'BGR',
  /** Bahrain */
  Bhr = 'BHR',
  /** Bahamas */
  Bhs = 'BHS',
  /** Bosnia & Herzegovina */
  Bih = 'BIH',
  /** Belarus */
  Blr = 'BLR',
  /** Belize */
  Blz = 'BLZ',
  /** Bolivia */
  Bol = 'BOL',
  /** Brazil */
  Bra = 'BRA',
  /** Barbados */
  Brb = 'BRB',
  /** Brunei */
  Brn = 'BRN',
  /** Bhutan */
  Btn = 'BTN',
  /** Botswana */
  Bwa = 'BWA',
  /** Central African Republic */
  Caf = 'CAF',
  /** Canada */
  Can = 'CAN',
  /** Switzerland */
  Che = 'CHE',
  /** Chile */
  Chl = 'CHL',
  /** China */
  Chn = 'CHN',
  /** Côte d’Ivoire */
  Civ = 'CIV',
  /** Cameroon */
  Cmr = 'CMR',
  /** DR Congo */
  Cod = 'COD',
  /** Congo */
  Cog = 'COG',
  /** Colombia */
  Col = 'COL',
  /** Comoros */
  Com = 'COM',
  /** Cabo Verde */
  Cpv = 'CPV',
  /** Costa Rica */
  Cri = 'CRI',
  /** Cuba */
  Cub = 'CUB',
  /** Cyprus */
  Cyp = 'CYP',
  /** Czech Republic */
  Cze = 'CZE',
  /** Germany */
  Deu = 'DEU',
  /** Djibouti */
  Dji = 'DJI',
  /** Dominica */
  Dma = 'DMA',
  /** Denmark */
  Dnk = 'DNK',
  /** Dominican Republic */
  Dom = 'DOM',
  /** Algeria */
  Dza = 'DZA',
  /** Ecuador */
  Ecu = 'ECU',
  /** Egypt */
  Egy = 'EGY',
  /** Eritrea */
  Eri = 'ERI',
  /** Spain */
  Esp = 'ESP',
  /** Estonia */
  Est = 'EST',
  /** Ethiopia */
  Eth = 'ETH',
  /** Finland */
  Fin = 'FIN',
  /** Fiji */
  Fji = 'FJI',
  /** France */
  Fra = 'FRA',
  /** Micronesia */
  Fsm = 'FSM',
  /** Gabon */
  Gab = 'GAB',
  /** United Kingdom */
  Gbr = 'GBR',
  /** Georgia */
  Geo = 'GEO',
  /** Ghana */
  Gha = 'GHA',
  /** Guinea */
  Gin = 'GIN',
  /** Gambia */
  Gmb = 'GMB',
  /** Guinea-Bissau */
  Gnb = 'GNB',
  /** Equatorial Guinea */
  Gnq = 'GNQ',
  /** Greece */
  Grc = 'GRC',
  /** Grenada */
  Grd = 'GRD',
  /** Guatemala */
  Gtm = 'GTM',
  /** Guyana */
  Guy = 'GUY',
  /** Honduras */
  Hnd = 'HND',
  /** Croatia */
  Hrv = 'HRV',
  /** Haiti */
  Hti = 'HTI',
  /** Hungary */
  Hun = 'HUN',
  /** Indonesia */
  Idn = 'IDN',
  /** India */
  Ind = 'IND',
  /** Ireland */
  Irl = 'IRL',
  /** Iran */
  Irn = 'IRN',
  /** Iraq */
  Irq = 'IRQ',
  /** Iceland */
  Isl = 'ISL',
  /** Israel */
  Isr = 'ISR',
  /** Italy */
  Ita = 'ITA',
  /** Jamaica */
  Jam = 'JAM',
  /** Jordan */
  Jor = 'JOR',
  /** Japan */
  Jpn = 'JPN',
  /** Kazakhstan */
  Kaz = 'KAZ',
  /** Kenya */
  Ken = 'KEN',
  /** Kyrgyzstan */
  Kgz = 'KGZ',
  /** Cambodia */
  Khm = 'KHM',
  /** Kiribati */
  Kir = 'KIR',
  /** Saint Kitts & Nevis */
  Kna = 'KNA',
  /** South Korea */
  Kor = 'KOR',
  /** Kuwait */
  Kwt = 'KWT',
  /** Laos */
  Lao = 'LAO',
  /** Lebanon */
  Lbn = 'LBN',
  /** Liberia */
  Lbr = 'LBR',
  /** Libya */
  Lby = 'LBY',
  /** Saint Lucia */
  Lca = 'LCA',
  /** Liechtenstein */
  Lie = 'LIE',
  /** Sri Lanka */
  Lka = 'LKA',
  /** Lesotho */
  Lso = 'LSO',
  /** Lithuania */
  Ltu = 'LTU',
  /** Luxembourg */
  Lux = 'LUX',
  /** Latvia */
  Lva = 'LVA',
  /** Morocco */
  Mar = 'MAR',
  /** Monaco */
  Mco = 'MCO',
  /** Moldova */
  Mda = 'MDA',
  /** Madagascar */
  Mdg = 'MDG',
  /** Maldives */
  Mdv = 'MDV',
  /** Mexico */
  Mex = 'MEX',
  /** Marshall Islands */
  Mhl = 'MHL',
  /** North Macedonia */
  Mkd = 'MKD',
  /** Mali */
  Mli = 'MLI',
  /** Malta */
  Mlt = 'MLT',
  /** Myanmar */
  Mmr = 'MMR',
  /** Montenegro */
  Mne = 'MNE',
  /** Mongolia */
  Mng = 'MNG',
  /** Mozambique */
  Moz = 'MOZ',
  /** Mauritania */
  Mrt = 'MRT',
  /** Mauritius */
  Mus = 'MUS',
  /** Malawi */
  Mwi = 'MWI',
  /** Malaysia */
  Mys = 'MYS',
  /** Namibia */
  Nam = 'NAM',
  /** Niger */
  Ner = 'NER',
  /** Nigeria */
  Nga = 'NGA',
  /** Nicaragua */
  Nic = 'NIC',
  /** Netherlands */
  Nld = 'NLD',
  /** Norway */
  Nor = 'NOR',
  /** Nepal */
  Npl = 'NPL',
  /** Nauru */
  Nru = 'NRU',
  /** New Zealand */
  Nzl = 'NZL',
  /** Oman */
  Omn = 'OMN',
  /** Pakistan */
  Pak = 'PAK',
  /** Panama */
  Pan = 'PAN',
  /** Peru */
  Per = 'PER',
  /** Philippines */
  Phl = 'PHL',
  /** Palau */
  Plw = 'PLW',
  /** Papua New Guinea */
  Png = 'PNG',
  /** Poland */
  Pol = 'POL',
  /** North Korea */
  Prk = 'PRK',
  /** Portugal */
  Prt = 'PRT',
  /** Paraguay */
  Pry = 'PRY',
  /** State of Palestine */
  Pse = 'PSE',
  /** Qatar */
  Qat = 'QAT',
  /** Romania */
  Rou = 'ROU',
  /** Russia */
  Rus = 'RUS',
  /** Rwanda */
  Rwa = 'RWA',
  /** Saudi Arabia */
  Sau = 'SAU',
  /** Sudan */
  Sdn = 'SDN',
  /** Senegal */
  Sen = 'SEN',
  /** Singapore */
  Sgp = 'SGP',
  /** Solomon Islands */
  Slb = 'SLB',
  /** Sierra Leone */
  Sle = 'SLE',
  /** El Salvador */
  Slv = 'SLV',
  /** San Marino */
  Smr = 'SMR',
  /** Somalia */
  Som = 'SOM',
  /** Serbia */
  Srb = 'SRB',
  /** South Sudan */
  Ssd = 'SSD',
  /** Sao Tome & Principe */
  Stp = 'STP',
  /** Suriname */
  Sur = 'SUR',
  /** Slovakia */
  Svk = 'SVK',
  /** Slovenia */
  Svn = 'SVN',
  /** Sweden */
  Swe = 'SWE',
  /** Eswatini */
  Swz = 'SWZ',
  /** Seychelles */
  Syc = 'SYC',
  /** Syria */
  Syr = 'SYR',
  /** Chad */
  Tcd = 'TCD',
  /** Togo */
  Tgo = 'TGO',
  /** Thailand */
  Tha = 'THA',
  /** Tajikistan */
  Tjk = 'TJK',
  /** Turkmenistan */
  Tkm = 'TKM',
  /** Timor-Leste */
  Tls = 'TLS',
  /** Tonga */
  Ton = 'TON',
  /** Trinidad & Tobago */
  Tto = 'TTO',
  /** Tunisia */
  Tun = 'TUN',
  /** Turkey */
  Tur = 'TUR',
  /** Tuvalu */
  Tuv = 'TUV',
  /** Tanzania */
  Tza = 'TZA',
  /** Uganda */
  Uga = 'UGA',
  /** Ukraine */
  Ukr = 'UKR',
  /** Uruguay */
  Ury = 'URY',
  /** United States */
  Usa = 'USA',
  /** Uzbekistan */
  Uzb = 'UZB',
  /** Holy See */
  Vat = 'VAT',
  /** St. Vincent & Grenadines */
  Vct = 'VCT',
  /** Venezuela */
  Ven = 'VEN',
  /** Vietnam */
  Vnm = 'VNM',
  /** Vanuatu */
  Vut = 'VUT',
  /** Samoa */
  Wsm = 'WSM',
  /** Yemen */
  Yem = 'YEM',
  /** South Africa */
  Zaf = 'ZAF',
  /** Zambia */
  Zmb = 'ZMB',
  /** Zimbabwe */
  Zwe = 'ZWE'
}

/** An enumeration. */
export enum OrganizationMode {
  /** BigQuery */
  Bigquery = 'BIGQUERY',
  /** Default */
  Default = 'DEFAULT',
  /** SQL */
  Sql = 'SQL'
}

/** An enumeration. */
export enum OrganizationNotificationKind {
  /** Upsell */
  Upsell = 'UPSELL'
}

export type OrganizationNotificationObject = {
  readonly __typename: 'OrganizationNotificationObject';
  readonly id: Scalars['String'];
  readonly kind: OrganizationNotificationKind;
  readonly organization: Maybe<LimitedOrganizationObject>;
  readonly recipients: Scalars['String'];
  readonly sentAt: Scalars['DateTime'];
};

export type OrganizationObject = {
  readonly __typename: 'OrganizationObject';
  readonly adStudioBusinessId: Maybe<Scalars['String']>;
  readonly advisor: Maybe<Advisor>;
  readonly advisorOptInDate: Maybe<Scalars['DateTime']>;
  readonly advisorQuiz: Maybe<AdvisorQuiz>;
  readonly advisorSavedSearches: ReadonlyArray<AdvisorSavedSearchObject>;
  readonly art19Secret: Maybe<Scalars['String']>;
  readonly assets: ReadonlyArray<AssetObject>;
  readonly attribution: AttributionObject;
  readonly attributionConfig: AttributionConfigObject;
  readonly attributionCpm: Maybe<Scalars['Float']>;
  readonly billingCity: Maybe<Scalars['String']>;
  readonly billingCountry: Maybe<Scalars['String']>;
  readonly billingEmail: Maybe<Scalars['String']>;
  readonly billingInfo: BillingInfoObject;
  readonly billingLine1: Maybe<Scalars['String']>;
  readonly billingLine2: Maybe<Scalars['String']>;
  readonly billingName: Maybe<Scalars['String']>;
  readonly billingPostalCode: Maybe<Scalars['String']>;
  readonly billingRecords: ReadonlyArray<BillingRecord>;
  readonly billingState: Maybe<Scalars['String']>;
  readonly brand: Maybe<BrandObject>;
  readonly campaign: CampaignObject;
  readonly campaignEpisodes: ReadonlyArray<CampaignEpisodeObject>;
  readonly campaignSet: ReadonlyArray<CampaignObject>;
  readonly campaigns: CampaignFilterObject;
  readonly campaignsCount: Scalars['Int'];
  readonly campaignsImpressionsMax: Maybe<Scalars['Int']>;
  readonly capabilities: ReadonlyArray<CapabilityObject>;
  readonly claims: ReadonlyArray<LimitedCompanyClaimObject>;
  readonly comments: ReadonlyArray<CommentObject>;
  readonly companies: ReadonlyArray<CompanyObject>;
  readonly company: CompanyObject;
  readonly contactEmail: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly currency: OrganizationCurrency;
  readonly domains: ReadonlyArray<OrganizationDomainObject>;
  readonly downloadAlgorithm: OrganizationDownloadAlgorithm;
  readonly dynamicApprovalsReceived: ReadonlyArray<DynamicApprovalObject>;
  readonly dynamicApprovalsSent: ReadonlyArray<DynamicApprovalObject>;
  readonly dynamicProvider: Maybe<Scalars['String']>;
  readonly dynamicProviderOptions: Maybe<ReadonlyArray<Maybe<ProviderNameObject>>>;
  readonly exportInstances: ReadonlyArray<ExportInstanceObject>;
  readonly exports: ExportObject;
  readonly feedSearch: FeedSearch;
  readonly futureEpisodes: ReadonlyArray<FutureEpisodeObject>;
  readonly genericTags: ReadonlyArray<GenericTagObject>;
  readonly hasActivePixel: Scalars['Boolean'];
  readonly hasMembers: Scalars['Boolean'];
  readonly id: Scalars['String'];
  readonly invoiceDaysUntilDue: Scalars['Int'];
  readonly invoices: ReadonlyArray<InvoiceObject>;
  readonly isActive: Scalars['Boolean'];
  readonly isAdmin: Scalars['Boolean'];
  readonly isAdvisor: Scalars['Boolean'];
  readonly isController: Scalars['Boolean'];
  readonly isExperianApproved: Scalars['Boolean'];
  readonly isLockedForTerms: Scalars['Boolean'];
  readonly isLogTransfer: Scalars['Boolean'];
  readonly isManager: Scalars['Boolean'];
  readonly isNielsenApproved: Scalars['Boolean'];
  readonly isSegmentsEnabled: Scalars['Boolean'];
  readonly key: KeyObject;
  readonly keys: ReadonlyArray<KeyObject>;
  readonly kind: OrganizationKind;
  readonly knowledgeLevel: OrganizationKnowledgeLevel;
  readonly liftReport: LiftReportObject;
  readonly liftReportRequests: ReadonlyArray<LiftReportObject>;
  readonly liftReports: ReadonlyArray<LiftReportObject>;
  readonly limitedCompany: LimitedCompanyObject;
  readonly linkingRequestState: Maybe<Scalars['String']>;
  readonly linkingrequestSet: ReadonlyArray<LinkingRequestObject>;
  readonly location: OrganizationLocation;
  readonly managers: ReadonlyArray<LimitedOrganizationObject>;
  readonly managing: ReadonlyArray<LimitedOrganizationObject>;
  readonly meRole: Maybe<Scalars['String']>;
  readonly member: UserObject;
  readonly memberAccess: ReadonlyArray<UserAccessObject>;
  readonly members: ReadonlyArray<UserObject>;
  readonly memberships: ReadonlyArray<MembershipObject>;
  readonly mode: OrganizationMode;
  readonly multiBillingRecords: MultiBillingRecords;
  readonly name: Scalars['String'];
  readonly note: Maybe<Scalars['String']>;
  readonly notifications: ReadonlyArray<OrganizationNotificationObject>;
  readonly overlap: Maybe<Overlap>;
  readonly overview: Maybe<OverviewObject>;
  readonly payerOrganizations: ReadonlyArray<PayerOrganizationObject>;
  readonly pays: ReadonlyArray<CampaignObject>;
  readonly permissions: ReadonlyArray<PermissionObject>;
  readonly podcast: PodcastObject;
  readonly podcastApprovalsReceived: ReadonlyArray<PodcastApprovalObject>;
  readonly podcastApprovalsSent: ReadonlyArray<PodcastApprovalObject>;
  readonly podcasts: ReadonlyArray<PodcastObject>;
  readonly podcastsCount: Scalars['Int'];
  readonly podlinkDomain: PodlinkDomainObject;
  readonly podlinkDomains: ReadonlyArray<PodlinkDomainObject>;
  readonly productionPixel: Maybe<KeyObject>;
  readonly publisherSearch: PublisherSearch;
  readonly renewalDate: Maybe<Scalars['Date']>;
  readonly research: Maybe<ResearchObject>;
  readonly reversePermissions: ReadonlyArray<PermissionObject>;
  readonly savedExports: ReadonlyArray<SavedExportObject>;
  readonly showTerms: Scalars['Boolean'];
  readonly showTermsReminder: Scalars['Boolean'];
  readonly slug: Scalars['String'];
  readonly spotifyBrandLiftReport: SpotifyBrandLiftReportObject;
  readonly spotifyBrandLiftReports: ReadonlyArray<SpotifyBrandLiftReportObject>;
  readonly spotifyOrder: SpotifyOrderObject;
  readonly spotifyOrders: ReadonlyArray<SpotifyOrderObject>;
  readonly streamingApprovalsReceived: ReadonlyArray<StreamingApprovalObject>;
  readonly streamingApprovalsSent: ReadonlyArray<StreamingApprovalObject>;
  readonly streamingProvider: Maybe<Scalars['String']>;
  readonly streamingProviderOptions: Maybe<ReadonlyArray<Maybe<ProviderNameObject>>>;
  readonly tier: OrganizationTier;
  readonly unmappedSpotifyOrderCount: Scalars['Int'];
  readonly unmappedSpotifyOrders: UnMappedOrderPagination;
  readonly updatedAt: Scalars['DateTime'];
};


export type OrganizationObjectBillingRecordsArgs = {
  after: Scalars['String'];
  before: InputMaybe<Scalars['String']>;
  span: InputMaybe<Scalars['String']>;
};


export type OrganizationObjectCampaignArgs = {
  id: InputMaybe<Scalars['ID']>;
  slug: InputMaybe<Scalars['String']>;
};


export type OrganizationObjectCampaignEpisodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  isFuture: InputMaybe<Scalars['Boolean']>;
  isMarketing: InputMaybe<Scalars['Boolean']>;
};


export type OrganizationObjectCampaignsArgs = {
  query: InputMaybe<CampaignFilterQuery>;
};


export type OrganizationObjectCampaignsCountArgs = {
  isMarketing: InputMaybe<Scalars['Boolean']>;
};


export type OrganizationObjectCompanyArgs = {
  id: Scalars['ID'];
};


export type OrganizationObjectFeedSearchArgs = {
  limit: Scalars['Int'];
  offset: InputMaybe<Scalars['Int']>;
  publisherId: InputMaybe<Scalars['ID']>;
  query: Scalars['String'];
};


export type OrganizationObjectFutureEpisodesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
};


export type OrganizationObjectKeyArgs = {
  key: Scalars['ID'];
};


export type OrganizationObjectLiftReportArgs = {
  id: Scalars['ID'];
};


export type OrganizationObjectLimitedCompanyArgs = {
  id: Scalars['ID'];
};


export type OrganizationObjectMemberArgs = {
  membershipId: Scalars['ID'];
};


export type OrganizationObjectMemberAccessArgs = {
  membershipId: Scalars['ID'];
};


export type OrganizationObjectMultiBillingRecordsArgs = {
  after: Scalars['String'];
  before: Scalars['String'];
};


export type OrganizationObjectOverlapArgs = {
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
  key: InputMaybe<Scalars['ID']>;
};


export type OrganizationObjectPayerOrganizationsArgs = {
  companyId: InputMaybe<Scalars['String']>;
};


export type OrganizationObjectPodcastArgs = {
  campaignId: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};


export type OrganizationObjectPodcastsArgs = {
  campaignId: InputMaybe<Scalars['ID']>;
};


export type OrganizationObjectPodcastsCountArgs = {
  isMarketing: InputMaybe<Scalars['Boolean']>;
};


export type OrganizationObjectPodlinkDomainArgs = {
  slug: Scalars['String'];
};


export type OrganizationObjectPublisherSearchArgs = {
  applyFilters?: InputMaybe<Scalars['Boolean']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type OrganizationObjectSpotifyBrandLiftReportArgs = {
  id: Scalars['ID'];
};


export type OrganizationObjectSpotifyOrderArgs = {
  id: InputMaybe<Scalars['ID']>;
};


export type OrganizationObjectUnmappedSpotifyOrdersArgs = {
  limit: InputMaybe<Scalars['Int']>;
  nameSearch: InputMaybe<Scalars['String']>;
  offset: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum OrganizationTier {
  /** Bronze */
  Bronze = 'BRONZE',
  /** Gold */
  Gold = 'GOLD',
  /** Silver */
  Silver = 'SILVER'
}

export type Overlap = {
  readonly __typename: 'Overlap';
  readonly after: Maybe<Scalars['Date']>;
  readonly allowedCampaignIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly before: Maybe<Scalars['Date']>;
  readonly campaignId: Maybe<Scalars['ID']>;
  readonly key: Scalars['ID'];
  readonly organizationId: Scalars['ID'];
  readonly pairs: Maybe<ReadonlyArray<Maybe<OverlapPair>>>;
};

export type OverlapPair = {
  readonly __typename: 'OverlapPair';
  readonly baseCampaign: Maybe<CampaignObject>;
  readonly baseCampaignDynamic: Maybe<CampaignDynamicObject>;
  readonly baseCampaignDynamicId: Maybe<Scalars['ID']>;
  readonly baseCampaignId: Scalars['ID'];
  readonly baseCampaignStreaming: Maybe<CampaignStreamingObject>;
  readonly baseDownloads: Maybe<Scalars['RoundedInt']>;
  readonly baseFeed: Maybe<FeedObject>;
  readonly baseFeedId: Maybe<Scalars['ID']>;
  readonly baseReach: Maybe<Scalars['RoundedInt']>;
  readonly combined: Maybe<Scalars['RoundedInt']>;
  readonly compCampaign: Maybe<CampaignObject>;
  readonly compCampaignDynamic: Maybe<CampaignDynamicObject>;
  readonly compCampaignDynamicId: Maybe<Scalars['ID']>;
  readonly compCampaignId: Scalars['ID'];
  readonly compCampaignStreaming: Maybe<CampaignStreamingObject>;
  readonly compDownloads: Maybe<Scalars['RoundedInt']>;
  readonly compFeed: Maybe<FeedObject>;
  readonly compFeedId: Maybe<Scalars['ID']>;
  readonly compReach: Maybe<Scalars['RoundedInt']>;
  readonly overlap: Maybe<Scalars['RoundedInt']>;
};

export type OverviewObject = {
  readonly __typename: 'OverviewObject';
  readonly allowedCampaignIds: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly brand: Maybe<BrandOverviewObject>;
  readonly impressions: Maybe<ImpressionsObject>;
  readonly organizationId: Scalars['ID'];
  readonly reach: Maybe<Scalars['RoundedInt']>;
};


export type OverviewObjectBrandArgs = {
  after: Scalars['Date'];
  before: Scalars['Date'];
  interval: InputMaybe<Scalars['String']>;
  spendByImpressions: InputMaybe<Scalars['Boolean']>;
};


export type OverviewObjectImpressionsArgs = {
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
  campaignIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  publisherIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
};


export type OverviewObjectReachArgs = {
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
  campaignIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
};

export type PayerOrganizationObject = {
  readonly __typename: 'PayerOrganizationObject';
  readonly id: Maybe<Scalars['ID']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
};

/** A permission is a normalization of the AccessObject. */
export type PermissionObject = {
  readonly __typename: 'PermissionObject';
  readonly contentObjectName: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly id: Maybe<Scalars['ID']>;
  readonly name: Maybe<Scalars['String']>;
  readonly objectName: Maybe<Scalars['String']>;
  readonly organization: Maybe<LimitedOrganizationObject>;
  readonly permission: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
};

export type PixelAction = {
  readonly __typename: 'PixelAction';
  readonly action: Maybe<Scalars['String']>;
  readonly total: Maybe<Scalars['RoundedInt']>;
};

export type PixelDebug = {
  readonly __typename: 'PixelDebug';
  readonly actions: Maybe<ReadonlyArray<Maybe<PixelAction>>>;
  readonly after: Maybe<Scalars['DateTime']>;
  readonly before: Maybe<Scalars['DateTime']>;
  readonly hasData: Maybe<Scalars['Boolean']>;
  readonly historical: Maybe<ReadonlyArray<Maybe<PixelHistorical>>>;
  readonly key: Scalars['String'];
  readonly query: Maybe<PixelQuery>;
};


export type PixelDebugHistoricalArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
};


export type PixelDebugQueryArgs = {
  action: InputMaybe<Scalars['String']>;
  showMobileOnly: InputMaybe<Scalars['Boolean']>;
};

export type PixelEvent = {
  readonly __typename: 'PixelEvent';
  readonly action: Maybe<Scalars['String']>;
  readonly alias: Maybe<Scalars['String']>;
  readonly category: Maybe<Scalars['String']>;
  readonly currency: Maybe<Scalars['String']>;
  readonly discountCode: Maybe<Scalars['String']>;
  readonly eventName: Maybe<Scalars['String']>;
  readonly key: Maybe<Scalars['String']>;
  readonly lineItems: Maybe<Scalars['String']>;
  readonly newCustomer: Maybe<Scalars['String']>;
  readonly orderId: Maybe<Scalars['String']>;
  readonly pid: Maybe<Scalars['String']>;
  readonly productId: Maybe<Scalars['String']>;
  readonly productName: Maybe<Scalars['String']>;
  readonly productType: Maybe<Scalars['String']>;
  readonly productVendor: Maybe<Scalars['String']>;
  readonly quantity: Maybe<Scalars['RoundedInt']>;
  readonly referrer: Maybe<Scalars['String']>;
  readonly referrerPath: Maybe<Scalars['String']>;
  readonly sid: Maybe<Scalars['String']>;
  readonly time: Maybe<Scalars['DateTime']>;
  readonly type: Maybe<Scalars['String']>;
  readonly uid: Maybe<Scalars['String']>;
  readonly url: Maybe<Scalars['String']>;
  readonly urlDomain: Maybe<Scalars['String']>;
  readonly urlPath: Maybe<Scalars['String']>;
  readonly userAgent: Maybe<UserAgent>;
  readonly value: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum PixelEventRecordEventType {
  /** Add to Cart */
  Addtocart = 'ADDTOCART',
  /** Checkout */
  Checkout = 'CHECKOUT',
  /** Install */
  Install = 'INSTALL',
  /** Lead */
  Lead = 'LEAD',
  /** Page View */
  PageView = 'PAGE_VIEW',
  /** Product */
  Product = 'PRODUCT',
  /** Purchase */
  Purchase = 'PURCHASE'
}

/** An enumeration. */
export enum PixelEventRecordInstallation {
  /** Adjust */
  Adjust = 'ADJUST',
  /** AppsFlyer */
  Appsflyer = 'APPSFLYER',
  /** Branch */
  Branch = 'BRANCH',
  /** JavaScript */
  Javascript = 'JAVASCRIPT',
  /** Kochava */
  Kochava = 'KOCHAVA',
  /** Segment */
  Segment = 'SEGMENT'
}

export type PixelEventRecordObject = {
  readonly __typename: 'PixelEventRecordObject';
  readonly category: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly currency: Scalars['String'];
  readonly discountCode: Scalars['String'];
  readonly eventType: PixelEventRecordEventType;
  readonly id: Scalars['String'];
  readonly installation: PixelEventRecordInstallation;
  readonly key: KeyObject;
  readonly lastActivity: Maybe<Scalars['DateTime']>;
  readonly lastActivityFlag: Maybe<Scalars['String']>;
  readonly lastUpdatedBy: LimitedUserObject;
  readonly name: Maybe<Scalars['String']>;
  readonly newCustomer: Scalars['String'];
  readonly orderId: Scalars['String'];
  readonly productId: Scalars['String'];
  readonly productName: Scalars['String'];
  readonly productType: Scalars['String'];
  readonly productVendor: Scalars['String'];
  readonly quantity: Scalars['String'];
  readonly type: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
  readonly value: Scalars['String'];
  readonly variantId: Scalars['String'];
  readonly variantName: Scalars['String'];
};

export type PixelHistorical = {
  readonly __typename: 'PixelHistorical';
  readonly hour: Maybe<Scalars['DateTime']>;
  readonly img: Maybe<ReadonlyArray<Maybe<PixelHistoricalEvent>>>;
  readonly js: Maybe<ReadonlyArray<Maybe<PixelHistoricalEvent>>>;
  readonly mobile: Maybe<ReadonlyArray<Maybe<PixelHistoricalEvent>>>;
};

export type PixelHistoricalEvent = {
  readonly __typename: 'PixelHistoricalEvent';
  readonly eventCounts: Maybe<ReadonlyArray<Maybe<PixelHistoricalEventCount>>>;
  readonly name: Maybe<Scalars['String']>;
};

export type PixelHistoricalEventCount = {
  readonly __typename: 'PixelHistoricalEventCount';
  readonly name: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['RoundedInt']>;
};

export type PixelQuery = {
  readonly __typename: 'PixelQuery';
  readonly action: Maybe<Scalars['String']>;
  readonly actionsMappings: Maybe<ReadonlyArray<Maybe<ActionMapObject>>>;
  readonly count: Maybe<Scalars['RoundedInt']>;
  readonly key: Scalars['String'];
  readonly nodes: Maybe<ReadonlyArray<Maybe<PixelEvent>>>;
  readonly showMobileOnly: Maybe<Scalars['Boolean']>;
};

export type PlacementInput = {
  readonly endTime: Scalars['Float'];
  readonly id: Scalars['ID'];
  readonly startTime: Scalars['Float'];
};

export type PlacementObject = {
  readonly __typename: 'PlacementObject';
  readonly ad: AdObject;
  readonly createdAt: Scalars['DateTime'];
  readonly endTime: Scalars['Float'];
  readonly episode: EpisodeObject;
  readonly id: Scalars['String'];
  readonly proxiedEnclosure: Maybe<ProxiedEnclosureObject>;
  readonly startTime: Scalars['Float'];
  readonly updatedAt: Scalars['DateTime'];
};

export type PodcastApprovalObject = {
  readonly __typename: 'PodcastApprovalObject';
  readonly campaignPodcast: CampaignPodcastObject;
  readonly comment: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly rejectedReason: Maybe<Scalars['String']>;
  readonly requestedAt: Scalars['DateTime'];
  readonly requestedBy: Maybe<UnAuthedUserObject>;
  readonly requestedByOrganization: Maybe<ApprovalOrganization>;
  readonly requestee: Maybe<UnAuthedUserObject>;
  readonly requesteeOrganization: Maybe<ApprovalOrganization>;
  readonly state: PodcastApprovalState;
  readonly updatedAt: Scalars['DateTime'];
  readonly updatedBy: Maybe<UnAuthedUserObject>;
};

/** An enumeration. */
export enum PodcastApprovalState {
  /** Approved */
  Approved = 'APPROVED',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Requested */
  Requested = 'REQUESTED'
}

export type PodcastIdAndFeedObject = {
  readonly __typename: 'PodcastIdAndFeedObject';
  readonly feed: Maybe<FeedObject>;
  readonly id: Maybe<Scalars['ID']>;
};

export type PodcastIdObject = {
  readonly __typename: 'PodcastIdObject';
  readonly id: Maybe<Scalars['ID']>;
};

export type PodcastObject = {
  readonly __typename: 'PodcastObject';
  readonly accessSet: Maybe<ReadonlyArray<Maybe<AccessObject>>>;
  readonly campaignDynamicPodcasts: Maybe<ReadonlyArray<Maybe<CampaignDynamicPodcastObject>>>;
  readonly campaignPodcasts: Maybe<ReadonlyArray<Maybe<CampaignPodcastObject>>>;
  readonly campaignTargets: Maybe<ReadonlyArray<Maybe<CampaignTargetObject>>>;
  readonly capabilities: ReadonlyArray<CapabilityObject>;
  readonly createdAt: Scalars['DateTime'];
  readonly downloads: Maybe<DownloadsObject>;
  readonly episode: Maybe<EpisodeObject>;
  readonly feed: Maybe<FeedObject>;
  readonly feeds: Maybe<ReadonlyArray<Maybe<FeedObject>>>;
  readonly futureEpisode: Maybe<FutureEpisodeObject>;
  readonly futureEpisodeNodes: Maybe<FutureEpisodeNodes>;
  readonly futureEpisodes: Maybe<ReadonlyArray<Maybe<FutureEpisodeObject>>>;
  readonly id: Scalars['String'];
  readonly isAdvisor: Scalars['Boolean'];
  readonly isTranscriptionDisabled: Scalars['Boolean'];
  readonly maids: Maybe<MaidsObject>;
  readonly organization: Maybe<LimitedOrganizationObject>;
  readonly podlinkdomainSet: ReadonlyArray<PodlinkDomainObject>;
  readonly processingStartedAt: Maybe<Scalars['Date']>;
  readonly publisher: Maybe<PublisherObject>;
  readonly relation: PodcastRelation;
  readonly updatedAt: Scalars['DateTime'];
};


export type PodcastObjectDownloadsArgs = {
  after: InputMaybe<Scalars['String']>;
  algorithm: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  kind: InputMaybe<Scalars['String']>;
};


export type PodcastObjectEpisodeArgs = {
  id: Scalars['ID'];
};


export type PodcastObjectFutureEpisodeArgs = {
  id: Scalars['ID'];
};


export type PodcastObjectFutureEpisodeNodesArgs = {
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum PodcastRelation {
  /** Owner */
  A_0 = 'A_0',
  /** Secondary */
  A_1 = 'A_1',
  /** DAI */
  A_2 = 'A_2',
  /** Archived */
  A_3 = 'A_3'
}

export type PodlinkDomainObject = {
  readonly __typename: 'PodlinkDomainObject';
  readonly backgroundColor: Maybe<Scalars['String']>;
  readonly description: Maybe<Scalars['String']>;
  readonly favicon: Maybe<AssetObject>;
  readonly fontColor: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly image: Maybe<AssetObject>;
  readonly podcasts: Maybe<ReadonlyArray<Maybe<PodcastIdAndFeedObject>>>;
  readonly primaryColor: Maybe<Scalars['String']>;
  readonly secondaryColor: Maybe<Scalars['String']>;
  readonly slug: Scalars['String'];
  readonly title: Scalars['String'];
};

export type ProcessCampaignEpisodes = {
  readonly __typename: 'ProcessCampaignEpisodes';
  readonly created: Maybe<ReadonlyArray<Maybe<CampaignEpisodeObject>>>;
  readonly success: Scalars['Boolean'];
  readonly updated: Maybe<ReadonlyArray<Maybe<CampaignEpisodeObject>>>;
};

export type ProcessCampaignEpisodesInput = {
  readonly creates: InputMaybe<ReadonlyArray<InputMaybe<CreateCampaignEpisodeInput>>>;
  readonly organizationId: Scalars['ID'];
  readonly removes: InputMaybe<ReadonlyArray<InputMaybe<RemoveCampaignEpisodeInput>>>;
  readonly updates: InputMaybe<ReadonlyArray<InputMaybe<UpdateCampaignEpisodeInput>>>;
};

/** start processing feeds. */
export type ProcessFeed = {
  readonly __typename: 'ProcessFeed';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type ProcessFeedInput = {
  readonly episodeId: InputMaybe<Scalars['ID']>;
  readonly feedId: Scalars['ID'];
};

export type ProductObject = {
  readonly __typename: 'ProductObject';
  readonly ads: Maybe<ReadonlyArray<Maybe<AdObject>>>;
  readonly adsCount: Maybe<Scalars['Int']>;
  readonly company: Maybe<CompanyObject>;
  readonly createdAt: Scalars['DateTime'];
  readonly description: Maybe<Scalars['String']>;
  readonly discountCode: Maybe<Scalars['String']>;
  readonly episodesCount: Maybe<Scalars['Int']>;
  readonly feedsCount: Maybe<Scalars['Int']>;
  readonly id: Scalars['String'];
  readonly image: Maybe<MediaImageObject>;
  readonly name: Scalars['String'];
  readonly slug: Scalars['String'];
  readonly tags: ReadonlyArray<TagObject>;
  readonly updatedAt: Scalars['DateTime'];
  readonly url: Maybe<Scalars['String']>;
};


export type ProductObjectAdsArgs = {
  after: InputMaybe<Scalars['String']>;
  feedId: InputMaybe<Scalars['ID']>;
  limit: InputMaybe<Scalars['Int']>;
};


export type ProductObjectAdsCountArgs = {
  after: InputMaybe<Scalars['String']>;
};


export type ProductObjectEpisodesCountArgs = {
  after: InputMaybe<Scalars['String']>;
};


export type ProductObjectFeedsCountArgs = {
  after: InputMaybe<Scalars['String']>;
};

/** Used by ProductSearchQuery so that we don't leak all the things. */
export type ProductSearchObject = {
  readonly __typename: 'ProductSearchObject';
  readonly id: Maybe<Scalars['ID']>;
  readonly name: Maybe<Scalars['ID']>;
  readonly slug: Maybe<Scalars['ID']>;
};

export type ProviderNameObject = {
  readonly __typename: 'ProviderNameObject';
  readonly providerName: Maybe<Scalars['String']>;
  readonly providerNameDisplay: Maybe<Scalars['String']>;
};

export type ProxiedEnclosureObject = {
  readonly __typename: 'ProxiedEnclosureObject';
  readonly contentPath: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly differentViaProxy: Scalars['Boolean'];
  readonly enclosure: EnclosureObject;
  readonly fileSize: Maybe<Scalars['Int']>;
  readonly href: Scalars['String'];
  readonly id: Scalars['String'];
  readonly length: Maybe<Scalars['String']>;
  readonly mpegPath: Maybe<Scalars['String']>;
  readonly placements: ReadonlyArray<PlacementObject>;
  readonly proxyId: Maybe<Scalars['ID']>;
  readonly proxyName: Maybe<Scalars['String']>;
  readonly sampleRate: Maybe<Scalars['Int']>;
  readonly sourcePath: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
  readonly waveform: Maybe<Scalars['String']>;
};

export type PublishMessage = {
  readonly __typename: 'PublishMessage';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type PublishMessageInput = {
  readonly action: Scalars['String'];
  readonly attributes: InputMaybe<Scalars['String']>;
  readonly topic: Scalars['String'];
};

export type PublishSpotifyBrandLiftReport = {
  readonly __typename: 'PublishSpotifyBrandLiftReport';
  readonly success: Scalars['Boolean'];
};

export type PublishSpotifyBrandLiftReportInput = {
  readonly id: Scalars['ID'];
  readonly isHiddenFromAgency: Scalars['Boolean'];
};

export type PublisherAffinityScoreObject = {
  readonly __typename: 'PublisherAffinityScoreObject';
  readonly industry: Scalars['String'];
  readonly percentile: Scalars['Float'];
  readonly rank: Scalars['Int'];
};

export type PublisherApproveCampaign = {
  readonly __typename: 'PublisherApproveCampaign';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type PublisherApproveCampaignInput = {
  readonly campaignId: Scalars['ID'];
  readonly organizationId: Scalars['ID'];
};

export type PublisherObject = {
  readonly __typename: 'PublisherObject';
  readonly companies: Maybe<ReadonlyArray<Maybe<CompanyObject>>>;
  readonly id: Scalars['ID'];
  readonly name: Scalars['ID'];
  readonly podcasts: Maybe<ReadonlyArray<Maybe<PodcastIdAndFeedObject>>>;
  readonly slug: Scalars['ID'];
};


export type PublisherObjectCompaniesArgs = {
  after: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
};

export type PublisherOverlapObject = {
  readonly __typename: 'PublisherOverlapObject';
  readonly baseDownloads: Maybe<Scalars['RoundedInt']>;
  readonly basePublisher: Maybe<ImpressionsPublisherObject>;
  readonly basePublisherId: Maybe<Scalars['ID']>;
  readonly baseReach: Maybe<Scalars['RoundedInt']>;
  readonly combined: Maybe<Scalars['RoundedInt']>;
  readonly compDownloads: Maybe<Scalars['RoundedInt']>;
  readonly compPublisher: Maybe<ImpressionsPublisherObject>;
  readonly compPublisherId: Maybe<Scalars['ID']>;
  readonly compReach: Maybe<Scalars['RoundedInt']>;
  readonly overlap: Maybe<Scalars['RoundedInt']>;
};

export type PublisherOverviewSearchResult = {
  readonly __typename: 'PublisherOverviewSearchResult';
  readonly adsCount: Maybe<Scalars['Int']>;
  readonly episodesCount: Maybe<Scalars['Int']>;
  readonly feedsCount: Maybe<Scalars['Int']>;
  readonly id: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly slug: Maybe<Scalars['String']>;
};

export type PublisherOverviewSearchResults = {
  readonly __typename: 'PublisherOverviewSearchResults';
  readonly results: Maybe<ReadonlyArray<Maybe<PublisherOverviewSearchResult>>>;
  readonly total: Maybe<Scalars['RoundedInt']>;
};

export type PublisherRejectCampaign = {
  readonly __typename: 'PublisherRejectCampaign';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type PublisherRejectCampaignInput = {
  readonly campaignId: Scalars['ID'];
  readonly organizationId: Scalars['ID'];
  readonly publisherDenyReason: InputMaybe<Scalars['String']>;
};

export type PublisherSearch = {
  readonly __typename: 'PublisherSearch';
  readonly count: Maybe<Scalars['Int']>;
  readonly limit: Maybe<Scalars['Int']>;
  readonly offset: Maybe<Scalars['Int']>;
  readonly results: Maybe<ReadonlyArray<Maybe<PublisherSearchObject>>>;
};

/** Used by PublisherSearchQuery so that we don't leak all the things that point to company. */
export type PublisherSearchObject = {
  readonly __typename: 'PublisherSearchObject';
  readonly id: Maybe<Scalars['ID']>;
  readonly name: Maybe<Scalars['String']>;
  readonly slug: Maybe<Scalars['String']>;
};

export type Query = {
  readonly __typename: 'Query';
  readonly admin: Maybe<Admin>;
  readonly claim: Maybe<Claim>;
  readonly currencies: ReadonlyArray<Maybe<CurrencyNameObject>>;
  readonly health: Scalars['String'];
  readonly locations: ReadonlyArray<Maybe<LocationNameObject>>;
  readonly me: Maybe<UserObject>;
  readonly productSearch: Maybe<ReadonlyArray<Maybe<ProductSearchObject>>>;
  readonly userInfo: Maybe<UserInfoObject>;
};


export type QueryAdminArgs = {
  token: InputMaybe<Scalars['String']>;
};


export type QueryCurrenciesArgs = {
  currency: InputMaybe<Scalars['String']>;
  currencyDisplay: InputMaybe<Scalars['String']>;
};


export type QueryLocationsArgs = {
  location: InputMaybe<Scalars['String']>;
  locationDisplay: InputMaybe<Scalars['String']>;
};


export type QueryMeArgs = {
  apiKeyId: InputMaybe<Scalars['String']>;
  apiKeySecret: InputMaybe<Scalars['String']>;
  token: InputMaybe<Scalars['String']>;
};


export type QueryProductSearchArgs = {
  companyId: Scalars['ID'];
  query: Scalars['String'];
};

export type QueueObject = {
  readonly __typename: 'QueueObject';
  readonly length: Maybe<Scalars['Int']>;
  readonly messages: Maybe<ReadonlyArray<Maybe<MessageObject>>>;
  readonly topic: Scalars['String'];
};


export type QueueObjectMessagesArgs = {
  start: InputMaybe<Scalars['Int']>;
  stop: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum RankCategory {
  /** Arts */
  Arts = 'ARTS',
  /** Business */
  Business = 'BUSINESS',
  /** Comedy */
  Comedy = 'COMEDY',
  /** Education */
  Education = 'EDUCATION',
  /** Games & Hobbies */
  GamesHobbies = 'GAMES_HOBBIES',
  /** Government & Organizations */
  GovernmentOrganizations = 'GOVERNMENT_ORGANIZATIONS',
  /** Health */
  Health = 'HEALTH',
  /** Kids & Family */
  KidsFamily = 'KIDS_FAMILY',
  /** Music */
  Music = 'MUSIC',
  /** News & Politics */
  NewsPolitics = 'NEWS_POLITICS',
  /** Religion & Spirituality */
  ReligionSpirituality = 'RELIGION_SPIRITUALITY',
  /** Science & Medicine */
  ScienceMedicine = 'SCIENCE_MEDICINE',
  /** Society & Culture */
  SocietyCulture = 'SOCIETY_CULTURE',
  /** Sports & Recreation */
  SportsRecreation = 'SPORTS_RECREATION',
  /** Technology */
  Technology = 'TECHNOLOGY',
  /** Top 200 */
  Top_200 = 'TOP_200',
  /** TV & Film */
  TvFilm = 'TV_FILM'
}

export type RankObject = {
  readonly __typename: 'RankObject';
  readonly category: RankCategory;
  readonly createdAt: Scalars['DateTime'];
  readonly episodesCount: Scalars['Int'];
  readonly feed: Maybe<LimitedFeedObject>;
  readonly id: Scalars['ID'];
  readonly num: Scalars['Int'];
  readonly placementsCount: Scalars['Int'];
  readonly provider: RankProvider;
};

/** An enumeration. */
export enum RankProvider {
  /** Itunes */
  Itunes = 'ITUNES'
}

export type RejectAd = {
  readonly __typename: 'RejectAd';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type RejectAdInput = {
  readonly id: Scalars['ID'];
  readonly reviewDuration: InputMaybe<Scalars['Int']>;
  readonly reviewerId: InputMaybe<Scalars['ID']>;
};

export type RejectCompanyClaim = {
  readonly __typename: 'RejectCompanyClaim';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type RejectCompanyClaimInput = {
  readonly id: Scalars['ID'];
};

export type RemoveAccess = {
  readonly __typename: 'RemoveAccess';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type RemoveAccessInput = {
  readonly accessId: Scalars['ID'];
};

export type RemoveAdvisorForOrganization = {
  readonly __typename: 'RemoveAdvisorForOrganization';
  readonly organization: Maybe<OrganizationObject>;
};

export type RemoveAdvisorForOrganizationInput = {
  readonly id: Scalars['String'];
};

export type RemoveCampaignEpisode = {
  readonly __typename: 'RemoveCampaignEpisode';
  readonly success: Scalars['Boolean'];
};

export type RemoveCampaignEpisodeInput = {
  readonly id: Scalars['ID'];
};

export type RemoveDomain = {
  readonly __typename: 'RemoveDomain';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type RemoveDomainInput = {
  readonly id: Scalars['String'];
};

export type RemoveMember = {
  readonly __typename: 'RemoveMember';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type RemoveMemberInput = {
  readonly id: Scalars['String'];
};

export type RemoveTag = {
  readonly __typename: 'RemoveTag';
  readonly companyId: Maybe<Scalars['ID']>;
  readonly productId: Maybe<Scalars['ID']>;
  readonly tag: Maybe<TagObject>;
};

export type RemoveTagInput = {
  readonly companyId: InputMaybe<Scalars['ID']>;
  readonly id: Scalars['ID'];
  readonly productId: InputMaybe<Scalars['ID']>;
};

export type RequestNewBrandForSpotifyOrder = {
  readonly __typename: 'RequestNewBrandForSpotifyOrder';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type RequestNewBrandForSpotifyOrderInput = {
  readonly advertiserWebsite: InputMaybe<Scalars['String']>;
  readonly agencyName: InputMaybe<Scalars['String']>;
  readonly bookedStatus: Scalars['String'];
  readonly brandContactEmail: Scalars['String'];
  readonly brandContactFirstName: Scalars['String'];
  readonly brandContactLastName: Scalars['String'];
  readonly brandName: Scalars['String'];
  readonly campaignKind: Scalars['String'];
  readonly comments: InputMaybe<Scalars['String']>;
  readonly opportunityName: InputMaybe<Scalars['String']>;
  readonly spotifyOrderId: Scalars['ID'];
};

/** We need to seperate this data out from the organization. */
export type ResearchObject = {
  readonly __typename: 'ResearchObject';
  readonly ad: Maybe<AdObject>;
  readonly adsCount: Maybe<Scalars['Int']>;
  readonly brand: Maybe<BrandObject>;
  readonly companies: Maybe<ReadonlyArray<Maybe<CompanyObject>>>;
  readonly companiesCount: Maybe<Scalars['Int']>;
  readonly company: Maybe<CompanyObject>;
  readonly feed: Maybe<FeedObject>;
  readonly publisher: Maybe<PublisherObject>;
  readonly publishers: Maybe<ReadonlyArray<Maybe<PublisherObject>>>;
  readonly rankings: Maybe<ReadonlyArray<Maybe<RankObject>>>;
  readonly reviewer: Maybe<ReviewerObject>;
  readonly reviewers: Maybe<ReadonlyArray<Maybe<ReviewerObject>>>;
  readonly reviewing: Maybe<Reviewing>;
  readonly search: Maybe<SearchResults>;
};


/** We need to seperate this data out from the organization. */
export type ResearchObjectAdArgs = {
  id: Scalars['ID'];
};


/** We need to seperate this data out from the organization. */
export type ResearchObjectCompaniesArgs = {
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  inactiveSince: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  maxAds: InputMaybe<Scalars['Int']>;
  maxEpisodes: InputMaybe<Scalars['Int']>;
  maxPodcasts: InputMaybe<Scalars['Int']>;
  minAds: InputMaybe<Scalars['Int']>;
  minEpisodes: InputMaybe<Scalars['Int']>;
  minPodcasts: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
};


/** We need to seperate this data out from the organization. */
export type ResearchObjectCompanyArgs = {
  id: Scalars['ID'];
};


/** We need to seperate this data out from the organization. */
export type ResearchObjectFeedArgs = {
  id: Scalars['ID'];
};


/** We need to seperate this data out from the organization. */
export type ResearchObjectPublisherArgs = {
  slug: Scalars['String'];
};


/** We need to seperate this data out from the organization. */
export type ResearchObjectPublishersArgs = {
  limit: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


/** We need to seperate this data out from the organization. */
export type ResearchObjectRankingsArgs = {
  category: Scalars['String'];
  hour: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  provider: Scalars['String'];
};


/** We need to seperate this data out from the organization. */
export type ResearchObjectReviewerArgs = {
  id: InputMaybe<Scalars['ID']>;
};


/** We need to seperate this data out from the organization. */
export type ResearchObjectSearchArgs = {
  limit: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};

export type ResetContact = {
  readonly __typename: 'ResetContact';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type ResetContactInput = {
  readonly contactId: Scalars['ID'];
};

/** An enumeration. */
export enum ReviewEndState {
  /** Approved */
  Approved = 'APPROVED',
  /** Duplicate */
  Duplicate = 'DUPLICATE',
  /** edited */
  Edited = 'EDITED',
  /** Initial Review */
  Initial = 'INITIAL',
  /** Media Generated */
  Media = 'MEDIA',
  /** New */
  New = 'NEW',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Split */
  Split = 'SPLIT',
  /** Transcript Generated */
  Transcript = 'TRANSCRIPT',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

export type ReviewObject = {
  readonly __typename: 'ReviewObject';
  readonly ad: Maybe<AdObject>;
  readonly companyId: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly deltas: Maybe<Scalars['String']>;
  readonly duration: Maybe<Scalars['Int']>;
  readonly endState: ReviewEndState;
  readonly episode: Maybe<EpisodeObject>;
  readonly hasNoAds: Scalars['Boolean'];
  readonly id: Scalars['String'];
  readonly mturkAssignmentId: Maybe<Scalars['String']>;
  readonly mturkHitId: Maybe<Scalars['String']>;
  readonly productId: Maybe<Scalars['String']>;
  readonly reviewer: ReviewerObject;
  readonly sponsorId: Maybe<Scalars['String']>;
  readonly startState: ReviewStartState;
  readonly updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum ReviewStartState {
  /** Approved */
  Approved = 'APPROVED',
  /** Duplicate */
  Duplicate = 'DUPLICATE',
  /** edited */
  Edited = 'EDITED',
  /** Initial Review */
  Initial = 'INITIAL',
  /** Media Generated */
  Media = 'MEDIA',
  /** New */
  New = 'NEW',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Split */
  Split = 'SPLIT',
  /** Transcript Generated */
  Transcript = 'TRANSCRIPT',
  /** Unknown */
  Unknown = 'UNKNOWN'
}

export type ReviewerObject = {
  readonly __typename: 'ReviewerObject';
  readonly createdAt: Scalars['DateTime'];
  readonly email: Maybe<Scalars['String']>;
  readonly episodes: Maybe<ReadonlyArray<Maybe<EpisodeObject>>>;
  readonly firstName: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly lastName: Maybe<Scalars['String']>;
  readonly mturkWorkerId: Maybe<Scalars['String']>;
  readonly reviews: Maybe<ReadonlyArray<Maybe<ReviewObject>>>;
  readonly reviewsCount: Maybe<Scalars['Int']>;
  readonly superReviewer: Scalars['Boolean'];
  readonly totalClassifyCount: Maybe<Scalars['Int']>;
  readonly totalEpisodeCount: Maybe<Scalars['Int']>;
  readonly totalEpisodeMinutes: Maybe<Scalars['Int']>;
  readonly type: ReviewerType;
  readonly updatedAt: Scalars['DateTime'];
};


export type ReviewerObjectEpisodesArgs = {
  limit: InputMaybe<Scalars['Int']>;
};


export type ReviewerObjectReviewsArgs = {
  limit: InputMaybe<Scalars['Int']>;
};

/** An enumeration. */
export enum ReviewerType {
  /** Ad */
  Ad = 'AD',
  /** All */
  All = 'ALL',
  /** Disabled */
  Disabled = 'DISABLED',
  /** Episode */
  Episode = 'EPISODE',
  /** Episode & Classify */
  EpisodeClassify = 'EPISODE_CLASSIFY'
}

export type Reviewing = {
  readonly __typename: 'Reviewing';
  readonly ad: Maybe<AdObject>;
  readonly ads: Maybe<ReadonlyArray<Maybe<AdObject>>>;
  readonly adsCount: Maybe<Scalars['Int']>;
  readonly companies: Maybe<ReadonlyArray<Maybe<CompanyObject>>>;
  readonly episodeMinutesByDay: Maybe<ReadonlyArray<Maybe<EpisodeMinutesByDay>>>;
  readonly episodes: Maybe<ReadonlyArray<Maybe<EpisodeObject>>>;
  readonly sortedAds: Maybe<ReadonlyArray<Maybe<SortedAdObject>>>;
  readonly transcribable: Maybe<ReadonlyArray<Maybe<EpisodeObject>>>;
};


export type ReviewingAdArgs = {
  id: Scalars['ID'];
};


export type ReviewingAdsArgs = {
  before: InputMaybe<Scalars['String']>;
  feedId: InputMaybe<Scalars['ID']>;
  includeUnknown: InputMaybe<Scalars['Boolean']>;
  offset: InputMaybe<Scalars['Int']>;
  reviewedById: InputMaybe<Scalars['ID']>;
  state: InputMaybe<Scalars['String']>;
};


export type ReviewingAdsCountArgs = {
  feedId: InputMaybe<Scalars['ID']>;
  includeUnknown: InputMaybe<Scalars['Boolean']>;
  reviewedById: InputMaybe<Scalars['ID']>;
  state: InputMaybe<Scalars['String']>;
};


export type ReviewingEpisodeMinutesByDayArgs = {
  after: InputMaybe<Scalars['Date']>;
  reviewerId: InputMaybe<Scalars['ID']>;
};


export type ReviewingSortedAdsArgs = {
  feedId: InputMaybe<Scalars['ID']>;
  includeUnknown: InputMaybe<Scalars['Boolean']>;
  sortedBy: InputMaybe<Scalars['String']>;
};


export type ReviewingTranscribableArgs = {
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
};

export type RunLiftReport = {
  readonly __typename: 'RunLiftReport';
  readonly liftReport: Maybe<LiftReportObject>;
};

export type RunLiftReportInput = {
  readonly liftReportId: Scalars['ID'];
};

/** An enumeration. */
export enum SavedExportExportType {
  /** Admin */
  Admin = 'ADMIN',
  /** Campaign Conversions */
  CampaignConversions = 'CAMPAIGN_CONVERSIONS',
  /** Campaign Daily Overview */
  CampaignDailyOverview = 'CAMPAIGN_DAILY_OVERVIEW',
  /** Campaign Entrances */
  CampaignEntrances = 'CAMPAIGN_ENTRANCES',
  /** Campaign Episode */
  CampaignEpisode = 'CAMPAIGN_EPISODE',
  /** Campaign Impressions */
  CampaignImpressions = 'CAMPAIGN_IMPRESSIONS',
  /** Campaign Overview */
  CampaignOverview = 'CAMPAIGN_OVERVIEW',
  /** Campaign Placements */
  CampaignPlacements = 'CAMPAIGN_PLACEMENTS',
  /** Campaign Podcast */
  CampaignPodcast = 'CAMPAIGN_PODCAST',
  /** Company Placements */
  CompanyPlacements = 'COMPANY_PLACEMENTS',
  /** Episode Downloads Daily */
  EpisodeDownloadsDaily = 'EPISODE_DOWNLOADS_DAILY',
  /** Episode Downloads Hourly */
  EpisodeDownloadsHourly = 'EPISODE_DOWNLOADS_HOURLY',
  /** Episode Placements */
  EpisodePlacements = 'EPISODE_PLACEMENTS',
  /** Feed Placements */
  FeedPlacements = 'FEED_PLACEMENTS',
  /** Feed Segments */
  FeedSegments = 'FEED_SEGMENTS',
  /** Organization Benchmark Campaigns */
  OrganizationBenchmarkCampaigns = 'ORGANIZATION_BENCHMARK_CAMPAIGNS',
  /** Organization Benchmark Campaigns Detail */
  OrganizationBenchmarkCampaignsDetail = 'ORGANIZATION_BENCHMARK_CAMPAIGNS_DETAIL',
  /** Organization Daily Overview */
  OrganizationCampaignConversions = 'ORGANIZATION_CAMPAIGN_CONVERSIONS',
  /** Organization Daily Overview */
  OrganizationDailyOverview = 'ORGANIZATION_DAILY_OVERVIEW',
  /** Organization Interval Overlap */
  OrganizationIntervalOverlap = 'ORGANIZATION_INTERVAL_OVERLAP',
  /** Organization IDs */
  OrganizationListAllIds = 'ORGANIZATION_LIST_ALL_IDS',
  /** Organization Campaign IDs */
  OrganizationListCampaignIds = 'ORGANIZATION_LIST_CAMPAIGN_IDS',
  /** Organization Locations Overview */
  OrganizationLocations = 'ORGANIZATION_LOCATIONS',
  /** Organization Placements */
  OrganizationPlacements = 'ORGANIZATION_PLACEMENTS',
  /** Organization Segments */
  OrganizationSegments = 'ORGANIZATION_SEGMENTS',
  /** Organization Weekly Overview */
  OrganizationWeeklyOverview = 'ORGANIZATION_WEEKLY_OVERVIEW',
  /** Podcast Downloads Daily */
  PodcastDownloadsDaily = 'PODCAST_DOWNLOADS_DAILY',
  /** Podcast Downloads Full */
  PodcastDownloadsFull = 'PODCAST_DOWNLOADS_FULL',
  /** Podcast Downloads Hourly */
  PodcastDownloadsHourly = 'PODCAST_DOWNLOADS_HOURLY'
}

export type SavedExportObject = {
  readonly __typename: 'SavedExportObject';
  readonly archived: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: Maybe<LimitedUserObject>;
  readonly exportInstances: ReadonlyArray<ExportInstanceObject>;
  readonly exportParameters: Maybe<Scalars['JSONString']>;
  readonly exportType: SavedExportExportType;
  readonly fields: Maybe<Scalars['JSONString']>;
  readonly id: Scalars['String'];
  readonly lastExportInstance: Maybe<ExportInstanceObject>;
  readonly name: Scalars['String'];
  readonly orderBy: Maybe<Scalars['JSONString']>;
  readonly organization: Maybe<LimitedOrganizationObject>;
  readonly slug: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
  readonly updatedBy: Maybe<LimitedUserObject>;
};

export type SearchResult = {
  readonly __typename: 'SearchResult';
  readonly body: Maybe<Scalars['String']>;
  readonly duration: Maybe<Scalars['Float']>;
  readonly id: Maybe<Scalars['String']>;
  readonly imagePath: Maybe<Scalars['String']>;
  readonly kind: Maybe<Scalars['String']>;
  readonly organizations: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly published: Maybe<Scalars['RoundedInt']>;
  readonly slug: Maybe<Scalars['String']>;
  readonly subtitle: Maybe<Scalars['String']>;
  readonly title: Maybe<Scalars['String']>;
};

export type SearchResults = {
  readonly __typename: 'SearchResults';
  readonly results: Maybe<ReadonlyArray<Maybe<SearchResult>>>;
  readonly total: Maybe<Scalars['RoundedInt']>;
};

export type SendTrackingUrlsConfirmationReminder = {
  readonly __typename: 'SendTrackingUrlsConfirmationReminder';
  readonly error: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type SendTrackingUrlsConfirmationReminderInput = {
  readonly campaignId: Scalars['ID'];
  readonly publisherId: Scalars['ID'];
  readonly recipientEmail: InputMaybe<Scalars['String']>;
};

/**
 * Verifies that the email, Gets the token and sends an email
 * to verify the user is able to login to SPAA
 */
export type SendVerifyEmail = {
  readonly __typename: 'SendVerifyEmail';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type SendVerifyEmailInput = {
  readonly host: InputMaybe<Scalars['String']>;
};

export type SetAdAnalyticsTutorialProgress = {
  readonly __typename: 'SetAdAnalyticsTutorialProgress';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type SetAdAnalyticsTutorialProgressInput = {
  readonly progress: Scalars['Int'];
};

export type SetAdvisorOptions = {
  readonly __typename: 'SetAdvisorOptions';
  readonly organization: Maybe<OrganizationObject>;
};

export type SetAdvisorOptionsInput = {
  readonly capabilityIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly organizationId: Scalars['ID'];
  readonly podcastIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
};

export type SetHasSeenAdAnalyticsWelcome = {
  readonly __typename: 'SetHasSeenAdAnalyticsWelcome';
  readonly status: Maybe<Scalars['Boolean']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type SetHasSeenAdAnalyticsWelcomeInput = {
  readonly status: Scalars['Boolean'];
};

export type SignMedia = {
  readonly __typename: 'SignMedia';
  readonly id: Maybe<Scalars['String']>;
  readonly path: Maybe<Scalars['String']>;
  readonly signedUrl: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type SignMediaInput = {
  readonly contentType: Scalars['String'];
  readonly prefix: InputMaybe<Scalars['String']>;
};

export enum Significance {
  Confidence_80 = 'CONFIDENCE_80',
  Confidence_90 = 'CONFIDENCE_90',
  NotDetected = 'NOT_DETECTED'
}

export type SimpleBillingRecord = {
  readonly __typename: 'SimpleBillingRecord';
  readonly downloadDate: Maybe<Scalars['Date']>;
  readonly impressions: Maybe<Scalars['RoundedInt']>;
  readonly marketingImpressions: Maybe<Scalars['RoundedInt']>;
  readonly totalImpressions: Maybe<Scalars['RoundedInt']>;
};

export type SortedAdObject = {
  readonly __typename: 'SortedAdObject';
  readonly ad: Maybe<AdObject>;
  readonly body: Maybe<Scalars['String']>;
  readonly companyId: Maybe<Scalars['String']>;
  readonly companyName: Maybe<Scalars['String']>;
  readonly maxScore: Maybe<Scalars['Float']>;
  readonly productId: Maybe<Scalars['String']>;
  readonly productName: Maybe<Scalars['String']>;
  readonly score: Maybe<Scalars['Float']>;
  readonly text: Maybe<Scalars['String']>;
};

export type SplitAd = {
  readonly __typename: 'SplitAd';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type SplitAdInput = {
  readonly id: Scalars['ID'];
  readonly reviewDuration: InputMaybe<Scalars['Int']>;
  readonly reviewerId: InputMaybe<Scalars['ID']>;
  readonly splitSeconds: Scalars['Float'];
};

export type SpotifyAudienceObject = {
  readonly __typename: 'SpotifyAudienceObject';
  readonly clicks: Scalars['RoundedInt'];
  readonly group: Scalars['String'];
  readonly impressions: Scalars['RoundedInt'];
};

export type SpotifyBrandLiftMessageContentObject = {
  readonly __typename: 'SpotifyBrandLiftMessageContentObject';
  readonly answer1: Maybe<Scalars['String']>;
  readonly answer2: Maybe<Scalars['String']>;
  readonly answer3: Maybe<Scalars['String']>;
  readonly answer4: Maybe<Scalars['String']>;
  readonly answer5: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly languageCode: Maybe<Scalars['String']>;
  readonly question: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum SpotifyBrandLiftMessageMessageType {
  /** Ad Recall */
  AdRecall = 'AD_RECALL',
  /** Aided Brand Awareness */
  AidedBrandAwareness = 'AIDED_BRAND_AWARENESS',
  /** Attribute Rating */
  AttributeRating = 'ATTRIBUTE_RATING',
  /** Favorability */
  Favorability = 'FAVORABILITY',
  /** Message Association */
  MessageAssociation = 'MESSAGE_ASSOCIATION',
  /** Preference */
  Preference = 'PREFERENCE',
  /** Purchase Intent */
  PurchaseIntent = 'PURCHASE_INTENT',
  /** Top of Mind Awareness */
  TopOfMindAwareness = 'TOP_OF_MIND_AWARENESS'
}

export type SpotifyBrandLiftMessageObject = {
  readonly __typename: 'SpotifyBrandLiftMessageObject';
  readonly brandLiftReport: SpotifyBrandLiftReportObject;
  readonly id: Scalars['String'];
  readonly messageContents: ReadonlyArray<SpotifyBrandLiftMessageContentObject>;
  readonly messageType: SpotifyBrandLiftMessageMessageType;
  readonly messageTypeDisplay: Scalars['String'];
  readonly result: Maybe<SpotifyBrandLiftMessageResultObject>;
};


export type SpotifyBrandLiftMessageObjectMessageContentsArgs = {
  languageCode: InputMaybe<Scalars['String']>;
};

export type SpotifyBrandLiftMessageResultObject = {
  readonly __typename: 'SpotifyBrandLiftMessageResultObject';
  readonly age13To17: MessageResultGroupObject;
  readonly age18To24: MessageResultGroupObject;
  readonly age25To34: MessageResultGroupObject;
  readonly age35To44: MessageResultGroupObject;
  readonly age45Plus: MessageResultGroupObject;
  readonly controlAnswer1: Maybe<Scalars['Int']>;
  readonly controlAnswer2: Maybe<Scalars['Int']>;
  readonly controlAnswer3: Maybe<Scalars['Int']>;
  readonly controlAnswer4: Maybe<Scalars['Int']>;
  readonly controlAnswer5: Maybe<Scalars['Int']>;
  readonly exposedAnswer1: Maybe<Scalars['Int']>;
  readonly exposedAnswer2: Maybe<Scalars['Int']>;
  readonly exposedAnswer3: Maybe<Scalars['Int']>;
  readonly exposedAnswer4: Maybe<Scalars['Int']>;
  readonly exposedAnswer5: Maybe<Scalars['Int']>;
  readonly female: MessageResultGroupObject;
  readonly male: MessageResultGroupObject;
  readonly overall: MessageResultGroupObject;
  readonly totalPositive: Scalars['Int'];
  readonly totalResponses: Scalars['Int'];
};

export type SpotifyBrandLiftReportObject = {
  readonly __typename: 'SpotifyBrandLiftReportObject';
  readonly campaigns: ReadonlyArray<CampaignObject>;
  readonly clicks: Maybe<Scalars['Int']>;
  readonly endDate: Maybe<Scalars['Date']>;
  readonly frequency: Maybe<Scalars['Float']>;
  readonly id: Scalars['String'];
  readonly impressions: Maybe<Scalars['Int']>;
  readonly internalLegalStatus: Maybe<Scalars['String']>;
  readonly internalStatus: Maybe<Scalars['String']>;
  readonly isComplete: Scalars['Boolean'];
  readonly isHiddenFromAgency: Scalars['Boolean'];
  readonly isPublished: Scalars['Boolean'];
  readonly messages: ReadonlyArray<SpotifyBrandLiftMessageObject>;
  readonly name: Scalars['String'];
  readonly reach: Maybe<Scalars['Int']>;
  readonly sblSurveyGamId: Scalars['String'];
  readonly startDate: Maybe<Scalars['Date']>;
};

export type SpotifyCampaignImportRequestObject = {
  readonly __typename: 'SpotifyCampaignImportRequestObject';
  readonly advertiser: CompanyObject;
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly isEnabled: Scalars['Boolean'];
  readonly spotifyOrderId: Scalars['String'];
};

export type SpotifyOrderObject = {
  readonly __typename: 'SpotifyOrderObject';
  readonly addtocartTotal: Maybe<Scalars['Float']>;
  readonly addtocartTotalModeled: Maybe<Scalars['Float']>;
  readonly brandMappingAttempt: Maybe<CloudsenseBrandMappingAttemptObject>;
  readonly campaigns: ReadonlyArray<CampaignObject>;
  readonly checkoutTotal: Maybe<Scalars['Float']>;
  readonly checkoutTotalModeled: Maybe<Scalars['Float']>;
  readonly cost: Scalars['Float'];
  readonly createdAt: Scalars['DateTime'];
  readonly downloadTotal: Maybe<Scalars['BigInt']>;
  readonly endAt: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly installedTotal: Maybe<Scalars['Float']>;
  readonly installedTotalModeled: Maybe<Scalars['Float']>;
  readonly isMegaphone: Scalars['Boolean'];
  readonly leadTotal: Maybe<Scalars['Float']>;
  readonly leadTotalModeled: Maybe<Scalars['Float']>;
  readonly leadValue: Maybe<Scalars['Float']>;
  readonly leadValueModeled: Maybe<Scalars['Float']>;
  readonly name: Scalars['String'];
  readonly productTotal: Maybe<Scalars['Float']>;
  readonly productTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseTotal: Maybe<Scalars['Float']>;
  readonly purchaseTotalModeled: Maybe<Scalars['Float']>;
  readonly purchaseValue: Maybe<Scalars['Float']>;
  readonly purchaseValueModeled: Maybe<Scalars['Float']>;
  readonly reachTotal: Maybe<Scalars['Int']>;
  readonly slug: Scalars['String'];
  readonly startAt: Scalars['DateTime'];
  readonly updatedAt: Scalars['DateTime'];
  readonly userTotal: Maybe<Scalars['Float']>;
  readonly userTotalModeled: Maybe<Scalars['Float']>;
  readonly valueTotal: Maybe<Scalars['Float']>;
  readonly valueTotalModeled: Maybe<Scalars['Float']>;
};

export type StreamingApprovalObject = {
  readonly __typename: 'StreamingApprovalObject';
  readonly campaignStreaming: CampaignStreamingObject;
  readonly comment: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly rejectedReason: Maybe<Scalars['String']>;
  readonly requestedAt: Scalars['DateTime'];
  readonly requestedBy: Maybe<UnAuthedUserObject>;
  readonly requestedByOrganization: Maybe<ApprovalOrganization>;
  readonly requestee: Maybe<UnAuthedUserObject>;
  readonly requesteeOrganization: Maybe<ApprovalOrganization>;
  readonly state: StreamingApprovalState;
  readonly updatedAt: Scalars['DateTime'];
  readonly updatedBy: Maybe<UnAuthedUserObject>;
};

/** An enumeration. */
export enum StreamingApprovalState {
  /** Approved */
  Approved = 'APPROVED',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Requested */
  Requested = 'REQUESTED'
}

export type Subscribe = {
  readonly __typename: 'Subscribe';
  readonly channel: Maybe<Scalars['String']>;
  readonly success: Maybe<Scalars['Boolean']>;
};

export type SubscribeInput = {
  readonly campaignEpisodeId: InputMaybe<Scalars['ID']>;
  readonly campaignId: InputMaybe<Scalars['ID']>;
  readonly campaignPodcastId: InputMaybe<Scalars['ID']>;
  readonly episodeId: InputMaybe<Scalars['ID']>;
  readonly podcastId: InputMaybe<Scalars['ID']>;
};

export type SyncUserEmailWithSpotifyAccount = {
  readonly __typename: 'SyncUserEmailWithSpotifyAccount';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type TagObject = {
  readonly __typename: 'TagObject';
  readonly companySet: ReadonlyArray<CompanyObject>;
  readonly id: Scalars['String'];
  readonly label: Scalars['String'];
  readonly productSet: ReadonlyArray<ProductObject>;
  readonly slug: Scalars['String'];
};

export type TargetAcquired = {
  readonly __typename: 'TargetAcquired';
  readonly count: Maybe<Scalars['Float']>;
  readonly day: Maybe<Scalars['DateTime']>;
};

export type Topic = {
  readonly __typename: 'Topic';
  readonly classification: Maybe<Scalars['String']>;
  readonly topic: Maybe<Scalars['String']>;
};

export type UaDeviceObject = {
  readonly __typename: 'UADeviceObject';
  readonly brand: Maybe<Scalars['String']>;
  readonly family: Maybe<Scalars['String']>;
  readonly major: Maybe<Scalars['String']>;
  readonly minor: Maybe<Scalars['String']>;
  readonly model: Maybe<Scalars['String']>;
  readonly patch: Maybe<Scalars['String']>;
  readonly patchMinor: Maybe<Scalars['String']>;
};

export type UaosObject = {
  readonly __typename: 'UAOSObject';
  readonly family: Maybe<Scalars['String']>;
  readonly major: Maybe<Scalars['String']>;
  readonly minor: Maybe<Scalars['String']>;
  readonly patch: Maybe<Scalars['String']>;
  readonly patchMinor: Maybe<Scalars['String']>;
};

export type UnArchiveFeed = {
  readonly __typename: 'UnArchiveFeed';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type UnArchiveFeedInput = {
  readonly feedId: Scalars['ID'];
};

/**
 * We use a small version of the organization object otherwise we
 * expose too much to unauthed users.
 */
export type UnAuthedOrganizationObject = {
  readonly __typename: 'UnAuthedOrganizationObject';
  readonly campaigns: Maybe<ReadonlyArray<Maybe<CampaignObject>>>;
  readonly hasMembers: Maybe<Scalars['Boolean']>;
  readonly id: Maybe<Scalars['ID']>;
  readonly keys: Maybe<ReadonlyArray<Maybe<KeyObject>>>;
  readonly kind: Maybe<Scalars['String']>;
  readonly managers: Maybe<ReadonlyArray<Maybe<UnAuthedOrganizationObject>>>;
  readonly members: Maybe<ReadonlyArray<Maybe<UnAuthedUserObject>>>;
  readonly mode: Maybe<Scalars['String']>;
  readonly name: Maybe<Scalars['String']>;
  readonly slug: Maybe<Scalars['String']>;
};

export type UnAuthedUserObject = {
  readonly __typename: 'UnAuthedUserObject';
  readonly email: Maybe<Scalars['String']>;
  readonly firstName: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly lastName: Maybe<Scalars['String']>;
};

export type UnMappedOrderPagination = {
  readonly __typename: 'UnMappedOrderPagination';
  readonly limit: Maybe<Scalars['Int']>;
  readonly offset: Maybe<Scalars['Int']>;
  readonly results: Maybe<ReadonlyArray<SpotifyOrderObject>>;
  readonly total: Maybe<Scalars['Int']>;
};

export type UnhideUnmappedSpotifyOrders = {
  readonly __typename: 'UnhideUnmappedSpotifyOrders';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type UnknownAd = {
  readonly __typename: 'UnknownAd';
  readonly ad: Maybe<AdObject>;
};

export type UnknownAdInput = {
  readonly id: Scalars['ID'];
  readonly reviewDuration: InputMaybe<Scalars['Int']>;
  readonly reviewerId: InputMaybe<Scalars['ID']>;
};

export type Unsubscribe = {
  readonly __typename: 'Unsubscribe';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type UnsubscribeInput = {
  readonly channel: Scalars['String'];
};

export type UpdateActionMap = {
  readonly __typename: 'UpdateActionMap';
  readonly actionMap: Maybe<ActionMapObject>;
};

export type UpdateActionMapInput = {
  readonly action: InputMaybe<Scalars['String']>;
  readonly actionMapId: Scalars['ID'];
  readonly eventName: InputMaybe<Scalars['String']>;
};

export type UpdateAd = {
  readonly __typename: 'UpdateAd';
  readonly ad: Maybe<AdObject>;
};

export type UpdateAdInput = {
  readonly assignmentId: InputMaybe<Scalars['String']>;
  readonly companyId: InputMaybe<Scalars['ID']>;
  readonly companyName: Scalars['String'];
  readonly deltas: InputMaybe<Scalars['JSONString']>;
  readonly hitId: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly productId: InputMaybe<Scalars['ID']>;
  readonly productName: InputMaybe<Scalars['String']>;
  readonly productUrl: InputMaybe<Scalars['String']>;
  readonly reviewDuration: InputMaybe<Scalars['Int']>;
  readonly reviewerId: InputMaybe<Scalars['ID']>;
  readonly sponsorId: InputMaybe<Scalars['ID']>;
  readonly sponsorName: InputMaybe<Scalars['String']>;
  readonly workerId: InputMaybe<Scalars['String']>;
};

export type UpdateAdvisorSavedSearch = {
  readonly __typename: 'UpdateAdvisorSavedSearch';
  readonly advisorSavedSearch: Maybe<AdvisorSavedSearchObject>;
};

export type UpdateAdvisorSavedSearchInput = {
  readonly data: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly orgDefault: InputMaybe<Scalars['Boolean']>;
  readonly organizationId: InputMaybe<Scalars['ID']>;
  readonly version: Scalars['Float'];
};

export type UpdateAffinityScores = {
  readonly __typename: 'UpdateAffinityScores';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type UpdateAffinityScoresInput = {
  readonly brandsFileName: InputMaybe<Scalars['String']>;
  readonly publishersFileName: InputMaybe<Scalars['String']>;
};

export type UpdateAllowBrandEditAccess = {
  readonly __typename: 'UpdateAllowBrandEditAccess';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type UpdateAllowBrandEditAccessInput = {
  readonly campaignId: Scalars['ID'];
};

export type UpdateAttributionConfig = {
  readonly __typename: 'UpdateAttributionConfig';
  readonly attributionConfig: Maybe<AttributionConfigObject>;
};

/** Lots of rules about how to create an organization. */
export type UpdateAttributionConfigInput = {
  readonly attributionInterval: Scalars['Int'];
  readonly cableInterval: Scalars['Int'];
  readonly cellularInterval: Scalars['Int'];
  readonly corporateInterval: Scalars['Int'];
  readonly householdInterval: Scalars['Int'];
  readonly maxUsersPerHousehold: Scalars['Int'];
  readonly organizationId: Scalars['ID'];
};

export type UpdateBillingInfo = {
  readonly __typename: 'UpdateBillingInfo';
  readonly billingInfo: Maybe<BillingInfoObject>;
};

export type UpdateBillingInfoInput = {
  readonly city: InputMaybe<Scalars['String']>;
  readonly companyName: InputMaybe<Scalars['String']>;
  readonly contactEmail: InputMaybe<Scalars['String']>;
  readonly email: InputMaybe<Scalars['String']>;
  readonly firstName: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly lastName: InputMaybe<Scalars['String']>;
  readonly phoneNumber: InputMaybe<Scalars['String']>;
  readonly stateOrProvince: InputMaybe<Scalars['String']>;
  readonly streetAddress: InputMaybe<Scalars['String']>;
  readonly taxRegistrationNumber: InputMaybe<Scalars['String']>;
  readonly zipCode: InputMaybe<Scalars['String']>;
};

export type UpdateCampaign = {
  readonly __typename: 'UpdateCampaign';
  readonly campaign: Maybe<CampaignObject>;
};

export type UpdateCampaignApprovals = {
  readonly __typename: 'UpdateCampaignApprovals';
  readonly dynamicApprovals: Maybe<ReadonlyArray<Maybe<DynamicApprovalObject>>>;
  readonly podcastApprovals: Maybe<ReadonlyArray<Maybe<PodcastApprovalObject>>>;
  readonly streamingApprovals: Maybe<ReadonlyArray<Maybe<StreamingApprovalObject>>>;
  readonly success: Scalars['Boolean'];
};

export type UpdateCampaignApprovalsInput = {
  readonly campaignDynamicApprovalUpdates: InputMaybe<ReadonlyArray<InputMaybe<UpdateCampaignDynamicApprovalInput>>>;
  readonly campaignId: Scalars['ID'];
  readonly campaignPodcastApprovalUpdates: InputMaybe<ReadonlyArray<InputMaybe<UpdateCampaignPodcastApprovalInput>>>;
  readonly campaignStreamingApprovalUpdates: InputMaybe<ReadonlyArray<InputMaybe<UpdateCampaignStreamingApprovalInput>>>;
  readonly organizationId: Scalars['ID'];
};

export type UpdateCampaignBrandAgencies = {
  readonly __typename: 'UpdateCampaignBrandAgencies';
  readonly campaigns: Maybe<ReadonlyArray<Maybe<CampaignObject>>>;
  readonly success: Scalars['Boolean'];
};

export type UpdateCampaignBrandAgenciesInput = {
  readonly organizationId: Scalars['ID'];
  readonly updates: InputMaybe<ReadonlyArray<InputMaybe<UpdateCampaignBrandAgencyInput>>>;
};

export type UpdateCampaignBrandAgencyInput = {
  readonly campaignId: Scalars['String'];
  readonly enabled: Scalars['Boolean'];
  readonly organizationId: Scalars['String'];
};

export type UpdateCampaignBroadcast = {
  readonly __typename: 'UpdateCampaignBroadcast';
  readonly campaignBroadcast: Maybe<CampaignBroadcastObject>;
};

export type UpdateCampaignBroadcastInput = {
  readonly cost: InputMaybe<Scalars['Float']>;
  readonly currency: InputMaybe<Scalars['String']>;
  readonly discountCode: InputMaybe<Scalars['String']>;
  readonly discountUrl: InputMaybe<Scalars['String']>;
  readonly duration: InputMaybe<Scalars['Int']>;
  readonly effectiveUrl: InputMaybe<Scalars['String']>;
  readonly goal: InputMaybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly isBaseline: InputMaybe<Scalars['Boolean']>;
  readonly name: InputMaybe<Scalars['String']>;
};

export type UpdateCampaignDates = {
  readonly __typename: 'UpdateCampaignDates';
  readonly campaign: Maybe<CampaignObject>;
};

export type UpdateCampaignDatesInput = {
  readonly endAt: InputMaybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly startAt: InputMaybe<Scalars['DateTime']>;
};

export type UpdateCampaignDynamic = {
  readonly __typename: 'UpdateCampaignDynamic';
  readonly campaignDynamic: Maybe<CampaignDynamicObject>;
};

export type UpdateCampaignDynamicApprovalInput = {
  readonly comment: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly rejectedReason: InputMaybe<Scalars['String']>;
  readonly state: Scalars['String'];
};

export type UpdateCampaignDynamicInput = {
  readonly art19Secret: InputMaybe<Scalars['String']>;
  readonly cost: InputMaybe<Scalars['Float']>;
  readonly currency: InputMaybe<Scalars['String']>;
  readonly discountCode: InputMaybe<Scalars['String']>;
  readonly discountUrl: InputMaybe<Scalars['String']>;
  readonly duration: InputMaybe<Scalars['Int']>;
  readonly dynamicType: InputMaybe<Scalars['String']>;
  readonly effectiveUrl: InputMaybe<Scalars['String']>;
  readonly expectedEndAt: InputMaybe<Scalars['DateTime']>;
  readonly expectedStartAt: InputMaybe<Scalars['DateTime']>;
  readonly goal: InputMaybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly isBaseline: InputMaybe<Scalars['CoercedBoolean']>;
  readonly isMidRoll: InputMaybe<Scalars['CoercedBoolean']>;
  readonly isPostRoll: InputMaybe<Scalars['CoercedBoolean']>;
  readonly isPreRoll: InputMaybe<Scalars['CoercedBoolean']>;
  readonly name: InputMaybe<Scalars['String']>;
  readonly notes: InputMaybe<Scalars['String']>;
  readonly organizationId: InputMaybe<Scalars['ID']>;
  readonly providerName: InputMaybe<Scalars['String']>;
};

export type UpdateCampaignDynamicProvider = {
  readonly __typename: 'UpdateCampaignDynamicProvider';
  readonly campaign: Maybe<CampaignObject>;
};

export type UpdateCampaignDynamicProviderInput = {
  readonly id: Scalars['ID'];
  readonly providerName: InputMaybe<Scalars['String']>;
};

export type UpdateCampaignEpisode = {
  readonly __typename: 'UpdateCampaignEpisode';
  readonly campaignEpisode: Maybe<CampaignEpisodeObject>;
};

export type UpdateCampaignEpisodeInput = {
  readonly episodeId: InputMaybe<Scalars['ID']>;
  readonly futureEpisodeId: InputMaybe<Scalars['ID']>;
  readonly id: Scalars['ID'];
  readonly isBaseline: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCampaignInput = {
  readonly cost: InputMaybe<Scalars['Float']>;
  readonly currency: InputMaybe<Scalars['String']>;
  readonly endAt: InputMaybe<Scalars['DateTime']>;
  readonly expectedEndAt: InputMaybe<Scalars['DateTime']>;
  readonly expectedStartAt: InputMaybe<Scalars['DateTime']>;
  readonly goLiveDate: InputMaybe<Scalars['Date']>;
  readonly goal: InputMaybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly isHiddenFromAgency: InputMaybe<Scalars['Boolean']>;
  readonly kind: InputMaybe<Scalars['String']>;
  readonly name: InputMaybe<Scalars['String']>;
  readonly payerId: InputMaybe<Scalars['ID']>;
  readonly startAt: InputMaybe<Scalars['DateTime']>;
};

export type UpdateCampaignIsNeustar = {
  readonly __typename: 'UpdateCampaignIsNeustar';
  readonly campaign: Maybe<CampaignObject>;
};

export type UpdateCampaignIsNeustarInput = {
  readonly id: Scalars['ID'];
  readonly isNeustar: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCampaignKind = {
  readonly __typename: 'UpdateCampaignKind';
  readonly campaign: Maybe<CampaignObject>;
};

export type UpdateCampaignKindInput = {
  readonly id: Scalars['ID'];
  readonly kind: Scalars['String'];
};

export type UpdateCampaignNoise = {
  readonly __typename: 'UpdateCampaignNoise';
  readonly campaignNoise: Maybe<CampaignNoiseObject>;
};

export type UpdateCampaignNoiseInput = {
  readonly campaignNoiseId: Scalars['ID'];
  readonly endAt: Scalars['Date'];
  readonly name: InputMaybe<Scalars['String']>;
  readonly startAt: Scalars['Date'];
  readonly targetImpressions: InputMaybe<Scalars['Int']>;
  readonly usePublisherImpressions: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCampaignPodcast = {
  readonly __typename: 'UpdateCampaignPodcast';
  readonly campaignPodcast: Maybe<CampaignPodcastObject>;
};

export type UpdateCampaignPodcastApprovalInput = {
  readonly comment: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly rejectedReason: InputMaybe<Scalars['String']>;
  readonly state: Scalars['String'];
};

export type UpdateCampaignPodcastInput = {
  readonly cost: InputMaybe<Scalars['Float']>;
  readonly currency: InputMaybe<Scalars['String']>;
  readonly discountCode: InputMaybe<Scalars['String']>;
  readonly discountUrl: InputMaybe<Scalars['String']>;
  readonly duration: InputMaybe<Scalars['Int']>;
  readonly effectiveUrl: InputMaybe<Scalars['String']>;
  readonly goal: InputMaybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly isMidRoll: InputMaybe<Scalars['CoercedBoolean']>;
  readonly isPostRoll: InputMaybe<Scalars['CoercedBoolean']>;
  readonly isPreRoll: InputMaybe<Scalars['CoercedBoolean']>;
  readonly name: InputMaybe<Scalars['String']>;
  readonly notes: InputMaybe<Scalars['String']>;
  readonly organizationId: InputMaybe<Scalars['ID']>;
};

export type UpdateCampaignState = {
  readonly __typename: 'UpdateCampaignState';
  readonly campaign: Maybe<CampaignObject>;
};

export type UpdateCampaignStateInput = {
  readonly advertiserEmail: InputMaybe<Scalars['String']>;
  readonly advertiserFirstName: InputMaybe<Scalars['String']>;
  readonly advertiserLastName: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly state: InputMaybe<Scalars['String']>;
};

export type UpdateCampaignStreaming = {
  readonly __typename: 'UpdateCampaignStreaming';
  readonly campaignStreaming: Maybe<CampaignStreamingObject>;
};

export type UpdateCampaignStreamingApprovalInput = {
  readonly comment: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly rejectedReason: InputMaybe<Scalars['String']>;
  readonly state: Scalars['String'];
};

export type UpdateCampaignStreamingInput = {
  readonly cost: InputMaybe<Scalars['Float']>;
  readonly currency: InputMaybe<Scalars['String']>;
  readonly discountCode: InputMaybe<Scalars['String']>;
  readonly discountUrl: InputMaybe<Scalars['String']>;
  readonly duration: InputMaybe<Scalars['Int']>;
  readonly effectiveUrl: InputMaybe<Scalars['String']>;
  readonly goal: InputMaybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly isBaseline: InputMaybe<Scalars['CoercedBoolean']>;
  readonly name: InputMaybe<Scalars['String']>;
  readonly notes: InputMaybe<Scalars['String']>;
  readonly organizationId: InputMaybe<Scalars['ID']>;
  readonly providerName: InputMaybe<Scalars['String']>;
};

export type UpdateCampaignStreamingProvider = {
  readonly __typename: 'UpdateCampaignStreamingProvider';
  readonly campaign: Maybe<CampaignObject>;
};

export type UpdateCampaignStreamingProviderInput = {
  readonly id: Scalars['ID'];
  readonly providerName: InputMaybe<Scalars['String']>;
};

export type UpdateComment = {
  readonly __typename: 'UpdateComment';
  readonly comment: Maybe<CommentObject>;
};

export type UpdateCommentInput = {
  readonly commentId: Scalars['ID'];
  readonly text: Scalars['String'];
};

export type UpdateCompany = {
  readonly __typename: 'UpdateCompany';
  readonly company: Maybe<CompanyObject>;
};

export type UpdateCompanyArchive = {
  readonly __typename: 'UpdateCompanyArchive';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type UpdateCompanyArchiveInput = {
  readonly id: Scalars['ID'];
};

export type UpdateCompanyIndustry = {
  readonly __typename: 'UpdateCompanyIndustry';
  readonly company: Maybe<CompanyObject>;
};

export type UpdateCompanyIndustryInput = {
  readonly id: Scalars['ID'];
  readonly industry: Scalars['String'];
};

export type UpdateCompanyInput = {
  readonly description: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly imageId: InputMaybe<Scalars['ID']>;
  readonly industry: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly organizationId: InputMaybe<Scalars['ID']>;
  readonly slug: Scalars['String'];
  readonly url: InputMaybe<Scalars['String']>;
};

export type UpdateConversionUrl = {
  readonly __typename: 'UpdateConversionURL';
  readonly conversionUrl: Maybe<ConversionUrlObject>;
};

export type UpdateConversionUrlInput = {
  readonly action: Scalars['String'];
  readonly category: InputMaybe<Scalars['String']>;
  readonly conversionUrlId: Scalars['ID'];
  readonly type: InputMaybe<Scalars['String']>;
  readonly url: Scalars['String'];
  readonly value: InputMaybe<Scalars['Float']>;
};

export type UpdateEpisodeAdspottingModelVersion = {
  readonly __typename: 'UpdateEpisodeAdspottingModelVersion';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type UpdateEpisodeAdspottingModelVersionInput = {
  readonly episodeId: Scalars['ID'];
  readonly modelVersion: Scalars['String'];
};

export type UpdateEpisodeAsrStatus = {
  readonly __typename: 'UpdateEpisodeAsrStatus';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type UpdateEpisodeAsrStatusInput = {
  readonly episodeId: Scalars['ID'];
  readonly state: Scalars['Int'];
  readonly status: Scalars['String'];
};

export type UpdateFeedContactEmail = {
  readonly __typename: 'UpdateFeedContactEmail';
  readonly feed: Maybe<FeedObject>;
  readonly success: Scalars['Boolean'];
};

export type UpdateFeedContactEmailInput = {
  readonly contactEmail: Scalars['String'];
  readonly feedId: Scalars['ID'];
  readonly organizationId: Scalars['ID'];
};

/** Force an update of all the attributes on the feeds. */
export type UpdateFeeds = {
  readonly __typename: 'UpdateFeeds';
  readonly feeds: Maybe<ReadonlyArray<Maybe<FeedObject>>>;
};

export type UpdateFeedsInput = {
  readonly feedIds: ReadonlyArray<InputMaybe<Scalars['ID']>>;
};

export type UpdateGenericTag = {
  readonly __typename: 'UpdateGenericTag';
  readonly genericTag: Maybe<GenericTagObject>;
};

export type UpdateGenericTagInput = {
  readonly color: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly title: InputMaybe<Scalars['String']>;
};

export type UpdateInvoice = {
  readonly __typename: 'UpdateInvoice';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type UpdateInvoiceInput = {
  readonly due: InputMaybe<Scalars['String']>;
  readonly invoiceId: Scalars['ID'];
  readonly paid: InputMaybe<Scalars['String']>;
  readonly sent: InputMaybe<Scalars['String']>;
};

export type UpdateIsController = {
  readonly __typename: 'UpdateIsController';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type UpdateIsControllerInput = {
  readonly isController: Scalars['Boolean'];
  readonly orgId: Scalars['ID'];
};

export type UpdateKey = {
  readonly __typename: 'UpdateKey';
  readonly key: Maybe<KeyObject>;
};

export type UpdateKeyInput = {
  readonly alias: InputMaybe<Scalars['String']>;
  readonly domain: InputMaybe<Scalars['String']>;
  readonly installations: InputMaybe<Scalars['String']>;
  readonly key: Scalars['ID'];
};

export type UpdateLiftReport = {
  readonly __typename: 'UpdateLiftReport';
  readonly liftReport: Maybe<LiftReportObject>;
};

export type UpdateLiftReportInput = {
  readonly clampUrl: InputMaybe<Scalars['String']>;
  readonly delta: InputMaybe<Scalars['Int']>;
  readonly impressionsEndAt: InputMaybe<Scalars['Date']>;
  readonly impressionsStartAt: InputMaybe<Scalars['Date']>;
  readonly liftReportId: Scalars['ID'];
  readonly name: InputMaybe<Scalars['String']>;
  readonly state: InputMaybe<Scalars['String']>;
  readonly useNoise: InputMaybe<Scalars['Boolean']>;
};

export type UpdateLinkingRequest = {
  readonly __typename: 'UpdateLinkingRequest';
  readonly requests: Maybe<ReadonlyArray<Maybe<LinkingRequestObject>>>;
};

export type UpdateLinkingRequestInput = {
  readonly linkingRequestIds: ReadonlyArray<InputMaybe<Scalars['String']>>;
  readonly state: Scalars['String'];
};

export type UpdateMember = {
  readonly __typename: 'UpdateMember';
  readonly membership: Maybe<MembershipObject>;
};

export type UpdateMemberInput = {
  readonly firstName: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly lastName: InputMaybe<Scalars['String']>;
  readonly role: Scalars['String'];
};

export type UpdateOrganization = {
  readonly __typename: 'UpdateOrganization';
  readonly organization: Maybe<OrganizationObject>;
};

export type UpdateOrganizationInput = {
  readonly attributionCpm: InputMaybe<Scalars['Float']>;
  readonly billingEmail: InputMaybe<Scalars['String']>;
  readonly currency: InputMaybe<Scalars['String']>;
  readonly dynamicProvider: InputMaybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly invoiceDaysUntilDue: InputMaybe<Scalars['Int']>;
  readonly isAdvisor: InputMaybe<Scalars['Boolean']>;
  readonly isExperianApproved: InputMaybe<Scalars['Boolean']>;
  readonly isNielsenApproved: InputMaybe<Scalars['Boolean']>;
  readonly isSegmentsEnabled: InputMaybe<Scalars['Boolean']>;
  readonly kind: InputMaybe<Scalars['String']>;
  readonly knowledgeLevel: InputMaybe<Scalars['String']>;
  readonly location: InputMaybe<Scalars['String']>;
  readonly name: InputMaybe<Scalars['String']>;
  readonly note: InputMaybe<Scalars['String']>;
  readonly streamingProvider: InputMaybe<Scalars['String']>;
  readonly tier: InputMaybe<Scalars['String']>;
};

export type UpdatePixelEventRecord = {
  readonly __typename: 'UpdatePixelEventRecord';
  readonly pixelEventRecord: Maybe<PixelEventRecordObject>;
};

export type UpdatePixelEventRecordInput = {
  readonly category: InputMaybe<Scalars['String']>;
  readonly currency: InputMaybe<Scalars['String']>;
  readonly discountCode: InputMaybe<Scalars['String']>;
  readonly eventType: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly installation: InputMaybe<Scalars['String']>;
  readonly name: InputMaybe<Scalars['String']>;
  readonly newCustomer: InputMaybe<Scalars['String']>;
  readonly orderId: InputMaybe<Scalars['String']>;
  readonly productId: InputMaybe<Scalars['String']>;
  readonly productName: InputMaybe<Scalars['String']>;
  readonly productType: InputMaybe<Scalars['String']>;
  readonly productVendor: InputMaybe<Scalars['String']>;
  readonly quantity: InputMaybe<Scalars['String']>;
  readonly type: InputMaybe<Scalars['String']>;
  readonly value: InputMaybe<Scalars['String']>;
  readonly variantId: InputMaybe<Scalars['String']>;
  readonly variantName: InputMaybe<Scalars['String']>;
};

export type UpdatePodlinkDomain = {
  readonly __typename: 'UpdatePodlinkDomain';
  readonly podlinkDomain: Maybe<PodlinkDomainObject>;
};

export type UpdatePodlinkDomainInput = {
  readonly description: InputMaybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly organizationId: Scalars['ID'];
  readonly podcastIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  readonly slug: Scalars['ID'];
  readonly title: InputMaybe<Scalars['String']>;
};

/** We do this serverside to send special headers. */
export type UpdatePodlinkPodcast = {
  readonly __typename: 'UpdatePodlinkPodcast';
  readonly success: Maybe<Scalars['Boolean']>;
};

export type UpdatePodlinkPodcastInput = {
  readonly backgroundColor: Scalars['String'];
  readonly fontColor: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly podcastId: Scalars['ID'];
  readonly primaryColor: Scalars['String'];
  readonly secondaryColor: Scalars['String'];
  readonly slug: Scalars['String'];
};

export type UpdateSavedExport = {
  readonly __typename: 'UpdateSavedExport';
  readonly savedExport: Maybe<SavedExportObject>;
  readonly success: Scalars['Boolean'];
};

export type UpdateSavedExportInput = {
  readonly exportParameters: InputMaybe<ExportInstanceParameters>;
  readonly exportType: InputMaybe<Scalars['String']>;
  readonly fields: InputMaybe<ReadonlyArray<InputMaybe<FieldsInputObject>>>;
  readonly id: Scalars['ID'];
  readonly name: InputMaybe<Scalars['String']>;
  readonly orderBy: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>>>;
  readonly slug: InputMaybe<Scalars['String']>;
};

export type UpsertPlacements = {
  readonly __typename: 'UpsertPlacements';
  readonly placements: Maybe<ReadonlyArray<Maybe<PlacementObject>>>;
};

export type UpsertPlacementsInput = {
  readonly assignmentId: InputMaybe<Scalars['String']>;
  readonly episodeId: Scalars['ID'];
  readonly hitId: InputMaybe<Scalars['String']>;
  readonly placements: ReadonlyArray<InputMaybe<PlacementInput>>;
  readonly proxiedEnclosureId: InputMaybe<Scalars['ID']>;
  readonly reviewDuration: InputMaybe<Scalars['Int']>;
  readonly reviewerId: InputMaybe<Scalars['ID']>;
  readonly workerId: InputMaybe<Scalars['String']>;
};

export type UserAccessObject = {
  readonly __typename: 'UserAccessObject';
  readonly appLabel: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly model: Maybe<Scalars['String']>;
  readonly objectPk: Scalars['String'];
  readonly permission: Maybe<Scalars['String']>;
  readonly permissionDisplay: Maybe<Scalars['String']>;
  readonly user: LimitedUserObject;
};

export type UserAgent = {
  readonly __typename: 'UserAgent';
  readonly device: Maybe<UaDeviceObject>;
  readonly os: Maybe<UaosObject>;
  readonly userAgent: Scalars['String'];
  readonly value: Maybe<Scalars['String']>;
};

export type UserInfoObject = {
  readonly __typename: 'UserInfoObject';
  readonly email: Maybe<Scalars['String']>;
  readonly hasSpaaUser: Maybe<Scalars['Boolean']>;
  readonly hasVerifiedEmailForSpaa: Maybe<Scalars['Boolean']>;
};

export type UserObject = {
  readonly __typename: 'UserObject';
  readonly adAnalyticsTutorialProgress: Scalars['Int'];
  readonly agencySearch: ReadonlyArray<AgencySearchObject>;
  readonly benchmarkReport: Maybe<BenchmarkReportObject>;
  readonly campaignDynamicsDelivered: Maybe<ReadonlyArray<Maybe<CampaignDynamicDeliveryObject>>>;
  readonly campaignStreamingsDelivered: Maybe<ReadonlyArray<Maybe<CampaignStreamingDeliveryObject>>>;
  readonly claims: ReadonlyArray<CompanyClaimObject>;
  readonly comments: ReadonlyArray<CommentObject>;
  readonly companySearch: ReadonlyArray<CompanySearchObject>;
  readonly contactsContacted: ReadonlyArray<ContactObject>;
  readonly contactsIgnored: ReadonlyArray<ContactObject>;
  readonly createdAt: Scalars['DateTime'];
  readonly createdGenericTagRelationships: ReadonlyArray<GenericTagRelationshipObject>;
  readonly createdGenericTags: ReadonlyArray<GenericTagObject>;
  readonly dynamicApprovals: ReadonlyArray<DynamicApprovalObject>;
  readonly email: Scalars['String'];
  readonly emailHash: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly fullName: Scalars['String'];
  readonly hasSeenAdAnalyticsWelcome: Scalars['Boolean'];
  readonly hasVerifiedEmailForSpaa: Scalars['Boolean'];
  readonly id: Scalars['String'];
  readonly industries: ReadonlyArray<IndustryObject>;
  readonly isActive: Scalars['Boolean'];
  readonly isAdmin: Scalars['Boolean'];
  readonly isServiceAccount: Scalars['Boolean'];
  readonly lastLogin: Maybe<Scalars['DateTime']>;
  readonly lastName: Scalars['String'];
  readonly liftReportRequests: Maybe<ReadonlyArray<Maybe<LiftReportObject>>>;
  readonly linkingRequests: Maybe<ReadonlyArray<Maybe<LinkingRequestObject>>>;
  readonly machineLearning: Maybe<MachineLearningObject>;
  readonly memberships: ReadonlyArray<MembershipObject>;
  readonly organization: OrganizationObject;
  readonly organizations: ReadonlyArray<OrganizationObject>;
  readonly pixel: Maybe<KeyObject>;
  readonly podcastApprovals: ReadonlyArray<PodcastApprovalObject>;
  readonly reviewer: Maybe<ReviewerObject>;
  readonly spotifyUserId: Scalars['String'];
  readonly streamingApprovals: ReadonlyArray<StreamingApprovalObject>;
  readonly updatedAt: Scalars['DateTime'];
  readonly useraccessSet: ReadonlyArray<UserAccessObject>;
};


export type UserObjectAgencySearchArgs = {
  query: Scalars['String'];
};


export type UserObjectBenchmarkReportArgs = {
  quarter: InputMaybe<Scalars['String']>;
};


export type UserObjectCompanySearchArgs = {
  query: Scalars['String'];
  requireActivePixel: InputMaybe<Scalars['Boolean']>;
  requireOrganization: InputMaybe<Scalars['Boolean']>;
};


export type UserObjectDynamicApprovalsArgs = {
  campaignId: InputMaybe<Scalars['ID']>;
  state: InputMaybe<Scalars['String']>;
};


export type UserObjectLinkingRequestsArgs = {
  state: InputMaybe<Scalars['String']>;
};


export type UserObjectOrganizationArgs = {
  id: InputMaybe<Scalars['ID']>;
  slug: InputMaybe<Scalars['String']>;
};


export type UserObjectOrganizationsArgs = {
  ids: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>>>;
  service: InputMaybe<Scalars['String']>;
};


export type UserObjectPixelArgs = {
  id: Scalars['ID'];
};


export type UserObjectPodcastApprovalsArgs = {
  campaignId: InputMaybe<Scalars['ID']>;
  state: InputMaybe<Scalars['String']>;
};


export type UserObjectStreamingApprovalsArgs = {
  campaignId: InputMaybe<Scalars['ID']>;
  state: InputMaybe<Scalars['String']>;
};

export type RejectAdMutationVariables = Exact<{
  input: RejectAdInput;
}>;


export type RejectAdMutation = { readonly __typename: 'Mutation', readonly rejectAd: { readonly __typename: 'RejectAd', readonly success: boolean | null } | null };

export type SplitAdMutationVariables = Exact<{
  input: SplitAdInput;
}>;


export type SplitAdMutation = { readonly __typename: 'Mutation', readonly splitAd: { readonly __typename: 'SplitAd', readonly success: boolean | null } | null };

export type UnknownAdMutationVariables = Exact<{
  input: UnknownAdInput;
}>;


export type UnknownAdMutation = { readonly __typename: 'Mutation', readonly unknownAd: { readonly __typename: 'UnknownAd', readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly createdAt: any } | null } | null };

export type UpdateAdMutationVariables = Exact<{
  input: UpdateAdInput;
}>;


export type UpdateAdMutation = { readonly __typename: 'Mutation', readonly updateAd: { readonly __typename: 'UpdateAd', readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly createdAt: any } | null } | null };

export type GetAllAdvisorQuizColumnGroupsQueryVariables = Exact<{
  orgId: Scalars['ID'];
  query: InputMaybe<Scalars['String']>;
  brandId: InputMaybe<Scalars['ID']>;
}>;


export type GetAllAdvisorQuizColumnGroupsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisorQuiz: { readonly __typename: 'AdvisorQuiz', readonly columnGroups: { readonly __typename: 'AdvisorColumnGroups', readonly general: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly brands: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly clearbit: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly contentMaturity: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly experian: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly feedGrowth: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly industries: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly nielsen: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly overlap: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly publishers: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly radioMarkets: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly tags: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null } | null } | null } } | null };

export type GetAdvisorQuizBrandsQueryVariables = Exact<{
  orgId: Scalars['ID'];
  query: InputMaybe<Scalars['String']>;
  brandId: InputMaybe<Scalars['ID']>;
}>;


export type GetAdvisorQuizBrandsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisorQuiz: { readonly __typename: 'AdvisorQuiz', readonly columnGroups: { readonly __typename: 'AdvisorColumnGroups', readonly brands: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null } | null } | null } } | null };

export type GetAdvisorQuizColumnsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  ids: ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type GetAdvisorQuizColumnsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisorQuiz: { readonly __typename: 'AdvisorQuiz', readonly columnGroups: { readonly __typename: 'AdvisorColumnGroups', readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null } | null } } | null };

export type GetAdvisorQuizNielsenInterestsQueryVariables = Exact<{
  orgId: Scalars['ID'];
  query: InputMaybe<Scalars['String']>;
  nielsenId: InputMaybe<Scalars['ID']>;
}>;


export type GetAdvisorQuizNielsenInterestsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisorQuiz: { readonly __typename: 'AdvisorQuiz', readonly columnGroups: { readonly __typename: 'AdvisorColumnGroups', readonly nielsen: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null } | null } | null } } | null };

export type GetAdvisorQuizRadioMarketsQueryVariables = Exact<{
  orgId: Scalars['ID'];
  query: InputMaybe<Scalars['String']>;
  radioMarketId: InputMaybe<Scalars['ID']>;
}>;


export type GetAdvisorQuizRadioMarketsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisorQuiz: { readonly __typename: 'AdvisorQuiz', readonly columnGroups: { readonly __typename: 'AdvisorColumnGroups', readonly radioMarkets: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null } | null } | null } } | null };

export type GetAdvisorQuizTagsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  query: InputMaybe<Scalars['String']>;
  tagId: InputMaybe<Scalars['ID']>;
}>;


export type GetAdvisorQuizTagsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisorQuiz: { readonly __typename: 'AdvisorQuiz', readonly columnGroups: { readonly __typename: 'AdvisorColumnGroups', readonly tags: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null } | null } | null } } | null };

export type CompletePlacementsMutationVariables = Exact<{
  input: CompletePlacementsInput;
}>;


export type CompletePlacementsMutation = { readonly __typename: 'Mutation', readonly completePlacements: { readonly __typename: 'CompletePlacements', readonly success: boolean | null } | null };

export type NoPlacementsMutationVariables = Exact<{
  input: NoPlacementsInput;
}>;


export type NoPlacementsMutation = { readonly __typename: 'Mutation', readonly noPlacements: { readonly __typename: 'NoPlacements', readonly success: boolean | null } | null };

export type UpsertPlacementsMutationVariables = Exact<{
  input: UpsertPlacementsInput;
}>;


export type UpsertPlacementsMutation = { readonly __typename: 'Mutation', readonly upsertPlacements: { readonly __typename: 'UpsertPlacements', readonly placements: ReadonlyArray<{ readonly __typename: 'PlacementObject', readonly id: string, readonly createdAt: any } | null> | null } | null };

export type AddAccessMutationVariables = Exact<{
  input: AddAccessInput;
}>;


export type AddAccessMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly addAccess: { readonly __typename: 'AddAccess', readonly access: { readonly __typename: 'AccessObject', readonly id: string, readonly name: string, readonly permission: string, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null, readonly kind: string | null } } | null } | null };

export type AddArt19SecretMutationVariables = Exact<{
  input: AddArt19SecretInput;
}>;


export type AddArt19SecretMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly addArt19Secret: { readonly __typename: 'AddArt19Secret', readonly art19Secret: string | null } | null };

export type AddMemberMutationVariables = Exact<{
  input: AddMemberInput;
}>;


export type AddMemberMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly addMember: { readonly __typename: 'AddMember', readonly organizationId: string | null, readonly membership: { readonly __typename: 'MembershipObject', readonly id: string, readonly role: string | null, readonly roleDisplay: string | null, readonly createdAt: any, readonly user: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string } | null } | null } | null };

export type CheckCampaignPodcastPrefixMutationVariables = Exact<{
  input: CheckCampaignPodcastPrefixInput;
}>;


export type CheckCampaignPodcastPrefixMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly checkCampaignPodcastPrefix: { readonly __typename: 'CheckCampaignPodcastPrefix', readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly name: string | null, readonly isDynamic: boolean, readonly drops: number | null, readonly campaignEpisodesCount: number | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly hasPodsightsPrefix: boolean, readonly createdAt: any, readonly updatedAt: any, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly href: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null } | null } | null };

export type ClaimAddPodcastMutationVariables = Exact<{
  input: ClaimAddPodcastInput;
}>;


export type ClaimAddPodcastMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly claimAddPodcast: { readonly __typename: 'ClaimAddPodcast', readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly slug: string } | null } | null };

export type ClaimFeedMutationVariables = Exact<{
  input: ClaimFeedInput;
}>;


export type ClaimFeedMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly claimFeed: { readonly __typename: 'ClaimFeed', readonly publisher: { readonly __typename: 'ClaimPublisherObject', readonly name: string | null, readonly email: string | null } | null } | null };

export type ContactPublisherMutationVariables = Exact<{
  input: ContactPublisherInput;
}>;


export type ContactPublisherMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly contactPublisher: { readonly __typename: 'ContactPublisher', readonly success: boolean | null } | null };

export type CreateActionMapMutationVariables = Exact<{
  input: CreateActionMapInput;
}>;


export type CreateActionMapMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createActionMap: { readonly __typename: 'CreateActionMap', readonly actionMap: { readonly __typename: 'ActionMapObject', readonly id: string, readonly eventName: string, readonly action: string | null } | null } | null };

export type CreateAdvisorSavedSearchMutationVariables = Exact<{
  input: CreateAdvisorSavedSearchInput;
}>;


export type CreateAdvisorSavedSearchMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createAdvisorSavedSearch: { readonly __typename: 'CreateAdvisorSavedSearch', readonly advisorSavedSearch: { readonly __typename: 'AdvisorSavedSearchObject', readonly id: string } | null } | null };

export type CreateBrandInvitesMutationVariables = Exact<{
  input: CreateBrandInvitesInput;
}>;


export type CreateBrandInvitesMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createBrandInvites: { readonly __typename: 'CreateBrandInvites', readonly success: boolean | null, readonly organizationId: string | null } | null };

export type CreateCampaignApprovalsMutationVariables = Exact<{
  input: CreateCampaignApprovalsInput;
}>;


export type CreateCampaignApprovalsMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createCampaignApprovals: { readonly __typename: 'CreateCampaignApprovals', readonly dynamicApprovals: ReadonlyArray<{ readonly __typename: 'DynamicApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: DynamicApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null } | null> | null, readonly podcastApprovals: ReadonlyArray<{ readonly __typename: 'PodcastApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: PodcastApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null } | null> | null, readonly streamingApprovals: ReadonlyArray<{ readonly __typename: 'StreamingApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: StreamingApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignStreaming: { readonly __typename: 'CampaignStreamingObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null } | null> | null } | null };

export type CreateCampaignLinkMutationVariables = Exact<{
  input: CreateCampaignLinkInput;
}>;


export type CreateCampaignLinkMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createCampaignLink: { readonly __typename: 'CreateCampaignLink', readonly campaignLink: { readonly __typename: 'CampaignLinkObject', readonly id: string, readonly name: string | null, readonly viewTotal: number | null, readonly clickTotal: number | null, readonly targetReachTotal: number | null, readonly targetDownloadTotal: number | null, readonly createdAt: any } | null } | null };

export type CreateCampaignNoiseMutationVariables = Exact<{
  input: CreateCampaignNoiseInput;
}>;


export type CreateCampaignNoiseMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createCampaignNoise: { readonly __typename: 'CreateCampaignNoise', readonly campaignNoise: { readonly __typename: 'CampaignNoiseObject', readonly id: string, readonly name: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly targetImpressions: number | null, readonly usePublisherImpressions: boolean } | null } | null };

export type CreateCampaignPodcastMutationVariables = Exact<{
  input: CreateCampaignPodcastInput;
}>;


export type CreateCampaignPodcastMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createCampaignPodcast: { readonly __typename: 'CreateCampaignPodcast', readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly name: string | null, readonly isDynamic: boolean, readonly drops: number | null, readonly campaignEpisodesCount: number | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly hasPodsightsPrefix: boolean, readonly createdAt: any, readonly updatedAt: any, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly href: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null } | null } | null };

export type CreateCampaignStreamingMutationVariables = Exact<{
  input: CreateCampaignStreamingInput;
}>;


export type CreateCampaignStreamingMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createCampaignStreaming: { readonly __typename: 'CreateCampaignStreaming', readonly campaignStreaming: { readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly name: string, readonly isActive: boolean, readonly source: CampaignStreamingSource, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly verifiedReach: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly providerName: CampaignStreamingProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignStreamingStreams: ReadonlyArray<{ readonly __typename: 'CampaignStreamingStreamObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null }> } | null } | null };

export type CreateCampaignTargetMutationVariables = Exact<{
  input: CreateCampaignTargetInput;
}>;


export type CreateCampaignTargetMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createCampaignTarget: { readonly __typename: 'CreateCampaignTarget', readonly campaignTarget: { readonly __typename: 'CampaignTargetObject', readonly id: string, readonly reachTotal: number | null, readonly downloadTotal: number | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly href: string, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null, readonly src: string | null } | null } } | null } | null };

export type CreateConversionUrlMutationVariables = Exact<{
  input: CreateConversionUrlInput;
}>;


export type CreateConversionUrlMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createConversionUrl: { readonly __typename: 'CreateConversionURL', readonly conversionUrl: { readonly __typename: 'ConversionURLObject', readonly id: string, readonly url: string, readonly value: number | null, readonly action: string | null, readonly type: string | null, readonly category: string | null } | null } | null };

export type CreateFutureEpisodeMutationVariables = Exact<{
  input: CreateFutureEpisodeInput;
}>;


export type CreateFutureEpisodeMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createFutureEpisode: { readonly __typename: 'CreateFutureEpisode', readonly organizationId: string, readonly podcastId: string, readonly futureEpisode: { readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly expectedPublished: any, readonly createdAt: any, readonly campaignEpisodes: ReadonlyArray<{ readonly __typename: 'CampaignEpisodeObject', readonly id: string, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string } } | null> | null } | null } | null };

export type CreateGenericTagMutationVariables = Exact<{
  input: CreateGenericTagInput;
}>;


export type CreateGenericTagMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createGenericTag: { readonly __typename: 'CreateGenericTag', readonly genericTag: { readonly __typename: 'GenericTagObject', readonly id: string, readonly title: string, readonly color: string, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null } | null } | null } | null };

export type CreateGenericTagRelationshipMutationVariables = Exact<{
  input: CreateGenericTagRelationshipInput;
}>;


export type CreateGenericTagRelationshipMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createGenericTagRelationship: { readonly __typename: 'CreateGenericTagRelationship', readonly genericTagRelationship: { readonly __typename: 'GenericTagRelationshipObject', readonly id: string, readonly objectPk: string, readonly genericTag: { readonly __typename: 'GenericTagObject', readonly id: string } } | null } | null };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createOrganization: { readonly __typename: 'CreateOrganization', readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string, readonly slug: string, readonly kind: OrganizationKind } | null } | null };

export type CreatePixelEventRecordMutationVariables = Exact<{
  input: CreatePixelEventRecordInput;
}>;


export type CreatePixelEventRecordMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createPixelEventRecord: { readonly __typename: 'CreatePixelEventRecord', readonly pixelEventRecord: { readonly __typename: 'PixelEventRecordObject', readonly id: string, readonly name: string | null, readonly eventType: PixelEventRecordEventType, readonly installation: PixelEventRecordInstallation, readonly createdAt: any, readonly updatedAt: any, readonly lastUpdatedBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } } | null } | null };

export type CreatePodlinkDomainMutationVariables = Exact<{
  input: CreatePodlinkDomainInput;
}>;


export type CreatePodlinkDomainMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createPodlinkDomain: { readonly __typename: 'CreatePodlinkDomain', readonly podlinkDomain: { readonly __typename: 'PodlinkDomainObject', readonly id: string, readonly slug: string, readonly title: string, readonly description: string | null } | null } | null };

export type CreateReviewerMutationVariables = Exact<{
  input: CreateReviewerInput;
}>;


export type CreateReviewerMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createReviewer: { readonly __typename: 'CreateReviewer', readonly reviewer: { readonly __typename: 'ReviewerObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null, readonly type: ReviewerType } | null } | null };

export type CreateUserAccessMutationVariables = Exact<{
  input: CreateUserAccessInput;
}>;


export type CreateUserAccessMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createUserAccess: { readonly __typename: 'CreateUserAccess', readonly userAccess: { readonly __typename: 'UserAccessObject', readonly id: string, readonly permission: string | null, readonly permissionDisplay: string | null, readonly objectPk: string, readonly appLabel: string | null, readonly model: string | null } | null } | null };

export type DeleteActionMapMutationVariables = Exact<{
  input: DeleteActionMapInput;
}>;


export type DeleteActionMapMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteActionMap: { readonly __typename: 'DeleteActionMap', readonly success: boolean } | null };

export type DeleteAdvisorSavedSearchMutationVariables = Exact<{
  input: DeleteAdvisorSavedSearchInput;
}>;


export type DeleteAdvisorSavedSearchMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteAdvisorSavedSearch: { readonly __typename: 'DeleteAdvisorSavedSearch', readonly success: boolean | null } | null };

export type DeleteCampaignMutationVariables = Exact<{
  input: DeleteCampaignInput;
}>;


export type DeleteCampaignMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteCampaign: { readonly __typename: 'DeleteCampaign', readonly success: boolean } | null };

export type DeleteCampaignNoiseMutationVariables = Exact<{
  input: DeleteCampaignNoiseInput;
}>;


export type DeleteCampaignNoiseMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteCampaignNoise: { readonly __typename: 'DeleteCampaignNoise', readonly success: boolean } | null };

export type DeleteCommentMutationVariables = Exact<{
  input: DeleteCommentInput;
  organizationId: Scalars['ID'];
}>;


export type DeleteCommentMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteComment: { readonly __typename: 'DeleteComment', readonly success: boolean } | null };

export type DeleteConversionUrlMutationVariables = Exact<{
  input: DeleteConversionUrlInput;
}>;


export type DeleteConversionUrlMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteConversionUrl: { readonly __typename: 'DeleteConversionURL', readonly success: boolean | null } | null };

export type DeleteGenericTagMutationVariables = Exact<{
  input: DeleteGenericTagInput;
}>;


export type DeleteGenericTagMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteGenericTag: { readonly __typename: 'DeleteGenericTag', readonly success: boolean } | null };

export type DeleteGenericTagRelationshipMutationVariables = Exact<{
  input: DeleteGenericTagRelationshipInput;
}>;


export type DeleteGenericTagRelationshipMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteGenericTagRelationship: { readonly __typename: 'DeleteGenericTagRelationship', readonly success: boolean } | null };

export type DeletePixelEventRecordMutationVariables = Exact<{
  input: DeletePixelEventRecordInput;
}>;


export type DeletePixelEventRecordMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deletePixelEventRecord: { readonly __typename: 'DeletePixelEventRecord', readonly success: boolean } | null };

export type DeletePodcastsMutationVariables = Exact<{
  input: DeletePodcastsInput;
}>;


export type DeletePodcastsMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deletePodcasts: { readonly __typename: 'DeletePodcasts', readonly success: boolean } | null };

export type DeletePodlinkDomainMutationVariables = Exact<{
  input: DeletePodlinkDomainInput;
}>;


export type DeletePodlinkDomainMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deletePodlinkDomain: { readonly __typename: 'DeletePodlinkDomain', readonly success: boolean | null } | null };

export type DeleteUserAccessMutationVariables = Exact<{
  input: DeleteUserAccessInput;
}>;


export type DeleteUserAccessMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteUserAccess: { readonly __typename: 'DeleteUserAccess', readonly success: boolean | null } | null };

export type DesignPodlinkDomainMutationVariables = Exact<{
  input: DesignPodlinkDomainInput;
}>;


export type DesignPodlinkDomainMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly designPodlinkDomain: { readonly __typename: 'DesignPodlinkDomain', readonly podlinkDomain: { readonly __typename: 'PodlinkDomainObject', readonly backgroundColor: string | null, readonly fontColor: string | null, readonly primaryColor: string | null, readonly secondaryColor: string | null, readonly id: string, readonly slug: string, readonly title: string, readonly description: string | null, readonly image: { readonly __typename: 'AssetObject', readonly id: string, readonly name: string, readonly contentType: string, readonly width: number | null, readonly height: number | null, readonly size: number, readonly src: string | null } | null, readonly favicon: { readonly __typename: 'AssetObject', readonly id: string, readonly name: string, readonly contentType: string, readonly width: number | null, readonly height: number | null, readonly size: number, readonly src: string | null } | null } | null } | null };

export type DownloadAdMutationVariables = Exact<{
  input: DownloadAdInput;
}>;


export type DownloadAdMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly downloadAd: { readonly __typename: 'DownloadAd', readonly success: boolean | null } | null };

export type ImportPodcastsMutationVariables = Exact<{
  input: ImportPodcastsInput;
}>;


export type ImportPodcastsMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly importPodcasts: { readonly __typename: 'ImportPodcasts', readonly added: ReadonlyArray<{ readonly __typename: 'PodcastObject', readonly id: string, readonly isAdvisor: boolean, readonly processingStartedAt: any | null, readonly createdAt: any, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly href: string, readonly state: FeedState, readonly publisherName: string | null, readonly publisherEmail: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null } | null>, readonly podcasts: ReadonlyArray<{ readonly __typename: 'PodcastObject', readonly id: string, readonly isAdvisor: boolean, readonly processingStartedAt: any | null, readonly createdAt: any, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly href: string, readonly state: FeedState, readonly publisherName: string | null, readonly publisherEmail: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null } | null>, readonly remove: ReadonlyArray<{ readonly __typename: 'PodcastObject', readonly id: string, readonly isAdvisor: boolean, readonly processingStartedAt: any | null, readonly createdAt: any, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly href: string, readonly state: FeedState, readonly publisherName: string | null, readonly publisherEmail: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null } | null>, readonly issues: ReadonlyArray<{ readonly __typename: 'ImportPodcastIssue', readonly href: string, readonly message: string } | null> | null } | null };

export type IsProcessingPodcastMutationVariables = Exact<{
  input: IsProcessingPodcastInput;
}>;


export type IsProcessingPodcastMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly isProcessingPodcast: { readonly __typename: 'IsProcessingPodcast', readonly processing: boolean, readonly podcast: { readonly __typename: 'LimitedPodcastObject', readonly id: string | null, readonly processingStartedAt: any | null } } | null };

export type IsProcessingPodcastsMutationVariables = Exact<{
  input: IsProcessingPodcastsInput;
}>;


export type IsProcessingPodcastsMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly isProcessingPodcasts: { readonly __typename: 'IsProcessingPodcasts', readonly podcasts: ReadonlyArray<{ readonly __typename: 'PodcastObject', readonly id: string, readonly isAdvisor: boolean, readonly processingStartedAt: any | null, readonly createdAt: any, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly href: string, readonly state: FeedState, readonly publisherName: string | null, readonly publisherEmail: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null } | null> } | null };

export type MeasureFeedMutationVariables = Exact<{
  input: MeasureFeedInput;
}>;


export type MeasureFeedMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly measureFeed: { readonly __typename: 'MeasureFeed', readonly success: boolean | null } | null };

export type ProcessCampaignEpisodesMutationVariables = Exact<{
  input: ProcessCampaignEpisodesInput;
}>;


export type ProcessCampaignEpisodesMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly processCampaignEpisodes: { readonly __typename: 'ProcessCampaignEpisodes', readonly success: boolean } | null };

export type ProcessFeedMutationVariables = Exact<{
  input: ProcessFeedInput;
}>;


export type ProcessFeedMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly processFeed: { readonly __typename: 'ProcessFeed', readonly success: boolean | null } | null };

export type RemoveAccessMutationVariables = Exact<{
  input: RemoveAccessInput;
}>;


export type RemoveAccessMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly removeAccess: { readonly __typename: 'RemoveAccess', readonly success: boolean | null } | null };

export type RemoveCampaignEpisodeMutationVariables = Exact<{
  input: RemoveCampaignEpisodeInput;
}>;


export type RemoveCampaignEpisodeMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly removeCampaignEpisode: { readonly __typename: 'RemoveCampaignEpisode', readonly success: boolean } | null };

export type RemoveDomainMutationVariables = Exact<{
  input: RemoveDomainInput;
}>;


export type RemoveDomainMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly removeDomain: { readonly __typename: 'RemoveDomain', readonly success: boolean | null } | null };

export type RemoveMemberMutationVariables = Exact<{
  input: RemoveMemberInput;
}>;


export type RemoveMemberMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly removeMember: { readonly __typename: 'RemoveMember', readonly success: boolean | null } | null };

export type SetAdvisorOptionsMutationVariables = Exact<{
  input: SetAdvisorOptionsInput;
}>;


export type SetAdvisorOptionsMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly setAdvisorOptions: { readonly __typename: 'SetAdvisorOptions', readonly organization: { readonly __typename: 'OrganizationObject', readonly isAdvisor: boolean, readonly podcasts: ReadonlyArray<{ readonly __typename: 'PodcastObject', readonly id: string, readonly isAdvisor: boolean, readonly processingStartedAt: any | null, readonly createdAt: any, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly href: string, readonly state: FeedState, readonly publisherName: string | null, readonly publisherEmail: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null }>, readonly capabilities: ReadonlyArray<{ readonly __typename: 'CapabilityObject', readonly id: string, readonly category: string, readonly title: string }> } | null } | null };

export type UpdateActionMapMutationVariables = Exact<{
  input: UpdateActionMapInput;
}>;


export type UpdateActionMapMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateActionMap: { readonly __typename: 'UpdateActionMap', readonly actionMap: { readonly __typename: 'ActionMapObject', readonly id: string, readonly eventName: string, readonly action: string | null } | null } | null };

export type UpdateAdvisorSavedSearchMutationVariables = Exact<{
  input: UpdateAdvisorSavedSearchInput;
}>;


export type UpdateAdvisorSavedSearchMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateAdvisorSavedSearch: { readonly __typename: 'UpdateAdvisorSavedSearch', readonly advisorSavedSearch: { readonly __typename: 'AdvisorSavedSearchObject', readonly id: string } | null } | null };

export type UpdateAttributionConfigMutationVariables = Exact<{
  input: UpdateAttributionConfigInput;
}>;


export type UpdateAttributionConfigMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateAttributionConfig: { readonly __typename: 'UpdateAttributionConfig', readonly attributionConfig: { readonly __typename: 'AttributionConfigObject', readonly id: string, readonly householdInterval: number, readonly cableInterval: number, readonly cellularInterval: number, readonly corporateInterval: number, readonly attributionInterval: number, readonly maxUsersPerHousehold: number } | null } | null };

export type UpdateCampaignApprovalsMutationVariables = Exact<{
  input: UpdateCampaignApprovalsInput;
}>;


export type UpdateCampaignApprovalsMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCampaignApprovals: { readonly __typename: 'UpdateCampaignApprovals', readonly dynamicApprovals: ReadonlyArray<{ readonly __typename: 'DynamicApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: DynamicApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null } | null> | null, readonly podcastApprovals: ReadonlyArray<{ readonly __typename: 'PodcastApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: PodcastApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null } | null> | null, readonly streamingApprovals: ReadonlyArray<{ readonly __typename: 'StreamingApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: StreamingApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignStreaming: { readonly __typename: 'CampaignStreamingObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null } | null> | null } | null };

export type UpdateCampaignBrandAgenciesMutationVariables = Exact<{
  input: UpdateCampaignBrandAgenciesInput;
}>;


export type UpdateCampaignBrandAgenciesMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCampaignBrandAgencies: { readonly __typename: 'UpdateCampaignBrandAgencies', readonly success: boolean, readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string } | null, readonly buySideAgencies: ReadonlyArray<{ readonly __typename: 'CampaignBuySideAgencyMembershipObject', readonly organizationId: string | null, readonly organizationName: string | null } | null> | null } | null> | null } | null };

export type UpdateCampaignDatesMutationVariables = Exact<{
  input: UpdateCampaignDatesInput;
}>;


export type UpdateCampaignDatesMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCampaignDates: { readonly __typename: 'UpdateCampaignDates', readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly startAt: any | null, readonly endAt: any | null } | null } | null };

export type UpdateCampaignEpisodeMutationVariables = Exact<{
  input: UpdateCampaignEpisodeInput;
}>;


export type UpdateCampaignEpisodeMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCampaignEpisode: { readonly __typename: 'UpdateCampaignEpisode', readonly campaignEpisode: { readonly __typename: 'CampaignEpisodeObject', readonly id: string, readonly isBaseline: boolean, readonly startAt: any | null, readonly endAt: any | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly goal: any | null, readonly verified: boolean, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string }, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null } | null, readonly futureEpisode: { readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly expectedPublished: any } | null } | null } | null };

export type UpdateCampaignNoiseMutationVariables = Exact<{
  input: UpdateCampaignNoiseInput;
}>;


export type UpdateCampaignNoiseMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCampaignNoise: { readonly __typename: 'UpdateCampaignNoise', readonly campaignNoise: { readonly __typename: 'CampaignNoiseObject', readonly id: string, readonly name: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly targetImpressions: number | null, readonly usePublisherImpressions: boolean } | null } | null };

export type UpdateCampaignPodcastMutationVariables = Exact<{
  input: UpdateCampaignPodcastInput;
}>;


export type UpdateCampaignPodcastMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCampaignPodcast: { readonly __typename: 'UpdateCampaignPodcast', readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly name: string | null, readonly isDynamic: boolean, readonly drops: number | null, readonly campaignEpisodesCount: number | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly hasPodsightsPrefix: boolean, readonly createdAt: any, readonly updatedAt: any, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly href: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null } | null } | null };

export type UpdateCampaignStateMutationVariables = Exact<{
  input: UpdateCampaignStateInput;
}>;


export type UpdateCampaignStateMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCampaignState: { readonly __typename: 'UpdateCampaignState', readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string, readonly state: CampaignState, readonly createdAt: any } | null } | null };

export type UpdateConversionUrlMutationVariables = Exact<{
  input: UpdateConversionUrlInput;
}>;


export type UpdateConversionUrlMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateConversionUrl: { readonly __typename: 'UpdateConversionURL', readonly conversionUrl: { readonly __typename: 'ConversionURLObject', readonly id: string, readonly url: string, readonly value: number | null, readonly action: string | null, readonly type: string | null, readonly category: string | null } | null } | null };

export type UpdateFeedsMutationVariables = Exact<{
  input: UpdateFeedsInput;
}>;


export type UpdateFeedsMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateFeeds: { readonly __typename: 'UpdateFeeds', readonly feeds: ReadonlyArray<{ readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly href: string, readonly state: FeedState, readonly publisherName: string | null, readonly publisherEmail: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null> | null } | null };

export type UpdateGenericTagMutationVariables = Exact<{
  input: UpdateGenericTagInput;
}>;


export type UpdateGenericTagMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateGenericTag: { readonly __typename: 'UpdateGenericTag', readonly genericTag: { readonly __typename: 'GenericTagObject', readonly id: string, readonly title: string, readonly color: string } | null } | null };

export type UpdateMemberMutationVariables = Exact<{
  input: UpdateMemberInput;
}>;


export type UpdateMemberMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateMember: { readonly __typename: 'UpdateMember', readonly membership: { readonly __typename: 'MembershipObject', readonly id: string, readonly role: string | null, readonly roleDisplay: string | null, readonly createdAt: any, readonly user: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string } | null } | null } | null };

export type UpdatePixelMutationVariables = Exact<{
  input: UpdateKeyInput;
}>;


export type UpdatePixelMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updatePixel: { readonly __typename: 'UpdateKey', readonly key: { readonly __typename: 'KeyObject', readonly key: string, readonly domain: string, readonly alias: string } | null } | null };

export type UpdatePixelEventRecordMutationVariables = Exact<{
  input: UpdatePixelEventRecordInput;
}>;


export type UpdatePixelEventRecordMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updatePixelEventRecord: { readonly __typename: 'UpdatePixelEventRecord', readonly pixelEventRecord: { readonly __typename: 'PixelEventRecordObject', readonly id: string, readonly name: string | null, readonly eventType: PixelEventRecordEventType, readonly installation: PixelEventRecordInstallation, readonly createdAt: any, readonly updatedAt: any, readonly lastUpdatedBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } } | null } | null };

export type UpdatePodlinkDomainMutationVariables = Exact<{
  input: UpdatePodlinkDomainInput;
}>;


export type UpdatePodlinkDomainMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updatePodlinkDomain: { readonly __typename: 'UpdatePodlinkDomain', readonly podlinkDomain: { readonly __typename: 'PodlinkDomainObject', readonly id: string, readonly slug: string, readonly title: string, readonly description: string | null } | null } | null };

export type UpdatePodlinkPodcastMutationVariables = Exact<{
  input: UpdatePodlinkPodcastInput;
}>;


export type UpdatePodlinkPodcastMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updatePodlinkPodcast: { readonly __typename: 'UpdatePodlinkPodcast', readonly success: boolean | null } | null };

export type AdvisorOptionsCapabilitiesQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdvisorOptionsCapabilitiesQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly id: string, readonly options: { readonly __typename: 'AdvisorOptions', readonly id: string, readonly capabilities: ReadonlyArray<{ readonly __typename: 'CapabilityObject', readonly id: string, readonly category: string, readonly title: string } | null> | null } | null } | null, readonly capabilities: ReadonlyArray<{ readonly __typename: 'CapabilityObject', readonly id: string, readonly category: string, readonly title: string }> } } | null };

export type GetAssetsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAssetsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly assets: ReadonlyArray<{ readonly __typename: 'AssetObject', readonly id: string, readonly name: string, readonly contentType: string, readonly width: number | null, readonly height: number | null, readonly size: number, readonly src: string | null }> } } | null };

export type GetAttributionConfigQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type GetAttributionConfigQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly attributionConfig: { readonly __typename: 'AttributionConfigObject', readonly id: string, readonly householdInterval: number, readonly cableInterval: number, readonly cellularInterval: number, readonly corporateInterval: number, readonly attributionInterval: number, readonly maxUsersPerHousehold: number } } } | null };

export type GetBrandCampaignAgenciesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type GetBrandCampaignAgenciesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly managers: ReadonlyArray<{ readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null, readonly slug: string | null, readonly kind: string | null }>, readonly reversePermissions: ReadonlyArray<{ readonly __typename: 'PermissionObject', readonly id: string | null, readonly name: string | null, readonly objectName: string | null, readonly permission: string | null, readonly contentObjectName: string | null, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null } | null }>, readonly campaigns: { readonly __typename: 'CampaignFilterObject', readonly results: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly isHiddenFromAgency: boolean, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string } | null, readonly buySideAgencies: ReadonlyArray<{ readonly __typename: 'CampaignBuySideAgencyMembershipObject', readonly organizationId: string | null, readonly organizationName: string | null } | null> | null } | null> | null } } } | null };

export type GetBrandCampaignAttributionReferrerDomainsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  offset: InputMaybe<Scalars['Int']>;
  limit: InputMaybe<Scalars['Int']>;
}>;


export type GetBrandCampaignAttributionReferrerDomainsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly referrerDomains: { readonly __typename: 'AttributionReferrerDomains', readonly count: any | null, readonly sum: any | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'AttributionReferrerDomain', readonly referrerDomain: string | null, readonly count: any | null } | null> | null } | null } | null } | null } } } | null };

export type GetBrandCampaignAttributionUrlsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  offset: InputMaybe<Scalars['Int']>;
  limit: InputMaybe<Scalars['Int']>;
}>;


export type GetBrandCampaignAttributionUrlsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly urls: { readonly __typename: 'AttributionUrls', readonly count: any | null, readonly sum: any | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'AttributionUrl', readonly url: string | null, readonly urlPath: string | null, readonly count: any | null } | null> | null } | null } | null } | null } } } | null };

export type GetCampaignDynamicEpisodeOmniChartQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  campaignDynamicId: Scalars['ID'];
  campaignDynamicPodcastId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCampaignDynamicEpisodeOmniChartQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly campaignDynamicPodcast: { readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly campaignDynamicEpisode: { readonly __typename: 'CampaignDynamicEpisodeObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly hourlyVisitors: ReadonlyArray<{ readonly __typename: 'AttributionVisitorsHourly', readonly count: number | null, readonly hour: any | null } | null> | null } | null } | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly downloadClass: string | null, readonly count: any | null } | null> | null } | null } | null } | null } | null } } } | null };

export type GetBrandCampaignDynamicOmniChartQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
}>;


export type GetBrandCampaignDynamicOmniChartQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly hourlyVisitors: ReadonlyArray<{ readonly __typename: 'AttributionVisitorsHourly', readonly count: number | null, readonly hour: any | null } | null> | null } | null } | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly downloadClass: string | null, readonly count: any | null } | null> | null } | null } | null } } } | null };

export type GetCampaignDynamicPodcastOmniChartQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  campaignDynamicId: Scalars['ID'];
  id: Scalars['ID'];
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
}>;


export type GetCampaignDynamicPodcastOmniChartQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly campaignDynamicPodcast: { readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly hourlyVisitors: ReadonlyArray<{ readonly __typename: 'AttributionVisitorsHourly', readonly count: number | null, readonly hour: any | null } | null> | null } | null } | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly downloadClass: string | null, readonly count: any | null } | null> | null } | null } | null } | null } } } | null };

export type GetBrandCampaignEpisodeOmniChartQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetBrandCampaignEpisodeOmniChartQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignEpisode: { readonly __typename: 'CampaignEpisodeObject', readonly id: string, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly path: string | null } | null } | null, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly hourlyVisitors: ReadonlyArray<{ readonly __typename: 'AttributionVisitorsHourly', readonly count: number | null, readonly hour: any | null } | null> | null } | null } | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly downloadClass: string | null, readonly count: any | null } | null> | null } | null } | null } } } | null };

export type GetBrandCampaignHouseholdQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetBrandCampaignHouseholdQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly households: { readonly __typename: 'AttributionHouseholds', readonly household: { readonly __typename: 'AttributionHousehold', readonly events: { readonly __typename: 'AttributionEventsQuery', readonly count: number | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'AttributionEvent', readonly latitude: string | null, readonly longitude: string | null, readonly country: string | null, readonly region: string | null, readonly city: string | null, readonly time: any | null, readonly action: string | null, readonly referrer: string | null, readonly referrerDomain: string | null, readonly url: string | null, readonly urlPath: string | null, readonly value: number | null, readonly currency: string | null, readonly product: string | null, readonly discountCode: string | null, readonly orderId: string | null, readonly quantity: any | null, readonly lineItems: string | null, readonly leadType: string | null, readonly leadCategory: string | null, readonly alias: string | null, readonly userAgent: { readonly __typename: 'UserAgent', readonly os: { readonly __typename: 'UAOSObject', readonly family: string | null } | null, readonly device: { readonly __typename: 'UADeviceObject', readonly family: string | null } | null } | null } | null> | null } | null, readonly downloads: { readonly __typename: 'AttributionDownloadsQuery', readonly count: number | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'AttributionDownload', readonly campaignId: string, readonly campaignDynamicId: string, readonly source: string, readonly kind: string, readonly time: any, readonly attribution: number, readonly country: string | null, readonly region: string | null, readonly city: string | null, readonly longitude: number | null, readonly latitude: number | null, readonly userAgent: { readonly __typename: 'UserAgent', readonly os: { readonly __typename: 'UAOSObject', readonly family: string | null } | null, readonly device: { readonly __typename: 'UADeviceObject', readonly family: string | null } | null } | null, readonly feed: { readonly __typename: 'FeedObject', readonly title: string } | null, readonly episode: { readonly __typename: 'EpisodeObject', readonly title: string } | null } | null> | null } | null } | null } | null } | null } } } | null };

export type GetBrandCampaignOmniChartQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
}>;


export type GetBrandCampaignOmniChartQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly hourlyVisitors: ReadonlyArray<{ readonly __typename: 'AttributionVisitorsHourly', readonly count: number | null, readonly hour: any | null } | null> | null } | null } | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly downloadClass: string | null, readonly count: any | null } | null> | null } | null, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null, readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly published: any | null } | null> | null } | null> | null } } } | null };

export type GetBrandCampaignOverlapQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetBrandCampaignOverlapQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly overlap: { readonly __typename: 'Overlap', readonly pairs: ReadonlyArray<{ readonly __typename: 'OverlapPair', readonly baseCampaignDynamicId: string | null, readonly baseFeedId: string | null, readonly compCampaignDynamicId: string | null, readonly compFeedId: string | null, readonly baseReach: any | null, readonly compReach: any | null, readonly overlap: any | null, readonly baseCampaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string } | null, readonly baseCampaignStreaming: { readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly name: string } | null, readonly baseFeed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly width: number | null, readonly height: number | null, readonly path: string | null } | null } | null, readonly compCampaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string } | null, readonly compCampaignStreaming: { readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly name: string } | null, readonly compFeed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly width: number | null, readonly height: number | null, readonly path: string | null } | null } | null } | null> | null } | null } } } | null };

export type GetBrandCampaignPodcastOmniChartQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
}>;


export type GetBrandCampaignPodcastOmniChartQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly path: string | null } | null } | null> | null, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly hourlyVisitors: ReadonlyArray<{ readonly __typename: 'AttributionVisitorsHourly', readonly count: number | null, readonly hour: any | null } | null> | null } | null } | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly downloadClass: string | null, readonly count: any | null } | null> | null } | null } | null } } } | null };

export type GetBrandCampaignReferrersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  domain: InputMaybe<Scalars['String']>;
  offset: InputMaybe<Scalars['Int']>;
  limit: InputMaybe<Scalars['Int']>;
}>;


export type GetBrandCampaignReferrersQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly referrers: { readonly __typename: 'AttributionReferrers', readonly count: any | null, readonly sum: any | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'AttributionReferrer', readonly referrer: string | null, readonly count: any | null } | null> | null } | null } | null } | null } } } | null };

export type GetBrandCampaignStreamingOmniChartQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
}>;


export type GetBrandCampaignStreamingOmniChartQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignStreaming: { readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly hourlyVisitors: ReadonlyArray<{ readonly __typename: 'AttributionVisitorsHourly', readonly count: number | null, readonly hour: any | null } | null> | null } | null } | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly downloadClass: string | null, readonly count: any | null } | null> | null } | null } | null } } } | null };

export type GetBrandOrganizationCampaignOverlapQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
}>;


export type GetBrandOrganizationCampaignOverlapQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly overview: { readonly __typename: 'OverviewObject', readonly impressions: { readonly __typename: 'ImpressionsObject', readonly overlap: { readonly __typename: 'ImpressionsOverlapObject', readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignOverlapObject', readonly baseDownloads: any | null, readonly baseReach: any | null, readonly baseCampaignId: string | null, readonly compDownloads: any | null, readonly compReach: any | null, readonly compCampaignId: string | null, readonly overlap: any | null, readonly combined: any | null, readonly baseCampaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string } | null } | null, readonly compCampaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string } | null } | null } | null> | null } | null } | null } | null } } | null };

export type GetBrandOrganizationFrequencyQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
  publisherIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  campaignIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetBrandOrganizationFrequencyQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly overview: { readonly __typename: 'OverviewObject', readonly impressions: { readonly __typename: 'ImpressionsObject', readonly impressions: any | null, readonly reach: any | null, readonly frequency: { readonly __typename: 'ImpressionsFrequencyObject', readonly max: any | null, readonly over: { readonly __typename: 'ImpressionsFrequencyOver', readonly impressions: any | null, readonly reach: any | null } | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'ImpressionsFrequencyNode', readonly frequency: any | null, readonly total: any | null } | null> | null } | null } | null } | null } } | null };

export type GetBrandOrganizationImpressionsCountryLocationQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
  publisherIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  campaignIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  country: InputMaybe<Scalars['String']>;
}>;


export type GetBrandOrganizationImpressionsCountryLocationQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly overview: { readonly __typename: 'OverviewObject', readonly impressions: { readonly __typename: 'ImpressionsObject', readonly locations: { readonly __typename: 'DownloadLocationsQuery', readonly count: number | null, readonly regions: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly region: string | null, readonly total: any | null } | null> | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly region: string | null, readonly city: string | null, readonly latitude: number | null, readonly longitude: number | null, readonly count: any | null } | null> | null } | null } | null } | null } } | null };

export type GetBrandOrganizationIntervalReachQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
  publisherIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  campaignIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  trailing: InputMaybe<Scalars['Int']>;
  interval: InputMaybe<Scalars['String']>;
  attr: InputMaybe<Scalars['String']>;
}>;


export type GetBrandOrganizationIntervalReachQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly overview: { readonly __typename: 'OverviewObject', readonly impressions: { readonly __typename: 'ImpressionsObject', readonly intervalReachOverlap: ReadonlyArray<{ readonly __typename: 'IntervalReachOverlap', readonly interval: any | null, readonly impressions: any | null, readonly reach: any | null, readonly priorImpressions: any | null, readonly priorReach: any | null, readonly combinedReach: any | null, readonly existingReach: any | null, readonly newReach: any | null, readonly percentNew: number | null, readonly impressionsToNewReach: any | null, readonly impressionsToPriorReach: any | null } | null> | null } | null } | null } } | null };

export type GetBrandOrganizationImpressionsPlayersQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
  campaignIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetBrandOrganizationImpressionsPlayersQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly overview: { readonly __typename: 'OverviewObject', readonly impressions: { readonly __typename: 'ImpressionsObject', readonly players: ReadonlyArray<{ readonly __typename: 'ImpressionsPlayer', readonly player: string | null, readonly total: any | null, readonly reach: any | null, readonly frequency: number | null, readonly impressionsLessThan5: any | null, readonly percentageImpressionsLessThan5: number | null, readonly reachLessThan5: any | null, readonly percentageReachLessThan5: number | null, readonly impressionsBetween5And15: any | null, readonly percentageImpressionsBetween5And15: number | null, readonly reachBetween5And15: any | null, readonly percentageReachBetween5And15: number | null, readonly impressionsGreaterThan15: any | null, readonly percentageImpressionsGreaterThan15: number | null, readonly reachGreaterThan15: any | null, readonly percentageReachGreaterThan15: number | null } | null> | null } | null } | null } } | null };

export type GetBrandOrganizationImpressionsRegionLocationQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
  publisherIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  campaignIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  country: InputMaybe<Scalars['String']>;
  region: InputMaybe<Scalars['String']>;
}>;


export type GetBrandOrganizationImpressionsRegionLocationQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly overview: { readonly __typename: 'OverviewObject', readonly impressions: { readonly __typename: 'ImpressionsObject', readonly locations: { readonly __typename: 'DownloadLocationsQuery', readonly count: number | null, readonly cities: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly region: string | null, readonly city: string | null, readonly total: any | null } | null> | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly region: string | null, readonly city: string | null, readonly latitude: number | null, readonly longitude: number | null, readonly count: any | null } | null> | null } | null } | null } | null } } | null };

export type GetBrandOrganizationOverlapQueryVariables = Exact<{
  id: Scalars['ID'];
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
}>;


export type GetBrandOrganizationOverlapQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly overlap: { readonly __typename: 'Overlap', readonly pairs: ReadonlyArray<{ readonly __typename: 'OverlapPair', readonly baseCampaignDynamicId: string | null, readonly baseFeedId: string | null, readonly compCampaignDynamicId: string | null, readonly compFeedId: string | null, readonly baseReach: any | null, readonly compReach: any | null, readonly overlap: any | null, readonly baseCampaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string } | null, readonly baseFeed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly width: number | null, readonly height: number | null, readonly path: string | null } | null } | null, readonly compCampaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string } | null, readonly compFeed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly width: number | null, readonly height: number | null, readonly path: string | null } | null } | null } | null> | null } | null } } | null };

export type GetBrandOrganizationPublisherOverlapQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
}>;


export type GetBrandOrganizationPublisherOverlapQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly overview: { readonly __typename: 'OverviewObject', readonly impressions: { readonly __typename: 'ImpressionsObject', readonly overlap: { readonly __typename: 'ImpressionsOverlapObject', readonly publishers: ReadonlyArray<{ readonly __typename: 'PublisherOverlapObject', readonly baseDownloads: any | null, readonly baseReach: any | null, readonly basePublisherId: string | null, readonly compDownloads: any | null, readonly compReach: any | null, readonly compPublisherId: string | null, readonly overlap: any | null, readonly combined: any | null, readonly basePublisher: { readonly __typename: 'ImpressionsPublisherObject', readonly id: string | null, readonly name: string | null } | null, readonly compPublisher: { readonly __typename: 'ImpressionsPublisherObject', readonly id: string | null, readonly name: string | null } | null } | null> | null } | null } | null } | null } } | null };

export type GetCampaignApprovalConfigQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type GetCampaignApprovalConfigQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly approvalConfig: { readonly __typename: 'ApprovalConfig', readonly publisherMembers: ReadonlyArray<{ readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } | null> | null, readonly brandMembers: ReadonlyArray<{ readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } | null> | null, readonly buySideAgencies: ReadonlyArray<{ readonly __typename: 'ApprovalAgency', readonly id: string, readonly name: string, readonly members: ReadonlyArray<{ readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } | null> | null } | null> | null } | null } } } | null };

export type GetCampaignApprovalsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type GetCampaignApprovalsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly dynamicApprovals: ReadonlyArray<{ readonly __typename: 'DynamicApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: DynamicApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null } | null> | null, readonly podcastApprovals: ReadonlyArray<{ readonly __typename: 'PodcastApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: PodcastApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null } | null> | null, readonly streamingApprovals: ReadonlyArray<{ readonly __typename: 'StreamingApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: StreamingApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignStreaming: { readonly __typename: 'CampaignStreamingObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null } | null> | null } } } | null };

export type GetCampaignAttributionPurchaseValueByDayQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
}>;


export type GetCampaignAttributionPurchaseValueByDayQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly events: { readonly __typename: 'AttributionEvents', readonly purchaseValueByDay: ReadonlyArray<{ readonly __typename: 'AttributionPurchaseValueByDay', readonly day: any | null, readonly value: number | null } | null> | null } | null } | null } } } | null };

export type GetCampaignDownloadCountryLocationsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  country: InputMaybe<Scalars['String']>;
}>;


export type GetCampaignDownloadCountryLocationsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly downloads: { readonly __typename: 'DownloadsObject', readonly locations: { readonly __typename: 'DownloadLocationsQuery', readonly count: number | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly region: string | null, readonly city: string | null, readonly latitude: number | null, readonly longitude: number | null, readonly total: any | null } | null> | null, readonly regions: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly region: string | null, readonly total: any | null } | null> | null } | null } | null } } } | null };

export type GetCampaignDownloadLocationsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCampaignDownloadLocationsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly downloads: { readonly __typename: 'DownloadsObject', readonly locations: { readonly __typename: 'DownloadLocationsQuery', readonly count: number | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly region: string | null, readonly city: string | null, readonly latitude: number | null, readonly longitude: number | null, readonly total: any | null } | null> | null, readonly countries: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly total: any | null } | null> | null } | null } | null } } } | null };

export type GetCampaignDownloadRegionLocationsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  country: InputMaybe<Scalars['String']>;
  region: InputMaybe<Scalars['String']>;
}>;


export type GetCampaignDownloadRegionLocationsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly downloads: { readonly __typename: 'DownloadsObject', readonly locations: { readonly __typename: 'DownloadLocationsQuery', readonly count: number | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly region: string | null, readonly city: string | null, readonly latitude: number | null, readonly longitude: number | null, readonly total: any | null } | null> | null, readonly cities: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly region: string | null, readonly city: string | null, readonly total: any | null } | null> | null } | null } | null } } } | null };

export type GetCampaignDynamicEpisodeQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  campaignDynamicId: Scalars['ID'];
  campaignDynamicPodcastId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCampaignDynamicEpisodeQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly campaignDynamicPodcast: { readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly campaignDynamicEpisode: { readonly __typename: 'CampaignDynamicEpisodeObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null, readonly duration: number | null, readonly mpegPath: string | null, readonly waveform: any | null } | null } | null } | null } | null } | null } } } | null };

export type GetCampaignDynamicPodcastQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  campaignDynamicId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCampaignDynamicPodcastQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly campaignDynamicPodcast: { readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly campaignDynamicEpisodes: ReadonlyArray<{ readonly __typename: 'CampaignDynamicEpisodeObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null, readonly duration: number | null, readonly mpegPath: string | null, readonly waveform: any | null } | null } | null }>, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null } | null } | null } } } | null };

export type GetCampaignEpisodeQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCampaignEpisodeQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignEpisode: { readonly __typename: 'CampaignEpisodeObject', readonly id: string, readonly goal: any | null, readonly cost: number | null, readonly costToDate: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly isDynamic: boolean, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly purchaseTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly verified: boolean, readonly downloads: { readonly __typename: 'DownloadsObject', readonly count: any | null } | null, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly sum: { readonly __typename: 'AttributionUsersSum', readonly users: any | null, readonly usersModeled: number | null, readonly pages: number | null, readonly pagesModeled: number | null, readonly sessions: number | null, readonly sessionsModeled: number | null, readonly products: number | null, readonly productsModeled: number | null, readonly addtocarts: number | null, readonly addtocartsModeled: number | null, readonly checkouts: number | null, readonly checkoutsModeled: number | null, readonly purchases: number | null, readonly purchasesModeled: number | null, readonly leads: number | null, readonly leadsModeled: number | null, readonly value: number | null, readonly valueModeled: number | null } | null } | null } | null, readonly placements: ReadonlyArray<{ readonly __typename: 'PlacementObject', readonly id: string, readonly startTime: number, readonly endTime: number, readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly waveform: any | null, readonly text: string | null, readonly mpegPath: string | null, readonly flacPath: string | null, readonly words: any | null, readonly duration: number } } | null> | null, readonly otherPlacements: ReadonlyArray<{ readonly __typename: 'PlacementObject', readonly id: string, readonly startTime: number, readonly endTime: number, readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly waveform: any | null, readonly text: string | null, readonly mpegPath: string | null, readonly flacPath: string | null, readonly words: any | null, readonly duration: number, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly slug: string } | null } } | null> | null, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null, readonly duration: number | null, readonly mpegPath: string | null, readonly waveform: any | null } | null } | null, readonly futureEpisode: { readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly expectedPublished: any } | null } | null } } } | null };

export type GetCampaignFrequencyQueryQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type GetCampaignFrequencyQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly impressions: { readonly __typename: 'ImpressionsObject', readonly frequency: { readonly __typename: 'ImpressionsFrequencyObject', readonly max: any | null, readonly over: { readonly __typename: 'ImpressionsFrequencyOver', readonly impressions: any | null, readonly reach: any | null } | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'ImpressionsFrequencyNode', readonly frequency: any | null, readonly total: any | null } | null> | null } | null } | null } } } | null };

export type GetCampaignLinkQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCampaignLinkQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignLink: { readonly __typename: 'CampaignLinkObject', readonly id: string, readonly name: string | null, readonly viewTotal: number | null, readonly clickTotal: number | null, readonly targetReachTotal: number | null, readonly targetDownloadTotal: number | null, readonly createdAt: any, readonly target: { readonly __typename: 'CampaignTargetObject', readonly id: string, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly href: string } } | null, readonly attribution: { readonly __typename: 'AttributionObject', readonly marketing: { readonly __typename: 'AttributionMarketing', readonly linkHourly: ReadonlyArray<{ readonly __typename: 'LinkHourly', readonly campaignLinkId: string | null, readonly hour: any | null, readonly action: string | null, readonly total: any | null } | null> | null, readonly linkClicks: ReadonlyArray<{ readonly __typename: 'LinkClicks', readonly campaignLinkId: string | null, readonly type: string | null, readonly category: string | null, readonly total: any | null } | null> | null, readonly linkAttributionTargetEpisodes: { readonly __typename: 'LinkTargetEpisodes', readonly count: any | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'LinkTargetEpisode', readonly id: string | null, readonly downloads: any | null, readonly reach: number | null, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null } | null } | null> | null } | null } | null } | null } | null } } } | null };

export type GetCampaignPermissionQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCampaignPermissionQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly permission: { readonly __typename: 'PermissionObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly objectName: string | null, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null } | null } | null } } } | null };

export type GetCampaignPermissionsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCampaignPermissionsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly permissions: ReadonlyArray<{ readonly __typename: 'PermissionObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly objectName: string | null, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null } | null } | null> | null } } } | null };

export type GetCampaignPlayersQueryQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
}>;


export type GetCampaignPlayersQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly enhancedConversions: { readonly __typename: 'CampaignEnhancedConversionsObject', readonly spotifyAttribution: number | null, readonly appleAttribution: number | null, readonly spotifyCr: number | null, readonly appleWeightedCr: number | null, readonly otherWeightedCr: number | null } | null, readonly impressions: { readonly __typename: 'ImpressionsObject', readonly players: ReadonlyArray<{ readonly __typename: 'ImpressionsPlayer', readonly player: string | null, readonly total: any | null, readonly reach: any | null, readonly frequency: number | null, readonly impressionsLessThan5: any | null, readonly percentageImpressionsLessThan5: number | null, readonly reachLessThan5: any | null, readonly percentageReachLessThan5: number | null, readonly impressionsBetween5And15: any | null, readonly percentageImpressionsBetween5And15: number | null, readonly reachBetween5And15: any | null, readonly percentageReachBetween5And15: number | null, readonly impressionsGreaterThan15: any | null, readonly percentageImpressionsGreaterThan15: number | null, readonly reachGreaterThan15: any | null, readonly percentageReachGreaterThan15: number | null } | null> | null } | null } } } | null };

export type GetCampaignPodcastQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCampaignPodcastQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly name: string | null, readonly isDynamic: boolean, readonly drops: number | null, readonly campaignEpisodesCount: number | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly hasPodsightsPrefix: boolean, readonly createdAt: any, readonly updatedAt: any, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly sum: { readonly __typename: 'AttributionUsersSum', readonly users: any | null, readonly usersModeled: number | null, readonly pages: number | null, readonly pagesModeled: number | null, readonly sessions: number | null, readonly sessionsModeled: number | null, readonly products: number | null, readonly productsModeled: number | null, readonly addtocarts: number | null, readonly addtocartsModeled: number | null, readonly checkouts: number | null, readonly checkoutsModeled: number | null, readonly purchases: number | null, readonly purchasesModeled: number | null, readonly leads: number | null, readonly leadsModeled: number | null, readonly value: number | null, readonly valueModeled: number | null } | null } | null } | null, readonly campaignEpisodes: ReadonlyArray<{ readonly __typename: 'CampaignEpisodeObject', readonly id: string, readonly isBaseline: boolean, readonly startAt: any | null, readonly endAt: any | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly goal: any | null, readonly verified: boolean, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string }, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null } | null, readonly futureEpisode: { readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly expectedPublished: any } | null }>, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly href: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null } | null } } } | null };

export type GetCampaignPrefixConsistencyQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  campaignPodcastId: InputMaybe<Scalars['ID']>;
  campaignEpisodeId: InputMaybe<Scalars['ID']>;
}>;


export type GetCampaignPrefixConsistencyQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly debug: { readonly __typename: 'CampaignDebug', readonly prefixConsistency: ReadonlyArray<{ readonly __typename: 'DataConsistencyNode', readonly day: string, readonly bigquery: any, readonly publisher: any | null, readonly diff: any, readonly bigtable: any }> } | null } } } | null };

export type GetCampaignRevenueQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
}>;


export type GetCampaignRevenueQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly multiplier: number, readonly downloads: { readonly __typename: 'DownloadsObject', readonly count: any | null } | null, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly sum: { readonly __typename: 'AttributionUsersSum', readonly users: any | null, readonly usersModeled: number | null, readonly pages: number | null, readonly pagesModeled: number | null, readonly sessions: number | null, readonly sessionsModeled: number | null, readonly products: number | null, readonly productsModeled: number | null, readonly addtocarts: number | null, readonly addtocartsModeled: number | null, readonly checkouts: number | null, readonly checkoutsModeled: number | null, readonly purchases: number | null, readonly purchasesModeled: number | null, readonly leads: number | null, readonly leadsModeled: number | null, readonly value: number | null, readonly valueModeled: number | null } | null } | null } | null, readonly campaignDynamics: ReadonlyArray<{ readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string, readonly art19Secret: string | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly dynamicType: string | null, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly providerName: CampaignDynamicProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly downloads: { readonly __typename: 'DownloadsObject', readonly count: any | null } | null, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly sum: { readonly __typename: 'AttributionUsersSum', readonly users: any | null, readonly usersModeled: number | null, readonly pages: number | null, readonly pagesModeled: number | null, readonly sessions: number | null, readonly sessionsModeled: number | null, readonly products: number | null, readonly productsModeled: number | null, readonly addtocarts: number | null, readonly addtocartsModeled: number | null, readonly checkouts: number | null, readonly checkoutsModeled: number | null, readonly purchases: number | null, readonly purchasesModeled: number | null, readonly leads: number | null, readonly leadsModeled: number | null, readonly value: number | null, readonly valueModeled: number | null } | null } | null } | null, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignDynamicPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null }> }>, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly name: string | null, readonly isDynamic: boolean, readonly drops: number | null, readonly campaignEpisodesCount: number | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly hasPodsightsPrefix: boolean, readonly createdAt: any, readonly updatedAt: any, readonly downloads: { readonly __typename: 'DownloadsObject', readonly count: any | null } | null, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly sum: { readonly __typename: 'AttributionUsersSum', readonly users: any | null, readonly usersModeled: number | null, readonly pages: number | null, readonly pagesModeled: number | null, readonly sessions: number | null, readonly sessionsModeled: number | null, readonly products: number | null, readonly productsModeled: number | null, readonly addtocarts: number | null, readonly addtocartsModeled: number | null, readonly checkouts: number | null, readonly checkoutsModeled: number | null, readonly purchases: number | null, readonly purchasesModeled: number | null, readonly leads: number | null, readonly leadsModeled: number | null, readonly value: number | null, readonly valueModeled: number | null } | null } | null } | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly href: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null } | null> | null, readonly campaignStreamings: ReadonlyArray<{ readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly name: string, readonly isActive: boolean, readonly source: CampaignStreamingSource, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly verifiedReach: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly providerName: CampaignStreamingProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly downloads: { readonly __typename: 'DownloadsObject', readonly count: any | null } | null, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly sum: { readonly __typename: 'AttributionUsersSum', readonly users: any | null, readonly usersModeled: number | null, readonly pages: number | null, readonly pagesModeled: number | null, readonly sessions: number | null, readonly sessionsModeled: number | null, readonly products: number | null, readonly productsModeled: number | null, readonly addtocarts: number | null, readonly addtocartsModeled: number | null, readonly checkouts: number | null, readonly checkoutsModeled: number | null, readonly purchases: number | null, readonly purchasesModeled: number | null, readonly leads: number | null, readonly leadsModeled: number | null, readonly value: number | null, readonly valueModeled: number | null } | null } | null } | null, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignStreamingStreams: ReadonlyArray<{ readonly __typename: 'CampaignStreamingStreamObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null }> }> } } } | null };

export type GetCampaignTargetOptionsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCampaignTargetOptionsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly targetOptions: ReadonlyArray<{ readonly __typename: 'PodcastIdAndFeedObject', readonly id: string | null, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null } | null> | null } } } | null };

export type GetCampaignTargetQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCampaignTargetQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignTarget: { readonly __typename: 'CampaignTargetObject', readonly id: string, readonly reachTotal: number | null, readonly downloadTotal: number | null, readonly attribution: { readonly __typename: 'AttributionObject', readonly marketing: { readonly __typename: 'AttributionMarketing', readonly acquired: ReadonlyArray<{ readonly __typename: 'TargetAcquired', readonly day: any | null, readonly count: number | null } | null> | null, readonly targetEpisodes: { readonly __typename: 'MarketingTargetEpisodes', readonly count: any | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'MarketingTargetEpisode', readonly id: string | null, readonly downloads: number | null, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null } | null } | null> | null } | null } | null } | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly href: string, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null, readonly src: string | null } | null } } | null } } } | null };

export type GetCampaignWebhookConsistencyQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  campaignDynamicId: InputMaybe<Scalars['ID']>;
}>;


export type GetCampaignWebhookConsistencyQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly debug: { readonly __typename: 'CampaignDebug', readonly webhookConsistency: ReadonlyArray<{ readonly __typename: 'DataConsistencyNode', readonly day: string, readonly bigquery: any, readonly diff: any, readonly bigqueryInvalid: any | null, readonly bigtable: any }>, readonly webhookInvalidImpressions: ReadonlyArray<{ readonly __typename: 'InvalidImpressionsNode', readonly reason: string, readonly count: any, readonly exampleRecord: string } | null> | null } | null } } } | null };

export type ClaimPublisherQueryVariables = Exact<{
  href: Scalars['String'];
}>;


export type ClaimPublisherQuery = { readonly __typename: 'Query', readonly claim: { readonly __typename: 'Claim', readonly publisher: { readonly __typename: 'ClaimPublisherObject', readonly href: string | null, readonly title: string | null, readonly email: string | null, readonly name: string | null } | null } | null };

export type ClaimVerifyQueryVariables = Exact<{
  payload: Scalars['String'];
}>;


export type ClaimVerifyQuery = { readonly __typename: 'Query', readonly claim: { readonly __typename: 'Claim', readonly verify: { readonly __typename: 'ClaimPublisherObject', readonly href: string | null, readonly hash: string | null, readonly title: string | null, readonly email: string | null, readonly name: string | null, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null, readonly slug: string | null } | null } | null } | null };

export type GetEpisodeHourlyDownloadsQueryQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  podcastId: Scalars['ID'];
  id: Scalars['ID'];
  algorithm: InputMaybe<Scalars['String']>;
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  kind: InputMaybe<Scalars['String']>;
}>;


export type GetEpisodeHourlyDownloadsQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly podcast: { readonly __typename: 'PodcastObject', readonly id: string, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly downloads: { readonly __typename: 'DownloadsObject', readonly count: any | null, readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly count: any | null, readonly downloadClass: string | null } | null> | null } | null } | null } | null } } } | null };

export type GetFutureEpisodeQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  podcastId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetFutureEpisodeQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly podcast: { readonly __typename: 'PodcastObject', readonly id: string, readonly futureEpisode: { readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly expectedPublished: any } | null } } } | null };

export type GetFutureEpisodesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  podcastId: Scalars['ID'];
}>;


export type GetFutureEpisodesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly podcast: { readonly __typename: 'PodcastObject', readonly id: string, readonly futureEpisodes: ReadonlyArray<{ readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly expectedPublished: any } | null> | null } } } | null };

export type GetMeApprovalsQueryVariables = Exact<{
  state: InputMaybe<Scalars['String']>;
  campaignId: InputMaybe<Scalars['ID']>;
}>;


export type GetMeApprovalsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly dynamicApprovals: ReadonlyArray<{ readonly __typename: 'DynamicApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: DynamicApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null }>, readonly podcastApprovals: ReadonlyArray<{ readonly __typename: 'PodcastApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: PodcastApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null }>, readonly streamingApprovals: ReadonlyArray<{ readonly __typename: 'StreamingApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: StreamingApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignStreaming: { readonly __typename: 'CampaignStreamingObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null }> } | null };

export type GetMembersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetMembersQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly isAdmin: boolean, readonly domains: ReadonlyArray<{ readonly __typename: 'OrganizationDomainObject', readonly id: string, readonly domain: string, readonly createdAt: any }>, readonly memberships: ReadonlyArray<{ readonly __typename: 'MembershipObject', readonly id: string, readonly role: string | null, readonly roleDisplay: string | null, readonly createdAt: any, readonly user: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string } | null }> } } | null };

export type GetOrganizationArt19SecretQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrganizationArt19SecretQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly art19Secret: string | null } } | null };

export type OrganizationCampaignDebugQueryQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type OrganizationCampaignDebugQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly debug: { readonly __typename: 'CampaignDebug', readonly events: { readonly __typename: 'AttributionEvents', readonly hourly: ReadonlyArray<{ readonly __typename: 'AttributionEventsHourly', readonly hour: any | null, readonly action: string | null, readonly count: any | null } | null> | null } | null, readonly pixel: { readonly __typename: 'PixelDebug', readonly historical: ReadonlyArray<{ readonly __typename: 'PixelHistorical', readonly hour: any | null, readonly js: ReadonlyArray<{ readonly __typename: 'PixelHistoricalEvent', readonly name: string | null, readonly eventCounts: ReadonlyArray<{ readonly __typename: 'PixelHistoricalEventCount', readonly name: string | null, readonly value: any | null } | null> | null } | null> | null, readonly mobile: ReadonlyArray<{ readonly __typename: 'PixelHistoricalEvent', readonly name: string | null, readonly eventCounts: ReadonlyArray<{ readonly __typename: 'PixelHistoricalEventCount', readonly name: string | null, readonly value: any | null } | null> | null } | null> | null, readonly img: ReadonlyArray<{ readonly __typename: 'PixelHistoricalEvent', readonly name: string | null, readonly eventCounts: ReadonlyArray<{ readonly __typename: 'PixelHistoricalEventCount', readonly name: string | null, readonly value: any | null } | null> | null } | null> | null } | null> | null } | null } | null } } } | null };

export type OrganizationCampaignEpisodesQueryQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
}>;


export type OrganizationCampaignEpisodesQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaignEpisodes: ReadonlyArray<{ readonly __typename: 'CampaignEpisodeObject', readonly goal: any | null, readonly futureEpisode: { readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly expectedPublished: any } | null, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string }, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null } }> } } | null };

export type OrganizationGenericTagsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrganizationGenericTagsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly genericTags: ReadonlyArray<{ readonly __typename: 'GenericTagObject', readonly id: string, readonly title: string, readonly color: string }> } } | null };

export type OrganizationKeyDebugHistoricalQueryQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  key: Scalars['ID'];
  after: Scalars['String'];
  before: Scalars['String'];
}>;


export type OrganizationKeyDebugHistoricalQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly key: { readonly __typename: 'KeyObject', readonly key: string, readonly debug: { readonly __typename: 'PixelDebug', readonly hasData: boolean | null, readonly historical: ReadonlyArray<{ readonly __typename: 'PixelHistorical', readonly hour: any | null, readonly js: ReadonlyArray<{ readonly __typename: 'PixelHistoricalEvent', readonly name: string | null, readonly eventCounts: ReadonlyArray<{ readonly __typename: 'PixelHistoricalEventCount', readonly name: string | null, readonly value: any | null } | null> | null } | null> | null, readonly mobile: ReadonlyArray<{ readonly __typename: 'PixelHistoricalEvent', readonly name: string | null, readonly eventCounts: ReadonlyArray<{ readonly __typename: 'PixelHistoricalEventCount', readonly name: string | null, readonly value: any | null } | null> | null } | null> | null, readonly img: ReadonlyArray<{ readonly __typename: 'PixelHistoricalEvent', readonly name: string | null, readonly eventCounts: ReadonlyArray<{ readonly __typename: 'PixelHistoricalEventCount', readonly name: string | null, readonly value: any | null } | null> | null } | null> | null } | null> | null } | null } } } | null };

export type OrganizationKeyDebugNodesQueryQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  key: Scalars['ID'];
  action: InputMaybe<Scalars['String']>;
  showMobileOnly: InputMaybe<Scalars['Boolean']>;
}>;


export type OrganizationKeyDebugNodesQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly key: { readonly __typename: 'KeyObject', readonly key: string, readonly domain: string, readonly createdAt: any, readonly debug: { readonly __typename: 'PixelDebug', readonly query: { readonly __typename: 'PixelQuery', readonly count: any | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'PixelEvent', readonly key: string | null, readonly time: any | null, readonly action: string | null, readonly referrer: string | null, readonly referrerPath: string | null, readonly url: string | null, readonly urlPath: string | null, readonly urlDomain: string | null, readonly value: number | null, readonly currency: string | null, readonly productId: string | null, readonly productName: string | null, readonly productType: string | null, readonly productVendor: string | null, readonly discountCode: string | null, readonly newCustomer: string | null, readonly orderId: string | null, readonly quantity: any | null, readonly lineItems: string | null, readonly type: string | null, readonly category: string | null, readonly alias: string | null, readonly eventName: string | null, readonly userAgent: { readonly __typename: 'UserAgent', readonly os: { readonly __typename: 'UAOSObject', readonly family: string | null } | null, readonly device: { readonly __typename: 'UADeviceObject', readonly family: string | null } | null } | null } | null> | null } | null } | null } } } | null };

export type OrganizationKeyQueryQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  key: Scalars['ID'];
}>;


export type OrganizationKeyQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly key: { readonly __typename: 'KeyObject', readonly key: string, readonly domain: string, readonly createdAt: any, readonly alias: string, readonly installations: string, readonly conversionUrls: ReadonlyArray<{ readonly __typename: 'ConversionURLObject', readonly id: string, readonly url: string, readonly action: string | null, readonly value: number | null, readonly type: string | null, readonly category: string | null }>, readonly actionMaps: ReadonlyArray<{ readonly __typename: 'ActionMapObject', readonly id: string, readonly eventName: string, readonly action: string | null }>, readonly debug: { readonly __typename: 'PixelDebug', readonly hasData: boolean | null } | null, readonly pixelEventRecords: ReadonlyArray<{ readonly __typename: 'PixelEventRecordObject', readonly id: string, readonly name: string | null, readonly eventType: PixelEventRecordEventType, readonly installation: PixelEventRecordInstallation, readonly createdAt: any, readonly lastActivity: any | null, readonly lastActivityFlag: string | null, readonly category: string, readonly currency: string, readonly type: string, readonly discountCode: string, readonly newCustomer: string, readonly orderId: string, readonly value: string, readonly quantity: string, readonly productId: string, readonly productName: string, readonly productType: string, readonly productVendor: string, readonly variantId: string, readonly variantName: string, readonly lastUpdatedBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } } | null> | null } } } | null };

export type OrganizationOverviewBrandQueryQueryVariables = Exact<{
  after: Scalars['Date'];
  before: Scalars['Date'];
  id: Scalars['ID'];
  interval: InputMaybe<Scalars['String']>;
  spendByImpressions: InputMaybe<Scalars['Boolean']>;
}>;


export type OrganizationOverviewBrandQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly overview: { readonly __typename: 'OverviewObject', readonly brand: { readonly __typename: 'BrandOverviewObject', readonly count: any, readonly nodes: ReadonlyArray<{ readonly __typename: 'BrandOverviewNode', readonly attributedDownloads: number | null, readonly attributedDownloadsModeled: number | null, readonly attributedReach: number | null, readonly attributedReachModeled: number | null, readonly campaignDynamicId: string, readonly campaignId: string, readonly campaignKind: string | null, readonly campaignName: string | null, readonly code: string | null, readonly episodeId: string, readonly episodeTitle: string | null, readonly feedId: string, readonly households: number | null, readonly householdsModeled: number | null, readonly impressions: any | null, readonly installed: number | null, readonly installedModeled: number | null, readonly leads: number | null, readonly leadsModeled: number | null, readonly lineItemName: string | null, readonly podcastTitle: string | null, readonly published: any | null, readonly publisherName: string | null, readonly purchases: number | null, readonly purchasesModeled: number | null, readonly reach: any | null, readonly spend: number | null, readonly time: any | null, readonly value: number | null, readonly valueModeled: number | null, readonly views: number | null, readonly viewsModeled: number | null } | null> | null } | null } | null } } | null };

export type OrganizationQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type OrganizationQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly hasSeenAdAnalyticsWelcome: boolean, readonly adAnalyticsTutorialProgress: number, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly isLockedForTerms: boolean, readonly name: string, readonly slug: string, readonly kind: OrganizationKind, readonly mode: OrganizationMode, readonly downloadAlgorithm: OrganizationDownloadAlgorithm, readonly dynamicProvider: string | null, readonly streamingProvider: string | null, readonly showTerms: boolean, readonly showTermsReminder: boolean, readonly hasActivePixel: boolean, readonly isNielsenApproved: boolean, readonly isExperianApproved: boolean, readonly isSegmentsEnabled: boolean, readonly isAdvisor: boolean, readonly isManager: boolean, readonly meRole: string | null, readonly createdAt: any, readonly campaignsCount: number, readonly podcastsCount: number, readonly adStudioBusinessId: string | null, readonly linkingRequestState: string | null, readonly keys: ReadonlyArray<{ readonly __typename: 'KeyObject', readonly key: string, readonly role: KeyRole, readonly domain: string, readonly alias: string, readonly createdAt: any, readonly installations: string, readonly pixelEventRecords: ReadonlyArray<{ readonly __typename: 'PixelEventRecordObject', readonly id: string, readonly name: string | null } | null> | null }>, readonly companies: ReadonlyArray<{ readonly __typename: 'CompanyObject', readonly id: string, readonly slug: string, readonly name: string, readonly description: string | null, readonly url: string | null, readonly hasCampaigns: boolean | null, readonly image: { readonly __typename: 'MediaImageObject', readonly id: string, readonly width: number, readonly height: number, readonly src: string | null, readonly path: string } | null }>, readonly claims: ReadonlyArray<{ readonly __typename: 'LimitedCompanyClaimObject', readonly id: string | null, readonly state: string | null, readonly createdAt: any | null, readonly company: { readonly __typename: 'LimitedCompanyObject', readonly id: string | null, readonly name: string | null } | null }>, readonly managers: ReadonlyArray<{ readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null, readonly slug: string | null, readonly kind: string | null }>, readonly managing: ReadonlyArray<{ readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null, readonly slug: string | null, readonly kind: string | null }> } } | null };

export type OrganizationResearchReviewersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationResearchReviewersQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly reviewers: ReadonlyArray<{ readonly __typename: 'ReviewerObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null, readonly type: ReviewerType, readonly createdAt: any, readonly reviewsCount: number | null } | null> | null } | null } } | null };

export type GetPodcastHourlyDownloadsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  kind: InputMaybe<Scalars['String']>;
  algorithm: InputMaybe<Scalars['String']>;
}>;


export type GetPodcastHourlyDownloadsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly podcast: { readonly __typename: 'PodcastObject', readonly id: string, readonly downloads: { readonly __typename: 'DownloadsObject', readonly count: any | null, readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly count: any | null, readonly downloadClass: string | null } | null> | null } | null } } } | null };

export type GetPodcastQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetPodcastQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly podcast: { readonly __typename: 'PodcastObject', readonly id: string, readonly createdAt: any, readonly processingStartedAt: any | null, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly segmentOverlap: number | null, readonly description: string | null, readonly href: string, readonly episodesCount: number | null, readonly isExperianApproved: boolean, readonly isNielsenApproved: boolean, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null } } } | null };

export type GetPaginatedPodcasterCampaignEpisodesNodesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  podcastId: Scalars['ID'];
  campaignId: InputMaybe<Scalars['ID']>;
  offset: InputMaybe<Scalars['Int']>;
  limit: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  orderBy: InputMaybe<Scalars['String']>;
}>;


export type GetPaginatedPodcasterCampaignEpisodesNodesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly podcast: { readonly __typename: 'PodcastObject', readonly id: string, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly episodeNodes: { readonly __typename: 'EpisodeNode', readonly offset: number | null, readonly pages: number | null, readonly count: number | null, readonly hasNext: boolean | null, readonly hasPrev: boolean | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly published: any | null } | null> | null } | null } | null } } } | null };

export type GetPodcasterCampaignEpisodeQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  campaignPodcastId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetPodcasterCampaignEpisodeQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly isMegaphone: boolean | null, readonly isArt19: boolean | null } | null } | null, readonly campaignEpisode: { readonly __typename: 'CampaignEpisodeObject', readonly id: string, readonly goal: any | null, readonly cost: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly futureEpisode: { readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly expectedPublished: any, readonly closeEpisodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly placements: ReadonlyArray<{ readonly __typename: 'PlacementObject', readonly id: string, readonly startTime: number, readonly endTime: number, readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly duration: number, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } } | null> | null } | null> | null, readonly closeInCampaignEpisodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly placements: ReadonlyArray<{ readonly __typename: 'PlacementObject', readonly id: string, readonly startTime: number, readonly endTime: number, readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly duration: number, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } } | null> | null } | null> | null } | null } | null } } } | null };

export type GetPaginatedPodcasterCampaignFutureEpisodesNodesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  podcastId: Scalars['ID'];
  campaignId: InputMaybe<Scalars['ID']>;
  offset: InputMaybe<Scalars['Int']>;
  limit: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  orderBy: InputMaybe<Scalars['String']>;
}>;


export type GetPaginatedPodcasterCampaignFutureEpisodesNodesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly podcast: { readonly __typename: 'PodcastObject', readonly id: string, readonly futureEpisodeNodes: { readonly __typename: 'FutureEpisodeNodes', readonly offset: number | null, readonly pages: number | null, readonly count: number | null, readonly hasNext: boolean | null, readonly hasPrev: boolean | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly title: string, readonly expectedPublished: any } | null> | null } | null } } } | null };

export type GetPodcasterEpisodeQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  podcastId: Scalars['ID'];
  id: Scalars['ID'];
  algorithm: InputMaybe<Scalars['String']>;
}>;


export type GetPodcasterEpisodeQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly podcast: { readonly __typename: 'PodcastObject', readonly id: string, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly description: string | null, readonly published: any | null, readonly reviewed: boolean | null, readonly hasNoAds: boolean, readonly placementsCount: number | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly path: string | null } | null } | null, readonly placements: ReadonlyArray<{ readonly __typename: 'PlacementObject', readonly id: string, readonly startTime: number, readonly endTime: number, readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly mpegPath: string | null, readonly flacPath: string | null, readonly waveform: any | null, readonly words: any | null, readonly text: string | null, readonly duration: number, readonly state: AdState, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null, readonly product: { readonly __typename: 'ProductObject', readonly id: string, readonly name: string } | null, readonly sponsor: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } } | null> | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly count: any | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null, readonly duration: number | null, readonly mpegPath: string | null, readonly waveform: any | null } | null } | null } | null } } } | null };

export type PodcasterPodcastsQueryQueryVariables = Exact<{
  id: Scalars['ID'];
  campaignId: InputMaybe<Scalars['ID']>;
}>;


export type PodcasterPodcastsQueryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly podcasts: ReadonlyArray<{ readonly __typename: 'PodcastObject', readonly id: string, readonly isAdvisor: boolean, readonly processingStartedAt: any | null, readonly createdAt: any, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly href: string, readonly state: FeedState, readonly publisherName: string | null, readonly publisherEmail: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null }> } } | null };

export type GetUserAccessDetailQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  membershipId: Scalars['ID'];
}>;


export type GetUserAccessDetailQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly member: { readonly __typename: 'UserObject', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string }, readonly memberAccess: ReadonlyArray<{ readonly __typename: 'UserAccessObject', readonly id: string, readonly permission: string | null, readonly permissionDisplay: string | null, readonly objectPk: string, readonly appLabel: string | null, readonly model: string | null }>, readonly campaigns: { readonly __typename: 'CampaignFilterObject', readonly results: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly advertiser: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } | null> | null } } } | null };

export type GetBrandAdQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  feedId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetBrandAdQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly limitedCompany: { readonly __typename: 'LimitedCompanyObject', readonly id: string | null, readonly ads: ReadonlyArray<{ readonly __typename: 'LimitedAdObject', readonly id: string | null, readonly mpegPath: string | null, readonly waveform: string | null, readonly createdAt: string | null, readonly duration: number | null } | null> | null } } } | null };

export type GetAdvisorDataQueryVariables = Exact<{
  columns: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  filters: InputMaybe<ReadonlyArray<InputMaybe<AdvisorFilter>> | InputMaybe<AdvisorFilter>>;
  includeTestData: Scalars['Boolean'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  organizationId: Scalars['ID'];
  query: Scalars['String'];
  sort: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type GetAdvisorDataQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly results: { readonly __typename: 'AdvisorResults', readonly limit: number, readonly offset: number, readonly count: number, readonly rows: ReadonlyArray<{ readonly __typename: 'AdvisorRow', readonly id: string | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly subtitle: string | null, readonly summary: string | null, readonly href: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null, readonly cells: ReadonlyArray<{ readonly __typename: 'AdvisorCell', readonly id: string, readonly values: ReadonlyArray<{ readonly __typename: 'AdvisorCellValue', readonly type: string | null, readonly value: string | null, readonly filterId: string | null, readonly objectId: string | null } | null> | null } | null> | null } | null> | null } | null } | null } } | null };

export type AdvisorPodcastBrandsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  query: InputMaybe<Scalars['String']>;
  after: InputMaybe<Scalars['String']>;
}>;


export type AdvisorPodcastBrandsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly show: { readonly __typename: 'AdvisorShow', readonly id: string, readonly adPlacements: { readonly __typename: 'AdvisorShowAdPlacements', readonly count: number | null, readonly rows: ReadonlyArray<{ readonly __typename: 'AdvisorShowAdPlacement', readonly brand: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null, readonly episode: { readonly __typename: 'EpisodeObject', readonly published: any | null } | null } | null> | null } | null, readonly topBrands: { readonly __typename: 'AdvisorShowTopBrandsResults', readonly offset: number | null, readonly limit: number | null, readonly count: number | null, readonly rows: ReadonlyArray<{ readonly __typename: 'AdvisorShowTopBrand', readonly adCount: number | null, readonly episodeCount: number | null, readonly brand: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly industry: string | null, readonly industryDisplay: string | null } | null } | null> | null } | null } | null } | null } } | null };

export type GetAdvisorPodcastEpisodeDetailQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  feedId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetAdvisorPodcastEpisodeDetailQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly show: { readonly __typename: 'AdvisorShow', readonly id: string, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly episodeId: string | null, readonly href: string, readonly type: string, readonly duration: number | null, readonly length: string | null, readonly mpegPath: string | null, readonly waveform: any | null } | null, readonly placements: ReadonlyArray<{ readonly __typename: 'PlacementObject', readonly id: string, readonly startTime: number, readonly endTime: number, readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly mpegPath: string | null, readonly flacPath: string | null, readonly waveform: any | null, readonly duration: number, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } } | null> | null } | null } } | null } | null } } | null };

export type GetAdvisorPodcastEpisodesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['Int']>;
}>;


export type GetAdvisorPodcastEpisodesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly show: { readonly __typename: 'AdvisorShow', readonly id: string, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly placementsCount: number | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly duration: number | null } | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null> | null } } | null } | null } } | null };

export type AdvisorPodcastIndustriesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type AdvisorPodcastIndustriesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly show: { readonly __typename: 'AdvisorShow', readonly id: string, readonly industriesOverview: ReadonlyArray<{ readonly __typename: 'AdvisorShowIndustriesOverview', readonly adCount: number | null, readonly episodeCount: number | null, readonly industry: string, readonly percent: number | null, readonly totalAds: number | null } | null> | null, readonly topBrands: { readonly __typename: 'AdvisorShowTopBrandsResults', readonly rows: ReadonlyArray<{ readonly __typename: 'AdvisorShowTopBrand', readonly adCount: number | null, readonly episodeCount: number | null, readonly brand: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly industry: string | null, readonly industryDisplay: string | null } | null } | null> | null } | null } | null } | null } } | null };

export type GetPodcastSamePublisherQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetPodcastSamePublisherQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly show: { readonly __typename: 'AdvisorShow', readonly id: string, readonly samePublisher: ReadonlyArray<{ readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly summary: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null> | null } | null } | null } } | null };

export type GetPodcastSimilarAudienceQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetPodcastSimilarAudienceQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly show: { readonly __typename: 'AdvisorShow', readonly id: string, readonly similarAudiences: ReadonlyArray<{ readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly summary: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null> | null } | null } | null } } | null };

export type PublisherSearchQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  limit: Scalars['Int'];
  query: Scalars['String'];
}>;


export type PublisherSearchQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly publisherSearch: { readonly __typename: 'AdvisorPublisherSearch', readonly results: ReadonlyArray<{ readonly __typename: 'AdvisorPublisherSearchResult', readonly id: string | null, readonly name: string | null } | null> | null } | null } | null } } | null };

export type GetSavedSearchQueryVariables = Exact<{
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
}>;


export type GetSavedSearchQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly id: string, readonly savedSearch: { readonly __typename: 'AdvisorSavedSearchObject', readonly data: string | null, readonly id: string, readonly name: string, readonly orgDefault: boolean, readonly slug: string, readonly version: number, readonly updatedAt: any, readonly createdAt: any, readonly user: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } | null, readonly organization: { readonly __typename: 'UnAuthedOrganizationObject', readonly id: string | null, readonly name: string | null } | null } | null } | null } } | null };

export type GetSavedSearchesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type GetSavedSearchesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly id: string, readonly savedSearches: ReadonlyArray<{ readonly __typename: 'AdvisorSavedSearchObject', readonly data: string | null, readonly id: string, readonly name: string, readonly orgDefault: boolean, readonly version: number, readonly updatedAt: any, readonly createdAt: any, readonly user: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } | null, readonly organization: { readonly __typename: 'UnAuthedOrganizationObject', readonly id: string | null } | null } | null> | null } | null } } | null };

export type FeedSearchQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  offset: Scalars['Int'];
  limit: Scalars['Int'];
  publisherId: Scalars['ID'];
  query: Scalars['String'];
}>;


export type FeedSearchQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly feedSearch: { readonly __typename: 'FeedSearch', readonly count: number | null, readonly results: ReadonlyArray<{ readonly __typename: 'FeedSearchObject', readonly id: string, readonly title: string, readonly podcast: { readonly __typename: 'FeedSearchPodcastObject', readonly id: string | null, readonly organization: { readonly __typename: 'FeedSearchOrganizationObject', readonly id: string | null } | null } | null } | null> | null } } } | null };

export type GetAdvisorColumnsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  ids: ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
}>;


export type GetAdvisorColumnsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly id: string, readonly columnGroups: { readonly __typename: 'AdvisorColumnGroups', readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null } | null } } | null };

export type GetAdvisorPublishersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  query: InputMaybe<Scalars['String']>;
  publisherId: InputMaybe<Scalars['ID']>;
}>;


export type GetAdvisorPublishersQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly id: string, readonly columnGroups: { readonly __typename: 'AdvisorColumnGroups', readonly publishers: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null } | null } | null } } | null };

export type AssetFragment = { readonly __typename: 'AssetObject', readonly id: string, readonly name: string, readonly contentType: string, readonly width: number | null, readonly height: number | null, readonly size: number, readonly src: string | null };

export type AttributionConfigFragment = { readonly __typename: 'AttributionConfigObject', readonly id: string, readonly householdInterval: number, readonly cableInterval: number, readonly cellularInterval: number, readonly corporateInterval: number, readonly attributionInterval: number, readonly maxUsersPerHousehold: number };

export type CampaignDynamicEpisodeFragment = { readonly __typename: 'CampaignDynamicEpisodeObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null, readonly duration: number | null, readonly mpegPath: string | null, readonly waveform: any | null } | null } | null };

export type CampaignDynamicOldFragment = { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string, readonly art19Secret: string | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly dynamicType: string | null, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly providerName: CampaignDynamicProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignDynamicPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null }> };

export type CampaignDynamicPodcastFragment = { readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null };

export type CampaignEpisodeFragment = { readonly __typename: 'CampaignEpisodeObject', readonly id: string, readonly isBaseline: boolean, readonly startAt: any | null, readonly endAt: any | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly goal: any | null, readonly verified: boolean, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string }, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null } | null, readonly futureEpisode: { readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly expectedPublished: any } | null };

export type CampaignLinkFragment = { readonly __typename: 'CampaignLinkObject', readonly id: string, readonly name: string | null, readonly viewTotal: number | null, readonly clickTotal: number | null, readonly targetReachTotal: number | null, readonly targetDownloadTotal: number | null, readonly createdAt: any };

export type CampaignNoiseFragment = { readonly __typename: 'CampaignNoiseObject', readonly id: string, readonly name: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly targetImpressions: number | null, readonly usePublisherImpressions: boolean };

export type CampaignPodcastFragment = { readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly name: string | null, readonly isDynamic: boolean, readonly drops: number | null, readonly campaignEpisodesCount: number | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly hasPodsightsPrefix: boolean, readonly createdAt: any, readonly updatedAt: any, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly href: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null };

export type CampaignStreamingOldFragment = { readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly name: string, readonly isActive: boolean, readonly source: CampaignStreamingSource, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly verifiedReach: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly providerName: CampaignStreamingProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignStreamingStreams: ReadonlyArray<{ readonly __typename: 'CampaignStreamingStreamObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null }> };

export type CampaignStreamingStreamFragment = { readonly __typename: 'CampaignStreamingStreamObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null };

export type CampaignTargetFragment = { readonly __typename: 'CampaignTargetObject', readonly id: string, readonly reachTotal: number | null, readonly downloadTotal: number | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly href: string, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null, readonly src: string | null } | null } };

export type CompanyFragment = { readonly __typename: 'CompanyObject', readonly id: string, readonly slug: string, readonly name: string, readonly description: string | null, readonly url: string | null, readonly industry: string | null, readonly industryDisplay: string | null, readonly createdAt: any, readonly image: { readonly __typename: 'MediaImageObject', readonly id: string, readonly width: number, readonly height: number, readonly src: string | null, readonly path: string } | null };

export type DynamicApprovalFragment = { readonly __typename: 'DynamicApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: DynamicApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null };

export type PodcastApprovalFragment = { readonly __typename: 'PodcastApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: PodcastApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null };

export type PodcastFragment = { readonly __typename: 'PodcastObject', readonly id: string, readonly isAdvisor: boolean, readonly processingStartedAt: any | null, readonly createdAt: any, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly href: string, readonly state: FeedState, readonly publisherName: string | null, readonly publisherEmail: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null };

export type PodlinkDomainFragment = { readonly __typename: 'PodlinkDomainObject', readonly id: string, readonly slug: string, readonly title: string, readonly description: string | null };

export type ReviewerEpisodeFragment = { readonly __typename: 'EpisodeObject', readonly id: string, readonly published: any | null, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly processed: any | null, readonly placementsCount: number | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null };

export type StreamingApprovalFragment = { readonly __typename: 'StreamingApprovalObject', readonly id: string, readonly requestedAt: any, readonly updatedAt: any, readonly state: StreamingApprovalState, readonly comment: string | null, readonly rejectedReason: string | null, readonly campaignStreaming: { readonly __typename: 'CampaignStreamingObject', readonly id: string }, readonly updatedBy: { readonly __typename: 'UnAuthedUserObject', readonly email: string | null } | null, readonly requestedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requestedByOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null, readonly requestee: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null, readonly requesteeOrganization: { readonly __typename: 'ApprovalOrganization', readonly id: string, readonly name: string | null } | null };

export type UserAccessFragment = { readonly __typename: 'UserAccessObject', readonly id: string, readonly permission: string | null, readonly permissionDisplay: string | null, readonly objectPk: string, readonly appLabel: string | null, readonly model: string | null };

export type GetPodlinkDomainQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  slug: Scalars['String'];
}>;


export type GetPodlinkDomainQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly podlinkDomain: { readonly __typename: 'PodlinkDomainObject', readonly backgroundColor: string | null, readonly fontColor: string | null, readonly primaryColor: string | null, readonly secondaryColor: string | null, readonly id: string, readonly slug: string, readonly title: string, readonly description: string | null, readonly image: { readonly __typename: 'AssetObject', readonly id: string, readonly name: string, readonly contentType: string, readonly width: number | null, readonly height: number | null, readonly size: number, readonly src: string | null } | null, readonly favicon: { readonly __typename: 'AssetObject', readonly id: string, readonly name: string, readonly contentType: string, readonly width: number | null, readonly height: number | null, readonly size: number, readonly src: string | null } | null, readonly podcasts: ReadonlyArray<{ readonly __typename: 'PodcastIdAndFeedObject', readonly id: string | null, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly href: string, readonly state: FeedState, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null } | null> | null } } } | null };

export type GetPodlinkDomainsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type GetPodlinkDomainsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly podlinkDomains: ReadonlyArray<{ readonly __typename: 'PodlinkDomainObject', readonly id: string, readonly slug: string, readonly title: string, readonly description: string | null }>, readonly podcasts: ReadonlyArray<{ readonly __typename: 'PodcastObject', readonly id: string, readonly isAdvisor: boolean, readonly processingStartedAt: any | null, readonly createdAt: any, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly href: string, readonly state: FeedState, readonly publisherName: string | null, readonly publisherEmail: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null }> } } | null };

export type GetBrandsOverviewQueryVariables = Exact<{
  id: Scalars['ID'];
  after: InputMaybe<Scalars['String']>;
  query: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
  minAds: InputMaybe<Scalars['Int']>;
  maxAds: InputMaybe<Scalars['Int']>;
  minPodcasts: InputMaybe<Scalars['Int']>;
  maxPodcasts: InputMaybe<Scalars['Int']>;
  minEpisodes: InputMaybe<Scalars['Int']>;
  maxEpisodes: InputMaybe<Scalars['Int']>;
}>;


export type GetBrandsOverviewQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly brand: { readonly __typename: 'BrandObject', readonly brandsOverview: { readonly __typename: 'BrandsOverviewSearchResults', readonly total: any | null, readonly results: ReadonlyArray<{ readonly __typename: 'BrandsOverviewSearchResult', readonly id: string | null, readonly name: string | null, readonly slug: string | null, readonly adFirstPublished: any | null, readonly adsCount: number | null, readonly episodesCount: number | null, readonly feedsCount: number | null } | null> | null } | null } | null } | null } } | null };

export type GetResearchCompanyAdQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  companyId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetResearchCompanyAdQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly placements: ReadonlyArray<{ readonly __typename: 'PlacementObject', readonly id: string, readonly startTime: number, readonly endTime: number, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly description: string | null, readonly published: any | null, readonly placementsCount: number | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null } } | null> | null, readonly reviews: ReadonlyArray<{ readonly __typename: 'ReviewObject', readonly id: string, readonly startState: ReviewStartState, readonly endState: ReviewEndState, readonly duration: number | null, readonly createdAt: any, readonly updatedAt: any, readonly reviewer: { readonly __typename: 'ReviewerObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } } | null> | null } | null } | null } | null } } | null };

export type GetCompanyAdQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  companyId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCompanyAdQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly mpegPath: string | null, readonly flacPath: string | null, readonly waveform: any | null, readonly words: any | null, readonly text: string | null, readonly transcript: any | null, readonly duration: number, readonly state: AdState, readonly src: string | null, readonly product: { readonly __typename: 'ProductObject', readonly id: string, readonly name: string } | null, readonly sponsor: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } | null } | null } | null } } | null };

export type CompanyAdsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
}>;


export type CompanyAdsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly ads: ReadonlyArray<{ readonly __typename: 'AdObject', readonly id: string, readonly mpegPath: string | null, readonly flacPath: string | null, readonly waveform: any | null, readonly text: string | null, readonly duration: number, readonly state: AdState, readonly src: string | null, readonly firstPublished: any | null, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null, readonly product: { readonly __typename: 'ProductObject', readonly id: string, readonly name: string } | null, readonly sponsor: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } | null> | null } | null } | null } } | null };

export type GetCompanyDetailQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCompanyDetailQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly slug: string } | null } | null } } | null };

export type GetCompanyFeedQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  companyId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetCompanyFeedQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly description: string | null, readonly published: any | null, readonly reviewed: boolean | null, readonly hasNoAds: boolean, readonly placementsCount: number | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null } | null> | null } | null } | null } } | null };

export type GetCompanyFeedsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['Int']>;
}>;


export type GetCompanyFeedsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly feeds: ReadonlyArray<{ readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly avgRank: number | null, readonly episodesCount: number | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null> | null } | null } | null } } | null };

export type GetResearchCompanyQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetResearchCompanyQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly slug: string, readonly name: string, readonly description: string | null, readonly url: string | null, readonly industry: string | null, readonly industryDisplay: string | null, readonly createdAt: any, readonly image: { readonly __typename: 'MediaImageObject', readonly id: string, readonly width: number, readonly height: number, readonly src: string | null, readonly path: string } | null } | null } | null } } | null };

export type GetRecentCompanyAdsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
}>;


export type GetRecentCompanyAdsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly ads: ReadonlyArray<{ readonly __typename: 'AdObject', readonly id: string, readonly mpegPath: string | null, readonly flacPath: string | null, readonly waveform: any | null, readonly text: string | null, readonly duration: number, readonly state: AdState, readonly src: string | null, readonly firstPublished: any | null, readonly placements: ReadonlyArray<{ readonly __typename: 'PlacementObject', readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null } } | null> | null } | null> | null } | null } | null } } | null };

export type GetCompanySimilarByEpisodeQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['Int']>;
}>;


export type GetCompanySimilarByEpisodeQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly similarByEpisode: ReadonlyArray<{ readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly description: string | null, readonly url: string | null, readonly episodesCount: number | null, readonly image: { readonly __typename: 'MediaImageObject', readonly id: string, readonly width: number, readonly height: number, readonly src: string | null, readonly path: string } | null } | null> | null } | null } | null } } | null };

export type GetCompanySimilarByFeedQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['Int']>;
}>;


export type GetCompanySimilarByFeedQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly similarByFeed: ReadonlyArray<{ readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly description: string | null, readonly url: string | null, readonly feedsCount: number | null, readonly image: { readonly __typename: 'MediaImageObject', readonly id: string, readonly width: number, readonly height: number, readonly src: string | null, readonly path: string } | null } | null> | null } | null } | null } } | null };

export type GetCompanySimilarCompanyQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  companyId: Scalars['ID'];
  limit: InputMaybe<Scalars['Int']>;
}>;


export type GetCompanySimilarCompanyQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly description: string | null, readonly feeds: ReadonlyArray<{ readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null> | null, readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly placementsCount: number | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null } | null> | null } | null } | null } } | null };

export type GetEpisodeQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  feedId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetEpisodeQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly description: string | null, readonly published: any | null, readonly processed: any | null, readonly reviewed: boolean | null, readonly hasNoAds: boolean, readonly placementsCount: number | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly episodeId: string | null, readonly href: string, readonly type: string, readonly duration: number | null, readonly length: string | null, readonly mpegPath: string | null, readonly waveform: any | null } | null, readonly placements: ReadonlyArray<{ readonly __typename: 'PlacementObject', readonly id: string, readonly startTime: number, readonly endTime: number, readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly mpegPath: string | null, readonly flacPath: string | null, readonly waveform: any | null, readonly words: any | null, readonly transcript: any | null, readonly duration: number, readonly state: AdState, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly slug: string } | null, readonly product: { readonly __typename: 'ProductObject', readonly id: string, readonly name: string } | null, readonly sponsor: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } } | null> | null } | null } | null } | null } } | null };

export type FeedAdsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
}>;


export type FeedAdsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly ads: ReadonlyArray<{ readonly __typename: 'AdObject', readonly id: string, readonly mpegPath: string | null, readonly flacPath: string | null, readonly waveform: any | null, readonly text: string | null, readonly duration: number, readonly state: AdState, readonly src: string | null, readonly firstPublished: any | null, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null, readonly product: { readonly __typename: 'ProductObject', readonly id: string, readonly name: string } | null, readonly sponsor: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } | null> | null } | null } | null } } | null };

export type GetFeedCompaniesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
}>;


export type GetFeedCompaniesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly companies: ReadonlyArray<{ readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly description: string | null, readonly url: string | null, readonly adsCount: number | null, readonly adFirstPublished: any | null, readonly image: { readonly __typename: 'MediaImageObject', readonly id: string, readonly width: number, readonly height: number, readonly src: string | null, readonly path: string } | null } | null> | null } | null } | null } } | null };

export type FeedDayRankingsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  after: Scalars['String'];
}>;


export type FeedDayRankingsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly dayRankings: ReadonlyArray<{ readonly __typename: 'DayRankObject', readonly day: string | null, readonly rank: number | null } | null> | null } | null } | null } } | null };

export type FeedEpisodesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['Int']>;
}>;


export type FeedEpisodesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly createdAt: any, readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly description: string | null, readonly published: any | null, readonly reviewed: boolean | null, readonly hasNoAds: boolean, readonly placementsCount: number | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly duration: number | null, readonly length: string | null } | null } | null> | null } | null } | null } } | null };

export type GetFeedQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetFeedQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly description: string | null, readonly processing: boolean, readonly measure: boolean, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly podcast: { readonly __typename: 'PodcastObject', readonly id: string, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null, readonly slug: string | null } | null } | null } | null } | null } } | null };

export type GetPublisherCompaniesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  publisherSlug: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Scalars['String']>;
}>;


export type GetPublisherCompaniesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly publisher: { readonly __typename: 'PublisherObject', readonly id: string, readonly companies: ReadonlyArray<{ readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly description: string | null, readonly url: string | null, readonly adsCount: number | null, readonly adFirstPublished: any | null, readonly image: { readonly __typename: 'MediaImageObject', readonly id: string, readonly width: number, readonly height: number, readonly src: string | null, readonly path: string } | null } | null> | null } | null } | null } } | null };

export type GetPublisherDetailQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  publisherSlug: Scalars['String'];
}>;


export type GetPublisherDetailQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly publisher: { readonly __typename: 'PublisherObject', readonly id: string, readonly slug: string, readonly name: string, readonly podcasts: ReadonlyArray<{ readonly __typename: 'PodcastIdAndFeedObject', readonly id: string | null, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly href: string, readonly episodesCount: number | null, readonly lastPublished: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null } | null> | null } | null } | null } } | null };

export type GetResearchPublishersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  query: Scalars['String'];
}>;


export type GetResearchPublishersQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly publishers: ReadonlyArray<{ readonly __typename: 'PublisherObject', readonly id: string, readonly name: string } | null> | null } | null } } | null };

export type GetRankingsQueryVariables = Exact<{
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['Int']>;
}>;


export type GetRankingsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly rankings: ReadonlyArray<{ readonly __typename: 'RankObject', readonly id: string, readonly num: number, readonly createdAt: any, readonly episodesCount: number, readonly placementsCount: number, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly subtitle: string | null, readonly summary: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null } | null> | null } | null } } | null };

export type GetReviewerDetailQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  reviewerId: InputMaybe<Scalars['ID']>;
}>;


export type GetReviewerDetailQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly reviewer: { readonly __typename: 'ReviewerObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null, readonly totalEpisodeMinutes: number | null, readonly totalClassifyCount: number | null, readonly totalEpisodeCount: number | null, readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly hasNoAds: boolean, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly path: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly path: string | null } | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null, readonly reviews: ReadonlyArray<{ readonly __typename: 'ReviewObject', readonly id: string, readonly hasNoAds: boolean, readonly duration: number | null, readonly startState: ReviewStartState, readonly endState: ReviewEndState, readonly createdAt: any, readonly updatedAt: any, readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } | null } | null> | null } | null> | null } | null } | null } } | null };

export type GetReviewerQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  reviewerId: InputMaybe<Scalars['ID']>;
}>;


export type GetReviewerQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly reviewer: { readonly __typename: 'ReviewerObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null, readonly type: ReviewerType } | null } | null } } | null };

export type SearchQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  query: Scalars['String'];
  limit: InputMaybe<Scalars['Int']>;
}>;


export type SearchQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly search: { readonly __typename: 'SearchResults', readonly total: any | null, readonly results: ReadonlyArray<{ readonly __typename: 'SearchResult', readonly id: string | null, readonly kind: string | null, readonly title: string | null, readonly slug: string | null, readonly subtitle: string | null, readonly body: string | null, readonly imagePath: string | null, readonly duration: number | null, readonly published: any | null } | null> | null } | null } | null } } | null };

export type EpisodeMinutesByDayQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  after: InputMaybe<Scalars['Date']>;
  reviewerId: InputMaybe<Scalars['ID']>;
}>;


export type EpisodeMinutesByDayQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly reviewing: { readonly __typename: 'Reviewing', readonly episodeMinutesByDay: ReadonlyArray<{ readonly __typename: 'EpisodeMinutesByDay', readonly day: any, readonly minutes: number } | null> | null } | null } | null } } | null };

export type GetReviewerEpisodeQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  feedId: Scalars['ID'];
  id: Scalars['ID'];
  proxiedEnclosureId: InputMaybe<Scalars['ID']>;
}>;


export type GetReviewerEpisodeQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly research: { readonly __typename: 'ResearchObject', readonly feed: { readonly __typename: 'FeedObject', readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly path: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly path: string | null } | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly episodeId: string | null, readonly href: string, readonly type: string, readonly length: string | null, readonly duration: number | null, readonly mpegPath: string | null, readonly waveform: any | null, readonly proxiedEnclosure: { readonly __typename: 'ProxiedEnclosureObject', readonly id: string, readonly proxyName: string | null, readonly href: string, readonly type: string, readonly length: string | null, readonly mpegPath: string | null, readonly waveform: string | null } | null } | null, readonly placements: ReadonlyArray<{ readonly __typename: 'PlacementObject', readonly id: string, readonly startTime: number, readonly endTime: number, readonly ad: { readonly __typename: 'AdObject', readonly mpegPath: string | null, readonly waveform: any | null, readonly transcript: any | null, readonly state: AdState, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null, readonly product: { readonly __typename: 'ProductObject', readonly id: string, readonly name: string } | null, readonly sponsor: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null, readonly reviews: ReadonlyArray<{ readonly __typename: 'ReviewObject', readonly reviewer: { readonly __typename: 'ReviewerObject', readonly id: string, readonly email: string | null } } | null> | null } } | null> | null, readonly asr: { readonly __typename: 'Asr', readonly transcript: { readonly __typename: 'AsrTranscript', readonly created: any | null, readonly duration: number | null, readonly confidence: number | null, readonly transcript: string | null, readonly speakers: ReadonlyArray<{ readonly __typename: 'AsrSpeaker', readonly id: number | null, readonly ranges: ReadonlyArray<{ readonly __typename: 'AsrRange', readonly start: number | null, readonly end: number | null } | null> | null } | null> | null, readonly words: ReadonlyArray<{ readonly __typename: 'AsrTranscriptWord', readonly word: string | null, readonly start: number | null, readonly end: number | null, readonly confidence: number | null, readonly speaker: number | null, readonly punctuatedWord: string | null } | null> | null } | null, readonly labels: ReadonlyArray<{ readonly __typename: 'AsrRange', readonly start: number | null, readonly end: number | null } | null> | null } | null, readonly keywords: ReadonlyArray<{ readonly __typename: 'KeywordObject', readonly id: number | null, readonly timestamp: number | null, readonly confidence: number | null, readonly version: number | null } | null> | null, readonly campaignEpisodes: ReadonlyArray<{ readonly __typename: 'CampaignEpisodeObject', readonly id: string, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly advertiser: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } } }> } | null } | null } | null } } | null };

export type GetReviewerAdQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetReviewerAdQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly reviewing: { readonly __typename: 'Reviewing', readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly mpegPath: string | null, readonly flacPath: string | null, readonly waveform: any | null, readonly words: any | null, readonly state: AdState, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null, readonly product: { readonly __typename: 'ProductObject', readonly id: string, readonly name: string, readonly url: string | null, readonly discountCode: string | null } | null, readonly sponsor: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null, readonly placements: ReadonlyArray<{ readonly __typename: 'PlacementObject', readonly id: string, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null } | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly path: string | null } | null } } | null> | null, readonly guess: { readonly __typename: 'AdSearchResult', readonly id: string | null, readonly kind: string | null, readonly body: string | null, readonly companyId: string | null, readonly companyName: string | null, readonly productId: string | null, readonly productName: string | null, readonly maxScore: number | null, readonly score: number | null, readonly duration: number | null } | null, readonly reviews: ReadonlyArray<{ readonly __typename: 'ReviewObject', readonly id: string, readonly startState: ReviewStartState, readonly reviewer: { readonly __typename: 'ReviewerObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } } | null> | null } | null } | null } | null } } | null };

export type GetReviewerCompaniesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type GetReviewerCompaniesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly reviewing: { readonly __typename: 'Reviewing', readonly companies: ReadonlyArray<{ readonly __typename: 'CompanyObject', readonly adsCount: number | null, readonly id: string, readonly slug: string, readonly name: string, readonly description: string | null, readonly url: string | null, readonly industry: string | null, readonly industryDisplay: string | null, readonly createdAt: any, readonly image: { readonly __typename: 'MediaImageObject', readonly id: string, readonly width: number, readonly height: number, readonly src: string | null, readonly path: string } | null } | null> | null } | null } | null } } | null };

export type ReviewerEpisodesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type ReviewerEpisodesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly reviewing: { readonly __typename: 'Reviewing', readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly published: any | null, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly processed: any | null, readonly placementsCount: number | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null } | null> | null } | null } | null } } | null };

export type ReviewerTranscribableQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  after: Scalars['Date'];
  before: Scalars['Date'];
}>;


export type ReviewerTranscribableQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly reviewing: { readonly __typename: 'Reviewing', readonly transcribable: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly published: any | null, readonly title: string, readonly subtitle: string | null, readonly summary: string | null, readonly processed: any | null, readonly placementsCount: number | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null } | null> | null } | null } | null } } | null };

export type AdvisorColumnGroupFieldsFragment = { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null };

export type AdvisorColumnFieldsFragment = { readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null };

export type AudienceInsightFragment = { readonly __typename: 'AudienceInsightsMetricObject', readonly segment: string, readonly impressions: number | null, readonly cr: number | null, readonly crIndex: number | null };

export type CampaignAttributionFragment = { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly sum: { readonly __typename: 'AttributionUsersSum', readonly addtocarts: number | null, readonly addtocartsModeled: number | null, readonly checkouts: number | null, readonly checkoutsModeled: number | null, readonly leads: number | null, readonly leadsModeled: number | null, readonly pages: number | null, readonly pagesModeled: number | null, readonly products: number | null, readonly productsModeled: number | null, readonly purchases: number | null, readonly purchasesModeled: number | null, readonly sessions: number | null, readonly sessionsModeled: number | null, readonly users: any | null, readonly usersModeled: number | null, readonly value: number | null, readonly valueModeled: number | null } | null } | null };

export type CampaignDetailsFragment = { readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string, readonly state: CampaignState, readonly kind: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly createdAt: any, readonly allowBrandEditAccess: boolean, readonly isPublisherApproved: boolean, readonly isCreatedByBrand: boolean, readonly publisherDenyReason: string | null, readonly isPpa: boolean | null, readonly cost: number | null, readonly costToDate: number | null, readonly currency: CampaignCurrency, readonly goal: number | null, readonly multiplier: number, readonly hideMatchedDynamics: boolean, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly attributionTotal: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly downloadTotal: any | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly reachTotal: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly userReachTotal: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly genericTags: ReadonlyArray<{ readonly __typename: 'GenericTagObject', readonly id: string, readonly title: string, readonly color: string, readonly genericTagRelationships: ReadonlyArray<{ readonly __typename: 'GenericTagRelationshipObject', readonly id: string, readonly objectPk: string }> } | null> | null };

export type CampaignDynamicDeliveryFragment = { readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null };

export type CampaignDynamicFragment = { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string, readonly art19Secret: string | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly spotifyAdFormat: string | null, readonly source: CampaignDynamicSource, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly dynamicType: string | null, readonly providerName: CampaignDynamicProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignDynamicPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null }> };

export type CampaignOmniChartFieldsFragment = { readonly __typename: 'CampaignObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly hourlyVisitors: ReadonlyArray<{ readonly __typename: 'AttributionVisitorsHourly', readonly count: number | null, readonly hour: any | null } | null> | null } | null } | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly downloadClass: string | null, readonly count: any | null } | null> | null } | null, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null, readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly published: any | null } | null> | null } | null> | null };

export type CampaignStreamingDeliveryFragment = { readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null };

export type CampaignStreamingFragment = { readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly name: string, readonly isActive: boolean, readonly source: CampaignStreamingSource, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly verifiedReach: number | null, readonly spotifyAdFormat: string | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly providerName: CampaignStreamingProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignStreamingStreams: ReadonlyArray<{ readonly __typename: 'CampaignStreamingStreamObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null }> };

export type CampaignFragment = { readonly __typename: 'CampaignObject', readonly downloadAlgorithm: CampaignDownloadAlgorithm, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly goLiveDate: any | null, readonly goodReach: number | null, readonly householdReach: number | null, readonly isHiddenFromAgency: boolean, readonly isMegaphone: boolean, readonly lastBuilt: any | null, readonly mode: CampaignMode, readonly noiselessReach: number | null, readonly verifiedReach: number | null, readonly id: string, readonly name: string, readonly slug: string, readonly state: CampaignState, readonly kind: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly createdAt: any, readonly allowBrandEditAccess: boolean, readonly isPublisherApproved: boolean, readonly isCreatedByBrand: boolean, readonly publisherDenyReason: string | null, readonly isPpa: boolean | null, readonly cost: number | null, readonly costToDate: number | null, readonly currency: CampaignCurrency, readonly goal: number | null, readonly multiplier: number, readonly hideMatchedDynamics: boolean, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly attributionTotal: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly downloadTotal: any | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly reachTotal: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly userReachTotal: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly spotifyOrder: { readonly __typename: 'SpotifyOrderObject', readonly id: string, readonly name: string } | null, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string, readonly slug: string, readonly kind: OrganizationKind } | null, readonly advertiser: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly organization: { readonly __typename: 'UnAuthedOrganizationObject', readonly id: string | null, readonly name: string | null, readonly kind: string | null, readonly mode: string | null, readonly slug: string | null, readonly hasMembers: boolean | null } | null } | null, readonly payer: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null } | null, readonly pixels: ReadonlyArray<{ readonly __typename: 'KeyObject', readonly key: string, readonly role: KeyRole, readonly domain: string, readonly createdAt: any } | null> | null, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly sum: { readonly __typename: 'AttributionUsersSum', readonly addtocarts: number | null, readonly addtocartsModeled: number | null, readonly checkouts: number | null, readonly checkoutsModeled: number | null, readonly leads: number | null, readonly leadsModeled: number | null, readonly pages: number | null, readonly pagesModeled: number | null, readonly products: number | null, readonly productsModeled: number | null, readonly purchases: number | null, readonly purchasesModeled: number | null, readonly sessions: number | null, readonly sessionsModeled: number | null, readonly users: any | null, readonly usersModeled: number | null, readonly value: number | null, readonly valueModeled: number | null } | null } | null } | null, readonly campaignDynamics: ReadonlyArray<{ readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string, readonly art19Secret: string | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly spotifyAdFormat: string | null, readonly source: CampaignDynamicSource, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly dynamicType: string | null, readonly providerName: CampaignDynamicProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignDynamicPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null }> }>, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly name: string | null, readonly isDynamic: boolean, readonly drops: number | null, readonly campaignEpisodesCount: number | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly hasPodsightsPrefix: boolean, readonly createdAt: any, readonly updatedAt: any, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly href: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null } | null> | null, readonly campaignStreamings: ReadonlyArray<{ readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly name: string, readonly isActive: boolean, readonly source: CampaignStreamingSource, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly verifiedReach: number | null, readonly spotifyAdFormat: string | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly providerName: CampaignStreamingProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignStreamingStreams: ReadonlyArray<{ readonly __typename: 'CampaignStreamingStreamObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null }> }>, readonly campaignNoises: ReadonlyArray<{ readonly __typename: 'CampaignNoiseObject', readonly id: string, readonly name: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly targetImpressions: number | null, readonly usePublisherImpressions: boolean }>, readonly campaignTargets: ReadonlyArray<{ readonly __typename: 'CampaignTargetObject', readonly id: string, readonly reachTotal: number | null, readonly downloadTotal: number | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly href: string, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null, readonly src: string | null } | null } }>, readonly campaignLinks: ReadonlyArray<{ readonly __typename: 'CampaignLinkObject', readonly id: string, readonly name: string | null, readonly viewTotal: number | null, readonly clickTotal: number | null, readonly targetReachTotal: number | null, readonly targetDownloadTotal: number | null, readonly createdAt: any }>, readonly genericTags: ReadonlyArray<{ readonly __typename: 'GenericTagObject', readonly id: string, readonly title: string, readonly color: string, readonly genericTagRelationships: ReadonlyArray<{ readonly __typename: 'GenericTagRelationshipObject', readonly id: string, readonly objectPk: string }> } | null> | null };

export type DailyBillingRecordFragment = { readonly __typename: 'DailyCampaignBillingRecord', readonly advertiserId: string | null, readonly advertiserName: string | null, readonly campaignId: string | null, readonly campaignName: string | null, readonly downloadDate: any | null, readonly impressions: any | null, readonly publisherId: string | null, readonly publisherName: string | null };

export type ExportTypesFragment = { readonly __typename: 'ExportTypes', readonly id: string, readonly types: ReadonlyArray<{ readonly __typename: 'ExportType', readonly id: string, readonly name: string, readonly supportedParameters: ReadonlyArray<{ readonly __typename: 'ExportSupportedParameter', readonly id: string } | null> | null } | null> | null };

export type GenericTagFragment = { readonly __typename: 'GenericTagObject', readonly id: string, readonly title: string, readonly color: string, readonly genericTagRelationships: ReadonlyArray<{ readonly __typename: 'GenericTagRelationshipObject', readonly id: string, readonly objectPk: string }> };

export type LiftReportFieldsFragment = { readonly __typename: 'LiftReportObject', readonly id: string, readonly name: string | null, readonly delta: number, readonly runDate: any | null, readonly createdAt: any, readonly updatedAt: any, readonly state: LiftReportState, readonly impressionsStartAt: any | null, readonly impressionsEndAt: any | null, readonly useNoise: boolean, readonly clampUrl: string | null, readonly requestedBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string } | null };

export type LimitedCompanyMembersFragment = { readonly __typename: 'LimitedCompanyObject', readonly id: string | null, readonly name: string | null, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly members: ReadonlyArray<{ readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } | null> | null, readonly managers: ReadonlyArray<{ readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null } | null> | null } | null };

export type SavedExportFieldsFragment = { readonly __typename: 'SavedExportObject', readonly id: string, readonly name: string, readonly exportType: SavedExportExportType, readonly fields: any | null, readonly exportParameters: any | null, readonly orderBy: any | null, readonly updatedAt: any, readonly createdBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } | null, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null } | null, readonly lastExportInstance: { readonly __typename: 'ExportInstanceObject', readonly id: string, readonly status: string | null, readonly downloadUrl: string | null, readonly updatedAt: any, readonly exportJobStatus: { readonly __typename: 'ExportJobStatusObject', readonly id: string, readonly status: ExportJobStatusStatus, readonly failedReason: string | null } | null } | null };

export type SimpleBillingRecordFragment = { readonly __typename: 'SimpleBillingRecord', readonly downloadDate: any | null, readonly impressions: any | null };

export type SpotifyAudienceFieldsFragment = { readonly __typename: 'SpotifyAudienceObject', readonly group: string, readonly impressions: any };

export type SpotifyBrandLiftMessageResultFieldsFragment = { readonly __typename: 'SpotifyBrandLiftMessageResultObject', readonly totalResponses: number, readonly totalPositive: number, readonly controlAnswer1: number | null, readonly controlAnswer2: number | null, readonly controlAnswer3: number | null, readonly controlAnswer4: number | null, readonly controlAnswer5: number | null, readonly exposedAnswer1: number | null, readonly exposedAnswer2: number | null, readonly exposedAnswer3: number | null, readonly exposedAnswer4: number | null, readonly exposedAnswer5: number | null, readonly overall: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly male: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly female: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly age13To17: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly age18To24: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly age25To34: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly age35To44: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly age45Plus: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance } };

export type SpotifyBrandLiftFieldsFragment = { readonly __typename: 'SpotifyBrandLiftReportObject', readonly id: string, readonly name: string, readonly sblSurveyGamId: string, readonly isComplete: boolean, readonly isPublished: boolean, readonly isHiddenFromAgency: boolean, readonly startDate: any | null, readonly endDate: any | null, readonly impressions: number | null, readonly clicks: number | null, readonly reach: number | null, readonly frequency: number | null, readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string, readonly startAt: any | null, readonly endAt: any | null, readonly isHiddenFromAgency: boolean, readonly advertiser: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null }> };

export type SpotifyMessageResultsFragment = { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance };

export type UnMappedOrderPaginationFragment = { readonly __typename: 'SpotifyOrderObject', readonly id: string, readonly name: string, readonly startAt: any, readonly endAt: any, readonly cost: number, readonly brandMappingAttempt: { readonly __typename: 'CloudsenseBrandMappingAttemptObject', readonly confidence: CloudsenseBrandMappingAttemptConfidence, readonly attemptMethod: CloudsenseBrandMappingAttemptAttemptMethod, readonly cloudsenseAdvertiserId: string, readonly cloudsenseAdvertiserName: string, readonly cloudsenseBillingAccountName: string, readonly advertiserWebsite: string | null, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly hasActivePixel: boolean | null, readonly campaignCount: number, readonly organization: { readonly __typename: 'UnAuthedOrganizationObject', readonly name: string | null, readonly slug: string | null, readonly keys: ReadonlyArray<{ readonly __typename: 'KeyObject', readonly domain: string, readonly role: KeyRole } | null> | null } | null } | null } | null };

export type AddAdStudioAdAccountMutationVariables = Exact<{
  input: AddAdStudioAdAccountInput;
}>;


export type AddAdStudioAdAccountMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly addAdStudioAdAccount: { readonly __typename: 'AddAdStudioAdAccount', readonly success: boolean | null } | null };

export type AddOrganizationAdvisorMutationVariables = Exact<{
  input: AddAdvisorForOrganizationInput;
}>;


export type AddOrganizationAdvisorMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly addOrganizationAdvisor: { readonly __typename: 'AddAdvisorForOrganization', readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string } | null } | null };

export type AddPixelMutationVariables = Exact<{
  input: CreateKeyInput;
}>;


export type AddPixelMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly addPixel: { readonly __typename: 'CreateKey', readonly key: { readonly __typename: 'KeyObject', readonly key: string, readonly role: KeyRole, readonly domain: string, readonly createdAt: any } | null } | null };

export type AttributionCampaignPreRunMutationVariables = Exact<{
  input: AttributionCampaignPreRunInput;
}>;


export type AttributionCampaignPreRunMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly attributionCampaignPreRun: { readonly __typename: 'AttributionCampaignPreRun', readonly success: boolean | null } | null };

export type CreateApiKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateApiKeyMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createApiKey: { readonly __typename: 'CreateApiKey', readonly apiKey: { readonly __typename: 'ApiKeyObject', readonly key: string | null, readonly secret: string | null } | null } | null };

export type CreateCampaignDynamicDeliveryMutationVariables = Exact<{
  input: CreateCampaignDynamicDeliveryInput;
}>;


export type CreateCampaignDynamicDeliveryMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createCampaignDynamicDelivery: { readonly __typename: 'CreateCampaignDynamicDelivery', readonly success: boolean | null, readonly campaignDynamicDelivery: { readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null } | null } | null };

export type CreateCampaignDynamicMutationVariables = Exact<{
  input: CreateCampaignDynamicInput;
}>;


export type CreateCampaignDynamicMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createCampaignDynamic: { readonly __typename: 'CreateCampaignDynamic', readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string, readonly art19Secret: string | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly dynamicType: string | null, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly providerName: CampaignDynamicProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignDynamicPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null }> } | null } | null };

export type CreateCampaignStreamingDeliveryMutationVariables = Exact<{
  input: CreateCampaignStreamingDeliveryInput;
}>;


export type CreateCampaignStreamingDeliveryMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createCampaignStreamingDelivery: { readonly __typename: 'CreateCampaignStreamingDelivery', readonly success: boolean | null, readonly campaignStreamingDelivery: { readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null } | null } | null };

export type CreateCampaignMutationVariables = Exact<{
  input: CreateCampaignInput;
  organizationId: Scalars['ID'];
}>;


export type CreateCampaignMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createCampaign: { readonly __typename: 'CreateCampaign', readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string, readonly state: CampaignState, readonly kind: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly createdAt: any, readonly allowBrandEditAccess: boolean, readonly isPublisherApproved: boolean, readonly isCreatedByBrand: boolean, readonly publisherDenyReason: string | null, readonly isPpa: boolean | null, readonly cost: number | null, readonly costToDate: number | null, readonly currency: CampaignCurrency, readonly goal: number | null, readonly multiplier: number, readonly hideMatchedDynamics: boolean, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly attributionTotal: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly downloadTotal: any | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly reachTotal: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly userReachTotal: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly payer: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null } | null, readonly genericTags: ReadonlyArray<{ readonly __typename: 'GenericTagObject', readonly id: string, readonly title: string, readonly color: string, readonly genericTagRelationships: ReadonlyArray<{ readonly __typename: 'GenericTagRelationshipObject', readonly id: string, readonly objectPk: string }> } | null> | null } | null } | null };

export type CreateCompanyClaimMutationVariables = Exact<{
  input: CreateCompanyClaimInput;
}>;


export type CreateCompanyClaimMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createCompanyClaim: { readonly __typename: 'CreateCompanyClaim', readonly companyClaim: { readonly __typename: 'LimitedCompanyClaimObject', readonly id: string | null, readonly state: string | null, readonly createdAt: any | null, readonly company: { readonly __typename: 'LimitedCompanyObject', readonly id: string | null, readonly name: string | null } | null } | null } | null };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInput;
}>;


export type CreateCompanyMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createCompany: { readonly __typename: 'CreateCompany', readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } | null };

export type CreateExportInstanceMutationVariables = Exact<{
  input: CreateExportInstanceInput;
}>;


export type CreateExportInstanceMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createExportInstance: { readonly __typename: 'CreateExportInstance', readonly success: boolean, readonly exportInstance: { readonly __typename: 'ExportInstanceObject', readonly id: string, readonly downloadUrl: string | null, readonly status: string | null, readonly updatedAt: any, readonly exportJobStatus: { readonly __typename: 'ExportJobStatusObject', readonly id: string, readonly status: ExportJobStatusStatus, readonly failedReason: string | null } | null } | null } | null };

export type CreateExportTokenMutationVariables = Exact<{
  input: CreateExportTokenInput;
}>;


export type CreateExportTokenMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createExportToken: { readonly __typename: 'CreateExportToken', readonly token: string } | null };

export type CreateLiftReportMutationVariables = Exact<{
  input: CreateLiftReportInput;
}>;


export type CreateLiftReportMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createLiftReport: { readonly __typename: 'CreateLiftReport', readonly liftReport: { readonly __typename: 'LiftReportObject', readonly id: string, readonly name: string | null, readonly delta: number, readonly runDate: any | null, readonly createdAt: any, readonly updatedAt: any, readonly state: LiftReportState, readonly impressionsStartAt: any | null, readonly impressionsEndAt: any | null, readonly useNoise: boolean, readonly clampUrl: string | null, readonly requestedBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string } | null } | null } | null };

export type CreateSavedExportMutationVariables = Exact<{
  input: CreateSavedExportInput;
}>;


export type CreateSavedExportMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createSavedExport: { readonly __typename: 'CreateSavedExport', readonly success: boolean | null, readonly savedExport: { readonly __typename: 'SavedExportObject', readonly id: string, readonly name: string, readonly exportType: SavedExportExportType, readonly fields: any | null, readonly exportParameters: any | null, readonly orderBy: any | null, readonly updatedAt: any, readonly createdBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } | null, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null } | null, readonly lastExportInstance: { readonly __typename: 'ExportInstanceObject', readonly id: string, readonly status: string | null, readonly downloadUrl: string | null, readonly updatedAt: any, readonly exportJobStatus: { readonly __typename: 'ExportJobStatusObject', readonly id: string, readonly status: ExportJobStatusStatus, readonly failedReason: string | null } | null } | null } | null } | null };

export type CreateServiceAccountApiKeyMutationVariables = Exact<{
  input: CreateServiceAccountApiKeyInput;
}>;


export type CreateServiceAccountApiKeyMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createServiceAccountApiKey: { readonly __typename: 'CreateServiceAccountApiKey', readonly apiKey: { readonly __typename: 'ApiKeyObject', readonly key: string | null, readonly secret: string | null } | null } | null };

export type CreateTermsAndConditionsMutationVariables = Exact<{
  input: CreateTermsAndConditionsInput;
}>;


export type CreateTermsAndConditionsMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createTermsAndConditions: { readonly __typename: 'CreateTermsAndConditions', readonly success: boolean | null } | null };

export type CreateUserSkippedTermsMutationVariables = Exact<{
  input: CreateUserSkippedTermsInput;
}>;


export type CreateUserSkippedTermsMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly createUserSkippedTerms: { readonly __typename: 'CreateUserSkippedTerms', readonly success: boolean | null } | null };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { readonly __typename: 'Mutation', readonly createUser: { readonly __typename: 'CreateUser', readonly user: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly email: string } | null } | null };

export type DeleteCampaignDynamicDeliveryMutationVariables = Exact<{
  input: DeleteCampaignDynamicDeliveryInput;
}>;


export type DeleteCampaignDynamicDeliveryMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteCampaignDynamicDelivery: { readonly __typename: 'DeleteCampaignDynamicDelivery', readonly success: boolean | null } | null };

export type DeleteCampaignDynamicMutationVariables = Exact<{
  input: DeleteCampaignDynamicInput;
}>;


export type DeleteCampaignDynamicMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteCampaignDynamic: { readonly __typename: 'DeleteCampaignDynamic', readonly success: boolean } | null };

export type DeleteCampaignPodcastMutationVariables = Exact<{
  input: DeleteCampaignPodcastInput;
}>;


export type DeleteCampaignPodcastMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteCampaignPodcast: { readonly __typename: 'DeleteCampaignPodcast', readonly success: boolean } | null };

export type DeleteCampaignStreamingDeliveryMutationVariables = Exact<{
  input: DeleteCampaignStreamingDeliveryInput;
}>;


export type DeleteCampaignStreamingDeliveryMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteCampaignStreamingDelivery: { readonly __typename: 'DeleteCampaignStreamingDelivery', readonly success: boolean | null } | null };

export type DeleteCampaignStreamingMutationVariables = Exact<{
  input: DeleteCampaignStreamingInput;
}>;


export type DeleteCampaignStreamingMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteCampaignStreaming: { readonly __typename: 'DeleteCampaignStreaming', readonly success: boolean } | null };

export type DeleteLiftReportMutationVariables = Exact<{
  input: DeleteLiftReportInput;
}>;


export type DeleteLiftReportMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteLiftReport: { readonly __typename: 'DeleteLiftReport', readonly success: boolean | null } | null };

export type DeleteSavedExportMutationVariables = Exact<{
  input: DeleteSavedExportInput;
}>;


export type DeleteSavedExportMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly deleteSavedExport: { readonly __typename: 'DeleteSavedExport', readonly success: boolean } | null };

export type FillCampaignDynamicsMutationVariables = Exact<{
  input: FillCampaignDynamicsInput;
}>;


export type FillCampaignDynamicsMutation = { readonly __typename: 'Mutation', readonly fillCampaignDynamics: { readonly __typename: 'FillCampaignDynamics', readonly success: boolean | null } | null };

export type PublishSpotifyBrandLiftReportMutationVariables = Exact<{
  input: PublishSpotifyBrandLiftReportInput;
}>;


export type PublishSpotifyBrandLiftReportMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly publishSpotifyBrandLiftReport: { readonly __typename: 'PublishSpotifyBrandLiftReport', readonly success: boolean } | null };

export type PublisherApproveCampaignMutationVariables = Exact<{
  input: PublisherApproveCampaignInput;
}>;


export type PublisherApproveCampaignMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly publisherApproveCampaign: { readonly __typename: 'PublisherApproveCampaign', readonly success: boolean | null } | null };

export type PublisherRejectCampaignMutationVariables = Exact<{
  input: PublisherRejectCampaignInput;
}>;


export type PublisherRejectCampaignMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly publisherRejectCampaign: { readonly __typename: 'PublisherRejectCampaign', readonly success: boolean | null } | null };

export type RunLiftReportMutationVariables = Exact<{
  input: RunLiftReportInput;
}>;


export type RunLiftReportMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly runLiftReport: { readonly __typename: 'RunLiftReport', readonly liftReport: { readonly __typename: 'LiftReportObject', readonly id: string, readonly name: string | null, readonly delta: number, readonly runDate: any | null, readonly createdAt: any, readonly updatedAt: any, readonly state: LiftReportState, readonly impressionsStartAt: any | null, readonly impressionsEndAt: any | null, readonly useNoise: boolean, readonly clampUrl: string | null, readonly requestedBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string } | null } | null } | null };

export type SendVerifyEmailMutationVariables = Exact<{
  input: SendVerifyEmailInput;
}>;


export type SendVerifyEmailMutation = { readonly __typename: 'Mutation', readonly sendVerifyEmail: { readonly __typename: 'SendVerifyEmail', readonly success: boolean | null } | null };

export type SetAdAnalyticsTutorialProgressMutationVariables = Exact<{
  input: SetAdAnalyticsTutorialProgressInput;
}>;


export type SetAdAnalyticsTutorialProgressMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly setAdAnalyticsTutorialProgress: { readonly __typename: 'SetAdAnalyticsTutorialProgress', readonly success: boolean | null } | null };

export type SetHasSeenAdAnalyticsWelcomeMutationVariables = Exact<{
  input: SetHasSeenAdAnalyticsWelcomeInput;
}>;


export type SetHasSeenAdAnalyticsWelcomeMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly setHasSeenAdAnalyticsWelcome: { readonly __typename: 'SetHasSeenAdAnalyticsWelcome', readonly status: boolean | null } | null };

export type SyncUserEmailWithSpotifyAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncUserEmailWithSpotifyAccountMutation = { readonly __typename: 'Mutation', readonly syncUserEmailWithSpotifyAccount: { readonly __typename: 'SyncUserEmailWithSpotifyAccount', readonly success: boolean | null } | null };

export type UpdateAllowBrandEditAccessMutationVariables = Exact<{
  input: UpdateAllowBrandEditAccessInput;
}>;


export type UpdateAllowBrandEditAccessMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateAllowBrandEditAccess: { readonly __typename: 'UpdateAllowBrandEditAccess', readonly success: boolean | null } | null };

export type UpdateCampaignDynamicProviderMutationVariables = Exact<{
  input: UpdateCampaignDynamicProviderInput;
}>;


export type UpdateCampaignDynamicProviderMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCampaignDynamicProvider: { readonly __typename: 'UpdateCampaignDynamicProvider', readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string } | null } | null };

export type UpdateCampaignDynamicMutationVariables = Exact<{
  input: UpdateCampaignDynamicInput;
}>;


export type UpdateCampaignDynamicMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCampaignDynamic: { readonly __typename: 'UpdateCampaignDynamic', readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string, readonly art19Secret: string | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly spotifyAdFormat: string | null, readonly source: CampaignDynamicSource, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly dynamicType: string | null, readonly providerName: CampaignDynamicProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignDynamicPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null }> } | null } | null };

export type UpdateCampaignStreamingProviderMutationVariables = Exact<{
  input: UpdateCampaignStreamingProviderInput;
}>;


export type UpdateCampaignStreamingProviderMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCampaignStreamingProvider: { readonly __typename: 'UpdateCampaignStreamingProvider', readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string } | null } | null };

export type UpdateCampaignStreamingMutationVariables = Exact<{
  input: UpdateCampaignStreamingInput;
}>;


export type UpdateCampaignStreamingMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCampaignStreaming: { readonly __typename: 'UpdateCampaignStreaming', readonly campaignStreaming: { readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly name: string, readonly isActive: boolean, readonly source: CampaignStreamingSource, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly verifiedReach: number | null, readonly spotifyAdFormat: string | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly providerName: CampaignStreamingProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignStreamingStreams: ReadonlyArray<{ readonly __typename: 'CampaignStreamingStreamObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null }> } | null } | null };

export type UpdateCampaignMutationVariables = Exact<{
  input: UpdateCampaignInput;
}>;


export type UpdateCampaignMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCampaign: { readonly __typename: 'UpdateCampaign', readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly slug: string, readonly name: string, readonly cost: number | null, readonly goal: number | null, readonly updatedAt: any, readonly isHiddenFromAgency: boolean, readonly startAt: any | null, readonly endAt: any | null, readonly payer: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null } | null } | null } | null };

export type UpdateCompanyIndustryMutationVariables = Exact<{
  input: UpdateCompanyIndustryInput;
}>;


export type UpdateCompanyIndustryMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCompanyIndustry: { readonly __typename: 'UpdateCompanyIndustry', readonly company: { readonly __typename: 'CompanyObject', readonly industry: string | null } | null } | null };

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateCompany: { readonly __typename: 'UpdateCompany', readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly slug: string, readonly name: string, readonly description: string | null, readonly url: string | null, readonly industry: string | null, readonly industryDisplay: string | null, readonly createdAt: any, readonly image: { readonly __typename: 'MediaImageObject', readonly id: string, readonly width: number, readonly height: number, readonly src: string | null, readonly path: string } | null } | null } | null };

export type UpdateLiftReportMutationVariables = Exact<{
  input: UpdateLiftReportInput;
}>;


export type UpdateLiftReportMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateLiftReport: { readonly __typename: 'UpdateLiftReport', readonly liftReport: { readonly __typename: 'LiftReportObject', readonly id: string, readonly name: string | null, readonly delta: number, readonly runDate: any | null, readonly createdAt: any, readonly updatedAt: any, readonly state: LiftReportState, readonly impressionsStartAt: any | null, readonly impressionsEndAt: any | null, readonly useNoise: boolean, readonly clampUrl: string | null, readonly requestedBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string } | null } | null } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateOrganization: { readonly __typename: 'UpdateOrganization', readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string, readonly slug: string, readonly kind: OrganizationKind, readonly dynamicProvider: string | null, readonly streamingProvider: string | null } | null } | null };

export type UpdateSavedExportMutationVariables = Exact<{
  input: UpdateSavedExportInput;
}>;


export type UpdateSavedExportMutation = { readonly __typename: 'Mutation', readonly authed: { readonly __typename: 'Authed', readonly success: boolean | null } | null, readonly updateSavedExport: { readonly __typename: 'UpdateSavedExport', readonly success: boolean, readonly savedExport: { readonly __typename: 'SavedExportObject', readonly id: string, readonly name: string, readonly exportType: SavedExportExportType, readonly fields: any | null, readonly exportParameters: any | null, readonly orderBy: any | null, readonly updatedAt: any, readonly createdBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } | null, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null } | null, readonly lastExportInstance: { readonly __typename: 'ExportInstanceObject', readonly id: string, readonly status: string | null, readonly downloadUrl: string | null, readonly updatedAt: any, readonly exportJobStatus: { readonly __typename: 'ExportJobStatusObject', readonly id: string, readonly status: ExportJobStatusStatus, readonly failedReason: string | null } | null } | null } | null } | null };

export type AdAnalyticsTutorialProgressQueryVariables = Exact<{ [key: string]: never; }>;


export type AdAnalyticsTutorialProgressQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly adAnalyticsTutorialProgress: number } | null };

export type GetAdvisorOverlapColumnGroupsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  query: InputMaybe<Scalars['String']>;
  tags: Scalars['Boolean'];
  contentMaturity: Scalars['Boolean'];
  brands: Scalars['Boolean'];
  industries: Scalars['Boolean'];
  nielsen: Scalars['Boolean'];
  experian: Scalars['Boolean'];
  clearbit: Scalars['Boolean'];
  publishers: Scalars['Boolean'];
  radioMarkets: Scalars['Boolean'];
  overlap: Scalars['Boolean'];
  feedGrowth: Scalars['Boolean'];
}>;


export type GetAdvisorOverlapColumnGroupsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly id: string, readonly organizationId: string, readonly columnGroups: { readonly __typename: 'AdvisorColumnGroups', readonly general: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly tags?: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly contentMaturity?: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly brands?: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly industries?: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly nielsen?: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly experian?: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly clearbit?: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly publishers?: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly radioMarkets?: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly overlap?: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null, readonly feedGrowth?: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null } | null } | null } } | null };

export type AdvisorShowQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  includeTestData: Scalars['Boolean'];
}>;


export type AdvisorShowQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly show: { readonly __typename: 'AdvisorShow', readonly id: string, readonly affinity: any | null, readonly percentNewReach: number | null, readonly averageWeeklyReach: any | null, readonly averageMonthlyReach: any | null, readonly averageEpisodeLength: any | null, readonly averageWeeklyImpressions: any | null, readonly averageMonthlyImpressions: any | null, readonly adsDurationMean: number | null, readonly adsPerEpisodeMean: number | null, readonly cadence: string | null, readonly contentMaturity: number | null, readonly capabilities: ReadonlyArray<{ readonly __typename: 'AdvisorShowCapability', readonly id: string | null, readonly title: string | null, readonly category: string | null } | null> | null, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly summary: string | null, readonly description: string | null, readonly contactEmail: string | null, readonly publisherEmail: string | null, readonly tags: ReadonlyArray<{ readonly __typename: 'FeedTagObject', readonly id: string, readonly term: string | null } | null> | null, readonly podcast: { readonly __typename: 'PodcastObject', readonly id: string } | null, readonly trailer: { readonly __typename: 'EpisodeObject', readonly enclosure: { readonly __typename: 'EnclosureObject', readonly waveform: any | null, readonly duration: number | null, readonly mpegPath: string | null } | null } | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null }, readonly ad: { readonly __typename: 'AdObject', readonly id: string, readonly waveform: any | null, readonly duration: number, readonly mpegPath: string | null, readonly flacPath: string | null, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly publisher: { readonly __typename: 'PublisherObject', readonly id: string, readonly name: string, readonly slug: string } | null } | null } | null } } | null };

export type AudienceNielsenSegmentQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  podcastId: Scalars['ID'];
  classifications: ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type AudienceNielsenSegmentQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly organization: { readonly __typename: 'OrganizationObject', readonly advisor: { readonly __typename: 'Advisor', readonly podcast: { readonly __typename: 'LimitedPodcastObject', readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly nielsenSegments: ReadonlyArray<{ readonly __typename: 'NielsenSegment', readonly feedId: string | null, readonly classification: string | null, readonly topic: string | null, readonly uniqueHhCount: number | null, readonly uniqueNielsenMatching: any | null, readonly percentNielsenMatching: number | null, readonly metrics: ReadonlyArray<{ readonly __typename: 'NielsenMetric', readonly variable: string | null, readonly reach: number | null, readonly totalHouseholds: number | null, readonly podcastPercentOfPop: number | null, readonly indexPercentOfPop: number | null, readonly index: number | null } | null> | null } | null> | null } | null } | null } | null } } | null };

export type BrandLocationsOverviewQueryVariables = Exact<{
  id: Scalars['ID'];
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
  publisherIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  campaignIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type BrandLocationsOverviewQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly overview: { readonly __typename: 'OverviewObject', readonly impressions: { readonly __typename: 'ImpressionsObject', readonly locations: { readonly __typename: 'DownloadLocationsQuery', readonly count: number | null, readonly countries: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly total: any | null } | null> | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly region: string | null, readonly city: string | null, readonly latitude: number | null, readonly longitude: number | null, readonly count: any | null } | null> | null } | null } | null } | null } } | null };

export type CampaignAudienceInsightsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type CampaignAudienceInsightsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly audienceInsights: { readonly __typename: 'AudienceInsightsObject', readonly age: ReadonlyArray<{ readonly __typename: 'AudienceInsightsMetricObject', readonly segment: string, readonly impressions: number | null, readonly cr: number | null, readonly crIndex: number | null }>, readonly gender: ReadonlyArray<{ readonly __typename: 'AudienceInsightsMetricObject', readonly segment: string, readonly impressions: number | null, readonly cr: number | null, readonly crIndex: number | null }>, readonly podcastCategory: ReadonlyArray<{ readonly __typename: 'AudienceInsightsMetricObject', readonly segment: string, readonly impressions: number | null, readonly cr: number | null, readonly crIndex: number | null }>, readonly musicGenre: ReadonlyArray<{ readonly __typename: 'AudienceInsightsMetricObject', readonly segment: string, readonly impressions: number | null, readonly cr: number | null, readonly crIndex: number | null }>, readonly playlist: ReadonlyArray<{ readonly __typename: 'AudienceInsightsMetricObject', readonly segment: string, readonly impressions: number | null, readonly cr: number | null, readonly crIndex: number | null }>, readonly userSegment: ReadonlyArray<{ readonly __typename: 'AudienceInsightsMetricObject', readonly segment: string, readonly impressions: number | null, readonly cr: number | null, readonly crIndex: number | null }>, readonly device: ReadonlyArray<{ readonly __typename: 'AudienceInsightsMetricObject', readonly segment: string, readonly impressions: number | null, readonly cr: number | null, readonly crIndex: number | null }>, readonly format: ReadonlyArray<{ readonly __typename: 'AudienceInsightsMetricObject', readonly segment: string, readonly impressions: number | null, readonly cr: number | null, readonly crIndex: number | null }> } } } } | null };

export type CampaignConversionsRowsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  before: Scalars['String'];
  after: Scalars['String'];
}>;


export type CampaignConversionsRowsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly conversionRows: ReadonlyArray<{ readonly __typename: 'ConversionRowObject', readonly leadType: string | null, readonly leadCategory: string | null, readonly quantity: any | null, readonly avgValue: number | null, readonly totalValue: number | null } | null> | null } } } | null };

export type CampaignsDeliveriesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type CampaignsDeliveriesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaigns: { readonly __typename: 'CampaignFilterObject', readonly results: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly state: CampaignState, readonly slug: string, readonly kind: string | null, readonly createdAt: any, readonly advertiser: { readonly __typename: 'CompanyObject', readonly name: string } | null, readonly campaignDynamics: ReadonlyArray<{ readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string }> }>, readonly campaignStreamings: ReadonlyArray<{ readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string }> }> } | null> | null } } } | null };

export type CampaignDynamicTrackingProvidersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type CampaignDynamicTrackingProvidersQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly organization: { readonly __typename: 'OrganizationObject', readonly campaign: { readonly __typename: 'CampaignObject', readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly providerNames: ReadonlyArray<{ readonly __typename: 'ProviderNameObject', readonly providerName: string | null, readonly providerNameDisplay: string | null } | null> | null } | null } } } | null };

export type CampaignDynamicQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type CampaignDynamicQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string, readonly art19Secret: string | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly spotifyAdFormat: string | null, readonly source: CampaignDynamicSource, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly dynamicType: string | null, readonly providerName: CampaignDynamicProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignDynamicPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null }> } | null } } } | null };

export type CampaignLiftReportsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type CampaignLiftReportsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly liftReports: ReadonlyArray<{ readonly __typename: 'LiftReportObject', readonly id: string, readonly name: string | null, readonly delta: number, readonly runDate: any | null, readonly createdAt: any, readonly updatedAt: any, readonly state: LiftReportState, readonly impressionsStartAt: any | null, readonly impressionsEndAt: any | null, readonly useNoise: boolean, readonly clampUrl: string | null, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string, readonly startAt: any | null, readonly endAt: any | null } | null, readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string, readonly startAt: any | null, readonly endAt: any | null }>, readonly requestedBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string } | null }>, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly name: string | null, readonly isDynamic: boolean, readonly drops: number | null, readonly campaignEpisodesCount: number | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly hasPodsightsPrefix: boolean, readonly createdAt: any, readonly updatedAt: any, readonly campaignEpisodes: ReadonlyArray<{ readonly __typename: 'CampaignEpisodeObject', readonly id: string, readonly isBaseline: boolean, readonly startAt: any | null, readonly endAt: any | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly goal: any | null, readonly verified: boolean, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string }, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null } | null, readonly futureEpisode: { readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly expectedPublished: any } | null }>, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly href: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null } | null> | null } } } | null };

export type CampaignOverviewImpressionsPublishersQueryVariables = Exact<{
  id: Scalars['ID'];
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
  isMarketing: InputMaybe<Scalars['Boolean']>;
}>;


export type CampaignOverviewImpressionsPublishersQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaigns: { readonly __typename: 'CampaignFilterObject', readonly results: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string } | null } | null> | null }, readonly overview: { readonly __typename: 'OverviewObject', readonly impressions: { readonly __typename: 'ImpressionsObject', readonly publishers: ReadonlyArray<{ readonly __typename: 'ImpressionsPublisherObject', readonly id: string | null, readonly name: string | null, readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string } | null> | null } | null> | null } | null } | null } } | null };

export type CampaignSpotifyAudienceQueryVariables = Exact<{
  id: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type CampaignSpotifyAudienceQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly spotAudAge: ReadonlyArray<{ readonly __typename: 'SpotifyAudienceObject', readonly group: string, readonly impressions: any }>, readonly spotAudDevice: ReadonlyArray<{ readonly __typename: 'SpotifyAudienceObject', readonly group: string, readonly impressions: any }>, readonly spotAudFormat: ReadonlyArray<{ readonly __typename: 'SpotifyAudienceObject', readonly group: string, readonly impressions: any }>, readonly spotAudGender: ReadonlyArray<{ readonly __typename: 'SpotifyAudienceObject', readonly group: string, readonly impressions: any }>, readonly spotAudGenre: ReadonlyArray<{ readonly __typename: 'SpotifyAudienceObject', readonly group: string, readonly impressions: any }>, readonly spotAudPlaylist: ReadonlyArray<{ readonly __typename: 'SpotifyAudienceObject', readonly group: string, readonly impressions: any }>, readonly spotAudSegment: ReadonlyArray<{ readonly __typename: 'SpotifyAudienceObject', readonly group: string, readonly impressions: any }> } } } | null };

export type CampaignStateQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type CampaignStateQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly stateOverview: { readonly __typename: 'CampaignStateOverview', readonly pixel: { readonly __typename: 'CampaignPixel', readonly hasData: boolean | null } | null, readonly members: ReadonlyArray<{ readonly __typename: 'CampaignStateMember', readonly firstName: string | null, readonly lastName: string | null } | null> | null, readonly managers: ReadonlyArray<{ readonly __typename: 'CampaignStateManger', readonly name: string | null } | null> | null } | null } } } | null };

export type CampaignStreamingDownloadLocationsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type CampaignStreamingDownloadLocationsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignStreamings: ReadonlyArray<{ readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly downloads: { readonly __typename: 'DownloadsObject', readonly locations: { readonly __typename: 'DownloadLocationsQuery', readonly count: number | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly region: string | null, readonly city: string | null, readonly latitude: number | null, readonly longitude: number | null, readonly total: any | null } | null> | null, readonly countries: ReadonlyArray<{ readonly __typename: 'DownloadLocation', readonly country: string | null, readonly total: any | null } | null> | null } | null } | null }> } } } | null };

export type CampaignStreamingTrackingProvidersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type CampaignStreamingTrackingProvidersQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly organization: { readonly __typename: 'OrganizationObject', readonly campaign: { readonly __typename: 'CampaignObject', readonly campaignStreaming: { readonly __typename: 'CampaignStreamingObject', readonly providerNames: ReadonlyArray<{ readonly __typename: 'ProviderNameObject', readonly providerName: string | null, readonly providerNameDisplay: string | null } | null> | null } | null } } } | null };

export type CampaignStreamingQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type CampaignStreamingQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly campaignStreaming: { readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly name: string, readonly isActive: boolean, readonly source: CampaignStreamingSource, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly verifiedReach: number | null, readonly spotifyAdFormat: string | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly providerName: CampaignStreamingProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignStreamingStreams: ReadonlyArray<{ readonly __typename: 'CampaignStreamingStreamObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null }> } | null } } } | null };

export type CampaignTrackingUrlsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
}>;


export type CampaignTrackingUrlsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignDynamics: ReadonlyArray<{ readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string, readonly providerName: CampaignDynamicProviderName | null, readonly providerTrackingUrl: string | null, readonly providerNames: ReadonlyArray<{ readonly __typename: 'ProviderNameObject', readonly providerName: string | null, readonly providerNameDisplay: string | null } | null> | null, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }> }>, readonly campaignStreamings: ReadonlyArray<{ readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly name: string, readonly isActive: boolean, readonly providerName: CampaignStreamingProviderName | null, readonly providerTrackingUrl: string | null, readonly providerNames: ReadonlyArray<{ readonly __typename: 'ProviderNameObject', readonly providerName: string | null, readonly providerNameDisplay: string | null } | null> | null, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }> }> } } } | null };

export type CampaignQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  slug: Scalars['String'];
}>;


export type CampaignQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly downloadAlgorithm: CampaignDownloadAlgorithm, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly goLiveDate: any | null, readonly goodReach: number | null, readonly householdReach: number | null, readonly isHiddenFromAgency: boolean, readonly isMegaphone: boolean, readonly lastBuilt: any | null, readonly mode: CampaignMode, readonly noiselessReach: number | null, readonly verifiedReach: number | null, readonly id: string, readonly name: string, readonly slug: string, readonly state: CampaignState, readonly kind: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly createdAt: any, readonly allowBrandEditAccess: boolean, readonly isPublisherApproved: boolean, readonly isCreatedByBrand: boolean, readonly publisherDenyReason: string | null, readonly isPpa: boolean | null, readonly cost: number | null, readonly costToDate: number | null, readonly currency: CampaignCurrency, readonly goal: number | null, readonly multiplier: number, readonly hideMatchedDynamics: boolean, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly attributionTotal: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly downloadTotal: any | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly reachTotal: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly userReachTotal: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly spotifyOrder: { readonly __typename: 'SpotifyOrderObject', readonly id: string, readonly name: string } | null, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string, readonly slug: string, readonly kind: OrganizationKind } | null, readonly advertiser: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly organization: { readonly __typename: 'UnAuthedOrganizationObject', readonly id: string | null, readonly name: string | null, readonly kind: string | null, readonly mode: string | null, readonly slug: string | null, readonly hasMembers: boolean | null } | null } | null, readonly payer: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null } | null, readonly pixels: ReadonlyArray<{ readonly __typename: 'KeyObject', readonly key: string, readonly role: KeyRole, readonly domain: string, readonly createdAt: any } | null> | null, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly sum: { readonly __typename: 'AttributionUsersSum', readonly addtocarts: number | null, readonly addtocartsModeled: number | null, readonly checkouts: number | null, readonly checkoutsModeled: number | null, readonly leads: number | null, readonly leadsModeled: number | null, readonly pages: number | null, readonly pagesModeled: number | null, readonly products: number | null, readonly productsModeled: number | null, readonly purchases: number | null, readonly purchasesModeled: number | null, readonly sessions: number | null, readonly sessionsModeled: number | null, readonly users: any | null, readonly usersModeled: number | null, readonly value: number | null, readonly valueModeled: number | null } | null } | null } | null, readonly campaignDynamics: ReadonlyArray<{ readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string, readonly art19Secret: string | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly spotifyAdFormat: string | null, readonly source: CampaignDynamicSource, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly dynamicType: string | null, readonly providerName: CampaignDynamicProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignDynamicPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null }> }>, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly name: string | null, readonly isDynamic: boolean, readonly drops: number | null, readonly campaignEpisodesCount: number | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly hasPodsightsPrefix: boolean, readonly createdAt: any, readonly updatedAt: any, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly href: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null } | null> | null, readonly campaignStreamings: ReadonlyArray<{ readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly name: string, readonly isActive: boolean, readonly source: CampaignStreamingSource, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly verifiedReach: number | null, readonly spotifyAdFormat: string | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly providerName: CampaignStreamingProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignStreamingStreams: ReadonlyArray<{ readonly __typename: 'CampaignStreamingStreamObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null }> }>, readonly campaignNoises: ReadonlyArray<{ readonly __typename: 'CampaignNoiseObject', readonly id: string, readonly name: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly targetImpressions: number | null, readonly usePublisherImpressions: boolean }>, readonly campaignTargets: ReadonlyArray<{ readonly __typename: 'CampaignTargetObject', readonly id: string, readonly reachTotal: number | null, readonly downloadTotal: number | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly href: string, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null, readonly src: string | null } | null } }>, readonly campaignLinks: ReadonlyArray<{ readonly __typename: 'CampaignLinkObject', readonly id: string, readonly name: string | null, readonly viewTotal: number | null, readonly clickTotal: number | null, readonly targetReachTotal: number | null, readonly targetDownloadTotal: number | null, readonly createdAt: any }>, readonly genericTags: ReadonlyArray<{ readonly __typename: 'GenericTagObject', readonly id: string, readonly title: string, readonly color: string, readonly genericTagRelationships: ReadonlyArray<{ readonly __typename: 'GenericTagRelationshipObject', readonly id: string, readonly objectPk: string }> } | null> | null } } } | null };

export type CampaignsConfirmTrackingUrlsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type CampaignsConfirmTrackingUrlsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaigns: { readonly __typename: 'CampaignFilterObject', readonly results: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly state: CampaignState, readonly slug: string, readonly kind: string | null, readonly createdAt: any, readonly advertiser: { readonly __typename: 'CompanyObject', readonly name: string } | null, readonly campaignDynamics: ReadonlyArray<{ readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string }> }>, readonly campaignStreamings: ReadonlyArray<{ readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string }> }> } | null> | null } } } | null };

export type CampaignsForPublisherReviewQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  name: InputMaybe<Scalars['String']>;
  sort: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type CampaignsForPublisherReviewQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaigns: { readonly __typename: 'CampaignFilterObject', readonly resultsCount: number | null, readonly results: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly kind: string | null, readonly state: CampaignState, readonly slug: string, readonly startAt: any | null, readonly endAt: any | null, readonly createdAt: any, readonly advertiser: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } | null> | null } } } | null };

export type CampaignsImpressionsMaxQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type CampaignsImpressionsMaxQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaignsImpressionsMax: number | null } } | null };

export type CampaignsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  query: InputMaybe<CampaignFilterQuery>;
}>;


export type CampaignsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaigns: { readonly __typename: 'CampaignFilterObject', readonly resultsCount: number | null, readonly results: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string, readonly state: CampaignState, readonly kind: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly createdAt: any, readonly allowBrandEditAccess: boolean, readonly isPublisherApproved: boolean, readonly isCreatedByBrand: boolean, readonly publisherDenyReason: string | null, readonly isPpa: boolean | null, readonly cost: number | null, readonly costToDate: number | null, readonly currency: CampaignCurrency, readonly goal: number | null, readonly multiplier: number, readonly hideMatchedDynamics: boolean, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly attributionTotal: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly downloadTotal: any | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly reachTotal: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly userReachTotal: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly advertiser: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string } | null, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly downloadTotal: any | null } | null> | null, readonly genericTags: ReadonlyArray<{ readonly __typename: 'GenericTagObject', readonly id: string, readonly title: string, readonly color: string, readonly genericTagRelationships: ReadonlyArray<{ readonly __typename: 'GenericTagRelationshipObject', readonly id: string, readonly objectPk: string }> } | null> | null } | null> | null } } } | null };

export type CompanyIndustryQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type CompanyIndustryQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly companies: ReadonlyArray<{ readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly slug: string, readonly industry: string | null }> } } | null };

export type CompanyMembersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type CompanyMembersQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly limitedCompany: { readonly __typename: 'LimitedCompanyObject', readonly id: string | null, readonly name: string | null, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly members: ReadonlyArray<{ readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } | null> | null, readonly managers: ReadonlyArray<{ readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null } | null> | null } | null } } } | null };

export type AdvisorContentMaturityQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type AdvisorContentMaturityQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly id: string, readonly columnGroups: { readonly __typename: 'AdvisorColumnGroups', readonly contentMaturity: { readonly __typename: 'AdvisorColumnGroup', readonly title: string, readonly filterId: string | null, readonly columns: ReadonlyArray<{ readonly __typename: 'AdvisorColumn', readonly id: string, readonly description: string | null, readonly title: string, readonly type: string, readonly filterId: string | null, readonly filterIndex: number | null, readonly filterMax: number | null, readonly filterMin: number | null, readonly filterStddev: number | null, readonly filterType: string | null } | null> | null } | null } | null } | null } } | null };

export type DeleteCampaignDynamicReasonsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteCampaignDynamicReasonsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly deleteReasons: ReadonlyArray<{ readonly __typename: 'DeleteReasonObject', readonly deleteReason: string | null, readonly deleteReasonDisplay: string | null } | null> | null } | null } } } | null };

export type DeleteCampaignPodcastReasonsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type DeleteCampaignPodcastReasonsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly deleteReasons: ReadonlyArray<{ readonly __typename: 'DeleteReasonObject', readonly deleteReason: string | null, readonly deleteReasonDisplay: string | null } | null> | null } | null } } } | null };

export type ExportInstanceQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type ExportInstanceQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly exports: { readonly __typename: 'ExportObject', readonly id: string | null, readonly exportInstance: { readonly __typename: 'ExportInstanceObject', readonly id: string, readonly downloadUrl: string | null } | null } } } | null };

export type ExportInstancesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ExportInstancesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly exports: { readonly __typename: 'ExportObject', readonly id: string | null, readonly organizationId: string, readonly exportInstances: ReadonlyArray<{ readonly __typename: 'ExportInstanceObject', readonly id: string, readonly exportType: ExportInstanceExportType, readonly status: string | null, readonly updatedAt: any, readonly savedExport: { readonly __typename: 'SavedExportObject', readonly id: string, readonly name: string } | null, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null } | null, readonly createdBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } | null } | null> | null } } } | null };

export type ExportTypesColumnsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  typeId: Scalars['ID'];
}>;


export type ExportTypesColumnsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly exports: { readonly __typename: 'ExportObject', readonly id: string | null, readonly exportTypes: { readonly __typename: 'ExportTypes', readonly id: string, readonly columns: ReadonlyArray<{ readonly __typename: 'ExportTypeColumn', readonly id: string, readonly name: string | null } | null> | null } | null } } } | null };

export type ExportTypesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type ExportTypesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly exports: { readonly __typename: 'ExportObject', readonly id: string | null, readonly exportTypes: { readonly __typename: 'ExportTypes', readonly id: string, readonly types: ReadonlyArray<{ readonly __typename: 'ExportType', readonly id: string, readonly name: string, readonly supportedParameters: ReadonlyArray<{ readonly __typename: 'ExportSupportedParameter', readonly id: string } | null> | null } | null> | null } | null } } } | null };

export type FutureEpisodesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
}>;


export type FutureEpisodesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly futureEpisodes: ReadonlyArray<{ readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly expectedPublished: any, readonly podcast: { readonly __typename: 'PodcastIdAndFeedObject', readonly id: string | null, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null } | null } | null, readonly campaignEpisodes: ReadonlyArray<{ readonly __typename: 'CampaignEpisodeObject', readonly id: string, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly slug: string, readonly name: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string, readonly slug: string, readonly kind: OrganizationKind } | null, readonly advertiser: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null } } } | null> | null }> } } | null };

export type HasSeenAdAnalyticsWelcomeQueryVariables = Exact<{ [key: string]: never; }>;


export type HasSeenAdAnalyticsWelcomeQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly hasSeenAdAnalyticsWelcome: boolean } | null };

export type LiftReportPreCreateCampaignQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  campaignId: Scalars['ID'];
  after: Scalars['String'];
  before: Scalars['String'];
}>;


export type LiftReportPreCreateCampaignQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly count: any | null } | null> | null } | null, readonly stateOverview: { readonly __typename: 'CampaignStateOverview', readonly pixel: { readonly __typename: 'CampaignPixel', readonly historical: ReadonlyArray<{ readonly __typename: 'CampaignPixelHistorical', readonly day: any | null, readonly init: any | null, readonly lead: any | null, readonly purchase: any | null, readonly installed: any | null } | null> | null } | null } | null } } } | null };

export type LiftReportPreCreateQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  liftReportId: Scalars['ID'];
  after: Scalars['String'];
  before: Scalars['String'];
}>;


export type LiftReportPreCreateQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly liftReport: { readonly __typename: 'LiftReportObject', readonly campaign: { readonly __typename: 'CampaignObject', readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly count: any | null } | null> | null } | null, readonly stateOverview: { readonly __typename: 'CampaignStateOverview', readonly pixel: { readonly __typename: 'CampaignPixel', readonly historical: ReadonlyArray<{ readonly __typename: 'CampaignPixelHistorical', readonly day: any | null, readonly init: any | null, readonly lead: any | null, readonly purchase: any | null, readonly installed: any | null } | null> | null } | null } | null } | null, readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly count: any | null } | null> | null } | null, readonly stateOverview: { readonly __typename: 'CampaignStateOverview', readonly pixel: { readonly __typename: 'CampaignPixel', readonly historical: ReadonlyArray<{ readonly __typename: 'CampaignPixelHistorical', readonly day: any | null, readonly init: any | null, readonly lead: any | null, readonly purchase: any | null, readonly installed: any | null } | null> | null } | null } | null }> } } } | null };

export type LiftReportPreRunQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  liftReportId: Scalars['ID'];
}>;


export type LiftReportPreRunQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly liftReport: { readonly __typename: 'LiftReportObject', readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly kind: string | null, readonly slug: string, readonly name: string, readonly pixels: ReadonlyArray<{ readonly __typename: 'KeyObject', readonly key: string } | null> | null, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly campaignEpisodes: ReadonlyArray<{ readonly __typename: 'CampaignEpisodeObject', readonly id: string, readonly isBaseline: boolean, readonly startAt: any | null, readonly endAt: any | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly goal: any | null, readonly verified: boolean, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string }, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null } | null, readonly futureEpisode: { readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly expectedPublished: any } | null }> } | null> | null, readonly campaignDynamics: ReadonlyArray<{ readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string, readonly art19Secret: string | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly spotifyAdFormat: string | null, readonly source: CampaignDynamicSource, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly dynamicType: string | null, readonly providerName: CampaignDynamicProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignDynamicPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null }> }>, readonly campaignNoises: ReadonlyArray<{ readonly __typename: 'CampaignNoiseObject', readonly id: string, readonly name: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly targetImpressions: number | null, readonly usePublisherImpressions: boolean }> } | null, readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly kind: string | null, readonly slug: string, readonly name: string, readonly currency: CampaignCurrency, readonly pixels: ReadonlyArray<{ readonly __typename: 'KeyObject', readonly key: string } | null> | null, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly campaignEpisodes: ReadonlyArray<{ readonly __typename: 'CampaignEpisodeObject', readonly id: string, readonly isBaseline: boolean, readonly startAt: any | null, readonly endAt: any | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly goal: any | null, readonly verified: boolean, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string }, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly published: any | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly length: string | null } | null } | null, readonly futureEpisode: { readonly __typename: 'FutureEpisodeObject', readonly id: string, readonly title: string, readonly subtitle: string | null, readonly expectedPublished: any } | null }> } | null> | null, readonly campaignDynamics: ReadonlyArray<{ readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string, readonly art19Secret: string | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly spotifyAdFormat: string | null, readonly source: CampaignDynamicSource, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly dynamicType: string | null, readonly providerName: CampaignDynamicProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignDynamicPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null }> }>, readonly campaignNoises: ReadonlyArray<{ readonly __typename: 'CampaignNoiseObject', readonly id: string, readonly name: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly targetImpressions: number | null, readonly usePublisherImpressions: boolean }> }> } } } | null };

export type LiftReportQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  after: InputMaybe<Scalars['Int']>;
  before: InputMaybe<Scalars['Int']>;
}>;


export type LiftReportQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly liftReport: { readonly __typename: 'LiftReportObject', readonly id: string, readonly name: string | null, readonly delta: number, readonly runDate: any | null, readonly createdAt: any, readonly updatedAt: any, readonly state: LiftReportState, readonly impressionsStartAt: any | null, readonly impressionsEndAt: any | null, readonly useNoise: boolean, readonly clampUrl: string | null, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string, readonly startAt: any | null, readonly endAt: any | null, readonly currency: CampaignCurrency } | null, readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string, readonly startAt: any | null, readonly endAt: any | null, readonly currency: CampaignCurrency }>, readonly lift: { readonly __typename: 'Lift', readonly averages: ReadonlyArray<{ readonly __typename: 'LiftReportAveragesObject', readonly groupId: string | null, readonly groupType: string | null, readonly groupName: string | null, readonly groupCost: number | null, readonly kind: string | null, readonly avgInitValue: number | null, readonly avgInitPercentage: number | null, readonly avgPurchaseValue: number | null, readonly avgPurchasePercentage: number | null, readonly avgLeadValue: number | null, readonly avgLeadPercentage: number | null, readonly avgInstalledValue: number | null, readonly avgInstalledPercentage: number | null, readonly groupHouseholds: any | null, readonly groupReach: any | null, readonly multiplier: number | null, readonly campaignPodcast: { readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly path: string | null } | null } | null } | null, readonly campaignDynamic: { readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string } | null } | null> | null, readonly nodes: ReadonlyArray<{ readonly __typename: 'LiftReportWeekObject', readonly week: any | null, readonly groupId: string | null, readonly groupType: string | null, readonly groupName: string | null, readonly kind: string | null, readonly campaignId: string | null, readonly initValue: number | null, readonly initPercentage: number | null, readonly purchaseValue: number | null, readonly purchasePercentage: number | null, readonly leadValue: number | null, readonly leadPercentage: number | null, readonly installedValue: number | null, readonly installedPercentage: number | null } | null> | null } | null, readonly requestedBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string } | null } } } | null };

export type LiftReportsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type LiftReportsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly liftReports: ReadonlyArray<{ readonly __typename: 'LiftReportObject', readonly id: string, readonly name: string | null, readonly delta: number, readonly runDate: any | null, readonly createdAt: any, readonly updatedAt: any, readonly state: LiftReportState, readonly impressionsStartAt: any | null, readonly impressionsEndAt: any | null, readonly useNoise: boolean, readonly clampUrl: string | null, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string, readonly startAt: any | null, readonly endAt: any | null, readonly currency: CampaignCurrency } | null, readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string, readonly startAt: any | null, readonly endAt: any | null, readonly currency: CampaignCurrency }>, readonly requestedBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string } | null }> } } | null };

export type LimitedCompanyQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type LimitedCompanyQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly limitedCompany: { readonly __typename: 'LimitedCompanyObject', readonly id: string | null, readonly name: string | null, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly members: ReadonlyArray<{ readonly __typename: 'UnAuthedUserObject', readonly firstName: string | null, readonly lastName: string | null } | null> | null, readonly managers: ReadonlyArray<{ readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null } | null> | null } | null } } } | null };

export type LocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationsQuery = { readonly __typename: 'Query', readonly locations: ReadonlyArray<{ readonly __typename: 'LocationNameObject', readonly locationName: string, readonly locationNameDisplay: string } | null> };

export type MultiBillingRecordsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  after: Scalars['String'];
  before: Scalars['String'];
}>;


export type MultiBillingRecordsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly multiBillingRecords: { readonly __typename: 'MultiBillingRecords', readonly simpleBillingRecords: ReadonlyArray<{ readonly __typename: 'SimpleBillingRecord', readonly downloadDate: any | null, readonly impressions: any | null } | null> | null, readonly dailyCampaignBillingRecords: ReadonlyArray<{ readonly __typename: 'DailyCampaignBillingRecord', readonly advertiserId: string | null, readonly advertiserName: string | null, readonly campaignId: string | null, readonly campaignName: string | null, readonly downloadDate: any | null, readonly impressions: any | null, readonly publisherId: string | null, readonly publisherName: string | null } | null> | null } } } | null };

export type BuySideOrganizationQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type BuySideOrganizationQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string, readonly slug: string, readonly mode: OrganizationMode, readonly kind: OrganizationKind, readonly downloadAlgorithm: OrganizationDownloadAlgorithm, readonly meRole: string | null, readonly companies: ReadonlyArray<{ readonly __typename: 'CompanyObject', readonly id: string, readonly slug: string, readonly name: string, readonly description: string | null, readonly url: string | null, readonly hasCampaigns: boolean | null, readonly image: { readonly __typename: 'MediaImageObject', readonly id: string, readonly width: number, readonly height: number, readonly src: string | null, readonly path: string } | null, readonly organization: { readonly __typename: 'UnAuthedOrganizationObject', readonly id: string | null, readonly name: string | null, readonly kind: string | null, readonly slug: string | null, readonly keys: ReadonlyArray<{ readonly __typename: 'KeyObject', readonly key: string, readonly role: KeyRole, readonly domain: string, readonly createdAt: any } | null> | null } | null, readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly state: CampaignState } | null> | null }>, readonly managing: ReadonlyArray<{ readonly __typename: 'LimitedOrganizationObject', readonly id: string | null, readonly name: string | null, readonly slug: string | null, readonly kind: string | null }> } } | null };

export type OrganizationProvidersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type OrganizationProvidersQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly organization: { readonly __typename: 'OrganizationObject', readonly dynamicProviderOptions: ReadonlyArray<{ readonly __typename: 'ProviderNameObject', readonly providerName: string | null, readonly providerNameDisplay: string | null } | null> | null, readonly streamingProviderOptions: ReadonlyArray<{ readonly __typename: 'ProviderNameObject', readonly providerName: string | null, readonly providerNameDisplay: string | null } | null> | null } } | null };

export type OverviewImpressionsReachQueryVariables = Exact<{
  id: Scalars['ID'];
  after: InputMaybe<Scalars['Date']>;
  before: InputMaybe<Scalars['Date']>;
  campaignIds: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type OverviewImpressionsReachQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly overview: { readonly __typename: 'OverviewObject', readonly impressions: { readonly __typename: 'ImpressionsObject', readonly impressions: any | null, readonly reach: any | null } | null } | null } } | null };

export type PodcastEpisodesDetailQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
  after: Scalars['String'];
  algorithm: InputMaybe<Scalars['String']>;
  offset: InputMaybe<Scalars['Int']>;
  limit: InputMaybe<Scalars['Int']>;
}>;


export type PodcastEpisodesDetailQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly podcast: { readonly __typename: 'PodcastObject', readonly id: string, readonly createdAt: any, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly episodesCount: number | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly path: string | null } | null, readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly description: string | null, readonly hasNoAds: boolean, readonly published: any | null, readonly placementsCount: number | null, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly count: any | null } | null, readonly enclosure: { readonly __typename: 'EnclosureObject', readonly id: string, readonly duration: number | null } | null } | null> | null } | null } } } | null };

export type PodcastExperianTypesQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  podcastId: Scalars['ID'];
}>;


export type PodcastExperianTypesQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly organization: { readonly __typename: 'OrganizationObject', readonly advisor: { readonly __typename: 'Advisor', readonly podcast: { readonly __typename: 'LimitedPodcastObject', readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly mosaicTypes: ReadonlyArray<{ readonly __typename: 'MosaicTypes', readonly types: ReadonlyArray<{ readonly __typename: 'MosaicType', readonly name: string | null, readonly descr: string | null, readonly feat1: string | null, readonly feat2: string | null, readonly feat3: string | null, readonly feat4: string | null, readonly feat5: string | null, readonly feat6: string | null, readonly index: number | null, readonly percentOfPop: number | null } | null> | null } | null> | null } | null } | null } | null } } | null };

export type PodcastFeedSegmentsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  podcastId: Scalars['ID'];
}>;


export type PodcastFeedSegmentsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly organization: { readonly __typename: 'OrganizationObject', readonly advisor: { readonly __typename: 'Advisor', readonly podcast: { readonly __typename: 'LimitedPodcastObject', readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly experianSegments: ReadonlyArray<{ readonly __typename: 'ExperianSegment', readonly feedId: string | null, readonly classification: string | null, readonly topic: string | null, readonly uniqueHhCount: number | null, readonly uniqueExperianMatching: any | null, readonly percentExperianMatching: number | null, readonly metrics: ReadonlyArray<{ readonly __typename: 'ExperianMetric', readonly variable: string | null, readonly percentage: number | null, readonly nationalMeans: number | null, readonly index: number | null } | null> | null } | null> | null, readonly nielsenSegments: ReadonlyArray<{ readonly __typename: 'NielsenSegment', readonly feedId: string | null, readonly classification: string | null, readonly topic: string | null, readonly uniqueHhCount: number | null, readonly uniqueNielsenMatching: any | null, readonly percentNielsenMatching: number | null, readonly metrics: ReadonlyArray<{ readonly __typename: 'NielsenMetric', readonly variable: string | null, readonly reach: number | null, readonly totalHouseholds: number | null, readonly podcastPercentOfPop: number | null, readonly indexPercentOfPop: number | null, readonly index: number | null } | null> | null } | null> | null } | null } | null } | null } } | null };

export type PodcasterPodcastsQueryVariables = Exact<{
  id: Scalars['ID'];
  campaignId: InputMaybe<Scalars['ID']>;
}>;


export type PodcasterPodcastsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly podcasts: ReadonlyArray<{ readonly __typename: 'PodcastObject', readonly id: string, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string } | null }> } } | null };

export type PodcastsAudienceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PodcastsAudienceQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly podcasts: ReadonlyArray<{ readonly __typename: 'PodcastObject', readonly id: string, readonly createdAt: any, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly description: string | null, readonly href: string, readonly state: FeedState, readonly isNielsenApproved: boolean, readonly isExperianApproved: boolean, readonly image: { readonly __typename: 'ImageObject', readonly id: string, readonly href: string, readonly path: string | null } | null, readonly experianSegments: ReadonlyArray<{ readonly __typename: 'ExperianSegment', readonly classification: string | null, readonly topic: string | null, readonly uniqueHhCount: number | null, readonly uniqueExperianMatching: any | null, readonly percentExperianMatching: number | null, readonly metrics: ReadonlyArray<{ readonly __typename: 'ExperianMetric', readonly variable: string | null, readonly percentage: number | null, readonly index: number | null } | null> | null } | null> | null, readonly nielsenSegments: ReadonlyArray<{ readonly __typename: 'NielsenSegment', readonly classification: string | null, readonly topic: string | null, readonly uniqueHhCount: number | null, readonly uniqueNielsenMatching: any | null, readonly percentNielsenMatching: number | null, readonly metrics: ReadonlyArray<{ readonly __typename: 'NielsenMetric', readonly variable: string | null, readonly reach: number | null, readonly totalHouseholds: number | null, readonly podcastPercentOfPop: number | null, readonly indexPercentOfPop: number | null, readonly index: number | null } | null> | null } | null> | null } | null }> } } | null };

export type PublisherAffinityScoresQueryVariables = Exact<{
  orgId: Scalars['ID'];
  feedId: Scalars['ID'];
}>;


export type PublisherAffinityScoresQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly advisor: { readonly __typename: 'Advisor', readonly id: string, readonly publisherAffinityScores: ReadonlyArray<{ readonly __typename: 'PublisherAffinityScoreObject', readonly rank: number, readonly industry: string, readonly percentile: number }> | null } | null } } | null };

export type ReviewerAdMultiQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  feedId: InputMaybe<Scalars['ID']>;
  reviewedById: InputMaybe<Scalars['ID']>;
  offset: InputMaybe<Scalars['Int']>;
  includeUnknown: InputMaybe<Scalars['Boolean']>;
  state: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
}>;


export type ReviewerAdMultiQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly research: { readonly __typename: 'ResearchObject', readonly reviewing: { readonly __typename: 'Reviewing', readonly adsCount: number | null, readonly ads: ReadonlyArray<{ readonly __typename: 'AdObject', readonly id: string, readonly mpegPath: string | null, readonly flacPath: string | null, readonly waveform: any | null, readonly words: any | null, readonly state: AdState, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null, readonly product: { readonly __typename: 'ProductObject', readonly id: string, readonly name: string, readonly url: string | null, readonly discountCode: string | null } | null, readonly sponsor: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null, readonly placements: ReadonlyArray<{ readonly __typename: 'PlacementObject', readonly id: string, readonly episode: { readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null } | null } } | null> | null, readonly guess: { readonly __typename: 'AdSearchResult', readonly id: string | null, readonly kind: string | null, readonly body: string | null, readonly companyId: string | null, readonly companyName: string | null, readonly productId: string | null, readonly productName: string | null, readonly maxScore: number | null, readonly score: number | null, readonly duration: number | null } | null, readonly reviews: ReadonlyArray<{ readonly __typename: 'ReviewObject', readonly id: string, readonly startState: ReviewStartState, readonly reviewer: { readonly __typename: 'ReviewerObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } } | null> | null } | null> | null } | null } | null } } | null };

export type SavedExportQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type SavedExportQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly exports: { readonly __typename: 'ExportObject', readonly id: string | null, readonly savedExport: { readonly __typename: 'SavedExportObject', readonly id: string, readonly name: string, readonly exportType: SavedExportExportType, readonly fields: any | null, readonly exportParameters: any | null, readonly orderBy: any | null, readonly updatedAt: any, readonly createdBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } | null, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null } | null, readonly lastExportInstance: { readonly __typename: 'ExportInstanceObject', readonly id: string, readonly status: string | null, readonly downloadUrl: string | null, readonly updatedAt: any, readonly exportJobStatus: { readonly __typename: 'ExportJobStatusObject', readonly id: string, readonly status: ExportJobStatusStatus, readonly failedReason: string | null } | null } | null } | null } } } | null };

export type SavedExportsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SavedExportsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly exports: { readonly __typename: 'ExportObject', readonly id: string | null, readonly savedExports: ReadonlyArray<{ readonly __typename: 'SavedExportObject', readonly id: string, readonly name: string, readonly exportType: SavedExportExportType, readonly fields: any | null, readonly exportParameters: any | null, readonly orderBy: any | null, readonly updatedAt: any, readonly createdBy: { readonly __typename: 'LimitedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null } | null, readonly organization: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null } | null, readonly lastExportInstance: { readonly __typename: 'ExportInstanceObject', readonly id: string, readonly status: string | null, readonly downloadUrl: string | null, readonly updatedAt: any, readonly exportJobStatus: { readonly __typename: 'ExportJobStatusObject', readonly id: string, readonly status: ExportJobStatusStatus, readonly failedReason: string | null } | null } | null } | null> | null, readonly exportTypes: { readonly __typename: 'ExportTypes', readonly id: string, readonly types: ReadonlyArray<{ readonly __typename: 'ExportType', readonly id: string, readonly name: string, readonly supportedParameters: ReadonlyArray<{ readonly __typename: 'ExportSupportedParameter', readonly id: string } | null> | null } | null> | null } | null } } } | null };

export type SpotifyBrandLiftReportQueryVariables = Exact<{
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
}>;


export type SpotifyBrandLiftReportQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly spotifyBrandLiftReport: { readonly __typename: 'SpotifyBrandLiftReportObject', readonly id: string, readonly name: string, readonly sblSurveyGamId: string, readonly isComplete: boolean, readonly isPublished: boolean, readonly isHiddenFromAgency: boolean, readonly startDate: any | null, readonly endDate: any | null, readonly impressions: number | null, readonly clicks: number | null, readonly reach: number | null, readonly frequency: number | null, readonly messages: ReadonlyArray<{ readonly __typename: 'SpotifyBrandLiftMessageObject', readonly id: string, readonly messageType: SpotifyBrandLiftMessageMessageType, readonly messageTypeDisplay: string, readonly messageContents: ReadonlyArray<{ readonly __typename: 'SpotifyBrandLiftMessageContentObject', readonly id: string, readonly languageCode: string | null, readonly question: string | null, readonly answer1: string | null, readonly answer2: string | null, readonly answer3: string | null, readonly answer4: string | null, readonly answer5: string | null }>, readonly result: { readonly __typename: 'SpotifyBrandLiftMessageResultObject', readonly totalResponses: number, readonly totalPositive: number, readonly controlAnswer1: number | null, readonly controlAnswer2: number | null, readonly controlAnswer3: number | null, readonly controlAnswer4: number | null, readonly controlAnswer5: number | null, readonly exposedAnswer1: number | null, readonly exposedAnswer2: number | null, readonly exposedAnswer3: number | null, readonly exposedAnswer4: number | null, readonly exposedAnswer5: number | null, readonly overall: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly male: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly female: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly age13To17: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly age18To24: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly age25To34: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly age35To44: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance }, readonly age45Plus: { readonly __typename: 'MessageResultGroupObject', readonly controlTotal: number, readonly controlPositive: number, readonly exposedTotal: number, readonly exposedPositive: number, readonly controlPercentage: number, readonly exposedPercentage: number, readonly percentChange: number, readonly significance: Significance } } | null }>, readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string, readonly startAt: any | null, readonly endAt: any | null, readonly isHiddenFromAgency: boolean, readonly advertiser: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null }> } } } | null };

export type SpotifyBrandLiftReportsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type SpotifyBrandLiftReportsQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly spotifyBrandLiftReports: ReadonlyArray<{ readonly __typename: 'SpotifyBrandLiftReportObject', readonly id: string, readonly name: string, readonly sblSurveyGamId: string, readonly isComplete: boolean, readonly isPublished: boolean, readonly isHiddenFromAgency: boolean, readonly startDate: any | null, readonly endDate: any | null, readonly impressions: number | null, readonly clicks: number | null, readonly reach: number | null, readonly frequency: number | null, readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly slug: string, readonly startAt: any | null, readonly endAt: any | null, readonly isHiddenFromAgency: boolean, readonly advertiser: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string } | null }> }> } } | null };

export type SpotifySalesOrderQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  orderId: Scalars['ID'];
}>;


export type SpotifySalesOrderQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly spotifyOrder: { readonly __typename: 'SpotifyOrderObject', readonly id: string, readonly name: string, readonly createdAt: any, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly downloadTotal: any | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly reachTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly downloadAlgorithm: CampaignDownloadAlgorithm, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly goLiveDate: any | null, readonly goodReach: number | null, readonly householdReach: number | null, readonly isHiddenFromAgency: boolean, readonly isMegaphone: boolean, readonly lastBuilt: any | null, readonly mode: CampaignMode, readonly noiselessReach: number | null, readonly verifiedReach: number | null, readonly id: string, readonly name: string, readonly slug: string, readonly state: CampaignState, readonly kind: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly createdAt: any, readonly allowBrandEditAccess: boolean, readonly isPublisherApproved: boolean, readonly isCreatedByBrand: boolean, readonly publisherDenyReason: string | null, readonly isPpa: boolean | null, readonly cost: number | null, readonly costToDate: number | null, readonly currency: CampaignCurrency, readonly goal: number | null, readonly multiplier: number, readonly hideMatchedDynamics: boolean, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly attributionTotal: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly downloadTotal: any | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly reachTotal: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly userReachTotal: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly spotifyOrder: { readonly __typename: 'SpotifyOrderObject', readonly id: string, readonly name: string } | null, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string, readonly slug: string, readonly kind: OrganizationKind } | null, readonly advertiser: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly organization: { readonly __typename: 'UnAuthedOrganizationObject', readonly id: string | null, readonly name: string | null, readonly kind: string | null, readonly mode: string | null, readonly slug: string | null, readonly hasMembers: boolean | null } | null } | null, readonly payer: { readonly __typename: 'LimitedOrganizationObject', readonly id: string | null } | null, readonly pixels: ReadonlyArray<{ readonly __typename: 'KeyObject', readonly key: string, readonly role: KeyRole, readonly domain: string, readonly createdAt: any } | null> | null, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly sum: { readonly __typename: 'AttributionUsersSum', readonly addtocarts: number | null, readonly addtocartsModeled: number | null, readonly checkouts: number | null, readonly checkoutsModeled: number | null, readonly leads: number | null, readonly leadsModeled: number | null, readonly pages: number | null, readonly pagesModeled: number | null, readonly products: number | null, readonly productsModeled: number | null, readonly purchases: number | null, readonly purchasesModeled: number | null, readonly sessions: number | null, readonly sessionsModeled: number | null, readonly users: any | null, readonly usersModeled: number | null, readonly value: number | null, readonly valueModeled: number | null } | null } | null } | null, readonly campaignDynamics: ReadonlyArray<{ readonly __typename: 'CampaignDynamicObject', readonly id: string, readonly name: string, readonly art19Secret: string | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly spotifyAdFormat: string | null, readonly source: CampaignDynamicSource, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly expectedStartAt: any | null, readonly expectedEndAt: any | null, readonly dynamicType: string | null, readonly providerName: CampaignDynamicProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignDynamicDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignDynamicPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignDynamicPodcastObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null }> }>, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly name: string | null, readonly isDynamic: boolean, readonly drops: number | null, readonly campaignEpisodesCount: number | null, readonly isPreRoll: boolean, readonly isMidRoll: boolean, readonly isPostRoll: boolean, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly hasPodsightsPrefix: boolean, readonly createdAt: any, readonly updatedAt: any, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly href: string | null, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null } | null> | null, readonly campaignStreamings: ReadonlyArray<{ readonly __typename: 'CampaignStreamingObject', readonly id: string, readonly name: string, readonly isActive: boolean, readonly source: CampaignStreamingSource, readonly discountCode: string | null, readonly discountUrl: string | null, readonly effectiveUrl: string | null, readonly duration: number | null, readonly goal: number | null, readonly cost: number | null, readonly costToDate: number | null, readonly verifiedReach: number | null, readonly spotifyAdFormat: string | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null, readonly providerName: CampaignStreamingProviderName | null, readonly providerTrackingUrl: string | null, readonly isBaseline: boolean, readonly createdAt: any, readonly updatedAt: any, readonly deliveries: ReadonlyArray<{ readonly __typename: 'CampaignStreamingDeliveryObject', readonly id: string, readonly viewedAt: any, readonly viewedBy: { readonly __typename: 'UnAuthedUserObject', readonly id: string, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null } | null }>, readonly campaignStreamingStreams: ReadonlyArray<{ readonly __typename: 'CampaignStreamingStreamObject', readonly id: string, readonly cost: number | null, readonly costToDate: number | null, readonly downloadTotal: any | null, readonly reachTotal: number | null, readonly attributionTotal: number | null, readonly userTotal: number | null, readonly userTotalModeled: number | null, readonly productTotal: number | null, readonly productTotalModeled: number | null, readonly addtocartTotal: number | null, readonly addtocartTotalModeled: number | null, readonly checkoutTotal: number | null, readonly checkoutTotalModeled: number | null, readonly purchaseTotal: number | null, readonly purchaseTotalModeled: number | null, readonly leadTotal: number | null, readonly leadTotalModeled: number | null, readonly valueTotal: number | null, readonly valueTotalModeled: number | null, readonly installedTotal: number | null, readonly installedTotalModeled: number | null, readonly targetDownloadTotal: number | null, readonly targetReachTotal: number | null, readonly startAt: any | null, readonly endAt: any | null }> }>, readonly campaignNoises: ReadonlyArray<{ readonly __typename: 'CampaignNoiseObject', readonly id: string, readonly name: string | null, readonly startAt: any | null, readonly endAt: any | null, readonly targetImpressions: number | null, readonly usePublisherImpressions: boolean }>, readonly campaignTargets: ReadonlyArray<{ readonly __typename: 'CampaignTargetObject', readonly id: string, readonly reachTotal: number | null, readonly downloadTotal: number | null, readonly podcast: { readonly __typename: 'PodcastIdObject', readonly id: string | null } | null, readonly feed: { readonly __typename: 'FeedObject', readonly id: string, readonly title: string, readonly href: string, readonly description: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null, readonly src: string | null } | null } }>, readonly campaignLinks: ReadonlyArray<{ readonly __typename: 'CampaignLinkObject', readonly id: string, readonly name: string | null, readonly viewTotal: number | null, readonly clickTotal: number | null, readonly targetReachTotal: number | null, readonly targetDownloadTotal: number | null, readonly createdAt: any }>, readonly genericTags: ReadonlyArray<{ readonly __typename: 'GenericTagObject', readonly id: string, readonly title: string, readonly color: string, readonly genericTagRelationships: ReadonlyArray<{ readonly __typename: 'GenericTagRelationshipObject', readonly id: string, readonly objectPk: string }> } | null> | null }> } } } | null };

export type SpotifySalesOrdersQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type SpotifySalesOrdersQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly spotifyOrders: ReadonlyArray<{ readonly __typename: 'SpotifyOrderObject', readonly id: string, readonly name: string, readonly downloadTotal: any | null, readonly createdAt: any, readonly campaigns: ReadonlyArray<{ readonly __typename: 'CampaignObject', readonly id: string, readonly expectedEndAt: any | null, readonly goal: number | null, readonly state: CampaignState }> }> } } | null };

export type SuperCampaignOmniChartQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  id1: Scalars['ID'];
  id2: InputMaybe<Scalars['ID']>;
  id3: InputMaybe<Scalars['ID']>;
  id4: InputMaybe<Scalars['ID']>;
  include2: Scalars['Boolean'];
  include3: Scalars['Boolean'];
  include4: Scalars['Boolean'];
  after: InputMaybe<Scalars['String']>;
  before: InputMaybe<Scalars['String']>;
}>;


export type SuperCampaignOmniChartQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign1: { readonly __typename: 'CampaignObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly hourlyVisitors: ReadonlyArray<{ readonly __typename: 'AttributionVisitorsHourly', readonly count: number | null, readonly hour: any | null } | null> | null } | null } | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly downloadClass: string | null, readonly count: any | null } | null> | null } | null, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null, readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly published: any | null } | null> | null } | null> | null }, readonly campaign2: { readonly __typename: 'CampaignObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly hourlyVisitors: ReadonlyArray<{ readonly __typename: 'AttributionVisitorsHourly', readonly count: number | null, readonly hour: any | null } | null> | null } | null } | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly downloadClass: string | null, readonly count: any | null } | null> | null } | null, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null, readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly published: any | null } | null> | null } | null> | null }, readonly campaign3: { readonly __typename: 'CampaignObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly hourlyVisitors: ReadonlyArray<{ readonly __typename: 'AttributionVisitorsHourly', readonly count: number | null, readonly hour: any | null } | null> | null } | null } | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly downloadClass: string | null, readonly count: any | null } | null> | null } | null, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null, readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly published: any | null } | null> | null } | null> | null }, readonly campaign4: { readonly __typename: 'CampaignObject', readonly id: string, readonly attribution: { readonly __typename: 'AttributionObject', readonly users: { readonly __typename: 'AttributionUsers', readonly hourlyVisitors: ReadonlyArray<{ readonly __typename: 'AttributionVisitorsHourly', readonly count: number | null, readonly hour: any | null } | null> | null } | null } | null, readonly downloads: { readonly __typename: 'DownloadsObject', readonly hourly: ReadonlyArray<{ readonly __typename: 'IABHourlyDownload', readonly hour: any | null, readonly downloadClass: string | null, readonly count: any | null } | null> | null } | null, readonly campaignPodcasts: ReadonlyArray<{ readonly __typename: 'CampaignPodcastObject', readonly id: string, readonly feed: { readonly __typename: 'LimitedFeedObject', readonly id: string | null, readonly title: string | null, readonly image: { readonly __typename: 'ImageObject', readonly href: string, readonly id: string, readonly path: string | null } | null } | null, readonly episodes: ReadonlyArray<{ readonly __typename: 'EpisodeObject', readonly id: string, readonly title: string, readonly published: any | null } | null> | null } | null> | null } } } | null };

export type UnmappedSpotifyOrdersQueryVariables = Exact<{
  nameSearch: InputMaybe<Scalars['String']>;
  limit: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
}>;


export type UnmappedSpotifyOrdersQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly name: string, readonly unmappedSpotifyOrders: { readonly __typename: 'UnMappedOrderPagination', readonly total: number | null, readonly offset: number | null, readonly limit: number | null, readonly results: ReadonlyArray<{ readonly __typename: 'SpotifyOrderObject', readonly id: string, readonly name: string, readonly startAt: any, readonly endAt: any, readonly cost: number, readonly brandMappingAttempt: { readonly __typename: 'CloudsenseBrandMappingAttemptObject', readonly confidence: CloudsenseBrandMappingAttemptConfidence, readonly attemptMethod: CloudsenseBrandMappingAttemptAttemptMethod, readonly cloudsenseAdvertiserId: string, readonly cloudsenseAdvertiserName: string, readonly cloudsenseBillingAccountName: string, readonly advertiserWebsite: string | null, readonly company: { readonly __typename: 'CompanyObject', readonly id: string, readonly name: string, readonly hasActivePixel: boolean | null, readonly campaignCount: number, readonly organization: { readonly __typename: 'UnAuthedOrganizationObject', readonly name: string | null, readonly slug: string | null, readonly keys: ReadonlyArray<{ readonly __typename: 'KeyObject', readonly domain: string, readonly role: KeyRole } | null> | null } | null } | null } | null }> | null } } } | null };

export type UserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type UserInfoQuery = { readonly __typename: 'Query', readonly userInfo: { readonly __typename: 'UserInfoObject', readonly email: string | null, readonly hasSpaaUser: boolean | null, readonly hasVerifiedEmailForSpaa: boolean | null } | null };

export type CampaignActivityLogQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  slug: Scalars['String'];
}>;


export type CampaignActivityLogQuery = { readonly __typename: 'Query', readonly me: { readonly __typename: 'UserObject', readonly id: string, readonly organization: { readonly __typename: 'OrganizationObject', readonly id: string, readonly campaign: { readonly __typename: 'CampaignObject', readonly id: string, readonly name: string, readonly auditLogEvents: ReadonlyArray<{ readonly __typename: 'CampaignAuditLogEventObject', readonly id: string, readonly dateTimeChanged: any, readonly userFirstName: string, readonly userLastInitial: string, readonly fieldName: string | null, readonly action: string, readonly oldVal: string | null, readonly newVal: string | null, readonly campaignOrLineItemName: string, readonly eventType: CampaignAuditLogEventTypes } | null> | null } } } | null };

export const AssetFragmentDoc = gql`
    fragment Asset on AssetObject {
  id
  name
  contentType
  width
  height
  size
  src
}
    `;
export const AttributionConfigFragmentDoc = gql`
    fragment AttributionConfig on AttributionConfigObject {
  id
  householdInterval
  cableInterval
  cellularInterval
  corporateInterval
  attributionInterval
  maxUsersPerHousehold
}
    `;
export const CampaignDynamicEpisodeFragmentDoc = gql`
    fragment CampaignDynamicEpisode on CampaignDynamicEpisodeObject {
  id
  cost
  costToDate
  downloadTotal
  reachTotal
  attributionTotal
  userTotal
  userTotalModeled
  productTotal
  productTotalModeled
  addtocartTotal
  addtocartTotalModeled
  checkoutTotal
  checkoutTotalModeled
  purchaseTotal
  purchaseTotalModeled
  leadTotal
  leadTotalModeled
  valueTotal
  valueTotalModeled
  installedTotal
  installedTotalModeled
  targetDownloadTotal
  targetReachTotal
  startAt
  endAt
  episode {
    id
    title
    description(words: 25)
    image {
      id
      href
      path
    }
    published
    enclosure {
      id
      length
      duration
      mpegPath
      waveform
    }
  }
}
    `;
export const CampaignDynamicPodcastFragmentDoc = gql`
    fragment CampaignDynamicPodcast on CampaignDynamicPodcastObject {
  id
  cost
  costToDate
  downloadTotal
  reachTotal
  attributionTotal
  userTotal
  userTotalModeled
  productTotal
  productTotalModeled
  addtocartTotal
  addtocartTotalModeled
  checkoutTotal
  checkoutTotalModeled
  purchaseTotal
  purchaseTotalModeled
  leadTotal
  leadTotalModeled
  valueTotal
  valueTotalModeled
  installedTotal
  installedTotalModeled
  targetDownloadTotal
  targetReachTotal
  startAt
  endAt
  podcast {
    id
  }
  feed {
    id
    title
    description(words: 50)
    image {
      href
      id
      path
    }
  }
}
    `;
export const CampaignDynamicOldFragmentDoc = gql`
    fragment CampaignDynamicOld on CampaignDynamicObject {
  id
  name
  art19Secret
  isPreRoll
  isMidRoll
  isPostRoll
  discountCode
  discountUrl
  effectiveUrl
  duration
  goal
  cost
  costToDate
  downloadTotal
  reachTotal
  attributionTotal
  userTotal
  userTotalModeled
  productTotal
  productTotalModeled
  addtocartTotal
  addtocartTotalModeled
  checkoutTotal
  checkoutTotalModeled
  purchaseTotal
  purchaseTotalModeled
  leadTotal
  leadTotalModeled
  valueTotal
  valueTotalModeled
  installedTotal
  installedTotalModeled
  targetDownloadTotal
  targetReachTotal
  startAt
  endAt
  dynamicType
  expectedStartAt
  expectedEndAt
  deliveries {
    id
    viewedBy {
      id
      firstName
      lastName
      email
    }
    viewedAt
  }
  providerName
  providerTrackingUrl
  campaignDynamicPodcasts {
    ...CampaignDynamicPodcast
  }
  isBaseline
  createdAt
  updatedAt
}
    ${CampaignDynamicPodcastFragmentDoc}`;
export const CampaignEpisodeFragmentDoc = gql`
    fragment CampaignEpisode on CampaignEpisodeObject {
  id
  isBaseline
  startAt
  endAt
  downloadTotal
  reachTotal
  attributionTotal
  userTotal
  userTotalModeled
  productTotal
  productTotalModeled
  addtocartTotal
  addtocartTotalModeled
  checkoutTotal
  checkoutTotalModeled
  purchaseTotal
  purchaseTotalModeled
  leadTotal
  leadTotalModeled
  valueTotal
  valueTotalModeled
  installedTotal
  installedTotalModeled
  targetDownloadTotal
  targetReachTotal
  cost
  costToDate
  goal
  verified
  campaignPodcast {
    id
  }
  episode {
    id
    title
    description(words: 25)
    image {
      id
      href
      path
    }
    published
    enclosure {
      id
      length
    }
  }
  futureEpisode {
    id
    title
    subtitle
    expectedPublished
  }
}
    `;
export const CampaignStreamingStreamFragmentDoc = gql`
    fragment CampaignStreamingStream on CampaignStreamingStreamObject {
  id
  cost
  costToDate
  downloadTotal
  reachTotal
  attributionTotal
  userTotal
  userTotalModeled
  productTotal
  productTotalModeled
  addtocartTotal
  addtocartTotalModeled
  checkoutTotal
  checkoutTotalModeled
  purchaseTotal
  purchaseTotalModeled
  leadTotal
  leadTotalModeled
  valueTotal
  valueTotalModeled
  installedTotal
  installedTotalModeled
  targetDownloadTotal
  targetReachTotal
  startAt
  endAt
}
    `;
export const CampaignStreamingOldFragmentDoc = gql`
    fragment CampaignStreamingOld on CampaignStreamingObject {
  id
  name
  isActive
  source
  discountCode
  discountUrl
  effectiveUrl
  duration
  goal
  cost
  costToDate
  verifiedReach
  downloadTotal
  reachTotal
  attributionTotal
  userTotal
  userTotalModeled
  productTotal
  productTotalModeled
  addtocartTotal
  addtocartTotalModeled
  checkoutTotal
  checkoutTotalModeled
  purchaseTotal
  purchaseTotalModeled
  leadTotal
  leadTotalModeled
  valueTotal
  valueTotalModeled
  installedTotal
  installedTotalModeled
  targetDownloadTotal
  targetReachTotal
  startAt
  endAt
  providerName
  providerTrackingUrl
  deliveries {
    id
    viewedBy {
      id
      firstName
      lastName
      email
    }
    viewedAt
  }
  isBaseline
  campaignStreamingStreams {
    ...CampaignStreamingStream
  }
  createdAt
  updatedAt
}
    ${CampaignStreamingStreamFragmentDoc}`;
export const CompanyFragmentDoc = gql`
    fragment Company on CompanyObject {
  id
  slug
  name
  description
  url
  industry
  industryDisplay
  image {
    id
    width
    height
    src
    path
  }
  createdAt
}
    `;
export const DynamicApprovalFragmentDoc = gql`
    fragment DynamicApproval on DynamicApprovalObject {
  id
  requestedAt
  updatedAt
  state
  comment
  campaignDynamic {
    id
  }
  updatedBy {
    email
  }
  requestedBy {
    id
    firstName
    lastName
    email
  }
  requestedByOrganization {
    id
    name
  }
  requestee {
    id
    firstName
    lastName
    email
  }
  requesteeOrganization {
    id
    name
  }
  rejectedReason
}
    `;
export const PodcastApprovalFragmentDoc = gql`
    fragment PodcastApproval on PodcastApprovalObject {
  id
  requestedAt
  updatedAt
  state
  comment
  campaignPodcast {
    id
  }
  updatedBy {
    email
  }
  requestedBy {
    id
    firstName
    lastName
    email
  }
  requestedByOrganization {
    id
    name
  }
  requestee {
    id
    firstName
    lastName
    email
  }
  requesteeOrganization {
    id
    name
  }
  rejectedReason
}
    `;
export const PodcastFragmentDoc = gql`
    fragment Podcast on PodcastObject {
  id
  isAdvisor
  processingStartedAt
  createdAt
  feed {
    id
    title
    description(words: 25)
    href
    state
    publisherName
    publisherEmail
    image {
      id
      href
      path
    }
  }
}
    `;
export const PodlinkDomainFragmentDoc = gql`
    fragment PodlinkDomain on PodlinkDomainObject {
  id
  slug
  title
  description
}
    `;
export const ReviewerEpisodeFragmentDoc = gql`
    fragment ReviewerEpisode on EpisodeObject {
  id
  published
  title
  subtitle
  summary
  image {
    id
    href
    path
  }
  feed {
    id
    title
    image {
      id
      href
      path
    }
  }
  processed
  placementsCount
  enclosure {
    id
    length
  }
}
    `;
export const StreamingApprovalFragmentDoc = gql`
    fragment StreamingApproval on StreamingApprovalObject {
  id
  requestedAt
  updatedAt
  state
  comment
  campaignStreaming {
    id
  }
  updatedBy {
    email
  }
  requestedBy {
    id
    firstName
    lastName
    email
  }
  requestedByOrganization {
    id
    name
  }
  requestee {
    id
    firstName
    lastName
    email
  }
  requesteeOrganization {
    id
    name
  }
  rejectedReason
}
    `;
export const UserAccessFragmentDoc = gql`
    fragment UserAccess on UserAccessObject {
  id
  permission
  permissionDisplay
  objectPk
  appLabel
  model
}
    `;
export const AdvisorColumnFieldsFragmentDoc = gql`
    fragment AdvisorColumnFields on AdvisorColumn {
  id
  description
  title
  type
  filterId
  filterIndex
  filterMax
  filterMin
  filterStddev
  filterType
}
    `;
export const AdvisorColumnGroupFieldsFragmentDoc = gql`
    fragment AdvisorColumnGroupFields on AdvisorColumnGroup {
  title
  filterId
  columns {
    ...AdvisorColumnFields
  }
}
    ${AdvisorColumnFieldsFragmentDoc}`;
export const AudienceInsightFragmentDoc = gql`
    fragment AudienceInsight on AudienceInsightsMetricObject {
  segment
  impressions
  cr
  crIndex
}
    `;
export const CampaignOmniChartFieldsFragmentDoc = gql`
    fragment CampaignOmniChartFields on CampaignObject {
  id
  attribution(after: $after, before: $before) {
    users {
      hourlyVisitors {
        count
        hour
      }
    }
  }
  downloads(after: $after, before: $before) {
    hourly {
      hour
      downloadClass
      count
    }
  }
  campaignPodcasts {
    id
    feed {
      id
      title
      image {
        href
        id
        path
      }
    }
    episodes(after: $after, before: $before) {
      id
      title
      published
    }
  }
}
    `;
export const GenericTagFragmentDoc = gql`
    fragment GenericTag on GenericTagObject {
  id
  title
  color
  genericTagRelationships {
    id
    objectPk
  }
}
    `;
export const CampaignDetailsFragmentDoc = gql`
    fragment CampaignDetails on CampaignObject {
  id
  name
  slug
  state
  kind
  startAt
  endAt
  createdAt
  allowBrandEditAccess
  isPublisherApproved
  isCreatedByBrand
  publisherDenyReason
  isPpa
  cost
  costToDate
  currency
  goal
  multiplier
  hideMatchedDynamics
  addtocartTotal
  addtocartTotalModeled
  attributionTotal
  checkoutTotal
  checkoutTotalModeled
  downloadTotal
  installedTotal
  installedTotalModeled
  leadTotal
  leadTotalModeled
  productTotal
  productTotalModeled
  purchaseTotal
  purchaseTotalModeled
  reachTotal
  targetDownloadTotal
  targetReachTotal
  userTotal
  userTotalModeled
  userReachTotal
  valueTotal
  valueTotalModeled
  genericTags(organizationId: $organizationId) {
    ...GenericTag
  }
}
    ${GenericTagFragmentDoc}`;
export const CampaignAttributionFragmentDoc = gql`
    fragment CampaignAttribution on AttributionObject {
  users {
    sum {
      addtocarts
      addtocartsModeled
      checkouts
      checkoutsModeled
      leads
      leadsModeled
      pages
      pagesModeled
      products
      productsModeled
      purchases
      purchasesModeled
      sessions
      sessionsModeled
      users
      usersModeled
      value
      valueModeled
    }
  }
}
    `;
export const CampaignDynamicDeliveryFragmentDoc = gql`
    fragment CampaignDynamicDelivery on CampaignDynamicDeliveryObject {
  id
  viewedBy {
    id
    firstName
    lastName
    email
  }
  viewedAt
}
    `;
export const CampaignDynamicFragmentDoc = gql`
    fragment CampaignDynamic on CampaignDynamicObject {
  id
  name
  art19Secret
  isPreRoll
  isMidRoll
  isPostRoll
  discountCode
  discountUrl
  effectiveUrl
  duration
  goal
  cost
  costToDate
  spotifyAdFormat
  source
  downloadTotal
  reachTotal
  attributionTotal
  userTotal
  userTotalModeled
  productTotal
  productTotalModeled
  addtocartTotal
  addtocartTotalModeled
  checkoutTotal
  checkoutTotalModeled
  purchaseTotal
  purchaseTotalModeled
  leadTotal
  leadTotalModeled
  valueTotal
  valueTotalModeled
  installedTotal
  installedTotalModeled
  targetDownloadTotal
  targetReachTotal
  startAt
  endAt
  expectedStartAt
  expectedEndAt
  dynamicType
  providerName
  providerTrackingUrl
  deliveries {
    ...CampaignDynamicDelivery
  }
  campaignDynamicPodcasts {
    ...CampaignDynamicPodcast
  }
  isBaseline
  createdAt
  updatedAt
}
    ${CampaignDynamicDeliveryFragmentDoc}
${CampaignDynamicPodcastFragmentDoc}`;
export const CampaignPodcastFragmentDoc = gql`
    fragment CampaignPodcast on CampaignPodcastObject {
  id
  name
  isDynamic
  podcast {
    id
  }
  feed {
    id
    title
    href
    description(words: 50)
    image {
      href
      id
      path
    }
  }
  drops
  campaignEpisodesCount
  isPreRoll
  isMidRoll
  isPostRoll
  discountCode
  discountUrl
  effectiveUrl
  duration
  goal
  cost
  costToDate
  downloadTotal
  reachTotal
  attributionTotal
  userTotal
  userTotalModeled
  productTotal
  productTotalModeled
  addtocartTotal
  addtocartTotalModeled
  checkoutTotal
  checkoutTotalModeled
  purchaseTotal
  purchaseTotalModeled
  leadTotal
  leadTotalModeled
  valueTotal
  valueTotalModeled
  installedTotal
  installedTotalModeled
  targetDownloadTotal
  targetReachTotal
  startAt
  endAt
  hasPodsightsPrefix
  createdAt
  updatedAt
}
    `;
export const CampaignStreamingDeliveryFragmentDoc = gql`
    fragment CampaignStreamingDelivery on CampaignStreamingDeliveryObject {
  id
  viewedBy {
    id
    firstName
    lastName
    email
  }
  viewedAt
}
    `;
export const CampaignStreamingFragmentDoc = gql`
    fragment CampaignStreaming on CampaignStreamingObject {
  id
  name
  isActive
  source
  discountCode
  discountUrl
  effectiveUrl
  duration
  goal
  cost
  costToDate
  verifiedReach
  spotifyAdFormat
  downloadTotal
  reachTotal
  attributionTotal
  userTotal
  userTotalModeled
  productTotal
  productTotalModeled
  addtocartTotal
  addtocartTotalModeled
  checkoutTotal
  checkoutTotalModeled
  purchaseTotal
  purchaseTotalModeled
  leadTotal
  leadTotalModeled
  valueTotal
  valueTotalModeled
  installedTotal
  installedTotalModeled
  targetDownloadTotal
  targetReachTotal
  startAt
  endAt
  providerName
  providerTrackingUrl
  deliveries {
    ...CampaignStreamingDelivery
  }
  isBaseline
  campaignStreamingStreams {
    ...CampaignStreamingStream
  }
  createdAt
  updatedAt
}
    ${CampaignStreamingDeliveryFragmentDoc}
${CampaignStreamingStreamFragmentDoc}`;
export const CampaignNoiseFragmentDoc = gql`
    fragment CampaignNoise on CampaignNoiseObject {
  id
  name
  startAt
  endAt
  targetImpressions
  usePublisherImpressions
}
    `;
export const CampaignTargetFragmentDoc = gql`
    fragment CampaignTarget on CampaignTargetObject {
  id
  podcast {
    id
  }
  feed {
    id
    title
    href
    description(words: 50)
    image {
      href
      id
      path
      src
    }
  }
  reachTotal
  downloadTotal
}
    `;
export const CampaignLinkFragmentDoc = gql`
    fragment CampaignLink on CampaignLinkObject {
  id
  name
  viewTotal
  clickTotal
  targetReachTotal
  targetDownloadTotal
  createdAt
}
    `;
export const CampaignFragmentDoc = gql`
    fragment Campaign on CampaignObject {
  ...CampaignDetails
  downloadAlgorithm
  expectedStartAt
  expectedEndAt
  goLiveDate
  goodReach
  householdReach
  isHiddenFromAgency
  isMegaphone
  lastBuilt
  mode
  noiselessReach
  verifiedReach
  spotifyOrder {
    id
    name
  }
  organization {
    id
    name
    slug
    kind
  }
  advertiser {
    id
    name
    organization {
      id
      name
      kind
      mode
      slug
      hasMembers
    }
  }
  payer {
    id
  }
  pixels {
    key
    role
    domain
    createdAt
  }
  attribution {
    ...CampaignAttribution
  }
  campaignDynamics {
    ...CampaignDynamic
  }
  campaignPodcasts {
    ...CampaignPodcast
  }
  campaignStreamings {
    ...CampaignStreaming
  }
  campaignNoises {
    ...CampaignNoise
  }
  campaignTargets {
    ...CampaignTarget
  }
  campaignLinks {
    ...CampaignLink
  }
}
    ${CampaignDetailsFragmentDoc}
${CampaignAttributionFragmentDoc}
${CampaignDynamicFragmentDoc}
${CampaignPodcastFragmentDoc}
${CampaignStreamingFragmentDoc}
${CampaignNoiseFragmentDoc}
${CampaignTargetFragmentDoc}
${CampaignLinkFragmentDoc}`;
export const DailyBillingRecordFragmentDoc = gql`
    fragment DailyBillingRecord on DailyCampaignBillingRecord {
  advertiserId
  advertiserName
  campaignId
  campaignName
  downloadDate
  impressions
  publisherId
  publisherName
}
    `;
export const ExportTypesFragmentDoc = gql`
    fragment ExportTypes on ExportTypes {
  id
  types {
    id
    name
    supportedParameters {
      id
    }
  }
}
    `;
export const LiftReportFieldsFragmentDoc = gql`
    fragment LiftReportFields on LiftReportObject {
  id
  name
  delta
  runDate
  createdAt
  updatedAt
  state
  impressionsStartAt
  impressionsEndAt
  useNoise
  clampUrl
  requestedBy {
    id
    firstName
    lastName
    email
  }
}
    `;
export const LimitedCompanyMembersFragmentDoc = gql`
    fragment LimitedCompanyMembers on LimitedCompanyObject {
  id
  name
  organization {
    id
    members {
      id
      firstName
      lastName
    }
    managers {
      id
      name
    }
  }
}
    `;
export const SavedExportFieldsFragmentDoc = gql`
    fragment SavedExportFields on SavedExportObject {
  id
  name
  exportType
  createdBy {
    id
    firstName
    lastName
  }
  organization {
    id
  }
  fields
  exportParameters
  orderBy
  updatedAt
  lastExportInstance {
    id
    status
    downloadUrl
    updatedAt
    exportJobStatus {
      id
      status
      failedReason
    }
  }
}
    `;
export const SimpleBillingRecordFragmentDoc = gql`
    fragment SimpleBillingRecord on SimpleBillingRecord {
  downloadDate
  impressions
}
    `;
export const SpotifyAudienceFieldsFragmentDoc = gql`
    fragment SpotifyAudienceFields on SpotifyAudienceObject {
  group
  impressions
}
    `;
export const SpotifyMessageResultsFragmentDoc = gql`
    fragment SpotifyMessageResults on MessageResultGroupObject {
  controlTotal
  controlPositive
  exposedTotal
  exposedPositive
  controlPercentage
  exposedPercentage
  percentChange
  significance
}
    `;
export const SpotifyBrandLiftMessageResultFieldsFragmentDoc = gql`
    fragment SpotifyBrandLiftMessageResultFields on SpotifyBrandLiftMessageResultObject {
  totalResponses
  totalPositive
  controlAnswer1
  controlAnswer2
  controlAnswer3
  controlAnswer4
  controlAnswer5
  exposedAnswer1
  exposedAnswer2
  exposedAnswer3
  exposedAnswer4
  exposedAnswer5
  overall {
    ...SpotifyMessageResults
  }
  male {
    ...SpotifyMessageResults
  }
  female {
    ...SpotifyMessageResults
  }
  age13To17 {
    ...SpotifyMessageResults
  }
  age18To24 {
    ...SpotifyMessageResults
  }
  age25To34 {
    ...SpotifyMessageResults
  }
  age35To44 {
    ...SpotifyMessageResults
  }
  age45Plus {
    ...SpotifyMessageResults
  }
}
    ${SpotifyMessageResultsFragmentDoc}`;
export const SpotifyBrandLiftFieldsFragmentDoc = gql`
    fragment SpotifyBrandLiftFields on SpotifyBrandLiftReportObject {
  id
  name
  sblSurveyGamId
  isComplete
  isPublished
  isHiddenFromAgency
  startDate
  endDate
  impressions
  clicks
  reach
  frequency
  campaigns {
    id
    name
    slug
    startAt
    endAt
    isHiddenFromAgency
    advertiser {
      id
      name
    }
  }
}
    `;
export const UnMappedOrderPaginationFragmentDoc = gql`
    fragment UnMappedOrderPagination on SpotifyOrderObject {
  id
  name
  startAt
  endAt
  cost
  brandMappingAttempt {
    company {
      id
      name
      organization {
        name
        slug
        keys {
          domain
          role
        }
      }
      hasActivePixel
      campaignCount
    }
    confidence
    attemptMethod
    cloudsenseAdvertiserId
    cloudsenseAdvertiserName
    cloudsenseBillingAccountName
    advertiserWebsite
  }
}
    `;
export const RejectAdDocument = gql`
    mutation rejectAd($input: RejectAdInput!) {
  rejectAd(input: $input) {
    success
  }
}
    `;
export type RejectAdMutationFn = Apollo.MutationFunction<RejectAdMutation, RejectAdMutationVariables>;

/**
 * __useRejectAdMutation__
 *
 * To run a mutation, you first call `useRejectAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectAdMutation, { data, loading, error }] = useRejectAdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectAdMutation(baseOptions?: Apollo.MutationHookOptions<RejectAdMutation, RejectAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectAdMutation, RejectAdMutationVariables>(RejectAdDocument, options);
      }
export type RejectAdMutationHookResult = ReturnType<typeof useRejectAdMutation>;
export type RejectAdMutationResult = Apollo.MutationResult<RejectAdMutation>;
export type RejectAdMutationOptions = Apollo.BaseMutationOptions<RejectAdMutation, RejectAdMutationVariables>;
export const SplitAdDocument = gql`
    mutation splitAd($input: SplitAdInput!) {
  splitAd(input: $input) {
    success
  }
}
    `;
export type SplitAdMutationFn = Apollo.MutationFunction<SplitAdMutation, SplitAdMutationVariables>;

/**
 * __useSplitAdMutation__
 *
 * To run a mutation, you first call `useSplitAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSplitAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [splitAdMutation, { data, loading, error }] = useSplitAdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSplitAdMutation(baseOptions?: Apollo.MutationHookOptions<SplitAdMutation, SplitAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SplitAdMutation, SplitAdMutationVariables>(SplitAdDocument, options);
      }
export type SplitAdMutationHookResult = ReturnType<typeof useSplitAdMutation>;
export type SplitAdMutationResult = Apollo.MutationResult<SplitAdMutation>;
export type SplitAdMutationOptions = Apollo.BaseMutationOptions<SplitAdMutation, SplitAdMutationVariables>;
export const UnknownAdDocument = gql`
    mutation unknownAd($input: UnknownAdInput!) {
  unknownAd(input: $input) {
    ad {
      id
      createdAt
    }
  }
}
    `;
export type UnknownAdMutationFn = Apollo.MutationFunction<UnknownAdMutation, UnknownAdMutationVariables>;

/**
 * __useUnknownAdMutation__
 *
 * To run a mutation, you first call `useUnknownAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnknownAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unknownAdMutation, { data, loading, error }] = useUnknownAdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnknownAdMutation(baseOptions?: Apollo.MutationHookOptions<UnknownAdMutation, UnknownAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnknownAdMutation, UnknownAdMutationVariables>(UnknownAdDocument, options);
      }
export type UnknownAdMutationHookResult = ReturnType<typeof useUnknownAdMutation>;
export type UnknownAdMutationResult = Apollo.MutationResult<UnknownAdMutation>;
export type UnknownAdMutationOptions = Apollo.BaseMutationOptions<UnknownAdMutation, UnknownAdMutationVariables>;
export const UpdateAdDocument = gql`
    mutation updateAd($input: UpdateAdInput!) {
  updateAd(input: $input) {
    ad {
      id
      createdAt
    }
  }
}
    `;
export type UpdateAdMutationFn = Apollo.MutationFunction<UpdateAdMutation, UpdateAdMutationVariables>;

/**
 * __useUpdateAdMutation__
 *
 * To run a mutation, you first call `useUpdateAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdMutation, { data, loading, error }] = useUpdateAdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdMutation, UpdateAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdMutation, UpdateAdMutationVariables>(UpdateAdDocument, options);
      }
export type UpdateAdMutationHookResult = ReturnType<typeof useUpdateAdMutation>;
export type UpdateAdMutationResult = Apollo.MutationResult<UpdateAdMutation>;
export type UpdateAdMutationOptions = Apollo.BaseMutationOptions<UpdateAdMutation, UpdateAdMutationVariables>;
export const GetAllAdvisorQuizColumnGroupsDocument = gql`
    query GetAllAdvisorQuizColumnGroups($orgId: ID!, $query: String, $brandId: ID) {
  me {
    id
    organization(id: $orgId) {
      id
      advisorQuiz {
        columnGroups {
          general {
            ...AdvisorColumnGroupFields
          }
          brands {
            ...AdvisorColumnGroupFields
          }
          clearbit {
            ...AdvisorColumnGroupFields
          }
          contentMaturity {
            ...AdvisorColumnGroupFields
          }
          experian {
            ...AdvisorColumnGroupFields
          }
          feedGrowth {
            ...AdvisorColumnGroupFields
          }
          industries {
            ...AdvisorColumnGroupFields
          }
          nielsen {
            ...AdvisorColumnGroupFields
          }
          overlap {
            ...AdvisorColumnGroupFields
          }
          publishers {
            ...AdvisorColumnGroupFields
          }
          radioMarkets {
            ...AdvisorColumnGroupFields
          }
          tags {
            ...AdvisorColumnGroupFields
          }
        }
      }
    }
  }
}
    ${AdvisorColumnGroupFieldsFragmentDoc}`;

/**
 * __useGetAllAdvisorQuizColumnGroupsQuery__
 *
 * To run a query within a React component, call `useGetAllAdvisorQuizColumnGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAdvisorQuizColumnGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAdvisorQuizColumnGroupsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      query: // value for 'query'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetAllAdvisorQuizColumnGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetAllAdvisorQuizColumnGroupsQuery, GetAllAdvisorQuizColumnGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAdvisorQuizColumnGroupsQuery, GetAllAdvisorQuizColumnGroupsQueryVariables>(GetAllAdvisorQuizColumnGroupsDocument, options);
      }
export function useGetAllAdvisorQuizColumnGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAdvisorQuizColumnGroupsQuery, GetAllAdvisorQuizColumnGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAdvisorQuizColumnGroupsQuery, GetAllAdvisorQuizColumnGroupsQueryVariables>(GetAllAdvisorQuizColumnGroupsDocument, options);
        }
export type GetAllAdvisorQuizColumnGroupsQueryHookResult = ReturnType<typeof useGetAllAdvisorQuizColumnGroupsQuery>;
export type GetAllAdvisorQuizColumnGroupsLazyQueryHookResult = ReturnType<typeof useGetAllAdvisorQuizColumnGroupsLazyQuery>;
export type GetAllAdvisorQuizColumnGroupsQueryResult = Apollo.QueryResult<GetAllAdvisorQuizColumnGroupsQuery, GetAllAdvisorQuizColumnGroupsQueryVariables>;
export const GetAdvisorQuizBrandsDocument = gql`
    query GetAdvisorQuizBrands($orgId: ID!, $query: String, $brandId: ID) {
  me {
    id
    organization(id: $orgId) {
      id
      advisorQuiz {
        columnGroups {
          brands(query: $query, id: $brandId) {
            ...AdvisorColumnGroupFields
          }
        }
      }
    }
  }
}
    ${AdvisorColumnGroupFieldsFragmentDoc}`;

/**
 * __useGetAdvisorQuizBrandsQuery__
 *
 * To run a query within a React component, call `useGetAdvisorQuizBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvisorQuizBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvisorQuizBrandsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      query: // value for 'query'
 *      brandId: // value for 'brandId'
 *   },
 * });
 */
export function useGetAdvisorQuizBrandsQuery(baseOptions: Apollo.QueryHookOptions<GetAdvisorQuizBrandsQuery, GetAdvisorQuizBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvisorQuizBrandsQuery, GetAdvisorQuizBrandsQueryVariables>(GetAdvisorQuizBrandsDocument, options);
      }
export function useGetAdvisorQuizBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvisorQuizBrandsQuery, GetAdvisorQuizBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvisorQuizBrandsQuery, GetAdvisorQuizBrandsQueryVariables>(GetAdvisorQuizBrandsDocument, options);
        }
export type GetAdvisorQuizBrandsQueryHookResult = ReturnType<typeof useGetAdvisorQuizBrandsQuery>;
export type GetAdvisorQuizBrandsLazyQueryHookResult = ReturnType<typeof useGetAdvisorQuizBrandsLazyQuery>;
export type GetAdvisorQuizBrandsQueryResult = Apollo.QueryResult<GetAdvisorQuizBrandsQuery, GetAdvisorQuizBrandsQueryVariables>;
export const GetAdvisorQuizColumnsDocument = gql`
    query GetAdvisorQuizColumns($organizationId: ID!, $ids: [ID]!) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisorQuiz {
        columnGroups {
          columns(ids: $ids) {
            ...AdvisorColumnFields
          }
        }
      }
    }
  }
}
    ${AdvisorColumnFieldsFragmentDoc}`;

/**
 * __useGetAdvisorQuizColumnsQuery__
 *
 * To run a query within a React component, call `useGetAdvisorQuizColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvisorQuizColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvisorQuizColumnsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetAdvisorQuizColumnsQuery(baseOptions: Apollo.QueryHookOptions<GetAdvisorQuizColumnsQuery, GetAdvisorQuizColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvisorQuizColumnsQuery, GetAdvisorQuizColumnsQueryVariables>(GetAdvisorQuizColumnsDocument, options);
      }
export function useGetAdvisorQuizColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvisorQuizColumnsQuery, GetAdvisorQuizColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvisorQuizColumnsQuery, GetAdvisorQuizColumnsQueryVariables>(GetAdvisorQuizColumnsDocument, options);
        }
export type GetAdvisorQuizColumnsQueryHookResult = ReturnType<typeof useGetAdvisorQuizColumnsQuery>;
export type GetAdvisorQuizColumnsLazyQueryHookResult = ReturnType<typeof useGetAdvisorQuizColumnsLazyQuery>;
export type GetAdvisorQuizColumnsQueryResult = Apollo.QueryResult<GetAdvisorQuizColumnsQuery, GetAdvisorQuizColumnsQueryVariables>;
export const GetAdvisorQuizNielsenInterestsDocument = gql`
    query GetAdvisorQuizNielsenInterests($orgId: ID!, $query: String, $nielsenId: ID) {
  me {
    id
    organization(id: $orgId) {
      id
      advisorQuiz {
        columnGroups {
          nielsen(query: $query, id: $nielsenId) {
            ...AdvisorColumnGroupFields
          }
        }
      }
    }
  }
}
    ${AdvisorColumnGroupFieldsFragmentDoc}`;

/**
 * __useGetAdvisorQuizNielsenInterestsQuery__
 *
 * To run a query within a React component, call `useGetAdvisorQuizNielsenInterestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvisorQuizNielsenInterestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvisorQuizNielsenInterestsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      query: // value for 'query'
 *      nielsenId: // value for 'nielsenId'
 *   },
 * });
 */
export function useGetAdvisorQuizNielsenInterestsQuery(baseOptions: Apollo.QueryHookOptions<GetAdvisorQuizNielsenInterestsQuery, GetAdvisorQuizNielsenInterestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvisorQuizNielsenInterestsQuery, GetAdvisorQuizNielsenInterestsQueryVariables>(GetAdvisorQuizNielsenInterestsDocument, options);
      }
export function useGetAdvisorQuizNielsenInterestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvisorQuizNielsenInterestsQuery, GetAdvisorQuizNielsenInterestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvisorQuizNielsenInterestsQuery, GetAdvisorQuizNielsenInterestsQueryVariables>(GetAdvisorQuizNielsenInterestsDocument, options);
        }
export type GetAdvisorQuizNielsenInterestsQueryHookResult = ReturnType<typeof useGetAdvisorQuizNielsenInterestsQuery>;
export type GetAdvisorQuizNielsenInterestsLazyQueryHookResult = ReturnType<typeof useGetAdvisorQuizNielsenInterestsLazyQuery>;
export type GetAdvisorQuizNielsenInterestsQueryResult = Apollo.QueryResult<GetAdvisorQuizNielsenInterestsQuery, GetAdvisorQuizNielsenInterestsQueryVariables>;
export const GetAdvisorQuizRadioMarketsDocument = gql`
    query GetAdvisorQuizRadioMarkets($orgId: ID!, $query: String, $radioMarketId: ID) {
  me {
    id
    organization(id: $orgId) {
      id
      advisorQuiz {
        columnGroups {
          radioMarkets(query: $query, id: $radioMarketId) {
            ...AdvisorColumnGroupFields
          }
        }
      }
    }
  }
}
    ${AdvisorColumnGroupFieldsFragmentDoc}`;

/**
 * __useGetAdvisorQuizRadioMarketsQuery__
 *
 * To run a query within a React component, call `useGetAdvisorQuizRadioMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvisorQuizRadioMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvisorQuizRadioMarketsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      query: // value for 'query'
 *      radioMarketId: // value for 'radioMarketId'
 *   },
 * });
 */
export function useGetAdvisorQuizRadioMarketsQuery(baseOptions: Apollo.QueryHookOptions<GetAdvisorQuizRadioMarketsQuery, GetAdvisorQuizRadioMarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvisorQuizRadioMarketsQuery, GetAdvisorQuizRadioMarketsQueryVariables>(GetAdvisorQuizRadioMarketsDocument, options);
      }
export function useGetAdvisorQuizRadioMarketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvisorQuizRadioMarketsQuery, GetAdvisorQuizRadioMarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvisorQuizRadioMarketsQuery, GetAdvisorQuizRadioMarketsQueryVariables>(GetAdvisorQuizRadioMarketsDocument, options);
        }
export type GetAdvisorQuizRadioMarketsQueryHookResult = ReturnType<typeof useGetAdvisorQuizRadioMarketsQuery>;
export type GetAdvisorQuizRadioMarketsLazyQueryHookResult = ReturnType<typeof useGetAdvisorQuizRadioMarketsLazyQuery>;
export type GetAdvisorQuizRadioMarketsQueryResult = Apollo.QueryResult<GetAdvisorQuizRadioMarketsQuery, GetAdvisorQuizRadioMarketsQueryVariables>;
export const GetAdvisorQuizTagsDocument = gql`
    query GetAdvisorQuizTags($organizationId: ID!, $query: String, $tagId: ID) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisorQuiz {
        columnGroups {
          tags(query: $query, id: $tagId) {
            ...AdvisorColumnGroupFields
          }
        }
      }
    }
  }
}
    ${AdvisorColumnGroupFieldsFragmentDoc}`;

/**
 * __useGetAdvisorQuizTagsQuery__
 *
 * To run a query within a React component, call `useGetAdvisorQuizTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvisorQuizTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvisorQuizTagsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      query: // value for 'query'
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useGetAdvisorQuizTagsQuery(baseOptions: Apollo.QueryHookOptions<GetAdvisorQuizTagsQuery, GetAdvisorQuizTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvisorQuizTagsQuery, GetAdvisorQuizTagsQueryVariables>(GetAdvisorQuizTagsDocument, options);
      }
export function useGetAdvisorQuizTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvisorQuizTagsQuery, GetAdvisorQuizTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvisorQuizTagsQuery, GetAdvisorQuizTagsQueryVariables>(GetAdvisorQuizTagsDocument, options);
        }
export type GetAdvisorQuizTagsQueryHookResult = ReturnType<typeof useGetAdvisorQuizTagsQuery>;
export type GetAdvisorQuizTagsLazyQueryHookResult = ReturnType<typeof useGetAdvisorQuizTagsLazyQuery>;
export type GetAdvisorQuizTagsQueryResult = Apollo.QueryResult<GetAdvisorQuizTagsQuery, GetAdvisorQuizTagsQueryVariables>;
export const CompletePlacementsDocument = gql`
    mutation completePlacements($input: CompletePlacementsInput!) {
  completePlacements(input: $input) {
    success
  }
}
    `;
export type CompletePlacementsMutationFn = Apollo.MutationFunction<CompletePlacementsMutation, CompletePlacementsMutationVariables>;

/**
 * __useCompletePlacementsMutation__
 *
 * To run a mutation, you first call `useCompletePlacementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompletePlacementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completePlacementsMutation, { data, loading, error }] = useCompletePlacementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompletePlacementsMutation(baseOptions?: Apollo.MutationHookOptions<CompletePlacementsMutation, CompletePlacementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompletePlacementsMutation, CompletePlacementsMutationVariables>(CompletePlacementsDocument, options);
      }
export type CompletePlacementsMutationHookResult = ReturnType<typeof useCompletePlacementsMutation>;
export type CompletePlacementsMutationResult = Apollo.MutationResult<CompletePlacementsMutation>;
export type CompletePlacementsMutationOptions = Apollo.BaseMutationOptions<CompletePlacementsMutation, CompletePlacementsMutationVariables>;
export const NoPlacementsDocument = gql`
    mutation noPlacements($input: NoPlacementsInput!) {
  noPlacements(input: $input) {
    success
  }
}
    `;
export type NoPlacementsMutationFn = Apollo.MutationFunction<NoPlacementsMutation, NoPlacementsMutationVariables>;

/**
 * __useNoPlacementsMutation__
 *
 * To run a mutation, you first call `useNoPlacementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoPlacementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noPlacementsMutation, { data, loading, error }] = useNoPlacementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNoPlacementsMutation(baseOptions?: Apollo.MutationHookOptions<NoPlacementsMutation, NoPlacementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoPlacementsMutation, NoPlacementsMutationVariables>(NoPlacementsDocument, options);
      }
export type NoPlacementsMutationHookResult = ReturnType<typeof useNoPlacementsMutation>;
export type NoPlacementsMutationResult = Apollo.MutationResult<NoPlacementsMutation>;
export type NoPlacementsMutationOptions = Apollo.BaseMutationOptions<NoPlacementsMutation, NoPlacementsMutationVariables>;
export const UpsertPlacementsDocument = gql`
    mutation upsertPlacements($input: UpsertPlacementsInput!) {
  upsertPlacements(input: $input) {
    placements {
      id
      createdAt
    }
  }
}
    `;
export type UpsertPlacementsMutationFn = Apollo.MutationFunction<UpsertPlacementsMutation, UpsertPlacementsMutationVariables>;

/**
 * __useUpsertPlacementsMutation__
 *
 * To run a mutation, you first call `useUpsertPlacementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPlacementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPlacementsMutation, { data, loading, error }] = useUpsertPlacementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPlacementsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPlacementsMutation, UpsertPlacementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPlacementsMutation, UpsertPlacementsMutationVariables>(UpsertPlacementsDocument, options);
      }
export type UpsertPlacementsMutationHookResult = ReturnType<typeof useUpsertPlacementsMutation>;
export type UpsertPlacementsMutationResult = Apollo.MutationResult<UpsertPlacementsMutation>;
export type UpsertPlacementsMutationOptions = Apollo.BaseMutationOptions<UpsertPlacementsMutation, UpsertPlacementsMutationVariables>;
export const AddAccessDocument = gql`
    mutation addAccess($input: AddAccessInput!) {
  authed {
    success
  }
  addAccess(input: $input) {
    access {
      id
      name
      permission
      organization {
        id
        name
        kind
      }
    }
  }
}
    `;
export type AddAccessMutationFn = Apollo.MutationFunction<AddAccessMutation, AddAccessMutationVariables>;

/**
 * __useAddAccessMutation__
 *
 * To run a mutation, you first call `useAddAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccessMutation, { data, loading, error }] = useAddAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAccessMutation(baseOptions?: Apollo.MutationHookOptions<AddAccessMutation, AddAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccessMutation, AddAccessMutationVariables>(AddAccessDocument, options);
      }
export type AddAccessMutationHookResult = ReturnType<typeof useAddAccessMutation>;
export type AddAccessMutationResult = Apollo.MutationResult<AddAccessMutation>;
export type AddAccessMutationOptions = Apollo.BaseMutationOptions<AddAccessMutation, AddAccessMutationVariables>;
export const AddArt19SecretDocument = gql`
    mutation addArt19Secret($input: AddArt19SecretInput!) {
  authed {
    success
  }
  addArt19Secret(input: $input) {
    art19Secret
  }
}
    `;
export type AddArt19SecretMutationFn = Apollo.MutationFunction<AddArt19SecretMutation, AddArt19SecretMutationVariables>;

/**
 * __useAddArt19SecretMutation__
 *
 * To run a mutation, you first call `useAddArt19SecretMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddArt19SecretMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addArt19SecretMutation, { data, loading, error }] = useAddArt19SecretMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddArt19SecretMutation(baseOptions?: Apollo.MutationHookOptions<AddArt19SecretMutation, AddArt19SecretMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddArt19SecretMutation, AddArt19SecretMutationVariables>(AddArt19SecretDocument, options);
      }
export type AddArt19SecretMutationHookResult = ReturnType<typeof useAddArt19SecretMutation>;
export type AddArt19SecretMutationResult = Apollo.MutationResult<AddArt19SecretMutation>;
export type AddArt19SecretMutationOptions = Apollo.BaseMutationOptions<AddArt19SecretMutation, AddArt19SecretMutationVariables>;
export const AddMemberDocument = gql`
    mutation addMember($input: AddMemberInput!) {
  authed {
    success
  }
  addMember(input: $input) {
    organizationId
    membership {
      id
      role
      roleDisplay
      createdAt
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
}
    `;
export type AddMemberMutationFn = Apollo.MutationFunction<AddMemberMutation, AddMemberMutationVariables>;

/**
 * __useAddMemberMutation__
 *
 * To run a mutation, you first call `useAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberMutation, { data, loading, error }] = useAddMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberMutation, AddMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberMutation, AddMemberMutationVariables>(AddMemberDocument, options);
      }
export type AddMemberMutationHookResult = ReturnType<typeof useAddMemberMutation>;
export type AddMemberMutationResult = Apollo.MutationResult<AddMemberMutation>;
export type AddMemberMutationOptions = Apollo.BaseMutationOptions<AddMemberMutation, AddMemberMutationVariables>;
export const CheckCampaignPodcastPrefixDocument = gql`
    mutation checkCampaignPodcastPrefix($input: CheckCampaignPodcastPrefixInput!) {
  authed {
    success
  }
  checkCampaignPodcastPrefix(input: $input) {
    campaignPodcast {
      ...CampaignPodcast
    }
  }
}
    ${CampaignPodcastFragmentDoc}`;
export type CheckCampaignPodcastPrefixMutationFn = Apollo.MutationFunction<CheckCampaignPodcastPrefixMutation, CheckCampaignPodcastPrefixMutationVariables>;

/**
 * __useCheckCampaignPodcastPrefixMutation__
 *
 * To run a mutation, you first call `useCheckCampaignPodcastPrefixMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckCampaignPodcastPrefixMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkCampaignPodcastPrefixMutation, { data, loading, error }] = useCheckCampaignPodcastPrefixMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckCampaignPodcastPrefixMutation(baseOptions?: Apollo.MutationHookOptions<CheckCampaignPodcastPrefixMutation, CheckCampaignPodcastPrefixMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckCampaignPodcastPrefixMutation, CheckCampaignPodcastPrefixMutationVariables>(CheckCampaignPodcastPrefixDocument, options);
      }
export type CheckCampaignPodcastPrefixMutationHookResult = ReturnType<typeof useCheckCampaignPodcastPrefixMutation>;
export type CheckCampaignPodcastPrefixMutationResult = Apollo.MutationResult<CheckCampaignPodcastPrefixMutation>;
export type CheckCampaignPodcastPrefixMutationOptions = Apollo.BaseMutationOptions<CheckCampaignPodcastPrefixMutation, CheckCampaignPodcastPrefixMutationVariables>;
export const ClaimAddPodcastDocument = gql`
    mutation claimAddPodcast($input: ClaimAddPodcastInput!) {
  authed {
    success
  }
  claimAddPodcast(input: $input) {
    podcast {
      id
    }
    organization {
      id
      slug
    }
  }
}
    `;
export type ClaimAddPodcastMutationFn = Apollo.MutationFunction<ClaimAddPodcastMutation, ClaimAddPodcastMutationVariables>;

/**
 * __useClaimAddPodcastMutation__
 *
 * To run a mutation, you first call `useClaimAddPodcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimAddPodcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimAddPodcastMutation, { data, loading, error }] = useClaimAddPodcastMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClaimAddPodcastMutation(baseOptions?: Apollo.MutationHookOptions<ClaimAddPodcastMutation, ClaimAddPodcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimAddPodcastMutation, ClaimAddPodcastMutationVariables>(ClaimAddPodcastDocument, options);
      }
export type ClaimAddPodcastMutationHookResult = ReturnType<typeof useClaimAddPodcastMutation>;
export type ClaimAddPodcastMutationResult = Apollo.MutationResult<ClaimAddPodcastMutation>;
export type ClaimAddPodcastMutationOptions = Apollo.BaseMutationOptions<ClaimAddPodcastMutation, ClaimAddPodcastMutationVariables>;
export const ClaimFeedDocument = gql`
    mutation claimFeed($input: ClaimFeedInput!) {
  authed {
    success
  }
  claimFeed(input: $input) {
    publisher {
      name
      email
    }
  }
}
    `;
export type ClaimFeedMutationFn = Apollo.MutationFunction<ClaimFeedMutation, ClaimFeedMutationVariables>;

/**
 * __useClaimFeedMutation__
 *
 * To run a mutation, you first call `useClaimFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimFeedMutation, { data, loading, error }] = useClaimFeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClaimFeedMutation(baseOptions?: Apollo.MutationHookOptions<ClaimFeedMutation, ClaimFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimFeedMutation, ClaimFeedMutationVariables>(ClaimFeedDocument, options);
      }
export type ClaimFeedMutationHookResult = ReturnType<typeof useClaimFeedMutation>;
export type ClaimFeedMutationResult = Apollo.MutationResult<ClaimFeedMutation>;
export type ClaimFeedMutationOptions = Apollo.BaseMutationOptions<ClaimFeedMutation, ClaimFeedMutationVariables>;
export const ContactPublisherDocument = gql`
    mutation contactPublisher($input: ContactPublisherInput!) {
  authed {
    success
  }
  contactPublisher(input: $input) {
    success
  }
}
    `;
export type ContactPublisherMutationFn = Apollo.MutationFunction<ContactPublisherMutation, ContactPublisherMutationVariables>;

/**
 * __useContactPublisherMutation__
 *
 * To run a mutation, you first call `useContactPublisherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactPublisherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactPublisherMutation, { data, loading, error }] = useContactPublisherMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactPublisherMutation(baseOptions?: Apollo.MutationHookOptions<ContactPublisherMutation, ContactPublisherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactPublisherMutation, ContactPublisherMutationVariables>(ContactPublisherDocument, options);
      }
export type ContactPublisherMutationHookResult = ReturnType<typeof useContactPublisherMutation>;
export type ContactPublisherMutationResult = Apollo.MutationResult<ContactPublisherMutation>;
export type ContactPublisherMutationOptions = Apollo.BaseMutationOptions<ContactPublisherMutation, ContactPublisherMutationVariables>;
export const CreateActionMapDocument = gql`
    mutation createActionMap($input: CreateActionMapInput!) {
  authed {
    success
  }
  createActionMap(input: $input) {
    actionMap {
      id
      eventName
      action
    }
  }
}
    `;
export type CreateActionMapMutationFn = Apollo.MutationFunction<CreateActionMapMutation, CreateActionMapMutationVariables>;

/**
 * __useCreateActionMapMutation__
 *
 * To run a mutation, you first call `useCreateActionMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActionMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActionMapMutation, { data, loading, error }] = useCreateActionMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateActionMapMutation(baseOptions?: Apollo.MutationHookOptions<CreateActionMapMutation, CreateActionMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActionMapMutation, CreateActionMapMutationVariables>(CreateActionMapDocument, options);
      }
export type CreateActionMapMutationHookResult = ReturnType<typeof useCreateActionMapMutation>;
export type CreateActionMapMutationResult = Apollo.MutationResult<CreateActionMapMutation>;
export type CreateActionMapMutationOptions = Apollo.BaseMutationOptions<CreateActionMapMutation, CreateActionMapMutationVariables>;
export const CreateAdvisorSavedSearchDocument = gql`
    mutation createAdvisorSavedSearch($input: CreateAdvisorSavedSearchInput!) {
  authed {
    success
  }
  createAdvisorSavedSearch(input: $input) {
    advisorSavedSearch {
      id
    }
  }
}
    `;
export type CreateAdvisorSavedSearchMutationFn = Apollo.MutationFunction<CreateAdvisorSavedSearchMutation, CreateAdvisorSavedSearchMutationVariables>;

/**
 * __useCreateAdvisorSavedSearchMutation__
 *
 * To run a mutation, you first call `useCreateAdvisorSavedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdvisorSavedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdvisorSavedSearchMutation, { data, loading, error }] = useCreateAdvisorSavedSearchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdvisorSavedSearchMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdvisorSavedSearchMutation, CreateAdvisorSavedSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdvisorSavedSearchMutation, CreateAdvisorSavedSearchMutationVariables>(CreateAdvisorSavedSearchDocument, options);
      }
export type CreateAdvisorSavedSearchMutationHookResult = ReturnType<typeof useCreateAdvisorSavedSearchMutation>;
export type CreateAdvisorSavedSearchMutationResult = Apollo.MutationResult<CreateAdvisorSavedSearchMutation>;
export type CreateAdvisorSavedSearchMutationOptions = Apollo.BaseMutationOptions<CreateAdvisorSavedSearchMutation, CreateAdvisorSavedSearchMutationVariables>;
export const CreateBrandInvitesDocument = gql`
    mutation createBrandInvites($input: CreateBrandInvitesInput!) {
  authed {
    success
  }
  createBrandInvites(input: $input) {
    success
    organizationId
  }
}
    `;
export type CreateBrandInvitesMutationFn = Apollo.MutationFunction<CreateBrandInvitesMutation, CreateBrandInvitesMutationVariables>;

/**
 * __useCreateBrandInvitesMutation__
 *
 * To run a mutation, you first call `useCreateBrandInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandInvitesMutation, { data, loading, error }] = useCreateBrandInvitesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrandInvitesMutation(baseOptions?: Apollo.MutationHookOptions<CreateBrandInvitesMutation, CreateBrandInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBrandInvitesMutation, CreateBrandInvitesMutationVariables>(CreateBrandInvitesDocument, options);
      }
export type CreateBrandInvitesMutationHookResult = ReturnType<typeof useCreateBrandInvitesMutation>;
export type CreateBrandInvitesMutationResult = Apollo.MutationResult<CreateBrandInvitesMutation>;
export type CreateBrandInvitesMutationOptions = Apollo.BaseMutationOptions<CreateBrandInvitesMutation, CreateBrandInvitesMutationVariables>;
export const CreateCampaignApprovalsDocument = gql`
    mutation createCampaignApprovals($input: CreateCampaignApprovalsInput!) {
  authed {
    success
  }
  createCampaignApprovals(input: $input) {
    dynamicApprovals {
      ...DynamicApproval
    }
    podcastApprovals {
      ...PodcastApproval
    }
    streamingApprovals {
      ...StreamingApproval
    }
  }
}
    ${DynamicApprovalFragmentDoc}
${PodcastApprovalFragmentDoc}
${StreamingApprovalFragmentDoc}`;
export type CreateCampaignApprovalsMutationFn = Apollo.MutationFunction<CreateCampaignApprovalsMutation, CreateCampaignApprovalsMutationVariables>;

/**
 * __useCreateCampaignApprovalsMutation__
 *
 * To run a mutation, you first call `useCreateCampaignApprovalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignApprovalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignApprovalsMutation, { data, loading, error }] = useCreateCampaignApprovalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignApprovalsMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignApprovalsMutation, CreateCampaignApprovalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignApprovalsMutation, CreateCampaignApprovalsMutationVariables>(CreateCampaignApprovalsDocument, options);
      }
export type CreateCampaignApprovalsMutationHookResult = ReturnType<typeof useCreateCampaignApprovalsMutation>;
export type CreateCampaignApprovalsMutationResult = Apollo.MutationResult<CreateCampaignApprovalsMutation>;
export type CreateCampaignApprovalsMutationOptions = Apollo.BaseMutationOptions<CreateCampaignApprovalsMutation, CreateCampaignApprovalsMutationVariables>;
export const CreateCampaignLinkDocument = gql`
    mutation createCampaignLink($input: CreateCampaignLinkInput!) {
  authed {
    success
  }
  createCampaignLink(input: $input) {
    campaignLink {
      ...CampaignLink
    }
  }
}
    ${CampaignLinkFragmentDoc}`;
export type CreateCampaignLinkMutationFn = Apollo.MutationFunction<CreateCampaignLinkMutation, CreateCampaignLinkMutationVariables>;

/**
 * __useCreateCampaignLinkMutation__
 *
 * To run a mutation, you first call `useCreateCampaignLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignLinkMutation, { data, loading, error }] = useCreateCampaignLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignLinkMutation, CreateCampaignLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignLinkMutation, CreateCampaignLinkMutationVariables>(CreateCampaignLinkDocument, options);
      }
export type CreateCampaignLinkMutationHookResult = ReturnType<typeof useCreateCampaignLinkMutation>;
export type CreateCampaignLinkMutationResult = Apollo.MutationResult<CreateCampaignLinkMutation>;
export type CreateCampaignLinkMutationOptions = Apollo.BaseMutationOptions<CreateCampaignLinkMutation, CreateCampaignLinkMutationVariables>;
export const CreateCampaignNoiseDocument = gql`
    mutation createCampaignNoise($input: CreateCampaignNoiseInput!) {
  authed {
    success
  }
  createCampaignNoise(input: $input) {
    campaignNoise {
      ...CampaignNoise
    }
  }
}
    ${CampaignNoiseFragmentDoc}`;
export type CreateCampaignNoiseMutationFn = Apollo.MutationFunction<CreateCampaignNoiseMutation, CreateCampaignNoiseMutationVariables>;

/**
 * __useCreateCampaignNoiseMutation__
 *
 * To run a mutation, you first call `useCreateCampaignNoiseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignNoiseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignNoiseMutation, { data, loading, error }] = useCreateCampaignNoiseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignNoiseMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignNoiseMutation, CreateCampaignNoiseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignNoiseMutation, CreateCampaignNoiseMutationVariables>(CreateCampaignNoiseDocument, options);
      }
export type CreateCampaignNoiseMutationHookResult = ReturnType<typeof useCreateCampaignNoiseMutation>;
export type CreateCampaignNoiseMutationResult = Apollo.MutationResult<CreateCampaignNoiseMutation>;
export type CreateCampaignNoiseMutationOptions = Apollo.BaseMutationOptions<CreateCampaignNoiseMutation, CreateCampaignNoiseMutationVariables>;
export const CreateCampaignPodcastDocument = gql`
    mutation createCampaignPodcast($input: CreateCampaignPodcastInput!) {
  authed {
    success
  }
  createCampaignPodcast(input: $input) {
    campaignPodcast {
      ...CampaignPodcast
    }
  }
}
    ${CampaignPodcastFragmentDoc}`;
export type CreateCampaignPodcastMutationFn = Apollo.MutationFunction<CreateCampaignPodcastMutation, CreateCampaignPodcastMutationVariables>;

/**
 * __useCreateCampaignPodcastMutation__
 *
 * To run a mutation, you first call `useCreateCampaignPodcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignPodcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignPodcastMutation, { data, loading, error }] = useCreateCampaignPodcastMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignPodcastMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignPodcastMutation, CreateCampaignPodcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignPodcastMutation, CreateCampaignPodcastMutationVariables>(CreateCampaignPodcastDocument, options);
      }
export type CreateCampaignPodcastMutationHookResult = ReturnType<typeof useCreateCampaignPodcastMutation>;
export type CreateCampaignPodcastMutationResult = Apollo.MutationResult<CreateCampaignPodcastMutation>;
export type CreateCampaignPodcastMutationOptions = Apollo.BaseMutationOptions<CreateCampaignPodcastMutation, CreateCampaignPodcastMutationVariables>;
export const CreateCampaignStreamingDocument = gql`
    mutation createCampaignStreaming($input: CreateCampaignStreamingInput!) {
  authed {
    success
  }
  createCampaignStreaming(input: $input) {
    campaignStreaming {
      ...CampaignStreamingOld
    }
  }
}
    ${CampaignStreamingOldFragmentDoc}`;
export type CreateCampaignStreamingMutationFn = Apollo.MutationFunction<CreateCampaignStreamingMutation, CreateCampaignStreamingMutationVariables>;

/**
 * __useCreateCampaignStreamingMutation__
 *
 * To run a mutation, you first call `useCreateCampaignStreamingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignStreamingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignStreamingMutation, { data, loading, error }] = useCreateCampaignStreamingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignStreamingMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignStreamingMutation, CreateCampaignStreamingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignStreamingMutation, CreateCampaignStreamingMutationVariables>(CreateCampaignStreamingDocument, options);
      }
export type CreateCampaignStreamingMutationHookResult = ReturnType<typeof useCreateCampaignStreamingMutation>;
export type CreateCampaignStreamingMutationResult = Apollo.MutationResult<CreateCampaignStreamingMutation>;
export type CreateCampaignStreamingMutationOptions = Apollo.BaseMutationOptions<CreateCampaignStreamingMutation, CreateCampaignStreamingMutationVariables>;
export const CreateCampaignTargetDocument = gql`
    mutation createCampaignTarget($input: CreateCampaignTargetInput!) {
  authed {
    success
  }
  createCampaignTarget(input: $input) {
    campaignTarget {
      ...CampaignTarget
    }
  }
}
    ${CampaignTargetFragmentDoc}`;
export type CreateCampaignTargetMutationFn = Apollo.MutationFunction<CreateCampaignTargetMutation, CreateCampaignTargetMutationVariables>;

/**
 * __useCreateCampaignTargetMutation__
 *
 * To run a mutation, you first call `useCreateCampaignTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignTargetMutation, { data, loading, error }] = useCreateCampaignTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignTargetMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignTargetMutation, CreateCampaignTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignTargetMutation, CreateCampaignTargetMutationVariables>(CreateCampaignTargetDocument, options);
      }
export type CreateCampaignTargetMutationHookResult = ReturnType<typeof useCreateCampaignTargetMutation>;
export type CreateCampaignTargetMutationResult = Apollo.MutationResult<CreateCampaignTargetMutation>;
export type CreateCampaignTargetMutationOptions = Apollo.BaseMutationOptions<CreateCampaignTargetMutation, CreateCampaignTargetMutationVariables>;
export const CreateConversionUrlDocument = gql`
    mutation createConversionUrl($input: CreateConversionURLInput!) {
  authed {
    success
  }
  createConversionUrl(input: $input) {
    conversionUrl {
      id
      url
      value
      action
      type
      category
    }
  }
}
    `;
export type CreateConversionUrlMutationFn = Apollo.MutationFunction<CreateConversionUrlMutation, CreateConversionUrlMutationVariables>;

/**
 * __useCreateConversionUrlMutation__
 *
 * To run a mutation, you first call `useCreateConversionUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversionUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversionUrlMutation, { data, loading, error }] = useCreateConversionUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConversionUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversionUrlMutation, CreateConversionUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversionUrlMutation, CreateConversionUrlMutationVariables>(CreateConversionUrlDocument, options);
      }
export type CreateConversionUrlMutationHookResult = ReturnType<typeof useCreateConversionUrlMutation>;
export type CreateConversionUrlMutationResult = Apollo.MutationResult<CreateConversionUrlMutation>;
export type CreateConversionUrlMutationOptions = Apollo.BaseMutationOptions<CreateConversionUrlMutation, CreateConversionUrlMutationVariables>;
export const CreateFutureEpisodeDocument = gql`
    mutation createFutureEpisode($input: CreateFutureEpisodeInput!) {
  authed {
    success
  }
  createFutureEpisode(input: $input) {
    organizationId
    podcastId
    futureEpisode {
      id
      title
      subtitle
      expectedPublished
      createdAt
      campaignEpisodes {
        id
        campaignPodcast {
          id
        }
      }
    }
  }
}
    `;
export type CreateFutureEpisodeMutationFn = Apollo.MutationFunction<CreateFutureEpisodeMutation, CreateFutureEpisodeMutationVariables>;

/**
 * __useCreateFutureEpisodeMutation__
 *
 * To run a mutation, you first call `useCreateFutureEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFutureEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFutureEpisodeMutation, { data, loading, error }] = useCreateFutureEpisodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFutureEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateFutureEpisodeMutation, CreateFutureEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFutureEpisodeMutation, CreateFutureEpisodeMutationVariables>(CreateFutureEpisodeDocument, options);
      }
export type CreateFutureEpisodeMutationHookResult = ReturnType<typeof useCreateFutureEpisodeMutation>;
export type CreateFutureEpisodeMutationResult = Apollo.MutationResult<CreateFutureEpisodeMutation>;
export type CreateFutureEpisodeMutationOptions = Apollo.BaseMutationOptions<CreateFutureEpisodeMutation, CreateFutureEpisodeMutationVariables>;
export const CreateGenericTagDocument = gql`
    mutation createGenericTag($input: CreateGenericTagInput!) {
  authed {
    success
  }
  createGenericTag(input: $input) {
    genericTag {
      organization {
        id
      }
      id
      title
      color
    }
  }
}
    `;
export type CreateGenericTagMutationFn = Apollo.MutationFunction<CreateGenericTagMutation, CreateGenericTagMutationVariables>;

/**
 * __useCreateGenericTagMutation__
 *
 * To run a mutation, you first call `useCreateGenericTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericTagMutation, { data, loading, error }] = useCreateGenericTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGenericTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericTagMutation, CreateGenericTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericTagMutation, CreateGenericTagMutationVariables>(CreateGenericTagDocument, options);
      }
export type CreateGenericTagMutationHookResult = ReturnType<typeof useCreateGenericTagMutation>;
export type CreateGenericTagMutationResult = Apollo.MutationResult<CreateGenericTagMutation>;
export type CreateGenericTagMutationOptions = Apollo.BaseMutationOptions<CreateGenericTagMutation, CreateGenericTagMutationVariables>;
export const CreateGenericTagRelationshipDocument = gql`
    mutation createGenericTagRelationship($input: CreateGenericTagRelationshipInput!) {
  authed {
    success
  }
  createGenericTagRelationship(input: $input) {
    genericTagRelationship {
      genericTag {
        id
      }
      id
      objectPk
    }
  }
}
    `;
export type CreateGenericTagRelationshipMutationFn = Apollo.MutationFunction<CreateGenericTagRelationshipMutation, CreateGenericTagRelationshipMutationVariables>;

/**
 * __useCreateGenericTagRelationshipMutation__
 *
 * To run a mutation, you first call `useCreateGenericTagRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericTagRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGenericTagRelationshipMutation, { data, loading, error }] = useCreateGenericTagRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGenericTagRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<CreateGenericTagRelationshipMutation, CreateGenericTagRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGenericTagRelationshipMutation, CreateGenericTagRelationshipMutationVariables>(CreateGenericTagRelationshipDocument, options);
      }
export type CreateGenericTagRelationshipMutationHookResult = ReturnType<typeof useCreateGenericTagRelationshipMutation>;
export type CreateGenericTagRelationshipMutationResult = Apollo.MutationResult<CreateGenericTagRelationshipMutation>;
export type CreateGenericTagRelationshipMutationOptions = Apollo.BaseMutationOptions<CreateGenericTagRelationshipMutation, CreateGenericTagRelationshipMutationVariables>;
export const CreateOrganizationDocument = gql`
    mutation createOrganization($input: CreateOrganizationInput!) {
  authed {
    success
  }
  createOrganization(input: $input) {
    organization {
      id
      name
      slug
      kind
    }
  }
}
    `;
export type CreateOrganizationMutationFn = Apollo.MutationFunction<CreateOrganizationMutation, CreateOrganizationMutationVariables>;

/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument, options);
      }
export type CreateOrganizationMutationHookResult = ReturnType<typeof useCreateOrganizationMutation>;
export type CreateOrganizationMutationResult = Apollo.MutationResult<CreateOrganizationMutation>;
export type CreateOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationMutation, CreateOrganizationMutationVariables>;
export const CreatePixelEventRecordDocument = gql`
    mutation createPixelEventRecord($input: CreatePixelEventRecordInput!) {
  authed {
    success
  }
  createPixelEventRecord(input: $input) {
    pixelEventRecord {
      id
      name
      eventType
      installation
      lastUpdatedBy {
        id
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreatePixelEventRecordMutationFn = Apollo.MutationFunction<CreatePixelEventRecordMutation, CreatePixelEventRecordMutationVariables>;

/**
 * __useCreatePixelEventRecordMutation__
 *
 * To run a mutation, you first call `useCreatePixelEventRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePixelEventRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPixelEventRecordMutation, { data, loading, error }] = useCreatePixelEventRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePixelEventRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreatePixelEventRecordMutation, CreatePixelEventRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePixelEventRecordMutation, CreatePixelEventRecordMutationVariables>(CreatePixelEventRecordDocument, options);
      }
export type CreatePixelEventRecordMutationHookResult = ReturnType<typeof useCreatePixelEventRecordMutation>;
export type CreatePixelEventRecordMutationResult = Apollo.MutationResult<CreatePixelEventRecordMutation>;
export type CreatePixelEventRecordMutationOptions = Apollo.BaseMutationOptions<CreatePixelEventRecordMutation, CreatePixelEventRecordMutationVariables>;
export const CreatePodlinkDomainDocument = gql`
    mutation createPodlinkDomain($input: CreatePodlinkDomainInput!) {
  authed {
    success
  }
  createPodlinkDomain(input: $input) {
    podlinkDomain {
      ...PodlinkDomain
    }
  }
}
    ${PodlinkDomainFragmentDoc}`;
export type CreatePodlinkDomainMutationFn = Apollo.MutationFunction<CreatePodlinkDomainMutation, CreatePodlinkDomainMutationVariables>;

/**
 * __useCreatePodlinkDomainMutation__
 *
 * To run a mutation, you first call `useCreatePodlinkDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePodlinkDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPodlinkDomainMutation, { data, loading, error }] = useCreatePodlinkDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePodlinkDomainMutation(baseOptions?: Apollo.MutationHookOptions<CreatePodlinkDomainMutation, CreatePodlinkDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePodlinkDomainMutation, CreatePodlinkDomainMutationVariables>(CreatePodlinkDomainDocument, options);
      }
export type CreatePodlinkDomainMutationHookResult = ReturnType<typeof useCreatePodlinkDomainMutation>;
export type CreatePodlinkDomainMutationResult = Apollo.MutationResult<CreatePodlinkDomainMutation>;
export type CreatePodlinkDomainMutationOptions = Apollo.BaseMutationOptions<CreatePodlinkDomainMutation, CreatePodlinkDomainMutationVariables>;
export const CreateReviewerDocument = gql`
    mutation createReviewer($input: CreateReviewerInput!) {
  authed {
    success
  }
  createReviewer(input: $input) {
    reviewer {
      id
      firstName
      lastName
      email
      type
    }
  }
}
    `;
export type CreateReviewerMutationFn = Apollo.MutationFunction<CreateReviewerMutation, CreateReviewerMutationVariables>;

/**
 * __useCreateReviewerMutation__
 *
 * To run a mutation, you first call `useCreateReviewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewerMutation, { data, loading, error }] = useCreateReviewerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReviewerMutation(baseOptions?: Apollo.MutationHookOptions<CreateReviewerMutation, CreateReviewerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReviewerMutation, CreateReviewerMutationVariables>(CreateReviewerDocument, options);
      }
export type CreateReviewerMutationHookResult = ReturnType<typeof useCreateReviewerMutation>;
export type CreateReviewerMutationResult = Apollo.MutationResult<CreateReviewerMutation>;
export type CreateReviewerMutationOptions = Apollo.BaseMutationOptions<CreateReviewerMutation, CreateReviewerMutationVariables>;
export const CreateUserAccessDocument = gql`
    mutation createUserAccess($input: CreateUserAccessInput!) {
  authed {
    success
  }
  createUserAccess(input: $input) {
    userAccess {
      ...UserAccess
    }
  }
}
    ${UserAccessFragmentDoc}`;
export type CreateUserAccessMutationFn = Apollo.MutationFunction<CreateUserAccessMutation, CreateUserAccessMutationVariables>;

/**
 * __useCreateUserAccessMutation__
 *
 * To run a mutation, you first call `useCreateUserAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserAccessMutation, { data, loading, error }] = useCreateUserAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserAccessMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserAccessMutation, CreateUserAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserAccessMutation, CreateUserAccessMutationVariables>(CreateUserAccessDocument, options);
      }
export type CreateUserAccessMutationHookResult = ReturnType<typeof useCreateUserAccessMutation>;
export type CreateUserAccessMutationResult = Apollo.MutationResult<CreateUserAccessMutation>;
export type CreateUserAccessMutationOptions = Apollo.BaseMutationOptions<CreateUserAccessMutation, CreateUserAccessMutationVariables>;
export const DeleteActionMapDocument = gql`
    mutation deleteActionMap($input: DeleteActionMapInput!) {
  authed {
    success
  }
  deleteActionMap(input: $input) {
    success
  }
}
    `;
export type DeleteActionMapMutationFn = Apollo.MutationFunction<DeleteActionMapMutation, DeleteActionMapMutationVariables>;

/**
 * __useDeleteActionMapMutation__
 *
 * To run a mutation, you first call `useDeleteActionMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionMapMutation, { data, loading, error }] = useDeleteActionMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteActionMapMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionMapMutation, DeleteActionMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionMapMutation, DeleteActionMapMutationVariables>(DeleteActionMapDocument, options);
      }
export type DeleteActionMapMutationHookResult = ReturnType<typeof useDeleteActionMapMutation>;
export type DeleteActionMapMutationResult = Apollo.MutationResult<DeleteActionMapMutation>;
export type DeleteActionMapMutationOptions = Apollo.BaseMutationOptions<DeleteActionMapMutation, DeleteActionMapMutationVariables>;
export const DeleteAdvisorSavedSearchDocument = gql`
    mutation deleteAdvisorSavedSearch($input: DeleteAdvisorSavedSearchInput!) {
  authed {
    success
  }
  deleteAdvisorSavedSearch(input: $input) {
    success
  }
}
    `;
export type DeleteAdvisorSavedSearchMutationFn = Apollo.MutationFunction<DeleteAdvisorSavedSearchMutation, DeleteAdvisorSavedSearchMutationVariables>;

/**
 * __useDeleteAdvisorSavedSearchMutation__
 *
 * To run a mutation, you first call `useDeleteAdvisorSavedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdvisorSavedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdvisorSavedSearchMutation, { data, loading, error }] = useDeleteAdvisorSavedSearchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAdvisorSavedSearchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdvisorSavedSearchMutation, DeleteAdvisorSavedSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdvisorSavedSearchMutation, DeleteAdvisorSavedSearchMutationVariables>(DeleteAdvisorSavedSearchDocument, options);
      }
export type DeleteAdvisorSavedSearchMutationHookResult = ReturnType<typeof useDeleteAdvisorSavedSearchMutation>;
export type DeleteAdvisorSavedSearchMutationResult = Apollo.MutationResult<DeleteAdvisorSavedSearchMutation>;
export type DeleteAdvisorSavedSearchMutationOptions = Apollo.BaseMutationOptions<DeleteAdvisorSavedSearchMutation, DeleteAdvisorSavedSearchMutationVariables>;
export const DeleteCampaignDocument = gql`
    mutation deleteCampaign($input: DeleteCampaignInput!) {
  authed {
    success
  }
  deleteCampaign(input: $input) {
    success
  }
}
    `;
export type DeleteCampaignMutationFn = Apollo.MutationFunction<DeleteCampaignMutation, DeleteCampaignMutationVariables>;

/**
 * __useDeleteCampaignMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignMutation, { data, loading, error }] = useDeleteCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCampaignMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignMutation, DeleteCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignMutation, DeleteCampaignMutationVariables>(DeleteCampaignDocument, options);
      }
export type DeleteCampaignMutationHookResult = ReturnType<typeof useDeleteCampaignMutation>;
export type DeleteCampaignMutationResult = Apollo.MutationResult<DeleteCampaignMutation>;
export type DeleteCampaignMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignMutation, DeleteCampaignMutationVariables>;
export const DeleteCampaignNoiseDocument = gql`
    mutation deleteCampaignNoise($input: DeleteCampaignNoiseInput!) {
  authed {
    success
  }
  deleteCampaignNoise(input: $input) {
    success
  }
}
    `;
export type DeleteCampaignNoiseMutationFn = Apollo.MutationFunction<DeleteCampaignNoiseMutation, DeleteCampaignNoiseMutationVariables>;

/**
 * __useDeleteCampaignNoiseMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignNoiseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignNoiseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignNoiseMutation, { data, loading, error }] = useDeleteCampaignNoiseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCampaignNoiseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignNoiseMutation, DeleteCampaignNoiseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignNoiseMutation, DeleteCampaignNoiseMutationVariables>(DeleteCampaignNoiseDocument, options);
      }
export type DeleteCampaignNoiseMutationHookResult = ReturnType<typeof useDeleteCampaignNoiseMutation>;
export type DeleteCampaignNoiseMutationResult = Apollo.MutationResult<DeleteCampaignNoiseMutation>;
export type DeleteCampaignNoiseMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignNoiseMutation, DeleteCampaignNoiseMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation deleteComment($input: DeleteCommentInput!, $organizationId: ID!) {
  authed(input: {organizationId: $organizationId}) {
    success
  }
  deleteComment(input: $input) {
    success
  }
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeleteConversionUrlDocument = gql`
    mutation deleteConversionUrl($input: DeleteConversionURLInput!) {
  authed {
    success
  }
  deleteConversionUrl(input: $input) {
    success
  }
}
    `;
export type DeleteConversionUrlMutationFn = Apollo.MutationFunction<DeleteConversionUrlMutation, DeleteConversionUrlMutationVariables>;

/**
 * __useDeleteConversionUrlMutation__
 *
 * To run a mutation, you first call `useDeleteConversionUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConversionUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConversionUrlMutation, { data, loading, error }] = useDeleteConversionUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteConversionUrlMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConversionUrlMutation, DeleteConversionUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConversionUrlMutation, DeleteConversionUrlMutationVariables>(DeleteConversionUrlDocument, options);
      }
export type DeleteConversionUrlMutationHookResult = ReturnType<typeof useDeleteConversionUrlMutation>;
export type DeleteConversionUrlMutationResult = Apollo.MutationResult<DeleteConversionUrlMutation>;
export type DeleteConversionUrlMutationOptions = Apollo.BaseMutationOptions<DeleteConversionUrlMutation, DeleteConversionUrlMutationVariables>;
export const DeleteGenericTagDocument = gql`
    mutation deleteGenericTag($input: DeleteGenericTagInput!) {
  authed {
    success
  }
  deleteGenericTag(input: $input) {
    success
  }
}
    `;
export type DeleteGenericTagMutationFn = Apollo.MutationFunction<DeleteGenericTagMutation, DeleteGenericTagMutationVariables>;

/**
 * __useDeleteGenericTagMutation__
 *
 * To run a mutation, you first call `useDeleteGenericTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGenericTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGenericTagMutation, { data, loading, error }] = useDeleteGenericTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteGenericTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGenericTagMutation, DeleteGenericTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGenericTagMutation, DeleteGenericTagMutationVariables>(DeleteGenericTagDocument, options);
      }
export type DeleteGenericTagMutationHookResult = ReturnType<typeof useDeleteGenericTagMutation>;
export type DeleteGenericTagMutationResult = Apollo.MutationResult<DeleteGenericTagMutation>;
export type DeleteGenericTagMutationOptions = Apollo.BaseMutationOptions<DeleteGenericTagMutation, DeleteGenericTagMutationVariables>;
export const DeleteGenericTagRelationshipDocument = gql`
    mutation deleteGenericTagRelationship($input: DeleteGenericTagRelationshipInput!) {
  authed {
    success
  }
  deleteGenericTagRelationship(input: $input) {
    success
  }
}
    `;
export type DeleteGenericTagRelationshipMutationFn = Apollo.MutationFunction<DeleteGenericTagRelationshipMutation, DeleteGenericTagRelationshipMutationVariables>;

/**
 * __useDeleteGenericTagRelationshipMutation__
 *
 * To run a mutation, you first call `useDeleteGenericTagRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGenericTagRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGenericTagRelationshipMutation, { data, loading, error }] = useDeleteGenericTagRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteGenericTagRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGenericTagRelationshipMutation, DeleteGenericTagRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGenericTagRelationshipMutation, DeleteGenericTagRelationshipMutationVariables>(DeleteGenericTagRelationshipDocument, options);
      }
export type DeleteGenericTagRelationshipMutationHookResult = ReturnType<typeof useDeleteGenericTagRelationshipMutation>;
export type DeleteGenericTagRelationshipMutationResult = Apollo.MutationResult<DeleteGenericTagRelationshipMutation>;
export type DeleteGenericTagRelationshipMutationOptions = Apollo.BaseMutationOptions<DeleteGenericTagRelationshipMutation, DeleteGenericTagRelationshipMutationVariables>;
export const DeletePixelEventRecordDocument = gql`
    mutation deletePixelEventRecord($input: DeletePixelEventRecordInput!) {
  authed {
    success
  }
  deletePixelEventRecord(input: $input) {
    success
  }
}
    `;
export type DeletePixelEventRecordMutationFn = Apollo.MutationFunction<DeletePixelEventRecordMutation, DeletePixelEventRecordMutationVariables>;

/**
 * __useDeletePixelEventRecordMutation__
 *
 * To run a mutation, you first call `useDeletePixelEventRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePixelEventRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePixelEventRecordMutation, { data, loading, error }] = useDeletePixelEventRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePixelEventRecordMutation(baseOptions?: Apollo.MutationHookOptions<DeletePixelEventRecordMutation, DeletePixelEventRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePixelEventRecordMutation, DeletePixelEventRecordMutationVariables>(DeletePixelEventRecordDocument, options);
      }
export type DeletePixelEventRecordMutationHookResult = ReturnType<typeof useDeletePixelEventRecordMutation>;
export type DeletePixelEventRecordMutationResult = Apollo.MutationResult<DeletePixelEventRecordMutation>;
export type DeletePixelEventRecordMutationOptions = Apollo.BaseMutationOptions<DeletePixelEventRecordMutation, DeletePixelEventRecordMutationVariables>;
export const DeletePodcastsDocument = gql`
    mutation deletePodcasts($input: DeletePodcastsInput!) {
  authed {
    success
  }
  deletePodcasts(input: $input) {
    success
  }
}
    `;
export type DeletePodcastsMutationFn = Apollo.MutationFunction<DeletePodcastsMutation, DeletePodcastsMutationVariables>;

/**
 * __useDeletePodcastsMutation__
 *
 * To run a mutation, you first call `useDeletePodcastsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePodcastsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePodcastsMutation, { data, loading, error }] = useDeletePodcastsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePodcastsMutation(baseOptions?: Apollo.MutationHookOptions<DeletePodcastsMutation, DeletePodcastsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePodcastsMutation, DeletePodcastsMutationVariables>(DeletePodcastsDocument, options);
      }
export type DeletePodcastsMutationHookResult = ReturnType<typeof useDeletePodcastsMutation>;
export type DeletePodcastsMutationResult = Apollo.MutationResult<DeletePodcastsMutation>;
export type DeletePodcastsMutationOptions = Apollo.BaseMutationOptions<DeletePodcastsMutation, DeletePodcastsMutationVariables>;
export const DeletePodlinkDomainDocument = gql`
    mutation deletePodlinkDomain($input: DeletePodlinkDomainInput!) {
  authed {
    success
  }
  deletePodlinkDomain(input: $input) {
    success
  }
}
    `;
export type DeletePodlinkDomainMutationFn = Apollo.MutationFunction<DeletePodlinkDomainMutation, DeletePodlinkDomainMutationVariables>;

/**
 * __useDeletePodlinkDomainMutation__
 *
 * To run a mutation, you first call `useDeletePodlinkDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePodlinkDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePodlinkDomainMutation, { data, loading, error }] = useDeletePodlinkDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePodlinkDomainMutation(baseOptions?: Apollo.MutationHookOptions<DeletePodlinkDomainMutation, DeletePodlinkDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePodlinkDomainMutation, DeletePodlinkDomainMutationVariables>(DeletePodlinkDomainDocument, options);
      }
export type DeletePodlinkDomainMutationHookResult = ReturnType<typeof useDeletePodlinkDomainMutation>;
export type DeletePodlinkDomainMutationResult = Apollo.MutationResult<DeletePodlinkDomainMutation>;
export type DeletePodlinkDomainMutationOptions = Apollo.BaseMutationOptions<DeletePodlinkDomainMutation, DeletePodlinkDomainMutationVariables>;
export const DeleteUserAccessDocument = gql`
    mutation deleteUserAccess($input: DeleteUserAccessInput!) {
  authed {
    success
  }
  deleteUserAccess(input: $input) {
    success
  }
}
    `;
export type DeleteUserAccessMutationFn = Apollo.MutationFunction<DeleteUserAccessMutation, DeleteUserAccessMutationVariables>;

/**
 * __useDeleteUserAccessMutation__
 *
 * To run a mutation, you first call `useDeleteUserAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserAccessMutation, { data, loading, error }] = useDeleteUserAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserAccessMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserAccessMutation, DeleteUserAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserAccessMutation, DeleteUserAccessMutationVariables>(DeleteUserAccessDocument, options);
      }
export type DeleteUserAccessMutationHookResult = ReturnType<typeof useDeleteUserAccessMutation>;
export type DeleteUserAccessMutationResult = Apollo.MutationResult<DeleteUserAccessMutation>;
export type DeleteUserAccessMutationOptions = Apollo.BaseMutationOptions<DeleteUserAccessMutation, DeleteUserAccessMutationVariables>;
export const DesignPodlinkDomainDocument = gql`
    mutation designPodlinkDomain($input: DesignPodlinkDomainInput!) {
  authed {
    success
  }
  designPodlinkDomain(input: $input) {
    podlinkDomain {
      ...PodlinkDomain
      backgroundColor
      fontColor
      primaryColor
      secondaryColor
      image {
        ...Asset
      }
      favicon {
        ...Asset
      }
    }
  }
}
    ${PodlinkDomainFragmentDoc}
${AssetFragmentDoc}`;
export type DesignPodlinkDomainMutationFn = Apollo.MutationFunction<DesignPodlinkDomainMutation, DesignPodlinkDomainMutationVariables>;

/**
 * __useDesignPodlinkDomainMutation__
 *
 * To run a mutation, you first call `useDesignPodlinkDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDesignPodlinkDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [designPodlinkDomainMutation, { data, loading, error }] = useDesignPodlinkDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDesignPodlinkDomainMutation(baseOptions?: Apollo.MutationHookOptions<DesignPodlinkDomainMutation, DesignPodlinkDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DesignPodlinkDomainMutation, DesignPodlinkDomainMutationVariables>(DesignPodlinkDomainDocument, options);
      }
export type DesignPodlinkDomainMutationHookResult = ReturnType<typeof useDesignPodlinkDomainMutation>;
export type DesignPodlinkDomainMutationResult = Apollo.MutationResult<DesignPodlinkDomainMutation>;
export type DesignPodlinkDomainMutationOptions = Apollo.BaseMutationOptions<DesignPodlinkDomainMutation, DesignPodlinkDomainMutationVariables>;
export const DownloadAdDocument = gql`
    mutation downloadAd($input: DownloadAdInput!) {
  authed {
    success
  }
  downloadAd(input: $input) {
    success
  }
}
    `;
export type DownloadAdMutationFn = Apollo.MutationFunction<DownloadAdMutation, DownloadAdMutationVariables>;

/**
 * __useDownloadAdMutation__
 *
 * To run a mutation, you first call `useDownloadAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadAdMutation, { data, loading, error }] = useDownloadAdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadAdMutation(baseOptions?: Apollo.MutationHookOptions<DownloadAdMutation, DownloadAdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadAdMutation, DownloadAdMutationVariables>(DownloadAdDocument, options);
      }
export type DownloadAdMutationHookResult = ReturnType<typeof useDownloadAdMutation>;
export type DownloadAdMutationResult = Apollo.MutationResult<DownloadAdMutation>;
export type DownloadAdMutationOptions = Apollo.BaseMutationOptions<DownloadAdMutation, DownloadAdMutationVariables>;
export const ImportPodcastsDocument = gql`
    mutation importPodcasts($input: ImportPodcastsInput!) {
  authed {
    success
  }
  importPodcasts(input: $input) {
    added {
      ...Podcast
    }
    podcasts {
      ...Podcast
    }
    remove {
      ...Podcast
    }
    issues {
      href
      message
    }
  }
}
    ${PodcastFragmentDoc}`;
export type ImportPodcastsMutationFn = Apollo.MutationFunction<ImportPodcastsMutation, ImportPodcastsMutationVariables>;

/**
 * __useImportPodcastsMutation__
 *
 * To run a mutation, you first call `useImportPodcastsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPodcastsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPodcastsMutation, { data, loading, error }] = useImportPodcastsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportPodcastsMutation(baseOptions?: Apollo.MutationHookOptions<ImportPodcastsMutation, ImportPodcastsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPodcastsMutation, ImportPodcastsMutationVariables>(ImportPodcastsDocument, options);
      }
export type ImportPodcastsMutationHookResult = ReturnType<typeof useImportPodcastsMutation>;
export type ImportPodcastsMutationResult = Apollo.MutationResult<ImportPodcastsMutation>;
export type ImportPodcastsMutationOptions = Apollo.BaseMutationOptions<ImportPodcastsMutation, ImportPodcastsMutationVariables>;
export const IsProcessingPodcastDocument = gql`
    mutation isProcessingPodcast($input: IsProcessingPodcastInput!) {
  authed {
    success
  }
  isProcessingPodcast(input: $input) {
    processing
    podcast {
      id
      processingStartedAt
    }
  }
}
    `;
export type IsProcessingPodcastMutationFn = Apollo.MutationFunction<IsProcessingPodcastMutation, IsProcessingPodcastMutationVariables>;

/**
 * __useIsProcessingPodcastMutation__
 *
 * To run a mutation, you first call `useIsProcessingPodcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIsProcessingPodcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [isProcessingPodcastMutation, { data, loading, error }] = useIsProcessingPodcastMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsProcessingPodcastMutation(baseOptions?: Apollo.MutationHookOptions<IsProcessingPodcastMutation, IsProcessingPodcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IsProcessingPodcastMutation, IsProcessingPodcastMutationVariables>(IsProcessingPodcastDocument, options);
      }
export type IsProcessingPodcastMutationHookResult = ReturnType<typeof useIsProcessingPodcastMutation>;
export type IsProcessingPodcastMutationResult = Apollo.MutationResult<IsProcessingPodcastMutation>;
export type IsProcessingPodcastMutationOptions = Apollo.BaseMutationOptions<IsProcessingPodcastMutation, IsProcessingPodcastMutationVariables>;
export const IsProcessingPodcastsDocument = gql`
    mutation isProcessingPodcasts($input: IsProcessingPodcastsInput!) {
  authed {
    success
  }
  isProcessingPodcasts(input: $input) {
    podcasts {
      ...Podcast
    }
  }
}
    ${PodcastFragmentDoc}`;
export type IsProcessingPodcastsMutationFn = Apollo.MutationFunction<IsProcessingPodcastsMutation, IsProcessingPodcastsMutationVariables>;

/**
 * __useIsProcessingPodcastsMutation__
 *
 * To run a mutation, you first call `useIsProcessingPodcastsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIsProcessingPodcastsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [isProcessingPodcastsMutation, { data, loading, error }] = useIsProcessingPodcastsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsProcessingPodcastsMutation(baseOptions?: Apollo.MutationHookOptions<IsProcessingPodcastsMutation, IsProcessingPodcastsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IsProcessingPodcastsMutation, IsProcessingPodcastsMutationVariables>(IsProcessingPodcastsDocument, options);
      }
export type IsProcessingPodcastsMutationHookResult = ReturnType<typeof useIsProcessingPodcastsMutation>;
export type IsProcessingPodcastsMutationResult = Apollo.MutationResult<IsProcessingPodcastsMutation>;
export type IsProcessingPodcastsMutationOptions = Apollo.BaseMutationOptions<IsProcessingPodcastsMutation, IsProcessingPodcastsMutationVariables>;
export const MeasureFeedDocument = gql`
    mutation measureFeed($input: MeasureFeedInput!) {
  authed {
    success
  }
  measureFeed(input: $input) {
    success
  }
}
    `;
export type MeasureFeedMutationFn = Apollo.MutationFunction<MeasureFeedMutation, MeasureFeedMutationVariables>;

/**
 * __useMeasureFeedMutation__
 *
 * To run a mutation, you first call `useMeasureFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMeasureFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [measureFeedMutation, { data, loading, error }] = useMeasureFeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMeasureFeedMutation(baseOptions?: Apollo.MutationHookOptions<MeasureFeedMutation, MeasureFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MeasureFeedMutation, MeasureFeedMutationVariables>(MeasureFeedDocument, options);
      }
export type MeasureFeedMutationHookResult = ReturnType<typeof useMeasureFeedMutation>;
export type MeasureFeedMutationResult = Apollo.MutationResult<MeasureFeedMutation>;
export type MeasureFeedMutationOptions = Apollo.BaseMutationOptions<MeasureFeedMutation, MeasureFeedMutationVariables>;
export const ProcessCampaignEpisodesDocument = gql`
    mutation processCampaignEpisodes($input: ProcessCampaignEpisodesInput!) {
  authed {
    success
  }
  processCampaignEpisodes(input: $input) {
    success
  }
}
    `;
export type ProcessCampaignEpisodesMutationFn = Apollo.MutationFunction<ProcessCampaignEpisodesMutation, ProcessCampaignEpisodesMutationVariables>;

/**
 * __useProcessCampaignEpisodesMutation__
 *
 * To run a mutation, you first call `useProcessCampaignEpisodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessCampaignEpisodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processCampaignEpisodesMutation, { data, loading, error }] = useProcessCampaignEpisodesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessCampaignEpisodesMutation(baseOptions?: Apollo.MutationHookOptions<ProcessCampaignEpisodesMutation, ProcessCampaignEpisodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessCampaignEpisodesMutation, ProcessCampaignEpisodesMutationVariables>(ProcessCampaignEpisodesDocument, options);
      }
export type ProcessCampaignEpisodesMutationHookResult = ReturnType<typeof useProcessCampaignEpisodesMutation>;
export type ProcessCampaignEpisodesMutationResult = Apollo.MutationResult<ProcessCampaignEpisodesMutation>;
export type ProcessCampaignEpisodesMutationOptions = Apollo.BaseMutationOptions<ProcessCampaignEpisodesMutation, ProcessCampaignEpisodesMutationVariables>;
export const ProcessFeedDocument = gql`
    mutation processFeed($input: ProcessFeedInput!) {
  authed {
    success
  }
  processFeed(input: $input) {
    success
  }
}
    `;
export type ProcessFeedMutationFn = Apollo.MutationFunction<ProcessFeedMutation, ProcessFeedMutationVariables>;

/**
 * __useProcessFeedMutation__
 *
 * To run a mutation, you first call `useProcessFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processFeedMutation, { data, loading, error }] = useProcessFeedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessFeedMutation(baseOptions?: Apollo.MutationHookOptions<ProcessFeedMutation, ProcessFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessFeedMutation, ProcessFeedMutationVariables>(ProcessFeedDocument, options);
      }
export type ProcessFeedMutationHookResult = ReturnType<typeof useProcessFeedMutation>;
export type ProcessFeedMutationResult = Apollo.MutationResult<ProcessFeedMutation>;
export type ProcessFeedMutationOptions = Apollo.BaseMutationOptions<ProcessFeedMutation, ProcessFeedMutationVariables>;
export const RemoveAccessDocument = gql`
    mutation removeAccess($input: RemoveAccessInput!) {
  authed {
    success
  }
  removeAccess(input: $input) {
    success
  }
}
    `;
export type RemoveAccessMutationFn = Apollo.MutationFunction<RemoveAccessMutation, RemoveAccessMutationVariables>;

/**
 * __useRemoveAccessMutation__
 *
 * To run a mutation, you first call `useRemoveAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAccessMutation, { data, loading, error }] = useRemoveAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveAccessMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAccessMutation, RemoveAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAccessMutation, RemoveAccessMutationVariables>(RemoveAccessDocument, options);
      }
export type RemoveAccessMutationHookResult = ReturnType<typeof useRemoveAccessMutation>;
export type RemoveAccessMutationResult = Apollo.MutationResult<RemoveAccessMutation>;
export type RemoveAccessMutationOptions = Apollo.BaseMutationOptions<RemoveAccessMutation, RemoveAccessMutationVariables>;
export const RemoveCampaignEpisodeDocument = gql`
    mutation removeCampaignEpisode($input: RemoveCampaignEpisodeInput!) {
  authed {
    success
  }
  removeCampaignEpisode(input: $input) {
    success
  }
}
    `;
export type RemoveCampaignEpisodeMutationFn = Apollo.MutationFunction<RemoveCampaignEpisodeMutation, RemoveCampaignEpisodeMutationVariables>;

/**
 * __useRemoveCampaignEpisodeMutation__
 *
 * To run a mutation, you first call `useRemoveCampaignEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCampaignEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCampaignEpisodeMutation, { data, loading, error }] = useRemoveCampaignEpisodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCampaignEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCampaignEpisodeMutation, RemoveCampaignEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCampaignEpisodeMutation, RemoveCampaignEpisodeMutationVariables>(RemoveCampaignEpisodeDocument, options);
      }
export type RemoveCampaignEpisodeMutationHookResult = ReturnType<typeof useRemoveCampaignEpisodeMutation>;
export type RemoveCampaignEpisodeMutationResult = Apollo.MutationResult<RemoveCampaignEpisodeMutation>;
export type RemoveCampaignEpisodeMutationOptions = Apollo.BaseMutationOptions<RemoveCampaignEpisodeMutation, RemoveCampaignEpisodeMutationVariables>;
export const RemoveDomainDocument = gql`
    mutation removeDomain($input: RemoveDomainInput!) {
  authed {
    success
  }
  removeDomain(input: $input) {
    success
  }
}
    `;
export type RemoveDomainMutationFn = Apollo.MutationFunction<RemoveDomainMutation, RemoveDomainMutationVariables>;

/**
 * __useRemoveDomainMutation__
 *
 * To run a mutation, you first call `useRemoveDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDomainMutation, { data, loading, error }] = useRemoveDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveDomainMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDomainMutation, RemoveDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDomainMutation, RemoveDomainMutationVariables>(RemoveDomainDocument, options);
      }
export type RemoveDomainMutationHookResult = ReturnType<typeof useRemoveDomainMutation>;
export type RemoveDomainMutationResult = Apollo.MutationResult<RemoveDomainMutation>;
export type RemoveDomainMutationOptions = Apollo.BaseMutationOptions<RemoveDomainMutation, RemoveDomainMutationVariables>;
export const RemoveMemberDocument = gql`
    mutation removeMember($input: RemoveMemberInput!) {
  authed {
    success
  }
  removeMember(input: $input) {
    success
  }
}
    `;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
      }
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const SetAdvisorOptionsDocument = gql`
    mutation setAdvisorOptions($input: SetAdvisorOptionsInput!) {
  authed {
    success
  }
  setAdvisorOptions(input: $input) {
    organization {
      isAdvisor
      podcasts {
        ...Podcast
      }
      capabilities {
        id
        category
        title
      }
    }
  }
}
    ${PodcastFragmentDoc}`;
export type SetAdvisorOptionsMutationFn = Apollo.MutationFunction<SetAdvisorOptionsMutation, SetAdvisorOptionsMutationVariables>;

/**
 * __useSetAdvisorOptionsMutation__
 *
 * To run a mutation, you first call `useSetAdvisorOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAdvisorOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAdvisorOptionsMutation, { data, loading, error }] = useSetAdvisorOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAdvisorOptionsMutation(baseOptions?: Apollo.MutationHookOptions<SetAdvisorOptionsMutation, SetAdvisorOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAdvisorOptionsMutation, SetAdvisorOptionsMutationVariables>(SetAdvisorOptionsDocument, options);
      }
export type SetAdvisorOptionsMutationHookResult = ReturnType<typeof useSetAdvisorOptionsMutation>;
export type SetAdvisorOptionsMutationResult = Apollo.MutationResult<SetAdvisorOptionsMutation>;
export type SetAdvisorOptionsMutationOptions = Apollo.BaseMutationOptions<SetAdvisorOptionsMutation, SetAdvisorOptionsMutationVariables>;
export const UpdateActionMapDocument = gql`
    mutation updateActionMap($input: UpdateActionMapInput!) {
  authed {
    success
  }
  updateActionMap(input: $input) {
    actionMap {
      id
      eventName
      action
    }
  }
}
    `;
export type UpdateActionMapMutationFn = Apollo.MutationFunction<UpdateActionMapMutation, UpdateActionMapMutationVariables>;

/**
 * __useUpdateActionMapMutation__
 *
 * To run a mutation, you first call `useUpdateActionMapMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionMapMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionMapMutation, { data, loading, error }] = useUpdateActionMapMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActionMapMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActionMapMutation, UpdateActionMapMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActionMapMutation, UpdateActionMapMutationVariables>(UpdateActionMapDocument, options);
      }
export type UpdateActionMapMutationHookResult = ReturnType<typeof useUpdateActionMapMutation>;
export type UpdateActionMapMutationResult = Apollo.MutationResult<UpdateActionMapMutation>;
export type UpdateActionMapMutationOptions = Apollo.BaseMutationOptions<UpdateActionMapMutation, UpdateActionMapMutationVariables>;
export const UpdateAdvisorSavedSearchDocument = gql`
    mutation updateAdvisorSavedSearch($input: UpdateAdvisorSavedSearchInput!) {
  authed {
    success
  }
  updateAdvisorSavedSearch(input: $input) {
    advisorSavedSearch {
      id
    }
  }
}
    `;
export type UpdateAdvisorSavedSearchMutationFn = Apollo.MutationFunction<UpdateAdvisorSavedSearchMutation, UpdateAdvisorSavedSearchMutationVariables>;

/**
 * __useUpdateAdvisorSavedSearchMutation__
 *
 * To run a mutation, you first call `useUpdateAdvisorSavedSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdvisorSavedSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdvisorSavedSearchMutation, { data, loading, error }] = useUpdateAdvisorSavedSearchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdvisorSavedSearchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdvisorSavedSearchMutation, UpdateAdvisorSavedSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdvisorSavedSearchMutation, UpdateAdvisorSavedSearchMutationVariables>(UpdateAdvisorSavedSearchDocument, options);
      }
export type UpdateAdvisorSavedSearchMutationHookResult = ReturnType<typeof useUpdateAdvisorSavedSearchMutation>;
export type UpdateAdvisorSavedSearchMutationResult = Apollo.MutationResult<UpdateAdvisorSavedSearchMutation>;
export type UpdateAdvisorSavedSearchMutationOptions = Apollo.BaseMutationOptions<UpdateAdvisorSavedSearchMutation, UpdateAdvisorSavedSearchMutationVariables>;
export const UpdateAttributionConfigDocument = gql`
    mutation updateAttributionConfig($input: UpdateAttributionConfigInput!) {
  authed {
    success
  }
  updateAttributionConfig(input: $input) {
    attributionConfig {
      ...AttributionConfig
    }
  }
}
    ${AttributionConfigFragmentDoc}`;
export type UpdateAttributionConfigMutationFn = Apollo.MutationFunction<UpdateAttributionConfigMutation, UpdateAttributionConfigMutationVariables>;

/**
 * __useUpdateAttributionConfigMutation__
 *
 * To run a mutation, you first call `useUpdateAttributionConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAttributionConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAttributionConfigMutation, { data, loading, error }] = useUpdateAttributionConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAttributionConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAttributionConfigMutation, UpdateAttributionConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAttributionConfigMutation, UpdateAttributionConfigMutationVariables>(UpdateAttributionConfigDocument, options);
      }
export type UpdateAttributionConfigMutationHookResult = ReturnType<typeof useUpdateAttributionConfigMutation>;
export type UpdateAttributionConfigMutationResult = Apollo.MutationResult<UpdateAttributionConfigMutation>;
export type UpdateAttributionConfigMutationOptions = Apollo.BaseMutationOptions<UpdateAttributionConfigMutation, UpdateAttributionConfigMutationVariables>;
export const UpdateCampaignApprovalsDocument = gql`
    mutation updateCampaignApprovals($input: UpdateCampaignApprovalsInput!) {
  authed {
    success
  }
  updateCampaignApprovals(input: $input) {
    dynamicApprovals {
      ...DynamicApproval
    }
    podcastApprovals {
      ...PodcastApproval
    }
    streamingApprovals {
      ...StreamingApproval
    }
  }
}
    ${DynamicApprovalFragmentDoc}
${PodcastApprovalFragmentDoc}
${StreamingApprovalFragmentDoc}`;
export type UpdateCampaignApprovalsMutationFn = Apollo.MutationFunction<UpdateCampaignApprovalsMutation, UpdateCampaignApprovalsMutationVariables>;

/**
 * __useUpdateCampaignApprovalsMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignApprovalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignApprovalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignApprovalsMutation, { data, loading, error }] = useUpdateCampaignApprovalsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignApprovalsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignApprovalsMutation, UpdateCampaignApprovalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignApprovalsMutation, UpdateCampaignApprovalsMutationVariables>(UpdateCampaignApprovalsDocument, options);
      }
export type UpdateCampaignApprovalsMutationHookResult = ReturnType<typeof useUpdateCampaignApprovalsMutation>;
export type UpdateCampaignApprovalsMutationResult = Apollo.MutationResult<UpdateCampaignApprovalsMutation>;
export type UpdateCampaignApprovalsMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignApprovalsMutation, UpdateCampaignApprovalsMutationVariables>;
export const UpdateCampaignBrandAgenciesDocument = gql`
    mutation updateCampaignBrandAgencies($input: UpdateCampaignBrandAgenciesInput!) {
  authed {
    success
  }
  updateCampaignBrandAgencies(input: $input) {
    success
    campaigns {
      id
      name
      organization {
        id
        name
      }
      buySideAgencies {
        organizationId
        organizationName
      }
    }
  }
}
    `;
export type UpdateCampaignBrandAgenciesMutationFn = Apollo.MutationFunction<UpdateCampaignBrandAgenciesMutation, UpdateCampaignBrandAgenciesMutationVariables>;

/**
 * __useUpdateCampaignBrandAgenciesMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignBrandAgenciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignBrandAgenciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignBrandAgenciesMutation, { data, loading, error }] = useUpdateCampaignBrandAgenciesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignBrandAgenciesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignBrandAgenciesMutation, UpdateCampaignBrandAgenciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignBrandAgenciesMutation, UpdateCampaignBrandAgenciesMutationVariables>(UpdateCampaignBrandAgenciesDocument, options);
      }
export type UpdateCampaignBrandAgenciesMutationHookResult = ReturnType<typeof useUpdateCampaignBrandAgenciesMutation>;
export type UpdateCampaignBrandAgenciesMutationResult = Apollo.MutationResult<UpdateCampaignBrandAgenciesMutation>;
export type UpdateCampaignBrandAgenciesMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignBrandAgenciesMutation, UpdateCampaignBrandAgenciesMutationVariables>;
export const UpdateCampaignDatesDocument = gql`
    mutation updateCampaignDates($input: UpdateCampaignDatesInput!) {
  authed {
    success
  }
  updateCampaignDates(input: $input) {
    campaign {
      id
      startAt
      endAt
    }
  }
}
    `;
export type UpdateCampaignDatesMutationFn = Apollo.MutationFunction<UpdateCampaignDatesMutation, UpdateCampaignDatesMutationVariables>;

/**
 * __useUpdateCampaignDatesMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignDatesMutation, { data, loading, error }] = useUpdateCampaignDatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignDatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignDatesMutation, UpdateCampaignDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignDatesMutation, UpdateCampaignDatesMutationVariables>(UpdateCampaignDatesDocument, options);
      }
export type UpdateCampaignDatesMutationHookResult = ReturnType<typeof useUpdateCampaignDatesMutation>;
export type UpdateCampaignDatesMutationResult = Apollo.MutationResult<UpdateCampaignDatesMutation>;
export type UpdateCampaignDatesMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignDatesMutation, UpdateCampaignDatesMutationVariables>;
export const UpdateCampaignEpisodeDocument = gql`
    mutation updateCampaignEpisode($input: UpdateCampaignEpisodeInput!) {
  authed {
    success
  }
  updateCampaignEpisode(input: $input) {
    campaignEpisode {
      ...CampaignEpisode
    }
  }
}
    ${CampaignEpisodeFragmentDoc}`;
export type UpdateCampaignEpisodeMutationFn = Apollo.MutationFunction<UpdateCampaignEpisodeMutation, UpdateCampaignEpisodeMutationVariables>;

/**
 * __useUpdateCampaignEpisodeMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignEpisodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignEpisodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignEpisodeMutation, { data, loading, error }] = useUpdateCampaignEpisodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignEpisodeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignEpisodeMutation, UpdateCampaignEpisodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignEpisodeMutation, UpdateCampaignEpisodeMutationVariables>(UpdateCampaignEpisodeDocument, options);
      }
export type UpdateCampaignEpisodeMutationHookResult = ReturnType<typeof useUpdateCampaignEpisodeMutation>;
export type UpdateCampaignEpisodeMutationResult = Apollo.MutationResult<UpdateCampaignEpisodeMutation>;
export type UpdateCampaignEpisodeMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignEpisodeMutation, UpdateCampaignEpisodeMutationVariables>;
export const UpdateCampaignNoiseDocument = gql`
    mutation updateCampaignNoise($input: UpdateCampaignNoiseInput!) {
  authed {
    success
  }
  updateCampaignNoise(input: $input) {
    campaignNoise {
      ...CampaignNoise
    }
  }
}
    ${CampaignNoiseFragmentDoc}`;
export type UpdateCampaignNoiseMutationFn = Apollo.MutationFunction<UpdateCampaignNoiseMutation, UpdateCampaignNoiseMutationVariables>;

/**
 * __useUpdateCampaignNoiseMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignNoiseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignNoiseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignNoiseMutation, { data, loading, error }] = useUpdateCampaignNoiseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignNoiseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignNoiseMutation, UpdateCampaignNoiseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignNoiseMutation, UpdateCampaignNoiseMutationVariables>(UpdateCampaignNoiseDocument, options);
      }
export type UpdateCampaignNoiseMutationHookResult = ReturnType<typeof useUpdateCampaignNoiseMutation>;
export type UpdateCampaignNoiseMutationResult = Apollo.MutationResult<UpdateCampaignNoiseMutation>;
export type UpdateCampaignNoiseMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignNoiseMutation, UpdateCampaignNoiseMutationVariables>;
export const UpdateCampaignPodcastDocument = gql`
    mutation updateCampaignPodcast($input: UpdateCampaignPodcastInput!) {
  authed {
    success
  }
  updateCampaignPodcast(input: $input) {
    campaignPodcast {
      ...CampaignPodcast
    }
  }
}
    ${CampaignPodcastFragmentDoc}`;
export type UpdateCampaignPodcastMutationFn = Apollo.MutationFunction<UpdateCampaignPodcastMutation, UpdateCampaignPodcastMutationVariables>;

/**
 * __useUpdateCampaignPodcastMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignPodcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignPodcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignPodcastMutation, { data, loading, error }] = useUpdateCampaignPodcastMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignPodcastMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignPodcastMutation, UpdateCampaignPodcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignPodcastMutation, UpdateCampaignPodcastMutationVariables>(UpdateCampaignPodcastDocument, options);
      }
export type UpdateCampaignPodcastMutationHookResult = ReturnType<typeof useUpdateCampaignPodcastMutation>;
export type UpdateCampaignPodcastMutationResult = Apollo.MutationResult<UpdateCampaignPodcastMutation>;
export type UpdateCampaignPodcastMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignPodcastMutation, UpdateCampaignPodcastMutationVariables>;
export const UpdateCampaignStateDocument = gql`
    mutation updateCampaignState($input: UpdateCampaignStateInput!) {
  authed {
    success
  }
  updateCampaignState(input: $input) {
    campaign {
      id
      name
      slug
      state
      createdAt
    }
  }
}
    `;
export type UpdateCampaignStateMutationFn = Apollo.MutationFunction<UpdateCampaignStateMutation, UpdateCampaignStateMutationVariables>;

/**
 * __useUpdateCampaignStateMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignStateMutation, { data, loading, error }] = useUpdateCampaignStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignStateMutation, UpdateCampaignStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignStateMutation, UpdateCampaignStateMutationVariables>(UpdateCampaignStateDocument, options);
      }
export type UpdateCampaignStateMutationHookResult = ReturnType<typeof useUpdateCampaignStateMutation>;
export type UpdateCampaignStateMutationResult = Apollo.MutationResult<UpdateCampaignStateMutation>;
export type UpdateCampaignStateMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignStateMutation, UpdateCampaignStateMutationVariables>;
export const UpdateConversionUrlDocument = gql`
    mutation updateConversionUrl($input: UpdateConversionURLInput!) {
  authed {
    success
  }
  updateConversionUrl(input: $input) {
    conversionUrl {
      id
      url
      value
      action
      type
      category
    }
  }
}
    `;
export type UpdateConversionUrlMutationFn = Apollo.MutationFunction<UpdateConversionUrlMutation, UpdateConversionUrlMutationVariables>;

/**
 * __useUpdateConversionUrlMutation__
 *
 * To run a mutation, you first call `useUpdateConversionUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversionUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversionUrlMutation, { data, loading, error }] = useUpdateConversionUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConversionUrlMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversionUrlMutation, UpdateConversionUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConversionUrlMutation, UpdateConversionUrlMutationVariables>(UpdateConversionUrlDocument, options);
      }
export type UpdateConversionUrlMutationHookResult = ReturnType<typeof useUpdateConversionUrlMutation>;
export type UpdateConversionUrlMutationResult = Apollo.MutationResult<UpdateConversionUrlMutation>;
export type UpdateConversionUrlMutationOptions = Apollo.BaseMutationOptions<UpdateConversionUrlMutation, UpdateConversionUrlMutationVariables>;
export const UpdateFeedsDocument = gql`
    mutation updateFeeds($input: UpdateFeedsInput!) {
  authed {
    success
  }
  updateFeeds(input: $input) {
    feeds {
      id
      title
      description(words: 25)
      href
      state
      publisherName
      publisherEmail
      image {
        id
        href
        path
      }
    }
  }
}
    `;
export type UpdateFeedsMutationFn = Apollo.MutationFunction<UpdateFeedsMutation, UpdateFeedsMutationVariables>;

/**
 * __useUpdateFeedsMutation__
 *
 * To run a mutation, you first call `useUpdateFeedsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeedsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeedsMutation, { data, loading, error }] = useUpdateFeedsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeedsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeedsMutation, UpdateFeedsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeedsMutation, UpdateFeedsMutationVariables>(UpdateFeedsDocument, options);
      }
export type UpdateFeedsMutationHookResult = ReturnType<typeof useUpdateFeedsMutation>;
export type UpdateFeedsMutationResult = Apollo.MutationResult<UpdateFeedsMutation>;
export type UpdateFeedsMutationOptions = Apollo.BaseMutationOptions<UpdateFeedsMutation, UpdateFeedsMutationVariables>;
export const UpdateGenericTagDocument = gql`
    mutation updateGenericTag($input: UpdateGenericTagInput!) {
  authed {
    success
  }
  updateGenericTag(input: $input) {
    genericTag {
      id
      title
      color
    }
  }
}
    `;
export type UpdateGenericTagMutationFn = Apollo.MutationFunction<UpdateGenericTagMutation, UpdateGenericTagMutationVariables>;

/**
 * __useUpdateGenericTagMutation__
 *
 * To run a mutation, you first call `useUpdateGenericTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGenericTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGenericTagMutation, { data, loading, error }] = useUpdateGenericTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGenericTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGenericTagMutation, UpdateGenericTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGenericTagMutation, UpdateGenericTagMutationVariables>(UpdateGenericTagDocument, options);
      }
export type UpdateGenericTagMutationHookResult = ReturnType<typeof useUpdateGenericTagMutation>;
export type UpdateGenericTagMutationResult = Apollo.MutationResult<UpdateGenericTagMutation>;
export type UpdateGenericTagMutationOptions = Apollo.BaseMutationOptions<UpdateGenericTagMutation, UpdateGenericTagMutationVariables>;
export const UpdateMemberDocument = gql`
    mutation updateMember($input: UpdateMemberInput!) {
  authed {
    success
  }
  updateMember(input: $input) {
    membership {
      id
      role
      roleDisplay
      createdAt
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
}
    `;
export type UpdateMemberMutationFn = Apollo.MutationFunction<UpdateMemberMutation, UpdateMemberMutationVariables>;

/**
 * __useUpdateMemberMutation__
 *
 * To run a mutation, you first call `useUpdateMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberMutation, { data, loading, error }] = useUpdateMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberMutation, UpdateMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberMutation, UpdateMemberMutationVariables>(UpdateMemberDocument, options);
      }
export type UpdateMemberMutationHookResult = ReturnType<typeof useUpdateMemberMutation>;
export type UpdateMemberMutationResult = Apollo.MutationResult<UpdateMemberMutation>;
export type UpdateMemberMutationOptions = Apollo.BaseMutationOptions<UpdateMemberMutation, UpdateMemberMutationVariables>;
export const UpdatePixelDocument = gql`
    mutation updatePixel($input: UpdateKeyInput!) {
  authed {
    success
  }
  updatePixel(input: $input) {
    key {
      key
      domain
      alias
    }
  }
}
    `;
export type UpdatePixelMutationFn = Apollo.MutationFunction<UpdatePixelMutation, UpdatePixelMutationVariables>;

/**
 * __useUpdatePixelMutation__
 *
 * To run a mutation, you first call `useUpdatePixelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePixelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePixelMutation, { data, loading, error }] = useUpdatePixelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePixelMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePixelMutation, UpdatePixelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePixelMutation, UpdatePixelMutationVariables>(UpdatePixelDocument, options);
      }
export type UpdatePixelMutationHookResult = ReturnType<typeof useUpdatePixelMutation>;
export type UpdatePixelMutationResult = Apollo.MutationResult<UpdatePixelMutation>;
export type UpdatePixelMutationOptions = Apollo.BaseMutationOptions<UpdatePixelMutation, UpdatePixelMutationVariables>;
export const UpdatePixelEventRecordDocument = gql`
    mutation updatePixelEventRecord($input: UpdatePixelEventRecordInput!) {
  authed {
    success
  }
  updatePixelEventRecord(input: $input) {
    pixelEventRecord {
      id
      name
      eventType
      installation
      lastUpdatedBy {
        id
        firstName
        lastName
      }
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdatePixelEventRecordMutationFn = Apollo.MutationFunction<UpdatePixelEventRecordMutation, UpdatePixelEventRecordMutationVariables>;

/**
 * __useUpdatePixelEventRecordMutation__
 *
 * To run a mutation, you first call `useUpdatePixelEventRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePixelEventRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePixelEventRecordMutation, { data, loading, error }] = useUpdatePixelEventRecordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePixelEventRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePixelEventRecordMutation, UpdatePixelEventRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePixelEventRecordMutation, UpdatePixelEventRecordMutationVariables>(UpdatePixelEventRecordDocument, options);
      }
export type UpdatePixelEventRecordMutationHookResult = ReturnType<typeof useUpdatePixelEventRecordMutation>;
export type UpdatePixelEventRecordMutationResult = Apollo.MutationResult<UpdatePixelEventRecordMutation>;
export type UpdatePixelEventRecordMutationOptions = Apollo.BaseMutationOptions<UpdatePixelEventRecordMutation, UpdatePixelEventRecordMutationVariables>;
export const UpdatePodlinkDomainDocument = gql`
    mutation updatePodlinkDomain($input: UpdatePodlinkDomainInput!) {
  authed {
    success
  }
  updatePodlinkDomain(input: $input) {
    podlinkDomain {
      ...PodlinkDomain
    }
  }
}
    ${PodlinkDomainFragmentDoc}`;
export type UpdatePodlinkDomainMutationFn = Apollo.MutationFunction<UpdatePodlinkDomainMutation, UpdatePodlinkDomainMutationVariables>;

/**
 * __useUpdatePodlinkDomainMutation__
 *
 * To run a mutation, you first call `useUpdatePodlinkDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePodlinkDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePodlinkDomainMutation, { data, loading, error }] = useUpdatePodlinkDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePodlinkDomainMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePodlinkDomainMutation, UpdatePodlinkDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePodlinkDomainMutation, UpdatePodlinkDomainMutationVariables>(UpdatePodlinkDomainDocument, options);
      }
export type UpdatePodlinkDomainMutationHookResult = ReturnType<typeof useUpdatePodlinkDomainMutation>;
export type UpdatePodlinkDomainMutationResult = Apollo.MutationResult<UpdatePodlinkDomainMutation>;
export type UpdatePodlinkDomainMutationOptions = Apollo.BaseMutationOptions<UpdatePodlinkDomainMutation, UpdatePodlinkDomainMutationVariables>;
export const UpdatePodlinkPodcastDocument = gql`
    mutation updatePodlinkPodcast($input: UpdatePodlinkPodcastInput!) {
  authed {
    success
  }
  updatePodlinkPodcast(input: $input) {
    success
  }
}
    `;
export type UpdatePodlinkPodcastMutationFn = Apollo.MutationFunction<UpdatePodlinkPodcastMutation, UpdatePodlinkPodcastMutationVariables>;

/**
 * __useUpdatePodlinkPodcastMutation__
 *
 * To run a mutation, you first call `useUpdatePodlinkPodcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePodlinkPodcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePodlinkPodcastMutation, { data, loading, error }] = useUpdatePodlinkPodcastMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePodlinkPodcastMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePodlinkPodcastMutation, UpdatePodlinkPodcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePodlinkPodcastMutation, UpdatePodlinkPodcastMutationVariables>(UpdatePodlinkPodcastDocument, options);
      }
export type UpdatePodlinkPodcastMutationHookResult = ReturnType<typeof useUpdatePodlinkPodcastMutation>;
export type UpdatePodlinkPodcastMutationResult = Apollo.MutationResult<UpdatePodlinkPodcastMutation>;
export type UpdatePodlinkPodcastMutationOptions = Apollo.BaseMutationOptions<UpdatePodlinkPodcastMutation, UpdatePodlinkPodcastMutationVariables>;
export const AdvisorOptionsCapabilitiesQueryDocument = gql`
    query advisorOptionsCapabilitiesQuery($id: ID!) {
  me {
    id
    organization(id: $id) {
      id
      advisor {
        id
        options {
          id
          capabilities {
            id
            category
            title
          }
        }
      }
      capabilities {
        id
        category
        title
      }
    }
  }
}
    `;

/**
 * __useAdvisorOptionsCapabilitiesQueryQuery__
 *
 * To run a query within a React component, call `useAdvisorOptionsCapabilitiesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvisorOptionsCapabilitiesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvisorOptionsCapabilitiesQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdvisorOptionsCapabilitiesQueryQuery(baseOptions: Apollo.QueryHookOptions<AdvisorOptionsCapabilitiesQueryQuery, AdvisorOptionsCapabilitiesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvisorOptionsCapabilitiesQueryQuery, AdvisorOptionsCapabilitiesQueryQueryVariables>(AdvisorOptionsCapabilitiesQueryDocument, options);
      }
export function useAdvisorOptionsCapabilitiesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvisorOptionsCapabilitiesQueryQuery, AdvisorOptionsCapabilitiesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvisorOptionsCapabilitiesQueryQuery, AdvisorOptionsCapabilitiesQueryQueryVariables>(AdvisorOptionsCapabilitiesQueryDocument, options);
        }
export type AdvisorOptionsCapabilitiesQueryQueryHookResult = ReturnType<typeof useAdvisorOptionsCapabilitiesQueryQuery>;
export type AdvisorOptionsCapabilitiesQueryLazyQueryHookResult = ReturnType<typeof useAdvisorOptionsCapabilitiesQueryLazyQuery>;
export type AdvisorOptionsCapabilitiesQueryQueryResult = Apollo.QueryResult<AdvisorOptionsCapabilitiesQueryQuery, AdvisorOptionsCapabilitiesQueryQueryVariables>;
export const GetAssetsDocument = gql`
    query getAssets($id: ID!) {
  me {
    id
    organization(id: $id) {
      id
      assets {
        ...Asset
      }
    }
  }
}
    ${AssetFragmentDoc}`;

/**
 * __useGetAssetsQuery__
 *
 * To run a query within a React component, call `useGetAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssetsQuery(baseOptions: Apollo.QueryHookOptions<GetAssetsQuery, GetAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetsQuery, GetAssetsQueryVariables>(GetAssetsDocument, options);
      }
export function useGetAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetsQuery, GetAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetsQuery, GetAssetsQueryVariables>(GetAssetsDocument, options);
        }
export type GetAssetsQueryHookResult = ReturnType<typeof useGetAssetsQuery>;
export type GetAssetsLazyQueryHookResult = ReturnType<typeof useGetAssetsLazyQuery>;
export type GetAssetsQueryResult = Apollo.QueryResult<GetAssetsQuery, GetAssetsQueryVariables>;
export const GetAttributionConfigDocument = gql`
    query getAttributionConfig($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      attributionConfig {
        ...AttributionConfig
      }
    }
  }
}
    ${AttributionConfigFragmentDoc}`;

/**
 * __useGetAttributionConfigQuery__
 *
 * To run a query within a React component, call `useGetAttributionConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAttributionConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAttributionConfigQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetAttributionConfigQuery(baseOptions: Apollo.QueryHookOptions<GetAttributionConfigQuery, GetAttributionConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAttributionConfigQuery, GetAttributionConfigQueryVariables>(GetAttributionConfigDocument, options);
      }
export function useGetAttributionConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAttributionConfigQuery, GetAttributionConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAttributionConfigQuery, GetAttributionConfigQueryVariables>(GetAttributionConfigDocument, options);
        }
export type GetAttributionConfigQueryHookResult = ReturnType<typeof useGetAttributionConfigQuery>;
export type GetAttributionConfigLazyQueryHookResult = ReturnType<typeof useGetAttributionConfigLazyQuery>;
export type GetAttributionConfigQueryResult = Apollo.QueryResult<GetAttributionConfigQuery, GetAttributionConfigQueryVariables>;
export const GetBrandCampaignAgenciesDocument = gql`
    query getBrandCampaignAgencies($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      managers {
        id
        name
        slug
        kind
      }
      reversePermissions {
        id
        name
        objectName
        permission
        contentObjectName
        organization {
          id
          name
        }
      }
      campaigns {
        results {
          id
          name
          isHiddenFromAgency
          organization {
            id
            name
          }
          buySideAgencies {
            organizationId
            organizationName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandCampaignAgenciesQuery__
 *
 * To run a query within a React component, call `useGetBrandCampaignAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCampaignAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCampaignAgenciesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetBrandCampaignAgenciesQuery(baseOptions: Apollo.QueryHookOptions<GetBrandCampaignAgenciesQuery, GetBrandCampaignAgenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandCampaignAgenciesQuery, GetBrandCampaignAgenciesQueryVariables>(GetBrandCampaignAgenciesDocument, options);
      }
export function useGetBrandCampaignAgenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandCampaignAgenciesQuery, GetBrandCampaignAgenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandCampaignAgenciesQuery, GetBrandCampaignAgenciesQueryVariables>(GetBrandCampaignAgenciesDocument, options);
        }
export type GetBrandCampaignAgenciesQueryHookResult = ReturnType<typeof useGetBrandCampaignAgenciesQuery>;
export type GetBrandCampaignAgenciesLazyQueryHookResult = ReturnType<typeof useGetBrandCampaignAgenciesLazyQuery>;
export type GetBrandCampaignAgenciesQueryResult = Apollo.QueryResult<GetBrandCampaignAgenciesQuery, GetBrandCampaignAgenciesQueryVariables>;
export const GetBrandCampaignAttributionReferrerDomainsDocument = gql`
    query getBrandCampaignAttributionReferrerDomains($organizationId: ID!, $id: ID!, $offset: Int, $limit: Int) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        attribution {
          users {
            referrerDomains {
              count
              sum
              nodes(offset: $offset, limit: $limit) {
                referrerDomain
                count
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandCampaignAttributionReferrerDomainsQuery__
 *
 * To run a query within a React component, call `useGetBrandCampaignAttributionReferrerDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCampaignAttributionReferrerDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCampaignAttributionReferrerDomainsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBrandCampaignAttributionReferrerDomainsQuery(baseOptions: Apollo.QueryHookOptions<GetBrandCampaignAttributionReferrerDomainsQuery, GetBrandCampaignAttributionReferrerDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandCampaignAttributionReferrerDomainsQuery, GetBrandCampaignAttributionReferrerDomainsQueryVariables>(GetBrandCampaignAttributionReferrerDomainsDocument, options);
      }
export function useGetBrandCampaignAttributionReferrerDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandCampaignAttributionReferrerDomainsQuery, GetBrandCampaignAttributionReferrerDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandCampaignAttributionReferrerDomainsQuery, GetBrandCampaignAttributionReferrerDomainsQueryVariables>(GetBrandCampaignAttributionReferrerDomainsDocument, options);
        }
export type GetBrandCampaignAttributionReferrerDomainsQueryHookResult = ReturnType<typeof useGetBrandCampaignAttributionReferrerDomainsQuery>;
export type GetBrandCampaignAttributionReferrerDomainsLazyQueryHookResult = ReturnType<typeof useGetBrandCampaignAttributionReferrerDomainsLazyQuery>;
export type GetBrandCampaignAttributionReferrerDomainsQueryResult = Apollo.QueryResult<GetBrandCampaignAttributionReferrerDomainsQuery, GetBrandCampaignAttributionReferrerDomainsQueryVariables>;
export const GetBrandCampaignAttributionUrlsDocument = gql`
    query getBrandCampaignAttributionUrls($organizationId: ID!, $id: ID!, $offset: Int, $limit: Int) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        attribution {
          users {
            urls {
              count
              sum
              nodes(offset: $offset, limit: $limit) {
                url
                urlPath
                count
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandCampaignAttributionUrlsQuery__
 *
 * To run a query within a React component, call `useGetBrandCampaignAttributionUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCampaignAttributionUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCampaignAttributionUrlsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBrandCampaignAttributionUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetBrandCampaignAttributionUrlsQuery, GetBrandCampaignAttributionUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandCampaignAttributionUrlsQuery, GetBrandCampaignAttributionUrlsQueryVariables>(GetBrandCampaignAttributionUrlsDocument, options);
      }
export function useGetBrandCampaignAttributionUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandCampaignAttributionUrlsQuery, GetBrandCampaignAttributionUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandCampaignAttributionUrlsQuery, GetBrandCampaignAttributionUrlsQueryVariables>(GetBrandCampaignAttributionUrlsDocument, options);
        }
export type GetBrandCampaignAttributionUrlsQueryHookResult = ReturnType<typeof useGetBrandCampaignAttributionUrlsQuery>;
export type GetBrandCampaignAttributionUrlsLazyQueryHookResult = ReturnType<typeof useGetBrandCampaignAttributionUrlsLazyQuery>;
export type GetBrandCampaignAttributionUrlsQueryResult = Apollo.QueryResult<GetBrandCampaignAttributionUrlsQuery, GetBrandCampaignAttributionUrlsQueryVariables>;
export const GetCampaignDynamicEpisodeOmniChartDocument = gql`
    query getCampaignDynamicEpisodeOmniChart($organizationId: ID!, $campaignId: ID!, $campaignDynamicId: ID!, $campaignDynamicPodcastId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignDynamic(id: $campaignDynamicId) {
          id
          campaignDynamicPodcast(id: $campaignDynamicPodcastId) {
            id
            campaignDynamicEpisode(id: $id) {
              id
              attribution {
                users {
                  hourlyVisitors {
                    count
                    hour
                  }
                }
              }
              downloads {
                hourly {
                  hour
                  downloadClass
                  count
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignDynamicEpisodeOmniChartQuery__
 *
 * To run a query within a React component, call `useGetCampaignDynamicEpisodeOmniChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignDynamicEpisodeOmniChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignDynamicEpisodeOmniChartQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      campaignDynamicId: // value for 'campaignDynamicId'
 *      campaignDynamicPodcastId: // value for 'campaignDynamicPodcastId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignDynamicEpisodeOmniChartQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignDynamicEpisodeOmniChartQuery, GetCampaignDynamicEpisodeOmniChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignDynamicEpisodeOmniChartQuery, GetCampaignDynamicEpisodeOmniChartQueryVariables>(GetCampaignDynamicEpisodeOmniChartDocument, options);
      }
export function useGetCampaignDynamicEpisodeOmniChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignDynamicEpisodeOmniChartQuery, GetCampaignDynamicEpisodeOmniChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignDynamicEpisodeOmniChartQuery, GetCampaignDynamicEpisodeOmniChartQueryVariables>(GetCampaignDynamicEpisodeOmniChartDocument, options);
        }
export type GetCampaignDynamicEpisodeOmniChartQueryHookResult = ReturnType<typeof useGetCampaignDynamicEpisodeOmniChartQuery>;
export type GetCampaignDynamicEpisodeOmniChartLazyQueryHookResult = ReturnType<typeof useGetCampaignDynamicEpisodeOmniChartLazyQuery>;
export type GetCampaignDynamicEpisodeOmniChartQueryResult = Apollo.QueryResult<GetCampaignDynamicEpisodeOmniChartQuery, GetCampaignDynamicEpisodeOmniChartQueryVariables>;
export const GetBrandCampaignDynamicOmniChartDocument = gql`
    query getBrandCampaignDynamicOmniChart($organizationId: ID!, $campaignId: ID!, $id: ID!, $after: String, $before: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignDynamic(id: $id) {
          id
          attribution(after: $after, before: $before) {
            users {
              hourlyVisitors {
                count
                hour
              }
            }
          }
          downloads(after: $after, before: $before) {
            hourly {
              hour
              downloadClass
              count
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandCampaignDynamicOmniChartQuery__
 *
 * To run a query within a React component, call `useGetBrandCampaignDynamicOmniChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCampaignDynamicOmniChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCampaignDynamicOmniChartQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetBrandCampaignDynamicOmniChartQuery(baseOptions: Apollo.QueryHookOptions<GetBrandCampaignDynamicOmniChartQuery, GetBrandCampaignDynamicOmniChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandCampaignDynamicOmniChartQuery, GetBrandCampaignDynamicOmniChartQueryVariables>(GetBrandCampaignDynamicOmniChartDocument, options);
      }
export function useGetBrandCampaignDynamicOmniChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandCampaignDynamicOmniChartQuery, GetBrandCampaignDynamicOmniChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandCampaignDynamicOmniChartQuery, GetBrandCampaignDynamicOmniChartQueryVariables>(GetBrandCampaignDynamicOmniChartDocument, options);
        }
export type GetBrandCampaignDynamicOmniChartQueryHookResult = ReturnType<typeof useGetBrandCampaignDynamicOmniChartQuery>;
export type GetBrandCampaignDynamicOmniChartLazyQueryHookResult = ReturnType<typeof useGetBrandCampaignDynamicOmniChartLazyQuery>;
export type GetBrandCampaignDynamicOmniChartQueryResult = Apollo.QueryResult<GetBrandCampaignDynamicOmniChartQuery, GetBrandCampaignDynamicOmniChartQueryVariables>;
export const GetCampaignDynamicPodcastOmniChartDocument = gql`
    query getCampaignDynamicPodcastOmniChart($organizationId: ID!, $campaignId: ID!, $campaignDynamicId: ID!, $id: ID!, $after: String, $before: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignDynamic(id: $campaignDynamicId) {
          id
          campaignDynamicPodcast(id: $id) {
            id
            attribution(after: $after, before: $before) {
              users {
                hourlyVisitors {
                  count
                  hour
                }
              }
            }
            downloads(after: $after, before: $before) {
              hourly {
                hour
                downloadClass
                count
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignDynamicPodcastOmniChartQuery__
 *
 * To run a query within a React component, call `useGetCampaignDynamicPodcastOmniChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignDynamicPodcastOmniChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignDynamicPodcastOmniChartQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      campaignDynamicId: // value for 'campaignDynamicId'
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetCampaignDynamicPodcastOmniChartQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignDynamicPodcastOmniChartQuery, GetCampaignDynamicPodcastOmniChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignDynamicPodcastOmniChartQuery, GetCampaignDynamicPodcastOmniChartQueryVariables>(GetCampaignDynamicPodcastOmniChartDocument, options);
      }
export function useGetCampaignDynamicPodcastOmniChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignDynamicPodcastOmniChartQuery, GetCampaignDynamicPodcastOmniChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignDynamicPodcastOmniChartQuery, GetCampaignDynamicPodcastOmniChartQueryVariables>(GetCampaignDynamicPodcastOmniChartDocument, options);
        }
export type GetCampaignDynamicPodcastOmniChartQueryHookResult = ReturnType<typeof useGetCampaignDynamicPodcastOmniChartQuery>;
export type GetCampaignDynamicPodcastOmniChartLazyQueryHookResult = ReturnType<typeof useGetCampaignDynamicPodcastOmniChartLazyQuery>;
export type GetCampaignDynamicPodcastOmniChartQueryResult = Apollo.QueryResult<GetCampaignDynamicPodcastOmniChartQuery, GetCampaignDynamicPodcastOmniChartQueryVariables>;
export const GetBrandCampaignEpisodeOmniChartDocument = gql`
    query getBrandCampaignEpisodeOmniChart($organizationId: ID!, $campaignId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignEpisode(id: $id) {
          id
          episode {
            id
            title
            image {
              id
              path
            }
            published
          }
          attribution {
            users {
              hourlyVisitors {
                count
                hour
              }
            }
          }
          downloads {
            hourly {
              hour
              downloadClass
              count
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandCampaignEpisodeOmniChartQuery__
 *
 * To run a query within a React component, call `useGetBrandCampaignEpisodeOmniChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCampaignEpisodeOmniChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCampaignEpisodeOmniChartQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandCampaignEpisodeOmniChartQuery(baseOptions: Apollo.QueryHookOptions<GetBrandCampaignEpisodeOmniChartQuery, GetBrandCampaignEpisodeOmniChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandCampaignEpisodeOmniChartQuery, GetBrandCampaignEpisodeOmniChartQueryVariables>(GetBrandCampaignEpisodeOmniChartDocument, options);
      }
export function useGetBrandCampaignEpisodeOmniChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandCampaignEpisodeOmniChartQuery, GetBrandCampaignEpisodeOmniChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandCampaignEpisodeOmniChartQuery, GetBrandCampaignEpisodeOmniChartQueryVariables>(GetBrandCampaignEpisodeOmniChartDocument, options);
        }
export type GetBrandCampaignEpisodeOmniChartQueryHookResult = ReturnType<typeof useGetBrandCampaignEpisodeOmniChartQuery>;
export type GetBrandCampaignEpisodeOmniChartLazyQueryHookResult = ReturnType<typeof useGetBrandCampaignEpisodeOmniChartLazyQuery>;
export type GetBrandCampaignEpisodeOmniChartQueryResult = Apollo.QueryResult<GetBrandCampaignEpisodeOmniChartQuery, GetBrandCampaignEpisodeOmniChartQueryVariables>;
export const GetBrandCampaignHouseholdDocument = gql`
    query getBrandCampaignHousehold($organizationId: ID!, $campaignId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        attribution {
          households {
            household(id: $id) {
              events {
                count
                nodes {
                  latitude
                  longitude
                  country
                  region
                  city
                  time
                  action
                  referrer
                  referrerDomain
                  url
                  urlPath
                  userAgent {
                    os {
                      family
                    }
                    device {
                      family
                    }
                  }
                  value
                  currency
                  product
                  discountCode
                  orderId
                  quantity
                  lineItems
                  leadType
                  leadCategory
                  alias
                }
              }
              downloads {
                count
                nodes {
                  campaignId
                  campaignDynamicId
                  source
                  kind
                  time
                  attribution
                  userAgent {
                    os {
                      family
                    }
                    device {
                      family
                    }
                  }
                  country
                  region
                  city
                  longitude
                  latitude
                  feed {
                    title
                  }
                  episode {
                    title
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandCampaignHouseholdQuery__
 *
 * To run a query within a React component, call `useGetBrandCampaignHouseholdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCampaignHouseholdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCampaignHouseholdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandCampaignHouseholdQuery(baseOptions: Apollo.QueryHookOptions<GetBrandCampaignHouseholdQuery, GetBrandCampaignHouseholdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandCampaignHouseholdQuery, GetBrandCampaignHouseholdQueryVariables>(GetBrandCampaignHouseholdDocument, options);
      }
export function useGetBrandCampaignHouseholdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandCampaignHouseholdQuery, GetBrandCampaignHouseholdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandCampaignHouseholdQuery, GetBrandCampaignHouseholdQueryVariables>(GetBrandCampaignHouseholdDocument, options);
        }
export type GetBrandCampaignHouseholdQueryHookResult = ReturnType<typeof useGetBrandCampaignHouseholdQuery>;
export type GetBrandCampaignHouseholdLazyQueryHookResult = ReturnType<typeof useGetBrandCampaignHouseholdLazyQuery>;
export type GetBrandCampaignHouseholdQueryResult = Apollo.QueryResult<GetBrandCampaignHouseholdQuery, GetBrandCampaignHouseholdQueryVariables>;
export const GetBrandCampaignOmniChartDocument = gql`
    query getBrandCampaignOmniChart($organizationId: ID!, $id: ID!, $after: String, $before: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        attribution(after: $after, before: $before) {
          users {
            hourlyVisitors {
              count
              hour
            }
          }
        }
        downloads(after: $after, before: $before) {
          hourly {
            hour
            downloadClass
            count
          }
        }
        campaignPodcasts {
          id
          feed {
            id
            title
            image {
              href
              id
              path
            }
          }
          episodes(after: $after, before: $before) {
            id
            title
            published
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandCampaignOmniChartQuery__
 *
 * To run a query within a React component, call `useGetBrandCampaignOmniChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCampaignOmniChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCampaignOmniChartQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetBrandCampaignOmniChartQuery(baseOptions: Apollo.QueryHookOptions<GetBrandCampaignOmniChartQuery, GetBrandCampaignOmniChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandCampaignOmniChartQuery, GetBrandCampaignOmniChartQueryVariables>(GetBrandCampaignOmniChartDocument, options);
      }
export function useGetBrandCampaignOmniChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandCampaignOmniChartQuery, GetBrandCampaignOmniChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandCampaignOmniChartQuery, GetBrandCampaignOmniChartQueryVariables>(GetBrandCampaignOmniChartDocument, options);
        }
export type GetBrandCampaignOmniChartQueryHookResult = ReturnType<typeof useGetBrandCampaignOmniChartQuery>;
export type GetBrandCampaignOmniChartLazyQueryHookResult = ReturnType<typeof useGetBrandCampaignOmniChartLazyQuery>;
export type GetBrandCampaignOmniChartQueryResult = Apollo.QueryResult<GetBrandCampaignOmniChartQuery, GetBrandCampaignOmniChartQueryVariables>;
export const GetBrandCampaignOverlapDocument = gql`
    query getBrandCampaignOverlap($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        overlap {
          pairs {
            baseCampaignDynamicId
            baseCampaignDynamic {
              id
              name
            }
            baseCampaignStreaming {
              id
              name
            }
            baseFeedId
            baseFeed {
              id
              title
              image {
                id
                width
                height
                path
              }
            }
            compCampaignDynamicId
            compCampaignDynamic {
              id
              name
            }
            compCampaignStreaming {
              id
              name
            }
            compFeedId
            compFeed {
              id
              title
              image {
                id
                width
                height
                path
              }
            }
            baseReach
            compReach
            overlap
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandCampaignOverlapQuery__
 *
 * To run a query within a React component, call `useGetBrandCampaignOverlapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCampaignOverlapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCampaignOverlapQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandCampaignOverlapQuery(baseOptions: Apollo.QueryHookOptions<GetBrandCampaignOverlapQuery, GetBrandCampaignOverlapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandCampaignOverlapQuery, GetBrandCampaignOverlapQueryVariables>(GetBrandCampaignOverlapDocument, options);
      }
export function useGetBrandCampaignOverlapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandCampaignOverlapQuery, GetBrandCampaignOverlapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandCampaignOverlapQuery, GetBrandCampaignOverlapQueryVariables>(GetBrandCampaignOverlapDocument, options);
        }
export type GetBrandCampaignOverlapQueryHookResult = ReturnType<typeof useGetBrandCampaignOverlapQuery>;
export type GetBrandCampaignOverlapLazyQueryHookResult = ReturnType<typeof useGetBrandCampaignOverlapLazyQuery>;
export type GetBrandCampaignOverlapQueryResult = Apollo.QueryResult<GetBrandCampaignOverlapQuery, GetBrandCampaignOverlapQueryVariables>;
export const GetBrandCampaignPodcastOmniChartDocument = gql`
    query getBrandCampaignPodcastOmniChart($organizationId: ID!, $campaignId: ID!, $id: ID!, $after: String, $before: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignPodcast(id: $id) {
          id
          episodes(after: $after, before: $before) {
            id
            title
            image {
              id
              path
            }
            published
          }
          attribution(after: $after, before: $before) {
            users {
              hourlyVisitors {
                count
                hour
              }
            }
          }
          downloads(after: $after, before: $before) {
            hourly {
              hour
              downloadClass
              count
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandCampaignPodcastOmniChartQuery__
 *
 * To run a query within a React component, call `useGetBrandCampaignPodcastOmniChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCampaignPodcastOmniChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCampaignPodcastOmniChartQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetBrandCampaignPodcastOmniChartQuery(baseOptions: Apollo.QueryHookOptions<GetBrandCampaignPodcastOmniChartQuery, GetBrandCampaignPodcastOmniChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandCampaignPodcastOmniChartQuery, GetBrandCampaignPodcastOmniChartQueryVariables>(GetBrandCampaignPodcastOmniChartDocument, options);
      }
export function useGetBrandCampaignPodcastOmniChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandCampaignPodcastOmniChartQuery, GetBrandCampaignPodcastOmniChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandCampaignPodcastOmniChartQuery, GetBrandCampaignPodcastOmniChartQueryVariables>(GetBrandCampaignPodcastOmniChartDocument, options);
        }
export type GetBrandCampaignPodcastOmniChartQueryHookResult = ReturnType<typeof useGetBrandCampaignPodcastOmniChartQuery>;
export type GetBrandCampaignPodcastOmniChartLazyQueryHookResult = ReturnType<typeof useGetBrandCampaignPodcastOmniChartLazyQuery>;
export type GetBrandCampaignPodcastOmniChartQueryResult = Apollo.QueryResult<GetBrandCampaignPodcastOmniChartQuery, GetBrandCampaignPodcastOmniChartQueryVariables>;
export const GetBrandCampaignReferrersDocument = gql`
    query getBrandCampaignReferrers($organizationId: ID!, $id: ID!, $domain: String, $offset: Int, $limit: Int) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        attribution {
          users {
            referrers(referrerDomain: $domain) {
              count
              sum
              nodes(offset: $offset, limit: $limit) {
                referrer
                count
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandCampaignReferrersQuery__
 *
 * To run a query within a React component, call `useGetBrandCampaignReferrersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCampaignReferrersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCampaignReferrersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      domain: // value for 'domain'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBrandCampaignReferrersQuery(baseOptions: Apollo.QueryHookOptions<GetBrandCampaignReferrersQuery, GetBrandCampaignReferrersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandCampaignReferrersQuery, GetBrandCampaignReferrersQueryVariables>(GetBrandCampaignReferrersDocument, options);
      }
export function useGetBrandCampaignReferrersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandCampaignReferrersQuery, GetBrandCampaignReferrersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandCampaignReferrersQuery, GetBrandCampaignReferrersQueryVariables>(GetBrandCampaignReferrersDocument, options);
        }
export type GetBrandCampaignReferrersQueryHookResult = ReturnType<typeof useGetBrandCampaignReferrersQuery>;
export type GetBrandCampaignReferrersLazyQueryHookResult = ReturnType<typeof useGetBrandCampaignReferrersLazyQuery>;
export type GetBrandCampaignReferrersQueryResult = Apollo.QueryResult<GetBrandCampaignReferrersQuery, GetBrandCampaignReferrersQueryVariables>;
export const GetBrandCampaignStreamingOmniChartDocument = gql`
    query getBrandCampaignStreamingOmniChart($organizationId: ID!, $campaignId: ID!, $id: ID!, $after: String, $before: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignStreaming(id: $id) {
          id
          attribution(after: $after, before: $before) {
            users {
              hourlyVisitors {
                count
                hour
              }
            }
          }
          downloads(after: $after, before: $before) {
            hourly {
              hour
              downloadClass
              count
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandCampaignStreamingOmniChartQuery__
 *
 * To run a query within a React component, call `useGetBrandCampaignStreamingOmniChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandCampaignStreamingOmniChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandCampaignStreamingOmniChartQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetBrandCampaignStreamingOmniChartQuery(baseOptions: Apollo.QueryHookOptions<GetBrandCampaignStreamingOmniChartQuery, GetBrandCampaignStreamingOmniChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandCampaignStreamingOmniChartQuery, GetBrandCampaignStreamingOmniChartQueryVariables>(GetBrandCampaignStreamingOmniChartDocument, options);
      }
export function useGetBrandCampaignStreamingOmniChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandCampaignStreamingOmniChartQuery, GetBrandCampaignStreamingOmniChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandCampaignStreamingOmniChartQuery, GetBrandCampaignStreamingOmniChartQueryVariables>(GetBrandCampaignStreamingOmniChartDocument, options);
        }
export type GetBrandCampaignStreamingOmniChartQueryHookResult = ReturnType<typeof useGetBrandCampaignStreamingOmniChartQuery>;
export type GetBrandCampaignStreamingOmniChartLazyQueryHookResult = ReturnType<typeof useGetBrandCampaignStreamingOmniChartLazyQuery>;
export type GetBrandCampaignStreamingOmniChartQueryResult = Apollo.QueryResult<GetBrandCampaignStreamingOmniChartQuery, GetBrandCampaignStreamingOmniChartQueryVariables>;
export const GetBrandOrganizationCampaignOverlapQueryDocument = gql`
    query getBrandOrganizationCampaignOverlapQuery($id: ID!, $after: Date, $before: Date) {
  me {
    id
    organization(id: $id) {
      id
      overview {
        impressions(after: $after, before: $before) {
          overlap {
            campaigns {
              baseDownloads
              baseReach
              baseCampaignId
              baseCampaign {
                id
                name
                organization {
                  id
                  name
                }
              }
              compDownloads
              compReach
              compCampaignId
              compCampaign {
                id
                name
                organization {
                  id
                  name
                }
              }
              overlap
              combined
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandOrganizationCampaignOverlapQueryQuery__
 *
 * To run a query within a React component, call `useGetBrandOrganizationCampaignOverlapQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOrganizationCampaignOverlapQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOrganizationCampaignOverlapQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetBrandOrganizationCampaignOverlapQueryQuery(baseOptions: Apollo.QueryHookOptions<GetBrandOrganizationCampaignOverlapQueryQuery, GetBrandOrganizationCampaignOverlapQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandOrganizationCampaignOverlapQueryQuery, GetBrandOrganizationCampaignOverlapQueryQueryVariables>(GetBrandOrganizationCampaignOverlapQueryDocument, options);
      }
export function useGetBrandOrganizationCampaignOverlapQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandOrganizationCampaignOverlapQueryQuery, GetBrandOrganizationCampaignOverlapQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandOrganizationCampaignOverlapQueryQuery, GetBrandOrganizationCampaignOverlapQueryQueryVariables>(GetBrandOrganizationCampaignOverlapQueryDocument, options);
        }
export type GetBrandOrganizationCampaignOverlapQueryQueryHookResult = ReturnType<typeof useGetBrandOrganizationCampaignOverlapQueryQuery>;
export type GetBrandOrganizationCampaignOverlapQueryLazyQueryHookResult = ReturnType<typeof useGetBrandOrganizationCampaignOverlapQueryLazyQuery>;
export type GetBrandOrganizationCampaignOverlapQueryQueryResult = Apollo.QueryResult<GetBrandOrganizationCampaignOverlapQueryQuery, GetBrandOrganizationCampaignOverlapQueryQueryVariables>;
export const GetBrandOrganizationFrequencyQueryDocument = gql`
    query getBrandOrganizationFrequencyQuery($id: ID!, $after: Date, $before: Date, $publisherIds: [ID], $campaignIds: [ID]) {
  me {
    id
    organization(id: $id) {
      id
      overview {
        impressions(
          publisherIds: $publisherIds
          campaignIds: $campaignIds
          after: $after
          before: $before
        ) {
          impressions
          reach
          frequency {
            max
            over {
              impressions
              reach
            }
            nodes {
              frequency
              total
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandOrganizationFrequencyQueryQuery__
 *
 * To run a query within a React component, call `useGetBrandOrganizationFrequencyQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOrganizationFrequencyQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOrganizationFrequencyQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      publisherIds: // value for 'publisherIds'
 *      campaignIds: // value for 'campaignIds'
 *   },
 * });
 */
export function useGetBrandOrganizationFrequencyQueryQuery(baseOptions: Apollo.QueryHookOptions<GetBrandOrganizationFrequencyQueryQuery, GetBrandOrganizationFrequencyQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandOrganizationFrequencyQueryQuery, GetBrandOrganizationFrequencyQueryQueryVariables>(GetBrandOrganizationFrequencyQueryDocument, options);
      }
export function useGetBrandOrganizationFrequencyQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandOrganizationFrequencyQueryQuery, GetBrandOrganizationFrequencyQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandOrganizationFrequencyQueryQuery, GetBrandOrganizationFrequencyQueryQueryVariables>(GetBrandOrganizationFrequencyQueryDocument, options);
        }
export type GetBrandOrganizationFrequencyQueryQueryHookResult = ReturnType<typeof useGetBrandOrganizationFrequencyQueryQuery>;
export type GetBrandOrganizationFrequencyQueryLazyQueryHookResult = ReturnType<typeof useGetBrandOrganizationFrequencyQueryLazyQuery>;
export type GetBrandOrganizationFrequencyQueryQueryResult = Apollo.QueryResult<GetBrandOrganizationFrequencyQueryQuery, GetBrandOrganizationFrequencyQueryQueryVariables>;
export const GetBrandOrganizationImpressionsCountryLocationQueryDocument = gql`
    query getBrandOrganizationImpressionsCountryLocationQuery($id: ID!, $after: Date, $before: Date, $publisherIds: [ID], $campaignIds: [ID], $country: String) {
  me {
    id
    organization(id: $id) {
      id
      overview {
        impressions(
          after: $after
          before: $before
          publisherIds: $publisherIds
          campaignIds: $campaignIds
        ) {
          locations(country: $country) {
            count
            regions {
              country
              region
              total
            }
            nodes {
              country
              region
              city
              latitude
              longitude
              count: total
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandOrganizationImpressionsCountryLocationQueryQuery__
 *
 * To run a query within a React component, call `useGetBrandOrganizationImpressionsCountryLocationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOrganizationImpressionsCountryLocationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOrganizationImpressionsCountryLocationQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      publisherIds: // value for 'publisherIds'
 *      campaignIds: // value for 'campaignIds'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetBrandOrganizationImpressionsCountryLocationQueryQuery(baseOptions: Apollo.QueryHookOptions<GetBrandOrganizationImpressionsCountryLocationQueryQuery, GetBrandOrganizationImpressionsCountryLocationQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandOrganizationImpressionsCountryLocationQueryQuery, GetBrandOrganizationImpressionsCountryLocationQueryQueryVariables>(GetBrandOrganizationImpressionsCountryLocationQueryDocument, options);
      }
export function useGetBrandOrganizationImpressionsCountryLocationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandOrganizationImpressionsCountryLocationQueryQuery, GetBrandOrganizationImpressionsCountryLocationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandOrganizationImpressionsCountryLocationQueryQuery, GetBrandOrganizationImpressionsCountryLocationQueryQueryVariables>(GetBrandOrganizationImpressionsCountryLocationQueryDocument, options);
        }
export type GetBrandOrganizationImpressionsCountryLocationQueryQueryHookResult = ReturnType<typeof useGetBrandOrganizationImpressionsCountryLocationQueryQuery>;
export type GetBrandOrganizationImpressionsCountryLocationQueryLazyQueryHookResult = ReturnType<typeof useGetBrandOrganizationImpressionsCountryLocationQueryLazyQuery>;
export type GetBrandOrganizationImpressionsCountryLocationQueryQueryResult = Apollo.QueryResult<GetBrandOrganizationImpressionsCountryLocationQueryQuery, GetBrandOrganizationImpressionsCountryLocationQueryQueryVariables>;
export const GetBrandOrganizationIntervalReachQueryDocument = gql`
    query getBrandOrganizationIntervalReachQuery($id: ID!, $after: Date, $before: Date, $publisherIds: [ID], $campaignIds: [ID], $trailing: Int, $interval: String, $attr: String) {
  me {
    id
    organization(id: $id) {
      id
      overview {
        impressions(
          after: $after
          before: $before
          publisherIds: $publisherIds
          campaignIds: $campaignIds
        ) {
          intervalReachOverlap(trailing: $trailing, interval: $interval, attr: $attr) {
            interval
            impressions
            reach
            priorImpressions
            priorReach
            combinedReach
            existingReach
            newReach
            percentNew
            impressionsToNewReach
            impressionsToPriorReach
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandOrganizationIntervalReachQueryQuery__
 *
 * To run a query within a React component, call `useGetBrandOrganizationIntervalReachQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOrganizationIntervalReachQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOrganizationIntervalReachQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      publisherIds: // value for 'publisherIds'
 *      campaignIds: // value for 'campaignIds'
 *      trailing: // value for 'trailing'
 *      interval: // value for 'interval'
 *      attr: // value for 'attr'
 *   },
 * });
 */
export function useGetBrandOrganizationIntervalReachQueryQuery(baseOptions: Apollo.QueryHookOptions<GetBrandOrganizationIntervalReachQueryQuery, GetBrandOrganizationIntervalReachQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandOrganizationIntervalReachQueryQuery, GetBrandOrganizationIntervalReachQueryQueryVariables>(GetBrandOrganizationIntervalReachQueryDocument, options);
      }
export function useGetBrandOrganizationIntervalReachQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandOrganizationIntervalReachQueryQuery, GetBrandOrganizationIntervalReachQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandOrganizationIntervalReachQueryQuery, GetBrandOrganizationIntervalReachQueryQueryVariables>(GetBrandOrganizationIntervalReachQueryDocument, options);
        }
export type GetBrandOrganizationIntervalReachQueryQueryHookResult = ReturnType<typeof useGetBrandOrganizationIntervalReachQueryQuery>;
export type GetBrandOrganizationIntervalReachQueryLazyQueryHookResult = ReturnType<typeof useGetBrandOrganizationIntervalReachQueryLazyQuery>;
export type GetBrandOrganizationIntervalReachQueryQueryResult = Apollo.QueryResult<GetBrandOrganizationIntervalReachQueryQuery, GetBrandOrganizationIntervalReachQueryQueryVariables>;
export const GetBrandOrganizationImpressionsPlayersQueryDocument = gql`
    query getBrandOrganizationImpressionsPlayersQuery($id: ID!, $after: Date, $before: Date, $campaignIds: [ID]) {
  me {
    id
    organization(id: $id) {
      id
      overview {
        impressions(campaignIds: $campaignIds, after: $after, before: $before) {
          players {
            player
            total
            reach
            frequency
            impressionsLessThan5
            percentageImpressionsLessThan5
            reachLessThan5
            percentageReachLessThan5
            impressionsBetween5And15
            percentageImpressionsBetween5And15
            reachBetween5And15
            percentageReachBetween5And15
            impressionsGreaterThan15
            percentageImpressionsGreaterThan15
            reachGreaterThan15
            percentageReachGreaterThan15
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandOrganizationImpressionsPlayersQueryQuery__
 *
 * To run a query within a React component, call `useGetBrandOrganizationImpressionsPlayersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOrganizationImpressionsPlayersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOrganizationImpressionsPlayersQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      campaignIds: // value for 'campaignIds'
 *   },
 * });
 */
export function useGetBrandOrganizationImpressionsPlayersQueryQuery(baseOptions: Apollo.QueryHookOptions<GetBrandOrganizationImpressionsPlayersQueryQuery, GetBrandOrganizationImpressionsPlayersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandOrganizationImpressionsPlayersQueryQuery, GetBrandOrganizationImpressionsPlayersQueryQueryVariables>(GetBrandOrganizationImpressionsPlayersQueryDocument, options);
      }
export function useGetBrandOrganizationImpressionsPlayersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandOrganizationImpressionsPlayersQueryQuery, GetBrandOrganizationImpressionsPlayersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandOrganizationImpressionsPlayersQueryQuery, GetBrandOrganizationImpressionsPlayersQueryQueryVariables>(GetBrandOrganizationImpressionsPlayersQueryDocument, options);
        }
export type GetBrandOrganizationImpressionsPlayersQueryQueryHookResult = ReturnType<typeof useGetBrandOrganizationImpressionsPlayersQueryQuery>;
export type GetBrandOrganizationImpressionsPlayersQueryLazyQueryHookResult = ReturnType<typeof useGetBrandOrganizationImpressionsPlayersQueryLazyQuery>;
export type GetBrandOrganizationImpressionsPlayersQueryQueryResult = Apollo.QueryResult<GetBrandOrganizationImpressionsPlayersQueryQuery, GetBrandOrganizationImpressionsPlayersQueryQueryVariables>;
export const GetBrandOrganizationImpressionsRegionLocationQueryDocument = gql`
    query getBrandOrganizationImpressionsRegionLocationQuery($id: ID!, $after: Date, $before: Date, $publisherIds: [ID], $campaignIds: [ID], $country: String, $region: String) {
  me {
    id
    organization(id: $id) {
      id
      overview {
        impressions(
          after: $after
          before: $before
          publisherIds: $publisherIds
          campaignIds: $campaignIds
        ) {
          locations(country: $country, region: $region) {
            count
            cities {
              country
              region
              city
              total
            }
            nodes {
              country
              region
              city
              latitude
              longitude
              count: total
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandOrganizationImpressionsRegionLocationQueryQuery__
 *
 * To run a query within a React component, call `useGetBrandOrganizationImpressionsRegionLocationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOrganizationImpressionsRegionLocationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOrganizationImpressionsRegionLocationQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      publisherIds: // value for 'publisherIds'
 *      campaignIds: // value for 'campaignIds'
 *      country: // value for 'country'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useGetBrandOrganizationImpressionsRegionLocationQueryQuery(baseOptions: Apollo.QueryHookOptions<GetBrandOrganizationImpressionsRegionLocationQueryQuery, GetBrandOrganizationImpressionsRegionLocationQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandOrganizationImpressionsRegionLocationQueryQuery, GetBrandOrganizationImpressionsRegionLocationQueryQueryVariables>(GetBrandOrganizationImpressionsRegionLocationQueryDocument, options);
      }
export function useGetBrandOrganizationImpressionsRegionLocationQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandOrganizationImpressionsRegionLocationQueryQuery, GetBrandOrganizationImpressionsRegionLocationQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandOrganizationImpressionsRegionLocationQueryQuery, GetBrandOrganizationImpressionsRegionLocationQueryQueryVariables>(GetBrandOrganizationImpressionsRegionLocationQueryDocument, options);
        }
export type GetBrandOrganizationImpressionsRegionLocationQueryQueryHookResult = ReturnType<typeof useGetBrandOrganizationImpressionsRegionLocationQueryQuery>;
export type GetBrandOrganizationImpressionsRegionLocationQueryLazyQueryHookResult = ReturnType<typeof useGetBrandOrganizationImpressionsRegionLocationQueryLazyQuery>;
export type GetBrandOrganizationImpressionsRegionLocationQueryQueryResult = Apollo.QueryResult<GetBrandOrganizationImpressionsRegionLocationQueryQuery, GetBrandOrganizationImpressionsRegionLocationQueryQueryVariables>;
export const GetBrandOrganizationOverlapDocument = gql`
    query getBrandOrganizationOverlap($id: ID!, $after: Date, $before: Date) {
  me {
    id
    organization(id: $id) {
      id
      overlap(after: $after, before: $before) {
        pairs {
          baseCampaignDynamicId
          baseCampaignDynamic {
            id
            name
          }
          baseFeedId
          baseFeed {
            id
            title
            image {
              id
              width
              height
              path
            }
          }
          compCampaignDynamicId
          compCampaignDynamic {
            id
            name
          }
          compFeedId
          compFeed {
            id
            title
            image {
              id
              width
              height
              path
            }
          }
          baseReach
          compReach
          overlap
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandOrganizationOverlapQuery__
 *
 * To run a query within a React component, call `useGetBrandOrganizationOverlapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOrganizationOverlapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOrganizationOverlapQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetBrandOrganizationOverlapQuery(baseOptions: Apollo.QueryHookOptions<GetBrandOrganizationOverlapQuery, GetBrandOrganizationOverlapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandOrganizationOverlapQuery, GetBrandOrganizationOverlapQueryVariables>(GetBrandOrganizationOverlapDocument, options);
      }
export function useGetBrandOrganizationOverlapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandOrganizationOverlapQuery, GetBrandOrganizationOverlapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandOrganizationOverlapQuery, GetBrandOrganizationOverlapQueryVariables>(GetBrandOrganizationOverlapDocument, options);
        }
export type GetBrandOrganizationOverlapQueryHookResult = ReturnType<typeof useGetBrandOrganizationOverlapQuery>;
export type GetBrandOrganizationOverlapLazyQueryHookResult = ReturnType<typeof useGetBrandOrganizationOverlapLazyQuery>;
export type GetBrandOrganizationOverlapQueryResult = Apollo.QueryResult<GetBrandOrganizationOverlapQuery, GetBrandOrganizationOverlapQueryVariables>;
export const GetBrandOrganizationPublisherOverlapQueryDocument = gql`
    query getBrandOrganizationPublisherOverlapQuery($id: ID!, $after: Date, $before: Date) {
  me {
    id
    organization(id: $id) {
      id
      overview {
        impressions(after: $after, before: $before) {
          overlap {
            publishers {
              baseDownloads
              baseReach
              basePublisherId
              basePublisher {
                id
                name
              }
              compDownloads
              compReach
              compPublisherId
              compPublisher {
                id
                name
              }
              overlap
              combined
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandOrganizationPublisherOverlapQueryQuery__
 *
 * To run a query within a React component, call `useGetBrandOrganizationPublisherOverlapQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandOrganizationPublisherOverlapQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandOrganizationPublisherOverlapQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetBrandOrganizationPublisherOverlapQueryQuery(baseOptions: Apollo.QueryHookOptions<GetBrandOrganizationPublisherOverlapQueryQuery, GetBrandOrganizationPublisherOverlapQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandOrganizationPublisherOverlapQueryQuery, GetBrandOrganizationPublisherOverlapQueryQueryVariables>(GetBrandOrganizationPublisherOverlapQueryDocument, options);
      }
export function useGetBrandOrganizationPublisherOverlapQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandOrganizationPublisherOverlapQueryQuery, GetBrandOrganizationPublisherOverlapQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandOrganizationPublisherOverlapQueryQuery, GetBrandOrganizationPublisherOverlapQueryQueryVariables>(GetBrandOrganizationPublisherOverlapQueryDocument, options);
        }
export type GetBrandOrganizationPublisherOverlapQueryQueryHookResult = ReturnType<typeof useGetBrandOrganizationPublisherOverlapQueryQuery>;
export type GetBrandOrganizationPublisherOverlapQueryLazyQueryHookResult = ReturnType<typeof useGetBrandOrganizationPublisherOverlapQueryLazyQuery>;
export type GetBrandOrganizationPublisherOverlapQueryQueryResult = Apollo.QueryResult<GetBrandOrganizationPublisherOverlapQueryQuery, GetBrandOrganizationPublisherOverlapQueryQueryVariables>;
export const GetCampaignApprovalConfigDocument = gql`
    query getCampaignApprovalConfig($organizationId: ID!, $campaignId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        approvalConfig {
          publisherMembers {
            id
            firstName
            lastName
          }
          brandMembers {
            id
            firstName
            lastName
          }
          buySideAgencies {
            id
            name
            members {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignApprovalConfigQuery__
 *
 * To run a query within a React component, call `useGetCampaignApprovalConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignApprovalConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignApprovalConfigQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignApprovalConfigQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignApprovalConfigQuery, GetCampaignApprovalConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignApprovalConfigQuery, GetCampaignApprovalConfigQueryVariables>(GetCampaignApprovalConfigDocument, options);
      }
export function useGetCampaignApprovalConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignApprovalConfigQuery, GetCampaignApprovalConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignApprovalConfigQuery, GetCampaignApprovalConfigQueryVariables>(GetCampaignApprovalConfigDocument, options);
        }
export type GetCampaignApprovalConfigQueryHookResult = ReturnType<typeof useGetCampaignApprovalConfigQuery>;
export type GetCampaignApprovalConfigLazyQueryHookResult = ReturnType<typeof useGetCampaignApprovalConfigLazyQuery>;
export type GetCampaignApprovalConfigQueryResult = Apollo.QueryResult<GetCampaignApprovalConfigQuery, GetCampaignApprovalConfigQueryVariables>;
export const GetCampaignApprovalsDocument = gql`
    query getCampaignApprovals($organizationId: ID!, $campaignId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        dynamicApprovals {
          ...DynamicApproval
        }
        podcastApprovals {
          ...PodcastApproval
        }
        streamingApprovals {
          ...StreamingApproval
        }
      }
    }
  }
}
    ${DynamicApprovalFragmentDoc}
${PodcastApprovalFragmentDoc}
${StreamingApprovalFragmentDoc}`;

/**
 * __useGetCampaignApprovalsQuery__
 *
 * To run a query within a React component, call `useGetCampaignApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignApprovalsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignApprovalsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignApprovalsQuery, GetCampaignApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignApprovalsQuery, GetCampaignApprovalsQueryVariables>(GetCampaignApprovalsDocument, options);
      }
export function useGetCampaignApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignApprovalsQuery, GetCampaignApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignApprovalsQuery, GetCampaignApprovalsQueryVariables>(GetCampaignApprovalsDocument, options);
        }
export type GetCampaignApprovalsQueryHookResult = ReturnType<typeof useGetCampaignApprovalsQuery>;
export type GetCampaignApprovalsLazyQueryHookResult = ReturnType<typeof useGetCampaignApprovalsLazyQuery>;
export type GetCampaignApprovalsQueryResult = Apollo.QueryResult<GetCampaignApprovalsQuery, GetCampaignApprovalsQueryVariables>;
export const GetCampaignAttributionPurchaseValueByDayDocument = gql`
    query getCampaignAttributionPurchaseValueByDay($organizationId: ID!, $id: ID!, $after: String, $before: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        attribution(after: $after, before: $before) {
          events {
            purchaseValueByDay {
              day
              value
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignAttributionPurchaseValueByDayQuery__
 *
 * To run a query within a React component, call `useGetCampaignAttributionPurchaseValueByDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignAttributionPurchaseValueByDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignAttributionPurchaseValueByDayQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetCampaignAttributionPurchaseValueByDayQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignAttributionPurchaseValueByDayQuery, GetCampaignAttributionPurchaseValueByDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignAttributionPurchaseValueByDayQuery, GetCampaignAttributionPurchaseValueByDayQueryVariables>(GetCampaignAttributionPurchaseValueByDayDocument, options);
      }
export function useGetCampaignAttributionPurchaseValueByDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignAttributionPurchaseValueByDayQuery, GetCampaignAttributionPurchaseValueByDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignAttributionPurchaseValueByDayQuery, GetCampaignAttributionPurchaseValueByDayQueryVariables>(GetCampaignAttributionPurchaseValueByDayDocument, options);
        }
export type GetCampaignAttributionPurchaseValueByDayQueryHookResult = ReturnType<typeof useGetCampaignAttributionPurchaseValueByDayQuery>;
export type GetCampaignAttributionPurchaseValueByDayLazyQueryHookResult = ReturnType<typeof useGetCampaignAttributionPurchaseValueByDayLazyQuery>;
export type GetCampaignAttributionPurchaseValueByDayQueryResult = Apollo.QueryResult<GetCampaignAttributionPurchaseValueByDayQuery, GetCampaignAttributionPurchaseValueByDayQueryVariables>;
export const GetCampaignDownloadCountryLocationsDocument = gql`
    query getCampaignDownloadCountryLocations($organizationId: ID!, $id: ID!, $country: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        downloads {
          locations(country: $country) {
            count
            nodes(limit: 2000) {
              country
              region
              city
              latitude
              longitude
              total
            }
            regions(limit: 200) {
              country
              region
              total
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignDownloadCountryLocationsQuery__
 *
 * To run a query within a React component, call `useGetCampaignDownloadCountryLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignDownloadCountryLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignDownloadCountryLocationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetCampaignDownloadCountryLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignDownloadCountryLocationsQuery, GetCampaignDownloadCountryLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignDownloadCountryLocationsQuery, GetCampaignDownloadCountryLocationsQueryVariables>(GetCampaignDownloadCountryLocationsDocument, options);
      }
export function useGetCampaignDownloadCountryLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignDownloadCountryLocationsQuery, GetCampaignDownloadCountryLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignDownloadCountryLocationsQuery, GetCampaignDownloadCountryLocationsQueryVariables>(GetCampaignDownloadCountryLocationsDocument, options);
        }
export type GetCampaignDownloadCountryLocationsQueryHookResult = ReturnType<typeof useGetCampaignDownloadCountryLocationsQuery>;
export type GetCampaignDownloadCountryLocationsLazyQueryHookResult = ReturnType<typeof useGetCampaignDownloadCountryLocationsLazyQuery>;
export type GetCampaignDownloadCountryLocationsQueryResult = Apollo.QueryResult<GetCampaignDownloadCountryLocationsQuery, GetCampaignDownloadCountryLocationsQueryVariables>;
export const GetCampaignDownloadLocationsDocument = gql`
    query getCampaignDownloadLocations($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        downloads {
          locations {
            count
            nodes(limit: 2000) {
              country
              region
              city
              latitude
              longitude
              total
            }
            countries(limit: 200) {
              country
              total
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignDownloadLocationsQuery__
 *
 * To run a query within a React component, call `useGetCampaignDownloadLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignDownloadLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignDownloadLocationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignDownloadLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignDownloadLocationsQuery, GetCampaignDownloadLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignDownloadLocationsQuery, GetCampaignDownloadLocationsQueryVariables>(GetCampaignDownloadLocationsDocument, options);
      }
export function useGetCampaignDownloadLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignDownloadLocationsQuery, GetCampaignDownloadLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignDownloadLocationsQuery, GetCampaignDownloadLocationsQueryVariables>(GetCampaignDownloadLocationsDocument, options);
        }
export type GetCampaignDownloadLocationsQueryHookResult = ReturnType<typeof useGetCampaignDownloadLocationsQuery>;
export type GetCampaignDownloadLocationsLazyQueryHookResult = ReturnType<typeof useGetCampaignDownloadLocationsLazyQuery>;
export type GetCampaignDownloadLocationsQueryResult = Apollo.QueryResult<GetCampaignDownloadLocationsQuery, GetCampaignDownloadLocationsQueryVariables>;
export const GetCampaignDownloadRegionLocationsDocument = gql`
    query getCampaignDownloadRegionLocations($organizationId: ID!, $id: ID!, $country: String, $region: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        downloads {
          locations(country: $country, region: $region) {
            count
            nodes(limit: 2000) {
              country
              region
              city
              latitude
              longitude
              total
            }
            cities(limit: 200) {
              country
              region
              city
              total
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignDownloadRegionLocationsQuery__
 *
 * To run a query within a React component, call `useGetCampaignDownloadRegionLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignDownloadRegionLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignDownloadRegionLocationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      country: // value for 'country'
 *      region: // value for 'region'
 *   },
 * });
 */
export function useGetCampaignDownloadRegionLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignDownloadRegionLocationsQuery, GetCampaignDownloadRegionLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignDownloadRegionLocationsQuery, GetCampaignDownloadRegionLocationsQueryVariables>(GetCampaignDownloadRegionLocationsDocument, options);
      }
export function useGetCampaignDownloadRegionLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignDownloadRegionLocationsQuery, GetCampaignDownloadRegionLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignDownloadRegionLocationsQuery, GetCampaignDownloadRegionLocationsQueryVariables>(GetCampaignDownloadRegionLocationsDocument, options);
        }
export type GetCampaignDownloadRegionLocationsQueryHookResult = ReturnType<typeof useGetCampaignDownloadRegionLocationsQuery>;
export type GetCampaignDownloadRegionLocationsLazyQueryHookResult = ReturnType<typeof useGetCampaignDownloadRegionLocationsLazyQuery>;
export type GetCampaignDownloadRegionLocationsQueryResult = Apollo.QueryResult<GetCampaignDownloadRegionLocationsQuery, GetCampaignDownloadRegionLocationsQueryVariables>;
export const GetCampaignDynamicEpisodeDocument = gql`
    query getCampaignDynamicEpisode($organizationId: ID!, $campaignId: ID!, $campaignDynamicId: ID!, $campaignDynamicPodcastId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignDynamic(id: $campaignDynamicId) {
          id
          campaignDynamicPodcast(id: $campaignDynamicPodcastId) {
            id
            campaignDynamicEpisode(id: $id) {
              ...CampaignDynamicEpisode
            }
          }
        }
      }
    }
  }
}
    ${CampaignDynamicEpisodeFragmentDoc}`;

/**
 * __useGetCampaignDynamicEpisodeQuery__
 *
 * To run a query within a React component, call `useGetCampaignDynamicEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignDynamicEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignDynamicEpisodeQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      campaignDynamicId: // value for 'campaignDynamicId'
 *      campaignDynamicPodcastId: // value for 'campaignDynamicPodcastId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignDynamicEpisodeQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignDynamicEpisodeQuery, GetCampaignDynamicEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignDynamicEpisodeQuery, GetCampaignDynamicEpisodeQueryVariables>(GetCampaignDynamicEpisodeDocument, options);
      }
export function useGetCampaignDynamicEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignDynamicEpisodeQuery, GetCampaignDynamicEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignDynamicEpisodeQuery, GetCampaignDynamicEpisodeQueryVariables>(GetCampaignDynamicEpisodeDocument, options);
        }
export type GetCampaignDynamicEpisodeQueryHookResult = ReturnType<typeof useGetCampaignDynamicEpisodeQuery>;
export type GetCampaignDynamicEpisodeLazyQueryHookResult = ReturnType<typeof useGetCampaignDynamicEpisodeLazyQuery>;
export type GetCampaignDynamicEpisodeQueryResult = Apollo.QueryResult<GetCampaignDynamicEpisodeQuery, GetCampaignDynamicEpisodeQueryVariables>;
export const GetCampaignDynamicPodcastDocument = gql`
    query getCampaignDynamicPodcast($organizationId: ID!, $campaignId: ID!, $campaignDynamicId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignDynamic(id: $campaignDynamicId) {
          id
          campaignDynamicPodcast(id: $id) {
            ...CampaignDynamicPodcast
            campaignDynamicEpisodes {
              ...CampaignDynamicEpisode
            }
          }
        }
      }
    }
  }
}
    ${CampaignDynamicPodcastFragmentDoc}
${CampaignDynamicEpisodeFragmentDoc}`;

/**
 * __useGetCampaignDynamicPodcastQuery__
 *
 * To run a query within a React component, call `useGetCampaignDynamicPodcastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignDynamicPodcastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignDynamicPodcastQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      campaignDynamicId: // value for 'campaignDynamicId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignDynamicPodcastQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignDynamicPodcastQuery, GetCampaignDynamicPodcastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignDynamicPodcastQuery, GetCampaignDynamicPodcastQueryVariables>(GetCampaignDynamicPodcastDocument, options);
      }
export function useGetCampaignDynamicPodcastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignDynamicPodcastQuery, GetCampaignDynamicPodcastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignDynamicPodcastQuery, GetCampaignDynamicPodcastQueryVariables>(GetCampaignDynamicPodcastDocument, options);
        }
export type GetCampaignDynamicPodcastQueryHookResult = ReturnType<typeof useGetCampaignDynamicPodcastQuery>;
export type GetCampaignDynamicPodcastLazyQueryHookResult = ReturnType<typeof useGetCampaignDynamicPodcastLazyQuery>;
export type GetCampaignDynamicPodcastQueryResult = Apollo.QueryResult<GetCampaignDynamicPodcastQuery, GetCampaignDynamicPodcastQueryVariables>;
export const GetCampaignEpisodeDocument = gql`
    query getCampaignEpisode($organizationId: ID!, $campaignId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignEpisode(id: $id) {
          id
          goal
          cost
          costToDate
          startAt
          endAt
          isDynamic
          downloadTotal
          reachTotal
          purchaseTotal
          attributionTotal
          userTotal
          userTotalModeled
          productTotal
          productTotalModeled
          addtocartTotal
          addtocartTotalModeled
          checkoutTotal
          checkoutTotalModeled
          purchaseTotal
          purchaseTotalModeled
          leadTotal
          leadTotalModeled
          valueTotal
          valueTotalModeled
          installedTotal
          installedTotalModeled
          verified
          downloads {
            count
          }
          attribution {
            users {
              sum {
                users
                usersModeled
                pages
                pagesModeled
                sessions
                sessionsModeled
                products
                productsModeled
                addtocarts
                addtocartsModeled
                checkouts
                checkoutsModeled
                purchases
                purchasesModeled
                leads
                leadsModeled
                value
                valueModeled
              }
            }
          }
          placements {
            id
            startTime
            endTime
            ad {
              id
              waveform
              text
              mpegPath
              flacPath
              words
              duration
            }
          }
          otherPlacements {
            id
            startTime
            endTime
            ad {
              id
              waveform
              text
              mpegPath
              flacPath
              words
              duration
              company {
                id
                name
                slug
              }
            }
          }
          episode {
            id
            title
            description(words: 25)
            image {
              id
              href
              path
            }
            published
            enclosure {
              id
              length
              duration
              mpegPath
              waveform
            }
          }
          futureEpisode {
            id
            title
            subtitle
            expectedPublished
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignEpisodeQuery__
 *
 * To run a query within a React component, call `useGetCampaignEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignEpisodeQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignEpisodeQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignEpisodeQuery, GetCampaignEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignEpisodeQuery, GetCampaignEpisodeQueryVariables>(GetCampaignEpisodeDocument, options);
      }
export function useGetCampaignEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignEpisodeQuery, GetCampaignEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignEpisodeQuery, GetCampaignEpisodeQueryVariables>(GetCampaignEpisodeDocument, options);
        }
export type GetCampaignEpisodeQueryHookResult = ReturnType<typeof useGetCampaignEpisodeQuery>;
export type GetCampaignEpisodeLazyQueryHookResult = ReturnType<typeof useGetCampaignEpisodeLazyQuery>;
export type GetCampaignEpisodeQueryResult = Apollo.QueryResult<GetCampaignEpisodeQuery, GetCampaignEpisodeQueryVariables>;
export const GetCampaignFrequencyQueryDocument = gql`
    query getCampaignFrequencyQuery($organizationId: ID!, $campaignId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        impressions {
          frequency {
            max
            over {
              impressions
              reach
            }
            nodes {
              frequency
              total
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignFrequencyQueryQuery__
 *
 * To run a query within a React component, call `useGetCampaignFrequencyQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignFrequencyQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignFrequencyQueryQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignFrequencyQueryQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignFrequencyQueryQuery, GetCampaignFrequencyQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignFrequencyQueryQuery, GetCampaignFrequencyQueryQueryVariables>(GetCampaignFrequencyQueryDocument, options);
      }
export function useGetCampaignFrequencyQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignFrequencyQueryQuery, GetCampaignFrequencyQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignFrequencyQueryQuery, GetCampaignFrequencyQueryQueryVariables>(GetCampaignFrequencyQueryDocument, options);
        }
export type GetCampaignFrequencyQueryQueryHookResult = ReturnType<typeof useGetCampaignFrequencyQueryQuery>;
export type GetCampaignFrequencyQueryLazyQueryHookResult = ReturnType<typeof useGetCampaignFrequencyQueryLazyQuery>;
export type GetCampaignFrequencyQueryQueryResult = Apollo.QueryResult<GetCampaignFrequencyQueryQuery, GetCampaignFrequencyQueryQueryVariables>;
export const GetCampaignLinkDocument = gql`
    query getCampaignLink($organizationId: ID!, $campaignId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignLink(id: $id) {
          ...CampaignLink
          target {
            id
            feed {
              id
              href
            }
          }
          attribution {
            marketing {
              linkHourly {
                campaignLinkId
                hour
                action
                total
              }
              linkClicks {
                campaignLinkId
                type
                category
                total
              }
              linkAttributionTargetEpisodes {
                count
                nodes {
                  id
                  downloads
                  reach
                  episode {
                    id
                    title
                    description(words: 50)
                    published
                    image {
                      id
                      href
                      path
                    }
                    enclosure {
                      id
                      length
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CampaignLinkFragmentDoc}`;

/**
 * __useGetCampaignLinkQuery__
 *
 * To run a query within a React component, call `useGetCampaignLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignLinkQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignLinkQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignLinkQuery, GetCampaignLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignLinkQuery, GetCampaignLinkQueryVariables>(GetCampaignLinkDocument, options);
      }
export function useGetCampaignLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignLinkQuery, GetCampaignLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignLinkQuery, GetCampaignLinkQueryVariables>(GetCampaignLinkDocument, options);
        }
export type GetCampaignLinkQueryHookResult = ReturnType<typeof useGetCampaignLinkQuery>;
export type GetCampaignLinkLazyQueryHookResult = ReturnType<typeof useGetCampaignLinkLazyQuery>;
export type GetCampaignLinkQueryResult = Apollo.QueryResult<GetCampaignLinkQuery, GetCampaignLinkQueryVariables>;
export const GetCampaignPermissionDocument = gql`
    query getCampaignPermission($organizationId: ID!, $campaignId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        permission(id: $id) {
          id
          title
          description
          objectName
          organization {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignPermissionQuery__
 *
 * To run a query within a React component, call `useGetCampaignPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignPermissionQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignPermissionQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignPermissionQuery, GetCampaignPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignPermissionQuery, GetCampaignPermissionQueryVariables>(GetCampaignPermissionDocument, options);
      }
export function useGetCampaignPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignPermissionQuery, GetCampaignPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignPermissionQuery, GetCampaignPermissionQueryVariables>(GetCampaignPermissionDocument, options);
        }
export type GetCampaignPermissionQueryHookResult = ReturnType<typeof useGetCampaignPermissionQuery>;
export type GetCampaignPermissionLazyQueryHookResult = ReturnType<typeof useGetCampaignPermissionLazyQuery>;
export type GetCampaignPermissionQueryResult = Apollo.QueryResult<GetCampaignPermissionQuery, GetCampaignPermissionQueryVariables>;
export const GetCampaignPermissionsDocument = gql`
    query getCampaignPermissions($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        permissions {
          id
          title
          description
          objectName
          organization {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignPermissionsQuery__
 *
 * To run a query within a React component, call `useGetCampaignPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignPermissionsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignPermissionsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignPermissionsQuery, GetCampaignPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignPermissionsQuery, GetCampaignPermissionsQueryVariables>(GetCampaignPermissionsDocument, options);
      }
export function useGetCampaignPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignPermissionsQuery, GetCampaignPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignPermissionsQuery, GetCampaignPermissionsQueryVariables>(GetCampaignPermissionsDocument, options);
        }
export type GetCampaignPermissionsQueryHookResult = ReturnType<typeof useGetCampaignPermissionsQuery>;
export type GetCampaignPermissionsLazyQueryHookResult = ReturnType<typeof useGetCampaignPermissionsLazyQuery>;
export type GetCampaignPermissionsQueryResult = Apollo.QueryResult<GetCampaignPermissionsQuery, GetCampaignPermissionsQueryVariables>;
export const GetCampaignPlayersQueryDocument = gql`
    query getCampaignPlayersQuery($organizationId: ID!, $id: ID!, $after: Date, $before: Date) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        enhancedConversions {
          spotifyAttribution
          appleAttribution
          spotifyCr
          appleWeightedCr
          otherWeightedCr
        }
        impressions(after: $after, before: $before) {
          players {
            player
            total
            reach
            frequency
            impressionsLessThan5
            percentageImpressionsLessThan5
            reachLessThan5
            percentageReachLessThan5
            impressionsBetween5And15
            percentageImpressionsBetween5And15
            reachBetween5And15
            percentageReachBetween5And15
            impressionsGreaterThan15
            percentageImpressionsGreaterThan15
            reachGreaterThan15
            percentageReachGreaterThan15
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignPlayersQueryQuery__
 *
 * To run a query within a React component, call `useGetCampaignPlayersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignPlayersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignPlayersQueryQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetCampaignPlayersQueryQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignPlayersQueryQuery, GetCampaignPlayersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignPlayersQueryQuery, GetCampaignPlayersQueryQueryVariables>(GetCampaignPlayersQueryDocument, options);
      }
export function useGetCampaignPlayersQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignPlayersQueryQuery, GetCampaignPlayersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignPlayersQueryQuery, GetCampaignPlayersQueryQueryVariables>(GetCampaignPlayersQueryDocument, options);
        }
export type GetCampaignPlayersQueryQueryHookResult = ReturnType<typeof useGetCampaignPlayersQueryQuery>;
export type GetCampaignPlayersQueryLazyQueryHookResult = ReturnType<typeof useGetCampaignPlayersQueryLazyQuery>;
export type GetCampaignPlayersQueryQueryResult = Apollo.QueryResult<GetCampaignPlayersQueryQuery, GetCampaignPlayersQueryQueryVariables>;
export const GetCampaignPodcastDocument = gql`
    query getCampaignPodcast($organizationId: ID!, $campaignId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignPodcast(id: $id) {
          ...CampaignPodcast
          attribution {
            users {
              sum {
                users
                usersModeled
                pages
                pagesModeled
                sessions
                sessionsModeled
                products
                productsModeled
                addtocarts
                addtocartsModeled
                checkouts
                checkoutsModeled
                purchases
                purchasesModeled
                leads
                leadsModeled
                value
                valueModeled
              }
            }
          }
          campaignEpisodes {
            ...CampaignEpisode
          }
        }
      }
    }
  }
}
    ${CampaignPodcastFragmentDoc}
${CampaignEpisodeFragmentDoc}`;

/**
 * __useGetCampaignPodcastQuery__
 *
 * To run a query within a React component, call `useGetCampaignPodcastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignPodcastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignPodcastQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignPodcastQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignPodcastQuery, GetCampaignPodcastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignPodcastQuery, GetCampaignPodcastQueryVariables>(GetCampaignPodcastDocument, options);
      }
export function useGetCampaignPodcastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignPodcastQuery, GetCampaignPodcastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignPodcastQuery, GetCampaignPodcastQueryVariables>(GetCampaignPodcastDocument, options);
        }
export type GetCampaignPodcastQueryHookResult = ReturnType<typeof useGetCampaignPodcastQuery>;
export type GetCampaignPodcastLazyQueryHookResult = ReturnType<typeof useGetCampaignPodcastLazyQuery>;
export type GetCampaignPodcastQueryResult = Apollo.QueryResult<GetCampaignPodcastQuery, GetCampaignPodcastQueryVariables>;
export const GetCampaignPrefixConsistencyDocument = gql`
    query getCampaignPrefixConsistency($organizationId: ID!, $campaignId: ID!, $campaignPodcastId: ID, $campaignEpisodeId: ID) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        debug {
          prefixConsistency(
            campaignPodcastId: $campaignPodcastId
            campaignEpisodeId: $campaignEpisodeId
          ) {
            day
            bigquery
            publisher
            diff
            bigtable
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignPrefixConsistencyQuery__
 *
 * To run a query within a React component, call `useGetCampaignPrefixConsistencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignPrefixConsistencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignPrefixConsistencyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      campaignPodcastId: // value for 'campaignPodcastId'
 *      campaignEpisodeId: // value for 'campaignEpisodeId'
 *   },
 * });
 */
export function useGetCampaignPrefixConsistencyQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignPrefixConsistencyQuery, GetCampaignPrefixConsistencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignPrefixConsistencyQuery, GetCampaignPrefixConsistencyQueryVariables>(GetCampaignPrefixConsistencyDocument, options);
      }
export function useGetCampaignPrefixConsistencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignPrefixConsistencyQuery, GetCampaignPrefixConsistencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignPrefixConsistencyQuery, GetCampaignPrefixConsistencyQueryVariables>(GetCampaignPrefixConsistencyDocument, options);
        }
export type GetCampaignPrefixConsistencyQueryHookResult = ReturnType<typeof useGetCampaignPrefixConsistencyQuery>;
export type GetCampaignPrefixConsistencyLazyQueryHookResult = ReturnType<typeof useGetCampaignPrefixConsistencyLazyQuery>;
export type GetCampaignPrefixConsistencyQueryResult = Apollo.QueryResult<GetCampaignPrefixConsistencyQuery, GetCampaignPrefixConsistencyQueryVariables>;
export const GetCampaignRevenueDocument = gql`
    query getCampaignRevenue($organizationId: ID!, $id: ID!, $after: String, $before: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        name
        multiplier
        downloads(after: $after, before: $before) {
          count
        }
        attribution(after: $after, before: $before) {
          users {
            sum {
              users
              usersModeled
              pages
              pagesModeled
              sessions
              sessionsModeled
              products
              productsModeled
              addtocarts
              addtocartsModeled
              checkouts
              checkoutsModeled
              purchases
              purchasesModeled
              leads
              leadsModeled
              value
              valueModeled
            }
          }
        }
        campaignDynamics {
          ...CampaignDynamicOld
          downloads(after: $after, before: $before) {
            count
          }
          attribution(after: $after, before: $before) {
            users {
              sum {
                users
                usersModeled
                pages
                pagesModeled
                sessions
                sessionsModeled
                products
                productsModeled
                addtocarts
                addtocartsModeled
                checkouts
                checkoutsModeled
                purchases
                purchasesModeled
                leads
                leadsModeled
                value
                valueModeled
              }
            }
          }
        }
        campaignPodcasts {
          ...CampaignPodcast
          downloads(after: $after, before: $before) {
            count
          }
          attribution(after: $after, before: $before) {
            users {
              sum {
                users
                usersModeled
                pages
                pagesModeled
                sessions
                sessionsModeled
                products
                productsModeled
                addtocarts
                addtocartsModeled
                checkouts
                checkoutsModeled
                purchases
                purchasesModeled
                leads
                leadsModeled
                value
                valueModeled
              }
            }
          }
        }
        campaignStreamings {
          ...CampaignStreamingOld
          downloads(after: $after, before: $before) {
            count
          }
          attribution(after: $after, before: $before) {
            users {
              sum {
                users
                usersModeled
                pages
                pagesModeled
                sessions
                sessionsModeled
                products
                productsModeled
                addtocarts
                addtocartsModeled
                checkouts
                checkoutsModeled
                purchases
                purchasesModeled
                leads
                leadsModeled
                value
                valueModeled
              }
            }
          }
        }
      }
    }
  }
}
    ${CampaignDynamicOldFragmentDoc}
${CampaignPodcastFragmentDoc}
${CampaignStreamingOldFragmentDoc}`;

/**
 * __useGetCampaignRevenueQuery__
 *
 * To run a query within a React component, call `useGetCampaignRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignRevenueQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetCampaignRevenueQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignRevenueQuery, GetCampaignRevenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignRevenueQuery, GetCampaignRevenueQueryVariables>(GetCampaignRevenueDocument, options);
      }
export function useGetCampaignRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignRevenueQuery, GetCampaignRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignRevenueQuery, GetCampaignRevenueQueryVariables>(GetCampaignRevenueDocument, options);
        }
export type GetCampaignRevenueQueryHookResult = ReturnType<typeof useGetCampaignRevenueQuery>;
export type GetCampaignRevenueLazyQueryHookResult = ReturnType<typeof useGetCampaignRevenueLazyQuery>;
export type GetCampaignRevenueQueryResult = Apollo.QueryResult<GetCampaignRevenueQuery, GetCampaignRevenueQueryVariables>;
export const GetCampaignTargetOptionsDocument = gql`
    query getCampaignTargetOptions($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        targetOptions {
          id
          feed {
            id
            title
            description(words: 50)
            image {
              href
              id
              path
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignTargetOptionsQuery__
 *
 * To run a query within a React component, call `useGetCampaignTargetOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignTargetOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignTargetOptionsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignTargetOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignTargetOptionsQuery, GetCampaignTargetOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignTargetOptionsQuery, GetCampaignTargetOptionsQueryVariables>(GetCampaignTargetOptionsDocument, options);
      }
export function useGetCampaignTargetOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignTargetOptionsQuery, GetCampaignTargetOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignTargetOptionsQuery, GetCampaignTargetOptionsQueryVariables>(GetCampaignTargetOptionsDocument, options);
        }
export type GetCampaignTargetOptionsQueryHookResult = ReturnType<typeof useGetCampaignTargetOptionsQuery>;
export type GetCampaignTargetOptionsLazyQueryHookResult = ReturnType<typeof useGetCampaignTargetOptionsLazyQuery>;
export type GetCampaignTargetOptionsQueryResult = Apollo.QueryResult<GetCampaignTargetOptionsQuery, GetCampaignTargetOptionsQueryVariables>;
export const GetCampaignTargetDocument = gql`
    query getCampaignTarget($organizationId: ID!, $campaignId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignTarget(id: $id) {
          ...CampaignTarget
          attribution {
            marketing {
              acquired {
                day
                count
              }
              targetEpisodes {
                count
                nodes {
                  id
                  downloads
                  episode {
                    id
                    title
                    description(words: 50)
                    published
                    image {
                      id
                      href
                      path
                    }
                    enclosure {
                      id
                      length
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${CampaignTargetFragmentDoc}`;

/**
 * __useGetCampaignTargetQuery__
 *
 * To run a query within a React component, call `useGetCampaignTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignTargetQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignTargetQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignTargetQuery, GetCampaignTargetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignTargetQuery, GetCampaignTargetQueryVariables>(GetCampaignTargetDocument, options);
      }
export function useGetCampaignTargetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignTargetQuery, GetCampaignTargetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignTargetQuery, GetCampaignTargetQueryVariables>(GetCampaignTargetDocument, options);
        }
export type GetCampaignTargetQueryHookResult = ReturnType<typeof useGetCampaignTargetQuery>;
export type GetCampaignTargetLazyQueryHookResult = ReturnType<typeof useGetCampaignTargetLazyQuery>;
export type GetCampaignTargetQueryResult = Apollo.QueryResult<GetCampaignTargetQuery, GetCampaignTargetQueryVariables>;
export const GetCampaignWebhookConsistencyDocument = gql`
    query getCampaignWebhookConsistency($organizationId: ID!, $campaignId: ID!, $campaignDynamicId: ID) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        debug {
          webhookConsistency(campaignDynamicId: $campaignDynamicId) {
            day
            bigquery
            diff
            bigqueryInvalid
            bigtable
          }
          webhookInvalidImpressions {
            reason
            count
            exampleRecord
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignWebhookConsistencyQuery__
 *
 * To run a query within a React component, call `useGetCampaignWebhookConsistencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignWebhookConsistencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignWebhookConsistencyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      campaignDynamicId: // value for 'campaignDynamicId'
 *   },
 * });
 */
export function useGetCampaignWebhookConsistencyQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignWebhookConsistencyQuery, GetCampaignWebhookConsistencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignWebhookConsistencyQuery, GetCampaignWebhookConsistencyQueryVariables>(GetCampaignWebhookConsistencyDocument, options);
      }
export function useGetCampaignWebhookConsistencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignWebhookConsistencyQuery, GetCampaignWebhookConsistencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignWebhookConsistencyQuery, GetCampaignWebhookConsistencyQueryVariables>(GetCampaignWebhookConsistencyDocument, options);
        }
export type GetCampaignWebhookConsistencyQueryHookResult = ReturnType<typeof useGetCampaignWebhookConsistencyQuery>;
export type GetCampaignWebhookConsistencyLazyQueryHookResult = ReturnType<typeof useGetCampaignWebhookConsistencyLazyQuery>;
export type GetCampaignWebhookConsistencyQueryResult = Apollo.QueryResult<GetCampaignWebhookConsistencyQuery, GetCampaignWebhookConsistencyQueryVariables>;
export const ClaimPublisherDocument = gql`
    query claimPublisher($href: String!) {
  claim {
    publisher(href: $href) {
      href
      title
      email
      name
    }
  }
}
    `;

/**
 * __useClaimPublisherQuery__
 *
 * To run a query within a React component, call `useClaimPublisherQuery` and pass it any options that fit your needs.
 * When your component renders, `useClaimPublisherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClaimPublisherQuery({
 *   variables: {
 *      href: // value for 'href'
 *   },
 * });
 */
export function useClaimPublisherQuery(baseOptions: Apollo.QueryHookOptions<ClaimPublisherQuery, ClaimPublisherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClaimPublisherQuery, ClaimPublisherQueryVariables>(ClaimPublisherDocument, options);
      }
export function useClaimPublisherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClaimPublisherQuery, ClaimPublisherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClaimPublisherQuery, ClaimPublisherQueryVariables>(ClaimPublisherDocument, options);
        }
export type ClaimPublisherQueryHookResult = ReturnType<typeof useClaimPublisherQuery>;
export type ClaimPublisherLazyQueryHookResult = ReturnType<typeof useClaimPublisherLazyQuery>;
export type ClaimPublisherQueryResult = Apollo.QueryResult<ClaimPublisherQuery, ClaimPublisherQueryVariables>;
export const ClaimVerifyDocument = gql`
    query claimVerify($payload: String!) {
  claim {
    verify(payload: $payload) {
      href
      hash
      title
      email
      name
      organization {
        id
        name
        slug
      }
    }
  }
}
    `;

/**
 * __useClaimVerifyQuery__
 *
 * To run a query within a React component, call `useClaimVerifyQuery` and pass it any options that fit your needs.
 * When your component renders, `useClaimVerifyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClaimVerifyQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useClaimVerifyQuery(baseOptions: Apollo.QueryHookOptions<ClaimVerifyQuery, ClaimVerifyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClaimVerifyQuery, ClaimVerifyQueryVariables>(ClaimVerifyDocument, options);
      }
export function useClaimVerifyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClaimVerifyQuery, ClaimVerifyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClaimVerifyQuery, ClaimVerifyQueryVariables>(ClaimVerifyDocument, options);
        }
export type ClaimVerifyQueryHookResult = ReturnType<typeof useClaimVerifyQuery>;
export type ClaimVerifyLazyQueryHookResult = ReturnType<typeof useClaimVerifyLazyQuery>;
export type ClaimVerifyQueryResult = Apollo.QueryResult<ClaimVerifyQuery, ClaimVerifyQueryVariables>;
export const GetEpisodeHourlyDownloadsQueryDocument = gql`
    query getEpisodeHourlyDownloadsQuery($organizationId: ID!, $podcastId: ID!, $id: ID!, $algorithm: String, $after: String, $before: String, $kind: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      podcast(id: $podcastId) {
        id
        feed {
          id
          episode(id: $id) {
            id
            downloads(algorithm: $algorithm, before: $before, after: $after, kind: $kind) {
              count
              hourly {
                hour
                count
                downloadClass
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEpisodeHourlyDownloadsQueryQuery__
 *
 * To run a query within a React component, call `useGetEpisodeHourlyDownloadsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeHourlyDownloadsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeHourlyDownloadsQueryQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      podcastId: // value for 'podcastId'
 *      id: // value for 'id'
 *      algorithm: // value for 'algorithm'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useGetEpisodeHourlyDownloadsQueryQuery(baseOptions: Apollo.QueryHookOptions<GetEpisodeHourlyDownloadsQueryQuery, GetEpisodeHourlyDownloadsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEpisodeHourlyDownloadsQueryQuery, GetEpisodeHourlyDownloadsQueryQueryVariables>(GetEpisodeHourlyDownloadsQueryDocument, options);
      }
export function useGetEpisodeHourlyDownloadsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEpisodeHourlyDownloadsQueryQuery, GetEpisodeHourlyDownloadsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEpisodeHourlyDownloadsQueryQuery, GetEpisodeHourlyDownloadsQueryQueryVariables>(GetEpisodeHourlyDownloadsQueryDocument, options);
        }
export type GetEpisodeHourlyDownloadsQueryQueryHookResult = ReturnType<typeof useGetEpisodeHourlyDownloadsQueryQuery>;
export type GetEpisodeHourlyDownloadsQueryLazyQueryHookResult = ReturnType<typeof useGetEpisodeHourlyDownloadsQueryLazyQuery>;
export type GetEpisodeHourlyDownloadsQueryQueryResult = Apollo.QueryResult<GetEpisodeHourlyDownloadsQueryQuery, GetEpisodeHourlyDownloadsQueryQueryVariables>;
export const GetFutureEpisodeDocument = gql`
    query getFutureEpisode($organizationId: ID!, $podcastId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      podcast(id: $podcastId) {
        id
        futureEpisode(id: $id) {
          id
          title
          subtitle
          expectedPublished
        }
      }
    }
  }
}
    `;

/**
 * __useGetFutureEpisodeQuery__
 *
 * To run a query within a React component, call `useGetFutureEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFutureEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFutureEpisodeQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      podcastId: // value for 'podcastId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFutureEpisodeQuery(baseOptions: Apollo.QueryHookOptions<GetFutureEpisodeQuery, GetFutureEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFutureEpisodeQuery, GetFutureEpisodeQueryVariables>(GetFutureEpisodeDocument, options);
      }
export function useGetFutureEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFutureEpisodeQuery, GetFutureEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFutureEpisodeQuery, GetFutureEpisodeQueryVariables>(GetFutureEpisodeDocument, options);
        }
export type GetFutureEpisodeQueryHookResult = ReturnType<typeof useGetFutureEpisodeQuery>;
export type GetFutureEpisodeLazyQueryHookResult = ReturnType<typeof useGetFutureEpisodeLazyQuery>;
export type GetFutureEpisodeQueryResult = Apollo.QueryResult<GetFutureEpisodeQuery, GetFutureEpisodeQueryVariables>;
export const GetFutureEpisodesDocument = gql`
    query getFutureEpisodes($organizationId: ID!, $podcastId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      podcast(id: $podcastId) {
        id
        futureEpisodes {
          id
          title
          subtitle
          expectedPublished
        }
      }
    }
  }
}
    `;

/**
 * __useGetFutureEpisodesQuery__
 *
 * To run a query within a React component, call `useGetFutureEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFutureEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFutureEpisodesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      podcastId: // value for 'podcastId'
 *   },
 * });
 */
export function useGetFutureEpisodesQuery(baseOptions: Apollo.QueryHookOptions<GetFutureEpisodesQuery, GetFutureEpisodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFutureEpisodesQuery, GetFutureEpisodesQueryVariables>(GetFutureEpisodesDocument, options);
      }
export function useGetFutureEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFutureEpisodesQuery, GetFutureEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFutureEpisodesQuery, GetFutureEpisodesQueryVariables>(GetFutureEpisodesDocument, options);
        }
export type GetFutureEpisodesQueryHookResult = ReturnType<typeof useGetFutureEpisodesQuery>;
export type GetFutureEpisodesLazyQueryHookResult = ReturnType<typeof useGetFutureEpisodesLazyQuery>;
export type GetFutureEpisodesQueryResult = Apollo.QueryResult<GetFutureEpisodesQuery, GetFutureEpisodesQueryVariables>;
export const GetMeApprovalsDocument = gql`
    query getMeApprovals($state: String, $campaignId: ID) {
  me {
    id
    dynamicApprovals(state: $state, campaignId: $campaignId) {
      ...DynamicApproval
    }
    podcastApprovals(state: $state, campaignId: $campaignId) {
      ...PodcastApproval
    }
    streamingApprovals(state: $state, campaignId: $campaignId) {
      ...StreamingApproval
    }
  }
}
    ${DynamicApprovalFragmentDoc}
${PodcastApprovalFragmentDoc}
${StreamingApprovalFragmentDoc}`;

/**
 * __useGetMeApprovalsQuery__
 *
 * To run a query within a React component, call `useGetMeApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeApprovalsQuery({
 *   variables: {
 *      state: // value for 'state'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetMeApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<GetMeApprovalsQuery, GetMeApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeApprovalsQuery, GetMeApprovalsQueryVariables>(GetMeApprovalsDocument, options);
      }
export function useGetMeApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeApprovalsQuery, GetMeApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeApprovalsQuery, GetMeApprovalsQueryVariables>(GetMeApprovalsDocument, options);
        }
export type GetMeApprovalsQueryHookResult = ReturnType<typeof useGetMeApprovalsQuery>;
export type GetMeApprovalsLazyQueryHookResult = ReturnType<typeof useGetMeApprovalsLazyQuery>;
export type GetMeApprovalsQueryResult = Apollo.QueryResult<GetMeApprovalsQuery, GetMeApprovalsQueryVariables>;
export const GetMembersDocument = gql`
    query getMembers($id: ID!) {
  me {
    id
    organization(id: $id) {
      id
      isAdmin
      domains {
        id
        domain
        createdAt
      }
      memberships {
        id
        role
        roleDisplay
        createdAt
        user {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
}
    `;

/**
 * __useGetMembersQuery__
 *
 * To run a query within a React component, call `useGetMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMembersQuery(baseOptions: Apollo.QueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
      }
export function useGetMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
        }
export type GetMembersQueryHookResult = ReturnType<typeof useGetMembersQuery>;
export type GetMembersLazyQueryHookResult = ReturnType<typeof useGetMembersLazyQuery>;
export type GetMembersQueryResult = Apollo.QueryResult<GetMembersQuery, GetMembersQueryVariables>;
export const GetOrganizationArt19SecretDocument = gql`
    query getOrganizationArt19Secret($id: ID!) {
  me {
    id
    organization(id: $id) {
      id
      art19Secret
    }
  }
}
    `;

/**
 * __useGetOrganizationArt19SecretQuery__
 *
 * To run a query within a React component, call `useGetOrganizationArt19SecretQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationArt19SecretQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationArt19SecretQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationArt19SecretQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationArt19SecretQuery, GetOrganizationArt19SecretQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationArt19SecretQuery, GetOrganizationArt19SecretQueryVariables>(GetOrganizationArt19SecretDocument, options);
      }
export function useGetOrganizationArt19SecretLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationArt19SecretQuery, GetOrganizationArt19SecretQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationArt19SecretQuery, GetOrganizationArt19SecretQueryVariables>(GetOrganizationArt19SecretDocument, options);
        }
export type GetOrganizationArt19SecretQueryHookResult = ReturnType<typeof useGetOrganizationArt19SecretQuery>;
export type GetOrganizationArt19SecretLazyQueryHookResult = ReturnType<typeof useGetOrganizationArt19SecretLazyQuery>;
export type GetOrganizationArt19SecretQueryResult = Apollo.QueryResult<GetOrganizationArt19SecretQuery, GetOrganizationArt19SecretQueryVariables>;
export const OrganizationCampaignDebugQueryDocument = gql`
    query OrganizationCampaignDebugQuery($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        debug {
          events {
            hourly {
              hour
              action
              count
            }
          }
          pixel {
            historical {
              hour
              js {
                name
                eventCounts {
                  name
                  value
                }
              }
              mobile {
                name
                eventCounts {
                  name
                  value
                }
              }
              img {
                name
                eventCounts {
                  name
                  value
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrganizationCampaignDebugQueryQuery__
 *
 * To run a query within a React component, call `useOrganizationCampaignDebugQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationCampaignDebugQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationCampaignDebugQueryQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationCampaignDebugQueryQuery(baseOptions: Apollo.QueryHookOptions<OrganizationCampaignDebugQueryQuery, OrganizationCampaignDebugQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationCampaignDebugQueryQuery, OrganizationCampaignDebugQueryQueryVariables>(OrganizationCampaignDebugQueryDocument, options);
      }
export function useOrganizationCampaignDebugQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationCampaignDebugQueryQuery, OrganizationCampaignDebugQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationCampaignDebugQueryQuery, OrganizationCampaignDebugQueryQueryVariables>(OrganizationCampaignDebugQueryDocument, options);
        }
export type OrganizationCampaignDebugQueryQueryHookResult = ReturnType<typeof useOrganizationCampaignDebugQueryQuery>;
export type OrganizationCampaignDebugQueryLazyQueryHookResult = ReturnType<typeof useOrganizationCampaignDebugQueryLazyQuery>;
export type OrganizationCampaignDebugQueryQueryResult = Apollo.QueryResult<OrganizationCampaignDebugQueryQuery, OrganizationCampaignDebugQueryQueryVariables>;
export const OrganizationCampaignEpisodesQueryDocument = gql`
    query OrganizationCampaignEpisodesQuery($organizationId: ID!, $after: String, $before: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaignEpisodes(isFuture: true, after: $after, before: $before) {
        futureEpisode {
          id
          expectedPublished
        }
        goal
        campaignPodcast {
          id
          campaign {
            id
            name
            slug
          }
          feed {
            id
            title
            image {
              id
              href
              path
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrganizationCampaignEpisodesQueryQuery__
 *
 * To run a query within a React component, call `useOrganizationCampaignEpisodesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationCampaignEpisodesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationCampaignEpisodesQueryQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useOrganizationCampaignEpisodesQueryQuery(baseOptions: Apollo.QueryHookOptions<OrganizationCampaignEpisodesQueryQuery, OrganizationCampaignEpisodesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationCampaignEpisodesQueryQuery, OrganizationCampaignEpisodesQueryQueryVariables>(OrganizationCampaignEpisodesQueryDocument, options);
      }
export function useOrganizationCampaignEpisodesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationCampaignEpisodesQueryQuery, OrganizationCampaignEpisodesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationCampaignEpisodesQueryQuery, OrganizationCampaignEpisodesQueryQueryVariables>(OrganizationCampaignEpisodesQueryDocument, options);
        }
export type OrganizationCampaignEpisodesQueryQueryHookResult = ReturnType<typeof useOrganizationCampaignEpisodesQueryQuery>;
export type OrganizationCampaignEpisodesQueryLazyQueryHookResult = ReturnType<typeof useOrganizationCampaignEpisodesQueryLazyQuery>;
export type OrganizationCampaignEpisodesQueryQueryResult = Apollo.QueryResult<OrganizationCampaignEpisodesQueryQuery, OrganizationCampaignEpisodesQueryQueryVariables>;
export const OrganizationGenericTagsDocument = gql`
    query OrganizationGenericTags($id: ID!) {
  me {
    id
    organization(id: $id) {
      id
      genericTags {
        id
        title
        color
      }
    }
  }
}
    `;

/**
 * __useOrganizationGenericTagsQuery__
 *
 * To run a query within a React component, call `useOrganizationGenericTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationGenericTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationGenericTagsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrganizationGenericTagsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationGenericTagsQuery, OrganizationGenericTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationGenericTagsQuery, OrganizationGenericTagsQueryVariables>(OrganizationGenericTagsDocument, options);
      }
export function useOrganizationGenericTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationGenericTagsQuery, OrganizationGenericTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationGenericTagsQuery, OrganizationGenericTagsQueryVariables>(OrganizationGenericTagsDocument, options);
        }
export type OrganizationGenericTagsQueryHookResult = ReturnType<typeof useOrganizationGenericTagsQuery>;
export type OrganizationGenericTagsLazyQueryHookResult = ReturnType<typeof useOrganizationGenericTagsLazyQuery>;
export type OrganizationGenericTagsQueryResult = Apollo.QueryResult<OrganizationGenericTagsQuery, OrganizationGenericTagsQueryVariables>;
export const OrganizationKeyDebugHistoricalQueryDocument = gql`
    query OrganizationKeyDebugHistoricalQuery($organizationId: ID!, $key: ID!, $after: String!, $before: String!) {
  me {
    id
    organization(id: $organizationId) {
      id
      key(key: $key) {
        key
        debug {
          hasData
          historical(after: $after, before: $before) {
            hour
            js {
              name
              eventCounts {
                name
                value
              }
            }
            mobile {
              name
              eventCounts {
                name
                value
              }
            }
            img {
              name
              eventCounts {
                name
                value
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrganizationKeyDebugHistoricalQueryQuery__
 *
 * To run a query within a React component, call `useOrganizationKeyDebugHistoricalQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationKeyDebugHistoricalQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationKeyDebugHistoricalQueryQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      key: // value for 'key'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useOrganizationKeyDebugHistoricalQueryQuery(baseOptions: Apollo.QueryHookOptions<OrganizationKeyDebugHistoricalQueryQuery, OrganizationKeyDebugHistoricalQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationKeyDebugHistoricalQueryQuery, OrganizationKeyDebugHistoricalQueryQueryVariables>(OrganizationKeyDebugHistoricalQueryDocument, options);
      }
export function useOrganizationKeyDebugHistoricalQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationKeyDebugHistoricalQueryQuery, OrganizationKeyDebugHistoricalQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationKeyDebugHistoricalQueryQuery, OrganizationKeyDebugHistoricalQueryQueryVariables>(OrganizationKeyDebugHistoricalQueryDocument, options);
        }
export type OrganizationKeyDebugHistoricalQueryQueryHookResult = ReturnType<typeof useOrganizationKeyDebugHistoricalQueryQuery>;
export type OrganizationKeyDebugHistoricalQueryLazyQueryHookResult = ReturnType<typeof useOrganizationKeyDebugHistoricalQueryLazyQuery>;
export type OrganizationKeyDebugHistoricalQueryQueryResult = Apollo.QueryResult<OrganizationKeyDebugHistoricalQueryQuery, OrganizationKeyDebugHistoricalQueryQueryVariables>;
export const OrganizationKeyDebugNodesQueryDocument = gql`
    query OrganizationKeyDebugNodesQuery($organizationId: ID!, $key: ID!, $action: String, $showMobileOnly: Boolean) {
  me {
    id
    organization(id: $organizationId) {
      id
      key(key: $key) {
        key
        domain
        createdAt
        debug {
          query(action: $action, showMobileOnly: $showMobileOnly) {
            count
            nodes {
              key
              time
              action
              referrer
              referrerPath
              url
              urlPath
              urlDomain
              userAgent {
                os {
                  family
                }
                device {
                  family
                }
              }
              value
              currency
              productId
              productName
              productType
              productVendor
              discountCode
              newCustomer
              orderId
              quantity
              lineItems
              type
              category
              alias
              eventName
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrganizationKeyDebugNodesQueryQuery__
 *
 * To run a query within a React component, call `useOrganizationKeyDebugNodesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationKeyDebugNodesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationKeyDebugNodesQueryQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      key: // value for 'key'
 *      action: // value for 'action'
 *      showMobileOnly: // value for 'showMobileOnly'
 *   },
 * });
 */
export function useOrganizationKeyDebugNodesQueryQuery(baseOptions: Apollo.QueryHookOptions<OrganizationKeyDebugNodesQueryQuery, OrganizationKeyDebugNodesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationKeyDebugNodesQueryQuery, OrganizationKeyDebugNodesQueryQueryVariables>(OrganizationKeyDebugNodesQueryDocument, options);
      }
export function useOrganizationKeyDebugNodesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationKeyDebugNodesQueryQuery, OrganizationKeyDebugNodesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationKeyDebugNodesQueryQuery, OrganizationKeyDebugNodesQueryQueryVariables>(OrganizationKeyDebugNodesQueryDocument, options);
        }
export type OrganizationKeyDebugNodesQueryQueryHookResult = ReturnType<typeof useOrganizationKeyDebugNodesQueryQuery>;
export type OrganizationKeyDebugNodesQueryLazyQueryHookResult = ReturnType<typeof useOrganizationKeyDebugNodesQueryLazyQuery>;
export type OrganizationKeyDebugNodesQueryQueryResult = Apollo.QueryResult<OrganizationKeyDebugNodesQueryQuery, OrganizationKeyDebugNodesQueryQueryVariables>;
export const OrganizationKeyQueryDocument = gql`
    query OrganizationKeyQuery($organizationId: ID!, $key: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      key(key: $key) {
        key
        domain
        createdAt
        alias
        installations
        conversionUrls {
          id
          url
          action
          value
          type
          category
        }
        actionMaps {
          id
          eventName
          action
        }
        debug {
          hasData
        }
        pixelEventRecords {
          id
          name
          eventType
          installation
          lastUpdatedBy {
            id
            firstName
            lastName
          }
          createdAt
          lastActivity
          lastActivityFlag
          category
          currency
          type
          discountCode
          newCustomer
          orderId
          value
          quantity
          productId
          productName
          productType
          productVendor
          variantId
          variantName
        }
      }
    }
  }
}
    `;

/**
 * __useOrganizationKeyQueryQuery__
 *
 * To run a query within a React component, call `useOrganizationKeyQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationKeyQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationKeyQueryQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useOrganizationKeyQueryQuery(baseOptions: Apollo.QueryHookOptions<OrganizationKeyQueryQuery, OrganizationKeyQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationKeyQueryQuery, OrganizationKeyQueryQueryVariables>(OrganizationKeyQueryDocument, options);
      }
export function useOrganizationKeyQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationKeyQueryQuery, OrganizationKeyQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationKeyQueryQuery, OrganizationKeyQueryQueryVariables>(OrganizationKeyQueryDocument, options);
        }
export type OrganizationKeyQueryQueryHookResult = ReturnType<typeof useOrganizationKeyQueryQuery>;
export type OrganizationKeyQueryLazyQueryHookResult = ReturnType<typeof useOrganizationKeyQueryLazyQuery>;
export type OrganizationKeyQueryQueryResult = Apollo.QueryResult<OrganizationKeyQueryQuery, OrganizationKeyQueryQueryVariables>;
export const OrganizationOverviewBrandQueryDocument = gql`
    query OrganizationOverviewBrandQuery($after: Date!, $before: Date!, $id: ID!, $interval: String, $spendByImpressions: Boolean) {
  me {
    id
    organization(id: $id) {
      id
      overview {
        brand(
          after: $after
          before: $before
          interval: $interval
          spendByImpressions: $spendByImpressions
        ) {
          count
          nodes {
            attributedDownloads
            attributedDownloadsModeled
            attributedReach
            attributedReachModeled
            campaignDynamicId
            campaignId
            campaignKind
            campaignName
            code
            episodeId
            episodeTitle
            feedId
            households
            householdsModeled
            impressions
            installed
            installedModeled
            leads
            leadsModeled
            lineItemName
            podcastTitle
            published
            publisherName
            purchases
            purchasesModeled
            reach
            spend
            time
            value
            valueModeled
            views
            viewsModeled
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrganizationOverviewBrandQueryQuery__
 *
 * To run a query within a React component, call `useOrganizationOverviewBrandQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationOverviewBrandQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationOverviewBrandQueryQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      id: // value for 'id'
 *      interval: // value for 'interval'
 *      spendByImpressions: // value for 'spendByImpressions'
 *   },
 * });
 */
export function useOrganizationOverviewBrandQueryQuery(baseOptions: Apollo.QueryHookOptions<OrganizationOverviewBrandQueryQuery, OrganizationOverviewBrandQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationOverviewBrandQueryQuery, OrganizationOverviewBrandQueryQueryVariables>(OrganizationOverviewBrandQueryDocument, options);
      }
export function useOrganizationOverviewBrandQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationOverviewBrandQueryQuery, OrganizationOverviewBrandQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationOverviewBrandQueryQuery, OrganizationOverviewBrandQueryQueryVariables>(OrganizationOverviewBrandQueryDocument, options);
        }
export type OrganizationOverviewBrandQueryQueryHookResult = ReturnType<typeof useOrganizationOverviewBrandQueryQuery>;
export type OrganizationOverviewBrandQueryLazyQueryHookResult = ReturnType<typeof useOrganizationOverviewBrandQueryLazyQuery>;
export type OrganizationOverviewBrandQueryQueryResult = Apollo.QueryResult<OrganizationOverviewBrandQueryQuery, OrganizationOverviewBrandQueryQueryVariables>;
export const OrganizationDocument = gql`
    query Organization($slug: String!) {
  me {
    id
    hasSeenAdAnalyticsWelcome
    adAnalyticsTutorialProgress
    organization(slug: $slug) {
      id
      isLockedForTerms
      name
      slug
      kind
      mode
      downloadAlgorithm
      dynamicProvider
      streamingProvider
      showTerms
      showTermsReminder
      hasActivePixel
      isNielsenApproved
      isExperianApproved
      isSegmentsEnabled
      isAdvisor
      isManager
      meRole
      createdAt
      campaignsCount
      podcastsCount
      adStudioBusinessId
      linkingRequestState
      keys {
        key
        role
        domain
        alias
        createdAt
        installations
        pixelEventRecords {
          id
          name
        }
      }
      companies {
        id
        slug
        name
        description
        url
        image {
          id
          width
          height
          src
          path
        }
        hasCampaigns
      }
      claims {
        id
        state
        company {
          id
          name
        }
        createdAt
      }
      managers {
        id
        name
        slug
        kind
      }
      managing {
        id
        name
        slug
        kind
      }
    }
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const OrganizationResearchReviewersDocument = gql`
    query OrganizationResearchReviewers($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        reviewers {
          id
          firstName
          lastName
          email
          type
          createdAt
          reviewsCount
        }
      }
    }
  }
}
    `;

/**
 * __useOrganizationResearchReviewersQuery__
 *
 * To run a query within a React component, call `useOrganizationResearchReviewersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationResearchReviewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationResearchReviewersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationResearchReviewersQuery(baseOptions: Apollo.QueryHookOptions<OrganizationResearchReviewersQuery, OrganizationResearchReviewersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationResearchReviewersQuery, OrganizationResearchReviewersQueryVariables>(OrganizationResearchReviewersDocument, options);
      }
export function useOrganizationResearchReviewersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationResearchReviewersQuery, OrganizationResearchReviewersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationResearchReviewersQuery, OrganizationResearchReviewersQueryVariables>(OrganizationResearchReviewersDocument, options);
        }
export type OrganizationResearchReviewersQueryHookResult = ReturnType<typeof useOrganizationResearchReviewersQuery>;
export type OrganizationResearchReviewersLazyQueryHookResult = ReturnType<typeof useOrganizationResearchReviewersLazyQuery>;
export type OrganizationResearchReviewersQueryResult = Apollo.QueryResult<OrganizationResearchReviewersQuery, OrganizationResearchReviewersQueryVariables>;
export const GetPodcastHourlyDownloadsDocument = gql`
    query getPodcastHourlyDownloads($organizationId: ID!, $id: ID!, $after: String, $before: String, $kind: String, $algorithm: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      podcast(id: $id) {
        id
        downloads(algorithm: $algorithm, before: $before, after: $after, kind: $kind) {
          count
          hourly {
            hour
            count
            downloadClass
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPodcastHourlyDownloadsQuery__
 *
 * To run a query within a React component, call `useGetPodcastHourlyDownloadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPodcastHourlyDownloadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPodcastHourlyDownloadsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      kind: // value for 'kind'
 *      algorithm: // value for 'algorithm'
 *   },
 * });
 */
export function useGetPodcastHourlyDownloadsQuery(baseOptions: Apollo.QueryHookOptions<GetPodcastHourlyDownloadsQuery, GetPodcastHourlyDownloadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPodcastHourlyDownloadsQuery, GetPodcastHourlyDownloadsQueryVariables>(GetPodcastHourlyDownloadsDocument, options);
      }
export function useGetPodcastHourlyDownloadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPodcastHourlyDownloadsQuery, GetPodcastHourlyDownloadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPodcastHourlyDownloadsQuery, GetPodcastHourlyDownloadsQueryVariables>(GetPodcastHourlyDownloadsDocument, options);
        }
export type GetPodcastHourlyDownloadsQueryHookResult = ReturnType<typeof useGetPodcastHourlyDownloadsQuery>;
export type GetPodcastHourlyDownloadsLazyQueryHookResult = ReturnType<typeof useGetPodcastHourlyDownloadsLazyQuery>;
export type GetPodcastHourlyDownloadsQueryResult = Apollo.QueryResult<GetPodcastHourlyDownloadsQuery, GetPodcastHourlyDownloadsQueryVariables>;
export const GetPodcastDocument = gql`
    query getPodcast($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      podcast(id: $id) {
        id
        createdAt
        processingStartedAt
        feed {
          id
          title
          subtitle
          summary
          segmentOverlap
          description(words: 50)
          href
          image {
            id
            href
            path
          }
          episodesCount
          isExperianApproved
          isNielsenApproved
        }
      }
    }
  }
}
    `;

/**
 * __useGetPodcastQuery__
 *
 * To run a query within a React component, call `useGetPodcastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPodcastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPodcastQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPodcastQuery(baseOptions: Apollo.QueryHookOptions<GetPodcastQuery, GetPodcastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPodcastQuery, GetPodcastQueryVariables>(GetPodcastDocument, options);
      }
export function useGetPodcastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPodcastQuery, GetPodcastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPodcastQuery, GetPodcastQueryVariables>(GetPodcastDocument, options);
        }
export type GetPodcastQueryHookResult = ReturnType<typeof useGetPodcastQuery>;
export type GetPodcastLazyQueryHookResult = ReturnType<typeof useGetPodcastLazyQuery>;
export type GetPodcastQueryResult = Apollo.QueryResult<GetPodcastQuery, GetPodcastQueryVariables>;
export const GetPaginatedPodcasterCampaignEpisodesNodesDocument = gql`
    query getPaginatedPodcasterCampaignEpisodesNodes($organizationId: ID!, $podcastId: ID!, $campaignId: ID, $offset: Int, $limit: Int, $query: String, $orderBy: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      podcast(id: $podcastId, campaignId: $campaignId) {
        id
        feed {
          id
          title
          episodeNodes(offset: $offset, limit: $limit, query: $query, orderBy: $orderBy) {
            offset
            pages
            count
            hasNext
            hasPrev
            nodes {
              id
              title
              published
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaginatedPodcasterCampaignEpisodesNodesQuery__
 *
 * To run a query within a React component, call `useGetPaginatedPodcasterCampaignEpisodesNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedPodcasterCampaignEpisodesNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedPodcasterCampaignEpisodesNodesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      podcastId: // value for 'podcastId'
 *      campaignId: // value for 'campaignId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetPaginatedPodcasterCampaignEpisodesNodesQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedPodcasterCampaignEpisodesNodesQuery, GetPaginatedPodcasterCampaignEpisodesNodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedPodcasterCampaignEpisodesNodesQuery, GetPaginatedPodcasterCampaignEpisodesNodesQueryVariables>(GetPaginatedPodcasterCampaignEpisodesNodesDocument, options);
      }
export function useGetPaginatedPodcasterCampaignEpisodesNodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedPodcasterCampaignEpisodesNodesQuery, GetPaginatedPodcasterCampaignEpisodesNodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedPodcasterCampaignEpisodesNodesQuery, GetPaginatedPodcasterCampaignEpisodesNodesQueryVariables>(GetPaginatedPodcasterCampaignEpisodesNodesDocument, options);
        }
export type GetPaginatedPodcasterCampaignEpisodesNodesQueryHookResult = ReturnType<typeof useGetPaginatedPodcasterCampaignEpisodesNodesQuery>;
export type GetPaginatedPodcasterCampaignEpisodesNodesLazyQueryHookResult = ReturnType<typeof useGetPaginatedPodcasterCampaignEpisodesNodesLazyQuery>;
export type GetPaginatedPodcasterCampaignEpisodesNodesQueryResult = Apollo.QueryResult<GetPaginatedPodcasterCampaignEpisodesNodesQuery, GetPaginatedPodcasterCampaignEpisodesNodesQueryVariables>;
export const GetPodcasterCampaignEpisodeDocument = gql`
    query getPodcasterCampaignEpisode($organizationId: ID!, $campaignId: ID!, $campaignPodcastId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignPodcast(id: $campaignPodcastId) {
          id
          feed {
            id
            isMegaphone
            isArt19
          }
        }
        campaignEpisode(id: $id) {
          id
          goal
          cost
          startAt
          endAt
          futureEpisode {
            id
            title
            subtitle
            expectedPublished
            closeEpisodes(excludeCampaignId: $campaignId) {
              id
              title
              description(words: 25)
              image {
                id
                href
                path
              }
              published
              placements {
                id
                startTime
                endTime
                ad {
                  id
                  duration
                  company {
                    id
                    name
                  }
                }
              }
            }
            closeInCampaignEpisodes(campaignId: $campaignId) {
              id
              title
              description(words: 25)
              image {
                id
                href
                path
              }
              published
              placements {
                id
                startTime
                endTime
                ad {
                  id
                  duration
                  company {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPodcasterCampaignEpisodeQuery__
 *
 * To run a query within a React component, call `useGetPodcasterCampaignEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPodcasterCampaignEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPodcasterCampaignEpisodeQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      campaignPodcastId: // value for 'campaignPodcastId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPodcasterCampaignEpisodeQuery(baseOptions: Apollo.QueryHookOptions<GetPodcasterCampaignEpisodeQuery, GetPodcasterCampaignEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPodcasterCampaignEpisodeQuery, GetPodcasterCampaignEpisodeQueryVariables>(GetPodcasterCampaignEpisodeDocument, options);
      }
export function useGetPodcasterCampaignEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPodcasterCampaignEpisodeQuery, GetPodcasterCampaignEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPodcasterCampaignEpisodeQuery, GetPodcasterCampaignEpisodeQueryVariables>(GetPodcasterCampaignEpisodeDocument, options);
        }
export type GetPodcasterCampaignEpisodeQueryHookResult = ReturnType<typeof useGetPodcasterCampaignEpisodeQuery>;
export type GetPodcasterCampaignEpisodeLazyQueryHookResult = ReturnType<typeof useGetPodcasterCampaignEpisodeLazyQuery>;
export type GetPodcasterCampaignEpisodeQueryResult = Apollo.QueryResult<GetPodcasterCampaignEpisodeQuery, GetPodcasterCampaignEpisodeQueryVariables>;
export const GetPaginatedPodcasterCampaignFutureEpisodesNodesDocument = gql`
    query getPaginatedPodcasterCampaignFutureEpisodesNodes($organizationId: ID!, $podcastId: ID!, $campaignId: ID, $offset: Int, $limit: Int, $query: String, $orderBy: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      podcast(id: $podcastId, campaignId: $campaignId) {
        id
        futureEpisodeNodes(
          offset: $offset
          limit: $limit
          query: $query
          orderBy: $orderBy
        ) {
          offset
          pages
          count
          hasNext
          hasPrev
          nodes {
            id
            title
            expectedPublished
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaginatedPodcasterCampaignFutureEpisodesNodesQuery__
 *
 * To run a query within a React component, call `useGetPaginatedPodcasterCampaignFutureEpisodesNodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedPodcasterCampaignFutureEpisodesNodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedPodcasterCampaignFutureEpisodesNodesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      podcastId: // value for 'podcastId'
 *      campaignId: // value for 'campaignId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetPaginatedPodcasterCampaignFutureEpisodesNodesQuery(baseOptions: Apollo.QueryHookOptions<GetPaginatedPodcasterCampaignFutureEpisodesNodesQuery, GetPaginatedPodcasterCampaignFutureEpisodesNodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaginatedPodcasterCampaignFutureEpisodesNodesQuery, GetPaginatedPodcasterCampaignFutureEpisodesNodesQueryVariables>(GetPaginatedPodcasterCampaignFutureEpisodesNodesDocument, options);
      }
export function useGetPaginatedPodcasterCampaignFutureEpisodesNodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaginatedPodcasterCampaignFutureEpisodesNodesQuery, GetPaginatedPodcasterCampaignFutureEpisodesNodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaginatedPodcasterCampaignFutureEpisodesNodesQuery, GetPaginatedPodcasterCampaignFutureEpisodesNodesQueryVariables>(GetPaginatedPodcasterCampaignFutureEpisodesNodesDocument, options);
        }
export type GetPaginatedPodcasterCampaignFutureEpisodesNodesQueryHookResult = ReturnType<typeof useGetPaginatedPodcasterCampaignFutureEpisodesNodesQuery>;
export type GetPaginatedPodcasterCampaignFutureEpisodesNodesLazyQueryHookResult = ReturnType<typeof useGetPaginatedPodcasterCampaignFutureEpisodesNodesLazyQuery>;
export type GetPaginatedPodcasterCampaignFutureEpisodesNodesQueryResult = Apollo.QueryResult<GetPaginatedPodcasterCampaignFutureEpisodesNodesQuery, GetPaginatedPodcasterCampaignFutureEpisodesNodesQueryVariables>;
export const GetPodcasterEpisodeDocument = gql`
    query getPodcasterEpisode($organizationId: ID!, $podcastId: ID!, $id: ID!, $algorithm: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      podcast(id: $podcastId) {
        id
        feed {
          id
          episode(id: $id) {
            id
            title
            subtitle
            summary
            description(words: 50)
            published
            reviewed
            hasNoAds
            image {
              id
              href
              path
            }
            feed {
              id
              image {
                id
                path
              }
            }
            placementsCount
            placements {
              id
              startTime
              endTime
              ad {
                id
                mpegPath
                flacPath
                waveform
                words
                text
                duration
                state
                company {
                  id
                  name
                }
                product {
                  id
                  name
                }
                sponsor {
                  id
                  name
                }
              }
            }
            downloads(algorithm: $algorithm) {
              count
            }
            enclosure {
              id
              length
              duration
              mpegPath
              waveform
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPodcasterEpisodeQuery__
 *
 * To run a query within a React component, call `useGetPodcasterEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPodcasterEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPodcasterEpisodeQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      podcastId: // value for 'podcastId'
 *      id: // value for 'id'
 *      algorithm: // value for 'algorithm'
 *   },
 * });
 */
export function useGetPodcasterEpisodeQuery(baseOptions: Apollo.QueryHookOptions<GetPodcasterEpisodeQuery, GetPodcasterEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPodcasterEpisodeQuery, GetPodcasterEpisodeQueryVariables>(GetPodcasterEpisodeDocument, options);
      }
export function useGetPodcasterEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPodcasterEpisodeQuery, GetPodcasterEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPodcasterEpisodeQuery, GetPodcasterEpisodeQueryVariables>(GetPodcasterEpisodeDocument, options);
        }
export type GetPodcasterEpisodeQueryHookResult = ReturnType<typeof useGetPodcasterEpisodeQuery>;
export type GetPodcasterEpisodeLazyQueryHookResult = ReturnType<typeof useGetPodcasterEpisodeLazyQuery>;
export type GetPodcasterEpisodeQueryResult = Apollo.QueryResult<GetPodcasterEpisodeQuery, GetPodcasterEpisodeQueryVariables>;
export const PodcasterPodcastsQueryDocument = gql`
    query podcasterPodcastsQuery($id: ID!, $campaignId: ID) {
  me {
    id
    organization(id: $id) {
      id
      podcasts(campaignId: $campaignId) {
        ...Podcast
      }
    }
  }
}
    ${PodcastFragmentDoc}`;

/**
 * __usePodcasterPodcastsQueryQuery__
 *
 * To run a query within a React component, call `usePodcasterPodcastsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcasterPodcastsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcasterPodcastsQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function usePodcasterPodcastsQueryQuery(baseOptions: Apollo.QueryHookOptions<PodcasterPodcastsQueryQuery, PodcasterPodcastsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcasterPodcastsQueryQuery, PodcasterPodcastsQueryQueryVariables>(PodcasterPodcastsQueryDocument, options);
      }
export function usePodcasterPodcastsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcasterPodcastsQueryQuery, PodcasterPodcastsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcasterPodcastsQueryQuery, PodcasterPodcastsQueryQueryVariables>(PodcasterPodcastsQueryDocument, options);
        }
export type PodcasterPodcastsQueryQueryHookResult = ReturnType<typeof usePodcasterPodcastsQueryQuery>;
export type PodcasterPodcastsQueryLazyQueryHookResult = ReturnType<typeof usePodcasterPodcastsQueryLazyQuery>;
export type PodcasterPodcastsQueryQueryResult = Apollo.QueryResult<PodcasterPodcastsQueryQuery, PodcasterPodcastsQueryQueryVariables>;
export const GetUserAccessDetailDocument = gql`
    query getUserAccessDetail($organizationId: ID!, $membershipId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      member(membershipId: $membershipId) {
        id
        firstName
        lastName
        email
      }
      memberAccess(membershipId: $membershipId) {
        ...UserAccess
      }
      campaigns {
        results {
          id
          name
          advertiser {
            id
            name
          }
        }
      }
    }
  }
}
    ${UserAccessFragmentDoc}`;

/**
 * __useGetUserAccessDetailQuery__
 *
 * To run a query within a React component, call `useGetUserAccessDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserAccessDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserAccessDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      membershipId: // value for 'membershipId'
 *   },
 * });
 */
export function useGetUserAccessDetailQuery(baseOptions: Apollo.QueryHookOptions<GetUserAccessDetailQuery, GetUserAccessDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserAccessDetailQuery, GetUserAccessDetailQueryVariables>(GetUserAccessDetailDocument, options);
      }
export function useGetUserAccessDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserAccessDetailQuery, GetUserAccessDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserAccessDetailQuery, GetUserAccessDetailQueryVariables>(GetUserAccessDetailDocument, options);
        }
export type GetUserAccessDetailQueryHookResult = ReturnType<typeof useGetUserAccessDetailQuery>;
export type GetUserAccessDetailLazyQueryHookResult = ReturnType<typeof useGetUserAccessDetailLazyQuery>;
export type GetUserAccessDetailQueryResult = Apollo.QueryResult<GetUserAccessDetailQuery, GetUserAccessDetailQueryVariables>;
export const GetBrandAdDocument = gql`
    query getBrandAd($organizationId: ID!, $feedId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      limitedCompany(id: $id) {
        id
        ads(feedId: $feedId, limit: 1) {
          id
          mpegPath
          waveform
          createdAt
          duration
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandAdQuery__
 *
 * To run a query within a React component, call `useGetBrandAdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandAdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandAdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      feedId: // value for 'feedId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBrandAdQuery(baseOptions: Apollo.QueryHookOptions<GetBrandAdQuery, GetBrandAdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandAdQuery, GetBrandAdQueryVariables>(GetBrandAdDocument, options);
      }
export function useGetBrandAdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandAdQuery, GetBrandAdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandAdQuery, GetBrandAdQueryVariables>(GetBrandAdDocument, options);
        }
export type GetBrandAdQueryHookResult = ReturnType<typeof useGetBrandAdQuery>;
export type GetBrandAdLazyQueryHookResult = ReturnType<typeof useGetBrandAdLazyQuery>;
export type GetBrandAdQueryResult = Apollo.QueryResult<GetBrandAdQuery, GetBrandAdQueryVariables>;
export const GetAdvisorDataDocument = gql`
    query getAdvisorData($columns: [String]!, $filters: [AdvisorFilter], $includeTestData: Boolean!, $limit: Int!, $offset: Int!, $organizationId: ID!, $query: String!, $sort: [String]!) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        results(
          query: {columns: $columns, filters: $filters, includeTestData: $includeTestData, limit: $limit, offset: $offset, query: $query, sort: $sort}
        ) {
          limit
          offset
          count
          rows {
            id
            feed {
              id
              title
              subtitle
              summary
              href
              image {
                href
                id
                path
              }
            }
            cells {
              id
              values {
                type
                value
                filterId
                objectId
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAdvisorDataQuery__
 *
 * To run a query within a React component, call `useGetAdvisorDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvisorDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvisorDataQuery({
 *   variables: {
 *      columns: // value for 'columns'
 *      filters: // value for 'filters'
 *      includeTestData: // value for 'includeTestData'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      organizationId: // value for 'organizationId'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAdvisorDataQuery(baseOptions: Apollo.QueryHookOptions<GetAdvisorDataQuery, GetAdvisorDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvisorDataQuery, GetAdvisorDataQueryVariables>(GetAdvisorDataDocument, options);
      }
export function useGetAdvisorDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvisorDataQuery, GetAdvisorDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvisorDataQuery, GetAdvisorDataQueryVariables>(GetAdvisorDataDocument, options);
        }
export type GetAdvisorDataQueryHookResult = ReturnType<typeof useGetAdvisorDataQuery>;
export type GetAdvisorDataLazyQueryHookResult = ReturnType<typeof useGetAdvisorDataLazyQuery>;
export type GetAdvisorDataQueryResult = Apollo.QueryResult<GetAdvisorDataQuery, GetAdvisorDataQueryVariables>;
export const AdvisorPodcastBrandsDocument = gql`
    query AdvisorPodcastBrands($organizationId: ID!, $id: ID!, $limit: Int, $offset: Int, $query: String, $after: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        show(id: $id) {
          id
          adPlacements(q: "", limit: 100, sort: "-published", after: $after) {
            count
            rows {
              brand {
                id
                name
              }
              episode {
                published
              }
            }
          }
          topBrands(q: $query, sort: "-adCount", limit: $limit, offset: $offset) {
            offset
            limit
            count
            rows {
              adCount
              episodeCount
              brand {
                id
                name
                industry
                industryDisplay
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdvisorPodcastBrandsQuery__
 *
 * To run a query within a React component, call `useAdvisorPodcastBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvisorPodcastBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvisorPodcastBrandsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAdvisorPodcastBrandsQuery(baseOptions: Apollo.QueryHookOptions<AdvisorPodcastBrandsQuery, AdvisorPodcastBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvisorPodcastBrandsQuery, AdvisorPodcastBrandsQueryVariables>(AdvisorPodcastBrandsDocument, options);
      }
export function useAdvisorPodcastBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvisorPodcastBrandsQuery, AdvisorPodcastBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvisorPodcastBrandsQuery, AdvisorPodcastBrandsQueryVariables>(AdvisorPodcastBrandsDocument, options);
        }
export type AdvisorPodcastBrandsQueryHookResult = ReturnType<typeof useAdvisorPodcastBrandsQuery>;
export type AdvisorPodcastBrandsLazyQueryHookResult = ReturnType<typeof useAdvisorPodcastBrandsLazyQuery>;
export type AdvisorPodcastBrandsQueryResult = Apollo.QueryResult<AdvisorPodcastBrandsQuery, AdvisorPodcastBrandsQueryVariables>;
export const GetAdvisorPodcastEpisodeDetailDocument = gql`
    query getAdvisorPodcastEpisodeDetail($organizationId: ID!, $feedId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        show(id: $feedId) {
          id
          feed {
            id
            episode(id: $id) {
              id
              title
              enclosure {
                id
                episodeId
                href
                type
                duration
                length
                mpegPath
                waveform
              }
              placements {
                id
                startTime
                endTime
                ad {
                  id
                  mpegPath
                  flacPath
                  waveform
                  duration
                  company {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAdvisorPodcastEpisodeDetailQuery__
 *
 * To run a query within a React component, call `useGetAdvisorPodcastEpisodeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvisorPodcastEpisodeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvisorPodcastEpisodeDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      feedId: // value for 'feedId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdvisorPodcastEpisodeDetailQuery(baseOptions: Apollo.QueryHookOptions<GetAdvisorPodcastEpisodeDetailQuery, GetAdvisorPodcastEpisodeDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvisorPodcastEpisodeDetailQuery, GetAdvisorPodcastEpisodeDetailQueryVariables>(GetAdvisorPodcastEpisodeDetailDocument, options);
      }
export function useGetAdvisorPodcastEpisodeDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvisorPodcastEpisodeDetailQuery, GetAdvisorPodcastEpisodeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvisorPodcastEpisodeDetailQuery, GetAdvisorPodcastEpisodeDetailQueryVariables>(GetAdvisorPodcastEpisodeDetailDocument, options);
        }
export type GetAdvisorPodcastEpisodeDetailQueryHookResult = ReturnType<typeof useGetAdvisorPodcastEpisodeDetailQuery>;
export type GetAdvisorPodcastEpisodeDetailLazyQueryHookResult = ReturnType<typeof useGetAdvisorPodcastEpisodeDetailLazyQuery>;
export type GetAdvisorPodcastEpisodeDetailQueryResult = Apollo.QueryResult<GetAdvisorPodcastEpisodeDetailQuery, GetAdvisorPodcastEpisodeDetailQueryVariables>;
export const GetAdvisorPodcastEpisodesDocument = gql`
    query getAdvisorPodcastEpisodes($organizationId: ID!, $id: ID!, $limit: Int) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        show(id: $id) {
          id
          feed {
            id
            episodes(limit: $limit) {
              id
              title
              description
              published
              placementsCount
              enclosure {
                id
                duration
              }
              image {
                id
                href
                path
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAdvisorPodcastEpisodesQuery__
 *
 * To run a query within a React component, call `useGetAdvisorPodcastEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvisorPodcastEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvisorPodcastEpisodesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAdvisorPodcastEpisodesQuery(baseOptions: Apollo.QueryHookOptions<GetAdvisorPodcastEpisodesQuery, GetAdvisorPodcastEpisodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvisorPodcastEpisodesQuery, GetAdvisorPodcastEpisodesQueryVariables>(GetAdvisorPodcastEpisodesDocument, options);
      }
export function useGetAdvisorPodcastEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvisorPodcastEpisodesQuery, GetAdvisorPodcastEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvisorPodcastEpisodesQuery, GetAdvisorPodcastEpisodesQueryVariables>(GetAdvisorPodcastEpisodesDocument, options);
        }
export type GetAdvisorPodcastEpisodesQueryHookResult = ReturnType<typeof useGetAdvisorPodcastEpisodesQuery>;
export type GetAdvisorPodcastEpisodesLazyQueryHookResult = ReturnType<typeof useGetAdvisorPodcastEpisodesLazyQuery>;
export type GetAdvisorPodcastEpisodesQueryResult = Apollo.QueryResult<GetAdvisorPodcastEpisodesQuery, GetAdvisorPodcastEpisodesQueryVariables>;
export const AdvisorPodcastIndustriesDocument = gql`
    query AdvisorPodcastIndustries($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        show(id: $id) {
          id
          industriesOverview(q: "", sort: "-adCount") {
            adCount
            episodeCount
            industry
            percent
            totalAds
          }
          topBrands(q: "", sort: "-adCount", limit: 100) {
            rows {
              adCount
              episodeCount
              brand {
                id
                name
                industry
                industryDisplay
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdvisorPodcastIndustriesQuery__
 *
 * To run a query within a React component, call `useAdvisorPodcastIndustriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvisorPodcastIndustriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvisorPodcastIndustriesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdvisorPodcastIndustriesQuery(baseOptions: Apollo.QueryHookOptions<AdvisorPodcastIndustriesQuery, AdvisorPodcastIndustriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvisorPodcastIndustriesQuery, AdvisorPodcastIndustriesQueryVariables>(AdvisorPodcastIndustriesDocument, options);
      }
export function useAdvisorPodcastIndustriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvisorPodcastIndustriesQuery, AdvisorPodcastIndustriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvisorPodcastIndustriesQuery, AdvisorPodcastIndustriesQueryVariables>(AdvisorPodcastIndustriesDocument, options);
        }
export type AdvisorPodcastIndustriesQueryHookResult = ReturnType<typeof useAdvisorPodcastIndustriesQuery>;
export type AdvisorPodcastIndustriesLazyQueryHookResult = ReturnType<typeof useAdvisorPodcastIndustriesLazyQuery>;
export type AdvisorPodcastIndustriesQueryResult = Apollo.QueryResult<AdvisorPodcastIndustriesQuery, AdvisorPodcastIndustriesQueryVariables>;
export const GetPodcastSamePublisherDocument = gql`
    query getPodcastSamePublisher($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        show(id: $id) {
          id
          samePublisher(limit: 6) {
            id
            title
            summary
            image {
              id
              href
              path
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPodcastSamePublisherQuery__
 *
 * To run a query within a React component, call `useGetPodcastSamePublisherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPodcastSamePublisherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPodcastSamePublisherQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPodcastSamePublisherQuery(baseOptions: Apollo.QueryHookOptions<GetPodcastSamePublisherQuery, GetPodcastSamePublisherQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPodcastSamePublisherQuery, GetPodcastSamePublisherQueryVariables>(GetPodcastSamePublisherDocument, options);
      }
export function useGetPodcastSamePublisherLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPodcastSamePublisherQuery, GetPodcastSamePublisherQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPodcastSamePublisherQuery, GetPodcastSamePublisherQueryVariables>(GetPodcastSamePublisherDocument, options);
        }
export type GetPodcastSamePublisherQueryHookResult = ReturnType<typeof useGetPodcastSamePublisherQuery>;
export type GetPodcastSamePublisherLazyQueryHookResult = ReturnType<typeof useGetPodcastSamePublisherLazyQuery>;
export type GetPodcastSamePublisherQueryResult = Apollo.QueryResult<GetPodcastSamePublisherQuery, GetPodcastSamePublisherQueryVariables>;
export const GetPodcastSimilarAudienceDocument = gql`
    query getPodcastSimilarAudience($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        show(id: $id) {
          id
          similarAudiences(limit: 6) {
            id
            title
            summary
            image {
              id
              href
              path
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPodcastSimilarAudienceQuery__
 *
 * To run a query within a React component, call `useGetPodcastSimilarAudienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPodcastSimilarAudienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPodcastSimilarAudienceQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPodcastSimilarAudienceQuery(baseOptions: Apollo.QueryHookOptions<GetPodcastSimilarAudienceQuery, GetPodcastSimilarAudienceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPodcastSimilarAudienceQuery, GetPodcastSimilarAudienceQueryVariables>(GetPodcastSimilarAudienceDocument, options);
      }
export function useGetPodcastSimilarAudienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPodcastSimilarAudienceQuery, GetPodcastSimilarAudienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPodcastSimilarAudienceQuery, GetPodcastSimilarAudienceQueryVariables>(GetPodcastSimilarAudienceDocument, options);
        }
export type GetPodcastSimilarAudienceQueryHookResult = ReturnType<typeof useGetPodcastSimilarAudienceQuery>;
export type GetPodcastSimilarAudienceLazyQueryHookResult = ReturnType<typeof useGetPodcastSimilarAudienceLazyQuery>;
export type GetPodcastSimilarAudienceQueryResult = Apollo.QueryResult<GetPodcastSimilarAudienceQuery, GetPodcastSimilarAudienceQueryVariables>;
export const PublisherSearchDocument = gql`
    query publisherSearch($organizationId: ID!, $limit: Int!, $query: String!) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        publisherSearch(query: {query: $query, limit: $limit}) {
          results {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePublisherSearchQuery__
 *
 * To run a query within a React component, call `usePublisherSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherSearchQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *   },
 * });
 */
export function usePublisherSearchQuery(baseOptions: Apollo.QueryHookOptions<PublisherSearchQuery, PublisherSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublisherSearchQuery, PublisherSearchQueryVariables>(PublisherSearchDocument, options);
      }
export function usePublisherSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublisherSearchQuery, PublisherSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublisherSearchQuery, PublisherSearchQueryVariables>(PublisherSearchDocument, options);
        }
export type PublisherSearchQueryHookResult = ReturnType<typeof usePublisherSearchQuery>;
export type PublisherSearchLazyQueryHookResult = ReturnType<typeof usePublisherSearchLazyQuery>;
export type PublisherSearchQueryResult = Apollo.QueryResult<PublisherSearchQuery, PublisherSearchQueryVariables>;
export const GetSavedSearchDocument = gql`
    query getSavedSearch($id: ID!, $organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        id
        savedSearch(id: $id) {
          data
          id
          name
          orgDefault
          slug
          version
          user {
            id
            firstName
            lastName
          }
          organization {
            id
            name
          }
          updatedAt
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetSavedSearchQuery__
 *
 * To run a query within a React component, call `useGetSavedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedSearchQuery({
 *   variables: {
 *      id: // value for 'id'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetSavedSearchQuery(baseOptions: Apollo.QueryHookOptions<GetSavedSearchQuery, GetSavedSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedSearchQuery, GetSavedSearchQueryVariables>(GetSavedSearchDocument, options);
      }
export function useGetSavedSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedSearchQuery, GetSavedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedSearchQuery, GetSavedSearchQueryVariables>(GetSavedSearchDocument, options);
        }
export type GetSavedSearchQueryHookResult = ReturnType<typeof useGetSavedSearchQuery>;
export type GetSavedSearchLazyQueryHookResult = ReturnType<typeof useGetSavedSearchLazyQuery>;
export type GetSavedSearchQueryResult = Apollo.QueryResult<GetSavedSearchQuery, GetSavedSearchQueryVariables>;
export const GetSavedSearchesDocument = gql`
    query getSavedSearches($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        id
        savedSearches {
          data
          id
          name
          orgDefault
          version
          user {
            id
            firstName
            lastName
          }
          organization {
            id
          }
          updatedAt
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetSavedSearchesQuery__
 *
 * To run a query within a React component, call `useGetSavedSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavedSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavedSearchesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetSavedSearchesQuery(baseOptions: Apollo.QueryHookOptions<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>(GetSavedSearchesDocument, options);
      }
export function useGetSavedSearchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>(GetSavedSearchesDocument, options);
        }
export type GetSavedSearchesQueryHookResult = ReturnType<typeof useGetSavedSearchesQuery>;
export type GetSavedSearchesLazyQueryHookResult = ReturnType<typeof useGetSavedSearchesLazyQuery>;
export type GetSavedSearchesQueryResult = Apollo.QueryResult<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>;
export const FeedSearchDocument = gql`
    query feedSearch($organizationId: ID!, $offset: Int!, $limit: Int!, $publisherId: ID!, $query: String!) {
  me {
    id
    organization(id: $organizationId) {
      id
      feedSearch(
        query: $query
        limit: $limit
        offset: $offset
        publisherId: $publisherId
      ) {
        count
        results {
          id
          title
          podcast {
            id
            organization {
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFeedSearchQuery__
 *
 * To run a query within a React component, call `useFeedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedSearchQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      publisherId: // value for 'publisherId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFeedSearchQuery(baseOptions: Apollo.QueryHookOptions<FeedSearchQuery, FeedSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedSearchQuery, FeedSearchQueryVariables>(FeedSearchDocument, options);
      }
export function useFeedSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedSearchQuery, FeedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedSearchQuery, FeedSearchQueryVariables>(FeedSearchDocument, options);
        }
export type FeedSearchQueryHookResult = ReturnType<typeof useFeedSearchQuery>;
export type FeedSearchLazyQueryHookResult = ReturnType<typeof useFeedSearchLazyQuery>;
export type FeedSearchQueryResult = Apollo.QueryResult<FeedSearchQuery, FeedSearchQueryVariables>;
export const GetAdvisorColumnsDocument = gql`
    query GetAdvisorColumns($organizationId: ID!, $ids: [ID]!) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        id
        columnGroups {
          columns(ids: $ids) {
            ...AdvisorColumnFields
          }
        }
      }
    }
  }
}
    ${AdvisorColumnFieldsFragmentDoc}`;

/**
 * __useGetAdvisorColumnsQuery__
 *
 * To run a query within a React component, call `useGetAdvisorColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvisorColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvisorColumnsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetAdvisorColumnsQuery(baseOptions: Apollo.QueryHookOptions<GetAdvisorColumnsQuery, GetAdvisorColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvisorColumnsQuery, GetAdvisorColumnsQueryVariables>(GetAdvisorColumnsDocument, options);
      }
export function useGetAdvisorColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvisorColumnsQuery, GetAdvisorColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvisorColumnsQuery, GetAdvisorColumnsQueryVariables>(GetAdvisorColumnsDocument, options);
        }
export type GetAdvisorColumnsQueryHookResult = ReturnType<typeof useGetAdvisorColumnsQuery>;
export type GetAdvisorColumnsLazyQueryHookResult = ReturnType<typeof useGetAdvisorColumnsLazyQuery>;
export type GetAdvisorColumnsQueryResult = Apollo.QueryResult<GetAdvisorColumnsQuery, GetAdvisorColumnsQueryVariables>;
export const GetAdvisorPublishersDocument = gql`
    query GetAdvisorPublishers($organizationId: ID!, $query: String, $publisherId: ID) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        id
        columnGroups {
          publishers(query: $query, id: $publisherId) {
            ...AdvisorColumnGroupFields
          }
        }
      }
    }
  }
}
    ${AdvisorColumnGroupFieldsFragmentDoc}`;

/**
 * __useGetAdvisorPublishersQuery__
 *
 * To run a query within a React component, call `useGetAdvisorPublishersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvisorPublishersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvisorPublishersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      query: // value for 'query'
 *      publisherId: // value for 'publisherId'
 *   },
 * });
 */
export function useGetAdvisorPublishersQuery(baseOptions: Apollo.QueryHookOptions<GetAdvisorPublishersQuery, GetAdvisorPublishersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvisorPublishersQuery, GetAdvisorPublishersQueryVariables>(GetAdvisorPublishersDocument, options);
      }
export function useGetAdvisorPublishersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvisorPublishersQuery, GetAdvisorPublishersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvisorPublishersQuery, GetAdvisorPublishersQueryVariables>(GetAdvisorPublishersDocument, options);
        }
export type GetAdvisorPublishersQueryHookResult = ReturnType<typeof useGetAdvisorPublishersQuery>;
export type GetAdvisorPublishersLazyQueryHookResult = ReturnType<typeof useGetAdvisorPublishersLazyQuery>;
export type GetAdvisorPublishersQueryResult = Apollo.QueryResult<GetAdvisorPublishersQuery, GetAdvisorPublishersQueryVariables>;
export const GetPodlinkDomainDocument = gql`
    query getPodlinkDomain($organizationId: ID!, $slug: String!) {
  me {
    id
    organization(id: $organizationId) {
      id
      podlinkDomain(slug: $slug) {
        ...PodlinkDomain
        backgroundColor
        fontColor
        primaryColor
        secondaryColor
        image {
          ...Asset
        }
        favicon {
          ...Asset
        }
        podcasts {
          id
          feed {
            id
            title
            description(words: 25)
            href
            state
            image {
              id
              href
              path
            }
          }
        }
      }
    }
  }
}
    ${PodlinkDomainFragmentDoc}
${AssetFragmentDoc}`;

/**
 * __useGetPodlinkDomainQuery__
 *
 * To run a query within a React component, call `useGetPodlinkDomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPodlinkDomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPodlinkDomainQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetPodlinkDomainQuery(baseOptions: Apollo.QueryHookOptions<GetPodlinkDomainQuery, GetPodlinkDomainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPodlinkDomainQuery, GetPodlinkDomainQueryVariables>(GetPodlinkDomainDocument, options);
      }
export function useGetPodlinkDomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPodlinkDomainQuery, GetPodlinkDomainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPodlinkDomainQuery, GetPodlinkDomainQueryVariables>(GetPodlinkDomainDocument, options);
        }
export type GetPodlinkDomainQueryHookResult = ReturnType<typeof useGetPodlinkDomainQuery>;
export type GetPodlinkDomainLazyQueryHookResult = ReturnType<typeof useGetPodlinkDomainLazyQuery>;
export type GetPodlinkDomainQueryResult = Apollo.QueryResult<GetPodlinkDomainQuery, GetPodlinkDomainQueryVariables>;
export const GetPodlinkDomainsDocument = gql`
    query getPodlinkDomains($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      podlinkDomains {
        ...PodlinkDomain
      }
      podcasts {
        ...Podcast
      }
    }
  }
}
    ${PodlinkDomainFragmentDoc}
${PodcastFragmentDoc}`;

/**
 * __useGetPodlinkDomainsQuery__
 *
 * To run a query within a React component, call `useGetPodlinkDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPodlinkDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPodlinkDomainsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetPodlinkDomainsQuery(baseOptions: Apollo.QueryHookOptions<GetPodlinkDomainsQuery, GetPodlinkDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPodlinkDomainsQuery, GetPodlinkDomainsQueryVariables>(GetPodlinkDomainsDocument, options);
      }
export function useGetPodlinkDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPodlinkDomainsQuery, GetPodlinkDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPodlinkDomainsQuery, GetPodlinkDomainsQueryVariables>(GetPodlinkDomainsDocument, options);
        }
export type GetPodlinkDomainsQueryHookResult = ReturnType<typeof useGetPodlinkDomainsQuery>;
export type GetPodlinkDomainsLazyQueryHookResult = ReturnType<typeof useGetPodlinkDomainsLazyQuery>;
export type GetPodlinkDomainsQueryResult = Apollo.QueryResult<GetPodlinkDomainsQuery, GetPodlinkDomainsQueryVariables>;
export const GetBrandsOverviewDocument = gql`
    query getBrandsOverview($id: ID!, $after: String, $query: String, $limit: Int, $orderBy: String, $before: String, $minAds: Int, $maxAds: Int, $minPodcasts: Int, $maxPodcasts: Int, $minEpisodes: Int, $maxEpisodes: Int) {
  me {
    id
    organization(id: $id) {
      id
      research {
        brand {
          brandsOverview(
            limit: $limit
            query: $query
            after: $after
            orderBy: $orderBy
            before: $before
            minAds: $minAds
            maxAds: $maxAds
            minPodcasts: $minPodcasts
            maxPodcasts: $maxPodcasts
            minEpisodes: $minEpisodes
            maxEpisodes: $maxEpisodes
          ) {
            total
            results {
              id
              name
              slug
              adFirstPublished
              adsCount
              episodesCount
              feedsCount
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBrandsOverviewQuery__
 *
 * To run a query within a React component, call `useGetBrandsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrandsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrandsOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *      before: // value for 'before'
 *      minAds: // value for 'minAds'
 *      maxAds: // value for 'maxAds'
 *      minPodcasts: // value for 'minPodcasts'
 *      maxPodcasts: // value for 'maxPodcasts'
 *      minEpisodes: // value for 'minEpisodes'
 *      maxEpisodes: // value for 'maxEpisodes'
 *   },
 * });
 */
export function useGetBrandsOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetBrandsOverviewQuery, GetBrandsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrandsOverviewQuery, GetBrandsOverviewQueryVariables>(GetBrandsOverviewDocument, options);
      }
export function useGetBrandsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrandsOverviewQuery, GetBrandsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrandsOverviewQuery, GetBrandsOverviewQueryVariables>(GetBrandsOverviewDocument, options);
        }
export type GetBrandsOverviewQueryHookResult = ReturnType<typeof useGetBrandsOverviewQuery>;
export type GetBrandsOverviewLazyQueryHookResult = ReturnType<typeof useGetBrandsOverviewLazyQuery>;
export type GetBrandsOverviewQueryResult = Apollo.QueryResult<GetBrandsOverviewQuery, GetBrandsOverviewQueryVariables>;
export const GetResearchCompanyAdDocument = gql`
    query getResearchCompanyAd($organizationId: ID!, $companyId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        company(id: $companyId) {
          id
          ad(id: $id) {
            id
            placements {
              id
              startTime
              endTime
              episode {
                id
                title
                subtitle
                summary
                description(words: 50)
                published
                image {
                  id
                  href
                  path
                }
                feed {
                  id
                  title
                  image {
                    id
                    href
                    path
                  }
                }
                enclosure {
                  id
                  length
                }
                placementsCount
              }
            }
            reviews {
              id
              startState
              endState
              reviewer {
                id
                firstName
                lastName
                email
              }
              duration
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetResearchCompanyAdQuery__
 *
 * To run a query within a React component, call `useGetResearchCompanyAdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResearchCompanyAdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResearchCompanyAdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResearchCompanyAdQuery(baseOptions: Apollo.QueryHookOptions<GetResearchCompanyAdQuery, GetResearchCompanyAdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResearchCompanyAdQuery, GetResearchCompanyAdQueryVariables>(GetResearchCompanyAdDocument, options);
      }
export function useGetResearchCompanyAdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResearchCompanyAdQuery, GetResearchCompanyAdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResearchCompanyAdQuery, GetResearchCompanyAdQueryVariables>(GetResearchCompanyAdDocument, options);
        }
export type GetResearchCompanyAdQueryHookResult = ReturnType<typeof useGetResearchCompanyAdQuery>;
export type GetResearchCompanyAdLazyQueryHookResult = ReturnType<typeof useGetResearchCompanyAdLazyQuery>;
export type GetResearchCompanyAdQueryResult = Apollo.QueryResult<GetResearchCompanyAdQuery, GetResearchCompanyAdQueryVariables>;
export const GetCompanyAdDocument = gql`
    query getCompanyAd($organizationId: ID!, $companyId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        company(id: $companyId) {
          id
          ad(id: $id) {
            id
            mpegPath
            flacPath
            waveform
            words
            text
            transcript
            duration
            state
            src
            product {
              id
              name
            }
            sponsor {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanyAdQuery__
 *
 * To run a query within a React component, call `useGetCompanyAdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyAdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyAdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyAdQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyAdQuery, GetCompanyAdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyAdQuery, GetCompanyAdQueryVariables>(GetCompanyAdDocument, options);
      }
export function useGetCompanyAdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyAdQuery, GetCompanyAdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyAdQuery, GetCompanyAdQueryVariables>(GetCompanyAdDocument, options);
        }
export type GetCompanyAdQueryHookResult = ReturnType<typeof useGetCompanyAdQuery>;
export type GetCompanyAdLazyQueryHookResult = ReturnType<typeof useGetCompanyAdLazyQuery>;
export type GetCompanyAdQueryResult = Apollo.QueryResult<GetCompanyAdQuery, GetCompanyAdQueryVariables>;
export const CompanyAdsDocument = gql`
    query CompanyAds($organizationId: ID!, $id: ID!, $limit: Int, $orderBy: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        company(id: $id) {
          id
          ads(limit: $limit, orderBy: $orderBy, state: "edited") {
            id
            mpegPath
            flacPath
            waveform
            text
            duration
            state
            src
            firstPublished
            company {
              id
              name
            }
            product {
              id
              name
            }
            sponsor {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCompanyAdsQuery__
 *
 * To run a query within a React component, call `useCompanyAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAdsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCompanyAdsQuery(baseOptions: Apollo.QueryHookOptions<CompanyAdsQuery, CompanyAdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAdsQuery, CompanyAdsQueryVariables>(CompanyAdsDocument, options);
      }
export function useCompanyAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAdsQuery, CompanyAdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAdsQuery, CompanyAdsQueryVariables>(CompanyAdsDocument, options);
        }
export type CompanyAdsQueryHookResult = ReturnType<typeof useCompanyAdsQuery>;
export type CompanyAdsLazyQueryHookResult = ReturnType<typeof useCompanyAdsLazyQuery>;
export type CompanyAdsQueryResult = Apollo.QueryResult<CompanyAdsQuery, CompanyAdsQueryVariables>;
export const GetCompanyDetailDocument = gql`
    query getCompanyDetail($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        company(id: $id) {
          id
          name
          slug
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanyDetailQuery__
 *
 * To run a query within a React component, call `useGetCompanyDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyDetailQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>(GetCompanyDetailDocument, options);
      }
export function useGetCompanyDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>(GetCompanyDetailDocument, options);
        }
export type GetCompanyDetailQueryHookResult = ReturnType<typeof useGetCompanyDetailQuery>;
export type GetCompanyDetailLazyQueryHookResult = ReturnType<typeof useGetCompanyDetailLazyQuery>;
export type GetCompanyDetailQueryResult = Apollo.QueryResult<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>;
export const GetCompanyFeedDocument = gql`
    query getCompanyFeed($organizationId: ID!, $companyId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        feed(id: $id) {
          id
          title
          subtitle
          summary
          description(words: 50)
          image {
            id
            href
            path
          }
          episodes(companyId: $companyId) {
            id
            title
            subtitle
            summary
            description(words: 50)
            published
            reviewed
            hasNoAds
            placementsCount(companyId: $companyId)
            image {
              id
              href
              path
            }
            enclosure {
              id
              length
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanyFeedQuery__
 *
 * To run a query within a React component, call `useGetCompanyFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyFeedQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      companyId: // value for 'companyId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyFeedQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyFeedQuery, GetCompanyFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyFeedQuery, GetCompanyFeedQueryVariables>(GetCompanyFeedDocument, options);
      }
export function useGetCompanyFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyFeedQuery, GetCompanyFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyFeedQuery, GetCompanyFeedQueryVariables>(GetCompanyFeedDocument, options);
        }
export type GetCompanyFeedQueryHookResult = ReturnType<typeof useGetCompanyFeedQuery>;
export type GetCompanyFeedLazyQueryHookResult = ReturnType<typeof useGetCompanyFeedLazyQuery>;
export type GetCompanyFeedQueryResult = Apollo.QueryResult<GetCompanyFeedQuery, GetCompanyFeedQueryVariables>;
export const GetCompanyFeedsDocument = gql`
    query getCompanyFeeds($organizationId: ID!, $id: ID!, $limit: Int) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        company(id: $id) {
          id
          feeds(limit: $limit) {
            id
            title
            subtitle
            summary
            image {
              id
              href
              path
            }
            avgRank
            episodesCount(companyId: $id)
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanyFeedsQuery__
 *
 * To run a query within a React component, call `useGetCompanyFeedsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyFeedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyFeedsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCompanyFeedsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyFeedsQuery, GetCompanyFeedsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyFeedsQuery, GetCompanyFeedsQueryVariables>(GetCompanyFeedsDocument, options);
      }
export function useGetCompanyFeedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyFeedsQuery, GetCompanyFeedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyFeedsQuery, GetCompanyFeedsQueryVariables>(GetCompanyFeedsDocument, options);
        }
export type GetCompanyFeedsQueryHookResult = ReturnType<typeof useGetCompanyFeedsQuery>;
export type GetCompanyFeedsLazyQueryHookResult = ReturnType<typeof useGetCompanyFeedsLazyQuery>;
export type GetCompanyFeedsQueryResult = Apollo.QueryResult<GetCompanyFeedsQuery, GetCompanyFeedsQueryVariables>;
export const GetResearchCompanyDocument = gql`
    query getResearchCompany($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        company(id: $id) {
          ...Company
        }
      }
    }
  }
}
    ${CompanyFragmentDoc}`;

/**
 * __useGetResearchCompanyQuery__
 *
 * To run a query within a React component, call `useGetResearchCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResearchCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResearchCompanyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResearchCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetResearchCompanyQuery, GetResearchCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResearchCompanyQuery, GetResearchCompanyQueryVariables>(GetResearchCompanyDocument, options);
      }
export function useGetResearchCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResearchCompanyQuery, GetResearchCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResearchCompanyQuery, GetResearchCompanyQueryVariables>(GetResearchCompanyDocument, options);
        }
export type GetResearchCompanyQueryHookResult = ReturnType<typeof useGetResearchCompanyQuery>;
export type GetResearchCompanyLazyQueryHookResult = ReturnType<typeof useGetResearchCompanyLazyQuery>;
export type GetResearchCompanyQueryResult = Apollo.QueryResult<GetResearchCompanyQuery, GetResearchCompanyQueryVariables>;
export const GetRecentCompanyAdsDocument = gql`
    query getRecentCompanyAds($organizationId: ID!, $id: ID!, $limit: Int, $orderBy: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        company(id: $id) {
          id
          ads(limit: $limit, orderBy: $orderBy, state: "edited") {
            id
            mpegPath
            flacPath
            waveform
            text
            duration
            state
            src
            firstPublished
            placements {
              episode {
                id
                feed {
                  id
                  title
                  image {
                    id
                    href
                    path
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRecentCompanyAdsQuery__
 *
 * To run a query within a React component, call `useGetRecentCompanyAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentCompanyAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentCompanyAdsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetRecentCompanyAdsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentCompanyAdsQuery, GetRecentCompanyAdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentCompanyAdsQuery, GetRecentCompanyAdsQueryVariables>(GetRecentCompanyAdsDocument, options);
      }
export function useGetRecentCompanyAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentCompanyAdsQuery, GetRecentCompanyAdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentCompanyAdsQuery, GetRecentCompanyAdsQueryVariables>(GetRecentCompanyAdsDocument, options);
        }
export type GetRecentCompanyAdsQueryHookResult = ReturnType<typeof useGetRecentCompanyAdsQuery>;
export type GetRecentCompanyAdsLazyQueryHookResult = ReturnType<typeof useGetRecentCompanyAdsLazyQuery>;
export type GetRecentCompanyAdsQueryResult = Apollo.QueryResult<GetRecentCompanyAdsQuery, GetRecentCompanyAdsQueryVariables>;
export const GetCompanySimilarByEpisodeDocument = gql`
    query getCompanySimilarByEpisode($organizationId: ID!, $id: ID!, $limit: Int) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        company(id: $id) {
          id
          similarByEpisode(limit: $limit) {
            id
            name
            description
            url
            image {
              id
              width
              height
              src
              path
            }
            episodesCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanySimilarByEpisodeQuery__
 *
 * To run a query within a React component, call `useGetCompanySimilarByEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySimilarByEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanySimilarByEpisodeQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCompanySimilarByEpisodeQuery(baseOptions: Apollo.QueryHookOptions<GetCompanySimilarByEpisodeQuery, GetCompanySimilarByEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanySimilarByEpisodeQuery, GetCompanySimilarByEpisodeQueryVariables>(GetCompanySimilarByEpisodeDocument, options);
      }
export function useGetCompanySimilarByEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanySimilarByEpisodeQuery, GetCompanySimilarByEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanySimilarByEpisodeQuery, GetCompanySimilarByEpisodeQueryVariables>(GetCompanySimilarByEpisodeDocument, options);
        }
export type GetCompanySimilarByEpisodeQueryHookResult = ReturnType<typeof useGetCompanySimilarByEpisodeQuery>;
export type GetCompanySimilarByEpisodeLazyQueryHookResult = ReturnType<typeof useGetCompanySimilarByEpisodeLazyQuery>;
export type GetCompanySimilarByEpisodeQueryResult = Apollo.QueryResult<GetCompanySimilarByEpisodeQuery, GetCompanySimilarByEpisodeQueryVariables>;
export const GetCompanySimilarByFeedDocument = gql`
    query getCompanySimilarByFeed($organizationId: ID!, $id: ID!, $limit: Int) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        company(id: $id) {
          id
          similarByFeed(limit: $limit) {
            id
            name
            description
            url
            image {
              id
              width
              height
              src
              path
            }
            feedsCount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanySimilarByFeedQuery__
 *
 * To run a query within a React component, call `useGetCompanySimilarByFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySimilarByFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanySimilarByFeedQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCompanySimilarByFeedQuery(baseOptions: Apollo.QueryHookOptions<GetCompanySimilarByFeedQuery, GetCompanySimilarByFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanySimilarByFeedQuery, GetCompanySimilarByFeedQueryVariables>(GetCompanySimilarByFeedDocument, options);
      }
export function useGetCompanySimilarByFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanySimilarByFeedQuery, GetCompanySimilarByFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanySimilarByFeedQuery, GetCompanySimilarByFeedQueryVariables>(GetCompanySimilarByFeedDocument, options);
        }
export type GetCompanySimilarByFeedQueryHookResult = ReturnType<typeof useGetCompanySimilarByFeedQuery>;
export type GetCompanySimilarByFeedLazyQueryHookResult = ReturnType<typeof useGetCompanySimilarByFeedLazyQuery>;
export type GetCompanySimilarByFeedQueryResult = Apollo.QueryResult<GetCompanySimilarByFeedQuery, GetCompanySimilarByFeedQueryVariables>;
export const GetCompanySimilarCompanyDocument = gql`
    query getCompanySimilarCompany($organizationId: ID!, $id: ID!, $companyId: ID!, $limit: Int) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        company(id: $companyId) {
          id
          name
          description
          feeds(companyId: $id, limit: $limit) {
            id
            title
            subtitle
            summary
            image {
              id
              href
              path
            }
          }
          episodes(companyId: $id, limit: $limit) {
            id
            title
            subtitle
            summary
            placementsCount
            image {
              id
              href
              path
            }
            feed {
              id
              image {
                id
                href
                path
              }
            }
            enclosure {
              id
              length
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanySimilarCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanySimilarCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanySimilarCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanySimilarCompanyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetCompanySimilarCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanySimilarCompanyQuery, GetCompanySimilarCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanySimilarCompanyQuery, GetCompanySimilarCompanyQueryVariables>(GetCompanySimilarCompanyDocument, options);
      }
export function useGetCompanySimilarCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanySimilarCompanyQuery, GetCompanySimilarCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanySimilarCompanyQuery, GetCompanySimilarCompanyQueryVariables>(GetCompanySimilarCompanyDocument, options);
        }
export type GetCompanySimilarCompanyQueryHookResult = ReturnType<typeof useGetCompanySimilarCompanyQuery>;
export type GetCompanySimilarCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanySimilarCompanyLazyQuery>;
export type GetCompanySimilarCompanyQueryResult = Apollo.QueryResult<GetCompanySimilarCompanyQuery, GetCompanySimilarCompanyQueryVariables>;
export const GetEpisodeDocument = gql`
    query getEpisode($organizationId: ID!, $feedId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        feed(id: $feedId) {
          id
          title
          subtitle
          summary
          description(words: 50)
          image {
            id
            href
            path
          }
          episode(id: $id) {
            id
            title
            subtitle
            summary
            description(words: 50)
            published
            processed
            reviewed
            hasNoAds
            image {
              id
              href
              path
            }
            feed {
              id
              title
              image {
                id
                href
                path
              }
            }
            enclosure {
              id
              episodeId
              href
              type
              duration
              length
              mpegPath
              waveform
            }
            placementsCount
            placements {
              id
              startTime
              endTime
              ad {
                id
                mpegPath
                flacPath
                waveform
                words
                transcript
                duration
                state
                company {
                  id
                  name
                  slug
                }
                product {
                  id
                  name
                }
                sponsor {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEpisodeQuery__
 *
 * To run a query within a React component, call `useGetEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEpisodeQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      feedId: // value for 'feedId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEpisodeQuery(baseOptions: Apollo.QueryHookOptions<GetEpisodeQuery, GetEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEpisodeQuery, GetEpisodeQueryVariables>(GetEpisodeDocument, options);
      }
export function useGetEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEpisodeQuery, GetEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEpisodeQuery, GetEpisodeQueryVariables>(GetEpisodeDocument, options);
        }
export type GetEpisodeQueryHookResult = ReturnType<typeof useGetEpisodeQuery>;
export type GetEpisodeLazyQueryHookResult = ReturnType<typeof useGetEpisodeLazyQuery>;
export type GetEpisodeQueryResult = Apollo.QueryResult<GetEpisodeQuery, GetEpisodeQueryVariables>;
export const FeedAdsDocument = gql`
    query FeedAds($organizationId: ID!, $id: ID!, $limit: Int, $orderBy: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        feed(id: $id) {
          id
          ads(limit: $limit, orderBy: $orderBy, state: "edited") {
            id
            mpegPath
            flacPath
            waveform
            text
            duration
            state
            src
            firstPublished
            company {
              id
              name
            }
            product {
              id
              name
            }
            sponsor {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFeedAdsQuery__
 *
 * To run a query within a React component, call `useFeedAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedAdsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFeedAdsQuery(baseOptions: Apollo.QueryHookOptions<FeedAdsQuery, FeedAdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedAdsQuery, FeedAdsQueryVariables>(FeedAdsDocument, options);
      }
export function useFeedAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedAdsQuery, FeedAdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedAdsQuery, FeedAdsQueryVariables>(FeedAdsDocument, options);
        }
export type FeedAdsQueryHookResult = ReturnType<typeof useFeedAdsQuery>;
export type FeedAdsLazyQueryHookResult = ReturnType<typeof useFeedAdsLazyQuery>;
export type FeedAdsQueryResult = Apollo.QueryResult<FeedAdsQuery, FeedAdsQueryVariables>;
export const GetFeedCompaniesDocument = gql`
    query getFeedCompanies($organizationId: ID!, $id: ID!, $limit: Int, $orderBy: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        feed(id: $id) {
          id
          companies(after: "2018-07-12", limit: $limit, orderBy: $orderBy) {
            id
            name
            description
            url
            image {
              id
              width
              height
              src
              path
            }
            adsCount(after: "2018-07-12", feedId: $id)
            adFirstPublished(after: "2018-07-12", feedId: $id)
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetFeedCompaniesQuery__
 *
 * To run a query within a React component, call `useGetFeedCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedCompaniesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetFeedCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetFeedCompaniesQuery, GetFeedCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedCompaniesQuery, GetFeedCompaniesQueryVariables>(GetFeedCompaniesDocument, options);
      }
export function useGetFeedCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedCompaniesQuery, GetFeedCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedCompaniesQuery, GetFeedCompaniesQueryVariables>(GetFeedCompaniesDocument, options);
        }
export type GetFeedCompaniesQueryHookResult = ReturnType<typeof useGetFeedCompaniesQuery>;
export type GetFeedCompaniesLazyQueryHookResult = ReturnType<typeof useGetFeedCompaniesLazyQuery>;
export type GetFeedCompaniesQueryResult = Apollo.QueryResult<GetFeedCompaniesQuery, GetFeedCompaniesQueryVariables>;
export const FeedDayRankingsDocument = gql`
    query FeedDayRankings($organizationId: ID!, $id: ID!, $after: String!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        feed(id: $id) {
          id
          dayRankings(category: "top-200", provider: "itunes", after: $after) {
            day
            rank
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFeedDayRankingsQuery__
 *
 * To run a query within a React component, call `useFeedDayRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedDayRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedDayRankingsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFeedDayRankingsQuery(baseOptions: Apollo.QueryHookOptions<FeedDayRankingsQuery, FeedDayRankingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedDayRankingsQuery, FeedDayRankingsQueryVariables>(FeedDayRankingsDocument, options);
      }
export function useFeedDayRankingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedDayRankingsQuery, FeedDayRankingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedDayRankingsQuery, FeedDayRankingsQueryVariables>(FeedDayRankingsDocument, options);
        }
export type FeedDayRankingsQueryHookResult = ReturnType<typeof useFeedDayRankingsQuery>;
export type FeedDayRankingsLazyQueryHookResult = ReturnType<typeof useFeedDayRankingsLazyQuery>;
export type FeedDayRankingsQueryResult = Apollo.QueryResult<FeedDayRankingsQuery, FeedDayRankingsQueryVariables>;
export const FeedEpisodesDocument = gql`
    query FeedEpisodes($organizationId: ID!, $id: ID!, $limit: Int) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        feed(id: $id) {
          id
          episodes(limit: $limit) {
            id
            title
            subtitle
            summary
            description(words: 50)
            published
            reviewed
            hasNoAds
            placementsCount
            image {
              id
              href
              path
            }
            enclosure {
              id
              duration
              length
            }
          }
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useFeedEpisodesQuery__
 *
 * To run a query within a React component, call `useFeedEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedEpisodesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFeedEpisodesQuery(baseOptions: Apollo.QueryHookOptions<FeedEpisodesQuery, FeedEpisodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedEpisodesQuery, FeedEpisodesQueryVariables>(FeedEpisodesDocument, options);
      }
export function useFeedEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedEpisodesQuery, FeedEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedEpisodesQuery, FeedEpisodesQueryVariables>(FeedEpisodesDocument, options);
        }
export type FeedEpisodesQueryHookResult = ReturnType<typeof useFeedEpisodesQuery>;
export type FeedEpisodesLazyQueryHookResult = ReturnType<typeof useFeedEpisodesLazyQuery>;
export type FeedEpisodesQueryResult = Apollo.QueryResult<FeedEpisodesQuery, FeedEpisodesQueryVariables>;
export const GetFeedDocument = gql`
    query getFeed($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        feed(id: $id) {
          id
          title
          subtitle
          summary
          description(words: 50)
          image {
            id
            href
            path
          }
          podcast {
            id
            organization {
              id
              name
              slug
            }
          }
          processing
          measure
        }
      }
    }
  }
}
    `;

/**
 * __useGetFeedQuery__
 *
 * To run a query within a React component, call `useGetFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFeedQuery(baseOptions: Apollo.QueryHookOptions<GetFeedQuery, GetFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedQuery, GetFeedQueryVariables>(GetFeedDocument, options);
      }
export function useGetFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedQuery, GetFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedQuery, GetFeedQueryVariables>(GetFeedDocument, options);
        }
export type GetFeedQueryHookResult = ReturnType<typeof useGetFeedQuery>;
export type GetFeedLazyQueryHookResult = ReturnType<typeof useGetFeedLazyQuery>;
export type GetFeedQueryResult = Apollo.QueryResult<GetFeedQuery, GetFeedQueryVariables>;
export const GetPublisherCompaniesDocument = gql`
    query getPublisherCompanies($organizationId: ID!, $publisherSlug: String!, $limit: Int, $orderBy: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        publisher(slug: $publisherSlug) {
          id
          companies(after: "2018-07-12", limit: $limit, orderBy: $orderBy) {
            id
            name
            description
            url
            image {
              id
              width
              height
              src
              path
            }
            adsCount(after: "2018-07-12")
            adFirstPublished(after: "2018-07-12")
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPublisherCompaniesQuery__
 *
 * To run a query within a React component, call `useGetPublisherCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublisherCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublisherCompaniesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      publisherSlug: // value for 'publisherSlug'
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetPublisherCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetPublisherCompaniesQuery, GetPublisherCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublisherCompaniesQuery, GetPublisherCompaniesQueryVariables>(GetPublisherCompaniesDocument, options);
      }
export function useGetPublisherCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublisherCompaniesQuery, GetPublisherCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublisherCompaniesQuery, GetPublisherCompaniesQueryVariables>(GetPublisherCompaniesDocument, options);
        }
export type GetPublisherCompaniesQueryHookResult = ReturnType<typeof useGetPublisherCompaniesQuery>;
export type GetPublisherCompaniesLazyQueryHookResult = ReturnType<typeof useGetPublisherCompaniesLazyQuery>;
export type GetPublisherCompaniesQueryResult = Apollo.QueryResult<GetPublisherCompaniesQuery, GetPublisherCompaniesQueryVariables>;
export const GetPublisherDetailDocument = gql`
    query getPublisherDetail($organizationId: ID!, $publisherSlug: String!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        publisher(slug: $publisherSlug) {
          id
          slug
          name
          podcasts {
            id
            feed {
              id
              title
              description(words: 25)
              href
              image {
                id
                href
                path
              }
              episodesCount
              lastPublished
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPublisherDetailQuery__
 *
 * To run a query within a React component, call `useGetPublisherDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublisherDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublisherDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      publisherSlug: // value for 'publisherSlug'
 *   },
 * });
 */
export function useGetPublisherDetailQuery(baseOptions: Apollo.QueryHookOptions<GetPublisherDetailQuery, GetPublisherDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublisherDetailQuery, GetPublisherDetailQueryVariables>(GetPublisherDetailDocument, options);
      }
export function useGetPublisherDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublisherDetailQuery, GetPublisherDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublisherDetailQuery, GetPublisherDetailQueryVariables>(GetPublisherDetailDocument, options);
        }
export type GetPublisherDetailQueryHookResult = ReturnType<typeof useGetPublisherDetailQuery>;
export type GetPublisherDetailLazyQueryHookResult = ReturnType<typeof useGetPublisherDetailLazyQuery>;
export type GetPublisherDetailQueryResult = Apollo.QueryResult<GetPublisherDetailQuery, GetPublisherDetailQueryVariables>;
export const GetResearchPublishersDocument = gql`
    query getResearchPublishers($organizationId: ID!, $query: String!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        publishers(query: $query) {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetResearchPublishersQuery__
 *
 * To run a query within a React component, call `useGetResearchPublishersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResearchPublishersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResearchPublishersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetResearchPublishersQuery(baseOptions: Apollo.QueryHookOptions<GetResearchPublishersQuery, GetResearchPublishersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResearchPublishersQuery, GetResearchPublishersQueryVariables>(GetResearchPublishersDocument, options);
      }
export function useGetResearchPublishersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResearchPublishersQuery, GetResearchPublishersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResearchPublishersQuery, GetResearchPublishersQueryVariables>(GetResearchPublishersDocument, options);
        }
export type GetResearchPublishersQueryHookResult = ReturnType<typeof useGetResearchPublishersQuery>;
export type GetResearchPublishersLazyQueryHookResult = ReturnType<typeof useGetResearchPublishersLazyQuery>;
export type GetResearchPublishersQueryResult = Apollo.QueryResult<GetResearchPublishersQuery, GetResearchPublishersQueryVariables>;
export const GetRankingsDocument = gql`
    query getRankings($id: ID!, $limit: Int) {
  me {
    id
    organization(id: $id) {
      id
      research {
        rankings(provider: "itunes", category: "top-200", limit: $limit) {
          id
          num
          createdAt
          episodesCount
          placementsCount
          feed {
            id
            title
            subtitle
            summary
            image {
              id
              href
              path
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRankingsQuery__
 *
 * To run a query within a React component, call `useGetRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRankingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRankingsQuery(baseOptions: Apollo.QueryHookOptions<GetRankingsQuery, GetRankingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRankingsQuery, GetRankingsQueryVariables>(GetRankingsDocument, options);
      }
export function useGetRankingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRankingsQuery, GetRankingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRankingsQuery, GetRankingsQueryVariables>(GetRankingsDocument, options);
        }
export type GetRankingsQueryHookResult = ReturnType<typeof useGetRankingsQuery>;
export type GetRankingsLazyQueryHookResult = ReturnType<typeof useGetRankingsLazyQuery>;
export type GetRankingsQueryResult = Apollo.QueryResult<GetRankingsQuery, GetRankingsQueryVariables>;
export const GetReviewerDetailDocument = gql`
    query getReviewerDetail($organizationId: ID!, $reviewerId: ID) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        reviewer(id: $reviewerId) {
          id
          firstName
          lastName
          email
          totalEpisodeMinutes
          totalClassifyCount
          totalEpisodeCount
          episodes {
            id
            title
            description(words: 25)
            image {
              id
              path
            }
            feed {
              id
              image {
                id
                path
              }
            }
            enclosure {
              id
              length
            }
            hasNoAds
            reviews(reviewerId: $reviewerId, includeAdReviews: true) {
              id
              hasNoAds
              duration
              startState
              endState
              ad {
                id
                company {
                  id
                  name
                }
              }
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetReviewerDetailQuery__
 *
 * To run a query within a React component, call `useGetReviewerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewerDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      reviewerId: // value for 'reviewerId'
 *   },
 * });
 */
export function useGetReviewerDetailQuery(baseOptions: Apollo.QueryHookOptions<GetReviewerDetailQuery, GetReviewerDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewerDetailQuery, GetReviewerDetailQueryVariables>(GetReviewerDetailDocument, options);
      }
export function useGetReviewerDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewerDetailQuery, GetReviewerDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewerDetailQuery, GetReviewerDetailQueryVariables>(GetReviewerDetailDocument, options);
        }
export type GetReviewerDetailQueryHookResult = ReturnType<typeof useGetReviewerDetailQuery>;
export type GetReviewerDetailLazyQueryHookResult = ReturnType<typeof useGetReviewerDetailLazyQuery>;
export type GetReviewerDetailQueryResult = Apollo.QueryResult<GetReviewerDetailQuery, GetReviewerDetailQueryVariables>;
export const GetReviewerDocument = gql`
    query getReviewer($organizationId: ID!, $reviewerId: ID) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        reviewer(id: $reviewerId) {
          id
          firstName
          lastName
          email
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetReviewerQuery__
 *
 * To run a query within a React component, call `useGetReviewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewerQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      reviewerId: // value for 'reviewerId'
 *   },
 * });
 */
export function useGetReviewerQuery(baseOptions: Apollo.QueryHookOptions<GetReviewerQuery, GetReviewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewerQuery, GetReviewerQueryVariables>(GetReviewerDocument, options);
      }
export function useGetReviewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewerQuery, GetReviewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewerQuery, GetReviewerQueryVariables>(GetReviewerDocument, options);
        }
export type GetReviewerQueryHookResult = ReturnType<typeof useGetReviewerQuery>;
export type GetReviewerLazyQueryHookResult = ReturnType<typeof useGetReviewerLazyQuery>;
export type GetReviewerQueryResult = Apollo.QueryResult<GetReviewerQuery, GetReviewerQueryVariables>;
export const SearchDocument = gql`
    query search($organizationId: ID!, $query: String!, $limit: Int) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        search(query: $query, limit: $limit) {
          total
          results {
            id
            kind
            title
            slug
            subtitle
            body
            imagePath
            duration
            published
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const EpisodeMinutesByDayDocument = gql`
    query EpisodeMinutesByDay($organizationId: ID!, $after: Date, $reviewerId: ID) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        reviewing {
          episodeMinutesByDay(after: $after, reviewerId: $reviewerId) {
            day
            minutes
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEpisodeMinutesByDayQuery__
 *
 * To run a query within a React component, call `useEpisodeMinutesByDayQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpisodeMinutesByDayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpisodeMinutesByDayQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      after: // value for 'after'
 *      reviewerId: // value for 'reviewerId'
 *   },
 * });
 */
export function useEpisodeMinutesByDayQuery(baseOptions: Apollo.QueryHookOptions<EpisodeMinutesByDayQuery, EpisodeMinutesByDayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpisodeMinutesByDayQuery, EpisodeMinutesByDayQueryVariables>(EpisodeMinutesByDayDocument, options);
      }
export function useEpisodeMinutesByDayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpisodeMinutesByDayQuery, EpisodeMinutesByDayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpisodeMinutesByDayQuery, EpisodeMinutesByDayQueryVariables>(EpisodeMinutesByDayDocument, options);
        }
export type EpisodeMinutesByDayQueryHookResult = ReturnType<typeof useEpisodeMinutesByDayQuery>;
export type EpisodeMinutesByDayLazyQueryHookResult = ReturnType<typeof useEpisodeMinutesByDayLazyQuery>;
export type EpisodeMinutesByDayQueryResult = Apollo.QueryResult<EpisodeMinutesByDayQuery, EpisodeMinutesByDayQueryVariables>;
export const GetReviewerEpisodeDocument = gql`
    query getReviewerEpisode($organizationId: ID!, $feedId: ID!, $id: ID!, $proxiedEnclosureId: ID) {
  me {
    id
    organization(id: $organizationId) {
      research {
        feed(id: $feedId) {
          episode(id: $id) {
            id
            title
            subtitle
            summary
            image {
              href
              path
            }
            feed {
              id
              title
              image {
                href
                path
              }
            }
            enclosure {
              episodeId
              href
              type
              length
              duration
              mpegPath
              waveform
              proxiedEnclosure(proxiedEnclosureId: $proxiedEnclosureId) {
                id
                proxyName
                href
                type
                length
                mpegPath
                waveform
              }
            }
            placements(proxiedEnclosureId: $proxiedEnclosureId) {
              id
              startTime
              endTime
              ad {
                mpegPath
                waveform
                transcript
                state
                company {
                  id
                  name
                }
                product {
                  id
                  name
                }
                sponsor {
                  id
                  name
                }
                reviews {
                  reviewer {
                    id
                    email
                  }
                }
              }
            }
            asr {
              transcript {
                created
                duration
                confidence
                transcript
                speakers {
                  id
                  ranges {
                    start
                    end
                  }
                }
                words {
                  word
                  start
                  end
                  confidence
                  speaker
                  punctuatedWord
                }
              }
              labels {
                start
                end
              }
            }
            keywords {
              id
              timestamp
              confidence
              version
            }
            campaignEpisodes {
              id
              campaignPodcast {
                id
                campaign {
                  id
                  advertiser {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetReviewerEpisodeQuery__
 *
 * To run a query within a React component, call `useGetReviewerEpisodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewerEpisodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewerEpisodeQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      feedId: // value for 'feedId'
 *      id: // value for 'id'
 *      proxiedEnclosureId: // value for 'proxiedEnclosureId'
 *   },
 * });
 */
export function useGetReviewerEpisodeQuery(baseOptions: Apollo.QueryHookOptions<GetReviewerEpisodeQuery, GetReviewerEpisodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewerEpisodeQuery, GetReviewerEpisodeQueryVariables>(GetReviewerEpisodeDocument, options);
      }
export function useGetReviewerEpisodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewerEpisodeQuery, GetReviewerEpisodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewerEpisodeQuery, GetReviewerEpisodeQueryVariables>(GetReviewerEpisodeDocument, options);
        }
export type GetReviewerEpisodeQueryHookResult = ReturnType<typeof useGetReviewerEpisodeQuery>;
export type GetReviewerEpisodeLazyQueryHookResult = ReturnType<typeof useGetReviewerEpisodeLazyQuery>;
export type GetReviewerEpisodeQueryResult = Apollo.QueryResult<GetReviewerEpisodeQuery, GetReviewerEpisodeQueryVariables>;
export const GetReviewerAdDocument = gql`
    query getReviewerAd($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        reviewing {
          ad(id: $id) {
            id
            mpegPath
            flacPath
            waveform
            words
            state
            company {
              id
              name
            }
            product {
              id
              name
              url
              discountCode
            }
            sponsor {
              id
              name
            }
            placements {
              id
              episode {
                id
                title
                subtitle
                summary
                feed {
                  id
                }
                image {
                  href
                  path
                }
              }
            }
            guess {
              id
              kind
              body
              companyId
              companyName
              productId
              productName
              maxScore
              score
              duration
            }
            reviews {
              id
              startState
              reviewer {
                id
                firstName
                lastName
                email
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetReviewerAdQuery__
 *
 * To run a query within a React component, call `useGetReviewerAdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewerAdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewerAdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReviewerAdQuery(baseOptions: Apollo.QueryHookOptions<GetReviewerAdQuery, GetReviewerAdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewerAdQuery, GetReviewerAdQueryVariables>(GetReviewerAdDocument, options);
      }
export function useGetReviewerAdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewerAdQuery, GetReviewerAdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewerAdQuery, GetReviewerAdQueryVariables>(GetReviewerAdDocument, options);
        }
export type GetReviewerAdQueryHookResult = ReturnType<typeof useGetReviewerAdQuery>;
export type GetReviewerAdLazyQueryHookResult = ReturnType<typeof useGetReviewerAdLazyQuery>;
export type GetReviewerAdQueryResult = Apollo.QueryResult<GetReviewerAdQuery, GetReviewerAdQueryVariables>;
export const GetReviewerCompaniesDocument = gql`
    query getReviewerCompanies($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        reviewing {
          companies {
            ...Company
            adsCount
          }
        }
      }
    }
  }
}
    ${CompanyFragmentDoc}`;

/**
 * __useGetReviewerCompaniesQuery__
 *
 * To run a query within a React component, call `useGetReviewerCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewerCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewerCompaniesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetReviewerCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetReviewerCompaniesQuery, GetReviewerCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReviewerCompaniesQuery, GetReviewerCompaniesQueryVariables>(GetReviewerCompaniesDocument, options);
      }
export function useGetReviewerCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReviewerCompaniesQuery, GetReviewerCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReviewerCompaniesQuery, GetReviewerCompaniesQueryVariables>(GetReviewerCompaniesDocument, options);
        }
export type GetReviewerCompaniesQueryHookResult = ReturnType<typeof useGetReviewerCompaniesQuery>;
export type GetReviewerCompaniesLazyQueryHookResult = ReturnType<typeof useGetReviewerCompaniesLazyQuery>;
export type GetReviewerCompaniesQueryResult = Apollo.QueryResult<GetReviewerCompaniesQuery, GetReviewerCompaniesQueryVariables>;
export const ReviewerEpisodesDocument = gql`
    query ReviewerEpisodes($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        reviewing {
          episodes {
            ...ReviewerEpisode
          }
        }
      }
    }
  }
}
    ${ReviewerEpisodeFragmentDoc}`;

/**
 * __useReviewerEpisodesQuery__
 *
 * To run a query within a React component, call `useReviewerEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewerEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewerEpisodesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReviewerEpisodesQuery(baseOptions: Apollo.QueryHookOptions<ReviewerEpisodesQuery, ReviewerEpisodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewerEpisodesQuery, ReviewerEpisodesQueryVariables>(ReviewerEpisodesDocument, options);
      }
export function useReviewerEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewerEpisodesQuery, ReviewerEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewerEpisodesQuery, ReviewerEpisodesQueryVariables>(ReviewerEpisodesDocument, options);
        }
export type ReviewerEpisodesQueryHookResult = ReturnType<typeof useReviewerEpisodesQuery>;
export type ReviewerEpisodesLazyQueryHookResult = ReturnType<typeof useReviewerEpisodesLazyQuery>;
export type ReviewerEpisodesQueryResult = Apollo.QueryResult<ReviewerEpisodesQuery, ReviewerEpisodesQueryVariables>;
export const ReviewerTranscribableDocument = gql`
    query ReviewerTranscribable($organizationId: ID!, $after: Date!, $before: Date!) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        reviewing {
          transcribable(after: $after, before: $before) {
            ...ReviewerEpisode
          }
        }
      }
    }
  }
}
    ${ReviewerEpisodeFragmentDoc}`;

/**
 * __useReviewerTranscribableQuery__
 *
 * To run a query within a React component, call `useReviewerTranscribableQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewerTranscribableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewerTranscribableQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useReviewerTranscribableQuery(baseOptions: Apollo.QueryHookOptions<ReviewerTranscribableQuery, ReviewerTranscribableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewerTranscribableQuery, ReviewerTranscribableQueryVariables>(ReviewerTranscribableDocument, options);
      }
export function useReviewerTranscribableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewerTranscribableQuery, ReviewerTranscribableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewerTranscribableQuery, ReviewerTranscribableQueryVariables>(ReviewerTranscribableDocument, options);
        }
export type ReviewerTranscribableQueryHookResult = ReturnType<typeof useReviewerTranscribableQuery>;
export type ReviewerTranscribableLazyQueryHookResult = ReturnType<typeof useReviewerTranscribableLazyQuery>;
export type ReviewerTranscribableQueryResult = Apollo.QueryResult<ReviewerTranscribableQuery, ReviewerTranscribableQueryVariables>;
export const AddAdStudioAdAccountDocument = gql`
    mutation AddAdStudioAdAccount($input: AddAdStudioAdAccountInput!) {
  authed {
    success
  }
  addAdStudioAdAccount(input: $input) {
    success
  }
}
    `;
export type AddAdStudioAdAccountMutationFn = Apollo.MutationFunction<AddAdStudioAdAccountMutation, AddAdStudioAdAccountMutationVariables>;

/**
 * __useAddAdStudioAdAccountMutation__
 *
 * To run a mutation, you first call `useAddAdStudioAdAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdStudioAdAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdStudioAdAccountMutation, { data, loading, error }] = useAddAdStudioAdAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddAdStudioAdAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddAdStudioAdAccountMutation, AddAdStudioAdAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAdStudioAdAccountMutation, AddAdStudioAdAccountMutationVariables>(AddAdStudioAdAccountDocument, options);
      }
export type AddAdStudioAdAccountMutationHookResult = ReturnType<typeof useAddAdStudioAdAccountMutation>;
export type AddAdStudioAdAccountMutationResult = Apollo.MutationResult<AddAdStudioAdAccountMutation>;
export type AddAdStudioAdAccountMutationOptions = Apollo.BaseMutationOptions<AddAdStudioAdAccountMutation, AddAdStudioAdAccountMutationVariables>;
export const AddOrganizationAdvisorDocument = gql`
    mutation addOrganizationAdvisor($input: AddAdvisorForOrganizationInput!) {
  authed {
    success
  }
  addOrganizationAdvisor(input: $input) {
    organization {
      id
    }
  }
}
    `;
export type AddOrganizationAdvisorMutationFn = Apollo.MutationFunction<AddOrganizationAdvisorMutation, AddOrganizationAdvisorMutationVariables>;

/**
 * __useAddOrganizationAdvisorMutation__
 *
 * To run a mutation, you first call `useAddOrganizationAdvisorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationAdvisorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationAdvisorMutation, { data, loading, error }] = useAddOrganizationAdvisorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganizationAdvisorMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationAdvisorMutation, AddOrganizationAdvisorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganizationAdvisorMutation, AddOrganizationAdvisorMutationVariables>(AddOrganizationAdvisorDocument, options);
      }
export type AddOrganizationAdvisorMutationHookResult = ReturnType<typeof useAddOrganizationAdvisorMutation>;
export type AddOrganizationAdvisorMutationResult = Apollo.MutationResult<AddOrganizationAdvisorMutation>;
export type AddOrganizationAdvisorMutationOptions = Apollo.BaseMutationOptions<AddOrganizationAdvisorMutation, AddOrganizationAdvisorMutationVariables>;
export const AddPixelDocument = gql`
    mutation addPixel($input: CreateKeyInput!) {
  authed {
    success
  }
  addPixel(input: $input) {
    key {
      key
      role
      domain
      createdAt
    }
  }
}
    `;
export type AddPixelMutationFn = Apollo.MutationFunction<AddPixelMutation, AddPixelMutationVariables>;

/**
 * __useAddPixelMutation__
 *
 * To run a mutation, you first call `useAddPixelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPixelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPixelMutation, { data, loading, error }] = useAddPixelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPixelMutation(baseOptions?: Apollo.MutationHookOptions<AddPixelMutation, AddPixelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPixelMutation, AddPixelMutationVariables>(AddPixelDocument, options);
      }
export type AddPixelMutationHookResult = ReturnType<typeof useAddPixelMutation>;
export type AddPixelMutationResult = Apollo.MutationResult<AddPixelMutation>;
export type AddPixelMutationOptions = Apollo.BaseMutationOptions<AddPixelMutation, AddPixelMutationVariables>;
export const AttributionCampaignPreRunDocument = gql`
    mutation attributionCampaignPreRun($input: AttributionCampaignPreRunInput!) {
  authed {
    success
  }
  attributionCampaignPreRun(input: $input) {
    success
  }
}
    `;
export type AttributionCampaignPreRunMutationFn = Apollo.MutationFunction<AttributionCampaignPreRunMutation, AttributionCampaignPreRunMutationVariables>;

/**
 * __useAttributionCampaignPreRunMutation__
 *
 * To run a mutation, you first call `useAttributionCampaignPreRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttributionCampaignPreRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attributionCampaignPreRunMutation, { data, loading, error }] = useAttributionCampaignPreRunMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAttributionCampaignPreRunMutation(baseOptions?: Apollo.MutationHookOptions<AttributionCampaignPreRunMutation, AttributionCampaignPreRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttributionCampaignPreRunMutation, AttributionCampaignPreRunMutationVariables>(AttributionCampaignPreRunDocument, options);
      }
export type AttributionCampaignPreRunMutationHookResult = ReturnType<typeof useAttributionCampaignPreRunMutation>;
export type AttributionCampaignPreRunMutationResult = Apollo.MutationResult<AttributionCampaignPreRunMutation>;
export type AttributionCampaignPreRunMutationOptions = Apollo.BaseMutationOptions<AttributionCampaignPreRunMutation, AttributionCampaignPreRunMutationVariables>;
export const CreateApiKeyDocument = gql`
    mutation createApiKey {
  authed {
    success
  }
  createApiKey {
    apiKey {
      key
      secret
    }
  }
}
    `;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const CreateCampaignDynamicDeliveryDocument = gql`
    mutation createCampaignDynamicDelivery($input: CreateCampaignDynamicDeliveryInput!) {
  authed {
    success
  }
  createCampaignDynamicDelivery(input: $input) {
    success
    campaignDynamicDelivery {
      ...CampaignDynamicDelivery
    }
  }
}
    ${CampaignDynamicDeliveryFragmentDoc}`;
export type CreateCampaignDynamicDeliveryMutationFn = Apollo.MutationFunction<CreateCampaignDynamicDeliveryMutation, CreateCampaignDynamicDeliveryMutationVariables>;

/**
 * __useCreateCampaignDynamicDeliveryMutation__
 *
 * To run a mutation, you first call `useCreateCampaignDynamicDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignDynamicDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignDynamicDeliveryMutation, { data, loading, error }] = useCreateCampaignDynamicDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignDynamicDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignDynamicDeliveryMutation, CreateCampaignDynamicDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignDynamicDeliveryMutation, CreateCampaignDynamicDeliveryMutationVariables>(CreateCampaignDynamicDeliveryDocument, options);
      }
export type CreateCampaignDynamicDeliveryMutationHookResult = ReturnType<typeof useCreateCampaignDynamicDeliveryMutation>;
export type CreateCampaignDynamicDeliveryMutationResult = Apollo.MutationResult<CreateCampaignDynamicDeliveryMutation>;
export type CreateCampaignDynamicDeliveryMutationOptions = Apollo.BaseMutationOptions<CreateCampaignDynamicDeliveryMutation, CreateCampaignDynamicDeliveryMutationVariables>;
export const CreateCampaignDynamicDocument = gql`
    mutation createCampaignDynamic($input: CreateCampaignDynamicInput!) {
  authed {
    success
  }
  createCampaignDynamic(input: $input) {
    campaignDynamic {
      ...CampaignDynamicOld
    }
  }
}
    ${CampaignDynamicOldFragmentDoc}`;
export type CreateCampaignDynamicMutationFn = Apollo.MutationFunction<CreateCampaignDynamicMutation, CreateCampaignDynamicMutationVariables>;

/**
 * __useCreateCampaignDynamicMutation__
 *
 * To run a mutation, you first call `useCreateCampaignDynamicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignDynamicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignDynamicMutation, { data, loading, error }] = useCreateCampaignDynamicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignDynamicMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignDynamicMutation, CreateCampaignDynamicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignDynamicMutation, CreateCampaignDynamicMutationVariables>(CreateCampaignDynamicDocument, options);
      }
export type CreateCampaignDynamicMutationHookResult = ReturnType<typeof useCreateCampaignDynamicMutation>;
export type CreateCampaignDynamicMutationResult = Apollo.MutationResult<CreateCampaignDynamicMutation>;
export type CreateCampaignDynamicMutationOptions = Apollo.BaseMutationOptions<CreateCampaignDynamicMutation, CreateCampaignDynamicMutationVariables>;
export const CreateCampaignStreamingDeliveryDocument = gql`
    mutation createCampaignStreamingDelivery($input: CreateCampaignStreamingDeliveryInput!) {
  authed {
    success
  }
  createCampaignStreamingDelivery(input: $input) {
    success
    campaignStreamingDelivery {
      ...CampaignStreamingDelivery
    }
  }
}
    ${CampaignStreamingDeliveryFragmentDoc}`;
export type CreateCampaignStreamingDeliveryMutationFn = Apollo.MutationFunction<CreateCampaignStreamingDeliveryMutation, CreateCampaignStreamingDeliveryMutationVariables>;

/**
 * __useCreateCampaignStreamingDeliveryMutation__
 *
 * To run a mutation, you first call `useCreateCampaignStreamingDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignStreamingDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignStreamingDeliveryMutation, { data, loading, error }] = useCreateCampaignStreamingDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCampaignStreamingDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignStreamingDeliveryMutation, CreateCampaignStreamingDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignStreamingDeliveryMutation, CreateCampaignStreamingDeliveryMutationVariables>(CreateCampaignStreamingDeliveryDocument, options);
      }
export type CreateCampaignStreamingDeliveryMutationHookResult = ReturnType<typeof useCreateCampaignStreamingDeliveryMutation>;
export type CreateCampaignStreamingDeliveryMutationResult = Apollo.MutationResult<CreateCampaignStreamingDeliveryMutation>;
export type CreateCampaignStreamingDeliveryMutationOptions = Apollo.BaseMutationOptions<CreateCampaignStreamingDeliveryMutation, CreateCampaignStreamingDeliveryMutationVariables>;
export const CreateCampaignDocument = gql`
    mutation createCampaign($input: CreateCampaignInput!, $organizationId: ID!) {
  authed {
    success
  }
  createCampaign(input: $input) {
    campaign {
      ...CampaignDetails
      payer {
        id
        name
      }
    }
  }
}
    ${CampaignDetailsFragmentDoc}`;
export type CreateCampaignMutationFn = Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = Apollo.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const CreateCompanyClaimDocument = gql`
    mutation createCompanyClaim($input: CreateCompanyClaimInput!) {
  authed {
    success
  }
  createCompanyClaim(input: $input) {
    companyClaim {
      id
      state
      company {
        id
        name
      }
      createdAt
    }
  }
}
    `;
export type CreateCompanyClaimMutationFn = Apollo.MutationFunction<CreateCompanyClaimMutation, CreateCompanyClaimMutationVariables>;

/**
 * __useCreateCompanyClaimMutation__
 *
 * To run a mutation, you first call `useCreateCompanyClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyClaimMutation, { data, loading, error }] = useCreateCompanyClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyClaimMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyClaimMutation, CreateCompanyClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyClaimMutation, CreateCompanyClaimMutationVariables>(CreateCompanyClaimDocument, options);
      }
export type CreateCompanyClaimMutationHookResult = ReturnType<typeof useCreateCompanyClaimMutation>;
export type CreateCompanyClaimMutationResult = Apollo.MutationResult<CreateCompanyClaimMutation>;
export type CreateCompanyClaimMutationOptions = Apollo.BaseMutationOptions<CreateCompanyClaimMutation, CreateCompanyClaimMutationVariables>;
export const CreateCompanyDocument = gql`
    mutation createCompany($input: CreateCompanyInput!) {
  authed {
    success
  }
  createCompany(input: $input) {
    company {
      id
      name
    }
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const CreateExportInstanceDocument = gql`
    mutation createExportInstance($input: CreateExportInstanceInput!) {
  authed {
    success
  }
  createExportInstance(input: $input) {
    success
    exportInstance {
      id
      downloadUrl
      status
      updatedAt
      exportJobStatus {
        id
        status
        failedReason
      }
    }
  }
}
    `;
export type CreateExportInstanceMutationFn = Apollo.MutationFunction<CreateExportInstanceMutation, CreateExportInstanceMutationVariables>;

/**
 * __useCreateExportInstanceMutation__
 *
 * To run a mutation, you first call `useCreateExportInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExportInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExportInstanceMutation, { data, loading, error }] = useCreateExportInstanceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExportInstanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateExportInstanceMutation, CreateExportInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExportInstanceMutation, CreateExportInstanceMutationVariables>(CreateExportInstanceDocument, options);
      }
export type CreateExportInstanceMutationHookResult = ReturnType<typeof useCreateExportInstanceMutation>;
export type CreateExportInstanceMutationResult = Apollo.MutationResult<CreateExportInstanceMutation>;
export type CreateExportInstanceMutationOptions = Apollo.BaseMutationOptions<CreateExportInstanceMutation, CreateExportInstanceMutationVariables>;
export const CreateExportTokenDocument = gql`
    mutation createExportToken($input: CreateExportTokenInput!) {
  authed {
    success
  }
  createExportToken(input: $input) {
    token
  }
}
    `;
export type CreateExportTokenMutationFn = Apollo.MutationFunction<CreateExportTokenMutation, CreateExportTokenMutationVariables>;

/**
 * __useCreateExportTokenMutation__
 *
 * To run a mutation, you first call `useCreateExportTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExportTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExportTokenMutation, { data, loading, error }] = useCreateExportTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExportTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateExportTokenMutation, CreateExportTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExportTokenMutation, CreateExportTokenMutationVariables>(CreateExportTokenDocument, options);
      }
export type CreateExportTokenMutationHookResult = ReturnType<typeof useCreateExportTokenMutation>;
export type CreateExportTokenMutationResult = Apollo.MutationResult<CreateExportTokenMutation>;
export type CreateExportTokenMutationOptions = Apollo.BaseMutationOptions<CreateExportTokenMutation, CreateExportTokenMutationVariables>;
export const CreateLiftReportDocument = gql`
    mutation createLiftReport($input: CreateLiftReportInput!) {
  authed {
    success
  }
  createLiftReport(input: $input) {
    liftReport {
      ...LiftReportFields
    }
  }
}
    ${LiftReportFieldsFragmentDoc}`;
export type CreateLiftReportMutationFn = Apollo.MutationFunction<CreateLiftReportMutation, CreateLiftReportMutationVariables>;

/**
 * __useCreateLiftReportMutation__
 *
 * To run a mutation, you first call `useCreateLiftReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLiftReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLiftReportMutation, { data, loading, error }] = useCreateLiftReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLiftReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateLiftReportMutation, CreateLiftReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLiftReportMutation, CreateLiftReportMutationVariables>(CreateLiftReportDocument, options);
      }
export type CreateLiftReportMutationHookResult = ReturnType<typeof useCreateLiftReportMutation>;
export type CreateLiftReportMutationResult = Apollo.MutationResult<CreateLiftReportMutation>;
export type CreateLiftReportMutationOptions = Apollo.BaseMutationOptions<CreateLiftReportMutation, CreateLiftReportMutationVariables>;
export const CreateSavedExportDocument = gql`
    mutation createSavedExport($input: CreateSavedExportInput!) {
  authed {
    success
  }
  createSavedExport(input: $input) {
    success
    savedExport {
      ...SavedExportFields
    }
  }
}
    ${SavedExportFieldsFragmentDoc}`;
export type CreateSavedExportMutationFn = Apollo.MutationFunction<CreateSavedExportMutation, CreateSavedExportMutationVariables>;

/**
 * __useCreateSavedExportMutation__
 *
 * To run a mutation, you first call `useCreateSavedExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSavedExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSavedExportMutation, { data, loading, error }] = useCreateSavedExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSavedExportMutation(baseOptions?: Apollo.MutationHookOptions<CreateSavedExportMutation, CreateSavedExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSavedExportMutation, CreateSavedExportMutationVariables>(CreateSavedExportDocument, options);
      }
export type CreateSavedExportMutationHookResult = ReturnType<typeof useCreateSavedExportMutation>;
export type CreateSavedExportMutationResult = Apollo.MutationResult<CreateSavedExportMutation>;
export type CreateSavedExportMutationOptions = Apollo.BaseMutationOptions<CreateSavedExportMutation, CreateSavedExportMutationVariables>;
export const CreateServiceAccountApiKeyDocument = gql`
    mutation createServiceAccountApiKey($input: CreateServiceAccountApiKeyInput!) {
  authed {
    success
  }
  createServiceAccountApiKey(input: $input) {
    apiKey {
      key
      secret
    }
  }
}
    `;
export type CreateServiceAccountApiKeyMutationFn = Apollo.MutationFunction<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>;

/**
 * __useCreateServiceAccountApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateServiceAccountApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceAccountApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceAccountApiKeyMutation, { data, loading, error }] = useCreateServiceAccountApiKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceAccountApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>(CreateServiceAccountApiKeyDocument, options);
      }
export type CreateServiceAccountApiKeyMutationHookResult = ReturnType<typeof useCreateServiceAccountApiKeyMutation>;
export type CreateServiceAccountApiKeyMutationResult = Apollo.MutationResult<CreateServiceAccountApiKeyMutation>;
export type CreateServiceAccountApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateServiceAccountApiKeyMutation, CreateServiceAccountApiKeyMutationVariables>;
export const CreateTermsAndConditionsDocument = gql`
    mutation createTermsAndConditions($input: CreateTermsAndConditionsInput!) {
  authed {
    success
  }
  createTermsAndConditions(input: $input) {
    success
  }
}
    `;
export type CreateTermsAndConditionsMutationFn = Apollo.MutationFunction<CreateTermsAndConditionsMutation, CreateTermsAndConditionsMutationVariables>;

/**
 * __useCreateTermsAndConditionsMutation__
 *
 * To run a mutation, you first call `useCreateTermsAndConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTermsAndConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTermsAndConditionsMutation, { data, loading, error }] = useCreateTermsAndConditionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTermsAndConditionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateTermsAndConditionsMutation, CreateTermsAndConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTermsAndConditionsMutation, CreateTermsAndConditionsMutationVariables>(CreateTermsAndConditionsDocument, options);
      }
export type CreateTermsAndConditionsMutationHookResult = ReturnType<typeof useCreateTermsAndConditionsMutation>;
export type CreateTermsAndConditionsMutationResult = Apollo.MutationResult<CreateTermsAndConditionsMutation>;
export type CreateTermsAndConditionsMutationOptions = Apollo.BaseMutationOptions<CreateTermsAndConditionsMutation, CreateTermsAndConditionsMutationVariables>;
export const CreateUserSkippedTermsDocument = gql`
    mutation createUserSkippedTerms($input: CreateUserSkippedTermsInput!) {
  authed {
    success
  }
  createUserSkippedTerms(input: $input) {
    success
  }
}
    `;
export type CreateUserSkippedTermsMutationFn = Apollo.MutationFunction<CreateUserSkippedTermsMutation, CreateUserSkippedTermsMutationVariables>;

/**
 * __useCreateUserSkippedTermsMutation__
 *
 * To run a mutation, you first call `useCreateUserSkippedTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserSkippedTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserSkippedTermsMutation, { data, loading, error }] = useCreateUserSkippedTermsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserSkippedTermsMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserSkippedTermsMutation, CreateUserSkippedTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserSkippedTermsMutation, CreateUserSkippedTermsMutationVariables>(CreateUserSkippedTermsDocument, options);
      }
export type CreateUserSkippedTermsMutationHookResult = ReturnType<typeof useCreateUserSkippedTermsMutation>;
export type CreateUserSkippedTermsMutationResult = Apollo.MutationResult<CreateUserSkippedTermsMutation>;
export type CreateUserSkippedTermsMutationOptions = Apollo.BaseMutationOptions<CreateUserSkippedTermsMutation, CreateUserSkippedTermsMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    user {
      id
      email
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteCampaignDynamicDeliveryDocument = gql`
    mutation deleteCampaignDynamicDelivery($input: DeleteCampaignDynamicDeliveryInput!) {
  authed {
    success
  }
  deleteCampaignDynamicDelivery(input: $input) {
    success
  }
}
    `;
export type DeleteCampaignDynamicDeliveryMutationFn = Apollo.MutationFunction<DeleteCampaignDynamicDeliveryMutation, DeleteCampaignDynamicDeliveryMutationVariables>;

/**
 * __useDeleteCampaignDynamicDeliveryMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignDynamicDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignDynamicDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignDynamicDeliveryMutation, { data, loading, error }] = useDeleteCampaignDynamicDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCampaignDynamicDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignDynamicDeliveryMutation, DeleteCampaignDynamicDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignDynamicDeliveryMutation, DeleteCampaignDynamicDeliveryMutationVariables>(DeleteCampaignDynamicDeliveryDocument, options);
      }
export type DeleteCampaignDynamicDeliveryMutationHookResult = ReturnType<typeof useDeleteCampaignDynamicDeliveryMutation>;
export type DeleteCampaignDynamicDeliveryMutationResult = Apollo.MutationResult<DeleteCampaignDynamicDeliveryMutation>;
export type DeleteCampaignDynamicDeliveryMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignDynamicDeliveryMutation, DeleteCampaignDynamicDeliveryMutationVariables>;
export const DeleteCampaignDynamicDocument = gql`
    mutation deleteCampaignDynamic($input: DeleteCampaignDynamicInput!) {
  authed {
    success
  }
  deleteCampaignDynamic(input: $input) {
    success
  }
}
    `;
export type DeleteCampaignDynamicMutationFn = Apollo.MutationFunction<DeleteCampaignDynamicMutation, DeleteCampaignDynamicMutationVariables>;

/**
 * __useDeleteCampaignDynamicMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignDynamicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignDynamicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignDynamicMutation, { data, loading, error }] = useDeleteCampaignDynamicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCampaignDynamicMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignDynamicMutation, DeleteCampaignDynamicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignDynamicMutation, DeleteCampaignDynamicMutationVariables>(DeleteCampaignDynamicDocument, options);
      }
export type DeleteCampaignDynamicMutationHookResult = ReturnType<typeof useDeleteCampaignDynamicMutation>;
export type DeleteCampaignDynamicMutationResult = Apollo.MutationResult<DeleteCampaignDynamicMutation>;
export type DeleteCampaignDynamicMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignDynamicMutation, DeleteCampaignDynamicMutationVariables>;
export const DeleteCampaignPodcastDocument = gql`
    mutation deleteCampaignPodcast($input: DeleteCampaignPodcastInput!) {
  authed {
    success
  }
  deleteCampaignPodcast(input: $input) {
    success
  }
}
    `;
export type DeleteCampaignPodcastMutationFn = Apollo.MutationFunction<DeleteCampaignPodcastMutation, DeleteCampaignPodcastMutationVariables>;

/**
 * __useDeleteCampaignPodcastMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignPodcastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignPodcastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignPodcastMutation, { data, loading, error }] = useDeleteCampaignPodcastMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCampaignPodcastMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignPodcastMutation, DeleteCampaignPodcastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignPodcastMutation, DeleteCampaignPodcastMutationVariables>(DeleteCampaignPodcastDocument, options);
      }
export type DeleteCampaignPodcastMutationHookResult = ReturnType<typeof useDeleteCampaignPodcastMutation>;
export type DeleteCampaignPodcastMutationResult = Apollo.MutationResult<DeleteCampaignPodcastMutation>;
export type DeleteCampaignPodcastMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignPodcastMutation, DeleteCampaignPodcastMutationVariables>;
export const DeleteCampaignStreamingDeliveryDocument = gql`
    mutation deleteCampaignStreamingDelivery($input: DeleteCampaignStreamingDeliveryInput!) {
  authed {
    success
  }
  deleteCampaignStreamingDelivery(input: $input) {
    success
  }
}
    `;
export type DeleteCampaignStreamingDeliveryMutationFn = Apollo.MutationFunction<DeleteCampaignStreamingDeliveryMutation, DeleteCampaignStreamingDeliveryMutationVariables>;

/**
 * __useDeleteCampaignStreamingDeliveryMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignStreamingDeliveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignStreamingDeliveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignStreamingDeliveryMutation, { data, loading, error }] = useDeleteCampaignStreamingDeliveryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCampaignStreamingDeliveryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignStreamingDeliveryMutation, DeleteCampaignStreamingDeliveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignStreamingDeliveryMutation, DeleteCampaignStreamingDeliveryMutationVariables>(DeleteCampaignStreamingDeliveryDocument, options);
      }
export type DeleteCampaignStreamingDeliveryMutationHookResult = ReturnType<typeof useDeleteCampaignStreamingDeliveryMutation>;
export type DeleteCampaignStreamingDeliveryMutationResult = Apollo.MutationResult<DeleteCampaignStreamingDeliveryMutation>;
export type DeleteCampaignStreamingDeliveryMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignStreamingDeliveryMutation, DeleteCampaignStreamingDeliveryMutationVariables>;
export const DeleteCampaignStreamingDocument = gql`
    mutation deleteCampaignStreaming($input: DeleteCampaignStreamingInput!) {
  authed {
    success
  }
  deleteCampaignStreaming(input: $input) {
    success
  }
}
    `;
export type DeleteCampaignStreamingMutationFn = Apollo.MutationFunction<DeleteCampaignStreamingMutation, DeleteCampaignStreamingMutationVariables>;

/**
 * __useDeleteCampaignStreamingMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignStreamingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignStreamingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignStreamingMutation, { data, loading, error }] = useDeleteCampaignStreamingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCampaignStreamingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignStreamingMutation, DeleteCampaignStreamingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignStreamingMutation, DeleteCampaignStreamingMutationVariables>(DeleteCampaignStreamingDocument, options);
      }
export type DeleteCampaignStreamingMutationHookResult = ReturnType<typeof useDeleteCampaignStreamingMutation>;
export type DeleteCampaignStreamingMutationResult = Apollo.MutationResult<DeleteCampaignStreamingMutation>;
export type DeleteCampaignStreamingMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignStreamingMutation, DeleteCampaignStreamingMutationVariables>;
export const DeleteLiftReportDocument = gql`
    mutation deleteLiftReport($input: DeleteLiftReportInput!) {
  authed {
    success
  }
  deleteLiftReport(input: $input) {
    success
  }
}
    `;
export type DeleteLiftReportMutationFn = Apollo.MutationFunction<DeleteLiftReportMutation, DeleteLiftReportMutationVariables>;

/**
 * __useDeleteLiftReportMutation__
 *
 * To run a mutation, you first call `useDeleteLiftReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLiftReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLiftReportMutation, { data, loading, error }] = useDeleteLiftReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLiftReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLiftReportMutation, DeleteLiftReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLiftReportMutation, DeleteLiftReportMutationVariables>(DeleteLiftReportDocument, options);
      }
export type DeleteLiftReportMutationHookResult = ReturnType<typeof useDeleteLiftReportMutation>;
export type DeleteLiftReportMutationResult = Apollo.MutationResult<DeleteLiftReportMutation>;
export type DeleteLiftReportMutationOptions = Apollo.BaseMutationOptions<DeleteLiftReportMutation, DeleteLiftReportMutationVariables>;
export const DeleteSavedExportDocument = gql`
    mutation deleteSavedExport($input: DeleteSavedExportInput!) {
  authed {
    success
  }
  deleteSavedExport(input: $input) {
    success
  }
}
    `;
export type DeleteSavedExportMutationFn = Apollo.MutationFunction<DeleteSavedExportMutation, DeleteSavedExportMutationVariables>;

/**
 * __useDeleteSavedExportMutation__
 *
 * To run a mutation, you first call `useDeleteSavedExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavedExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavedExportMutation, { data, loading, error }] = useDeleteSavedExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSavedExportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSavedExportMutation, DeleteSavedExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSavedExportMutation, DeleteSavedExportMutationVariables>(DeleteSavedExportDocument, options);
      }
export type DeleteSavedExportMutationHookResult = ReturnType<typeof useDeleteSavedExportMutation>;
export type DeleteSavedExportMutationResult = Apollo.MutationResult<DeleteSavedExportMutation>;
export type DeleteSavedExportMutationOptions = Apollo.BaseMutationOptions<DeleteSavedExportMutation, DeleteSavedExportMutationVariables>;
export const FillCampaignDynamicsDocument = gql`
    mutation fillCampaignDynamics($input: FillCampaignDynamicsInput!) {
  fillCampaignDynamics(input: $input) {
    success
  }
}
    `;
export type FillCampaignDynamicsMutationFn = Apollo.MutationFunction<FillCampaignDynamicsMutation, FillCampaignDynamicsMutationVariables>;

/**
 * __useFillCampaignDynamicsMutation__
 *
 * To run a mutation, you first call `useFillCampaignDynamicsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFillCampaignDynamicsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fillCampaignDynamicsMutation, { data, loading, error }] = useFillCampaignDynamicsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFillCampaignDynamicsMutation(baseOptions?: Apollo.MutationHookOptions<FillCampaignDynamicsMutation, FillCampaignDynamicsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FillCampaignDynamicsMutation, FillCampaignDynamicsMutationVariables>(FillCampaignDynamicsDocument, options);
      }
export type FillCampaignDynamicsMutationHookResult = ReturnType<typeof useFillCampaignDynamicsMutation>;
export type FillCampaignDynamicsMutationResult = Apollo.MutationResult<FillCampaignDynamicsMutation>;
export type FillCampaignDynamicsMutationOptions = Apollo.BaseMutationOptions<FillCampaignDynamicsMutation, FillCampaignDynamicsMutationVariables>;
export const PublishSpotifyBrandLiftReportDocument = gql`
    mutation publishSpotifyBrandLiftReport($input: PublishSpotifyBrandLiftReportInput!) {
  authed {
    success
  }
  publishSpotifyBrandLiftReport(input: $input) {
    success
  }
}
    `;
export type PublishSpotifyBrandLiftReportMutationFn = Apollo.MutationFunction<PublishSpotifyBrandLiftReportMutation, PublishSpotifyBrandLiftReportMutationVariables>;

/**
 * __usePublishSpotifyBrandLiftReportMutation__
 *
 * To run a mutation, you first call `usePublishSpotifyBrandLiftReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishSpotifyBrandLiftReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishSpotifyBrandLiftReportMutation, { data, loading, error }] = usePublishSpotifyBrandLiftReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishSpotifyBrandLiftReportMutation(baseOptions?: Apollo.MutationHookOptions<PublishSpotifyBrandLiftReportMutation, PublishSpotifyBrandLiftReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishSpotifyBrandLiftReportMutation, PublishSpotifyBrandLiftReportMutationVariables>(PublishSpotifyBrandLiftReportDocument, options);
      }
export type PublishSpotifyBrandLiftReportMutationHookResult = ReturnType<typeof usePublishSpotifyBrandLiftReportMutation>;
export type PublishSpotifyBrandLiftReportMutationResult = Apollo.MutationResult<PublishSpotifyBrandLiftReportMutation>;
export type PublishSpotifyBrandLiftReportMutationOptions = Apollo.BaseMutationOptions<PublishSpotifyBrandLiftReportMutation, PublishSpotifyBrandLiftReportMutationVariables>;
export const PublisherApproveCampaignDocument = gql`
    mutation publisherApproveCampaign($input: PublisherApproveCampaignInput!) {
  authed {
    success
  }
  publisherApproveCampaign(input: $input) {
    success
  }
}
    `;
export type PublisherApproveCampaignMutationFn = Apollo.MutationFunction<PublisherApproveCampaignMutation, PublisherApproveCampaignMutationVariables>;

/**
 * __usePublisherApproveCampaignMutation__
 *
 * To run a mutation, you first call `usePublisherApproveCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublisherApproveCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publisherApproveCampaignMutation, { data, loading, error }] = usePublisherApproveCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublisherApproveCampaignMutation(baseOptions?: Apollo.MutationHookOptions<PublisherApproveCampaignMutation, PublisherApproveCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublisherApproveCampaignMutation, PublisherApproveCampaignMutationVariables>(PublisherApproveCampaignDocument, options);
      }
export type PublisherApproveCampaignMutationHookResult = ReturnType<typeof usePublisherApproveCampaignMutation>;
export type PublisherApproveCampaignMutationResult = Apollo.MutationResult<PublisherApproveCampaignMutation>;
export type PublisherApproveCampaignMutationOptions = Apollo.BaseMutationOptions<PublisherApproveCampaignMutation, PublisherApproveCampaignMutationVariables>;
export const PublisherRejectCampaignDocument = gql`
    mutation publisherRejectCampaign($input: PublisherRejectCampaignInput!) {
  authed {
    success
  }
  publisherRejectCampaign(input: $input) {
    success
  }
}
    `;
export type PublisherRejectCampaignMutationFn = Apollo.MutationFunction<PublisherRejectCampaignMutation, PublisherRejectCampaignMutationVariables>;

/**
 * __usePublisherRejectCampaignMutation__
 *
 * To run a mutation, you first call `usePublisherRejectCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublisherRejectCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publisherRejectCampaignMutation, { data, loading, error }] = usePublisherRejectCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublisherRejectCampaignMutation(baseOptions?: Apollo.MutationHookOptions<PublisherRejectCampaignMutation, PublisherRejectCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublisherRejectCampaignMutation, PublisherRejectCampaignMutationVariables>(PublisherRejectCampaignDocument, options);
      }
export type PublisherRejectCampaignMutationHookResult = ReturnType<typeof usePublisherRejectCampaignMutation>;
export type PublisherRejectCampaignMutationResult = Apollo.MutationResult<PublisherRejectCampaignMutation>;
export type PublisherRejectCampaignMutationOptions = Apollo.BaseMutationOptions<PublisherRejectCampaignMutation, PublisherRejectCampaignMutationVariables>;
export const RunLiftReportDocument = gql`
    mutation RunLiftReport($input: RunLiftReportInput!) {
  authed {
    success
  }
  runLiftReport(input: $input) {
    liftReport {
      ...LiftReportFields
    }
  }
}
    ${LiftReportFieldsFragmentDoc}`;
export type RunLiftReportMutationFn = Apollo.MutationFunction<RunLiftReportMutation, RunLiftReportMutationVariables>;

/**
 * __useRunLiftReportMutation__
 *
 * To run a mutation, you first call `useRunLiftReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunLiftReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runLiftReportMutation, { data, loading, error }] = useRunLiftReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunLiftReportMutation(baseOptions?: Apollo.MutationHookOptions<RunLiftReportMutation, RunLiftReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunLiftReportMutation, RunLiftReportMutationVariables>(RunLiftReportDocument, options);
      }
export type RunLiftReportMutationHookResult = ReturnType<typeof useRunLiftReportMutation>;
export type RunLiftReportMutationResult = Apollo.MutationResult<RunLiftReportMutation>;
export type RunLiftReportMutationOptions = Apollo.BaseMutationOptions<RunLiftReportMutation, RunLiftReportMutationVariables>;
export const SendVerifyEmailDocument = gql`
    mutation sendVerifyEmail($input: SendVerifyEmailInput!) {
  sendVerifyEmail(input: $input) {
    success
  }
}
    `;
export type SendVerifyEmailMutationFn = Apollo.MutationFunction<SendVerifyEmailMutation, SendVerifyEmailMutationVariables>;

/**
 * __useSendVerifyEmailMutation__
 *
 * To run a mutation, you first call `useSendVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerifyEmailMutation, { data, loading, error }] = useSendVerifyEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendVerifyEmailMutation, SendVerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendVerifyEmailMutation, SendVerifyEmailMutationVariables>(SendVerifyEmailDocument, options);
      }
export type SendVerifyEmailMutationHookResult = ReturnType<typeof useSendVerifyEmailMutation>;
export type SendVerifyEmailMutationResult = Apollo.MutationResult<SendVerifyEmailMutation>;
export type SendVerifyEmailMutationOptions = Apollo.BaseMutationOptions<SendVerifyEmailMutation, SendVerifyEmailMutationVariables>;
export const SetAdAnalyticsTutorialProgressDocument = gql`
    mutation SetAdAnalyticsTutorialProgress($input: SetAdAnalyticsTutorialProgressInput!) {
  authed {
    success
  }
  setAdAnalyticsTutorialProgress(input: $input) {
    success
  }
}
    `;
export type SetAdAnalyticsTutorialProgressMutationFn = Apollo.MutationFunction<SetAdAnalyticsTutorialProgressMutation, SetAdAnalyticsTutorialProgressMutationVariables>;

/**
 * __useSetAdAnalyticsTutorialProgressMutation__
 *
 * To run a mutation, you first call `useSetAdAnalyticsTutorialProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAdAnalyticsTutorialProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAdAnalyticsTutorialProgressMutation, { data, loading, error }] = useSetAdAnalyticsTutorialProgressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAdAnalyticsTutorialProgressMutation(baseOptions?: Apollo.MutationHookOptions<SetAdAnalyticsTutorialProgressMutation, SetAdAnalyticsTutorialProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAdAnalyticsTutorialProgressMutation, SetAdAnalyticsTutorialProgressMutationVariables>(SetAdAnalyticsTutorialProgressDocument, options);
      }
export type SetAdAnalyticsTutorialProgressMutationHookResult = ReturnType<typeof useSetAdAnalyticsTutorialProgressMutation>;
export type SetAdAnalyticsTutorialProgressMutationResult = Apollo.MutationResult<SetAdAnalyticsTutorialProgressMutation>;
export type SetAdAnalyticsTutorialProgressMutationOptions = Apollo.BaseMutationOptions<SetAdAnalyticsTutorialProgressMutation, SetAdAnalyticsTutorialProgressMutationVariables>;
export const SetHasSeenAdAnalyticsWelcomeDocument = gql`
    mutation SetHasSeenAdAnalyticsWelcome($input: SetHasSeenAdAnalyticsWelcomeInput!) {
  authed {
    success
  }
  setHasSeenAdAnalyticsWelcome(input: $input) {
    status
  }
}
    `;
export type SetHasSeenAdAnalyticsWelcomeMutationFn = Apollo.MutationFunction<SetHasSeenAdAnalyticsWelcomeMutation, SetHasSeenAdAnalyticsWelcomeMutationVariables>;

/**
 * __useSetHasSeenAdAnalyticsWelcomeMutation__
 *
 * To run a mutation, you first call `useSetHasSeenAdAnalyticsWelcomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHasSeenAdAnalyticsWelcomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHasSeenAdAnalyticsWelcomeMutation, { data, loading, error }] = useSetHasSeenAdAnalyticsWelcomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetHasSeenAdAnalyticsWelcomeMutation(baseOptions?: Apollo.MutationHookOptions<SetHasSeenAdAnalyticsWelcomeMutation, SetHasSeenAdAnalyticsWelcomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetHasSeenAdAnalyticsWelcomeMutation, SetHasSeenAdAnalyticsWelcomeMutationVariables>(SetHasSeenAdAnalyticsWelcomeDocument, options);
      }
export type SetHasSeenAdAnalyticsWelcomeMutationHookResult = ReturnType<typeof useSetHasSeenAdAnalyticsWelcomeMutation>;
export type SetHasSeenAdAnalyticsWelcomeMutationResult = Apollo.MutationResult<SetHasSeenAdAnalyticsWelcomeMutation>;
export type SetHasSeenAdAnalyticsWelcomeMutationOptions = Apollo.BaseMutationOptions<SetHasSeenAdAnalyticsWelcomeMutation, SetHasSeenAdAnalyticsWelcomeMutationVariables>;
export const SyncUserEmailWithSpotifyAccountDocument = gql`
    mutation SyncUserEmailWithSpotifyAccount {
  syncUserEmailWithSpotifyAccount {
    success
  }
}
    `;
export type SyncUserEmailWithSpotifyAccountMutationFn = Apollo.MutationFunction<SyncUserEmailWithSpotifyAccountMutation, SyncUserEmailWithSpotifyAccountMutationVariables>;

/**
 * __useSyncUserEmailWithSpotifyAccountMutation__
 *
 * To run a mutation, you first call `useSyncUserEmailWithSpotifyAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncUserEmailWithSpotifyAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncUserEmailWithSpotifyAccountMutation, { data, loading, error }] = useSyncUserEmailWithSpotifyAccountMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncUserEmailWithSpotifyAccountMutation(baseOptions?: Apollo.MutationHookOptions<SyncUserEmailWithSpotifyAccountMutation, SyncUserEmailWithSpotifyAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncUserEmailWithSpotifyAccountMutation, SyncUserEmailWithSpotifyAccountMutationVariables>(SyncUserEmailWithSpotifyAccountDocument, options);
      }
export type SyncUserEmailWithSpotifyAccountMutationHookResult = ReturnType<typeof useSyncUserEmailWithSpotifyAccountMutation>;
export type SyncUserEmailWithSpotifyAccountMutationResult = Apollo.MutationResult<SyncUserEmailWithSpotifyAccountMutation>;
export type SyncUserEmailWithSpotifyAccountMutationOptions = Apollo.BaseMutationOptions<SyncUserEmailWithSpotifyAccountMutation, SyncUserEmailWithSpotifyAccountMutationVariables>;
export const UpdateAllowBrandEditAccessDocument = gql`
    mutation updateAllowBrandEditAccess($input: UpdateAllowBrandEditAccessInput!) {
  authed {
    success
  }
  updateAllowBrandEditAccess(input: $input) {
    success
  }
}
    `;
export type UpdateAllowBrandEditAccessMutationFn = Apollo.MutationFunction<UpdateAllowBrandEditAccessMutation, UpdateAllowBrandEditAccessMutationVariables>;

/**
 * __useUpdateAllowBrandEditAccessMutation__
 *
 * To run a mutation, you first call `useUpdateAllowBrandEditAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllowBrandEditAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllowBrandEditAccessMutation, { data, loading, error }] = useUpdateAllowBrandEditAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAllowBrandEditAccessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllowBrandEditAccessMutation, UpdateAllowBrandEditAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllowBrandEditAccessMutation, UpdateAllowBrandEditAccessMutationVariables>(UpdateAllowBrandEditAccessDocument, options);
      }
export type UpdateAllowBrandEditAccessMutationHookResult = ReturnType<typeof useUpdateAllowBrandEditAccessMutation>;
export type UpdateAllowBrandEditAccessMutationResult = Apollo.MutationResult<UpdateAllowBrandEditAccessMutation>;
export type UpdateAllowBrandEditAccessMutationOptions = Apollo.BaseMutationOptions<UpdateAllowBrandEditAccessMutation, UpdateAllowBrandEditAccessMutationVariables>;
export const UpdateCampaignDynamicProviderDocument = gql`
    mutation updateCampaignDynamicProvider($input: UpdateCampaignDynamicProviderInput!) {
  authed {
    success
  }
  updateCampaignDynamicProvider(input: $input) {
    campaign {
      id
    }
  }
}
    `;
export type UpdateCampaignDynamicProviderMutationFn = Apollo.MutationFunction<UpdateCampaignDynamicProviderMutation, UpdateCampaignDynamicProviderMutationVariables>;

/**
 * __useUpdateCampaignDynamicProviderMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignDynamicProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignDynamicProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignDynamicProviderMutation, { data, loading, error }] = useUpdateCampaignDynamicProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignDynamicProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignDynamicProviderMutation, UpdateCampaignDynamicProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignDynamicProviderMutation, UpdateCampaignDynamicProviderMutationVariables>(UpdateCampaignDynamicProviderDocument, options);
      }
export type UpdateCampaignDynamicProviderMutationHookResult = ReturnType<typeof useUpdateCampaignDynamicProviderMutation>;
export type UpdateCampaignDynamicProviderMutationResult = Apollo.MutationResult<UpdateCampaignDynamicProviderMutation>;
export type UpdateCampaignDynamicProviderMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignDynamicProviderMutation, UpdateCampaignDynamicProviderMutationVariables>;
export const UpdateCampaignDynamicDocument = gql`
    mutation updateCampaignDynamic($input: UpdateCampaignDynamicInput!) {
  authed {
    success
  }
  updateCampaignDynamic(input: $input) {
    campaignDynamic {
      ...CampaignDynamic
    }
  }
}
    ${CampaignDynamicFragmentDoc}`;
export type UpdateCampaignDynamicMutationFn = Apollo.MutationFunction<UpdateCampaignDynamicMutation, UpdateCampaignDynamicMutationVariables>;

/**
 * __useUpdateCampaignDynamicMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignDynamicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignDynamicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignDynamicMutation, { data, loading, error }] = useUpdateCampaignDynamicMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignDynamicMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignDynamicMutation, UpdateCampaignDynamicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignDynamicMutation, UpdateCampaignDynamicMutationVariables>(UpdateCampaignDynamicDocument, options);
      }
export type UpdateCampaignDynamicMutationHookResult = ReturnType<typeof useUpdateCampaignDynamicMutation>;
export type UpdateCampaignDynamicMutationResult = Apollo.MutationResult<UpdateCampaignDynamicMutation>;
export type UpdateCampaignDynamicMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignDynamicMutation, UpdateCampaignDynamicMutationVariables>;
export const UpdateCampaignStreamingProviderDocument = gql`
    mutation updateCampaignStreamingProvider($input: UpdateCampaignStreamingProviderInput!) {
  authed {
    success
  }
  updateCampaignStreamingProvider(input: $input) {
    campaign {
      id
    }
  }
}
    `;
export type UpdateCampaignStreamingProviderMutationFn = Apollo.MutationFunction<UpdateCampaignStreamingProviderMutation, UpdateCampaignStreamingProviderMutationVariables>;

/**
 * __useUpdateCampaignStreamingProviderMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignStreamingProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignStreamingProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignStreamingProviderMutation, { data, loading, error }] = useUpdateCampaignStreamingProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignStreamingProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignStreamingProviderMutation, UpdateCampaignStreamingProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignStreamingProviderMutation, UpdateCampaignStreamingProviderMutationVariables>(UpdateCampaignStreamingProviderDocument, options);
      }
export type UpdateCampaignStreamingProviderMutationHookResult = ReturnType<typeof useUpdateCampaignStreamingProviderMutation>;
export type UpdateCampaignStreamingProviderMutationResult = Apollo.MutationResult<UpdateCampaignStreamingProviderMutation>;
export type UpdateCampaignStreamingProviderMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignStreamingProviderMutation, UpdateCampaignStreamingProviderMutationVariables>;
export const UpdateCampaignStreamingDocument = gql`
    mutation updateCampaignStreaming($input: UpdateCampaignStreamingInput!) {
  authed {
    success
  }
  updateCampaignStreaming(input: $input) {
    campaignStreaming {
      ...CampaignStreaming
    }
  }
}
    ${CampaignStreamingFragmentDoc}`;
export type UpdateCampaignStreamingMutationFn = Apollo.MutationFunction<UpdateCampaignStreamingMutation, UpdateCampaignStreamingMutationVariables>;

/**
 * __useUpdateCampaignStreamingMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignStreamingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignStreamingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignStreamingMutation, { data, loading, error }] = useUpdateCampaignStreamingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignStreamingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignStreamingMutation, UpdateCampaignStreamingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignStreamingMutation, UpdateCampaignStreamingMutationVariables>(UpdateCampaignStreamingDocument, options);
      }
export type UpdateCampaignStreamingMutationHookResult = ReturnType<typeof useUpdateCampaignStreamingMutation>;
export type UpdateCampaignStreamingMutationResult = Apollo.MutationResult<UpdateCampaignStreamingMutation>;
export type UpdateCampaignStreamingMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignStreamingMutation, UpdateCampaignStreamingMutationVariables>;
export const UpdateCampaignDocument = gql`
    mutation updateCampaign($input: UpdateCampaignInput!) {
  authed {
    success
  }
  updateCampaign(input: $input) {
    campaign {
      id
      slug
      name
      cost
      goal
      updatedAt
      isHiddenFromAgency
      startAt
      endAt
      payer {
        id
      }
    }
  }
}
    `;
export type UpdateCampaignMutationFn = Apollo.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;

/**
 * __useUpdateCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutation, { data, loading, error }] = useUpdateCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignMutation, UpdateCampaignMutationVariables>(UpdateCampaignDocument, options);
      }
export type UpdateCampaignMutationHookResult = ReturnType<typeof useUpdateCampaignMutation>;
export type UpdateCampaignMutationResult = Apollo.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const UpdateCompanyIndustryDocument = gql`
    mutation updateCompanyIndustry($input: UpdateCompanyIndustryInput!) {
  authed {
    success
  }
  updateCompanyIndustry(input: $input) {
    company {
      industry
    }
  }
}
    `;
export type UpdateCompanyIndustryMutationFn = Apollo.MutationFunction<UpdateCompanyIndustryMutation, UpdateCompanyIndustryMutationVariables>;

/**
 * __useUpdateCompanyIndustryMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyIndustryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyIndustryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyIndustryMutation, { data, loading, error }] = useUpdateCompanyIndustryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyIndustryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyIndustryMutation, UpdateCompanyIndustryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyIndustryMutation, UpdateCompanyIndustryMutationVariables>(UpdateCompanyIndustryDocument, options);
      }
export type UpdateCompanyIndustryMutationHookResult = ReturnType<typeof useUpdateCompanyIndustryMutation>;
export type UpdateCompanyIndustryMutationResult = Apollo.MutationResult<UpdateCompanyIndustryMutation>;
export type UpdateCompanyIndustryMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyIndustryMutation, UpdateCompanyIndustryMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($input: UpdateCompanyInput!) {
  authed {
    success
  }
  updateCompany(input: $input) {
    company {
      ...Company
    }
  }
}
    ${CompanyFragmentDoc}`;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const UpdateLiftReportDocument = gql`
    mutation updateLiftReport($input: UpdateLiftReportInput!) {
  authed {
    success
  }
  updateLiftReport(input: $input) {
    liftReport {
      ...LiftReportFields
    }
  }
}
    ${LiftReportFieldsFragmentDoc}`;
export type UpdateLiftReportMutationFn = Apollo.MutationFunction<UpdateLiftReportMutation, UpdateLiftReportMutationVariables>;

/**
 * __useUpdateLiftReportMutation__
 *
 * To run a mutation, you first call `useUpdateLiftReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLiftReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLiftReportMutation, { data, loading, error }] = useUpdateLiftReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLiftReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLiftReportMutation, UpdateLiftReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLiftReportMutation, UpdateLiftReportMutationVariables>(UpdateLiftReportDocument, options);
      }
export type UpdateLiftReportMutationHookResult = ReturnType<typeof useUpdateLiftReportMutation>;
export type UpdateLiftReportMutationResult = Apollo.MutationResult<UpdateLiftReportMutation>;
export type UpdateLiftReportMutationOptions = Apollo.BaseMutationOptions<UpdateLiftReportMutation, UpdateLiftReportMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($input: UpdateOrganizationInput!) {
  authed {
    success
  }
  updateOrganization(input: $input) {
    organization {
      id
      name
      slug
      kind
      dynamicProvider
      streamingProvider
    }
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateSavedExportDocument = gql`
    mutation updateSavedExport($input: UpdateSavedExportInput!) {
  authed {
    success
  }
  updateSavedExport(input: $input) {
    success
    savedExport {
      ...SavedExportFields
    }
  }
}
    ${SavedExportFieldsFragmentDoc}`;
export type UpdateSavedExportMutationFn = Apollo.MutationFunction<UpdateSavedExportMutation, UpdateSavedExportMutationVariables>;

/**
 * __useUpdateSavedExportMutation__
 *
 * To run a mutation, you first call `useUpdateSavedExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSavedExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSavedExportMutation, { data, loading, error }] = useUpdateSavedExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSavedExportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSavedExportMutation, UpdateSavedExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSavedExportMutation, UpdateSavedExportMutationVariables>(UpdateSavedExportDocument, options);
      }
export type UpdateSavedExportMutationHookResult = ReturnType<typeof useUpdateSavedExportMutation>;
export type UpdateSavedExportMutationResult = Apollo.MutationResult<UpdateSavedExportMutation>;
export type UpdateSavedExportMutationOptions = Apollo.BaseMutationOptions<UpdateSavedExportMutation, UpdateSavedExportMutationVariables>;
export const AdAnalyticsTutorialProgressDocument = gql`
    query AdAnalyticsTutorialProgress {
  me {
    adAnalyticsTutorialProgress
  }
}
    `;

/**
 * __useAdAnalyticsTutorialProgressQuery__
 *
 * To run a query within a React component, call `useAdAnalyticsTutorialProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdAnalyticsTutorialProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdAnalyticsTutorialProgressQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdAnalyticsTutorialProgressQuery(baseOptions?: Apollo.QueryHookOptions<AdAnalyticsTutorialProgressQuery, AdAnalyticsTutorialProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdAnalyticsTutorialProgressQuery, AdAnalyticsTutorialProgressQueryVariables>(AdAnalyticsTutorialProgressDocument, options);
      }
export function useAdAnalyticsTutorialProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdAnalyticsTutorialProgressQuery, AdAnalyticsTutorialProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdAnalyticsTutorialProgressQuery, AdAnalyticsTutorialProgressQueryVariables>(AdAnalyticsTutorialProgressDocument, options);
        }
export type AdAnalyticsTutorialProgressQueryHookResult = ReturnType<typeof useAdAnalyticsTutorialProgressQuery>;
export type AdAnalyticsTutorialProgressLazyQueryHookResult = ReturnType<typeof useAdAnalyticsTutorialProgressLazyQuery>;
export type AdAnalyticsTutorialProgressQueryResult = Apollo.QueryResult<AdAnalyticsTutorialProgressQuery, AdAnalyticsTutorialProgressQueryVariables>;
export const GetAdvisorOverlapColumnGroupsDocument = gql`
    query getAdvisorOverlapColumnGroups($organizationId: ID!, $query: String, $tags: Boolean!, $contentMaturity: Boolean!, $brands: Boolean!, $industries: Boolean!, $nielsen: Boolean!, $experian: Boolean!, $clearbit: Boolean!, $publishers: Boolean!, $radioMarkets: Boolean!, $overlap: Boolean!, $feedGrowth: Boolean!) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        id
        organizationId
        columnGroups {
          general {
            ...AdvisorColumnGroupFields
          }
          tags(query: $query) @include(if: $tags) {
            ...AdvisorColumnGroupFields
          }
          contentMaturity @include(if: $contentMaturity) {
            ...AdvisorColumnGroupFields
          }
          brands(query: $query) @include(if: $brands) {
            ...AdvisorColumnGroupFields
          }
          industries(query: $query) @include(if: $industries) {
            ...AdvisorColumnGroupFields
          }
          nielsen(query: $query) @include(if: $nielsen) {
            ...AdvisorColumnGroupFields
          }
          experian(query: $query) @include(if: $experian) {
            ...AdvisorColumnGroupFields
          }
          clearbit(query: $query) @include(if: $clearbit) {
            ...AdvisorColumnGroupFields
          }
          publishers(query: $query) @include(if: $publishers) {
            ...AdvisorColumnGroupFields
          }
          radioMarkets(query: $query) @include(if: $radioMarkets) {
            ...AdvisorColumnGroupFields
          }
          overlap(query: $query) @include(if: $overlap) {
            ...AdvisorColumnGroupFields
          }
          feedGrowth(query: $query) @include(if: $feedGrowth) {
            ...AdvisorColumnGroupFields
          }
        }
      }
    }
  }
}
    ${AdvisorColumnGroupFieldsFragmentDoc}`;

/**
 * __useGetAdvisorOverlapColumnGroupsQuery__
 *
 * To run a query within a React component, call `useGetAdvisorOverlapColumnGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvisorOverlapColumnGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvisorOverlapColumnGroupsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      query: // value for 'query'
 *      tags: // value for 'tags'
 *      contentMaturity: // value for 'contentMaturity'
 *      brands: // value for 'brands'
 *      industries: // value for 'industries'
 *      nielsen: // value for 'nielsen'
 *      experian: // value for 'experian'
 *      clearbit: // value for 'clearbit'
 *      publishers: // value for 'publishers'
 *      radioMarkets: // value for 'radioMarkets'
 *      overlap: // value for 'overlap'
 *      feedGrowth: // value for 'feedGrowth'
 *   },
 * });
 */
export function useGetAdvisorOverlapColumnGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetAdvisorOverlapColumnGroupsQuery, GetAdvisorOverlapColumnGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdvisorOverlapColumnGroupsQuery, GetAdvisorOverlapColumnGroupsQueryVariables>(GetAdvisorOverlapColumnGroupsDocument, options);
      }
export function useGetAdvisorOverlapColumnGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdvisorOverlapColumnGroupsQuery, GetAdvisorOverlapColumnGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdvisorOverlapColumnGroupsQuery, GetAdvisorOverlapColumnGroupsQueryVariables>(GetAdvisorOverlapColumnGroupsDocument, options);
        }
export type GetAdvisorOverlapColumnGroupsQueryHookResult = ReturnType<typeof useGetAdvisorOverlapColumnGroupsQuery>;
export type GetAdvisorOverlapColumnGroupsLazyQueryHookResult = ReturnType<typeof useGetAdvisorOverlapColumnGroupsLazyQuery>;
export type GetAdvisorOverlapColumnGroupsQueryResult = Apollo.QueryResult<GetAdvisorOverlapColumnGroupsQuery, GetAdvisorOverlapColumnGroupsQueryVariables>;
export const AdvisorShowDocument = gql`
    query AdvisorShow($organizationId: ID!, $id: ID!, $includeTestData: Boolean!) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        show(id: $id, includeTestData: $includeTestData) {
          id
          affinity
          percentNewReach
          averageWeeklyReach
          averageMonthlyReach
          averageEpisodeLength
          averageWeeklyImpressions
          averageMonthlyImpressions
          adsDurationMean
          adsPerEpisodeMean
          cadence
          contentMaturity
          capabilities {
            id
            title
            category
          }
          feed {
            id
            title
            summary
            description
            tags {
              id
              term
            }
            podcast {
              id
            }
            contactEmail
            publisherEmail
            trailer {
              enclosure {
                waveform
                duration
                mpegPath
              }
            }
            image {
              href
              id
              path
            }
          }
          ad {
            id
            company {
              id
              name
            }
            waveform
            duration
            mpegPath
            flacPath
          }
          podcast {
            id
          }
          publisher {
            id
            name
            slug
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdvisorShowQuery__
 *
 * To run a query within a React component, call `useAdvisorShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvisorShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvisorShowQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      includeTestData: // value for 'includeTestData'
 *   },
 * });
 */
export function useAdvisorShowQuery(baseOptions: Apollo.QueryHookOptions<AdvisorShowQuery, AdvisorShowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvisorShowQuery, AdvisorShowQueryVariables>(AdvisorShowDocument, options);
      }
export function useAdvisorShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvisorShowQuery, AdvisorShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvisorShowQuery, AdvisorShowQueryVariables>(AdvisorShowDocument, options);
        }
export type AdvisorShowQueryHookResult = ReturnType<typeof useAdvisorShowQuery>;
export type AdvisorShowLazyQueryHookResult = ReturnType<typeof useAdvisorShowLazyQuery>;
export type AdvisorShowQueryResult = Apollo.QueryResult<AdvisorShowQuery, AdvisorShowQueryVariables>;
export const AudienceNielsenSegmentDocument = gql`
    query AudienceNielsenSegment($organizationId: ID!, $podcastId: ID!, $classifications: [String]!) {
  me {
    organization(id: $organizationId) {
      advisor {
        podcast(id: $podcastId) {
          feed {
            id
            title
            nielsenSegments(classifications: $classifications) {
              feedId
              classification
              topic
              uniqueHhCount
              uniqueNielsenMatching
              percentNielsenMatching
              metrics {
                variable
                reach
                totalHouseholds
                podcastPercentOfPop
                indexPercentOfPop
                index
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAudienceNielsenSegmentQuery__
 *
 * To run a query within a React component, call `useAudienceNielsenSegmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAudienceNielsenSegmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAudienceNielsenSegmentQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      podcastId: // value for 'podcastId'
 *      classifications: // value for 'classifications'
 *   },
 * });
 */
export function useAudienceNielsenSegmentQuery(baseOptions: Apollo.QueryHookOptions<AudienceNielsenSegmentQuery, AudienceNielsenSegmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AudienceNielsenSegmentQuery, AudienceNielsenSegmentQueryVariables>(AudienceNielsenSegmentDocument, options);
      }
export function useAudienceNielsenSegmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AudienceNielsenSegmentQuery, AudienceNielsenSegmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AudienceNielsenSegmentQuery, AudienceNielsenSegmentQueryVariables>(AudienceNielsenSegmentDocument, options);
        }
export type AudienceNielsenSegmentQueryHookResult = ReturnType<typeof useAudienceNielsenSegmentQuery>;
export type AudienceNielsenSegmentLazyQueryHookResult = ReturnType<typeof useAudienceNielsenSegmentLazyQuery>;
export type AudienceNielsenSegmentQueryResult = Apollo.QueryResult<AudienceNielsenSegmentQuery, AudienceNielsenSegmentQueryVariables>;
export const BrandLocationsOverviewDocument = gql`
    query BrandLocationsOverview($id: ID!, $after: Date, $before: Date, $publisherIds: [ID], $campaignIds: [ID]) {
  me {
    id
    organization(id: $id) {
      id
      overview {
        impressions(
          after: $after
          before: $before
          publisherIds: $publisherIds
          campaignIds: $campaignIds
        ) {
          locations {
            count
            countries {
              country
              total
            }
            nodes {
              country
              region
              city
              latitude
              longitude
              count: total
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBrandLocationsOverviewQuery__
 *
 * To run a query within a React component, call `useBrandLocationsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandLocationsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandLocationsOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      publisherIds: // value for 'publisherIds'
 *      campaignIds: // value for 'campaignIds'
 *   },
 * });
 */
export function useBrandLocationsOverviewQuery(baseOptions: Apollo.QueryHookOptions<BrandLocationsOverviewQuery, BrandLocationsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandLocationsOverviewQuery, BrandLocationsOverviewQueryVariables>(BrandLocationsOverviewDocument, options);
      }
export function useBrandLocationsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandLocationsOverviewQuery, BrandLocationsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandLocationsOverviewQuery, BrandLocationsOverviewQueryVariables>(BrandLocationsOverviewDocument, options);
        }
export type BrandLocationsOverviewQueryHookResult = ReturnType<typeof useBrandLocationsOverviewQuery>;
export type BrandLocationsOverviewLazyQueryHookResult = ReturnType<typeof useBrandLocationsOverviewLazyQuery>;
export type BrandLocationsOverviewQueryResult = Apollo.QueryResult<BrandLocationsOverviewQuery, BrandLocationsOverviewQueryVariables>;
export const CampaignAudienceInsightsDocument = gql`
    query CampaignAudienceInsights($organizationId: ID!, $campaignId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        audienceInsights {
          age {
            ...AudienceInsight
          }
          gender {
            ...AudienceInsight
          }
          podcastCategory {
            ...AudienceInsight
          }
          musicGenre {
            ...AudienceInsight
          }
          playlist {
            ...AudienceInsight
          }
          userSegment {
            ...AudienceInsight
          }
          device {
            ...AudienceInsight
          }
          format {
            ...AudienceInsight
          }
        }
      }
    }
  }
}
    ${AudienceInsightFragmentDoc}`;

/**
 * __useCampaignAudienceInsightsQuery__
 *
 * To run a query within a React component, call `useCampaignAudienceInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignAudienceInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignAudienceInsightsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignAudienceInsightsQuery(baseOptions: Apollo.QueryHookOptions<CampaignAudienceInsightsQuery, CampaignAudienceInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignAudienceInsightsQuery, CampaignAudienceInsightsQueryVariables>(CampaignAudienceInsightsDocument, options);
      }
export function useCampaignAudienceInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignAudienceInsightsQuery, CampaignAudienceInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignAudienceInsightsQuery, CampaignAudienceInsightsQueryVariables>(CampaignAudienceInsightsDocument, options);
        }
export type CampaignAudienceInsightsQueryHookResult = ReturnType<typeof useCampaignAudienceInsightsQuery>;
export type CampaignAudienceInsightsLazyQueryHookResult = ReturnType<typeof useCampaignAudienceInsightsLazyQuery>;
export type CampaignAudienceInsightsQueryResult = Apollo.QueryResult<CampaignAudienceInsightsQuery, CampaignAudienceInsightsQueryVariables>;
export const CampaignConversionsRowsDocument = gql`
    query CampaignConversionsRows($organizationId: ID!, $campaignId: ID!, $limit: Int!, $offset: Int!, $before: String!, $after: String!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        conversionRows(limit: $limit, offset: $offset, before: $before, after: $after) {
          leadType
          leadCategory
          quantity
          avgValue
          totalValue
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignConversionsRowsQuery__
 *
 * To run a query within a React component, call `useCampaignConversionsRowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignConversionsRowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignConversionsRowsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCampaignConversionsRowsQuery(baseOptions: Apollo.QueryHookOptions<CampaignConversionsRowsQuery, CampaignConversionsRowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignConversionsRowsQuery, CampaignConversionsRowsQueryVariables>(CampaignConversionsRowsDocument, options);
      }
export function useCampaignConversionsRowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignConversionsRowsQuery, CampaignConversionsRowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignConversionsRowsQuery, CampaignConversionsRowsQueryVariables>(CampaignConversionsRowsDocument, options);
        }
export type CampaignConversionsRowsQueryHookResult = ReturnType<typeof useCampaignConversionsRowsQuery>;
export type CampaignConversionsRowsLazyQueryHookResult = ReturnType<typeof useCampaignConversionsRowsLazyQuery>;
export type CampaignConversionsRowsQueryResult = Apollo.QueryResult<CampaignConversionsRowsQuery, CampaignConversionsRowsQueryVariables>;
export const CampaignsDeliveriesDocument = gql`
    query CampaignsDeliveries($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaigns(query: {states: ["DRAFT"]}) {
        results {
          id
          name
          state
          slug
          advertiser {
            name
          }
          kind
          createdAt
          campaignDynamics {
            id
            deliveries {
              id
            }
          }
          campaignStreamings {
            id
            deliveries {
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignsDeliveriesQuery__
 *
 * To run a query within a React component, call `useCampaignsDeliveriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsDeliveriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsDeliveriesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCampaignsDeliveriesQuery(baseOptions: Apollo.QueryHookOptions<CampaignsDeliveriesQuery, CampaignsDeliveriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsDeliveriesQuery, CampaignsDeliveriesQueryVariables>(CampaignsDeliveriesDocument, options);
      }
export function useCampaignsDeliveriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsDeliveriesQuery, CampaignsDeliveriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsDeliveriesQuery, CampaignsDeliveriesQueryVariables>(CampaignsDeliveriesDocument, options);
        }
export type CampaignsDeliveriesQueryHookResult = ReturnType<typeof useCampaignsDeliveriesQuery>;
export type CampaignsDeliveriesLazyQueryHookResult = ReturnType<typeof useCampaignsDeliveriesLazyQuery>;
export type CampaignsDeliveriesQueryResult = Apollo.QueryResult<CampaignsDeliveriesQuery, CampaignsDeliveriesQueryVariables>;
export const CampaignDynamicTrackingProvidersDocument = gql`
    query CampaignDynamicTrackingProviders($organizationId: ID!, $campaignId: ID!, $id: ID!) {
  me {
    organization(id: $organizationId) {
      campaign(id: $campaignId) {
        campaignDynamic(id: $id) {
          providerNames {
            providerName
            providerNameDisplay
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignDynamicTrackingProvidersQuery__
 *
 * To run a query within a React component, call `useCampaignDynamicTrackingProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignDynamicTrackingProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignDynamicTrackingProvidersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignDynamicTrackingProvidersQuery(baseOptions: Apollo.QueryHookOptions<CampaignDynamicTrackingProvidersQuery, CampaignDynamicTrackingProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignDynamicTrackingProvidersQuery, CampaignDynamicTrackingProvidersQueryVariables>(CampaignDynamicTrackingProvidersDocument, options);
      }
export function useCampaignDynamicTrackingProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignDynamicTrackingProvidersQuery, CampaignDynamicTrackingProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignDynamicTrackingProvidersQuery, CampaignDynamicTrackingProvidersQueryVariables>(CampaignDynamicTrackingProvidersDocument, options);
        }
export type CampaignDynamicTrackingProvidersQueryHookResult = ReturnType<typeof useCampaignDynamicTrackingProvidersQuery>;
export type CampaignDynamicTrackingProvidersLazyQueryHookResult = ReturnType<typeof useCampaignDynamicTrackingProvidersLazyQuery>;
export type CampaignDynamicTrackingProvidersQueryResult = Apollo.QueryResult<CampaignDynamicTrackingProvidersQuery, CampaignDynamicTrackingProvidersQueryVariables>;
export const CampaignDynamicDocument = gql`
    query CampaignDynamic($organizationId: ID!, $campaignId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignDynamic(id: $id) {
          ...CampaignDynamic
        }
      }
    }
  }
}
    ${CampaignDynamicFragmentDoc}`;

/**
 * __useCampaignDynamicQuery__
 *
 * To run a query within a React component, call `useCampaignDynamicQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignDynamicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignDynamicQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignDynamicQuery(baseOptions: Apollo.QueryHookOptions<CampaignDynamicQuery, CampaignDynamicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignDynamicQuery, CampaignDynamicQueryVariables>(CampaignDynamicDocument, options);
      }
export function useCampaignDynamicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignDynamicQuery, CampaignDynamicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignDynamicQuery, CampaignDynamicQueryVariables>(CampaignDynamicDocument, options);
        }
export type CampaignDynamicQueryHookResult = ReturnType<typeof useCampaignDynamicQuery>;
export type CampaignDynamicLazyQueryHookResult = ReturnType<typeof useCampaignDynamicLazyQuery>;
export type CampaignDynamicQueryResult = Apollo.QueryResult<CampaignDynamicQuery, CampaignDynamicQueryVariables>;
export const CampaignLiftReportsDocument = gql`
    query CampaignLiftReports($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        liftReports {
          ...LiftReportFields
          campaign {
            id
            name
            slug
            startAt
            endAt
          }
          campaigns {
            id
            name
            slug
            startAt
            endAt
          }
        }
        campaignPodcasts {
          ...CampaignPodcast
          campaignEpisodes {
            ...CampaignEpisode
          }
        }
      }
    }
  }
}
    ${LiftReportFieldsFragmentDoc}
${CampaignPodcastFragmentDoc}
${CampaignEpisodeFragmentDoc}`;

/**
 * __useCampaignLiftReportsQuery__
 *
 * To run a query within a React component, call `useCampaignLiftReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignLiftReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignLiftReportsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignLiftReportsQuery(baseOptions: Apollo.QueryHookOptions<CampaignLiftReportsQuery, CampaignLiftReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignLiftReportsQuery, CampaignLiftReportsQueryVariables>(CampaignLiftReportsDocument, options);
      }
export function useCampaignLiftReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignLiftReportsQuery, CampaignLiftReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignLiftReportsQuery, CampaignLiftReportsQueryVariables>(CampaignLiftReportsDocument, options);
        }
export type CampaignLiftReportsQueryHookResult = ReturnType<typeof useCampaignLiftReportsQuery>;
export type CampaignLiftReportsLazyQueryHookResult = ReturnType<typeof useCampaignLiftReportsLazyQuery>;
export type CampaignLiftReportsQueryResult = Apollo.QueryResult<CampaignLiftReportsQuery, CampaignLiftReportsQueryVariables>;
export const CampaignOverviewImpressionsPublishersDocument = gql`
    query CampaignOverviewImpressionsPublishers($id: ID!, $after: Date, $before: Date, $isMarketing: Boolean) {
  me {
    id
    organization(id: $id) {
      id
      campaigns(query: {isMarketing: $isMarketing}) {
        results {
          id
          name
          organization {
            id
            name
          }
        }
      }
      overview {
        impressions(after: $after, before: $before) {
          publishers {
            id
            name
            campaigns {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignOverviewImpressionsPublishersQuery__
 *
 * To run a query within a React component, call `useCampaignOverviewImpressionsPublishersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignOverviewImpressionsPublishersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignOverviewImpressionsPublishersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      isMarketing: // value for 'isMarketing'
 *   },
 * });
 */
export function useCampaignOverviewImpressionsPublishersQuery(baseOptions: Apollo.QueryHookOptions<CampaignOverviewImpressionsPublishersQuery, CampaignOverviewImpressionsPublishersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignOverviewImpressionsPublishersQuery, CampaignOverviewImpressionsPublishersQueryVariables>(CampaignOverviewImpressionsPublishersDocument, options);
      }
export function useCampaignOverviewImpressionsPublishersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignOverviewImpressionsPublishersQuery, CampaignOverviewImpressionsPublishersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignOverviewImpressionsPublishersQuery, CampaignOverviewImpressionsPublishersQueryVariables>(CampaignOverviewImpressionsPublishersDocument, options);
        }
export type CampaignOverviewImpressionsPublishersQueryHookResult = ReturnType<typeof useCampaignOverviewImpressionsPublishersQuery>;
export type CampaignOverviewImpressionsPublishersLazyQueryHookResult = ReturnType<typeof useCampaignOverviewImpressionsPublishersLazyQuery>;
export type CampaignOverviewImpressionsPublishersQueryResult = Apollo.QueryResult<CampaignOverviewImpressionsPublishersQuery, CampaignOverviewImpressionsPublishersQueryVariables>;
export const CampaignSpotifyAudienceDocument = gql`
    query CampaignSpotifyAudience($id: ID!, $campaignId: ID!) {
  me {
    id
    organization(id: $id) {
      id
      campaign(id: $campaignId) {
        id
        spotAudAge {
          ...SpotifyAudienceFields
        }
        spotAudDevice {
          ...SpotifyAudienceFields
        }
        spotAudFormat {
          ...SpotifyAudienceFields
        }
        spotAudGender {
          ...SpotifyAudienceFields
        }
        spotAudGenre {
          ...SpotifyAudienceFields
        }
        spotAudPlaylist {
          ...SpotifyAudienceFields
        }
        spotAudSegment {
          ...SpotifyAudienceFields
        }
      }
    }
  }
}
    ${SpotifyAudienceFieldsFragmentDoc}`;

/**
 * __useCampaignSpotifyAudienceQuery__
 *
 * To run a query within a React component, call `useCampaignSpotifyAudienceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignSpotifyAudienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignSpotifyAudienceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignSpotifyAudienceQuery(baseOptions: Apollo.QueryHookOptions<CampaignSpotifyAudienceQuery, CampaignSpotifyAudienceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignSpotifyAudienceQuery, CampaignSpotifyAudienceQueryVariables>(CampaignSpotifyAudienceDocument, options);
      }
export function useCampaignSpotifyAudienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignSpotifyAudienceQuery, CampaignSpotifyAudienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignSpotifyAudienceQuery, CampaignSpotifyAudienceQueryVariables>(CampaignSpotifyAudienceDocument, options);
        }
export type CampaignSpotifyAudienceQueryHookResult = ReturnType<typeof useCampaignSpotifyAudienceQuery>;
export type CampaignSpotifyAudienceLazyQueryHookResult = ReturnType<typeof useCampaignSpotifyAudienceLazyQuery>;
export type CampaignSpotifyAudienceQueryResult = Apollo.QueryResult<CampaignSpotifyAudienceQuery, CampaignSpotifyAudienceQueryVariables>;
export const CampaignStateDocument = gql`
    query CampaignState($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $id) {
        id
        stateOverview {
          pixel {
            hasData
          }
          members {
            firstName
            lastName
          }
          managers {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignStateQuery__
 *
 * To run a query within a React component, call `useCampaignStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignStateQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignStateQuery(baseOptions: Apollo.QueryHookOptions<CampaignStateQuery, CampaignStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignStateQuery, CampaignStateQueryVariables>(CampaignStateDocument, options);
      }
export function useCampaignStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignStateQuery, CampaignStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignStateQuery, CampaignStateQueryVariables>(CampaignStateDocument, options);
        }
export type CampaignStateQueryHookResult = ReturnType<typeof useCampaignStateQuery>;
export type CampaignStateLazyQueryHookResult = ReturnType<typeof useCampaignStateLazyQuery>;
export type CampaignStateQueryResult = Apollo.QueryResult<CampaignStateQuery, CampaignStateQueryVariables>;
export const CampaignStreamingDownloadLocationsDocument = gql`
    query CampaignStreamingDownloadLocations($organizationId: ID!, $campaignId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignStreamings {
          id
          downloads {
            locations {
              count
              nodes(limit: 2000) {
                country
                region
                city
                latitude
                longitude
                total
              }
              countries(limit: 200) {
                country
                total
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignStreamingDownloadLocationsQuery__
 *
 * To run a query within a React component, call `useCampaignStreamingDownloadLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignStreamingDownloadLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignStreamingDownloadLocationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignStreamingDownloadLocationsQuery(baseOptions: Apollo.QueryHookOptions<CampaignStreamingDownloadLocationsQuery, CampaignStreamingDownloadLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignStreamingDownloadLocationsQuery, CampaignStreamingDownloadLocationsQueryVariables>(CampaignStreamingDownloadLocationsDocument, options);
      }
export function useCampaignStreamingDownloadLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignStreamingDownloadLocationsQuery, CampaignStreamingDownloadLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignStreamingDownloadLocationsQuery, CampaignStreamingDownloadLocationsQueryVariables>(CampaignStreamingDownloadLocationsDocument, options);
        }
export type CampaignStreamingDownloadLocationsQueryHookResult = ReturnType<typeof useCampaignStreamingDownloadLocationsQuery>;
export type CampaignStreamingDownloadLocationsLazyQueryHookResult = ReturnType<typeof useCampaignStreamingDownloadLocationsLazyQuery>;
export type CampaignStreamingDownloadLocationsQueryResult = Apollo.QueryResult<CampaignStreamingDownloadLocationsQuery, CampaignStreamingDownloadLocationsQueryVariables>;
export const CampaignStreamingTrackingProvidersDocument = gql`
    query CampaignStreamingTrackingProviders($organizationId: ID!, $campaignId: ID!, $id: ID!) {
  me {
    organization(id: $organizationId) {
      campaign(id: $campaignId) {
        campaignStreaming(id: $id) {
          providerNames {
            providerName
            providerNameDisplay
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignStreamingTrackingProvidersQuery__
 *
 * To run a query within a React component, call `useCampaignStreamingTrackingProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignStreamingTrackingProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignStreamingTrackingProvidersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignStreamingTrackingProvidersQuery(baseOptions: Apollo.QueryHookOptions<CampaignStreamingTrackingProvidersQuery, CampaignStreamingTrackingProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignStreamingTrackingProvidersQuery, CampaignStreamingTrackingProvidersQueryVariables>(CampaignStreamingTrackingProvidersDocument, options);
      }
export function useCampaignStreamingTrackingProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignStreamingTrackingProvidersQuery, CampaignStreamingTrackingProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignStreamingTrackingProvidersQuery, CampaignStreamingTrackingProvidersQueryVariables>(CampaignStreamingTrackingProvidersDocument, options);
        }
export type CampaignStreamingTrackingProvidersQueryHookResult = ReturnType<typeof useCampaignStreamingTrackingProvidersQuery>;
export type CampaignStreamingTrackingProvidersLazyQueryHookResult = ReturnType<typeof useCampaignStreamingTrackingProvidersLazyQuery>;
export type CampaignStreamingTrackingProvidersQueryResult = Apollo.QueryResult<CampaignStreamingTrackingProvidersQuery, CampaignStreamingTrackingProvidersQueryVariables>;
export const CampaignStreamingDocument = gql`
    query CampaignStreaming($organizationId: ID!, $campaignId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        campaignStreaming(id: $id) {
          ...CampaignStreaming
        }
      }
    }
  }
}
    ${CampaignStreamingFragmentDoc}`;

/**
 * __useCampaignStreamingQuery__
 *
 * To run a query within a React component, call `useCampaignStreamingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignStreamingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignStreamingQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignStreamingQuery(baseOptions: Apollo.QueryHookOptions<CampaignStreamingQuery, CampaignStreamingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignStreamingQuery, CampaignStreamingQueryVariables>(CampaignStreamingDocument, options);
      }
export function useCampaignStreamingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignStreamingQuery, CampaignStreamingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignStreamingQuery, CampaignStreamingQueryVariables>(CampaignStreamingDocument, options);
        }
export type CampaignStreamingQueryHookResult = ReturnType<typeof useCampaignStreamingQuery>;
export type CampaignStreamingLazyQueryHookResult = ReturnType<typeof useCampaignStreamingLazyQuery>;
export type CampaignStreamingQueryResult = Apollo.QueryResult<CampaignStreamingQuery, CampaignStreamingQueryVariables>;
export const CampaignTrackingUrlsDocument = gql`
    query CampaignTrackingUrls($organizationId: ID!, $campaignId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignDynamics {
          id
          name
          providerName
          providerTrackingUrl
          providerNames {
            providerName
            providerNameDisplay
          }
          deliveries {
            ...CampaignDynamicDelivery
          }
        }
        campaignStreamings {
          id
          name
          isActive
          providerName
          providerTrackingUrl
          providerNames {
            providerName
            providerNameDisplay
          }
          deliveries {
            ...CampaignStreamingDelivery
          }
        }
      }
    }
  }
}
    ${CampaignDynamicDeliveryFragmentDoc}
${CampaignStreamingDeliveryFragmentDoc}`;

/**
 * __useCampaignTrackingUrlsQuery__
 *
 * To run a query within a React component, call `useCampaignTrackingUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignTrackingUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignTrackingUrlsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignTrackingUrlsQuery(baseOptions: Apollo.QueryHookOptions<CampaignTrackingUrlsQuery, CampaignTrackingUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignTrackingUrlsQuery, CampaignTrackingUrlsQueryVariables>(CampaignTrackingUrlsDocument, options);
      }
export function useCampaignTrackingUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignTrackingUrlsQuery, CampaignTrackingUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignTrackingUrlsQuery, CampaignTrackingUrlsQueryVariables>(CampaignTrackingUrlsDocument, options);
        }
export type CampaignTrackingUrlsQueryHookResult = ReturnType<typeof useCampaignTrackingUrlsQuery>;
export type CampaignTrackingUrlsLazyQueryHookResult = ReturnType<typeof useCampaignTrackingUrlsLazyQuery>;
export type CampaignTrackingUrlsQueryResult = Apollo.QueryResult<CampaignTrackingUrlsQuery, CampaignTrackingUrlsQueryVariables>;
export const CampaignDocument = gql`
    query Campaign($organizationId: ID!, $slug: String!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(slug: $slug) {
        ...Campaign
      }
    }
  }
}
    ${CampaignFragmentDoc}`;

/**
 * __useCampaignQuery__
 *
 * To run a query within a React component, call `useCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCampaignQuery(baseOptions: Apollo.QueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
      }
export function useCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export type CampaignQueryHookResult = ReturnType<typeof useCampaignQuery>;
export type CampaignLazyQueryHookResult = ReturnType<typeof useCampaignLazyQuery>;
export type CampaignQueryResult = Apollo.QueryResult<CampaignQuery, CampaignQueryVariables>;
export const CampaignsConfirmTrackingUrlsDocument = gql`
    query CampaignsConfirmTrackingUrls($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaigns(query: {states: ["draft"]}) {
        results {
          id
          name
          state
          slug
          advertiser {
            name
          }
          kind
          createdAt
          campaignDynamics {
            id
            deliveries {
              id
            }
          }
          campaignStreamings {
            id
            deliveries {
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignsConfirmTrackingUrlsQuery__
 *
 * To run a query within a React component, call `useCampaignsConfirmTrackingUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsConfirmTrackingUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsConfirmTrackingUrlsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCampaignsConfirmTrackingUrlsQuery(baseOptions: Apollo.QueryHookOptions<CampaignsConfirmTrackingUrlsQuery, CampaignsConfirmTrackingUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsConfirmTrackingUrlsQuery, CampaignsConfirmTrackingUrlsQueryVariables>(CampaignsConfirmTrackingUrlsDocument, options);
      }
export function useCampaignsConfirmTrackingUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsConfirmTrackingUrlsQuery, CampaignsConfirmTrackingUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsConfirmTrackingUrlsQuery, CampaignsConfirmTrackingUrlsQueryVariables>(CampaignsConfirmTrackingUrlsDocument, options);
        }
export type CampaignsConfirmTrackingUrlsQueryHookResult = ReturnType<typeof useCampaignsConfirmTrackingUrlsQuery>;
export type CampaignsConfirmTrackingUrlsLazyQueryHookResult = ReturnType<typeof useCampaignsConfirmTrackingUrlsLazyQuery>;
export type CampaignsConfirmTrackingUrlsQueryResult = Apollo.QueryResult<CampaignsConfirmTrackingUrlsQuery, CampaignsConfirmTrackingUrlsQueryVariables>;
export const CampaignsForPublisherReviewDocument = gql`
    query CampaignsForPublisherReview($organizationId: ID!, $limit: Int, $offset: Int, $name: String, $sort: [String]) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaigns(
        query: {states: ["draft", "live", "ready", "complete", "requested", "agency"], isCreatedByBrand: true, isPublisherApproved: false, limit: $limit, offset: $offset, name: $name, sort: $sort}
      ) {
        resultsCount
        results {
          id
          name
          kind
          state
          slug
          startAt
          endAt
          createdAt
          advertiser {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignsForPublisherReviewQuery__
 *
 * To run a query within a React component, call `useCampaignsForPublisherReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsForPublisherReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsForPublisherReviewQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      name: // value for 'name'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCampaignsForPublisherReviewQuery(baseOptions: Apollo.QueryHookOptions<CampaignsForPublisherReviewQuery, CampaignsForPublisherReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsForPublisherReviewQuery, CampaignsForPublisherReviewQueryVariables>(CampaignsForPublisherReviewDocument, options);
      }
export function useCampaignsForPublisherReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsForPublisherReviewQuery, CampaignsForPublisherReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsForPublisherReviewQuery, CampaignsForPublisherReviewQueryVariables>(CampaignsForPublisherReviewDocument, options);
        }
export type CampaignsForPublisherReviewQueryHookResult = ReturnType<typeof useCampaignsForPublisherReviewQuery>;
export type CampaignsForPublisherReviewLazyQueryHookResult = ReturnType<typeof useCampaignsForPublisherReviewLazyQuery>;
export type CampaignsForPublisherReviewQueryResult = Apollo.QueryResult<CampaignsForPublisherReviewQuery, CampaignsForPublisherReviewQueryVariables>;
export const CampaignsImpressionsMaxDocument = gql`
    query CampaignsImpressionsMax($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaignsImpressionsMax
    }
  }
}
    `;

/**
 * __useCampaignsImpressionsMaxQuery__
 *
 * To run a query within a React component, call `useCampaignsImpressionsMaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsImpressionsMaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsImpressionsMaxQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCampaignsImpressionsMaxQuery(baseOptions: Apollo.QueryHookOptions<CampaignsImpressionsMaxQuery, CampaignsImpressionsMaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsImpressionsMaxQuery, CampaignsImpressionsMaxQueryVariables>(CampaignsImpressionsMaxDocument, options);
      }
export function useCampaignsImpressionsMaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsImpressionsMaxQuery, CampaignsImpressionsMaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsImpressionsMaxQuery, CampaignsImpressionsMaxQueryVariables>(CampaignsImpressionsMaxDocument, options);
        }
export type CampaignsImpressionsMaxQueryHookResult = ReturnType<typeof useCampaignsImpressionsMaxQuery>;
export type CampaignsImpressionsMaxLazyQueryHookResult = ReturnType<typeof useCampaignsImpressionsMaxLazyQuery>;
export type CampaignsImpressionsMaxQueryResult = Apollo.QueryResult<CampaignsImpressionsMaxQuery, CampaignsImpressionsMaxQueryVariables>;
export const CampaignsDocument = gql`
    query Campaigns($organizationId: ID!, $query: CampaignFilterQuery) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaigns(query: $query) {
        resultsCount
        results {
          ...CampaignDetails
          advertiser {
            id
            name
          }
          organization {
            id
            name
          }
          campaignPodcasts {
            id
            isPreRoll
            isMidRoll
            isPostRoll
            downloadTotal
          }
        }
      }
    }
  }
}
    ${CampaignDetailsFragmentDoc}`;

/**
 * __useCampaignsQuery__
 *
 * To run a query within a React component, call `useCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCampaignsQuery(baseOptions: Apollo.QueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
      }
export function useCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
        }
export type CampaignsQueryHookResult = ReturnType<typeof useCampaignsQuery>;
export type CampaignsLazyQueryHookResult = ReturnType<typeof useCampaignsLazyQuery>;
export type CampaignsQueryResult = Apollo.QueryResult<CampaignsQuery, CampaignsQueryVariables>;
export const CompanyIndustryDocument = gql`
    query CompanyIndustry($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      companies {
        id
        name
        slug
        industry
      }
    }
  }
}
    `;

/**
 * __useCompanyIndustryQuery__
 *
 * To run a query within a React component, call `useCompanyIndustryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyIndustryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyIndustryQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCompanyIndustryQuery(baseOptions: Apollo.QueryHookOptions<CompanyIndustryQuery, CompanyIndustryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyIndustryQuery, CompanyIndustryQueryVariables>(CompanyIndustryDocument, options);
      }
export function useCompanyIndustryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyIndustryQuery, CompanyIndustryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyIndustryQuery, CompanyIndustryQueryVariables>(CompanyIndustryDocument, options);
        }
export type CompanyIndustryQueryHookResult = ReturnType<typeof useCompanyIndustryQuery>;
export type CompanyIndustryLazyQueryHookResult = ReturnType<typeof useCompanyIndustryLazyQuery>;
export type CompanyIndustryQueryResult = Apollo.QueryResult<CompanyIndustryQuery, CompanyIndustryQueryVariables>;
export const CompanyMembersDocument = gql`
    query CompanyMembers($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      limitedCompany(id: $id) {
        ...LimitedCompanyMembers
      }
    }
  }
}
    ${LimitedCompanyMembersFragmentDoc}`;

/**
 * __useCompanyMembersQuery__
 *
 * To run a query within a React component, call `useCompanyMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyMembersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyMembersQuery(baseOptions: Apollo.QueryHookOptions<CompanyMembersQuery, CompanyMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyMembersQuery, CompanyMembersQueryVariables>(CompanyMembersDocument, options);
      }
export function useCompanyMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyMembersQuery, CompanyMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyMembersQuery, CompanyMembersQueryVariables>(CompanyMembersDocument, options);
        }
export type CompanyMembersQueryHookResult = ReturnType<typeof useCompanyMembersQuery>;
export type CompanyMembersLazyQueryHookResult = ReturnType<typeof useCompanyMembersLazyQuery>;
export type CompanyMembersQueryResult = Apollo.QueryResult<CompanyMembersQuery, CompanyMembersQueryVariables>;
export const AdvisorContentMaturityDocument = gql`
    query AdvisorContentMaturity($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      advisor {
        id
        columnGroups {
          contentMaturity {
            ...AdvisorColumnGroupFields
          }
        }
      }
    }
  }
}
    ${AdvisorColumnGroupFieldsFragmentDoc}`;

/**
 * __useAdvisorContentMaturityQuery__
 *
 * To run a query within a React component, call `useAdvisorContentMaturityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdvisorContentMaturityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvisorContentMaturityQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAdvisorContentMaturityQuery(baseOptions: Apollo.QueryHookOptions<AdvisorContentMaturityQuery, AdvisorContentMaturityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvisorContentMaturityQuery, AdvisorContentMaturityQueryVariables>(AdvisorContentMaturityDocument, options);
      }
export function useAdvisorContentMaturityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvisorContentMaturityQuery, AdvisorContentMaturityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvisorContentMaturityQuery, AdvisorContentMaturityQueryVariables>(AdvisorContentMaturityDocument, options);
        }
export type AdvisorContentMaturityQueryHookResult = ReturnType<typeof useAdvisorContentMaturityQuery>;
export type AdvisorContentMaturityLazyQueryHookResult = ReturnType<typeof useAdvisorContentMaturityLazyQuery>;
export type AdvisorContentMaturityQueryResult = Apollo.QueryResult<AdvisorContentMaturityQuery, AdvisorContentMaturityQueryVariables>;
export const DeleteCampaignDynamicReasonsDocument = gql`
    query DeleteCampaignDynamicReasons($organizationId: ID!, $campaignId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        campaignDynamic(id: $id) {
          deleteReasons {
            deleteReason
            deleteReasonDisplay
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDeleteCampaignDynamicReasonsQuery__
 *
 * To run a query within a React component, call `useDeleteCampaignDynamicReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignDynamicReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteCampaignDynamicReasonsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCampaignDynamicReasonsQuery(baseOptions: Apollo.QueryHookOptions<DeleteCampaignDynamicReasonsQuery, DeleteCampaignDynamicReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeleteCampaignDynamicReasonsQuery, DeleteCampaignDynamicReasonsQueryVariables>(DeleteCampaignDynamicReasonsDocument, options);
      }
export function useDeleteCampaignDynamicReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeleteCampaignDynamicReasonsQuery, DeleteCampaignDynamicReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeleteCampaignDynamicReasonsQuery, DeleteCampaignDynamicReasonsQueryVariables>(DeleteCampaignDynamicReasonsDocument, options);
        }
export type DeleteCampaignDynamicReasonsQueryHookResult = ReturnType<typeof useDeleteCampaignDynamicReasonsQuery>;
export type DeleteCampaignDynamicReasonsLazyQueryHookResult = ReturnType<typeof useDeleteCampaignDynamicReasonsLazyQuery>;
export type DeleteCampaignDynamicReasonsQueryResult = Apollo.QueryResult<DeleteCampaignDynamicReasonsQuery, DeleteCampaignDynamicReasonsQueryVariables>;
export const DeleteCampaignPodcastReasonsDocument = gql`
    query DeleteCampaignPodcastReasons($organizationId: ID!, $campaignId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        campaignPodcast(id: $id) {
          id
          deleteReasons {
            deleteReason
            deleteReasonDisplay
          }
        }
      }
    }
  }
}
    `;

/**
 * __useDeleteCampaignPodcastReasonsQuery__
 *
 * To run a query within a React component, call `useDeleteCampaignPodcastReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignPodcastReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeleteCampaignPodcastReasonsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCampaignPodcastReasonsQuery(baseOptions: Apollo.QueryHookOptions<DeleteCampaignPodcastReasonsQuery, DeleteCampaignPodcastReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeleteCampaignPodcastReasonsQuery, DeleteCampaignPodcastReasonsQueryVariables>(DeleteCampaignPodcastReasonsDocument, options);
      }
export function useDeleteCampaignPodcastReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeleteCampaignPodcastReasonsQuery, DeleteCampaignPodcastReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeleteCampaignPodcastReasonsQuery, DeleteCampaignPodcastReasonsQueryVariables>(DeleteCampaignPodcastReasonsDocument, options);
        }
export type DeleteCampaignPodcastReasonsQueryHookResult = ReturnType<typeof useDeleteCampaignPodcastReasonsQuery>;
export type DeleteCampaignPodcastReasonsLazyQueryHookResult = ReturnType<typeof useDeleteCampaignPodcastReasonsLazyQuery>;
export type DeleteCampaignPodcastReasonsQueryResult = Apollo.QueryResult<DeleteCampaignPodcastReasonsQuery, DeleteCampaignPodcastReasonsQueryVariables>;
export const ExportInstanceDocument = gql`
    query ExportInstance($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      exports {
        id
        exportInstance(id: $id) {
          id
          downloadUrl
        }
      }
    }
  }
}
    `;

/**
 * __useExportInstanceQuery__
 *
 * To run a query within a React component, call `useExportInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportInstanceQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExportInstanceQuery(baseOptions: Apollo.QueryHookOptions<ExportInstanceQuery, ExportInstanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportInstanceQuery, ExportInstanceQueryVariables>(ExportInstanceDocument, options);
      }
export function useExportInstanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportInstanceQuery, ExportInstanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportInstanceQuery, ExportInstanceQueryVariables>(ExportInstanceDocument, options);
        }
export type ExportInstanceQueryHookResult = ReturnType<typeof useExportInstanceQuery>;
export type ExportInstanceLazyQueryHookResult = ReturnType<typeof useExportInstanceLazyQuery>;
export type ExportInstanceQueryResult = Apollo.QueryResult<ExportInstanceQuery, ExportInstanceQueryVariables>;
export const ExportInstancesDocument = gql`
    query ExportInstances($id: ID!) {
  me {
    id
    organization(id: $id) {
      id
      exports {
        id
        organizationId
        exportInstances {
          id
          exportType
          status
          updatedAt
          savedExport {
            id
            name
          }
          organization {
            id
          }
          createdBy {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useExportInstancesQuery__
 *
 * To run a query within a React component, call `useExportInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportInstancesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExportInstancesQuery(baseOptions: Apollo.QueryHookOptions<ExportInstancesQuery, ExportInstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportInstancesQuery, ExportInstancesQueryVariables>(ExportInstancesDocument, options);
      }
export function useExportInstancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportInstancesQuery, ExportInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportInstancesQuery, ExportInstancesQueryVariables>(ExportInstancesDocument, options);
        }
export type ExportInstancesQueryHookResult = ReturnType<typeof useExportInstancesQuery>;
export type ExportInstancesLazyQueryHookResult = ReturnType<typeof useExportInstancesLazyQuery>;
export type ExportInstancesQueryResult = Apollo.QueryResult<ExportInstancesQuery, ExportInstancesQueryVariables>;
export const ExportTypesColumnsDocument = gql`
    query ExportTypesColumns($organizationId: ID!, $typeId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      exports {
        id
        exportTypes {
          id
          columns(typeId: $typeId) {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useExportTypesColumnsQuery__
 *
 * To run a query within a React component, call `useExportTypesColumnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTypesColumnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTypesColumnsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      typeId: // value for 'typeId'
 *   },
 * });
 */
export function useExportTypesColumnsQuery(baseOptions: Apollo.QueryHookOptions<ExportTypesColumnsQuery, ExportTypesColumnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportTypesColumnsQuery, ExportTypesColumnsQueryVariables>(ExportTypesColumnsDocument, options);
      }
export function useExportTypesColumnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportTypesColumnsQuery, ExportTypesColumnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportTypesColumnsQuery, ExportTypesColumnsQueryVariables>(ExportTypesColumnsDocument, options);
        }
export type ExportTypesColumnsQueryHookResult = ReturnType<typeof useExportTypesColumnsQuery>;
export type ExportTypesColumnsLazyQueryHookResult = ReturnType<typeof useExportTypesColumnsLazyQuery>;
export type ExportTypesColumnsQueryResult = Apollo.QueryResult<ExportTypesColumnsQuery, ExportTypesColumnsQueryVariables>;
export const ExportTypesDocument = gql`
    query ExportTypes($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      exports {
        id
        exportTypes {
          ...ExportTypes
        }
      }
    }
  }
}
    ${ExportTypesFragmentDoc}`;

/**
 * __useExportTypesQuery__
 *
 * To run a query within a React component, call `useExportTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTypesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useExportTypesQuery(baseOptions: Apollo.QueryHookOptions<ExportTypesQuery, ExportTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportTypesQuery, ExportTypesQueryVariables>(ExportTypesDocument, options);
      }
export function useExportTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportTypesQuery, ExportTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportTypesQuery, ExportTypesQueryVariables>(ExportTypesDocument, options);
        }
export type ExportTypesQueryHookResult = ReturnType<typeof useExportTypesQuery>;
export type ExportTypesLazyQueryHookResult = ReturnType<typeof useExportTypesLazyQuery>;
export type ExportTypesQueryResult = Apollo.QueryResult<ExportTypesQuery, ExportTypesQueryVariables>;
export const FutureEpisodesDocument = gql`
    query FutureEpisodes($organizationId: ID!, $after: String, $before: String) {
  me {
    organization(id: $organizationId) {
      id
      futureEpisodes(after: $after, before: $before) {
        id
        expectedPublished
        podcast {
          id
          feed {
            id
            title
            description(words: 15)
            image {
              id
              href
              path
            }
          }
        }
        campaignEpisodes {
          id
          campaignPodcast {
            id
            campaign {
              id
              slug
              name
              organization {
                id
                name
                slug
                kind
              }
              advertiser {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFutureEpisodesQuery__
 *
 * To run a query within a React component, call `useFutureEpisodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFutureEpisodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFutureEpisodesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useFutureEpisodesQuery(baseOptions: Apollo.QueryHookOptions<FutureEpisodesQuery, FutureEpisodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FutureEpisodesQuery, FutureEpisodesQueryVariables>(FutureEpisodesDocument, options);
      }
export function useFutureEpisodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FutureEpisodesQuery, FutureEpisodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FutureEpisodesQuery, FutureEpisodesQueryVariables>(FutureEpisodesDocument, options);
        }
export type FutureEpisodesQueryHookResult = ReturnType<typeof useFutureEpisodesQuery>;
export type FutureEpisodesLazyQueryHookResult = ReturnType<typeof useFutureEpisodesLazyQuery>;
export type FutureEpisodesQueryResult = Apollo.QueryResult<FutureEpisodesQuery, FutureEpisodesQueryVariables>;
export const HasSeenAdAnalyticsWelcomeDocument = gql`
    query hasSeenAdAnalyticsWelcome {
  me {
    hasSeenAdAnalyticsWelcome
  }
}
    `;

/**
 * __useHasSeenAdAnalyticsWelcomeQuery__
 *
 * To run a query within a React component, call `useHasSeenAdAnalyticsWelcomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasSeenAdAnalyticsWelcomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasSeenAdAnalyticsWelcomeQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasSeenAdAnalyticsWelcomeQuery(baseOptions?: Apollo.QueryHookOptions<HasSeenAdAnalyticsWelcomeQuery, HasSeenAdAnalyticsWelcomeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasSeenAdAnalyticsWelcomeQuery, HasSeenAdAnalyticsWelcomeQueryVariables>(HasSeenAdAnalyticsWelcomeDocument, options);
      }
export function useHasSeenAdAnalyticsWelcomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasSeenAdAnalyticsWelcomeQuery, HasSeenAdAnalyticsWelcomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasSeenAdAnalyticsWelcomeQuery, HasSeenAdAnalyticsWelcomeQueryVariables>(HasSeenAdAnalyticsWelcomeDocument, options);
        }
export type HasSeenAdAnalyticsWelcomeQueryHookResult = ReturnType<typeof useHasSeenAdAnalyticsWelcomeQuery>;
export type HasSeenAdAnalyticsWelcomeLazyQueryHookResult = ReturnType<typeof useHasSeenAdAnalyticsWelcomeLazyQuery>;
export type HasSeenAdAnalyticsWelcomeQueryResult = Apollo.QueryResult<HasSeenAdAnalyticsWelcomeQuery, HasSeenAdAnalyticsWelcomeQueryVariables>;
export const LiftReportPreCreateCampaignDocument = gql`
    query LiftReportPreCreateCampaign($organizationId: ID!, $campaignId: ID!, $after: String!, $before: String!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(id: $campaignId) {
        id
        downloads {
          hourly(after: $after, before: $before, interval: "day") {
            hour
            count
          }
        }
        stateOverview {
          pixel {
            historical(after: $after, before: $before) {
              day
              init
              lead
              purchase
              installed
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLiftReportPreCreateCampaignQuery__
 *
 * To run a query within a React component, call `useLiftReportPreCreateCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiftReportPreCreateCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiftReportPreCreateCampaignQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      campaignId: // value for 'campaignId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useLiftReportPreCreateCampaignQuery(baseOptions: Apollo.QueryHookOptions<LiftReportPreCreateCampaignQuery, LiftReportPreCreateCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiftReportPreCreateCampaignQuery, LiftReportPreCreateCampaignQueryVariables>(LiftReportPreCreateCampaignDocument, options);
      }
export function useLiftReportPreCreateCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiftReportPreCreateCampaignQuery, LiftReportPreCreateCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiftReportPreCreateCampaignQuery, LiftReportPreCreateCampaignQueryVariables>(LiftReportPreCreateCampaignDocument, options);
        }
export type LiftReportPreCreateCampaignQueryHookResult = ReturnType<typeof useLiftReportPreCreateCampaignQuery>;
export type LiftReportPreCreateCampaignLazyQueryHookResult = ReturnType<typeof useLiftReportPreCreateCampaignLazyQuery>;
export type LiftReportPreCreateCampaignQueryResult = Apollo.QueryResult<LiftReportPreCreateCampaignQuery, LiftReportPreCreateCampaignQueryVariables>;
export const LiftReportPreCreateDocument = gql`
    query LiftReportPreCreate($organizationId: ID!, $liftReportId: ID!, $after: String!, $before: String!) {
  me {
    id
    organization(id: $organizationId) {
      id
      liftReport(id: $liftReportId) {
        campaign {
          downloads {
            hourly(after: $after, before: $before, interval: "day") {
              hour
              count
            }
          }
          stateOverview {
            pixel {
              historical(after: $after, before: $before) {
                day
                init
                lead
                purchase
                installed
              }
            }
          }
        }
        campaigns {
          downloads {
            hourly(after: $after, before: $before, interval: "day") {
              hour
              count
            }
          }
          stateOverview {
            pixel {
              historical(after: $after, before: $before) {
                day
                init
                lead
                purchase
                installed
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLiftReportPreCreateQuery__
 *
 * To run a query within a React component, call `useLiftReportPreCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiftReportPreCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiftReportPreCreateQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      liftReportId: // value for 'liftReportId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useLiftReportPreCreateQuery(baseOptions: Apollo.QueryHookOptions<LiftReportPreCreateQuery, LiftReportPreCreateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiftReportPreCreateQuery, LiftReportPreCreateQueryVariables>(LiftReportPreCreateDocument, options);
      }
export function useLiftReportPreCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiftReportPreCreateQuery, LiftReportPreCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiftReportPreCreateQuery, LiftReportPreCreateQueryVariables>(LiftReportPreCreateDocument, options);
        }
export type LiftReportPreCreateQueryHookResult = ReturnType<typeof useLiftReportPreCreateQuery>;
export type LiftReportPreCreateLazyQueryHookResult = ReturnType<typeof useLiftReportPreCreateLazyQuery>;
export type LiftReportPreCreateQueryResult = Apollo.QueryResult<LiftReportPreCreateQuery, LiftReportPreCreateQueryVariables>;
export const LiftReportPreRunDocument = gql`
    query LiftReportPreRun($organizationId: ID!, $liftReportId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      liftReport(id: $liftReportId) {
        campaign {
          id
          kind
          slug
          name
          pixels {
            key
          }
          campaignPodcasts {
            id
            campaignEpisodes {
              ...CampaignEpisode
            }
          }
          campaignDynamics {
            ...CampaignDynamic
          }
          campaignNoises {
            ...CampaignNoise
          }
        }
        campaigns {
          id
          kind
          slug
          name
          currency
          pixels {
            key
          }
          campaignPodcasts {
            id
            campaignEpisodes {
              ...CampaignEpisode
            }
          }
          campaignDynamics {
            ...CampaignDynamic
          }
          campaignNoises {
            ...CampaignNoise
          }
        }
      }
    }
  }
}
    ${CampaignEpisodeFragmentDoc}
${CampaignDynamicFragmentDoc}
${CampaignNoiseFragmentDoc}`;

/**
 * __useLiftReportPreRunQuery__
 *
 * To run a query within a React component, call `useLiftReportPreRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiftReportPreRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiftReportPreRunQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      liftReportId: // value for 'liftReportId'
 *   },
 * });
 */
export function useLiftReportPreRunQuery(baseOptions: Apollo.QueryHookOptions<LiftReportPreRunQuery, LiftReportPreRunQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiftReportPreRunQuery, LiftReportPreRunQueryVariables>(LiftReportPreRunDocument, options);
      }
export function useLiftReportPreRunLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiftReportPreRunQuery, LiftReportPreRunQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiftReportPreRunQuery, LiftReportPreRunQueryVariables>(LiftReportPreRunDocument, options);
        }
export type LiftReportPreRunQueryHookResult = ReturnType<typeof useLiftReportPreRunQuery>;
export type LiftReportPreRunLazyQueryHookResult = ReturnType<typeof useLiftReportPreRunLazyQuery>;
export type LiftReportPreRunQueryResult = Apollo.QueryResult<LiftReportPreRunQuery, LiftReportPreRunQueryVariables>;
export const LiftReportDocument = gql`
    query LiftReport($organizationId: ID!, $id: ID!, $after: Int, $before: Int) {
  me {
    id
    organization(id: $organizationId) {
      id
      liftReport(id: $id) {
        ...LiftReportFields
        campaign {
          id
          name
          slug
          startAt
          endAt
          currency
        }
        campaigns {
          id
          name
          slug
          startAt
          endAt
          currency
        }
        lift(after: $after, before: $before) {
          averages {
            groupId
            groupType
            groupName
            groupCost
            kind
            avgInitValue
            avgInitPercentage
            avgPurchaseValue
            avgPurchasePercentage
            avgLeadValue
            avgLeadPercentage
            avgInstalledValue
            avgInstalledPercentage
            groupHouseholds
            groupReach
            multiplier
            campaignPodcast {
              id
              feed {
                id
                title
                description(words: 50)
                image {
                  id
                  path
                }
              }
            }
            campaignDynamic {
              id
              name
            }
          }
          nodes {
            week
            groupId
            groupType
            groupName
            kind
            campaignId
            initValue
            initPercentage
            purchaseValue
            purchasePercentage
            leadValue
            leadPercentage
            installedValue
            installedPercentage
          }
        }
      }
    }
  }
}
    ${LiftReportFieldsFragmentDoc}`;

/**
 * __useLiftReportQuery__
 *
 * To run a query within a React component, call `useLiftReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiftReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiftReportQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useLiftReportQuery(baseOptions: Apollo.QueryHookOptions<LiftReportQuery, LiftReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiftReportQuery, LiftReportQueryVariables>(LiftReportDocument, options);
      }
export function useLiftReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiftReportQuery, LiftReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiftReportQuery, LiftReportQueryVariables>(LiftReportDocument, options);
        }
export type LiftReportQueryHookResult = ReturnType<typeof useLiftReportQuery>;
export type LiftReportLazyQueryHookResult = ReturnType<typeof useLiftReportLazyQuery>;
export type LiftReportQueryResult = Apollo.QueryResult<LiftReportQuery, LiftReportQueryVariables>;
export const LiftReportsDocument = gql`
    query LiftReports($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      liftReports {
        ...LiftReportFields
        campaign {
          id
          name
          slug
          startAt
          endAt
          currency
        }
        campaigns {
          id
          name
          slug
          startAt
          endAt
          currency
        }
      }
    }
  }
}
    ${LiftReportFieldsFragmentDoc}`;

/**
 * __useLiftReportsQuery__
 *
 * To run a query within a React component, call `useLiftReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiftReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiftReportsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useLiftReportsQuery(baseOptions: Apollo.QueryHookOptions<LiftReportsQuery, LiftReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiftReportsQuery, LiftReportsQueryVariables>(LiftReportsDocument, options);
      }
export function useLiftReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiftReportsQuery, LiftReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiftReportsQuery, LiftReportsQueryVariables>(LiftReportsDocument, options);
        }
export type LiftReportsQueryHookResult = ReturnType<typeof useLiftReportsQuery>;
export type LiftReportsLazyQueryHookResult = ReturnType<typeof useLiftReportsLazyQuery>;
export type LiftReportsQueryResult = Apollo.QueryResult<LiftReportsQuery, LiftReportsQueryVariables>;
export const LimitedCompanyDocument = gql`
    query LimitedCompany($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      limitedCompany(id: $id) {
        id
        name
        organization {
          id
          members {
            firstName
            lastName
          }
          managers {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLimitedCompanyQuery__
 *
 * To run a query within a React component, call `useLimitedCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useLimitedCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLimitedCompanyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLimitedCompanyQuery(baseOptions: Apollo.QueryHookOptions<LimitedCompanyQuery, LimitedCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LimitedCompanyQuery, LimitedCompanyQueryVariables>(LimitedCompanyDocument, options);
      }
export function useLimitedCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LimitedCompanyQuery, LimitedCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LimitedCompanyQuery, LimitedCompanyQueryVariables>(LimitedCompanyDocument, options);
        }
export type LimitedCompanyQueryHookResult = ReturnType<typeof useLimitedCompanyQuery>;
export type LimitedCompanyLazyQueryHookResult = ReturnType<typeof useLimitedCompanyLazyQuery>;
export type LimitedCompanyQueryResult = Apollo.QueryResult<LimitedCompanyQuery, LimitedCompanyQueryVariables>;
export const LocationsDocument = gql`
    query Locations {
  locations {
    locationName
    locationNameDisplay
  }
}
    `;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: Apollo.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
      }
export function useLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsQueryResult = Apollo.QueryResult<LocationsQuery, LocationsQueryVariables>;
export const MultiBillingRecordsDocument = gql`
    query MultiBillingRecords($organizationId: ID!, $after: String!, $before: String!) {
  me {
    organization(id: $organizationId) {
      id
      multiBillingRecords(after: $after, before: $before) {
        simpleBillingRecords {
          ...SimpleBillingRecord
        }
        dailyCampaignBillingRecords {
          ...DailyBillingRecord
        }
      }
    }
  }
}
    ${SimpleBillingRecordFragmentDoc}
${DailyBillingRecordFragmentDoc}`;

/**
 * __useMultiBillingRecordsQuery__
 *
 * To run a query within a React component, call `useMultiBillingRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMultiBillingRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMultiBillingRecordsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useMultiBillingRecordsQuery(baseOptions: Apollo.QueryHookOptions<MultiBillingRecordsQuery, MultiBillingRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MultiBillingRecordsQuery, MultiBillingRecordsQueryVariables>(MultiBillingRecordsDocument, options);
      }
export function useMultiBillingRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MultiBillingRecordsQuery, MultiBillingRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MultiBillingRecordsQuery, MultiBillingRecordsQueryVariables>(MultiBillingRecordsDocument, options);
        }
export type MultiBillingRecordsQueryHookResult = ReturnType<typeof useMultiBillingRecordsQuery>;
export type MultiBillingRecordsLazyQueryHookResult = ReturnType<typeof useMultiBillingRecordsLazyQuery>;
export type MultiBillingRecordsQueryResult = Apollo.QueryResult<MultiBillingRecordsQuery, MultiBillingRecordsQueryVariables>;
export const BuySideOrganizationDocument = gql`
    query BuySideOrganization($slug: String!) {
  me {
    id
    organization(slug: $slug) {
      id
      name
      slug
      mode
      kind
      downloadAlgorithm
      meRole
      companies {
        id
        slug
        name
        description
        url
        image {
          id
          width
          height
          src
          path
        }
        hasCampaigns
        organization {
          id
          name
          kind
          slug
          keys {
            key
            role
            domain
            createdAt
          }
        }
        campaigns {
          id
          state
        }
      }
      managing {
        id
        name
        slug
        kind
      }
    }
  }
}
    `;

/**
 * __useBuySideOrganizationQuery__
 *
 * To run a query within a React component, call `useBuySideOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuySideOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuySideOrganizationQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useBuySideOrganizationQuery(baseOptions: Apollo.QueryHookOptions<BuySideOrganizationQuery, BuySideOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuySideOrganizationQuery, BuySideOrganizationQueryVariables>(BuySideOrganizationDocument, options);
      }
export function useBuySideOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuySideOrganizationQuery, BuySideOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuySideOrganizationQuery, BuySideOrganizationQueryVariables>(BuySideOrganizationDocument, options);
        }
export type BuySideOrganizationQueryHookResult = ReturnType<typeof useBuySideOrganizationQuery>;
export type BuySideOrganizationLazyQueryHookResult = ReturnType<typeof useBuySideOrganizationLazyQuery>;
export type BuySideOrganizationQueryResult = Apollo.QueryResult<BuySideOrganizationQuery, BuySideOrganizationQueryVariables>;
export const OrganizationProvidersDocument = gql`
    query OrganizationProviders($organizationId: ID!) {
  me {
    organization(id: $organizationId) {
      dynamicProviderOptions {
        providerName
        providerNameDisplay
      }
      streamingProviderOptions {
        providerName
        providerNameDisplay
      }
    }
  }
}
    `;

/**
 * __useOrganizationProvidersQuery__
 *
 * To run a query within a React component, call `useOrganizationProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationProvidersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationProvidersQuery(baseOptions: Apollo.QueryHookOptions<OrganizationProvidersQuery, OrganizationProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationProvidersQuery, OrganizationProvidersQueryVariables>(OrganizationProvidersDocument, options);
      }
export function useOrganizationProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationProvidersQuery, OrganizationProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationProvidersQuery, OrganizationProvidersQueryVariables>(OrganizationProvidersDocument, options);
        }
export type OrganizationProvidersQueryHookResult = ReturnType<typeof useOrganizationProvidersQuery>;
export type OrganizationProvidersLazyQueryHookResult = ReturnType<typeof useOrganizationProvidersLazyQuery>;
export type OrganizationProvidersQueryResult = Apollo.QueryResult<OrganizationProvidersQuery, OrganizationProvidersQueryVariables>;
export const OverviewImpressionsReachDocument = gql`
    query OverviewImpressionsReach($id: ID!, $after: Date, $before: Date, $campaignIds: [ID]) {
  me {
    id
    organization(id: $id) {
      id
      overview {
        impressions(campaignIds: $campaignIds, after: $after, before: $before) {
          impressions
          reach
        }
      }
    }
  }
}
    `;

/**
 * __useOverviewImpressionsReachQuery__
 *
 * To run a query within a React component, call `useOverviewImpressionsReachQuery` and pass it any options that fit your needs.
 * When your component renders, `useOverviewImpressionsReachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOverviewImpressionsReachQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      campaignIds: // value for 'campaignIds'
 *   },
 * });
 */
export function useOverviewImpressionsReachQuery(baseOptions: Apollo.QueryHookOptions<OverviewImpressionsReachQuery, OverviewImpressionsReachQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OverviewImpressionsReachQuery, OverviewImpressionsReachQueryVariables>(OverviewImpressionsReachDocument, options);
      }
export function useOverviewImpressionsReachLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OverviewImpressionsReachQuery, OverviewImpressionsReachQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OverviewImpressionsReachQuery, OverviewImpressionsReachQueryVariables>(OverviewImpressionsReachDocument, options);
        }
export type OverviewImpressionsReachQueryHookResult = ReturnType<typeof useOverviewImpressionsReachQuery>;
export type OverviewImpressionsReachLazyQueryHookResult = ReturnType<typeof useOverviewImpressionsReachLazyQuery>;
export type OverviewImpressionsReachQueryResult = Apollo.QueryResult<OverviewImpressionsReachQuery, OverviewImpressionsReachQueryVariables>;
export const PodcastEpisodesDetailDocument = gql`
    query PodcastEpisodesDetail($organizationId: ID!, $id: ID!, $after: String!, $algorithm: String, $offset: Int, $limit: Int) {
  me {
    id
    organization(id: $organizationId) {
      id
      podcast(id: $id) {
        id
        createdAt
        feed {
          id
          image {
            id
            path
          }
          episodesCount(after: $after)
          episodes(after: $after, offset: $offset, limit: $limit) {
            id
            title
            description(words: 25)
            hasNoAds
            published
            image {
              id
              href
              path
            }
            placementsCount
            downloads(algorithm: $algorithm) {
              count
            }
            enclosure {
              id
              duration
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePodcastEpisodesDetailQuery__
 *
 * To run a query within a React component, call `usePodcastEpisodesDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcastEpisodesDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcastEpisodesDetailQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      algorithm: // value for 'algorithm'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePodcastEpisodesDetailQuery(baseOptions: Apollo.QueryHookOptions<PodcastEpisodesDetailQuery, PodcastEpisodesDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcastEpisodesDetailQuery, PodcastEpisodesDetailQueryVariables>(PodcastEpisodesDetailDocument, options);
      }
export function usePodcastEpisodesDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcastEpisodesDetailQuery, PodcastEpisodesDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcastEpisodesDetailQuery, PodcastEpisodesDetailQueryVariables>(PodcastEpisodesDetailDocument, options);
        }
export type PodcastEpisodesDetailQueryHookResult = ReturnType<typeof usePodcastEpisodesDetailQuery>;
export type PodcastEpisodesDetailLazyQueryHookResult = ReturnType<typeof usePodcastEpisodesDetailLazyQuery>;
export type PodcastEpisodesDetailQueryResult = Apollo.QueryResult<PodcastEpisodesDetailQuery, PodcastEpisodesDetailQueryVariables>;
export const PodcastExperianTypesDocument = gql`
    query PodcastExperianTypes($organizationId: ID!, $podcastId: ID!) {
  me {
    organization(id: $organizationId) {
      advisor {
        podcast(id: $podcastId) {
          feed {
            id
            title
            mosaicTypes {
              types {
                name
                descr
                feat1
                feat2
                feat3
                feat4
                feat5
                feat6
                index
                percentOfPop
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePodcastExperianTypesQuery__
 *
 * To run a query within a React component, call `usePodcastExperianTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcastExperianTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcastExperianTypesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      podcastId: // value for 'podcastId'
 *   },
 * });
 */
export function usePodcastExperianTypesQuery(baseOptions: Apollo.QueryHookOptions<PodcastExperianTypesQuery, PodcastExperianTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcastExperianTypesQuery, PodcastExperianTypesQueryVariables>(PodcastExperianTypesDocument, options);
      }
export function usePodcastExperianTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcastExperianTypesQuery, PodcastExperianTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcastExperianTypesQuery, PodcastExperianTypesQueryVariables>(PodcastExperianTypesDocument, options);
        }
export type PodcastExperianTypesQueryHookResult = ReturnType<typeof usePodcastExperianTypesQuery>;
export type PodcastExperianTypesLazyQueryHookResult = ReturnType<typeof usePodcastExperianTypesLazyQuery>;
export type PodcastExperianTypesQueryResult = Apollo.QueryResult<PodcastExperianTypesQuery, PodcastExperianTypesQueryVariables>;
export const PodcastFeedSegmentsDocument = gql`
    query PodcastFeedSegments($organizationId: ID!, $podcastId: ID!) {
  me {
    organization(id: $organizationId) {
      advisor {
        podcast(id: $podcastId) {
          feed {
            id
            title
            experianSegments {
              feedId
              classification
              topic
              uniqueHhCount
              uniqueExperianMatching
              percentExperianMatching
              metrics {
                variable
                percentage
                nationalMeans
                index
              }
            }
            nielsenSegments {
              feedId
              classification
              topic
              uniqueHhCount
              uniqueNielsenMatching
              percentNielsenMatching
              metrics {
                variable
                reach
                totalHouseholds
                podcastPercentOfPop
                indexPercentOfPop
                index
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePodcastFeedSegmentsQuery__
 *
 * To run a query within a React component, call `usePodcastFeedSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcastFeedSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcastFeedSegmentsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      podcastId: // value for 'podcastId'
 *   },
 * });
 */
export function usePodcastFeedSegmentsQuery(baseOptions: Apollo.QueryHookOptions<PodcastFeedSegmentsQuery, PodcastFeedSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcastFeedSegmentsQuery, PodcastFeedSegmentsQueryVariables>(PodcastFeedSegmentsDocument, options);
      }
export function usePodcastFeedSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcastFeedSegmentsQuery, PodcastFeedSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcastFeedSegmentsQuery, PodcastFeedSegmentsQueryVariables>(PodcastFeedSegmentsDocument, options);
        }
export type PodcastFeedSegmentsQueryHookResult = ReturnType<typeof usePodcastFeedSegmentsQuery>;
export type PodcastFeedSegmentsLazyQueryHookResult = ReturnType<typeof usePodcastFeedSegmentsLazyQuery>;
export type PodcastFeedSegmentsQueryResult = Apollo.QueryResult<PodcastFeedSegmentsQuery, PodcastFeedSegmentsQueryVariables>;
export const PodcasterPodcastsDocument = gql`
    query PodcasterPodcasts($id: ID!, $campaignId: ID) {
  me {
    id
    organization(id: $id) {
      id
      podcasts(campaignId: $campaignId) {
        id
        feed {
          id
          title
        }
      }
    }
  }
}
    `;

/**
 * __usePodcasterPodcastsQuery__
 *
 * To run a query within a React component, call `usePodcasterPodcastsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcasterPodcastsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcasterPodcastsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function usePodcasterPodcastsQuery(baseOptions: Apollo.QueryHookOptions<PodcasterPodcastsQuery, PodcasterPodcastsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcasterPodcastsQuery, PodcasterPodcastsQueryVariables>(PodcasterPodcastsDocument, options);
      }
export function usePodcasterPodcastsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcasterPodcastsQuery, PodcasterPodcastsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcasterPodcastsQuery, PodcasterPodcastsQueryVariables>(PodcasterPodcastsDocument, options);
        }
export type PodcasterPodcastsQueryHookResult = ReturnType<typeof usePodcasterPodcastsQuery>;
export type PodcasterPodcastsLazyQueryHookResult = ReturnType<typeof usePodcasterPodcastsLazyQuery>;
export type PodcasterPodcastsQueryResult = Apollo.QueryResult<PodcasterPodcastsQuery, PodcasterPodcastsQueryVariables>;
export const PodcastsAudienceDocument = gql`
    query PodcastsAudience($id: ID!) {
  me {
    id
    organization(id: $id) {
      podcasts {
        id
        createdAt
        feed {
          id
          title
          description(words: 25)
          href
          state
          image {
            id
            href
            path
          }
          isNielsenApproved
          isExperianApproved
          experianSegments {
            classification
            topic
            uniqueHhCount
            uniqueExperianMatching
            percentExperianMatching
            metrics {
              variable
              percentage
              index
            }
          }
          nielsenSegments {
            classification
            topic
            uniqueHhCount
            uniqueNielsenMatching
            percentNielsenMatching
            metrics {
              variable
              reach
              totalHouseholds
              podcastPercentOfPop
              indexPercentOfPop
              index
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePodcastsAudienceQuery__
 *
 * To run a query within a React component, call `usePodcastsAudienceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcastsAudienceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcastsAudienceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePodcastsAudienceQuery(baseOptions: Apollo.QueryHookOptions<PodcastsAudienceQuery, PodcastsAudienceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcastsAudienceQuery, PodcastsAudienceQueryVariables>(PodcastsAudienceDocument, options);
      }
export function usePodcastsAudienceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcastsAudienceQuery, PodcastsAudienceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcastsAudienceQuery, PodcastsAudienceQueryVariables>(PodcastsAudienceDocument, options);
        }
export type PodcastsAudienceQueryHookResult = ReturnType<typeof usePodcastsAudienceQuery>;
export type PodcastsAudienceLazyQueryHookResult = ReturnType<typeof usePodcastsAudienceLazyQuery>;
export type PodcastsAudienceQueryResult = Apollo.QueryResult<PodcastsAudienceQuery, PodcastsAudienceQueryVariables>;
export const PublisherAffinityScoresDocument = gql`
    query PublisherAffinityScores($orgId: ID!, $feedId: ID!) {
  me {
    organization(id: $orgId) {
      id
      advisor {
        id
        publisherAffinityScores(feedId: $feedId) {
          rank
          industry
          percentile
        }
      }
    }
  }
}
    `;

/**
 * __usePublisherAffinityScoresQuery__
 *
 * To run a query within a React component, call `usePublisherAffinityScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublisherAffinityScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublisherAffinityScoresQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      feedId: // value for 'feedId'
 *   },
 * });
 */
export function usePublisherAffinityScoresQuery(baseOptions: Apollo.QueryHookOptions<PublisherAffinityScoresQuery, PublisherAffinityScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublisherAffinityScoresQuery, PublisherAffinityScoresQueryVariables>(PublisherAffinityScoresDocument, options);
      }
export function usePublisherAffinityScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublisherAffinityScoresQuery, PublisherAffinityScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublisherAffinityScoresQuery, PublisherAffinityScoresQueryVariables>(PublisherAffinityScoresDocument, options);
        }
export type PublisherAffinityScoresQueryHookResult = ReturnType<typeof usePublisherAffinityScoresQuery>;
export type PublisherAffinityScoresLazyQueryHookResult = ReturnType<typeof usePublisherAffinityScoresLazyQuery>;
export type PublisherAffinityScoresQueryResult = Apollo.QueryResult<PublisherAffinityScoresQuery, PublisherAffinityScoresQueryVariables>;
export const ReviewerAdMultiDocument = gql`
    query ReviewerAdMulti($organizationId: ID!, $feedId: ID, $reviewedById: ID, $offset: Int, $includeUnknown: Boolean, $state: String, $before: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      research {
        reviewing {
          adsCount(
            feedId: $feedId
            reviewedById: $reviewedById
            includeUnknown: $includeUnknown
            state: $state
          )
          ads(
            feedId: $feedId
            reviewedById: $reviewedById
            offset: $offset
            includeUnknown: $includeUnknown
            state: $state
            before: $before
          ) {
            id
            mpegPath
            flacPath
            waveform
            words
            state
            company {
              id
              name
            }
            product {
              id
              name
              url
              discountCode
            }
            sponsor {
              id
              name
            }
            placements {
              id
              episode {
                id
                title
                feed {
                  id
                }
              }
            }
            guess {
              id
              kind
              body
              companyId
              companyName
              productId
              productName
              maxScore
              score
              duration
            }
            reviews {
              id
              startState
              reviewer {
                id
                firstName
                lastName
                email
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useReviewerAdMultiQuery__
 *
 * To run a query within a React component, call `useReviewerAdMultiQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewerAdMultiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewerAdMultiQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      feedId: // value for 'feedId'
 *      reviewedById: // value for 'reviewedById'
 *      offset: // value for 'offset'
 *      includeUnknown: // value for 'includeUnknown'
 *      state: // value for 'state'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useReviewerAdMultiQuery(baseOptions: Apollo.QueryHookOptions<ReviewerAdMultiQuery, ReviewerAdMultiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewerAdMultiQuery, ReviewerAdMultiQueryVariables>(ReviewerAdMultiDocument, options);
      }
export function useReviewerAdMultiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewerAdMultiQuery, ReviewerAdMultiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewerAdMultiQuery, ReviewerAdMultiQueryVariables>(ReviewerAdMultiDocument, options);
        }
export type ReviewerAdMultiQueryHookResult = ReturnType<typeof useReviewerAdMultiQuery>;
export type ReviewerAdMultiLazyQueryHookResult = ReturnType<typeof useReviewerAdMultiLazyQuery>;
export type ReviewerAdMultiQueryResult = Apollo.QueryResult<ReviewerAdMultiQuery, ReviewerAdMultiQueryVariables>;
export const SavedExportDocument = gql`
    query SavedExport($organizationId: ID!, $id: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      exports {
        id
        savedExport(id: $id) {
          ...SavedExportFields
        }
      }
    }
  }
}
    ${SavedExportFieldsFragmentDoc}`;

/**
 * __useSavedExportQuery__
 *
 * To run a query within a React component, call `useSavedExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedExportQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSavedExportQuery(baseOptions: Apollo.QueryHookOptions<SavedExportQuery, SavedExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedExportQuery, SavedExportQueryVariables>(SavedExportDocument, options);
      }
export function useSavedExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedExportQuery, SavedExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedExportQuery, SavedExportQueryVariables>(SavedExportDocument, options);
        }
export type SavedExportQueryHookResult = ReturnType<typeof useSavedExportQuery>;
export type SavedExportLazyQueryHookResult = ReturnType<typeof useSavedExportLazyQuery>;
export type SavedExportQueryResult = Apollo.QueryResult<SavedExportQuery, SavedExportQueryVariables>;
export const SavedExportsDocument = gql`
    query SavedExports($id: ID!) {
  me {
    id
    organization(id: $id) {
      id
      exports {
        id
        savedExports {
          ...SavedExportFields
        }
        exportTypes {
          ...ExportTypes
        }
      }
    }
  }
}
    ${SavedExportFieldsFragmentDoc}
${ExportTypesFragmentDoc}`;

/**
 * __useSavedExportsQuery__
 *
 * To run a query within a React component, call `useSavedExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedExportsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSavedExportsQuery(baseOptions: Apollo.QueryHookOptions<SavedExportsQuery, SavedExportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SavedExportsQuery, SavedExportsQueryVariables>(SavedExportsDocument, options);
      }
export function useSavedExportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SavedExportsQuery, SavedExportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SavedExportsQuery, SavedExportsQueryVariables>(SavedExportsDocument, options);
        }
export type SavedExportsQueryHookResult = ReturnType<typeof useSavedExportsQuery>;
export type SavedExportsLazyQueryHookResult = ReturnType<typeof useSavedExportsLazyQuery>;
export type SavedExportsQueryResult = Apollo.QueryResult<SavedExportsQuery, SavedExportsQueryVariables>;
export const SpotifyBrandLiftReportDocument = gql`
    query SpotifyBrandLiftReport($id: ID!, $organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      spotifyBrandLiftReport(id: $id) {
        ...SpotifyBrandLiftFields
        messages {
          id
          messageType
          messageTypeDisplay
          messageContents {
            id
            languageCode
            question
            answer1
            answer2
            answer3
            answer4
            answer5
          }
          result {
            ...SpotifyBrandLiftMessageResultFields
          }
        }
      }
    }
  }
}
    ${SpotifyBrandLiftFieldsFragmentDoc}
${SpotifyBrandLiftMessageResultFieldsFragmentDoc}`;

/**
 * __useSpotifyBrandLiftReportQuery__
 *
 * To run a query within a React component, call `useSpotifyBrandLiftReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpotifyBrandLiftReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpotifyBrandLiftReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSpotifyBrandLiftReportQuery(baseOptions: Apollo.QueryHookOptions<SpotifyBrandLiftReportQuery, SpotifyBrandLiftReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpotifyBrandLiftReportQuery, SpotifyBrandLiftReportQueryVariables>(SpotifyBrandLiftReportDocument, options);
      }
export function useSpotifyBrandLiftReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpotifyBrandLiftReportQuery, SpotifyBrandLiftReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpotifyBrandLiftReportQuery, SpotifyBrandLiftReportQueryVariables>(SpotifyBrandLiftReportDocument, options);
        }
export type SpotifyBrandLiftReportQueryHookResult = ReturnType<typeof useSpotifyBrandLiftReportQuery>;
export type SpotifyBrandLiftReportLazyQueryHookResult = ReturnType<typeof useSpotifyBrandLiftReportLazyQuery>;
export type SpotifyBrandLiftReportQueryResult = Apollo.QueryResult<SpotifyBrandLiftReportQuery, SpotifyBrandLiftReportQueryVariables>;
export const SpotifyBrandLiftReportsDocument = gql`
    query SpotifyBrandLiftReports($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      spotifyBrandLiftReports {
        ...SpotifyBrandLiftFields
      }
    }
  }
}
    ${SpotifyBrandLiftFieldsFragmentDoc}`;

/**
 * __useSpotifyBrandLiftReportsQuery__
 *
 * To run a query within a React component, call `useSpotifyBrandLiftReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpotifyBrandLiftReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpotifyBrandLiftReportsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSpotifyBrandLiftReportsQuery(baseOptions: Apollo.QueryHookOptions<SpotifyBrandLiftReportsQuery, SpotifyBrandLiftReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpotifyBrandLiftReportsQuery, SpotifyBrandLiftReportsQueryVariables>(SpotifyBrandLiftReportsDocument, options);
      }
export function useSpotifyBrandLiftReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpotifyBrandLiftReportsQuery, SpotifyBrandLiftReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpotifyBrandLiftReportsQuery, SpotifyBrandLiftReportsQueryVariables>(SpotifyBrandLiftReportsDocument, options);
        }
export type SpotifyBrandLiftReportsQueryHookResult = ReturnType<typeof useSpotifyBrandLiftReportsQuery>;
export type SpotifyBrandLiftReportsLazyQueryHookResult = ReturnType<typeof useSpotifyBrandLiftReportsLazyQuery>;
export type SpotifyBrandLiftReportsQueryResult = Apollo.QueryResult<SpotifyBrandLiftReportsQuery, SpotifyBrandLiftReportsQueryVariables>;
export const SpotifySalesOrderDocument = gql`
    query SpotifySalesOrder($organizationId: ID!, $orderId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      spotifyOrder(id: $orderId) {
        id
        name
        createdAt
        addtocartTotal
        addtocartTotalModeled
        checkoutTotal
        checkoutTotalModeled
        downloadTotal
        installedTotal
        installedTotalModeled
        leadTotal
        leadTotalModeled
        productTotal
        productTotalModeled
        purchaseTotal
        purchaseTotalModeled
        reachTotal
        userTotal
        userTotalModeled
        valueTotal
        valueTotalModeled
        campaigns {
          ...Campaign
        }
      }
    }
  }
}
    ${CampaignFragmentDoc}`;

/**
 * __useSpotifySalesOrderQuery__
 *
 * To run a query within a React component, call `useSpotifySalesOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpotifySalesOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpotifySalesOrderQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSpotifySalesOrderQuery(baseOptions: Apollo.QueryHookOptions<SpotifySalesOrderQuery, SpotifySalesOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpotifySalesOrderQuery, SpotifySalesOrderQueryVariables>(SpotifySalesOrderDocument, options);
      }
export function useSpotifySalesOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpotifySalesOrderQuery, SpotifySalesOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpotifySalesOrderQuery, SpotifySalesOrderQueryVariables>(SpotifySalesOrderDocument, options);
        }
export type SpotifySalesOrderQueryHookResult = ReturnType<typeof useSpotifySalesOrderQuery>;
export type SpotifySalesOrderLazyQueryHookResult = ReturnType<typeof useSpotifySalesOrderLazyQuery>;
export type SpotifySalesOrderQueryResult = Apollo.QueryResult<SpotifySalesOrderQuery, SpotifySalesOrderQueryVariables>;
export const SpotifySalesOrdersDocument = gql`
    query SpotifySalesOrders($organizationId: ID!) {
  me {
    id
    organization(id: $organizationId) {
      id
      spotifyOrders {
        id
        name
        downloadTotal
        createdAt
        campaigns {
          id
          expectedEndAt
          goal
          state
        }
      }
    }
  }
}
    `;

/**
 * __useSpotifySalesOrdersQuery__
 *
 * To run a query within a React component, call `useSpotifySalesOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpotifySalesOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpotifySalesOrdersQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSpotifySalesOrdersQuery(baseOptions: Apollo.QueryHookOptions<SpotifySalesOrdersQuery, SpotifySalesOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpotifySalesOrdersQuery, SpotifySalesOrdersQueryVariables>(SpotifySalesOrdersDocument, options);
      }
export function useSpotifySalesOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpotifySalesOrdersQuery, SpotifySalesOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpotifySalesOrdersQuery, SpotifySalesOrdersQueryVariables>(SpotifySalesOrdersDocument, options);
        }
export type SpotifySalesOrdersQueryHookResult = ReturnType<typeof useSpotifySalesOrdersQuery>;
export type SpotifySalesOrdersLazyQueryHookResult = ReturnType<typeof useSpotifySalesOrdersLazyQuery>;
export type SpotifySalesOrdersQueryResult = Apollo.QueryResult<SpotifySalesOrdersQuery, SpotifySalesOrdersQueryVariables>;
export const SuperCampaignOmniChartDocument = gql`
    query SuperCampaignOmniChart($organizationId: ID!, $id1: ID!, $id2: ID, $id3: ID, $id4: ID, $include2: Boolean!, $include3: Boolean!, $include4: Boolean!, $after: String, $before: String) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign1: campaign(id: $id1) {
        ...CampaignOmniChartFields
      }
      campaign2: campaign(id: $id2) @include(if: $include2) {
        ...CampaignOmniChartFields
      }
      campaign3: campaign(id: $id3) @include(if: $include3) {
        ...CampaignOmniChartFields
      }
      campaign4: campaign(id: $id4) @include(if: $include4) {
        ...CampaignOmniChartFields
      }
    }
  }
}
    ${CampaignOmniChartFieldsFragmentDoc}`;

/**
 * __useSuperCampaignOmniChartQuery__
 *
 * To run a query within a React component, call `useSuperCampaignOmniChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperCampaignOmniChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperCampaignOmniChartQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      id1: // value for 'id1'
 *      id2: // value for 'id2'
 *      id3: // value for 'id3'
 *      id4: // value for 'id4'
 *      include2: // value for 'include2'
 *      include3: // value for 'include3'
 *      include4: // value for 'include4'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useSuperCampaignOmniChartQuery(baseOptions: Apollo.QueryHookOptions<SuperCampaignOmniChartQuery, SuperCampaignOmniChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperCampaignOmniChartQuery, SuperCampaignOmniChartQueryVariables>(SuperCampaignOmniChartDocument, options);
      }
export function useSuperCampaignOmniChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperCampaignOmniChartQuery, SuperCampaignOmniChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperCampaignOmniChartQuery, SuperCampaignOmniChartQueryVariables>(SuperCampaignOmniChartDocument, options);
        }
export type SuperCampaignOmniChartQueryHookResult = ReturnType<typeof useSuperCampaignOmniChartQuery>;
export type SuperCampaignOmniChartLazyQueryHookResult = ReturnType<typeof useSuperCampaignOmniChartLazyQuery>;
export type SuperCampaignOmniChartQueryResult = Apollo.QueryResult<SuperCampaignOmniChartQuery, SuperCampaignOmniChartQueryVariables>;
export const UnmappedSpotifyOrdersDocument = gql`
    query UnmappedSpotifyOrders($nameSearch: String, $limit: Int, $offset: Int) {
  me {
    organization(slug: "spotify") {
      id
      name
      unmappedSpotifyOrders(nameSearch: $nameSearch, limit: $limit, offset: $offset) {
        results {
          ...UnMappedOrderPagination
        }
        total
        offset
        limit
      }
    }
  }
}
    ${UnMappedOrderPaginationFragmentDoc}`;

/**
 * __useUnmappedSpotifyOrdersQuery__
 *
 * To run a query within a React component, call `useUnmappedSpotifyOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnmappedSpotifyOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnmappedSpotifyOrdersQuery({
 *   variables: {
 *      nameSearch: // value for 'nameSearch'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useUnmappedSpotifyOrdersQuery(baseOptions?: Apollo.QueryHookOptions<UnmappedSpotifyOrdersQuery, UnmappedSpotifyOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnmappedSpotifyOrdersQuery, UnmappedSpotifyOrdersQueryVariables>(UnmappedSpotifyOrdersDocument, options);
      }
export function useUnmappedSpotifyOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnmappedSpotifyOrdersQuery, UnmappedSpotifyOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnmappedSpotifyOrdersQuery, UnmappedSpotifyOrdersQueryVariables>(UnmappedSpotifyOrdersDocument, options);
        }
export type UnmappedSpotifyOrdersQueryHookResult = ReturnType<typeof useUnmappedSpotifyOrdersQuery>;
export type UnmappedSpotifyOrdersLazyQueryHookResult = ReturnType<typeof useUnmappedSpotifyOrdersLazyQuery>;
export type UnmappedSpotifyOrdersQueryResult = Apollo.QueryResult<UnmappedSpotifyOrdersQuery, UnmappedSpotifyOrdersQueryVariables>;
export const UserInfoDocument = gql`
    query userInfo {
  userInfo {
    email
    hasSpaaUser
    hasVerifiedEmailForSpaa
  }
}
    `;

/**
 * __useUserInfoQuery__
 *
 * To run a query within a React component, call `useUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
      }
export function useUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInfoQuery, UserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInfoQuery, UserInfoQueryVariables>(UserInfoDocument, options);
        }
export type UserInfoQueryHookResult = ReturnType<typeof useUserInfoQuery>;
export type UserInfoLazyQueryHookResult = ReturnType<typeof useUserInfoLazyQuery>;
export type UserInfoQueryResult = Apollo.QueryResult<UserInfoQuery, UserInfoQueryVariables>;
export const CampaignActivityLogDocument = gql`
    query CampaignActivityLog($organizationId: ID!, $slug: String!) {
  me {
    id
    organization(id: $organizationId) {
      id
      campaign(slug: $slug) {
        id
        name
        auditLogEvents {
          id
          dateTimeChanged
          userFirstName
          userLastInitial
          fieldName
          action
          oldVal
          newVal
          campaignOrLineItemName
          eventType
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignActivityLogQuery__
 *
 * To run a query within a React component, call `useCampaignActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignActivityLogQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCampaignActivityLogQuery(baseOptions: Apollo.QueryHookOptions<CampaignActivityLogQuery, CampaignActivityLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignActivityLogQuery, CampaignActivityLogQueryVariables>(CampaignActivityLogDocument, options);
      }
export function useCampaignActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignActivityLogQuery, CampaignActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignActivityLogQuery, CampaignActivityLogQueryVariables>(CampaignActivityLogDocument, options);
        }
export type CampaignActivityLogQueryHookResult = ReturnType<typeof useCampaignActivityLogQuery>;
export type CampaignActivityLogLazyQueryHookResult = ReturnType<typeof useCampaignActivityLogLazyQuery>;
export type CampaignActivityLogQueryResult = Apollo.QueryResult<CampaignActivityLogQuery, CampaignActivityLogQueryVariables>;